module.exports={
"label_emailtocloudcc_department":`分部`,
"label.wei.weiresearch":`微投票`,
"message.error.appsecret.null":`秘钥密码不能为空！`,
"label.file.orderbylastmodifydate":`按上次修改日期排序`,
"label.minus":`-减`,
"label.horizontalbar":`水平条`,
"label.emailobject.emailsentfailed":`邮件发送失败！`,
"assignedresource.check":`此服务资源已分配到此服务预约，请勿重复添加。`,
"label.finish":`完成`,
"label.document.history":`下载历史`,
"label.customfields.number.numberLengthHelpText":`1. 输入数字的长度和小数位数。例如，输入长度为8，小数位数为2，则可接受的最大值位数即为12345678.90`,
"label.standard.buttonandlink.info":`改写标准按钮和链接更改了CloudCC URL 以及对该URL所有调用（例如 CloudCC页面、浏览器快捷方式或外部系统）的含义。您可以使用 CloudCC的自定义页面替换标准按钮或链接的CloudCC URL。`,
"front-epwechat-module-v1-contacts-desc":`开启后，会在CloudCC系统内增加企业微信联系人对象，会将企业微信中的客户信息同步至该对象中`,
"label.mr.caption.contact.result":`查重合并：查询联系人重复数据的结果`,
"label.ems.selectaccount":`选择账号`,
"label.group.no.activity":`没有匹配的活动小组。`,
"label.call.for":`邀约人`,
"label.newreportguide":`新建报表向导`,
"component.telerecord.label.name":`姓名`,
"vue.add.dashboard.component":`添加{titleName}组件`,
"label.chatter.sendEmailToGroupMember.check.V":`查看投票`,
"UG.ST.002":`确定`,
"label.setting.intergrationmanage":`集成应用管理`,
"label.field.apiname.validate":`请输入0-6之间的一位数`,
"label.emailmerge.list.deletefolder":`删除文件夹`,
"vue_label_pool_received":`已领取`,
"label_emailtocloudcc_step1_case1":`Email to Case`,
"message.sumlength":`长度与小数位数之和不能超出18位`,
"vue_label_approve_reassignapproval":`{name}将审批重新分配至{people}`,
"label.specify.time":`时间： 2016年06月21日 13:00`,
"vue_label_report_sortdown":`按降序排列`,
"chatter.login.now":`正在上载中...`,
"label.import.page2.notsuited":`未映射`,
"label.please.fill.out":`请填写`,
"label.recordtype.edit.description":`从可用值"列表中选择某一项，并将其添加到"所选值"列表中，以便将其作为此记录类型的选项列表值。请注意，从选项列表中删除某一项不会从任何现有记录中删除此项。最后，为该记录类型选择默认选项列表值"`,
"label.customer.tab.new":`新建自定义菜单`,
"label.sameas":`同`,
"front-filter-module-v1-filter-a-week-ago":`一周前`,
"label.processsetting.disable.process.failed":`禁用进程失败！`,
"label.summaryreport.2018.step4":`步骤4：选择报表标准`,
"label.secrecyinfo":`保密信息-请勿散布`,
"label.custom.page.component.general.settings":`组件一般设置`,
"label.ccpeak.folder":`未归档类文件夹`,
"vue_label_homepage_select_button_operation":`选择按钮操作项`,
"message.pleaseinputrightdistance":`请填写正确的间隔天数`,
"label.mobile.phone.required.short":`为必填项`,
"vue_label_account_equityseructure":`股权架构图`,
"label.file.library.error1":`此文件已存在于此文档库中`,
"fliter.nextmonth":`下个月`,
"label.mr.descreption.oneGroupNote2":`组企业信息，共有`,
"label.allfolderdashboard":`所有仪表板文件夹`,
"lable.opppdt.selPdt.bykeywords":`按关键字`,
"setup_layout_label_selectedfield":`选取字段`,
"label.file.preview.convert.firstpage.failure":`预览时发生错误，请点击预览详情或下载查看`,
"vue_label_systemSettings_companie":`公司设置`,
"label.loginhis.recently":`最近登录历史`,
"label.permission.visualpagepermission.edit":`自定义页面分配`,
"label.ccservice.validate.email":`对象API为{0}下的{1}字段对应值为{2} 格式有误，请输入正确的电子邮件地址！`,
"label.sms.companyname.gm":`创明网络短信接口`,
"lable.opppdt.addpdt.table.discount":`折扣(%off)`,
"Lead.Scoring.Setting.LevelSetting":`潜在客户热度设置`,
"message.duplication.label.duplicationremark":`是对新建或编辑记录保存时查询重复数据的操作`,
"label.file.preview.error":`预览时发生错误，请下载查看`,
"label.imgfield.type.input":`输入图片`,
"label.file.share.email.content1":`文件名称：#filename`,
"vue_label_notice_batchedit_fail":`id为{0}的数据更新失败，失败原因为{1}`,
"label.reportsSubscriptionPage.schedulereport.monthly.week.four":`第四个星期`,
"label.view.sortview.printview":`打印视图`,
"label.projectManagement.Addposttask":`添加后置任务`,
"vue_label_commonobjects_view_fail":`设置默认视图失败`,
"label.dayinweek":`个星期的`,
"label.layout.notexist":`布局不存在`,
"label.brief.total":`记录{total}条`,
"label.dashboardSetup.tz.bb":`跳转到报表`,
"label_emailtocloudcc_select3":`请选择记录所有人`,
"label.input.least.string":`请输入至少 {0} 个字符`,
"label.app.step2":`步骤 2. 输入详细信息`,
"lable.account.LastWeek":`上星期`,
"label.notifications":`通知`,
"label.tabpage.viewname":`视图名称`,
"label.knowledge.language.italian":`意大利语`,
"label.sendmail.step2.introduce":`请选择要使用的电子邮件模板。`,
"label_enable_or_no":`是否启用`,
"pagecreator_button_save":`保存`,
"template.chart.cplb":`产品类别`,
"label.knowledge.publish":`不符合要求不能发布`,
"label.name.required":`名称为必填项。`,
"component.chatter.label.myfans":`我的追随者`,
"label.rejectoperate":`拒绝操作`,
"label.report.action.addtodashboard3":`选择仪表板`,
"label.icon.101":`课本`,
"label.data.exp.su.ok":`系统正在导出`,
"label.appupload.component.type.layout":`页面布局`,
"template.chart.yscb":`预算成本`,
"label.tabularreport.selectorder":`确定各报表列的显示排序`,
"email.title.one":`找回密码`,
"label.case.copy.link":`复制网页链接`,
"label.mr.descreption.oneGroupReData4":`组，还剩余`,
"label.newprocess5.error.des":`只能输入数字`,
"label.partnerCloud.loginButton":`登录按钮`,
"label.interfaceconstraint.adminonly":`只有系统管理员可以使用此接口`,
"label.campaign.channel.input.date":`2.请为您的营销渠道设置有效期:`,
"label.clientwebsiteentranceprofile":`客户网站入口 简档`,
"UG.opportunity.011":`导入交易`,
"label.page.copy.value.paste.template":`将合并字段值复制并粘贴到以下模板。`,
"label.notselect":`未选中`,
"label.weixin.input.password":`请输入密码`,
"label.email.select.template":`选择模板`,
"label_chatter_ok":`确认`,
"permissionService.error":`权限集分配失败，请检查应用许可是否过期或者分配达到上限`,
"label.webtocloudcc.sorry":`抱歉,网页出现了异常，请重试或联系管理员！`,
"UG.opportunity.007":`联系人角色`,
"label.manageAll.forapproval":`待审批`,
"label.imgfield.type.ref":`公式图片`,
"label.profile.setcustomtab":`自定义菜单设置`,
"label.tabpage.datatyoez":`数据类型`,
"label.partnerCloud.basicSetting.editPersonal":`允许伙伴云用户编辑个人信息`,
"label.mr.caption.account":`查重合并：查询客户重复数据的条件`,
"message.serviceterritoryMe.time.violation":`派遣时间违规:派遣时段不在其作为区域成员的时间内`,
"pagecreator_page_message_publish_success":`页面发布成功`,
"label.field.formula.timezonetip":`注意处理日期时间类型函数的多时区支持。在公式中使用SYSDATE等系统函数来获取当前时间时，应采用其对应的支持多时区的函数代替，例如CURRENT_DATE。`,
"label.marketseamemset.specialuser":`特殊成员`,
"label.staticresource.message":`静态资源详细信息`,
"label.workflow.rulecondition":`规则条件`,
"component_salesperformance_label_nodata":`添加您的业务机会，然后返回此处查看业绩图。`,
"label.customfields.textarea.tip":`允许用户输入多行文本，最多可输入 4000 个字符。`,
"font-evaluate-module-v1-template":`自定义模板`,
"label.step3.total5":`第3步，共5步`,
"label.customfields.formula.percent.tip":`计算百分比，并自动向数字添加百分号`,
"label.sortdesc":`降序`,
"lable.PowerProcess.edit":`权利过程编辑`,
"label.dongshifang.description":`配置东时方短信接口信息，满足您组织的短信收发业务需求。`,
"label.chatter.addressee":`收件人`,
"vue_label_systemSettings_obj2":`对象管理器`,
"label.selectreporttype.tip":`选择希望包括在报表中的数据类型`,
"label.version.enterprise":`企业版`,
"label.area.add":`添加区域`,
"label.h5.bookmarked":`我收藏的`,
"label.step5.total7":`第5步，共7步`,
"front-lightning-module-v1-title-quotation":`报价单预览`,
"label.search.onlymyrecords":`限于我拥有的项目`,
"vue_label_commonobjects_noduplication":`与{记录}中{字段}重复`,
"label.customerpage.edit":`编辑自定义页面菜单`,
"message.please.choose.user":`请选择用户`,
"label.approval.his.currentactor":`当前审批人`,
"label.field.duplicate.error.msg3":`最多创建三个独有属性字段`,
"label.page_url":`页面链接`,
"label.permission.goback":`返回权限集概述`,
"vue_label_commonobjects_view_kanban_notice2":`要查看所有记录，请使用列表或分屏视图`,
"label.group.no.recent.searchs":`没有匹配的最近查看小组。`,
"label.event.fiducial.point":`准点`,
"label.integrations.mailchimp.addtolist":`将CloudCC中的潜在客户和联系人添加到Mailchimp收件人列表中`,
"label.workflow.configrule.introduce":`输入规则名、备注和触发工作流规则的条件。在下一个步骤中，将工作流操作与此工作流规则关联起来。`,
"label.icon.161":`皮箱`,
"label.recordtype.enable":`启用`,
"label_mailboxes_limit":`邮箱数量超过上限`,
"label.notification.time3":`{0}小时前`,
"label.setsharerule.step2":`第二步：选择要共享的条件`,
"vue_label_homepage_somecomponents":`警告！添加组件后高度超出导致显示不全，请删除部分组件`,
"label.icon.63":`地下井`,
"label.use.standard.sharerules":`使用标准共享规则`,
"label.button.step2.select.required.field":`步骤2：选择必填字段`,
"lable.Confirm.collect.potential.customers":`确认领取潜在客户{name}`,
"label.version.sum.custompage":`个自定义页面`,
"label.file.ccchat.changefile":`更改文件`,
"label.mobile.phone.phone.call":`拨打电话`,
"label.appupload.managed.img":`受管`,
"vue_label_chatter_comment":`评论`,
"label.central.european.time":`中欧时间`,
"label.three.quarter":`第三季度`,
"label.service.newBuildDialog.filter.editor":`筛选编辑器`,
"pagecreator_systemstyle_funcpath":`/构建器/品牌化样式库`,
"label_chatter_collect":`收藏`,
"label.custom.page.component.window.settings":`组件窗口设置`,
"component_chatter_file_label_title":`文件上传`,
"label.marketsea.button.discard":`废弃`,
"label.Batch.input":`批量输入`,
"vue_label_campaign_market_members":`现有市场活动成员`,
"label.salescloud.salesdashboard":`销售看板`,
"message.summaryconditionrepeated":`汇总条件重复，请重新选择！`,
"label.tianyancha.h5.companycode":`公司代码`,
"label.quickbooks.description":`配置QuickBooks账号信息，跟踪您的在线发票支付情况`,
"label.colombia.time":`哥伦比亚时间`,
"label.usermanage.unknown.license":`未知的许可证书，无法创建用户，请联系系统管理员！`,
"label.operatedata.selectoperateandobject":`选择操作(导入或者导出)并选择对象`,
"message.setup.field.picklist.valuerepeated":`列表值不能出现重复，请重新输入！`,
"label.editerror.list":`未编辑数据列表`,
"pagecreator_page_message_save_success":`页面保存成功`,
"label.icon.154":`电脑`,
"label.emailsync.setting":`个人邮箱设置`,
"label.startuploadfile.step2":`步骤 3.单击“开始上传”按钮，上传文件`,
"label.dashboard.notmeet.conditions":`没有符合条件的信息，尚未配置仪表板！`,
"label.temp.del.conf":`确认要删除吗？`,
"label.sms.authkey":`认证密码`,
"lable.oppt.jieduan.choosejieduan":`选择已结束阶段`,
"label.tabpage.viewNamez":`请输入视图名称`,
"label.totalQuotation":`报价单总计`,
"label.tabpage.hoursagoz":`小时前`,
"label.receiveadminnews":`接收  管理员新闻简报`,
"label.field.is.lookup":`字段是否关联查找字段`,
"label.any_changes":`此处的任何更改也将更新在下方的页脚`,
"lable.products.to.assets":`确定将产品转资产?`,
"label.dashboard.compare":`比较`,
"vue_label_chatter_notice1":`删除小组后将删除小组中的所有信息，但不会删除小组文件`,
"label_tabpage_exitz":`退出`,
"label.potentialcustomerflow":`潜在客户流程`,
"label.longtext":`长文本区`,
"october":`十月`,
"label.customer.email":`邮件`,
"label.partnerCloud.productSet.addChildren":`添加子级`,
"label.defaultline.cannot.greater":`默认行数不能超过30行`,
"front-detail-module-v1-view-report":`查看报表`,
"label.knowledge.setting.hint.sixteen":`保存知识继续传播`,
"label.page.use.merged.field":`使用合并字段`,
"label.salescloud.salescloud.continuerecover":`如果继续，将执行删除操作且不可恢复：`,
"front-project-module-v1-from-template-create":`从模板新建`,
"label.exportall":`导出全部`,
"label.weixin.recalculate.shared.results":`重新计算共享规则结果`,
"label.components.isTemplate":`是否是模板数据`,
"label_emailsync_status":`用户邮箱状态统计`,
"label.file.library.delete":`是否确定要删除{librayrname}？`,
"label.integrations.username":`用户名`,
"front-lightningset-module-v1-detail-page-report-chart":`详情页报表图表`,
"label_tabular":`列表式`,
"label.approverecords":`批准记录`,
"vue_label_helpcenter_topic":`lightning版本使用与帮助`,
"label.h5.date.none":`-无-`,
"lable.outlook.mcto.allrecord":`所有记录`,
"label.readandwrite":`读/写`,
"label.allfold":`全部折叠`,
"AD":`地址`,
"message.custom.field.donotdelete.reporttype":`该字段被报表数据源所引用`,
"label.escalation.setup.newaction.title":`编辑升级操作`,
"label.dashboard.snapshot.settings":`仪表板快照设置`,
"label.attendance.inner":`内勤`,
"chatter.ns":`新消息`,
"label.validate.nowork":`错误：无效字段，请重新选择错误位置`,
"label.custom.EmptyCanvas":`清空画布`,
"label.service.miniProgram.fillImageOrder":`请填写轮播图顺序`,
"label.icon.16":`维修`,
"label.selected":`已选中`,
"component_chatter_link_label_name":`链接名称`,
"label.reportsSubscriptionPage.schedulereport.starttime":`开始时间`,
"label.file.uploadNewVersion":`上载新版本`,
"chatter.group.theMembership":`成员关系`,
"label.knowledge.recommended.articles":`推荐文章`,
"label.appupload.install.parentobj":`所属对象`,
"label.file.recent":`最近`,
"vue_label_helpcenter_quote":`    报价表示贵公司产品和服务的建议价格。您可以从业务机会及其产品中创建报价。<br>在详细信息右上角，通过按钮可以从业务机会同步报价单，或将报价单同步到业务机会下。当报价与业务机会同步时，对报价行任何更改都会与业务机会产品同步，反之亦然。每个业务机会可以有多个关联的报价，其中任何一个报价都能与业务机会同步。<br>在详细信息右上角，可以将报价单生成pdf并预览，且可直接进行打印、下载或保存操作。`,
"message.error.field.default":`默认值必须是正整数`,
"label.campaignmember.main.importmember.contacts.desc":`将文件中的数据导入到这个市场活动联系人中`,
"vue_label_calendar_show_only_this_calendar":`仅显示此日历`,
"vue_label_quot_syncfrom":`从业务机会同步`,
"label.data.expnode.e_desc2":`2、按模板导出：用户可以选择模板进行数据导出。`,
"label.login.verification.mfa.desc1":`您必须先在智能设备上安装一个MFA应用程序，才能继续进行操作。在智能设备上支持MFA的常用应用程序有洋葱，Google Authenticator。`,
"label.jiandangfenpei.desc":`分配简档对当前自定义页面的访问权限。系统管理员可以访问所有自定义页面。`,
"label_tabpage_thisrecord":`此记录`,
"lable.SalesCommitmentKanBan.totalPaymentAmount":`累计收款金额`,
"message.error.object.notvalidcurrency":`无效的币种`,
"label.edit.discount":`编辑折扣`,
"label.setup.mobile.offlinecache.setenable":`启用移动端离线功能`,
"UG.ST.005":`我知道了，不用再显示此页面，下次直接进入。`,
"label.assignedapprover":`已分配批准人`,
"template.chart.htlx":`合同类型`,
"scope":`在范围内`,
"label.workmate.search":`搜索同事`,
"message.validation.isnotdigits":`输入正确的数字`,
"label.ccpeak.use.class.time.page":`如果是自定义页面调用该类，需调用PageClsInvoker类中的invoker()方法`,
"setup_mainpage_label_welcome27":`CloudCC 云平台提供系统内所有对象数据的导入、导出、数据批量删除、批量转移等功能。`,
"front-epwechat-module-v1-epwechat-integrate":`企业微信集成`,
"label.file.publiclink":`公用链接`,
"front-epwechat-module-v1-input-name":`请输入企业名称`,
"lable.Number.of.columns":`列数`,
"message.error.dev.service.duplicateparameter":`服务参数重复！`,
"label.projectManagement.percent.complete":`完成百分比`,
"label.chatter.nextSevenday":`未来7天`,
"chatter.feed.myfollowers":`我的追随者`,
"label.bacchtransfer.pleaseselecttouser":`请选择转移到用户`,
"label_partner_workspace_member_memo":`选定的简档、权限集的所有用户都可以访问此伙伴云。`,
"label.marketsea.chosen.member":`已选成员`,
"label.marketsea.assignment.setup":`分配设置`,
"label.myaccount":`我的客户`,
"label.schedulejob.setup.schedule.executedate":`执行时间`,
"label.uploadaccessory":`附件上载`,
"Homepage.News.004":`暂无新闻`,
"label.marketsea.name":`公海池名称`,
"label.pending.task":`待办任务`,
"label.report.details":`详细信息`,
"UG.homepage.008":`了解目前业务状态（销售简报，排行榜，销售漏斗等），查看可能存在问题的业务机会，预测未来业绩达成情况，及时受理和分派重要事项，做出明智决策。`,
"label.h5.similar.opportunity.clear.all":`清除所有`,
"label.tabpage.noz":`否`,
"label.report.recent.all.reports":`所有报表`,
"vue_label_lead_to_score":`点击打分，为当前视图内潜在客户进行打分。`,
"vue_label_normal_receivable_sf":`收款计划`,
"label.layout.edittabdistribute":`编辑菜单布局`,
"label.validate.function.funcFormat.PRIORVALUE":`PRIORVALUE(field)`,
"label.salescloud.field.editoptionlist":`选项列表编辑`,
"APPIntegration.Dropbox.01":`从Dropbox中选择文件`,
"label.campaign.channel.step2":`步骤2：营销渠道潜在客户字段默认值设置`,
"label_partner_new_function":`功能说明`,
"vue_label_chat_no_search_results":`无搜索结果`,
"vue_label_commonobjects_detail_visitstate":`拜候状态`,
"label.sendemail.send.testemail":`这是一封测试邮件，如果您能收到这封邮件，证明您可以使用这个邮箱发送邮件。`,
"label.attendance.clear.position":`清除地标`,
"chatter.write.n":`编写注释...`,
"label_chatter_sendmail":`发送电子邮件`,
"label.remindertime":`提醒时间`,
"label.app.elegantgray":`淡雅灰`,
"label.tabpage.ownedz":`共有`,
"label.select.approval":`选择审批人`,
"UG.Lead.007":`Google同步`,
"chatter.emailSetUp":`我的CCChat提醒设置`,
"label.default.censor":`默认审查人`,
"vue_label_notice_uploadavatar_success":`上传头像成功`,
"label.sms.title":`短信接口信息`,
"front-console-choose-contact":`选择联系人`,
"label.field.edit.des":`最大评分控制着星星图标显示的数量，最大的评分为100`,
"label.pw.big.letter":`大写字母`,
"label.select.time.dimension":`请选择时间维度`,
"UG_Campaign_004":`导入市场活动`,
"label.dashboard.summary":`度量`,
"label.ems.yahoo":`雅虎`,
"label.leadscore.rule.name":`打分规则名称`,
"vue_label_calendar_object_name":`对象名称`,
"label.icon.69":`机器`,
"label.reporttotal":`总计`,
"lable.SalesCommitmentKanBan.theActualContract":`实际签约额`,
"label.project.member.data":`此用户已是当前项目下成员！`,
"label.cloudccclass.list.viewremark":`查看使用说明`,
"label.deleteObject.isNotAdministrator":`不是系统管理员，不能删除对象。`,
"lable.edit.queue.nameandemail":`队列名称和电子邮件地址`,
"label.recordtype.tabname":`记录类型`,
"label.file.is.ok":`是否确定`,
"label.knowledge.language.german":`德语`,
"label.layout.realityapprover":`实际批准人`,
"label.ems.with7day":`7天以内`,
"label.autoRegister.changepwd.setpwd.setpwd.button":`设置`,
"label.weixin.edit.polls":`修改投票`,
"label.layout.mobile.default.tab":`选择手机默认打开的菜单`,
"vue_label_report_deletegroupcolumn":`删除组列`,
"label.group.archived.success":`归档成功`,
"label.customfields.formula.returntype":`公式的返回类型`,
"label.file.followers":`追随者`,
"label.textmessage.new.templates.message1":`短信模板名称不能为空！`,
"label.selected.field.length":`已选字段不能超过10个`,
"ObjectDetailed_ViewKeyInformation_Layout":`编辑关键信息`,
"label.paging.totalofpage":`共{0}页`,
"label.ccchat.message.new.error41":`要同更多人会话，尝试使用小组`,
"message.recordtype.detail.noselectlist":`没有可以显示的选项列表`,
"label.conditiontag.lookup.title":`在下面选择要添加的选项列表值`,
"label_partner_setup":`伙伴云设置`,
"front-epwechat-module-v1-android-packname":`Android应用包名：`,
"lable.custom.Current.CY":`当前自定义年度`,
"label.newprocess2.desc":`如果折扣大于0.3%时，评估为真。`,
"label.operatedata.selectobjectfields":`选择导出对象的字段`,
"report_reportdatasource_label":`报表数据源`,
"label.chosesubject.others":`其它活动`,
"label.list.desc2":`Web to CloudCC 页面分成两种：PC版和移动版。PC版可用于电脑访问，移动版用于手机访问，例如微信。`,
"vue_group_several_groups":`{totalSize}个小组`,
"label.page.button.linkurl":`按钮或链接URL`,
"show.week":`显示周末`,
"label.gotocalendar.new":`到日历中创建事件`,
"button.reset.advancedsearch":`清除高级搜索条件`,
"label.h5.chatter.feedandcomnum":`发帖和留言`,
"lable.opppdt.addpdt.table.unitprice":`销售价格`,
"label.dataimport.validate":`选择要执行的验证`,
"label.lead.score":`潜在客户打分`,
"vue_label_help_product":`产品与价格手册`,
"label.role.select":`已选定角色`,
"lable.opppdt.selPdt.searchproduct":`查找产品`,
"component_event_label_newevent":`新建事件`,
"front-invoice-online-payment-setup-configure-button":`立即配置`,
"label.stdashbord.xsld.business.img2":`可能性为1%-99%阶段的总金额`,
"label.event.moveup.2week":`提前 2 星期`,
"label.partnerCloud.priceOfManual.allCustomer":`全部客户`,
"lable.account.dep":`单击“新建”按钮定义一个新的会计年度`,
"label.dataimport.insertdata.error.null.update":`该记录中的$schemefield_name$值为空,无法进行更新操作，该记录已忽略导入。`,
"label_component_helper_businesschange_0activity":`30天内没有任何活动`,
"lable.account.NextbbDays":`未来60天`,
"label_scope_length":`范围长度`,
"label.customfields.operation":`来运行数据导出操作。`,
"serviceappointment.save.workorder":`请选择工作订单行项目关联的工作订单`,
"label.field.update.hide.editor":`隐藏公式编辑器`,
"button.partner.new":`新建伙伴云`,
"label.stdashbord.xsld.business.oppdetails":`业务情况详细表`,
"message.pleasewaitingnextversion":`此功能将在下一版本推出，敬请期待！`,
"label_tabpage_potentialcustomersz":`潜在客户`,
"label_emailtocloudcc_step2":`步骤2`,
"label.weixin.username":`姓名`,
"label.quickbooks.viewlist.type":`类型`,
"front-kefu-moudle-v1-Select-seats":`选择坐席`,
"label.customsetting.manage":`管理`,
"label.tabpage.field":`字段`,
"label.custom.page.button.icon.URL":`按钮图标URL`,
"font-evaluate-module-v1-evaluation-link":`添加评价链接：`,
"vue_label_salesfunnel_notice3":`可能性为1%-99%的业务机会总个数`,
"front-email-payment-describe":`感谢您对我们业务的支持，您可以通过以下链接在线支付，并查看、打印、下载PDF格式的发票。`,
"label.productsales.today.noevttskaddevt":`今天没有未处理的事件或者到期的任务，您也可以点击右上角的“ ”添加事件！`,
"component.setup.iframe.label.memo":`点击设置图标，输入嵌入的URL地址。`,
"front-email-payment-select-country":`请输入国家`,
"label.ems.starred":`标星邮件`,
"component_setup_label_object":`对象`,
"label.query.detail.viewpartneruser":`查看合作伙伴用户`,
"this.year":`本年`,
"serviceresource.isactive.notactive":`此服务资源未启用`,
"label.marketing.message.recipientisnull":`收件人不能为空`,
"label.unfold":`展开`,
"label.service.assetBOM.view.tip":`请联系管理员，您不具有查看资产BOM的权限`,
"label.validate.function.funcExplain.ISCHANGED":`检查字段值是否不同于上一个值，如果不同，则返回TRUE。否则返回FALSE`,
"label.validate.function.funcExplain.NOW":`返回表示当前时刻的日期时间`,
"label.phoenix.islands.time":`菲尼克斯群岛时间`,
"vue_label_checkduplicate_complete_filter_rules":`请填写完整筛选条件`,
"vue_label_report_rowcount":`行计数`,
"chatter.p":`个人`,
"label.umeng.activity.distributetask":`已为您分配任务`,
"UG_quota_05":`与业务机会双向同步`,
"june":`六月`,
"label.reportsSubscriptionPage.schedulereport.monthly.day.tuesday":`星期二`,
"vue_label_commonobjects_view_chart_upto5":`最多展示5个分组`,
"vue_label_opportunity_contactrole_searchallcontacts":`在全部联系人中搜索`,
"label.custom.field.task.notice":`任务通知`,
"label.weixin.insert.address":`插入位置`,
"label.attachementNew.desc":`将附件归档至文档，且该附件不能被删除`,
"setup_mainpage_label_welcome18":`CloudCC 的企业级权限设置使您在处理数据和模块时可以控制各用户的使用权限。基于角色的权限设置还包括用户岗位、组、角色、数据共享规则、字段级安全控制，实现企业不同人员、部门之间的数据共享。`,
"front-kefu-instance-noarea":`该区域尚未创建实例，请重新选择`,
"label.please.ChooseMax":`请最多选择{0}个产品选项。`,
"label.businesschance":`业务机会`,
"label.verticalline-group":`垂直列-分组`,
"label.ordering.platform":`订货平台`,
"label.product.pricebooks.ples":`请选择价格手册`,
"vue_label_norm_addcomponent":`添加组件`,
"label.ServiceCloud.Installation.address":`安装地址`,
"vue_label_report_groupcolumn":`组列`,
"label.ccchat.person.invite.notallsucc":`{0}个电子邮件地址被保存，但未发送。要发送邀请，校正以下错误并单击发送。`,
"label.customfields.optionlist.tip":`允许用户从定义的列表中选择值。`,
"UG.activity.07":`创建一个任务`,
"label.reportsSubscriptionPage.schedulereport.monthly.week.last":`最后一个星期`,
"label.permission.accessname":`权限组名称`,
"lable.custom.year.stadate":`自定义年度开始日期`,
"label.ems.inputmails":`接收邮件服务器（I）`,
"label.cpq.quote.transfer.order.already":`该报价单已经转成订单，请删除原订单后再重新生成订单`,
"label.sendletter.status":`市场活动成员状态`,
"vue_label_commonobjects_view_save_as_view":`另存为视图`,
"message.mobilechooseatmostfive":`最多选取五个字段`,
"label.errormessage.batchedit.nopermission":`没有您具有编辑的数据记录。`,
"label.dataoperate.tip":`请选择将要进行的操作，并选择将要操作的对象`,
"label.enableoperate":`可用操作`,
"label.ems.usernamepassword.error":`邮箱地址或密码错误。`,
"label.campaignmember.selectmember.deletemember":`中删除成员`,
"label.Tab":`菜单`,
"label.emailobject.template.message1":`请选择一个字段，然后点击“插入”。后跟“>”的标签表示还有更多的可用字段。`,
"label.approvalstep3.tip":`指定记录进入此步骤的用户。可选项，可以选择是否允许批准代理也可以批准这些请求`,
"label.inusing":`已启用`,
"label.edit.select.tre":`复选框列表`,
"label.appointmentconfirmail.wizard.title1":`{0} 你好`,
"label.partnerCloud.financeSetting.setAlipay":`设置支付宝支付`,
"lable.edit.queue.avobj":`可用对象`,
"vue_label_checkduplicate_verify_all_characters":`验证全部字符`,
"label.huntingzone":`搜索范围`,
"label.request.approved":`该请求已被审批，请勿重复审批`,
"label.sharerule.msgerror":`服务器内部错误消息`,
"front-epwechat-module-v1-tick-unbound":`请勾选同意并接受以上解绑信息`,
"label.console.step6":`步骤 6.选择列表布置`,
"label.multilang.micropost.vote":`{0}票`,
"message.error.appid.null":`秘钥不能为空！`,
"lable.product.delq":`删除问题`,
"label.h5.approval.leixing":`审批类型`,
"label.edit.field.select.style1":`平铺显示`,
"label.passwordPolicy.setup.alpandnum":`必须混合使用字母和数字`,
"label.ems.close2":`关闭`,
"label.report.reporttypetitle":`报表数据源名`,
"label.umeng.approval.approvalsuccess":`审批已提交`,
"label.page.showamount":`每页显示记录数：`,
"label.copy.asset.successfully":`复制资产BOM成功`,
"vue_label_homepage_bigscreen_dark":`深色`,
"vue_label_email_selected_members":`已选成员`,
"label.file.preview":`预览`,
"label.partner.new.step3.name":`名称`,
"label.forecast.settings.periods.ago":`个周期前`,
"label.evaluation.praise":`好评`,
"label.cloudccsite.edit":`编辑站点`,
"label.knowledgebase.advanced.filtering":`高级筛选`,
"label.knowledgebase.framework":`框架`,
"vue_label_pool_ownedpool":`所属公海池`,
"label.exchange.sync.setting.license":`启用此功能后，部分组织数据可能会以内部部署或基于云的形式，保存到  Microsoft Exchange 服务器，并通过  Microsoft Exchange 服务器进行处理。 CloudCC.com 对 Exchange或 Office 365 等第三方应用程序或系统的隐私和安全实践概不负责。`,
"front-console-conversation-btn2":`邮件回复`,
"label.projectManagement.thelastone":`已经是最后一条了`,
"message.duplication.confirmscript.mergeoperation":`通过所选值将这些记录合并到一个记录中。注意：合并操作将无法撤消，是否继续执行记录合并操作?`,
"lable.outlook.detail.nosyn":`不同步`,
"label.iscopy":`是否允许拷贝`,
"message.matrixReportSetupStage.row":`请选择【指定行标题】小计依据，两个小计依据至少选择一个。`,
"label.forecast.forehistory.possibility":`可能性`,
"label.timetrigger.validate":`输入值必须是正整数，当满足该工作流的依赖触发时间时，系统将自动执行其下的工作流操作`,
"member.name.choice.field":`成员名称为必选字段哦！`,
"label.undone_external page":`这是无法挽回的，所以请确定。此表单不用于任何登录页面，但可能在其他地方使用。例如，您可能已经使用嵌入代码将其插入外部页面。`,
"UG_Lead_012":`导入线索`,
"component_chatter_label_fans":`追随者`,
"label.systeminfo":`系统信息`,
"label.mr.descreption.oneGroupNote1":`请至少勾选两条数据，点击按钮【加载选中的信息】，进入数据合并页面。当前是第`,
"label.wtd.changefields.selfields":`选择要包含在 Web to CloudCC页面中的字段：`,
"message.error.fileinfoid.null":`fileinfoid不能为空！文件信息id`,
"label_tabpage_cownerz":`更改所有人`,
"setup_layout_button_save":`保存`,
"Dashboard.View.Createdbyme":`我创建的仪表板`,
"label.escalation.setup.detail.order":`顺序号`,
"button.partner.start":`开始使用`,
"label.htyj.remark1":`您当前的版本不支持合同对象`,
"component.event.label.person":`被分配人`,
"label.appointmentconfirmail.wizard.subtitle3":`地点`,
"label.emailtocloudcc.filed.username":`邮箱用户名`,
"label.vlidaterule.remark":`通过指定错误条件和相应错误消息，定义验证规则；用户可以更正错误，然后重试`,
"message.duplication.label.insertoption":`新建时操作`,
"front-web-module-v1-detail-comment-toast":`请您完成所有评价`,
"label.import.page2.notsuitedfiledwillbenotimport":`注：系统不会导入您未映射的字段`,
"label.h5.similar.opportunity.enable":`启用类似业务机会`,
"label.allunfold":`全部展开`,
"component_setup_iframe_label_inputurl":`输入URL地址`,
"label.manage.all":`管理全部`,
"label.mobile.side.tab.cs":`常用功能`,
"label.datamanage.contact.information":`联系人信息`,
"lable.outlook.edit.sel":`选择值...`,
"label.imgfield.type.url.tip2":`例如：http://www.cloudcc.com/images/logo.png&cimgSize=50,50。`,
"setup.layout.label.areasetup":`设置区域属性`,
"label.date":`日期`,
"vue_label_commonobjects_detail_openfilter":`展开筛选器`,
"label.loginip.pagecue":`输入有效IP地址范围，指定具有此简档的用户可以从哪些地址登录。`,
"vue_label_email_not_valid":`您输入的不是有效的邮箱`,
"label.page.step5.add.application":`步骤5：添加到自定义应用程序`,
"label.dashboard.donot.delete":`当前仪表板文件夹下存在仪表板，不能被删除！`,
"label.visitAPPexchange":`访问 Appexchange（新窗口）`,
"label.generate.location":`生成客户经纬度数据`,
"lable.quote.syncing.syncingbutton":`同步`,
"label.pw.error.text":`两次输入密码不一致!`,
"label_partner_setup_Enable":`检查可用性`,
"label.file.preview.unav":`预览不可用`,
"label.sms.tip":`来自网络`,
"setup.mainpage.label.welcome21":`CloudCC 云平台提供用户自定义邮件模板功能。方便用户统一使用，提高工作效率。`,
"label.trigger.for.example":`例如：在客户的update触发器中更新业务机会，在业务机会的update触发器中更新客户同时又触发客户的update触发器，如果在触发器中不加条件控制，那么系统最多允许执行3次这样的循环调用！`,
"setup.layout.button.layoutprop":`布局属性`,
"component.chatter.label.fans":`追随者`,
"lable.PowerProcess.event.edit":`重大事件编辑`,
"label.detailintro":`明细说明`,
"vue_label_report_nosearchresults":`搜索无结果`,
"error.name.repeat":`名称不能重复`,
"label.emailEncoding":`邮件编码`,
"label.partnerCloud.financeSetting.enableAccount":`启用返利账户`,
"label_emailtocloudcc_clear":`清空`,
"setup_mainpage_label_welcome12":`用户通过点击鼠标，无需编程，按照系统提示步骤，便可以完成报表定义。系统有列表式报表、汇总报表、矩阵式报表可供选择。同时提供所有字段的显示选择。去除不必要的字段信息。 同时提包括、条状、折线、环状、漏斗、饼状等多类图形显示。让使用者一目了然。`,
"lable.SalesCommitmentKanBan.contractStartDate":`合同开始日期`,
"front-starter-v1-potential-customer-tips-success":`启动潜在客户公池海成功`,
"UG_Forcast_02":`预测是对指定阶段预期销售的估算，预测模式可帮助您确定一段时间内的产品需求和销售收入情况。管理者可以使用预测来设定目标并衡量团队的进展情况。机构的整体预测可按销售代表来反映所有销售的概要情况（不论销售处于从管道阶段到关闭阶段之间的何种完成阶段）。`,
"label.escalation.setup.detail.ruleentries":`规则条目`,
"lable.SalesCommitmentKanBan.allComplete":`总完成额`,
"label.appupload.install.apicanuse":`api名称可用`,
"label.organiza.field":`组织字段`,
"button.partner.workspace.manage":`管理`,
"lable.PowerProcess.setevent":`设置重大事件`,
"label.emailobject.groupemail.msg2":`缺失电子邮件地址，这将导致此封邮件无法发送给该收件人。`,
"label.h5.orderbyname":`按姓名排序`,
"vue_label_salesadvance_opportunities":`商机数`,
"label.appointment.disable.cancel":`禁用取消预约`,
"label.trigger.folder.edit":`触发器页面：编辑文件夹`,
"label.customfields.new.step2.opration.unique.info.v2":`将ABC"和"abc"视为不同值(区分大小写)"`,
"label.icon.40":`定位`,
"label.eventmenuandlink":`事件按钮和链接`,
"label.service.gantt.candidate":`候选人`,
"label.top.userphoto":`用户头像`,
"label.appointmentconfirmail.wizard.btn2":`取消会议`,
"label.print":`打印`,
"saveandreturn":`保存并返回`,
"lable.account.CurrentandNextCY":`当前和下一个日历年度`,
"label.group.no.recent1":`您尚未查看任何启用的小组。`,
"lable.Asset.conversion":`转资产时根据订单产品上“资产转换”的方式生成资产。`,
"label.emailtocloudcc.button.sure":`确认`,
"label.Path.List":`进程列表`,
"label.please.rule.name":`请输入规则名称`,
"label.knowledge.category.hint.six":`可用分类组`,
"setup_mainpage_label_welcome28":`操作指导： 点击本页左侧菜单 → 管理设置 → 数据管理 → 数据导入导出、批量转移、批量删除。`,
"vue_label_commonobjects_view_chart_editchart":`编辑图表`,
"label.permission.detail.app.object":`对象设置`,
"label.multilang.totalpage":`共`,
"label.marketsea.button.return":`退回`,
"Click.to.load.more":`点击加载更多`,
"label.validate.globalvariable":`全局变量`,
"label.marketsea.iseditseabymanager":`允许管理员更改所属公海池`,
"label.price.yuan":`价格（元）`,
"label.service.resource.uesr.tip":`选择用户创建服务资源，资源类型不能选择班组。`,
"vue_label_help_viewusageguide":`查看Lightning版本使用指南`,
"label.autoRegister.changepwd.setpwd.too.long":`太长`,
"label.campagin.roi.fwsl":`访问数量`,
"label.campaign.mobile":`移动端`,
"UG.Lead.012":`导入线索`,
"link.recordtype.detail.backtoobject":`返回自定义对象`,
"front-kefu-moudle-callcentrt-hasclose":`呼叫中心已关闭`,
"label.category.5":`IT高科技`,
"label.import.page1.selectwayofdealdata":`选择处理数据的方式`,
"chatter.emailReceiveEmail":`接收CCChat提醒`,
"vue_label_file_manage_lib_members":`管理文件库成员`,
"label.appupload.upload.overview":`概述`,
"label.service.miniProgram.inputNumber":`请填写0-999的数字`,
"label.emailtemplate.finishdetailinfo":`完成邮件模板的详细信息`,
"label.weixin.fmu.before.day":`提前 {0} 天`,
"label.integrations.login":`登录`,
"label.dashboard.setUpHomePage":`已设置显示的主页`,
"label_partner_common_webSit":`域名`,
"front-epwechat-module-v1-unbound-user":`未绑定用户列表`,
"label.partnerCloud.basicSetting.offline":`启用线下支付`,
"label.start.loginip":`IP开始地址`,
"label.projectManagement.delete.subtasks":`删除该子任务，将删除子任务和子任务关联的所有信息，且数据无法恢复，是否确认删除`,
"label.message.batchapp":`批量审批`,
"message.duplication.label.ruletitle":`查重过滤器规则`,
"label.all_networks":`全部网络`,
"label.select_columns":`选择您希望表单提交时所显示的列`,
"vue_label_notice_uploadavatar_exceed":`上传头像图片大小不能超过 2MB`,
"message.error.get.failed":`获取信息失败！`,
"label.quickbooks.viewlist.duedate":`到期日期`,
"label.ccchat.topic.search":`搜索主题`,
"label.forecast.shre.manager":`分配经理`,
"label.reportsSubscriptionPage.schedulereport.monthly.day.thursday":`星期四`,
"lable.product.pricebooks.copy":`从现有价格手册复制`,
"label.instrumentPanel.minLabelname":`该值必须是正数且要小于断点1值`,
"front-market-form-createdsecond":`注册页面静默填写字段`,
"label.submission_detail":`提交详情`,
"label.customfields.checkbox.tip":`允许用户选择真"（选取）或"假"（不选取）值。"`,
"label.escalation.setup.list.description":`当具有条件的个案超过规定时间仍未处理，您可以通过升级规则定义自动操作。升级个案时，您可以选择自动通知用户、将个案重新分配给另一个用户。`,
"UG.Forcast.05":`预测设置：步骤{0}/{1}`,
"label.data.import":`数据导入`,
"label.upload.error.cause":`上传失败，原因为`,
"label.search.change.remark":`应用于前台左侧栏搜索部分所显示的对象设置`,
"serviceappointment.edit.status.limitwithstatus":`服务预约的状态无法从{0}更改至{1}`,
"label.department.operation":`操作`,
"label.textmessage.vonage.message3":`要查找API密钥和API机密，您可以登录Vonage API帐户，然后转到帐户名下的“设置”。要查找Vonage API帐户中的电话号码，可以转到“产品”下的“号码”，然后单击“您的号码”以查看您拥有的所有电话号码。`,
"label.privacystatement.dialog":`隐私声明 （新窗口）`,
"label.datamanage.import.leadfield":`在下表中，选择导入文件中应导入到每个潜在客户的字段。完成操作后，点击下一步：`,
"label.appupload.upload.install.failar":`安装失败。`,
"label.viewall":`查看全部`,
"label.sendemail.chat.addComentsfavoritesubject":`CloudCC CCChat回复收藏的微贴`,
"lable.custom.dp":`此页允许您定义自定义年度。`,
"label.mobile.more.share":`与同事或组共享`,
"lable.name.cannot.be.empty":`名不能为空`,
"label.autoRegister.changepwd.setpwd.password":`您的密码`,
"label.multipleactivity.aevents":`个事件`,
"label.many.dayline.lastday":`前一天`,
"lable.Please.bind.the.QuickBooks.record.first":`请先绑定QuickBooks记录`,
"vue_no_related_dashboards":`无相关仪表板`,
"label.newdashboardpage.name":`仪表板名称`,
"vue_label_commonobjects_detail_network":`关系网`,
"label.tianyancha.reginstitute":`登记机关`,
"label.the.lower.bound.of.each.level.must.be.equal.to.the.upper.bound.of.the.upper.level.":`分块定价每1层的下界必须等于上1层的上界。`,
"label.chat.file.upload.info":`上传文件`,
"label.appexchange.vlidaterule":`验证规则`,
"label.salescloud.salesdashboard.current.business":`当前商机`,
"label.app.step4.homeisfrist":`主页必须是第一个菜单且不能移除！`,
"label.weixin.micro.research.optionname":`微调研选项名称`,
"label.paging.totalofnbsp":`共{0}条`,
"label.opportunity.perm.title":`请求访问权限`,
"front-kefu-moudle-v1-zhyzcw-reinput":`租户验证错误，请重新输入`,
"label.unsaved_changes":`如果您继续操作的话，未保存的修改将会丢失。`,
"label_partner_all_description":`描述`,
"lable.account.Next.CQ":`下一个日历季度`,
"chatter.feed.menutype.feed.me":`涉及我的更新`,
"label.sourcetranstemp":`源翻译模板：空翻译模板，可以制作一门新的语言文件`,
"label.apply.newuser.validate":`CloudCC新用户注册，验证码：`,
"label.user.password.error":`用户名密码错误，或无效的用户！`,
"label.there.is.no.quotation.line.item.in.this.quotation.line.group.at.present.":`该报价行组目前没有报价行项目，请点击“添加产品”按钮添加产品。`,
"lable.PowerProcess.time.filed":`基于{detailInterestType}的日期时间字段`,
"label.file.default.value.is.integer":`只能输入整数`,
"label.processsetting.please.select.field":`请选择字段`,
"label.app.step3.introduce":`自定义应用程序图标文件大小必须小于20K。为获得最佳效果，图像尺寸最大值应为宽300像素，高55像素。其它尺寸的图像，系统会调整其大小，可能会失真。另外，只有保存后，新图才能生效。`,
"button_partner_save":`保存`,
"label.marketingmanagement":`市场营销`,
"label.isEnableVisualpage_new.leftlist":`可用的自定义页面`,
"label.salescloud.teamrole.optionlist.choose.correct":`列表中存在相同的项，请更正`,
"System_ChangeUser_Info_001":`更改所有人成功，您没有查看此记录的权限，点击后返回到上一个页面。`,
"front-console-no-contact":`无联系人`,
"component.assistant.label.overduetask":`业务机会包含逾期任务`,
"label.roleofpartner":`合作伙伴角色`,
"label.appointmentconfirmpage.wizard.subtitle4-1":`您与{0}`,
"front-template-V1-Please-select-a-picture":`请选择图片`,
"lable.SalesCommitmentKanBan.allsignedCommitmentRate":`总签约承诺率`,
"label.h5.similar.opportunity.step2.conment":`在3与10字段或相关列表之间选择以在查找类似业务机会时互相匹配`,
"label.projectManagement.alert.frequency.will.not.work":`当您选择“否”时，提醒频率将无法生效!`,
"vue_label_fllscreen":`全屏查看`,
"label.customfields.selectcontainfieldlayout":`选择应包含该字段的页面布局`,
"label.appointment.wizard.subtitle1-4":`45分钟`,
"label.tianyancha.businessverify.unagree":`不同意`,
"label.unique":`独有`,
"setup_mainpage_label_welcome10":`操作指导： 点击本页左侧菜单 → 应用程序设置 → 创建 → 对象 → 对象名 → 自定义布局。`,
"vue_label_account_subsidiary":`子公司`,
"label.dataimport.format.error":`格式错误，请使用MM/DD/YYYY或者YYYY-MM-DD的格式。`,
"label.email.new":`新建邮件`,
"label.log.descri":`操作详述`,
"vue_label_dashboard_componentname":`请输入组件名称`,
"label.weixin.quick.reply":`快速回复`,
"label.productsales.payment.badversion":`您当前的版本不支持合同对象无法查看销售回款业绩`,
"label.position":`位置`,
"label.Annex.Conditions":`添加附加条件的逻辑筛选器 （例如：1 And 2 Or 3 ）`,
"label_tabpage_endz":`结束`,
"label.setup.mobile.bottombutton.prompt":`提示：该设置点击保存后，将覆盖用户在移动端自定义的一级页面设置。`,
"lable.Edit.template":`编辑服务报告模板`,
"vue_label_report_onlydisplay2000":`仅显示2000条数据`,
"label.salescloud.salesdashboard.sign.account.top5":`签约大客户top5`,
"label.weixin.ontime":`准点`,
"font-evaluate-module-v1-disappoint":`很抱歉，让您失望了！`,
"chatter.sel.addre":`至多可以选择5个收件人!`,
"label.mobile.phone.month.summary":`本月总结`,
"label.partnerCloud.priceOfManual.selected":`选定客户`,
"label.south.georgia.time":`南乔治亚标准时间`,
"label.create.ccdocument":`新增附件`,
"label.chatter.to":`到`,
"label.ems.minute":`分钟`,
"label.mobile.phone.submit.tome":`提交给我的报告`,
"label.approvalstep1":`步骤 1：输入名称和说明`,
"label.h5.similar.opportunity.last.months9":`最近6-9个月`,
"Opportunity_Detailed_Phase_Label_003":`更改阶段`,
"lable.PowerProcess.time.input":`请输入时间`,
"label.stdashbord.xsld.business.yqzsr":`预期总收入`,
"label.icon.64":`探照灯`,
"label.data.choses.i_desc":`根据您的需要，选择导入单个对象的数据。`,
"label.integrations.mainlandchinaleads":`中国大陆潜在客户`,
"vue_label_notice_savemenu_success":`菜单保存成功`,
"front-kefu-moudle-v1-xzhxzxkf-online":`选择环信在线客服`,
"label_chatter_name":`名称`,
"label.Viewon_Linkedin":`在LinkedIn上查看`,
"lable.PowerProcess.chioce.event":`请选择重大事件`,
"component.chatter.file.label.maxsize":`文件最大为20M`,
"label.validate.function.funcExplain.SECOND":`返回日期/时间字段中的秒数`,
"label.data.downpage.i.title.num4":`4、如果您要导入的对象中具有查找字段和主详字段，则该字段对应的值必须是ID，否则无效。`,
"label.icon.139":`货币`,
"label.app.step4.atleastone":`主页菜单不能被移除！`,
"label.weixin.input.telephone":`请输入手机号`,
"label.setup.mobile.bottombutton.remark":`各组织可根据业务场景设置组织级的一级页面初始设置。`,
"label.file.searchs":`搜索文件`,
"vue_label_email_there_is_no_draft_yet":`暂时没有草稿哦`,
"front-kefu-moudle-v1-bind-seats":`绑定坐席`,
"label.customfields.lookupmuti.tip":`创建一个将此对象链接到另一对象的关系。 关系字段允许用户单击查找图标，以从弹出列表中选择多个值。 另一对象是列表中值的源。`,
"label.integrations.password":`密码`,
"label.data.newtemplate.t_conditions":`模板条件`,
"message.error.repeatsubmit":`此提交存在重复提交或同一页面打开多个窗口修改的情况，若是后者，请在最新打开的窗口中提交。`,
"label.umeng.approval.approvalreassign":`#obj批准被重新分配#objname`,
"lable.edit.queue.selobj":`错误：队列中必须至少有一个所选对象`,
"label.compact.layout.frame":`页面布局框架`,
"label.sms.companyname.dsf.infor":`东时方短信接口信息`,
"template.report.individual.case.source":`个案来源`,
"pagecreator.button.pcpage":`PC端`,
"vue_label_commonobject_selectdatatime":`选择日期时间`,
"label.icon.181":`档案`,
"label.loginip.setup.please":`请指定IP范围`,
"vue_label_dashboard_?secondarygroup":`请选择二级分组`,
"lable.outlook.mcto.pleasedes":`请输入您不愿有关联的电子邮件域，并用逗号隔开。`,
"DetailedInfo_Activity_EmailMessage_01":`{0} 已为 {1}发送一封电子邮件`,
"label.sendmail.step4":`步骤4：您已提交电子邮件进行处理`,
"label.monitorsys.delete.source":`操作描述`,
"label.monitorsys.log.datetime":`下载搜索范围内的系统重点操作审计日志(Excel.xls文件)`,
"component_chatter_label_myfans":`我的追随者`,
"label.tianyancha.h5.registereddate":`注册时间`,
"label.multilang.feedtrack.operatecreate":`已创建一条{0}记录`,
"label.console.step6.no":`选择列表布置`,
"four":`四`,
"message.confirmsetpwdforuser":`是否为用户重新设置密码？`,
"label.cape.verde.time":`佛德角时间`,
"label.queue.new":`新建队列`,
"label.cloudccsite.start":`启用站点主页`,
"label.data.exp.way":`导出方式`,
"label.lock.record.donot.delete":`已锁定记录不允许删除`,
"label_emailtocloudcc_filed_type":`类型`,
"frame_personinfo_label_minipic":`缩略图`,
"label.checkfield.choosetab":`选择查重字段`,
"component.setup.tabs.label.default":`默认页`,
"page.404.button.toknowmore":`了解更多`,
"vue_label_SMS_message_sent_cannot_be_empty":`发送的消息内容不能为空哦`,
"label.lookupreplaceselectvalue":`查找并替换选项列表值`,
"pagecreator_layout_button_new":`新建布局`,
"label.mobile.more.upload":`上载新版本`,
"front-kefu-moudle-v1-Connection-failure":`关联失败`,
"label.version.support.unlimited":`支持不受限`,
"message.error.notmarketseamember":`不是该公海池成员`,
"label.taskandincident":`任务和事件`,
"label.report.export.print.title":`打印报表视图`,
"label.file.publicview.error2":`公用链接信息有误，请使用新的公用链接`,
"label_chatter_cancel":`取消`,
"front-web-module-v1-detail-comment-satisfied":`满意程度`,
"label.knowledge.delete.topic":`删除只被该知识文章使用的话题出错`,
"label.forecast.forehistory.all":`全部`,
"label.displaybutton":`显示的按钮`,
"label.icon.148":`机器人`,
"label_tabpage_ok":`确定`,
"label.checkfield.merge.mainrecord":`主记录`,
"label.notification.arketsea.restored":`{5}恢复了{2}{0}：{1}`,
"setup.mainpage.label.welcome31":`操作指导： 点击本页左侧菜单 → 管理设置 → 创建 → 应用程序`,
"front-kefu-moudle-v1-jtrrt-connect":`将CloudCC的用户与天润融通的分机相关联`,
"vue_label_calendar_please_select":`请选择显示的字段`,
"setup.layout.label.pagename":`页面布局名称`,
"template.chart.schdywjhz":`市场活动业务机会值`,
"label.access_report":`谁可以查看本报表？`,
"label.assignment.layout.section.optional":`可选`,
"label_chatter_recently":`最近`,
"lable.chat.advanced.setting":`高级设置`,
"label.knowledge.category.hint.eight":`分类组`,
"message.error.facebookuid.null":`Facebook用户ID不能为空！`,
"label.step5.total6":`第5步，共6步`,
"label.is.cancel.delete":`是否取消删除`,
"setup_mainpage_label_welcome11":`自定义报表`,
"label.answers":`回应`,
"label.approvalstep1.tip":`为新批准步骤输入名称、说明和步骤号。`,
"template.chart.htjeph":`合同金额排行`,
"label.campaigns.onsiteregistration":`现场注册`,
"front-epwechat-module-v1-input-agentid":`请输入agentId`,
"label.emailobject.wizard.desc2":`跟踪电子邮件是否被打开及打开次数`,
"label.multilang.chatterdetial.vote":`{0}票`,
"label.customsetting.manage.value":`自定义数据`,
"front-electronic-export-listCount":`当前视图总计{totalView}条数据，选择导入的数据`,
"label.dashboard.create.prompt":`列表型报表不可创建仪表板`,
"label_tabpage_askz":`你想提问什么`,
"label.ems.sentmail":`发件箱`,
"label.reportlist.untop":`取消固定`,
"label.owner.h5.plzchose":`请选择所有人后再点击确定按钮`,
"label.callcenter.addup.10.pieces":`一次最多添加10条数据`,
"label.ccdocument.save":`保存文档`,
"label.productcannotnull":`产品不能为空`,
"label_tabpage_enabletomobile":`是否启用到移动端`,
"lable.account.CYAgo":`两个日历年度之前`,
"lable.Select.the.returned.high.seas.pool":`选择退回的公海池`,
"tuesday":`星期二`,
"label.partnerCloud.basicSetting.partnerPayment":`启用伙伴账户`,
"label.validate.function.funcExplain.WEEKDAY":`返回星期几，1代表星期日，7代表星期六`,
"label.query.detail.manageexuser":`管理外部用户`,
"vue_label_systemSettings_environment":`环境`,
"component_setup_tabs_label_delete":`删除`,
"label.weixin.delete.ccchat":`确定要删除这条微贴吗?`,
"label.lanxin.title":`蓝信-H5微应用`,
"label.layout.editcondition.morethanten":`查询条件不能超过10个`,
"label.project.hit.fourteen":`里程碑更新通知`,
"label.createby":`创建人`,
"label.moreoperation":`更多操作`,
"label.lock.tip":`锁定记录以免进行编辑`,
"label.check.input.condition.three":`插入字段中不支持公式和累计汇总类型`,
"label.quote.dingjia":`定价`,
"label.currentuseremail":`当前用户的电子邮箱地址`,
"UG_homepage_004":`自动化`,
"chatter.link":`链接`,
"label.new.zealand.standard.time":`新西兰夏令时`,
"APPIntegration.Dropbox.setting.02":`禁用`,
"label.version.searchandmerge":`查重及合并`,
"label.allmenus.showmsg.nomenu":`没有找到您要搜索的菜单！`,
"front-template-V1-Enable-disable":`启用|禁用`,
"label.marketing.setting4":`注册成功返回网址默认值`,
"UG.Forcast.07":`允许预测`,
"vue_label_systemSettings_correlation":`相关列表展示方式`,
"label.cloudccsite.remark.length":`站点描述不能超过255个字符`,
"label.favorite":`收藏此页`,
"template.report.converted.leads":`已转化潜在客户`,
"label.campaignmember.main.description":`使用此页面管理此市场活动的成员。可以添加新成员或更新现有成员的市场活动成员状态。`,
"label.salescloud.teamrole.account.organization":`小组成员对此客户的访问级别可能高于您组织默认的客户访问设置`,
"label.permission.modifyAppPermission.canselectapp":`可选应用程序`,
"front-epwechat-module-v1-self":`设置自建应用`,
"message.duplication.label.matchexactletters":`精确匹配`,
"label.appointmentdetail.wizard.title18":`周五时间规划`,
"label.area":`区域`,
"label.sso.saml.sp.username":`用户名`,
"lable.outlook.new":`新建Exchange Sync配置`,
"label.custom.field.close.conversion":`关闭-已转化`,
"lable.outlook.detail.tmaping":`任务字段映射`,
"label.emailobject.emaildetail.nextactivity.event":`添加事件`,
"vue_label_commonobjects_detail_date":`结束日期不得小于开始日期`,
"vue_label_email_mark?as":`标记为`,
"label.guestgroup":`客户小组`,
"label_emailtocloudcc_filed_server":`服务器`,
"label.icon.186":`咨询`,
"label.department.user.edit":`编辑`,
"label.custom.page.component.button.settings":`组件按钮设置`,
"label.partnerCloud.orderingPlatform.nextProduct":`是否保存当前配置的产品，并进行下一个产品的配置？`,
"vue_label_appstore_cloud_platform":`cloud官方平台`,
"label.page.previous":`上一页`,
"label.direct.dashboard.week.report":`新建工作周报`,
"label.ServiceCloud.prompt.warning":`按地址统计时暂无资源分布数量!`,
"label.emailtocloudcc.position":`职位`,
"vue_label_email_please_enter_the_message_content":`请输入邮件内容`,
"labal_About_to_jump":`即将跳转`,
"label_profile_mobile_setup_stand":`标准主页`,
"label.visualpage.component.n3":`3.参数. 参数写在args属性中,args="name:'zhang', age:26" 注意单双引号。`,
"vue_label_report_operationmode":`报表运行方式`,
"label.reportsSubscription.select.attached.file":`请选择附加文件的类型！`,
"label.afghanistan.time":`阿富汗时间`,
"label.vlidaterule.formulatrue":`如果公式结果为真，则显示“错误信息”区中定义的文本`,
"label.ccchat.person.invite.erroremail":`电子邮件地址格式不正确。`,
"label.viewDashboard":`转到仪表板列表`,
"label.at":`于`,
"label.notification.arketsea.beforeretrieve":`您的{0}：{1} 即将被回收至{2}，剩余时间{6}天`,
"label.field.update.show.editor":`显示公式编辑器`,
"label.weixin.polls.time":`投票时间`,
"vue_label_commonobjects_detail_activity_nostarttime":`无开始时间`,
"label.direct.dashboard.me.not.approval70":`我提交的未终审项目`,
"label.data.setok.t_desc3":`，进行操作。`,
"label.view.edit.search.describe":`输入关键字后搜索`,
"label.importsourcefiletip":`在导入之前，请确保文件符合以下条件：<span><ul><li>1.为每种您要导入的语言创建包含名称和翻译的文件。</li><li>2.每个文件顶部必须包含语言属性(不支持中文导入)。语言属性如：Language=en_US。</li><li>3.确定您导入的文件采用的是正确的编码格式，如果没有指定系统将会采用UTF-8编码。</li><li>4.确定您导入的文件末尾处已进行回车换行。</li></ul></span>`,
"UG.Case.01":`个案`,
"label.weixin.report.filters":`筛选器`,
"vue_label_homepage_profilehomepageassignment":`简档主页分配`,
"label_tabpage_editview":`编辑视图`,
"label.tabpage.allpotentialcustomers":`所有潜在客户`,
"label.sendemail.send.standbyemail":`(备用发件箱)`,
"errormessage.email.atleastonereceiver.z":`请至少选择或者填写一条收件人地址`,
"workflow.action.tasks.assignortype.ownertype":`所有人类型`,
"label.list.userinterface.new.page.setup":`新版界面`,
"chatter.seladress":`请至少选择一个收件人`,
"Pagelayout_Setup_004":`最多只能配置4个字段`,
"label.mobile.home.page.tenbig.opp":`未来30天十大业务机会`,
"label.wtd.changefields.newpc":`生成PC版页面`,
"label.opportunity.perm.remark":`这是专有业务机会，请和业务机会所有人“owneridccname”联系<br>以取得访问权限。`,
"label.data.exp.tempdes":`模板描述`,
"label.appointment.wizard.subtitle2-1":`从`,
"lable.currencyManage.button.manageexchangeRate":`管理过期汇率`,
"label.file.viewinfo":`查看文件详细信息`,
"label.integrations.mailchimp.export.failed":`导出数据失败，请检查您的网络连接，稍后再试`,
"pagecreator_page_button_edit":`编辑`,
"label.icon.86":`公文包`,
"label.exchange.sync.reset":`重置同步`,
"label.customfields.lookupfilter":`可以创建一个筛选器以限制用户在查找字段中可用的记录`,
"label.component.hotdeal.nopermission":`请联系CloudCC管理员，获取业务机会相关数据`,
"label.address.province":`省/辖区`,
"lable.PowerProcess.3digit.input":`不能超过三位数`,
"label.asset":`资产`,
"label.passwordPolicy.setup.nopwdremember":`不记录`,
"front-electronic-signature-setting-intro2":`发起合同前，请先在DocuSign平台预置好模板。发起签署时，可以选择已经预置好的合同模板发起签署。`,
"pagecreator.page.button.new":`新建页面`,
"label.tabpage.step2":`第二步：指定过滤条件`,
"label_switch_two_column_or_responsive_layout":`切换标准布局或响应式布局`,
"label.batchDelete":`批量删除`,
"chatter.edit.ct":`编辑您的联系方式`,
"UG_ST_003":`您没有创建{0}的权限，请联系管理员，点击确定则直接进入{0}界面。`,
"label.timzone.tip.info2":`使用SimpleDateFormat来对Date进行格式化时，应给SimpleDateFormat类实例设置时区，例如：SimpleDateFormat myDateFormat=new SimpleDateFormat("YYYY-MM-DD、MM/DD/YYYY");myDateFormat.setTimeZone(TimeUtil.getUserTimeZone(userInfo));或者使用TimeUtil提供的工具方法获取实例，SimpleDateFormat myDateFormat=TimeUtil.getSimpleDateFormat("YYYY-MM-DD、MM/DD/YYYY",userInfo);`,
"label.ems.firstsynchistory":`首次同步多久的邮件`,
"label.currency.invalid":`无效币种`,
"label.mask.custom":`自定义`,
"lable.opppdt.addpdt.title":`选择产品`,
"label.appointment.wizard.subtitle3-3":`周三`,
"label.weixin.report.criteria":`分组条件`,
"label.appupload.upload.install.uninstall":`无法安装`,
"label.compact.layout.frame.split":`分屏显示`,
"label.email.attach.complete.info":`上载完成后，文件将显示在下面的附件列表中`,
"label.Receivables":`收款计划`,
"label.linkedin.title.setting":`领英集成信息`,
"label.companynotice":`公司公告`,
"label.emailobject.discard":`取消`,
"label.selected.searchfield":`已选搜索结果字段`,
"front-electronic-signature-explainDocusign":`DocuSign电子签章服务说明：`,
"chatter.link.name":`链接名称`,
"label.low":`低`,
"label.verticalline":`垂直列`,
"label.approval.isallowed.reject.label":`单一数据审批时是否允许拒绝`,
"label.emailtocloudcc.button.enable":`启用`,
"label.dashboardSetup.showdw.d5":`整数单位`,
"label.usermanage.not.authority":`您没有足够的权限执行此操作`,
"label.customobjects.track.introduce0":`此页面允许您选择要在{0}“字段跟踪”相关列表中跟踪的字段。无论何时用户修改以下所选的任何字段，旧字段值和新字段值，以及日期、时间、更改特性和进行更改的用户都将添加到“字段跟踪”相关列表中`,
"canlendarmonth":`日历月`,
"vue_label_dashboard_minimum":`请输入最小值`,
"label.salescloud.optionlist.inputname.linealone":`在下面添加一个或多个选项列表值，每个值应单独占一行`,
"message.error.organuzation.information.null":`组织信息不存在`,
"label.tabpage.maxfilez":`文件最大为`,
"message.validation.apiname":`必须以字母开头，只能包含大小写字母，数字，下划线，最大长度50，最小2位`,
"report.type.label.contractPayment":`合同和收款`,
"label.limiting.choose.three.files":`当前限制选择 3 个文件，本次选择了`,
"label.reportTypeFocus":`报表数据源焦点`,
"Report_Delete_Confirm_Title":`请确认`,
"front-gantt-module-reorder-milestones":`重新排序里程碑`,
"front-starter-v1-customer-tips-success":`启动客户公池海成功`,
"label.tabpage.isdeleteview":`您确定是否删除此视图？`,
"label.favorite.title":`CloudCC云平台`,
"page.layout.sysinfo":`系统信息`,
"label.tabpage.pleaseSelectz":`请选择`,
"label.smsnotice":`短信通知`,
"label.forecast.customforecast.foretype.Pipeline":`Pipeline`,
"label.rejectbehaviour":`拒绝行为`,
"label.searchlayout.view.example.new":`查看示例（新窗口）`,
"vue_label_homepage_notice2":`您可以手动分配主页布局,从而使员工更容易有效地完成其日常任务`,
"label.import.index.chooseidorother":`3、可以选择使用id或名称匹配记录与填写查找字段。若需获取对应记录id等信息，可创建报表，并将记录名称与记录id设置为组列，再将报表导出。`,
"label.westem.european.summer.time":`西欧时间`,
"label.brackets":`括号`,
"asset.serialnumber.unique":`资产序列号已存在，请勿重复添加。`,
"label.callcenter.access.keyID":`访问秘钥ID`,
"label.calendar.month.view":`月视图`,
"label.realdelete":`彻底删除`,
"label.partnerCloud.orderingPlatform.amountPaid:":`待支付金额：`,
"label.reportTypName":`报表数据源名称`,
"lable.newtabpage.opensearchresult":`展开搜索结果`,
"front-kefu-moudle-v1-Session-duration":`会话时长:`,
"label.import.index.ignore":`忽略`,
"label.customfields.url.tip":`允许用户输入任何有效的网址。如果用户单击该字段，将根据用户选择的模式在浏览器的新窗口或当前窗口中打开该 URL。系统默认在浏览器的新窗口中打开该URL。`,
"label.projectManagement.editMilestone":`编辑里程碑`,
"front-gantt-module-v1-project-gantt-list":`项目列表`,
"label.validate.remark":`通过防止用户保存错误数据，验证规则可以改进数据质量。您可以定义一个或多个验证规则，其中包括错误条件以及相应的错误消息。验证规则在保存记录时执行。如果满足错误条件，则中止保存，并显示错误消息。`,
"front-kefu-moudle-v1-sjgsbzq-reinput":`手机格式不正确，请重新输入`,
"label.channel.name":`渠道名称`,
"label.weixin.cloudcc.user.message":`CloudCC用户信息`,
"label.icon.59":`车间`,
"label.ccpeak.function":`方法`,
"lable.opppdt.selPdt.leastten.fields":`请至多选择五个字段`,
"label.deadline":`截止时间`,
"label.product.sel":`价格手册选择`,
"vue_label_helpcenter_detail2":`所有活动：显示您拥有访问权限的所有活动，即使您未参与。<br>    您也可以根据日期范围和活动类型筛选您想要查看的活动记录。<br>4、动态<br>    所有可以查看到本条记录的人员都可以在该记录的“动态”栏目下进行留言发帖，而且您也可以查看关于该条记录的所有信息变更、最新活动，以及其他人员对该记录的留言帖子。该栏目方便您<br>    和同事之间进行网上的工作交流和协作，有助与提高团队协作和工作效率。<br>发表帖子<br>    步骤1: 点击发帖栏，输入发帖内容<br>    步骤2: 根据需要，点击文件/链接按钮，添加文件/链接<br>    步骤3: 点击”共享“，完成发帖。<br>查看帖子<br>    帖子发表成功后，您可以在下方看到刚刚发表的微贴。微贴由以下几部分组成：头像、人员姓名、微贴内容及互动方式（点赞/评论/编辑/删除帖子）。<br>帖子的排序和查找<br>    点击“排序”右侧的下拉列表，可以更改帖子的排序方式。<br>     “最新活动”排序：按微贴的最新互动时间排列；<br>     “最新发表”排列：按微贴的发表时间排列；<br>    查看不同类型的微贴<br>    纯文本微贴：直接在微贴发表区就可浏览全部内容；<br>    含有文件的微贴：点击文件的下载按钮，可以将文件下载到本地进行查看；<br>    含有链接的微贴：点击微贴中的链接，即可打开；<br>评论和点赞微贴<br>    发表评论<br>    步骤1: 点击每条微贴下方的“评论” <br>    步骤2: 在打开的文本框中输入评论内容<br>    步骤3: 根据需要添加评论的文件/链接<br>    步骤4: 点击文本框下的“评论”，完成操作<br>    删除评论<br>    评论的发表人可以删除评论内容。点击评论右侧的按钮，在下拉框中选择“删除”。`,
"pagecreator_layout_button_mergecell":`合并单元格`,
"Lead_Scoring_Setting_Rule_Setup_Active":`是否激活`,
"label.query.detail.loginbypartneruser":`以用户身份登录伙伴云网站`,
"label.view.selectrenderfields":`选择要显示的字段`,
"label.code.add":`添加二维码链接信息`,
"label.appointmentconfirmpage.wizard.title1":`会议已预约`,
"label.timzone.tip.title":`日期时间类型数据多时区支持。在使用new Date()或者Calendar处理日期时，应注意处理相应的多时区问题。另外，TimeUtil工具类中提供了很多支持多时区的工具方法。`,
"label.tag.addtags.visibility":`可见性`,
"label.appointmentconfirmpage.wizard.title3":`您确定要取消现有预约并创建一个新的预约吗？`,
"lable.outlook.detail.oldest":`最旧`,
"label.account.custom.quarter.timeerror":`自定义季度开始日期或自定义季度结束日期在历史自定义季度时间段内，请检查后重新设置！`,
"label.sendsms.idea":`尊敬的`,
"label.manageAll.pagenum2":`当前已经是最后一页了`,
"serviceterritory.isactive.notactive":`此服务区域未启用`,
"label.userinfo.newpwd.notnull":`新密码不能为空！`,
"vue_label_dashboard_nolinkagedashboard":`暂无可联动仪表盘`,
"message.cannotdeleteapproval":`无法删除批准过程`,
"label.wtd.detail.m":`移动版`,
"label.app.step4.introduce":`选择要包括在此自定义应用程序中的菜单。`,
"label.ccchat.error.permission":`无权限`,
"UG_opportunity_009":`或者`,
"label.Receivables.TheActualAmountOfMoney":`实际收款金额`,
"label.callcenter.no.search":`没有相关查询到信息`,
"label.user.introduce":`用户`,
"message.datalocked.addpdt":`该业务机会已锁定，不能再添加产品。`,
"label.sendsms.step1":`步骤1：指定短信接受者`,
"label.brief.contracts":`合同数`,
"label.setup.mini.swap":`轮播图设置`,
"label.emailobject.wizard.desc1":`关联您的个人邮箱，在此发送邮件并自动同步到记录`,
"label.login.verification.mfa.desc2":`如果您因为某些原因（如手机丢失或误删除MFA应用等）无法进行验证，可以通过管理员解除MFA绑定`,
"label.notification.receiveSms.message":`您有一条来自{!fromaddress}的短信，请点击查看`,
"label.emailmerge.mergeFolder.publicfolder":`未归档公用邮件合并模板`,
"label.password.update.false":`密码修改失败，请联系系统管理员！`,
"label_tabpage_systemz":`个系统`,
"label.dataimport.objectid.null":`对象ID为空，系统不允许导入`,
"label.currency.type":`币种类型`,
"component_setup_button_appurl":`本系统URL`,
"label.appointmentconfirmail.wizard.title2":`您已经成功预约了{0}`,
"lable.product.please.enter":`请输入`,
"label.escalation.setup.title":`个案升级规则`,
"label.create_failure":`表单创建失败`,
"label.weixin.brand.model":`厂牌型号`,
"label.layout.nameoftestobj2":`测试对象二名称`,
"vue_label_filters_number":`每个报表支持最多15个筛选器。`,
"label.file.following":`正在追随`,
"vue_label_account_all_contracts":`转移客户所有人的所有合同`,
"label.service.please.select.cycle.type":`请选择周期类型`,
"label.weixin.weipoll.optionname":`微投票选项名称`,
"label.data.newtemplate.null":`无`,
"message.passwordPolicy.validate.complexReq1":`错误：密码必须是数字和字母的组合`,
"label.forecast.shre.editmanager":`编辑经理`,
"label.emailtemplate.tip":`以下列出了选定文件夹中的所有电子邮件模板。 单击新建"按钮可以创建新的文本或HTML电子邮件模板。您可以在发送邮件时使用这些电子邮件模板。单击角色链接可查看更详尽的信息"`,
"label.tag.manage.button":`管理标签`,
"label.changepw":`修改密码`,
"label.sso.saml.sp.idsource.nameid":`身份在“主题”声明NameIdentifier元素中`,
"label.salescloud.teamrole.addmember":`添加业务机会小组成员 CloudCC`,
"label.h5.similar.opportunity.last.months6":`最近3-6个月`,
"message.save.opportunity.role.save.failed":`联系人角色保存失败`,
"vue_label_report_formulainformation":`公式信息`,
"label.area.assignuser.remark":`将用户分配给区域`,
"label.multilang.viewlist.total":`共计选中{0}条记录`,
"label.newprocessstep4":`步骤 4 选择电子邮件通知模板`,
"label.permission.objectpermission.open":`打开`,
"label.service.gantt.close.list":`关闭列表`,
"label.standarduserfield":`标准用户字段`,
"vue_label_commonobjects_detail_the_administrator":`该记录已锁定，请联系管理员。`,
"label.exchange.sync.account":`Exchange 服务帐户凭据`,
"label.mr.title.button.back":`返回，重新设置查询条件`,
"label.notsetup.operation":`行条件错误，未设置运算符！`,
"label.notifications_center":`通知中心`,
"label.event.moveup.5hour":`提前 5 小时`,
"report_label_pleaseinput":`请输入搜索内容`,
"label.batchadd.newbatchpage.errorlist":`条数据添加失败`,
"label.quickbooks.invoices":`发票`,
"chatter.feed.usingchatter":`启用CCChat后，可以对人员和记录进行追随，可以进行张贴。`,
"label.all.marketing.activities":`市场活动所有人`,
"label.lookup.finish":`查找自动完成`,
"label.weixin.unbind":`解除绑定`,
"front-console-closeTime":`关闭时间`,
"label.service.rest.time":`剩余时间`,
"label.mr.descreption.condition1":`请输入查询重复数据的范围和规则，点击【查询重复数据】按钮，得到符合条件的重复数据。`,
"label.group.new":`新建小组`,
"vue_label_SMS_sending_please_wait":`发送中，请稍后`,
"label.Standardobj.tab":`标准对象菜单`,
"label_chatter_pastEvents":`过去活动`,
"label.chatter.priority":`优先级`,
"select.nullvalue":`--无--`,
"setup_layout_group_pagecomponent":`页面元素`,
"label.dataimport.dataerror.check":`数据错误，请仔细检查本条数据`,
"label.permission.detail.app.pagesetting.tip":`执行自定义页面权限的设置`,
"label.knowledge.language.polish":`波兰语`,
"label.project.hit.two":`子任务到期提醒`,
"label.customerapp":`自定义应用程序`,
"label.reportsSubscriptionPage.condition.value":`值`,
"label.tabpage.no2z":`否2`,
"lable.system.administrator":`抱歉，您无权进行此操作，请联系系统管理员`,
"homepage.layout.buttion":`页面布局分配`,
"label.notification.event.overlapEvent":`被分配人已在{begintime}-{endtime}安排了{subject}，是否继续创建？`,
"label.customfields":`自定义字段`,
"label.data.downpage.e.title":`导出数据的步骤:`,
"label.notification.serviceappointment.remove":`您已被取消派遣工单{0}，请合理安排工作。
`,
"label.campagin.roi.zhuangtai":`市场活动状态`,
"label.applt.updown":`下载小程序二维码`,
"label.customfields.new.step1.tip":`指定自定义字段所要包含的信息类型`,
"label.staticresource.upload.limit":`只能上传以下格式中的文件：png、jpg、gif、js、css、zip.`,
"chatter.edit.user.p":`更改用户头像`,
"label.icon.32":`电脑`,
"vue_label_homepage_notice_cantset":`未给该简档配置简档主页，无法修改简档的默认主页`,
"front-epwechat-module-v1-agree-unbound":`同意并接受以上解绑信息`,
"label.version.chatter.cooperation":`同事圈`,
"label.customer.tab.step1.selectstyle":`请选择菜单样式`,
"label.select.an.asset":`请选择一个资产`,
"label.search.sizer.field":`搜索筛选器字段`,
"label.emailmerge.mergeFolder.lastone":`请至少选择一个模板!`,
"label_tabpage_step2":`第二步：指定过滤条件`,
"label.version.lead.automatic.allocation":`潜在客户自动分配`,
"label.projectManagement.update.succeeded":`更新成功`,
"label_tabpage_bar":`条`,
"label.appupload.component.type.tab":`菜单`,
"label.pigeonhole.sel.f":`选择要归档的文件夹`,
"homepage.components.status":`组件状态`,
"label.currency.edit.new":`币种编辑：新币种`,
"label.input.new.password":`请输入正确的新密码`,
"chatter.group.membersName":`成员名`,
"label.myinfo.modify":`编辑我的信息`,
"label_tabpage_next":`下一步`,
"vue_label_homepage_card_closedopportunities":`已逾期的业务机会`,
"label.permission.edit":`编辑属性`,
"message.error.searchfield.objid.null":`查询字段所需的对象id不能为空`,
"label.partnerCloud.productSet":`产品设置`,
"label.emailtocloudcc.filed.emailto":`Email to`,
"label.service.miniProgram.uploadingImage":`请上传轮播图图片`,
"label.sso.saml.idp.description1":`连接的应用程序`,
"label.event.moveup.10minutes":`提前 10 分钟`,
"label.quote.createby":`准备者`,
"label.workflow.baseontimeoparate":`依赖于时间的工作流操作`,
"label.searchall.r":`重新搜索`,
"vue_label_homepage_differentprofiles":`为不同的简档分配不同的主页`,
"label.campaign.channel.step1":`步骤1：基本信息`,
"label.event.moveup.2hour":`提前 2 小时`,
"font-evaluate-module-v1-cancle-reply":`取消自动回复`,
"message.datalocked.delete":`记录已锁定:您试图删除的记录已锁定。如果必须执行此操作，请与您的管理员联系。`,
"label.sso.listOfKey":`密钥列表`,
"label_chatter_newtask":`新建任务`,
"label_emailsync_form_seversetting":`设置`,
"label.partner.new.function":`功能说明`,
"vue_label_notice_homepage_pleaceentername":`请输入主页名称`,
"message.please.choose.opportunity":`请选择业务机会`,
"label_file_use_most_user":`使用存储空间最多的用户`,
"label.htyj.remark2":`无法查看合同业绩`,
"label.formula.message":`当公式评估为假时提交的失败提示信息`,
"UG_Case_04":`个案分配`,
"label.displaycolumn":`显示列`,
"vue_label_campaign_selected_member_status":`更新为选定成员状态`,
"label.workflow.operate":`工作流操作`,
"label_chatter_mail":`邮件`,
"label.setup.mini.setting":`小程序后台设置`,
"vue_label_chat_invitetojoin":`你邀请“{invite}”加入了群聊`,
"setup.object.field.dependency.label.linkedfieldvalue":`依赖字段值`,
"vue_label_email_update_template":`更新模板`,
"label.email.template.private.mail":`专用邮件模板文件夹`,
"lable.Confirm .potential.customers":`确认回收潜在客户{name}`,
"vue_label_leadpool":`潜在客户公海池`,
"label.ems.hostorpost.error":`服务器或端口配置错误，请检查。`,
"label.search.saveok":`保存成功`,
"label.custom.field.cannot.maping":`无法多次映射到此字段`,
"label.projectManagement.dispatched":`已派遣`,
"time":`时间`,
"label.choose_socialnetwork":`选择一个社交网络开始`,
"label.vlidaterule.checkedtrue":`如果是复选框字段时直接这样判断，不需要加双引号`,
"label.appointmentconfirmail.wizard.btn1":`重新预约`,
"front-kefu-moudle-v1-maxchars-input":`最多输入{0}个字符`,
"setup.mainpage.label.welcome10":`操作指导： 点击本页左侧菜单 → 应用程序设置 → 创建 → 对象 → 对象名 → 自定义布局。`,
"label.ems.company.setup.title":`公司发件箱设置`,
"label.channel":`营销渠道`,
"label.textmessage.groupsms":`群发短信`,
"label.asset.deleted.successfully":`删除资产BOM成功`,
"label.knowledgebase.new.workspace":`新建工作区`,
"label.ServiceCloud.diliweizhi":`地理位置`,
"label.private_me":`仅对所有人（本人）`,
"label.service.miniProgram.imageLink":`轮播图链接`,
"label.area.assigned":`已分配的用户`,
"label.weixin..xsld.name":`业务机会名称`,
"label.campaign.matchway.select.name":`姓名`,
"label.installedsoft":`已安装的软件包`,
"label.projectManagement.spare.time":`空余时间`,
"label.user.select.custom.text.sendemail":`选择自定义的文本格式直接发送邮件`,
"label_chatter_chatter":`CCChat`,
"label.approveorrefuse":`进行审批`,
"startdate.enddate.time.illegal":`开始日期应小于等于结束日期。`,
"label.project.hit.eight":`每天项目任务提醒`,
"message.duplication.label.uncheck":`不校验`,
"label.allocation.role":`分配用户`,
"label.sendemail.lead.scoreinfo":`尊敬的#userName:\r\n    系统已经使用潜在客户打分规则，对您所选择的潜在客户视图“#viewlabel”上所有的潜在客户打分完毕，耗时#timestr,\r\n 请您登陆系统，打开视图进行查看。\r\n    请注意：\r\n 如果没有看到潜在客户打分分值，您可以编辑视图，添加”潜在客户打分“到要显示的字段上查看打分的结果。\r\n 感谢您的使用！\r\n                                                          #orgName\r\n`,
"lable.oppt.jieduan.closejieduan":`结束此业务机会`,
"label.ems.verify":`验证`,
"message.error.startdate":`开始日期必须小于结束日期`,
"label.campaignmember.main.deletelead":`删除成员-现有潜在客户`,
"label.partnerCloud.financeSetting.account":`启用后，会添加伙伴账户与账户流水对象，合作伙伴用户在下单时可以使用CloudCC系统内的账户支付。`,
"message.datalocked":`记录已锁定:<br> 您试图编辑的记录已锁定。如果必须执行此操作，请与您的管理员联系。`,
"lable.opppdt.selPbk.pricebook":`价格手册`,
"label.knowledgebase.restore.article":`还原文章？`,
"label.object.batchadd":`批量新增{objName}`,
"label.what_happen":`访客提交此表单后所看到的页面`,
"label.roleandunderling":`角色和下属`,
"label.knowledge.language.russian":`俄语`,
"front-electronic-signature-explain-first":`绑定电子签章服务前，建议您先在法大大平台进行企业注册和认证。`,
"component.sendmail.label.subject":`主题`,
"month":`月`,
"label_chatter_save":`保存`,
"label.view.sortview.sectiontitle":`视图将按照选择的顺序输出。`,
"label.mobile.home.page.major.project":`重点项目`,
"label.weixin.input.filename":`请填写文件名`,
"label.pagelayout.remark":`使用此页面可创建各种页面布局以显示`,
"label.service.miniProgram.store":`品牌故事`,
"label.recordtype.edit.selected":`所选值`,
"message.selectgroupcondition":`请选择分组条件`,
"label.y.axis.cannot.empty":`Y轴不能为空！`,
"label.textmessage.vonage.connected.count":`计为已联系`,
"setup.layout.label.readonly":`只读`,
"front-kefu-moudle-service-agent":`客服`,
"message.login.mfaverification.page.invalid":`页面失效，请重新刷新页面`,
"label.central.standard.time":`中央标准时间`,
"label.processnoticepic":`批准过程注意图像`,
"vue_label_helpcenter_calendar1.2":`日历条目显示规则：日历条目会显示在日历网格中，日历条目所在的格子区域代表着此条记录所处的时间范围。日、星期、可用性视图中会在时间刻度顶部显示跨度超过24小时的日历条目。月视图中一个网格中如果有多个日历条目，可以点击“ 更多”查看。日历条目左或右侧边呈半圆，代表所在格子的前一天或后一天都没有此记录。日历条目左或右侧边呈直角圆，代表所在格子的前一天或后一天还有此记录。<br>    快速定位日历视图的日期：您可以通过选择日历页面右侧的小日历上的时间去定位左侧日历视图显示的日期范围。您也可以单击日历页面右上方“<”和“>”图标快速切换日期。如果您的日历视图所处的时间不是当前时间，您可以单击日历页面右上方“今天”图标快速切换回今天。<br> 列表视图<br>    从日历视图切换至列表视图：单击日历视图右上方“日历”图标，选择“表格”，即可切换至事件列表视图。<br>    列表视图的使用：要同时查看特定事件或多个事件，打开表视图。列表视图中有预设的列表视图，单击列表视图左上角“下拉按钮”图标，即可展示所有您具有访问权限的列表视图。您还可以通过自定义事件列表视图，以满足您的需求。<br>2、我的日历和其他日历<br> 我的日历<br>    我的日历包含我的事件日历和对象日历。<br>    我的事件日历：在日历视图上显示被分配人是您的所有事件记录。我的事件日历不能移除、编辑或更改颜色。您可以将“我的事件日历”共享给您的同事。`,
"label.approval.end":`流程结束`,
"vue_label_report_notice_cannotdelete":`该文件夹内有报表不能删除`,
"label.sso.saml.idp.loginurl":`身份提供商登录URL`,
"label.emailtocloudcc.filed.port":`端口`,
"label.directdashboard.righttitle":`销售分析仪表板`,
"label.knowledge.case.suggest.article":`在个案中建议相关文章`,
"label.version.maxcount":`，已超出上限！`,
"label.weixin..xsld.yjqyrq":`预计签约日期`,
"front-project-module-v1-unmarket-is-template":`取消模板标记`,
"label.mobile.quickcreate.default.map":`签到`,
"chatter.click.p":`单击预览`,
"label.chat.topic.all.topic":`所有主题`,
"label.channel.head":`渠道负责人`,
"lable.edit.queue.emaildes":`输入发送通知时（例如已将个案放入队列时）要使用的队列名称和电子邮件地址。电子邮件地址可以是单个地址，也可以是通讯组列表。向队列分配对象时，将只通知队列成员。`,
"label.tag.filter":`标签过滤`,
"label_chatter_filterTimeLine":`筛选时间线`,
"label.dashboard.show.value":`显示值`,
"vue_label_normal_solution_sf":`解决方案`,
"label.customfields.location.tip":`允许用户定义位置。包括经度和纬度组件，可用于计算距离。`,
"label.weixin.copyright":`Copyright© 2008-2022 CloudCC.com Inc. 北京神州云动科技股份有限公司版权所有。`,
"label.icon.33":`电脑`,
"label.mr.title.opportunityName":`业务机会名称`,
"template.report.sales.month":`本月销售情况`,
"chatter.group.lookingForPeople":`查找人员...`,
"label_tabpage_userz":`用户`,
"label.reportsSubscriptionPage.email.formatselection":`请选择你想要邮件的报表形式`,
"lable.product.plist":`价目表价格`,
"label.multilang.activity.monthline":`第{0}周`,
"label.ccchat.whose.name.contains2":`的任何活动小组的成员`,
"label.mobile.phone.day.report":`日报`,
"label.processsetting.set.files":`设置字段`,
"label.systemlog.s":`成功`,
"label.tabpage.uploadsz":`上传`,
"serviceterritory.member.time.conflict":`在此时间范围内，服务资源已成为其他服务区域成员`,
"label_chatter_startDate":`开始日期`,
"label.search.at.least.two":`搜索词不能少于两个字符`,
"label.approval.ressign.project":`待分配项目`,
"lable.custom.Previous.CY":`上一个自定义年度`,
"label_chatter_link":`链接`,
"label.weixin.group.name":`名称`,
"label.partnerCloud.basicSetting.domainName":`该操作不可逆，且初始化后不可修改域名，是否确定？`,
"lable.SalesCommitmentKanBan.targetContract":`目标签约额`,
"label.currency.new":`新公司币种`,
"message.passwordPolicy.validate.complexReq3":`错误：密码必须是数字、大小写字母的组合和符号`,
"label.icon.127":`医生`,
"label.customfields.fieldname.tip":`字段名"供内部用于API集成`,
"chatter.feed.menutype.feed":`摘要`,
"label.home.standard.dashboard.role":`您没有角色信息，不能查看销售承诺看板。`,
"label.customfields.fielddependency.button":`单击该按钮可在依赖选项列表中包括所选值或从中排除这些值`,
"label.recentprojects":`最近访问的记录`,
"label.appupload.logo.introduce":`AppExchange软件包图标文件大小必须小于20K。为获得最佳效果，建议图像尺寸为宽60像素，高60像素。其它尺寸的图像，系统会调整其大小，可能会失真。另外，只有保存后，新图才能生效。`,
"label.integrations.northamericanleads":`北美潜在客户`,
"label.sms.balance":`余额(元)`,
"label.ccchat.message.num":`个消息`,
"label.embed_website":`仅需将以下代码复制并粘贴在您的页面HTML代码中，即可嵌入本表单。`,
"label.trigger.check.error":`触发器语法检查失败`,
"label.bmap.baidu.maps":`百度地图`,
"label.nextapproverauto":`下一个批准人的自动确定方式`,
"label.customfields.date.tip":`允许用户输入日期或从弹出式日历中选择日期。`,
"button.partner.back":`返回`,
"label.layout.editcondition.tip":`选择要作为查找条件的字段。请注意，此处最多可选择10个字段`,
"label.stacked.area":`堆叠图形-区域`,
"font-evaluate-module-v1-case-closed":`仅当个案关闭时`,
"label_emailsync_status_log":`关联日志`,
"label.version.area.and.sales":`区域管理和销售团队`,
"label.service.booking.sessions":`服务预约时段`,
"label.untransfile":`未翻译的语言文件`,
"label.textmessage.sentfail":`发送失败`,
"label.emailtemplate.detailinfo":`邮件模板详细信息`,
"setup_mainpage_label_welcome13":`操作指导： 点击顶部菜单 → 报表 → 新建 。`,
"label.ccchat.error.nullid":`ID不能为空`,
"label.partnerCloud.partnerAccount.rebate":`返利收入`,
"label.appupload.component.type.scheme":`字段`,
"front-kefu-moudle-phonein":`来电`,
"label.emailmerge.list.description":`邮件合并模板为Microsoft Word 文档，其中的合并字段引用CloudCC字段。单击'新建模板'可上载新的邮件合并模板`,
"vue_label_commonobjects_detail_select_first":`请先选择相关项`,
"label_emailsync_form_action":`操作`,
"label.customfieldrelation":`自定义字段和关系`,
"label.ems.other.msg":`请联系Cloudcc管理员(<a href='mailto:admin@cloudcc.com' style='text-decoration: underline;'>admin@cloudcc.com</a>)，开启邮件同步服务.`,
"label.appointment.wizard.subtitle4-3-4":`1小时`,
"label.service.miniProgram.isOpen":`是否开启`,
"equal":`等于`,
"label.partnerCloud.financeSetting.merchantInformation":`获取路径：商户平台-账户中心-商户信息`,
"vue_label_calendar_displayed_field_name":`显示的字段名称`,
"UG_opportunity_002":`定义您的销售周期 配置阶段`,
"label.tag.addtags.button1":`确定`,
"label.explain":`说明`,
"label.icon.166":`亭子`,
"label.exchange.sync.setting.use":`启用 Exchange Sync`,
"label.chatter.assignPerson":`被分配人`,
"lable.PowerProcess.event.condition":`重大事件条件`,
"label.addattachment.step1":`步骤 1.选择文件`,
"label.account.fiscal.quarter.timeerror":`会计季度开始日期或会计季度结束日期在历史会计季度时间段内，请检查后重新设置！`,
"label.URL":`URL路径`,
"label.icon.134":`数据`,
"label.forecast.customforecast.foredis.sq":`数千`,
"label.custom.field.number.decimal":`数字位数不对`,
"label.version.history.track.error":`您的版本目前仅支持选择<=5个字段，无法选择更多。`,
"label.log.os":`操作系统`,
"label.partner.workspace.tab.option":`可选菜单`,
"label.partnerCloud.partnerAccount.accountWater":`账户流水`,
"setup_layout_label_norelatedlist":`暂无相关列表`,
"label.import.page1.nextstep":`下一步`,
"label.emailobject.view.attached":`有附件`,
"label.SalesCommitmentKanBan.allTask":`总任务额`,
"label.eastem.daylight.time":`东部夏令时`,
"label.create_engaging":`创建一个吸引人的帖子，与世界联系。`,
"label.area.adduser":`添加或删除用户`,
"label.timezone.importtimezone.user":`使用当前用户时区时间`,
"label.passwordPolicy.setup.pwdremember1":`记住1个密码`,
"label.query.detail.openpartneruser":`启用合作伙伴用户`,
"label.senduser":`发件人`,
"Pagelayout_Setup_001":`选择要在悬停页面布局上显示的相关列表`,
"label.mobile.parameter.setup":`移动端参数配置`,
"message.device.not.bound.mfa":`未绑定的MFA设备`,
"setup.layout.label.buttonarea":`按钮区域`,
"chatter.email.reply.like":`对我喜欢的帖子回复时`,
"label.chatter.day":`天`,
"label.sendemail.chat.addComentspraisesubject":`CloudCC CCChat回复喜欢的微贴`,
"label.field.remark2":`页面上显示的字段。`,
"label.ggReleaseRange.release":`发布范围`,
"lebel.alreadyback":`已调回`,
"label.appupload.install.appname":`应用程序名称`,
"label.selectnewadeckertag":`选择新层次结构字段的标签`,
"label.cliententrancewebsiteadmin":`客户入口网站管理员`,
"label.checkbox.checked":`选中的`,
"UG.Case.03":`个案自动升级`,
"vue_label_dashboard_group":`请选择一级分组`,
"label.import.index.preparedata":`准备您要导入的数据`,
"vue_label_member_notice1":`您可以上传JPG、GIF或PNG文件，最大文件大小为2M`,
"message.modify.success":`修改成功。`,
"label.userquotas":`定额`,
"label.appointmentpage.wizard.subtitle3-1":`姓名`,
"label.import.index.maxdata2":`2、导入之前，请先确保导入其相关的所有记录。例如：如果您当前导入的对象与联系人之间存在查找关系，请先导入这些联系人，然后再导入您的数据。若需获取对应记录id等信息，可创建报表，并将记录名称与记录id设置为组列，再将报表导出。`,
"label.pc.sectionpart":`PC部分`,
"template.chart.wcldqzkh":`未处理的潜在客户`,
"label.save.the.block.pricing.information.of.the.current.price.manual":`是否保存当前价格手册的分块定价信息？`,
"label.partnerCloud.financeSetting.payments":`允许订单线上付款`,
"lable.account.ThisWeek":`本星期`,
"label.validate.function.funcFormat.RIGHT":`RIGHT(text, num_chars)`,
"label.app.select.bgcolor":`选择背景色`,
"label.planned.work":`计划的作业`,
"label.passwordPolicy.setup.nolimit":`无限制`,
"label.vlidaterule.s":`如果您禁用用户使用的币种，则用户的币种将被设置为公司币种.`,
"label.paging.totalofrecords":`共{0}条记录`,
"label.customobjects.behaviour":`行为`,
"vue_label_ccchat_notice_deletecommentsuccess":`删除评论成功`,
"label.lock.record.dele":`当前记录已锁定，不允许删除！`,
"label.data.expnode.e.desc3":`3、模板制作：用户可以根据需求将所需导出的字段及条件制作成模板，方便下次使用。`,
"label.button.step3.create.page":`步骤3：生成页面`,
"label.sharer":`共享者`,
"label.service.cycle.type":`周期类型`,
"lable.SalesCommitmentKanBan.allreceivingCommitmentRate":`总收款承诺率`,
"label.formuladate":`日期格式：YYYY-MM-DD hh:mm:ss或MM/DD/YYYY hh:mm:ss 比如: 2007-12-25 12:25:30或12/25/2007 12:25:30,也可以使用today()，或now();`,
"front-template-V1-addImg":`添加图片`,
"label.basecontrol":`基本权限`,
"label.forecast.settings.lable1":`预测数据聚合`,
"message.error.file.null":`上传文件不能为空`,
"label.multiply":`*乘`,
"message.duplication.label.targetobject":`目标对象`,
"label.addattachment":`添加附件`,
"vue_label_dashboard_notice_editcertification":`确认编辑组件{name}吗？`,
"label.notification.tip2":`您现在没有新通知`,
"lable.quote.syncingfrom.firstsync":`初步同步： 业务机会同步至报价单`,
"label.createtasktip":`创建一个任务以关联一个或多个工作流规则、批准过程或权利过程。 如果更改任务，任何修改都将应用到与之相关联的所有规则、批准或权利过程。`,
"label.leave":`离开`,
"front-invoice-online-payment-setup-china":`适用于中国客户`,
"label.appointment.wizard.subtitle4-1-2":`30分钟`,
"label.projectManagement.the.person.not.be.informed":`当您选择否时，将无法通知负责人!`,
"label.campagin.roi.name":`市场活动名称`,
"label.import.page1.newcreate":`新建`,
"label.data.downpage.i.title.num2":`2、开始导入之前，请确保您要导入文件中的字段名称和 CloudCC 系统中对象字段名称的匹配。`,
"label.callcenter.call.in":`呼入`,
"label.weixin.activity.phone":`活动: 电话`,
"label.forecast.customforecast.type.role":`按角色`,
"label.moscow.standard.time":`莫斯科标准时间`,
"label.profile.setcustomobjectrecordtype":`自定义对象记录类型设置`,
"lable.edit.queue.new":`新建队列`,
"label.newAPPexchange":`新建应用程序...`,
"message.custom.field.donotdelete.fieldupdate":`该字段被其他工作流或批准过程下的字段更新所引用`,
"label.chatter.state":`状态`,
"label.subject_line":`主题行`,
"template.report.folder.active":`活动和行为分析`,
"label.icon.114":`房子`,
"label.assignment.setup.newentries.step3":`步骤 3：选择要分配的用户`,
"label.salescloud.salesdashboard.sales.behavior.rankings":`个人-行为一览`,
"label.weixin.optiontwo":`选项二`,
"label.sso.saml.idp.config.sp":`服务提供商`,
"System_TimeField_Description":`允许用户输入当地时间。例如，"2:40 PM"、"14:40"和"14:40:00"是此字段的所有有效时间。`,
"label.knowledgebase.draft":`草稿`,
"label.chat.topic.no.more.suggestions":`无其他建议`,
"label.quote.product":`产品`,
"label.cryptographictext":`加密文本`,
"label.custom.unlock":`解锁`,
"label.assignment.setup.newentries.step2":`步骤 2：选择此规则条目的条件`,
"label.tabularreport.selectline":`选择要在报表中包含的列`,
"label.exchange.sync.state.contact.m2":`在最后 60 分钟同步的记录：`,
"label.codeType":`码类型`,
"saturday":`星期六`,
"label.mask.type":`掩码类型`,
"label.schedulejob.setup.schedule.Monthly":`每月`,
"label.import.page2.totalfiled{{20}}，{{4}}notsuited":`文件中共{{20}}个字段，剩余{{20}}个未映射`,
"label.projectManagement.delete.item":`删除该项目，将删除项目和项目关联的所有信息，且数据无法恢复，是否确认删除`,
"label.page.general.us.and.western.europe":`通用美语和西欧语言`,
"label.reportsSubscription.status":`已订阅`,
"label.discount.baifenbi":`折扣（%）`,
"font-evaluate-module-v1-web-page-evaluation-settings":`网页评价设置`,
"message.error.searchwork":`搜索词不能少于两个字。`,
"label.weixin.option.setting":`选项设置（最多设置10个选项）`,
"label.lead.score.prompt1":`针对单个潜在客户系统可在新建，编辑潜在客户时自动打分，但针对批量导入或者通过接口创建的潜在客户需使用批量打分手工进行。`,
"label.exception.must.try.throw":`异常必须在语句块中抛出！`,
"label.activity.plan":`计划`,
"label.partnerCloud.productSet.editor":`编辑选项`,
"label.mobile.quickcreate.default.signinnew":`签到`,
"label.summaryreport.2018.step6.new":`步骤6：选择图表类型和报表突出显示`,
"vue_label_homepage_owner":`我的主页`,
"vue_label_dashboard_editfoldersuccessfully":`编辑文件夹成功`,
"label.quickbooks.view.overdueinvoices":`逾期的Invoices`,
"label.emailtocloudcc.redmessage4":`请输入端口信息`,
"label.tabpage.equalz":`等于`,
"lable.quote.syncing.firstsync":`初步同步： 报价单同步至业务机会`,
"label.download.CloudCCAPP":`下载CloudCC App`,
"label.icon.6":`货币`,
"label.list.serial.number":`序列号`,
"label.profile.setstandardobjectrecordtype":`标准对象记录类型设置`,
"label.customize.memory.function.sorting.error":`查询时间过长导致页面超时，可能是由于您启用了视图表头排序记忆功能，请前往个人设置并禁用该功能重试。`,
"message.view.addtoallusers":`相关人员可见`,
"label.globaloperation.operationtype.record.phone":`记录电话`,
"lable.opppdt.selPdt.searchresult":`查询结果`,
"label.import":`导  入`,
"label.service.gantt.work.based.resources":`基于工时的资源`,
"label_partner_template_detailimage":`详图`,
"label.cpq.product.feature.option.count":`产品选项最小数量不能大于产品选项最大数量`,
"label.chatter.newtask":`新建任务`,
"font-trade-module-v1-invoice-total-price":`计划回款总金额`,
"setup_mainpage_label_welcome29":`标准的API 与第三方产品集成`,
"label.data.exportall.all.btn":`导出全部数据`,
"front-epwechat-module-v1-unbound-WeChat":`解绑企业微信`,
"label.salescloud.salesdashboard.performance.rankings":`整体-销售合同业绩排行榜`,
"label.import.page1.newcreateandupdate":`更新并新建`,
"component.chatter.post.button.file":`添加附件`,
"label.partnerCloud.orderingPlatform.createOrder":`创建订单`,
"label.lookup.multiple.data":`检索到的数据有多条，请手动选择`,
"button.partner.save":`保存`,
"label.service.add.timeslot":`添加时隙`,
"label.campaign.matchway.select.email":`电子邮箱`,
"front-sales-button-fromQB":`从QuickBooks更新`,
"label.icon.108":`箭头`,
"lable.outlook.edit.efmapping":`编辑字段映射`,
"label_tabpage_refreshz":`刷新`,
"chatter.follow.cancel":`取消追随`,
"label.totals.sum":`统计总数`,
"label.noRequest":`无要求`,
"vue_label_homepage_fixedcomponent":`请选择标准组件`,
"label.knowledge.delete.case":`删除个案文章出错`,
"label.weixin..xsld.yjwc":`预期收入`,
"label.customcomponent.page.index.console.btn":`开发者控制台`,
"label.sendsms.batch":`批量发送短信`,
"vue_label_chat_onlychosechat":`只能选择使用群策的用户聊天`,
"label.tabpage.page":`页`,
"label.cyen.note":`币种启用。请注意，启用币种之后将不可逆。`,
"label.weixin.againsend":`重新发送`,
"label.processnumber":`步骤号`,
"label.emailobject.to":`收件人：`,
"label.event.today":`今天的事件`,
"label.dashboard.dispalyPosition":`显示位置`,
"message.error.recalculate.dupoperate":`重计算正在进行中，请勿频繁操作！`,
"vue_label_email_linkrecordsuccess":`关联记录成功`,
"label.updateoutboundnews":`更新出站消息`,
"label_emailtocloudcc_exists2":`此邮箱已经设置为Email to Case，请勿重复设置`,
"label.tag.addtags.button2":`取消`,
"label.stdashbord.xsld.business.role":`该角色取自预测层次结构中已启用用户的角色`,
"label.commonnew":`普通新建`,
"label.validate.remark2":`使用示例：`,
"label.reportsSubscriptionPage.condition.checkbox":`在此报表上添加条件`,
"label.globalselect":`全局选项列表值集`,
"label.partnerCloud.partnerAccount.available":`可用额度`,
"label_tabpage_nothingz":`无`,
"label.version.webtolead":`We to Lead`,
"label.projectManagement.heat.map":`热图`,
"message.error.pleasecorrectdata":`请审查下列所有错误消息以纠正数据。`,
"label.hight.tip":`不启用高级筛选时，不同筛选，各个条件之间是“与”，也就是满足1与2共同的特征的记录`,
"label.workflow.estimatecondition3":`每次创建或编辑记录时`,
"AssetRelationship.time.limit.error":`起始日期应小于等于截止日期`,
"label.multilang.workflow.dayinmonth":`每隔{0}个月的第{1}个`,
"label.reportsSubscriptionPage.schedulereport.daily":`每天`,
"label.emailtocloudcc.step1.name":`选择功能`,
"label.follow_up":`跟进邮件`,
"label.price.list.price.cannot.be.empty":`价目表价格不可为空`,
"label.chatter.link":`链接`,
"label.ccpeak.condition.return.record":`按条件返回记录，支持常用的where条件。`,
"pagecreator.layout.message.canntdelete":`当前布局不允许删除`,
"label.compact.layout.main":`主要关键信息布局`,
"label.testandupdate":`检查更新`,
"button_partner_cancel":`取消`,
"label.activity":`活动`,
"label.knowledge.setting.hint.fourteen":`您已准备进行撰写！`,
"vue_label_commonobjects_view_open_from_list":`从列表中打开,以开始使用`,
"front-electronic-export-intro":`导出至Mailchimp功能支持单次导出2000条记录`,
"label.chosen.all":`全部字段`,
"label.file.extension":`文件扩展名`,
"vue_label_systemSettings_server_miniprogram":`服务小程序`,
"label.weixin.no.pending.wdgz.qin.today":`亲，今天没有工作安排`,
"label_tabpage_issuez":`问题`,
"label.staticresource.tip":`使用静态资源上载您想在自定义页面中引用的内容，包括.zip、图像、样式表、JavaScript程序和其他文件。`,
"label.approvalstep":`批准步骤`,
"label.china.standard.time":`中国标准时间`,
"label.appexchange.download.tiaoguo":`跳过`,
"label.callcenter.link.Amazon.connect":`Amazon Connect连接`,
"vue.dashboard.notRequired.notConformToTheRules":`有必填项未填写或不符合规则，不可提交！`,
"label.appointment.wizard.title1":`请设置您的空余时间`,
"label.chat.remove.bookmark":`取消收藏`,
"label.tabpage.advancedsearch":`高级搜索`,
"batch.ranf.f":`批量转移操作失败！`,
"label.appointment.wizard.subtitle4-1-4":`1小时`,
"label.brief.account":`客户`,
"component.chatter.link.label.url":`链接URL`,
"label_emailtocloudcc_redmessage8":`参数错误，请联系管理员`,
"label.object.create.two.number.field":`每个对象最多可以建两个自定义自动编号字段`,
"label.salecommit.not.roleinformation":`您没有角色信息，不能查看销售承诺看板。`,
"label.defautline.cannot.less":`默认行数不能少于1行`,
"label.selectedproducts":`已选产品数`,
"label.productsales.today.notskadd":`今天没有到期的任务，您也可以点击右上角的“ ”添加任务！`,
"lable.account.year.stadate":`会计年度开始日期`,
"label.mobile.phone.month.plan2":`本月计划`,
"label.ccpeakfolder":`类文件夹`,
"setup_mainpage_label_welcome21":`CloudCC 云平台提供用户自定义邮件模板功能。方便用户统一使用，提高工作效率。`,
"label.modify.layout":`编辑布局`,
"report.label.folder":`文件夹`,
"label.tianyancha.businessverify.rewritename":`回填客户名`,
"lable.currencyAdv.dao":`到`,
"label.mobilelayout":`移动端布局`,
"label.the.current.model.is.enabled.and.cannot.be.edited.":`当前模型已启用，不可编辑。`,
"label_partner_all_disable":`禁用`,
"label.ownerapproverfield":`所有人 的批准人字段`,
"label.emailobject.template.message4":`当前邮件正文中插入的字段存在空值，建议编辑后重新发送！`,
"label.productsales.today.notsk":`今天没有到期的任务！`,
"label.multilang.document.upload.success":`成功上传了{0}个文件,失败了{1}个文件`,
"label.manageAll.sta3":`审批拒绝`,
"vue_label_calendar_week_view":`日历-星期视图`,
"setup_layout_label_nocustompage":`暂无自定义页面`,
"label.weixin.wdyj.jxdcl":`个人-绩效达成率`,
"label.donot.update":`您没有更改权限！`,
"setup.mainpage.label.welcome14":`工作流定制、批准过程管理`,
"UG_Campaign_002":`规划、执行并监控市场活动的效果。`,
"label.layout2":`布局二`,
"label.app.looup":`查找应用程序`,
"label.projectManagement.selectitem":`请选择项目`,
"label.field.relating.rule":`查找字段关联规则`,
"vue_label_commonobjects_detail_selectname":`请先选择名称`,
"front-email-payment-Invoice-select-pay":`选择付款方式：`,
"label.customfields.formula.numberexample":`Fahrenheit（华氏度）= 1.8 * Celsius__c   32`,
"component_event_label_enddate":`*结束时间`,
"label.partnerCloud.partnerAccount.lineOfCredit":`信用额度`,
"label.chatter.newpost":`最新帖子`,
"label.report_dashboard":`本报表将存于您的所有报表中。您可以添加该报表至仪表板。`,
"label.assigned":`被分配人`,
"Homepage_News_002":`当前新闻组件服务不可用`,
"label.approval.select.relatedobj":`选择相关项必须选择一个类型`,
"label.service.miniProgram.isTop":`是否置顶`,
"message.error.object.datatoolang":`数据长度太长，最长{!length}个字符。`,
"label.importsourcetip":`导入用于将导出的文件修改后，再导入到系统中。如果还未导出，请转到导出页面导出。`,
"label.select.deadlineplease.deadline":`请选择截止时间`,
"vue_label_account_equityrelationship":`股权关系`,
"label.account.Calendar.month":`日历月度`,
"label.appointment.wizard.subtitle3-4":`周四`,
"font-evaluate-module-v1-smaller-500":`文件应小于500KB`,
"label.reportsSubscriptionPage.email.tome":`只发送给我`,
"label.ccchat.person.invite.existpers":`已经在追踪：`,
"label.appointment.wizard.subtitle1-3":`30分钟`,
"front-kefu-moudle-connected":`已连接`,
"label.campaignmember.main.duplicatelist.tip":`系统将根据此处的设置，启用进行潜在客户和市场活动成员除重。`,
"label.visualpage.such.tags.double":`等标签一定成对出现`,
"label.sendsms.batch.step2.introduce":`按短信模板发送：请选择要使用的短信模板。`,
"Account_News_Setting_002":`使用下面的客户设置为贵组织指定默认的客户行为`,
"message.encryptchange.alert":`您即将把{{!fieldapi}}从加密字段(存储加密)"转换成"加密文本(显示加密)"，转换成功后，此字段将以明文形式存储在数据库中，显示时根据简档设置可为明文显示或加密显示，字段可搜索。\\r此操作不可逆转，请确认是否继续进行?`,
"label.mainpageset.description":`根据实际使用场景配置组织级主页<br>你可将与企业业务无关的组件从默认配置中禁用或关闭。<br>启用：启用的模块显示在所有成员的主页中。<br>禁用：禁用的模块不显示在所有成员的主页中，也不支持显示在移动端“配置我的主页”列表中。<br>关闭：默认不显示在组织内所有成员的主页中，用户可以通过移动端“配置我的主页”来开启模块。`,
"label_tabpage_linknamez":`链接名称`,
"label.companyname":`北京神州云动科技有限公司`,
"label.currency.current":`当前公司币种`,
"label.campaignmember.main.duplicatelist.html.title":`扫码除重设置`,
"label.sendsms.batch.step3.plan":`交付日期计划`,
"label.profile":`简档`,
"label.canceluploadfile.step":`单击“取消上传”按钮，则取消上方区域显示的所有文件`,
"message.newreport":`新建报表`,
"label.service.newBuildDialog.date.selection":`日期选择`,
"label.lookup":`查找`,
"label.file.editinfo":`编辑文件详细信息`,
"component_assistant_label_nodata":`今天无事项，请稍后检查。`,
"label.tianyancha.businessverify.msg4":`本功能使用第三方数据查询接口提供的服务，目前免费使用，但 CloudCC不确保后续第三方是否继续免费。如果第三方收费，则 CloudCC 有权向用户收费或者用户停止使用此功能。`,
"label.noequal":`!=不等于`,
"vue_label_metric_column":`表必须拥有至少 1 个评测列。`,
"label_reportType_chose_and_form":`选择报表数据源及报表格式`,
"vue_label_pool_reasondescription":`{0}原因描述`,
"label.isusing":`是否启用`,
"label.passwordPolicy.setup.pwdremember5":`记住5个密码`,
"label.cancel":`取消`,
"vue_label_helpcenter_detail1.1":`在lightning版本的数据详情页中，可以查看单条记录的基本信息、相关的活动、动态，在模块右上角展开或收起对应信息。还可以通过相关列表查看、管理与该记录相关联的数据。<br>1、查看、管理单条数据<br>通过右上角按钮，可以对数据进行编辑、复制、删除，或是为其他人员共享数据的权限。<br>查看用户的详细信息，且可以在页面上直接对部分字段进行编辑，更改数据的所有人或记录类型。<br>通过相关列表，查看、管理与该记录相关联的数据。在文件相关列表中，上传记录的文件，或是通过点击文件名称来下载查看对应文件。<br>2、相关列表<br>通过相关列表快速连接，使用浮窗查看最多10条相关记录。点击后进入列表视图，查看全部相关记录，还可进行内联编辑。<br>在下方使用卡片式查看与管理相关记录。<br>3、活动<br>    在记录的详情页面，Lightning版本不显示“未处理活动”或“活动历史记录”这两个相关列表。而显示活动时间线。<br>活动时间线显示内容<br>    活动时间线可以显示当前记录下从未来到过去的所有活动。已逾期的任务和即将到来的任务、事件在活动时间线“已逾期和即将到来”模块中展示。过去或现在的已结束的任务、事件、记录电话、电子邮件、短信会在对应的月份展示。<br>`,
"registration.page.preview":`注册页面预览`,
"label.quickbooks.search":`搜索`,
"label.setup.mobile.bottombutton.tab.show":`底部Tab显示
`,
"lable.want.to.delete.tem":`确定删除{currentTelmplateName}服务报告模板吗`,
"label.multilang.fielddtrack.dealkey":`将{0}从{1}更改至{2}`,
"vue_label_pool_return":`退回`,
"vue_label_calendar_failed_to_share_calendar":`共享日历失败`,
"label.less":`<小于`,
"label.email.form.html":`HTML`,
"label.tag.nodata":`无标签数据`,
"label.setarticlecon":`指定项目条件`,
"label.searchlayout.displayrow":`显示的列`,
"label.change.task":`切换到任务视图`,
"lable.quote.editqtpdt.title":`编辑报价单明细`,
"label.appointment.wizard.subtitle4-4":`最长可以提前预约的时间`,
"label.custom.page.button.css":`按钮CSS`,
"label.input.documentmessage":`输入详细信息`,
"vue_label_commonobjects_detail_email_address":`收件人地址`,
"label.chatter.filterTimeLine":`筛选时间线`,
"label.must.select.twoorthree.records":`必须选择两个或三个要合并的记录`,
"label.mobile.setup":`手机端设置`,
"vue_label_commonobjects_detail_key_field":`关键字段`,
"label.chatter.relateitem":`相关项`,
"label.customobjects.tip":`一旦创建自定义对象，便可以创建自定义菜单、自定义相关列表、报表和仪表板，以便用户对自定义对象数据进行交互操作。 您也可以通过 CloudCC.com API 访问自定义对象数据。`,
"label.sso.saml.idp.config":`身份提供商设置`,
"label.knowledgebase.affect.article.version":`更改是否会影响本文章的现有翻译？如果这样，您可以将之前的翻译标记为“过期”。这样，您可以生成需要翻译供应商更新的文章列表。`,
"message.error.record":`未找到相应的记录！`,
"message.duplication.label.fieldname":`目标字段`,
"setup.layout.button.cancel":`取消`,
"label_radar_map_function":`利用雷达图与多个指标，衡量联系人在销售决策链中的作用`,
"label.campagin.roi.fss":`发送数`,
"label.emailobject.template.giveup":`放弃`,
"label.apiname.exists":`Api名称已经存在`,
"message.failtoreaddata":`读取数据失败`,
"label.file.versionedit":`内容修改者`,
"template.report.lost.business.opportunity":`丢单的业务机会`,
"label.ccchat.group.allowgd":`允许小组归档`,
"label.fieldaccesslimit":`字段可访问性`,
"label_target_model":`目标模型`,
"message.validation.isnoturl":`输入正确的URL`,
"servicecrew.member.time.conflict":`在此时间范围内，服务资源已成为其他服务班组成员`,
"label.knowledgebase.delete.details":`将删除任何分配详细信息。`,
"vue_label_normal_bottom":`置底`,
"label.custombutton.editerror":`编辑失败`,
"label.dashboardSetup.showdw.d6":`自动`,
"message.error.field.decimalPlaces":`小数位数输入格式有误`,
"label.tabpage.busoppnamez":`业务机会名`,
"label.insertfield.intro":`请选择一个字段，然后点击“插入”。后跟“>”的标签表示还有更多的可用字段。`,
"setup.layout.label.nocustompage":`暂无自定义页面`,
"front-gantt-module-project-has-only":`此项目仅有{n}个里程碑`,
"label.weixin.fmu.am":`上午{0}`,
"label.emailsync.status.connectaccounts":`关联邮箱账号`,
"label.customcomponent.check.name.same":`名称已存在`,
"label.validate.function.funcFormat.HOUR":`HOUR(date)`,
"label.approvepagelayout4":`复制上一行布局`,
"label.knowledge.category.hint.nine":`启用分类组`,
"label.report.sorting.column":`排序列`,
"label.hours":`时`,
"label.email.clearAllemail":`是否清空所有该邮箱同步的邮件`,
"font-evaluate-module-v1-satisfaction":`满意评价`,
"label.service.hide.more.info":`隐藏更多信息`,
"label.area.list.intro":`在这里您可以操作区域信息`,
"label.sendemail.chat.addPostat":`尊敬的#name:\n\n    您好！#userName发的微贴中提及了您。`,
"label.data.newtemplate.e_seltype.desc":`数据导出方式有两种：</li><li class="titledesc1">1.CSV格式（默认）</li><li class="titledesc1">2.压缩格式。导出方式的压缩格式分为两种：</li><li class="titledesc1">2.1.自动生成压缩文件密码，自动生成的密码将在数据导出成功后发送到用户邮箱</li><li class="titledesc1">2.2.手动输入压缩文件密码 ，手动输入的密码不会发送到用户邮箱，所以需要用户牢记自己输入的密码，若不输入，则默认没有密码`,
"message.passwordPolicy.validate.minlengths":`错误：密码长度不得少于`,
"message.save":`确定要保存吗？`,
"label.marketsea.notfollowdays1":`获取后`,
"label.app.step1":`步骤 1. 选择类型`,
"message.error.pageid.null":`Facebook社交媒体ID不能为空！`,
"label.weixin.input.lookupfield":`输入关键字查找匹配的微投票`,
"label.whChatAccount":`微信账号`,
"label.tabpage.groupingitem":`分组项目`,
"label.callboard.introduce":`以下列出了您公司的所有公告。`,
"label.financial.services.seminar":`金融理财研讨会`,
"label.data.file.i_title.num1":`1.导入的文件必须是CSV格式的文件，CSV文件必须包含标题，没有标题不能导入。`,
"label.visualpage.filename.exist":`文件名称已经存在`,
"front-kefu-moudle-v1-new-chats":`新建坐席`,
"label.console.step5.tab":`打开菜单`,
"vue_label_opportunity_contactrole_edit":`管理联系人角色`,
"label.projectManagement.delete.return":`已经是最后一条数据，删除后将返回上一页`,
"registration.page.designs":`注册页面外观设置`,
"label.console.step6.heigth":`高度`,
"label.objectRelationshipAtLeast":`具有至少一个相关记录`,
"label.knowledge.delete.viewstat":`删除知识文章浏览数据出错`,
"label.direct.dashboard.month.report":`新建工作月报`,
"label_tabpage_lookatmorez":`查看更多`,
"label.setup.rights.management":`权利管理`,
"label.campaign.channel.clear.img":`清除图片`,
"label.calendar":`日历`,
"label.biaoqingfaxian.username":`账号`,
"label.weixin.wdyj.jxht":`个人-销售绩效-合同`,
"label.emailtocloudcc.exists1":`此邮箱已经设置为Email to Lead，请勿重复设置`,
"label.emailtocloudcc.filed.password":`邮箱密码`,
"label.what_create":`您想要创建哪种表单？`,
"vue_label_report_onlydisplaypart":`最多显示50条数据，运行后显示全部数据`,
"label.up":`向上`,
"label.addattachment.edit":`编辑附件`,
"label.ccchat.message.search.desc5":`搜索词不能少于2个字符`,
"label.chose.nonotice":`请先选择不再提醒的记录`,
"UG_activity_06":`想跟进客户`,
"label.set_contactsmarketing":`设为市场联系人`,
"pagecreator.layout.button.horizontal":`横向拆分`,
"label.brief.opportunity2":`预计关闭机会`,
"label.ems.nomsg":`未设置`,
"label.fieldupdate.tip":`字段更新允许您将某个字段值自动更改为指定值。 字段更新是与工作流规则和批准过程相关的操作。`,
"label.sso.saml.sp.federationid":`联盟ID`,
"label.import.page2.suited":`已映射`,
"message.error.appexchange.integrity":`请确保上传软件包中组件的完整性！`,
"label.fielddatatype":`字段数据类型`,
"message.approval.cannotsubmit.detail2":`当前记录必须满足下面项目条件之一或者经公式评估为真，否则无法提交待审批，请修改后重新提交即可。`,
"vue_label_commonobjects_detail_cloud_as_a_user":`以用户身份登陆伙伴云`,
"label.summaryreport.selectlinetogroup":`选择报表分组所依据的列`,
"label.tabpage.norecordtypez":`不可用记录类型`,
"label.icon.141":`货币`,
"label.addattachment.step3.intruduce":`如果正在上传，这将取消正在进行的上传`,
"label.trigger.recursive.call.three":`触发器可以循环调用，循环次数限制为三次，如果超过三次系统将会出现错误提示！`,
"maintenanceplan.workorder.type.asset.workorder":`工作订单生成方式请选择“每个资产产生一个工作订单”`,
"label.emailtocloudcc.select1":`请选择`,
"label.system.log":`系统配置审计日志`,
"vue_homepage_dashboard_not_support_fullscreen":`抱歉，您的浏览器不支持使用全屏`,
"label.projectManagement.nodata.resource":`还没参与到任何项目中。在成员中添加‘我‘的项目信息，即可查看团队成员的时间分配了`,
"label.exchange.sync.state.contact":`联系人`,
"label.field.type":`字段类型`,
"label.selected.object":`已选对象`,
"label.customfields.new.step2":`步骤2.输入详细信息`,
"label.monitorsys.delete.style":`操作类型`,
"label.projectcondition":`项目条件`,
"potential.customers.field.default":`潜在客户字段默认值设置`,
"message.password.nosame":`两次输入的密码不一致，重新输入！`,
"label.validate.function.funcExplain.MONTH":`返回月份，是1(一月)与12(十二月)之间的一个数字`,
"label.project.user.project.count":`用户参与项目数量`,
"chatter.to":`更改至`,
"vue_label_commonobjects_detail_activity_owntask":`拥有任务`,
"label.generate.mobile.page":`已完成生成移动端页面`,
"label.escalation.setup.newentries.step1":`步骤1：设置处理此规则条目的顺序`,
"label.email_footer":`邮件页脚`,
"label_partner_workspace_member_profile":`可选简档`,
"label.loginhis.between":`开始时间距离结束时间不能超过2个月`,
"label.user.verficationcode.error":`验证码不正确`,
"label.email_notifications":`发送提交电子邮件通知`,
"APPIntegration_Dropbox_01":`从Dropbox中选择文件`,
"label.projectManagement.Selectweek":`选择周`,
"wednesday":`星期三`,
"message.atleastonereceiver":`至少要有一个接收人`,
"label.applt.link.text":`我们已经将贵公司和门户小程序绑定，复制专属于贵公司的小程序门户网站地址，将地址放置到公司公众号菜单的小程序路径的跳转链接中，客户可以点击公众号菜单使用小程序。（公众号自定义菜单<跳转小程序<小程序路径）`,
"label.wait.for.a.moment":`设置中，请稍等……`,
"vue_label_chatter_only_group_members_look":`只有小组成员才有权限查看，您可以尝试申请加入小组`,
"label.knowledgebase.last.release":`上次发布`,
"component.setup.label.pagesize":`每页显示条数`,
"label.paging.totalofpages":`共{0}页`,
"label.globaloperation.successmessage":`成功消息`,
"label.logout":`退出`,
"label.partner.common.enable":`启用伙伴云`,
"label.permission.objectpermission.goback":`返回权限集对象列表`,
"label.approvalstep5.required":`必填`,
"component_chatter_label_to":`到`,
"message.please.choose.role":`请选择角色`,
"maintenanceasset.servicecontract.contractlineitem.illegal":`您必须选择与维护计划关联的服务合同下的合同行项目。`,
"label.projectManagement.Resource.usage.view":`资源使用视图`,
"label.smsmainbody":`短信正文`,
"label.ccchat.error.nullname":`名称不能为空`,
"label.appupload.upload.version":`版本号`,
"label.data.setok.t_desc2":`返回到数据模板页面`,
"vue_label_pool_allocationstatus":`分配状态`,
"label.tianyancha.orgapprovedinstitute":`核准机构`,
"label.quickbooks.searchlist.startdate":`开始日期`,
"label.setapp":`应用程序设置`,
"chatter.about":`关于我`,
"label.layoutname":`页面布局名称`,
"label.icon.160":`地球`,
"label.tabpage.Rolesz":`角色和下属`,
"label.console.step5.introduce":`选择以下如何显示`,
"label.customfields.totalsummary.gettogetherfield":`要聚合的字段`,
"message.appexchange.addtopackage.profile":`一个软件包中最多只允许添加一个简档组件!`,
"vue_label_file_user_header_pic":`头像`,
"font-trade-module-v1-invoice-detail-price":`回款明细金额`,
"homepage.components.three":`步骤3：填写自定义组件显示内容`,
"nine":`九`,
"label.marketsea.button.restore":`恢复`,
"label.forecast.editshrepage.desc2":`个别共享只能用于授予对数据更广的访问权限，而不用于限制访问权限`,
"label.cloudccsite.list":`站点`,
"label.icon.35":`云`,
"vue_label_pricebook_price":`添加标准价格`,
"label.version.sum.addressfield":`个地址字段`,
"label.projectManagement.Gotomilestone":`转到里程碑`,
"label.dataimport.name.length":`出现错误：name长度过长。`,
"label_alculation_method":`计算方式`,
"label.uploadfile":`上传文件`,
"label.ems.otheraccount":`其他账号`,
"vue_label_commonobjects_detail_group_opportunitystrategy":`确定加入该机会群策吗`,
"message.error.chatter.img.nodata":`图像文件不存在，无法进行头像截取！`,
"component.chatter.file.button.files":`选择文件`,
"label.salescloud.teamrole.optionlist.choose.null":`角色名称不能为空`,
"label.yourexportsuc":`已处理您的导出请求，请查看您的电子邮件。`,
"pagecreator_systemstyle_label_modifycolor":`编辑颜色`,
"label_partner_setup_title":`设置`,
"label.chat.topic.topic":`主题`,
"file.error.nottype":`错误：无效的类型，可以上载的文件类型是txt、doc、excel、ppt、pdf、jpg、jpeg!`,
"label.all_time":`全部时间`,
"homepage_componet_approval_label":`审批中心`,
"label.partnerCloud.financeSetting.merchantNumber":`微信支付商户号`,
"label.user.resetpw":`重置密码`,
"label.exchange.sync1":`在 Microsoft© Exchange 中为用户设置带有模拟权限的服务帐户后，输入服务帐户凭据，以允许 CloudCC 与 Exchange 服务器通讯。`,
"label.import.index.editfield":`编辑字段映射`,
"and":`与`,
"label.partnerCloud.cloudInfrastructure":`伙伴云基础设置`,
"label.escalation.setup.newentries.createdate":`根据创建个案的时间`,
"Pagelayout.Setup.002":`您已经选择了3个相关列表，再次选择的话将影响页面布局`,
"label.customfields.file.tip":`允许用户上传1-N个文件`,
"label.tianyancha.businessverify.accname":`客户名称实时查询`,
"label.Additional.Conditions":`按照附加条件筛选服务预约`,
"label.emailtocloudcc.filed.type":`类型`,
"vue_label_homepage_fixedcomponents":`标准组件`,
"label.visualpage.delerror":`删除失败，请稍后再试`,
"label.tabpage.filetypez":`文件类型`,
"label.emailobject.search.input":`请输入搜索内容`,
"label.createprocessstep2":`步骤 2 指定项目条件`,
"label.weixin.inhead":`处理中`,
"component.recdetail.label.title":`详细信息`,
"label.weixin.telephone":`手机号`,
"label.web.link":`网页链接`,
"label.partnerCloud.paySuccess":`支付成功`,
"label.case.adress.link":`网页客户服务门户地址`,
"label.emailobject.view.connectopp":`关联未关闭业务机会`,
"front-kefu-moudle-think-again":`我再想想`,
"label.Button":`按钮`,
"chatter.pt.most":`最大文件大小为20M。`,
"label.service.newBuildDialog.numberdays.horizontal":`水平日期之前的天数`,
"label.ems.relatedobj":`关联记录`,
"label.notification.insert.approval":`【提交人】提交【对象】待您审批`,
"label.setting.codeSet":`代码集`,
"vue_label_report_rowlevelformula":`行级公式`,
"label.validate.function.funcFormat.TIMENOW":`TIMENOW()`,
"label.copyright":`© 2008-2023 CloudCC Inc.公司版权所有。保留所有权利。客户服务热线：400-642-2008`,
"component.setup.button.save":`保存`,
"label.emailsync.button.sure":`确认`,
"label.multilang.dupicatecheck.getdatalist":`第{0}组重复数据，共有{1}条记录`,
"label.ccchat.person.invite.tochat":`邀请人员到同事圈`,
"label_partner_all_maxNum":`伙伴云的最大数据：`,
"label.checkfield":`查重字段设置`,
"label.sales.dashboard.income":`收入目标`,
"label.setup":`设置`,
"label.dashboardSetup.center":`中`,
"lable.quote.syncing.finished":`已完成同步。`,
"vue_label_helpcenter_dashboard1":`为了帮助您更加直观地显示统计数据，CloudCC销售云Lightning仪表板为您提供了强大的图表制作能力。<br>    CloudCC销售云Lightning版本仪表板具有以下几个特点<br>•能够使用不同的数据源：既可以选择对象下某个视图内原始数据作为数据源，也可以选择报表处理过后的数据作为数据源<br>•多达13种图表模版供你选择：支持销售漏斗、指针仪表、饼图、二级分组柱状图等<br>•自由拖拽更改图表大小和位置：仪表板可以通过摆放不同图表的位置和大小来区分重要数据和辅助数据，这些完全由您决定<br>•仪表板全局筛选：仪表板支持通过时间范围和用户来筛选设置了筛选字段的内置图表数据<br>•数据缓存：仪表板图表数据在首次创建时即可缓存数据，减少二次加载时间。<br>•组件穿透：可以通过点击组件跳转到对应的报表详情或对象相应视图内记录列表<br>•组件联动：同一仪表板内，组件可以设置和自己同一数据源的其他组件来和自己联动，通过点击组件内数据区，能够让设置的其他组件根据这个数据区的筛选条件来重新统计数据<br>1、新建仪表板<br>    作为销售代表或者销售部门的管理人员，可通过制作仪表板来展示您的销售数据，CloudCC销售云Lightning版本提供了丰富的能力来制作仪表板<br>    注意：Lightning版本的仪表板和老版本的仪表板的数据不互通。<br>    点击“仪表板”选项卡，点击“新建仪表板”，填写仪表板名称并选择您希望将此仪表板保存到哪个文件夹。即可进入一个新的仪表板。<br>    `,
"label.layout.availabletab.trackrecord":`跟踪记录`,
"label.campaignmember.main.deletecontact":`删除成员-现有联系人`,
"lable.outlook.mcto.emaltoc":`当电子邮件发送到CloudCC.com时`,
"label.setup.mobile.offlinecache.savesuccess":`移动端离线缓存设置保存成功`,
"label.timezone.default":`默认时区`,
"label.noRules.have.been.enabled":`还没有已启用规则`,
"label.ccchat.person.invite.existsend":`您输入的部分电子邮件地址匹配现有用户。`,
"label.work":`工作`,
"actualstarttime.actualendtime.time.illegal":`服务预约的实际开始时间应小于等于实际结束时间。`,
"lable.product.stsp":`设置标准价格`,
"vue_label_normal_account_sf":`客户`,
"label.finishpic":`已生成的图表`,
"label.h5.similar.opportunity.step3":`步骤3.选择为类似业务机会显示的字段`,
"label.relateobjDefault":`默认相关记录`,
"label.customcomponent.check.tag.endwith":`组件必须以&lt;/cc:component&gt;标签结尾`,
"label.related.organization":`相关机会`,
"label.recordtype.edit.selectvalue.orderby":`选项列表值排序`,
"vue_label_homepage_enter_name":`请输入名称`,
"label.permission.group":`权限组`,
"label.emailobject.send":`发送`,
"label.ralateuser":`相关用户`,
"label.validate.function.funcFormat.ADDMONTHS":`ADDMONTHS(date,num)`,
"label.tablayoutedit.remark2":`选择要在前台菜单页面显示的字段`,
"setup_mainpage_label_welcome3":`CloudCC 云平台中建立表单依靠自定制数据库（对象）来实现，用户定义对象是一些数据库表格，用于存储贵组织特有的数据。无需任何程序开发的情况下，还可轻松建立表与表间的关系。`,
"label.user.notallowed.login.scope":`您不在允许登录时间范围内或您的登录IP受到限制。`,
"label.tel.ten.case":`您最多可输入10个要发送通知的手机号码，每个手机号码之间用`,
"front-kefu-moudle-v1-user-info":`用户信息`,
"label.aboutme":`关于我`,
"label.setfieldediting.tip":`定义批准步骤时，可以向不同的用户分配批准请求。其中一个选项是为了使用用户字段自动传送这些请求。如果要将此选项用于任何批准步骤，请从下面的选项列表中选择一个字段。而且，当记录在批准过程中时，它总是锁定的-- 只有管理员可以对其进行编辑。但是，您也可以选择允许当前分配的批准人来编辑该记录。`,
"label.existing_dashboard":`添加到已有仪表板`,
"label.sendemail.spotsign":`尊敬的#name:您所邀约的#activity活动的客人#customer已经成功签到来现场,请知晓。`,
"UG_solution_01":`提供解决方案`,
"label.tianyancha.estiblishtime":`成立时间`,
"label.pc.lightningpage":`轻量级应用(Beta)`,
"label.saveAndSync":`保存并同步`,
"label.state.end":`已结束`,
"label.sendemail.queue.assigninfo":`队列：[#queueName] 分配了 #objectName ：#recordName`,
"label.approvalprocessname":`批准过程名称`,
"label.view.conditions.message":`按{!conditions}筛选`,
"label.partnerCloud.financeSetting.alipayCorporate":`支付宝企业账户`,
"label.forecast.detailforecast.de":`的`,
"label.savepayset.failure.nopay":`请先配置至少一个线上支付账户`,
"label.step1.total6":`第1步，共6步`,
"label.appointment.wizard.subtitle4-1-3":`45分钟`,
"label.emailobject.markasread":`已读`,
"message.error.orgid.null":`orgid不能为空！`,
"label.emailtemplate.mergefield":`合并字段值`,
"label.weixin.recent.list":`最近查看列表`,
"label.emailsync.form.email":`邮箱`,
"label.funnel":`漏斗`,
"label.logintime.clear":`清除时间`,
"label.chatter.followed":`已关注`,
"label.ccpeak.function.field.spack":`函数中的字段两边必须有空格`,
"label.setup.mobile.offlinecache.remark":`启用该功能后，组织内的成员可以在移动端无网络状态新建、查看、编辑、删除记录`,
"label.product.function":`套餐类目`,
"label.icon.14":`锤子`,
"message.report.nodata":`报表未返回数据`,
"label.please.ChooseMin":`请最少选择{0}个产品选项。`,
"label.tabpage.releaseTourz":`发布导览`,
"vue_label_chat_opportunity":`机会群策`,
"vue_label_chatter_refucecertification":`确定拒绝"{name}"成为小组成员吗`,
"label.version.unlimited":`不限`,
"label.processsetting.enable.prompt":`启用后，设置的路径会在lightning版本对应的详情页中。也可先保存设置，稍后再启用。`,
"label.page.display.property":`显示属性`,
"label.service.appointmentList.thisOption":`未勾选`,
"label.register.date":`注册日期`,
"label.brief.contract.amount":`合同金额`,
"setup.object.field.dependency.label.actionfieldnotnull":`请先选择一个控制字段的值进行设置`,
"UG_homepage_009":`访问CRM`,
"label.icon.98":`文件夹`,
"label.weixin.datacount":`数据合计`,
"label.mobile.hasbind":`手机号已被使用，绑定后将自动解除上一次绑定`,
"label.emailtemplate.choosemorecontacts":`请选择您要发送给的更多人`,
"setup_layout_button_deleteitem":`移除选中项`,
"vue_label_account_collection_plan":`未处理的收款计划`,
"label_chatter_maturiyDate":`到期日期`,
"label.emailtocloudcc.license":`用户许可`,
"vue_label_checkduplicate_complete_check_rules":`请填写完整查重规则`,
"chatter.up.type":`您可以上载JPG、GIF或PNG文件。`,
"label.attendance.nocheckout":`未签退`,
"label.setup.mobile.offlinecache.remark2":`选取的菜单将作为默认离线缓存菜单在全组织人员的移动端启用，每个用户可以根据不同的场景需求在移动端设置关闭组织设置的菜单离线缓存，或切换启用其他需要的菜单`,
"template.report.count.marketing.activities":`市场活动总计`,
"label.multilingual.tip4":`禁用多语言将会根据公司地址把公司默认语言为中文或者英文，并且将所有用户的语言设置为公司默认语言`,
"label.settings_area":`设置区域`,
"label_assessment_content":`考核内容`,
"label.top":`顶部`,
"UG.Account.06":`创建一个客户`,
"label.emailtocloudcc.step1.case2":`配置后，该邮箱收到的邮件均可自动生成个案，并根据发件箱匹配联系人与客户，将个案挂在对应的客户与联系人之上，方便Case服务的受理与追踪。`,
"label.forecast.forehistory.best.remark":`超常发挥备注`,
"label.project.problem.date":`问题日期必须在所属里程碑或项目的日期范围内。`,
"label.forecast.customforecast.foredis.wzs":`完整数`,
"message.setup.field.name.value.notexists":`输入的小组角色列表值不存在，请重新输入！`,
"label.salescloud.teamrole.opportunity.organization":`小组成员对此业务机会的访问级别可能高于您组织默认的业务机会访问设置`,
"label.sms.message.input":`请输入短信内容`,
"label.document.type.not.allow":`该文档类型不支持！`,
"label.customfields.totalsummary.tip":`在相关列表中显示字段的汇总值、最小值或最大值的只读字段，或在相关列表中列出的所有记录的记录数。`,
"label.tabpage.filesizez":`文件大小`,
"label.import.page2.filedname":`文件名`,
"label.same.analyze":`我的撞单分析`,
"label.service.gantt.refreshData":`刷新页面后更新数据`,
"label.sendsms.batch.step2.sendbycontext":`按自定义短信内容发送`,
"UG_Account_05":`联系人架构图`,
"label_emailtocloudcc_step1total3":`第1步，共3步`,
"label.weixin.no.history":`暂无历史记录`,
"label.datamanage.queryfield.error":`查询字段出错`,
"label.emailmerge.mergeFolder.emailmerge":`邮件模板合并`,
"label.workflow.estimatecondition":`评估条件`,
"label.autonumberfield.wrong":`请输入0-{0}中的一个数字`,
"label.data.setok.t.desc1":`如果需要用此模板导出数据，请点击`,
"label.data.downpage.i.title":`导入数据的步骤:`,
"label.data.downpage.i_list.desc2":`导入数据后，您会收到一封邮件，提醒您是否导入成功。`,
"label.opportunity.jieduan":`当前阶段`,
"vue_label_commonobjects_view_sumby":`汇总方式`,
"label.knowledge.setting.hint.three":`我们将帮您准备并运行。以下是您需要完成的设置：`,
"page.activity.history":`活动历史`,
"label.cancelQuoteLineGroup":`取消报价行组`,
"label.addattachment.batch.step3":`步骤 3.单击“完成”按钮，返回上一页`,
"label.chat.topic.follow":`追随`,
"label.import.page1.uploadcsvfiled":`拖拽或点击上传CSV文件`,
"label.batchtransfer.datetype.tip":`对于日期字段，采用如下格式输入值：`,
"vue_label_systemSettings_application_util":`应用程序管理器`,
"label.partner.workspace.member.selectedpermission":`已选权限集`,
"label.service.appointmentList.plansToEnd":`计划结束`,
"label.industrialandcommercialverification.contactinformation":`购买或咨询请联系 400-642-2008`,
"chatter.del.p":`删除此帖子`,
"label.forecast.customforecast.replacefirst":`被我优先`,
"Lead.Scoring.Setting.Rule.Setup.RuleName":`打分规则名称`,
"label.weixin.appr.applicant":`发起人`,
"component_event_label_calendar":`查看日历`,
"step":`步骤`,
"label.attendance.setting.position.alert":`内勤必须设置地标`,
"label.end":`已结束`,
"label.mobile.change.owner.success":`已变更为新所有人`,
"label.chinese":`中文`,
"label.textmessage.vonage.account":`账户信息`,
"front-console-no-related-contact":`请先关联联系人`,
"label.dashboardSetup.seltype":`可选择的组件类型`,
"chatter.follow.user":`追随该用户`,
"label.textmessage.sentsuccess":`发送成功`,
"label.australian.gentral.standard.time":`中央夏令时（南澳大利亚）`,
"label.validate.function.funcFormat.AND":`AND(logical1,logical2,...)`,
"lable.SalesCommitmentKanBan.contract":`签约`,
"label.processsetting.basic.settings":`基本设置`,
"label.escalation.setup.newentries.ifcondtions":`如果满足以下条件，则运行此规则`,
"label.lookup.nofound.data":`值不存在,或与筛选条件不匹配。`,
"vue_label_commonobjects_view_chart_chartname":`图表名称`,
"label.dashboard.show.percent":`显示%`,
"label.sso.saml.sp.userid":`用户ID`,
"label_tabpage_minutesagoz":`分钟前`,
"vue_label_chatter_comment_content":`请输入评论内容`,
"label.campaign.channel.step6.mobilepc":`生成移动端加电脑端页面`,
"vue_label_homepage_editprofilepage":`编辑名称`,
"label.tabpage.crecordtypez":`更改记录类型`,
"label.social.posts.type.null":`帖子类型不能为空`,
"label.projectManagement.groupbyuser":`按用户分组`,
"vue_label_email_new_template":`另存为新模板`,
"label.ems.close":`取消`,
"label.ccdocument.noauthority.folder":`你没有操作该文件夹的权限！`,
"message.filterconditionerror":`<strong>错误：</strong> 您的筛选器引用了错误的筛选条件：`,
"label.User.Interface":`用户界面`,
"label_tabpage_greaterz":`大于`,
"vue_label_CCChat_unfollow":`取消关注`,
"label.selectandcontinue":`选择并继续`,
"vue_label_commonobjects_detail_influence":`影响力`,
"label.total.have.priority":`的优先`,
"label.manageAll.sta4":`调回`,
"label.setup.mobile.offlinecache.setup":`移动端离线缓存设置`,
"vue_label_chatter_cancel_adding":`取消添加`,
"vue_label_lead_select_existing":`选择现有`,
"front-epwechat-module-v1-contacts-sync":`企业微信联系人同步`,
"label.appupload.component.type.recordtype":`记录类型`,
"label.layout.hint":`暂不支持在当前页面查看效果，请在保存后，到前台页面查看`,
"label.change":`更改`,
"setup_layout_label_detailpage":`详细页面`,
"label.imgfield.use.tip":`img(docid,width,height),该函数是输出图片所用的，docid为文档id,width设置图片的宽度(Integer类型,可以为空)，height设置图片的高度(Integer类型,可以为空)。`,
"pagecreator.systemstyle.button.edit":`编辑样式`,
"label.delete_externalpage":`你要删除的' '无法撤回，请再次确定。表单不用于任何登录页面，但可能在其他地方使用。例如，您可能已经使用嵌入代码将其插入外部页面。`,
"font-evaluate-module-v1-open-case":`重新打开个案：`,
"label_not_adjust":`无调整`,
"vue_label_title_ordernow":`立即订购`,
"label.notification.serviceappointment.allocation":`您已被派遣新的工单{0}，请注意查收。`,
"label.objectRelationshipDescription2":`的报表。通过选择一个与它有关系的对象，可以定义其他对象中的哪些相关记录将返回到报表结果中。`,
"vue_label_calendar_notice_createfail":`创建日历失败`,
"label.ems.step1":`步骤1`,
"label.ems.password":`密码`,
"label.icon.143":`存钱罐`,
"label.select.year":`选择年度`,
"label.termsforusage.dialog":`使用条款 （新窗口）`,
"label.tag.addtags.create":`新增`,
"label.emailobject.groupemail.msg4":`无电子邮件地址，导致此封邮件无法发送给该收件人`,
"label.version.sum.autonumberfield":`个自动编号字段`,
"label.projectManagement.unallocated.time":`未分配时间`,
"PageLayout.Search.MultiSearch.002":`搜索字段铺开显示（单字段搜索）`,
"label.icon.150":`VR`,
"label.SMS.edit":`短信通知编辑`,
"Opportunity.Detailed.Phase.Label.003":`更改阶段`,
"vue_label_helpcenter_all":`1、全局搜索<br>    全局搜索是一个帮助您快速查找的所需内容的工具。<br>在页面顶部导航栏的搜索输入框中输入关键字。输入过程中系统会根据您的输入内容实时为您推荐相关的内容；<br>点击“搜索”或者直接按键盘回车键，即打开搜索结果页；<br>在搜索结果页中您可以通过筛选左侧的对象，来查看该对象下的搜索结果列表。结果列表中为您推荐最多10条记录，您可以点击“查看更多”，进入此对象的列表页查看更多的搜索结果；<br>注：系统默认对“报价单”、“客户”、“潜在客户”、“业务机会”、“市场活动”、“合同”、“产品”、“服务请求单”、“任务”和“事件”这十个对象进行搜索。<br>2、快速新建<br>        点击导航栏的“ ”，在下拉窗口中可以选择您要新建的对象。<br>3、个人中心<br>        点击导航栏右侧的头像，打开个人中心窗口。为您提供以下功能：<br>快速进入个人设置页、批量导入和回收站的入口；<br>如果您处于试用期，点击“立即订购”可快速进入cloudcc订购页面；<br>点击某个版本，可以快速切换；<br>退出登录。<br>4、菜单<br>        在菜单栏中为您推荐了一些菜单对象，您可以点击某个菜单，快速进入页面。您也可以查看全部菜单和设置要展示在菜单栏中的常用菜单。<br>全部菜单：点击“更多”，在下拉框底部点击“全部菜单”； <br>自定义我的菜单：点击菜单右侧的按钮，打开自定义菜单窗口，在全部菜单中设置您需要展示在菜单栏中的常用菜单。<br>5、应用启动中心<br>        点击菜单栏右侧的图标，可以快速切换到系统管理员为您配置到其他应用程序服务。<br>注：应用程序为一系列功能模块（如潜在客户管理、业务机会、合同管理等）的集合，可用来满足特定的业务需要`,
"label.summaryreport.2018.step5.new":`步骤5：选择报表标准`,
"label.weixin.id":`编号`,
"chatter.pu.mess":`个发贴和留言`,
"label.weixin.lookup.record":`查找记录`,
"label.ServiceCloud.statistics.by.address":`按照地址统计`,
"label.jixiaoswitchoff":`收起绩效`,
"label.savealipay.failure":`保存支付宝商户信息失败`,
"template.chart.khdqfb":`客户地区分布`,
"front-email-payment-immediate-payment":`立即支付`,
"label.dashboard.unit5":`单位：亿`,
"label.tabpage.greaterz":`大于`,
"vue_label_calendar_stop_sharing_calendar":`停止共享日历`,
"label.projectManagement.allhours":`全部(小时)`,
"label.currency":`币种`,
"label_vue_create_edit_obj_create_event_dialog_title":`待办事项重复提示`,
"front-template-V1-templateSetting":`模板设置`,
"label.dashboard.away.condition":`收起条件`,
"label.replacelayout":`替换页面布局`,
"label.permission.detail.system.setting.tip":`执行应用到应用程序的操作，如“修改所有数据的权限”`,
"label.customfield.delete.prompt":`自定义字段标签`,
"label.add":`添加`,
"label.deputationalsoapprove":`委派代理也可以批准此请求`,
"label.leave_nosave":`离开后，当前数据将不被保存。`,
"label.tianyancha.title":`天眼查`,
"vue_label_pool_restore":`恢复`,
"chatter.feed.menutype.feed.markcom":`已收藏的微贴`,
"label.query.data.error":`查询相关列表数据失败`,
"label.pc.ui.2018.unpin":`取消置顶`,
"label.partner.template.memo":`简述`,
"label.weixin.cannot.gain.userinformation":`无法获取用户的信息`,
"label.stdashbord.xsld.department":`部门`,
"label.service.ganttBaiduMap.scheduled.starttime":`计划开始时间`,
"label.documentforms":`文档`,
"label.operator.insert":`插入运算符`,
"label.processsetting.select.five.fields":`最多可选择5个字段`,
"label.weixin.password":`密码`,
"vue_label_chatter_share_followers":`与关注人员共享`,
"label.brief.baifang":`签到拜访`,
"label.emailobject.track.unopen":`没有打开`,
"label.sendmail.immediately":`立即发送`,
"label.partnerCloud.payTheAmount":`支付金额`,
"label.integrations.mailchimp.connect":`将CloudCC连接到您的账户`,
"label.datamove.record.sucessfully":`条记录转移成功！`,
"lable.outlook.edit.allocation":`分配用户和简档`,
"label.chosesubject.talk":`约会谈`,
"label.escalation.setup.entrydetail.escalation.time":`升级时间`,
"label.projectManagement.must.be.less.than.24.hours":`必须小于24小时`,
"setup_mainpage_label_welcome15":`CloudCC 云平台工作流规则可以自动化您的销售、市场等各种对象的支持过程。根据预先定义的一组规则，可以将记录自动分配给用户，或从一个用户转换到另一个用户。工作流管理的主要好处是，通过在更新记录时消除许多不必要的操作来提高工作效率，通过标准化工作方法、减少操作成本来提高业务处理水平，优化控制流程。支持任意对象的无限极审批，同时可以触发提醒邮件、短信提醒、任务、字段更新等功能。`,
"label.mobile.phone.week.plan2":`本周计划`,
"label.add.newAsset":`新建资产`,
"vue_label_salesadvance_losts":`流失数`,
"vue_label_report_editcolumn":`编辑列`,
"vue_label_homepage_assignedtasks":`已分配任务`,
"label.posting_from":`发布人`,
"year":`年`,
"label.autoRegister.changepwd.setpwd.tip.letter":`至少有一个字母`,
"label.version.nonsupport.feature.staticresource":`暂不支持此功能！请等待功能升级后使用！`,
"label.toleadmyclientandlinkman":`导入我的客户和联系人`,
"label.appupload.install.processcrash":`处理冲突`,
"label.profile.setstandardtab":`标准菜单设置`,
"template.chart.khhyfx":`客户行业分析`,
"label.reportTypcrtC":`关联对象（C） 请点击选择关联对象`,
"vue_label_report_mayormaynothave":`上级对象可能有或没有相关此对象记录`,
"label.service.gantt.plan.recommendation":`计划已推荐`,
"label.version.sum.lookupfield":`个查找字段`,
"label.builder":`页面构建器`,
"label.sharerule.remark":`指定此记录的共享。您可与用户，角色、角色及下属、区域、区域及下级区域所对应的用户共享此记录及相关数据。个别共享只能用于授予对数据更广的访问权限，而不用于限制访问权限`,
"vue_label_email_benn_added":`该邮箱已添加`,
"label.version.allow.sum":`，已达到上限！如有需要，请升级CloudCC版本！`,
"label.icon.130":`货币`,
"label.custom.new":`新建`,
"label.see_allfields":`查看全部字段`,
"front-marketing-module-v1-share-poster":`分享海报`,
"label.service.one":`您的筛选器引用了未定义的筛选条件:`,
"lable.outlook.edit.alprec":`始终首选CloudCC.com`,
"Account_News_Setting_001":`客户设置`,
"label.mr.caption.opportunity.result":`查重合并：查询业务机会重复数据的结果`,
"label.forbidden":`禁用`,
"label.query.detail.openpartner":`作为合作伙伴启用`,
"label.session_date":`会话日期`,
"label.forecast.customforecast.submit.deyuce":`的预测`,
"label.emailtocloudcc.filed.server":`服务器`,
"label.emailtocloudcc.tip2":`删除后将无法通过此邮箱实现Email to CloudCC功能，确认删除？`,
"pagecreator_layout_message_delete_fail":`布局删除失败`,
"front-lightning-module-v1-dashborad-export-PDF":`导出PDF`,
"lable.quote.syncing.syncingto":`报价单明细已同步到业务机会产品。`,
"message.error.view.lastview.update":`不能删除最后一个公共列表视图</br>您不能将所有用户皆可视的最后一个列表视图改成仅个人可见<br><br>`,
"label.weixin.select.one":`至少选择一项`,
"label.projectManagement.Pleaseenterprojectname":`请输入项目名称...`,
"label.data.downpage.e_list.desc1":`此页面显示的数据为导出成功的文件，请您根据邮件中提示的信息及时下载您导出的文件。`,
"label_tabpage_notexceed25":`选择的记录不能超过25条`,
"label.campaign.channel.step5.remark":`您已经完成了您的注册页面的设置`,
"label.setup.mobile.bottombutton.profile.prompt":`提示：定制的简档底部菜单会覆盖公司底部菜单统一设置
`,
"label.stdashbord.xsld.business.knx":`可能性`,
"label.setemailtip":`创建一个电子邮件通知 以关联一个或多个工作流规则、批准过程。 如果更改电子邮件通知 ，任何修改都将应用到与之相关联的所有规则、批准。`,
"report.button.go":`前往`,
"lable.the.united.arab.emirates":`记录已被领取`,
"label.writer. name.file":`请填写报价文件名称`,
"label.validate.function.funcExplain.ADDMONTHS":`在输入的date（日期字段）上加上num（月数）使其返回一个新的日期。在原先月份天数等于当月最后一天 或者 新的日期的月份天数少于原先输入的日期月份天数时，将会返回一个月份天数为当月最后一天新日期。`,
"vue_label_chatter_enter_shared_content":`请输入共享内容`,
"message.lookup.condition":`搜索条件必须输入一个以上字符`,
"vue_label_commonobjects_detail_customers":`永久禁用外部用户的客户将禁止所有与客户关联的外部用户，同时从与他们关联的所有社区、组、小组、权限集和共享规则中删除。同时，将永久删除与该账户关联的角色和组，同时不会出现在回收站中。是否确定？`,
"label.emailobject.view.all":`全部`,
"vue_label_file_size_limit_new":`附件大小超过{size}M，上传失败`,
"front-gantt-module-please-reorder-milestones":`请输入有效号码重新排序里程碑`,
"label.escalation.setup.entrydetail.escalation.assingTemplate":`电子邮件`,
"label.namespaceprefix":`名称空间前缀`,
"label.ems.delete.success":`删除成功`,
"label.partnerCloud.financeSetting.setWechatPay":`设置微信支付`,
"front-epwechat-module-v1-input-token":`请输入Token`,
"setup_object_field_dependency_button_setdependency":`设置字段依赖`,
"chatter.group.request01":`个请求`,
"message.error.field.number.length":`长度输入格式有误`,
"label.tabpage.lessz":`小于`,
"vue_label_notice_uploadavatar_format":`上传头像图片只能是JPG/PNG/GIF格式`,
"label.project.hit.thirteen":`每天里程碑提醒`,
"frame_personinfo_label_usethisimage":`我们会在应用程序周围使用此缩略图的变形图。`,
"label.startuploadfile.step":`否则没有成功上传的文件会显示在上方区域并有提示信息，需要将其全部清除，方可重新选择文件`,
"component_assistant_label_overduetask":`业务机会包含逾期任务`,
"label.partnerCloud.financeSetting.information":`如何设置支付宝签约信息`,
"label.appupload.install.package.component":`软件包组件`,
"label.emailobject.emaildetail.nextactivity.task":`添加任务`,
"vue_label_chatter_edit_post":`编辑帖子`,
"label.appupload.upload.logo":`图标`,
"label.role.selecteduser":`已选中用户`,
"label.letter.assign":`指定邀请函内容`,
"label.forecast.shrepage.title":`预测共享详细信息`,
"lable.Generate.service.appointment":`工作订单行项目生成的服务预约`,
"label.productsales.nodata":`没有数据`,
"vue_label_email_Please_select_at_least_one_email":`请至少选择一封邮件`,
"label.data.downpage.i_title.num4":`4、如果您要导入的对象中具有查找字段和主详字段，则该字段对应的值必须是ID，否则无效。`,
"label.new.exchagecurrency":`新汇率`,
"label.layout.listtip":`下表显示不同简档的页面布局分配`,
"label.icon.2":`钱包`,
"label.chat.topic.delete.prompt3":`是否确认删除此主题？`,
"UG_Lead_008":`名片扫码`,
"label.multilang.databatchadd.fail":`{0}条数据添加失败`,
"front-kefu-moudle-v1-chzx-confirm":`确定要删除坐席吗？`,
"label.import.page1.matchlabel":`匹配{{$store.state.labelName}}方式`,
"label.dashboardSetup.showdw.d3":`百万`,
"label.version.ifnecessary":`如有需要，请升级CloudCC版本！`,
"label.confirm.delete.default.tab":`确认要删除默认登录菜单吗？`,
"label.emailtemplate.mergefields.tip":`设计电子邮件的内容时可向内容中添加合并字段替换文本。当邮件被使用时，系统会替换成文本。例如{!Contact.name}，使用电子邮件时，正文中会变成联系人的姓名`,
"vue_label_chatter_decline_members_join":`拒绝成员加入小组`,
"label.role.no":`无角色`,
"label.service.gantt.resources":`的资源`,
"label.knowledge.language.simplified":`简体中文`,
"label.eidt.queue.length.cannot.than":`名称长度不能超过50`,
"label.mobile.quickcreate.default.tasks":`任务`,
"label.discount.yuan":`折扣（元）`,
"message.error.delete.pending":`记录正在审批中，不能删除<br>单击<a href='javascript:history.back();'>此处</a>返回上一页`,
"chatter.show.mostnews":`显示更多消息`,
"label.optionlist":`选项列表`,
"template.chart.cpdj":`产品定价`,
"label.user.usernamepassword.error":`用户名或密码错误`,
"label.file.sharetype.check":`查看者`,
"label.completed.generated.page":`已完成生成电脑端页面`,
"label.martrixcross":`矩阵交叉`,
"label_tabpage_entercusnamez":`请输入客户名`,
"lable.account.NextwDays":`未来30天`,
"label.list.userinterface.dashboard.hint":`新的仪表板图表支持在手机、平板等终端上显示，并且能快速呈现。`,
"message.fieldtrack.operatecreate":`已创建`,
"label.service.gantt.available.plan":`可被计划的时间空档：`,
"label.activity.setting":`活动设置`,
"label.tag.manage.record":`记录数`,
"label.customcomponent.page.edit.title":`编辑自定义组件`,
"label.import.index.creationrecord":`创建记录`,
"label.tabpage.printz":`打印`,
"label.appointment.wizard.subtitle4-1-5":`1.5小时`,
"label.partnerCloud.orderingPlatform.discountUnit":`折扣单位：`,
"label.weixin.micro.message.profile.associated":`微信公众号与公司简档关系`,
"label.cpq.opportunity.pricebook.change":`该业务机会已关联主报价单，价格手册不可更改`,
"vue_label_opportunity_business_opportunity":`结果为已结束且赢得客户的业务机会中，包含与当前业务机会有一个或多个相同字段的记录。`,
"message.standardreport":`标准报表`,
"vue_label_account_outstanding_business":`转移其他人所有未处理业务机会`,
"vue_label_commonobjects_detail_field":`选择筛选字段`,
"pagecreator_page_button_delete":`删除`,
"label.leadconvers.permisson":`没有{!objectname}的{!operator}权限，请联系系统管理员!`,
"vue_label_systemSettings_customcode":`自定义代码`,
"button.partner.cancel":`取消`,
"label.whChatBindingState":`微信账号绑定状态`,
"label.appointmentconfirmail.wizard.subtitle6":`电话号码`,
"label.recycle.dis.tip2":`用户可通过点击清空您的回收站或清空贵组织的回收站按钮对回收站进行清空操作，执行清空回收站操作需要一定的时间，系统将在操作执行完成后，发送邮件通知。`,
"batch.transfer.succ":`批量转移数据成功的条数为：`,
"label.chat.add.bookmark":`收藏`,
"label.mr.object.contact":`联系人`,
"component_setup_label_parentobject":`上级对象`,
"label.reportsSubscriptionPage.schedulereport.weekly.tuesday":`星期二`,
"vue_label_report_list":`选择要显示在列表标题的字段`,
"label.checkbox.false":`否`,
"label.chatter.followers":`被关注`,
"label.mr.loadReDate":`加载选中的信息`,
"label.versiontype.Essential":`基础版`,
"front-project-module-v1-input-actual_working_hours":`请输入报工工时`,
"label.visualpage.staticresource.p2":`2.注意.  支持的静态资源文件类型有png、jpg、gif、js、css`,
"label.query.clone.detail.choose":`请选择需要复制的明细记录`,
"component.assistant.label.30daysnoact":`30天没有任何活动`,
"label.tianyancha.businessverify.relation":`已映射`,
"vue_label_email_havent_received_the_email_yet":`暂时没有收到邮件哦`,
"label.isEnableVisualpage_new.title":`启用自定义页面访问`,
"lable.SalesCommitmentKanBan.allContractAmount":`总签约额`,
"label.searchall":`搜索全部`,
"label.h5.similar.opportunity.select.all":`选择全部`,
"label.area.tree.intro":`在这里您可以直观的查看区域和区域之间的关系`,
"label.select.up.three.fields":`注意：最多选择三个字段`,
"label.leadscore.doing":`正在打分中，请不要重复打分`,
"message.choosereportobj":`请选择报表对象`,
"button_partner_start":`开始使用`,
"label.quote.print":`打印报价单`,
"label.workflowoperateselect":`步骤3：指定工作流操作`,
"label.greate":`>大于`,
"lable.setting.qrcodeOrbarcode.rule":`二维码/条形码规则设置`,
"label.partnerCloud.orderingPlatform.discounts":`折扣计划`,
"label.ems.save2draft":`存草稿箱`,
"vue_label_homepage_editname":`编辑主页名称`,
"label.ccdocument.save.error":`保存失败,错误代码为`,
"label.samoa.standard.time":`萨摩亚群岛标准时间`,
"label.tianyancha.businessverify.msg7":`三：数据服务范围：`,
"vue_label_commonobjects_view_up_to_data":`该操作最多支持200条数据`,
"label.manage":`管理`,
"label.tooltip":`报表数据源已使用，不能编辑对象关系！`,
"vue_label_calendar_edit_calendar":`编辑日历`,
"label.attendance.keywords":`请输入关键词`,
"label.otherinfo":`其它信息`,
"System_TAB_SeeViewAmount":`查看总数`,
"label.recordtype.remark":`描述`,
"label.object.cannot.delete":`无法完成对象的删除尝试，因为它与同其他对象的以下关系相关联`,
"label.setup.mobile.bottombutton.saveprompt":`请选择4个一级页面`,
"label.department.lastpage":`已经是最后一页了`,
"label.emailtemplate.mergefield.use":`将合并字段值复制并粘贴到邮件正文`,
"vue_label_salesfunnel_notice8":`成功由本阶段转换为下一阶段的比例`,
"lable.opppdt.addpdt.table.product":`产品`,
"vue_label_helpcenter_report2.2":`步骤2：选择您如何汇总列：总和、平均、最大值、最小值。<br>•对报表中的数据进行升、降序排列<br>    单击预览报表表头中的任意字段旁的“↑”或“↓”标志，。报表中的数据将按照这个字段的升、降序进行排列。<br>•显示或隐藏详细信息行<br>    在进行分组后，通过预览报表右上方的“详细信息行”开关，您可以显示或隐藏详细信息行。“详细信息行”开关默认关闭。<br>•开启或关闭自动更新预览<br>    通过预览报表右上方的“自动更新预览”开关，您可以开启或关闭自动更新预览。开启后，您的每一步操作对数据产生的影响将会在预览报表中自动展示。•想要筛选报表记录，单击筛选器<br>    筛选器分为标准筛选器和字段筛选器。<br>    其中标准筛选器包含“角色”筛选器、“向我显示”筛选器和“日期”筛选器。<br>    A.“角色”筛选器，通过当前角色和直属下属角色划分数据，单击角色名称可切换不同角色。<br>    B.“向我显示”筛选器，通过“向我显示”和“向所有人显示”划分数据，“向我显示”展示的是所有人是当前用户的数据，“向所有人显示”展示的是当前用户具有查看权限的所有数据。<br>    C.“日期范围”筛选器，通过日期划分一段时间范围内的数据，例如“创建日期”、“结束日期”。 <br>    其中字段筛选器包含字段筛选器和高级筛选器。<br>    `,
"label.validate.function.funcFormat.YEAR":`YEAR(date)`,
"label.service.gantt.timeScale":`选择在甘特图中显示的时间刻度`,
"label.data.dataexptemplate.desc1":`1、数据导出的文件有两种方式，一种是CSV格式，另一种是压缩格式。默认为CSV格式。`,
"template.chart.btjbkhqk":`不同级别客户情况`,
"label.role.assign.select":`从<b>已选中用户</b>列表中移除一个用户会将该用户分配给上面选择的角色。`,
"label.event.lookupmulti.assigner":`被分配人`,
"label.appexchange.fieldupdata":`工作流字段更新`,
"label.lookup.page.notexists":`页面不存在`,
"label.appupload.install.error.choice3":`合并冲突的组件，合并为同一个组件`,
"vue_label_commonobjects_detail_team":`管理小组`,
"label.approvereqiest":`批准请求`,
"message.error.id.replace":`未查询到{0}对应的日历信息`,
"font-evaluate-module-v1-general":`评价类型是一般`,
"vue_label_report_whatweek":`周几`,
"vue_label_chatter_img_upload":`您可以上传JPG、GIF或PNG文件，最大文件大小为2M`,
"label.checkbox":`复选框`,
"label.visualpage.component.n5":`5.实例. 调用: &lt:component:c1 args="name:sqlName,age=18, sex='man'" /&gt; 使用: &lt;cc:component>&lt;cc>String myName = name; int myAge = age; String sex = sex;&lt;/cc>&lt;/cc:component>`,
"chatter.updat":`上传时间`,
"label.ems.emailaccount":`邮箱账号`,
"label.autoRegister.changepwd.setpwd.tip1":`设置密码为CloudCC帐户`,
"label.import.step1.matchway":`匹配{labelNameshow}方式`,
"label.manageAll.sel.one4":`我拒绝过的项目`,
"label.tabpage.lookatmorez":`查看更多`,
"label_tabpage_addadvancedoptions":`添加高级选项`,
"message.validation.accept":`输入合法的格式`,
"label.handlingnooperate":`数据正在处理中，请不要进行其它操作，否则将会处理失败。`,
"label.mobile.buttom.homepage":`主页`,
"lable.account.LastaDays":`过去7天`,
"label.user.notexists":`用户不存在！`,
"front-electronic-signature-isclose":`未开启`,
"label.optional.groups":`可选报价行组`,
"pagecreator.layout.label.layoutname":`布局名称`,
"label.error404":`您访问的页面不存在<br />请您稍后再来...`,
"label.eventtrigger":`事件触发器`,
"label.projectManagement.next.page":`后一页`,
"vue_label_SMS_chosen":`已选择`,
"label.part.cannot.empty":`段不能为空！`,
"label.call.center.jilu":`通话记录`,
"front-kefu-moudle-v1-tenant-reinput":`请输入租户ID`,
"label.projectManagement.you.want.to.delete.this.data":`确认要删除这条数据吗`,
"label.projectManagement.nocharge":`不计费`,
"System_TAB_SeeViewPageAmount":`查看页数`,
"label.password.query.error":`用户查询出现错误`,
"message.chooseatleastone":`请至少选择一个值`,
"label.sortasc":`升序`,
"label.stdashbord.xsld.business.jinezhb":`金额占比`,
"label.attendance.add":`添加考勤`,
"vue_label_account_invoices":`转移客户所有人的全部发票`,
"label_delete _model":`删除模型会同时删除相关目标数据，且不可撤回。确认删除么？`,
"label.folder.sort。discreption":`文件夹将按照选择的顺序输出。`,
"label.partnerCloud.financeSetting.merchantPlatform":`获取路径：商户平台-账户中心-API安全-API密钥`,
"label.equal":`=等于`,
"lable.PowerProcess.Workorder":`工作订单`,
"front-docusign-setting-error-tips":`请选择自定义字段`,
"template.report.lead.status":`潜在客户状态`,
"label.create.remark":`新增备注`,
"font-evaluate-module-v1-one-points":`差评得分：1分`,
"label.validate.function.funcExplain.DATETIMEVALUE":`返回年，月，日以及GMT时间（日期/时间 字段）`,
"label.report.select.group.mode":`选择分组方式`,
"label.h5.editmydetails":`编辑个人信息`,
"front-epwechat-module-v1-authorize":`授权回调域：`,
"label.tabpage.kanban":`看板设置`,
"label.emailobject.emaildetail.button.addtocontact":`添加到联系人`,
"lable.opppdt.selPbk.description":`为此业务机会选择价格手册。您只能从单个价格手册添加产品。更改已选取价格手册将从该业务机会中删除全部现有的产品。`,
"component.event.button.save":`保存`,
"vue_label_homepage_homepage_assigned_success":`主页分配成功`,
"message.duplication.label.blankmatch":`空值是否匹配`,
"label.icon.24":`急救箱`,
"label.mobile.same":`新手机号码同老手机号码一致。`,
"label.file.library.managemembers.addmember":`添加成员`,
"chatter.sp":`显示微贴`,
"label.user.notlogin.range":`不在登录时间范围内！`,
"label.step3.total7":`第3步，共7步`,
"label.user.fullname":`全名`,
"label.button.menubar":`菜单栏`,
"#label.importfilestep3":`步骤三：选择并上传您的文件#`,
"label.appointment.wizard.subtitle6":`描述`,
"message.lostnextapprover":`此提交需要相关用户字段确定的下一个审批人,此值为空。详情，请与您的管理员联系。`,
"label.sso.saml.sp.logoutUrl":`身份提供商单点注销URL`,
"label.weixin.isgoon":`您的会员信息已存在，如继续，以前绑定此手机号的微信号将不能使用爱马社微信公众号。是否继续？`,
"vue_label_notice_homepage1":`请输入12位之内的正确的目标值`,
"label.umeng.activity.event.will":`即将在`,
"label.insertURL":`插入URL`,
"label.partnerCloud.orderingPlatform.administrator":`无可用价格手册，请联系上游管理员`,
"vue_label_systemSettings_emailtemplate":`电子邮件模版`,
"template.dashboard.market.analysis":`市场活动分析`,
"message.deleteapproval.tip":`您只可以删除与其没有数据记录关联的批准过程。`,
"pagecreator_page_message_delete":`是否删除当前所选页面？`,
"component.telerecord.label.message":`留言`,
"front-email-payment-Invoice-preview-opening":`请联系系统管理员开通在线支付功能，并配置好相应的支付方式参数。`,
"noless":`大于或等于`,
"label_emailtocloudcc_button_back":`取消`,
"lable.Please.select.a.template":`请选择现有模板`,
"front-lightning-module-v1-details-page-chart-relevant":`· 当所选报表的相关对象中包含当前对象，可以将报表中的数据根据当前记录进行进一步筛选；可以选择是否允许用户手动刷新报表中的缓存数据`,
"label.object.page.head":`页首`,
"label.notification.time1":`刚刚`,
"label.weixin.optionnine":`选项九`,
"label.approval.content.tolang":`输入内容过长，请重新输入！`,
"label.leadconvers":`潜在客户转化`,
"label.compact.layout.frame.tabseq":`显示TAB页面顺序：`,
"label.permission":`权限集`,
"vue_label_notice_new_success":`新建成功`,
"label.money":`货币`,
"label.ccchat.person.invite.unsuppem":`您输入的电子邮件地址对{0}不支持`,
"message.profile.del":`此简档为系统管理员简档，不能删除！`,
"vue_label_report_savelocation":`保存位置`,
"label.knowledgebase.select.lighting.target":`请选择lighting目标`,
"label.visualpage.labelname":`页面标签名`,
"label.notification.ccchat2":`【点赞用户名】赞了您的微贴`,
"label.htyj.wanchenglv":`完成率`,
"label.weixin.report.generatedchart":`已生成图表`,
"label.customer.tab.please.label":`请输入菜单标签`,
"label.template.lookup":`查看模板`,
"label.attendance.setting.wucha":`误差200米以内`,
"vue_label_opportunity_product_addproduct":`添加产品`,
"label.data.setok.t.desc3":`，进行操作。`,
"label.emailobject.template.public":`公开`,
"label.setsubmit":`提交设置`,
"chatter.feed.menutype.feed.companycom":`所有微贴`,
"label.Generate.Document":`生成文档`,
"label.knowledge.setting.hint.six":`通过数据分类组织文章`,
"label.dashboard.show.total":`显示总数`,
"attachment.select.warning.001":`勾选了归档的附件，归档按钮不可用， 请重新选择附件。`,
"message.schedulejob.error.delete":`删除Job库的过程中发生错误。`,
"setup.layout.group.pagecomponent":`页面元素`,
"label_partner_new_step3_meno":`不确定输入什么？别担心，您随后可以随时进行更改。`,
"label.partnerCloud.orderingPlatform.mutex":`互斥`,
"label.subtotalrely":`小计依据`,
"label.file.library.selectFile2Lib":`添加文件`,
"label.lock.record":`已锁定记录（`,
"label.multilang.addcustomreporttypestage2.description":`此数据源将生成有关{0}的报表。通过选择一个与它有关系的对象， 可以定义其他对象中的哪些相关记录将返回到数据源结果中。`,
"message.duplication.errorinscript.greaterthan10":`最多只可选择10个要合并的记录!`,
"label.encd":`显示加密`,
"UG.Account.03":`主动查重客户并合并`,
"label.salescloud.teamrole.main2":`主要`,
"label.email.to":`收件人`,
"label.members.sign.notify":`成员签到是否通知负责人`,
"template.report.individual.case.priority":`个案优先级`,
"vue_label_report_selectfolder":`选择文件夹`,
"label_partner_all":`全部伙伴云`,
"lable.custom.year":`自定义年度`,
"label.ispigeonhole":`附件归档`,
"label.campaignmember.selectmember.steptotal":`第2步，共2步`,
"label.userphoto.save":`保存`,
"label.knowledgebase.published.version.online":`已发布版本仍将在线，直到您发布此草稿。`,
"template.report.customer.level.statistics":`客户级别统计`,
"label.mobile.phone.day.plan":`明日计划`,
"label.icon.95":`教学`,
"label.recordphone":`记录电话`,
"lable.currencyManage.unEnabledadvcurrency.discripation":`如果禁用高级货币管理，将无法使用过期汇率。业务机会、业务机会产品和这两个对象相关的报表的货币将不再映射特定日期范围内的汇率。所有的货币字段都将使用固定汇率。`,
"label.service.gantt.is.candidate":`的候选人`,
"label.ruleofchecktask":`任务验证规则`,
"label.whole.page.show":`整页显示`,
"label.validate.function.funcFormat.ISNULL":`ISNULL(expression)`,
"label.ccdocument.template.set":`模板套红功能`,
"label.icon.103":`日程`,
"lable.no.products.to.assets":`没有可以转换为资产的产品`,
"label.fristname":`名`,
"label.appointmentconfirmail.wizard.subtitle5":`发起者/组织者`,
"label.partner.workspace.myspace":`我的工作区`,
"label.tabpage.optionsz":`选项`,
"component_chatter_link_button_save":`发表`,
"label.validate.function.funcFormat.NOW":`NOW()`,
"label.discountPlanEditor":`折扣计划编辑器`,
"label.weixin.fmu.pm":`下午{0}`,
"front-gantt-module-milestone-sorting":`里程碑排序`,
"label.partnerCloud.maximumNumber":`伙伴站点的最大数量：`,
"label.mobile.place.record.interval.setup":`移动端位置上报间隔时间`,
"label.visiblelinenumber":`可见行数`,
"front-kefu-moudle-nopower-calluser":`没有权限，请联系管理员`,
"label.field":`字段`,
"label.projectManagement.groupbydate":`按日期分组`,
"label_vue_create_edit_obj_create_event_dialog_desc_deal_field":`安排了`,
"label.operation.monitoring.history":`作业监控历史`,
"label.data.dataexpalltype.all_desc1":`1、导出全部的压缩文件密码可以自动生成，或手动输入。自动生成的密码将在数据导出成功后发送到用户邮箱。手动输入的密码不会发送到用户邮箱，所以需要用户牢记自己输入的密码，若不输入，则默认没有密码。`,
"front-web-module-v1-detail-comment-proposal":`期待您留下宝贵的建议`,
"label_partner_workspace_member_selectedpermission":`已选权限集`,
"vue_label_helpcenter_view1":`在lighting版本的视图中，您可以直观、灵活地查看、管理拥有访问权限的数据。通过视图，可以实现数据分类查看、数据多种方式的展示、对数据的新增、修改、删除等基本功能，还可以便捷的查看报表、图表，以便对数据进一步分析。<br>1、管理视图<br> 在视图的左上角下拉菜单中，选择想要查看的视图，并可通过固定设置选择默认视图。<br> 使用列表视图控制菜单，可以新建、编辑、删除视图，或是进行排序。同时，使用右上方的筛选器功能，也可以快速的编辑、新建视图。<br>2、通过多种视图查看数据<br>    可以通过不同的方式查看数据。在右上角切换列表、看板、分屏三种方式来查看数据。<br> 在列表视图下，部分类型的字段支持直接对单条或多条数据进行修改。双击需要编辑的单元格，或点击编辑按钮，可以直接弹窗对数据进行编辑。若要编辑多条数据，只需先选择多条数据，再在编辑的弹窗中选中“应用于所选数据”。 <br> 在列表视图中，可以在左上角直接编辑要展示的列，在表头处点击表头进行排序，或通过下拉浮窗选择要锁定的列。<br> 设置看板视图后，可以分组查看数据，并查看每个分组的汇总值。在看板视图设置中，可以编辑看板视图的分组依据、汇总依据与汇总方式，同时也可以选择最多四个字段来展示。通过拖拽方式可以快速更改数据的分组。<br>`,
"component.task.label.priority":`优先级`,
"label.datamanage.field.error":`查询对象字段出现错误`,
"label.console.step3":`步骤 3. 选择控制台徽标的图像源`,
"label.ems.emailsyncsetup":`邮件同步设置`,
"label_tabpage_placeenterz":`请输入`,
"label.getontocolumn":`转至列：`,
"label.file.down.e":`当前文件类型不允许下载`,
"vue_label_notificationcenter_unreadonly":`只显示未读`,
"label.login.access.change":`更改`,
"label.globaloperation.operationtype.send_e-mail":`发送电子邮件`,
"label.dashboard.refresh.hint":`刷新仪表板会重新运行所有源报表，因此会占用一些时间，是否继续？`,
"front-kefu-moudle-open-free":`开启（试用）`,
"label.lanxin.setting.appsecret":`AppSecret`,
"label.payment.manage.order":`管理订购`,
"label.chatter.maturiyDate":`到期日期`,
"message.mobilechooseatmostthree":`手机前台菜单最多选取三个字段`,
"label.customfields.formula.tip":`根据您定义的公式表达式派生其值的只读字段。任何来源字段有所更改，该公式字段均将更新。`,
"lable.PowerProcess.start.time":`请选择开始时间`,
"label.mr.title.button.group2":`组重复数据，共有`,
"label.atlantic.standard.time":`大西洋标准时间`,
"label.account.LengthofTime":`持续时间`,
"label.ccchat.message.search.desc2":`的消息`,
"label.pigeonhole.desc":`附件归档只针对未归档的附件有效，对已归档的附件无效。<br/>附件一旦归档，将不可删除。`,
"label.partnerCloud.orderingPlatform.sure":`切换{alias}会清空购物车，是否确认？`,
"label.default.value.is.positive.integer":`默认值值必须是正整数！`,
"label.partnerCloud.selectOne":`至少选择一个菜单`,
"label.dashboard.more.condition":`更多条件`,
"component.event.label.enddate":`*结束时间`,
"label.forecast.settings.type":`预测类型`,
"com.cloudcc.login.error.message.licensenotstart":`许可未开始`,
"lable.list.queue":`队列`,
"label.mobile.app.isdisablum":`是否禁止签到时从手机相册选择照片`,
"label.service.gantt.filter":`在使用技能筛选时，仅拥有选定技能的资源才会显示到甘特图上`,
"label.potentialcustomeronline":`在线潜在客户`,
"label.campaignmember.main.deletecontactdesc":`一次从市场活动批量删除全部联系人`,
"label.list.desc1":`通过 Web to CloudCC 功能，生成web页面，通过web访问捕获数据到CloudCC系统。`,
"label.generatepage.title.desc3":`名称必须是唯一的，并且名称必须以字母开头，只能包含大小写字母，数字，下划线，且长度不能大于30。`,
"label.emailtocloudcc.step2total3":`第2步，共3步`,
"label.movablemenu":`活动按钮`,
"label.partnerCloud.partnerAccount.topUp":`充值`,
"label.data.standobject":`标准对象`,
"label.frequency":`频率`,
"label.schedulejob.setup.schedule.end":`结束`,
"label.chat.topic.following":`正在追随`,
"label.martrixreport.2018.step2":`步骤2：选择要汇总的信息`,
"label.event.moveup.11hour":`提前 11 小时`,
"label.forecast.customforecast.directorcommit":`直接下属的承诺额`,
"vue_label_homepage_card_view":`卡片视图`,
"vue_labenl_applauncher_notice_closecertification":`关闭后将会导致数据丢失，是否确认关闭`,
"component_setup_button_weburl":`外部URL`,
"label_emailtocloudcc_button_addemailaddress":`添加企业邮箱`,
"vue_label_campaign_added_campaign_members":`添加市场活动成员成功`,
"label_tabpage_rtemptyz":`记录类型不能为空`,
"label.martrixreport.2018.step5":`步骤5：选择图表类型和报表突出显示`,
"label.moverecord":`转移记录`,
"pagecreator_layout_label_layoutdesc":`布局描述`,
"label.knowledge.setting.data.nine":`是，我要删除此类别组及其类别`,
"label.icon.90":`人`,
"label.weixin.micro.research.name":`微调研名称`,
"label.ccchat.micropost.allowedit":`允许用户编辑帖子和留言`,
"vue_label_homepage_fixed_components":`标准组件`,
"label.version.document":`文档库`,
"label_assessment":`考核（业务机会-金额）`,
"label.appupload.component.type.lookuplayout":`搜索布局`,
"label_chatter_loadmore":`加载更多`,
"component_setup_tabs_label_memo":`设置Tab标签名称`,
"label.icon.167":`指南针`,
"vue_label_chatter_enter_content_sharing":`请输入共享内容和分享小组`,
"vue_label_notice_modify_success":`修改成功`,
"label.sharerules":`共享规则`,
"label.field.api.exists":`字段API已存在`,
"label.icon.83":`粉刷`,
"label.file":`文件`,
"vue_label_report_foldernameisrequired":`文件夹名称是必填项`,
"label.emailobject.wizard.btn2":`已关联，去发邮件`,
"label.data.downpage.i_title.num3":`3、导入之前，请先确保导入其相关的所有记录。例如：如果您当前导入的对象与联系人之间存在查找关系，请先导入这些联系人，然后再导入您的数据。`,
"label.email.original.content":`原文内容`,
"vue_label_campaign_add_to_campaign":`添加到市场活动`,
"label.dashboard.new":`新建仪表板`,
"label.console.detail":`查看控制台`,
"label.view.desc":`日期字段等于时可以使用“昨天”，“今天”，“明天”，“上个月”，“本月”，“下个月”，“上星期”，“本星期”，“下星期” 或  “YYYY-MM-DD、MM/DD/YYYY”格式。`,
"label.emailobject.template.insert.continue":`继续添加`,
"label.notification.appointment.overlapEvent":`该时段已被预约，请重新选择`,
"label.console.step6.top":`固定到顶部。列表始终可见。`,
"label.data.file.the_trigger":`执行触发器`,
"message.report.error.operation":`操作失败,请重新设置报表！`,
"vue_label_helpcenter_detail3":` <br>    点赞和取消点赞<br>    您可以对微贴或微贴的评论进行点赞。点赞后可以查看该帖子的点赞人数，也可以取消点赞。<br>编辑和删除帖子<br>    帖子的发表人可以重新编辑或者删除帖子。<br>    步骤1: 点击帖子右侧的按钮，在下拉框中选择编辑或删除<br>    步骤2: 打开编辑/确定删除的弹窗<br>    步骤3: 点击保存/确定，完成操作<br>5、审批历史<br>提交待审批<br>    当创建一条新纪录、调回审批请求或者审批被最终拒绝后，会出现“提交待审批”按钮。<br>    步骤1: 点击“提交待审批”。 系统会判定该条记录和提交操作人是否满足审批流程设定的项目和初始提交人条件，如果以上条件都满足，则提交成功。<br>    如果审批流程配置中下一个审批步骤需要手动选择审批人，则“提交待审批”后执行步骤2。<br>    步骤2: 选择下一个审批人，完成提交操作。<br>审批历史<br>    A.提交前：<br>    点击“审批流程预览”，系统会判断该条记录和提交操作人是否满足审批流程设定的项目和初始提交人条件，如果以上条件都满足，则展示审批流程。<br>    B.提交后：<br>    在审批历史中您不仅可以查看该记录的审批历史步骤和当前的审批状态，还可以预览接下来的审批流程。<br>调回批准请求<br>    如果该审批流程设定了可以调回审批请求，则在您提交之后可以随时撤回。<br>    步骤1: 点击记录详情页的“调回批准请求” <br>    步骤2: 打开调回批准请求页面，点击“调回批准请求”，完成操作`,
"Opportunity_Detailed_Phase_Label_004":`天`,
"PageLayout_Search_MultiSearch_001":`您最多只能选择不超过3个字段。`,
"vue_label_systemSettings_set_business":`设置业务对象布局和字段，使之更符合您的业务`,
"label.compact.layout.frame.select":`请选择页面布局框架`,
"label.tabpage.rolez":`角色`,
"label.weixin.appr.currentauditor":`被分配人`,
"label.knowledgebase.verification.status":`验证状态`,
"UG_Case_05":`创建个案`,
"label.service.marking.completed":`标记已完成`,
"label.notification.ccchat1":`【发出@的用户名】提及了您`,
"label.knowledgebase.no.action.available":`无操作可用`,
"label.tabpage.newlybuildz":`新建自定义报表数据源`,
"label.appupload.install.error.choice2":`重新命名与软件包中冲突的本地组件`,
"label_tabpage_as":`如`,
"Opportunity.Detailed.Phase.Label.Popup.001":`进入日期`,
"vue_label_homepage_singlepage":`单个页面最多添加10个组件`,
"font-evaluate-module-v1-fair-and-bad":`当评价类型是一般和差评时`,
"label.partnerCloud.orderingPlatform.orderInformation":`订单信息确认`,
"label.custom.lead.conversion.notice":`潜在客户转化通知`,
"label.re.upload":`重新上传`,
"label.knowledgebase.top.window":`最顶级窗口`,
"label.h5.allmarkedasread":`全部标记为已读`,
"vue_label_SMS_open_record_from_start_activation":`从列表中打开记录，以开始启用。`,
"label.customer.tab.step2":`步骤2：添加到简档`,
"label.campaign.channel.input.owner.select2":`此营销渠道邀约人`,
"component.task.button.save":`保存`,
"front-kefu-moudle-v1-phone-type":`电话类型`,
"label.wedge-shapearrows":`楔形尾箭头`,
"vue_label_homepage_todaysevent":`今日事件`,
"label.data.exp.way.sel":`选择导出方式`,
"label.setting.intergrationlist.status1":`目前尚未安装此集成`,
"button_partner_workspace_disable":`取消启用`,
"label.customfields.reference":`可能会被公式、选项列表、查找等其它字段所引用。`,
"label.publicgroups.new":`新建公用小组`,
"label.data.setok.e_desc3":`下载您导出的数据。`,
"vue_label_commonobjects_view_chart_countmode":`合计方式`,
"label.service.appointmentList.earliest.allowedStart":`最早允许的开始时间`,
"label.data.choses.e.desc":`根据您的需要，可以选择导出全部数据或选择导出单个对象的数据。`,
"label.multilang.common.fieldlist.fieldremark":`应用于在{0}页面上显示的字段。`,
"label.umeng.activity.event":`事件`,
"label.project.hit.ten":`问题更新通知`,
"label.c_d_least":`每个 C" 记录必须至少有一个相关 "D" 记录。"`,
"label.emailobject.wizard.btn1":`关联个人邮箱`,
"lable.product.pricebooks.info":`价格手册详细信息`,
"component_telerecord_label_message":`留言`,
"lable.total.of.estimates":`共计0个概算`,
"label.stdashbord.xsld.business.oppcounts":`机会数量`,
"vue_label_commonobject_duplicatewith":`与{0}中{1}重复`,
"label.setpicandreport":`图表设置`,
"label.category.2":`通用`,
"label.emailtocloudcc.reauthorization":`重新授权`,
"label.chatter.vote":`投票`,
"label_emailtocloudcc_edit":`编辑`,
"label.pleaseinput":`输入`,
"vue_label_homepage_user_particular_application":`用户使用特定应用程序时的主页，这些分配会覆盖标准主页`,
"label.allianceID":`联盟ID`,
"label.h5.homepage.cannot.applied.mobile.terminal":`未给该简档配置简档主页，无法应用于移动端`,
"label.appointmentpage.wizard.notif2":`请填写姓名`,
"label_emailsync_status_email":`操作邮箱`,
"label.icon.179":`人`,
"UG_Contract_03":`创建合同`,
"label.cy.new":`新币种`,
"label.version.setup.controllist":`后台设置控制列表`,
"label.vlidaterule":`验证规则`,
"label.customer.tab.name":`菜单名`,
"label.recentview.seloption1":`我最近查看的`,
"vue_label_report_notice_nameisrequired":`报表名称为必填项`,
"label.createapproveprocessstep":`<li>1.阅读帮助主题</li><li>2.创建电子邮件模板</li><li>3.创建短信模板</li><li>4.使用跳转起点向导或标准向导创建批准过程</li><li>5.将批准历史"相关列表添加到全部页面布局</li><li>6.启用过程，部署给用户</li>`,
"label.gotocalendar":`去日历`,
"label.import.page1.pleaseselectobj":`请先选择对象`,
"label_tabpage_messagez":`请输入留言`,
"vue_label_homepage_profilepage":`简档主页`,
"label.tabpage.choose":`选择`,
"label.campaignmember.setup.lead.field":`潜在客户字段`,
"label.setalipay.null":`配置支付宝必填信息为空`,
"label.custom.Current.and.NextCQ":`当前和下一个自定义季度`,
"label.knowledgebase.needto.publish.articles":`还原已归档文章会创建草稿版本。您将需要发布文章吗，以使其可用。`,
"pagecreator.layout.message.save.success":`布局保存成功`,
"homepage.componet.approval.label":`审批中心`,
"label.last_submission":`最后提交时间`,
"lable.outlook.detail.prefo":`首选Exchange`,
"label.projectManagement.new.subtask":`新建子任务`,
"label.service.appointmentList.checkThe":`勾选`,
"message.error.searchlayoutselectdefields":`无法删除，并且必须是搜索布局中的第一个字段。`,
"label.ems.normal":`正常`,
"vue_label_notice_pleaseselectobject":`请选择对象`,
"component.sendmail.button.send":`发送`,
"label.relevant.records":`相关记录`,
"label.weixin.login.CloudCC":`登录到 CloudCC`,
"label.tag.addtags.private":`私用`,
"label.appointment.disable.remark":`非常抱歉，此功能已经被禁用。如果您想重新或者取消预约，请由邮件：{邮箱地址}与您的负责人联系`,
"label.campaignmember.main.addMember1":`添加成员`,
"message.error.objectnofound":`对象未定义;`,
"label.employeenum":`员工编号`,
"label.search.applyfilter":`应用筛选`,
"label.version.history.track.nonsupport":`仅仅无限版本支持字段跟踪历史功能。`,
"label.ccpeak.direction.for.use.time":`CloudCC 平台定时类使用说明[2.0版本]`,
"label.ems.settings":`设置`,
"label_tabpage_arecordtypez":`可用记录类型`,
"vue_label_pool_assign1":`{0}{1}`,
"label.customcomponent.direction.for.use":`平台自定义组件使用说明[2.0版本]`,
"label.appupload.appname":`软件包名称`,
"label.cpq.order.status.no.active":`只有激活状态的订单才能生成合同`,
"label.dashboard.maxlength":`请输入至多255个字符`,
"label.customize.memory.function.sorting.title2":`表头排序记忆`,
"label.report.chose.obj":`选择对象关系与报表数据源`,
"label.partner.step3":`步骤3：基本信息`,
"message.report.type.error.fail":`报表数据源错误！`,
"pagecreator.page.message.publish.fail":`页面发布失败`,
"label.minimun":`最小值`,
"label.state":`状态`,
"label.customcomponent.referencetype":`引用类型`,
"label.nameandemailtemplate":`在下面的框中输入过程名，然后选择一个电子邮件模板，通知批准人（可选）.`,
"label.customobjects.track.introduce":`此页面允许您选择要在`,
"label.campaign.matchway.label":`匹配方式：`,
"label.redistribution":`重新分配`,
"label.groupmanage":`组织管理`,
"label.icon.157":`摄像头`,
"label.quickbooks.viewlist.total":`总计`,
"label.file.copy.file.fail":`复制失败，请手动复制`,
"label.outline.selectfield":`概要选中的字段：`,
"label.datetime.maxsize":`查询的周期不能大于3个月`,
"label.dashboard.CustomDashboardMyHomePage":`自定义我的主页仪表板`,
"label.data.customobject":`自定义对象`,
"vue_label_SMS_noselected":`未选择记录`,
"label_tabpage_value":`值`,
"label.quote.qianming":`签名`,
"label.view.source":`源代码查看`,
"label_popup_infoz":`提示`,
"label.emailtocloudcc.redmessage8":`参数错误，请联系管理员`,
"label.tianyancha.Search.business":`搜索工商注册信息`,
"vue_label_systemSettings_server":`服务`,
"vue_label_homepage_dashboard_components":`仪表板组件`,
"label.search.listview":`列表视图`,
"label.service.gantt.distribution.success":`分配成功`,
"label.icon.4":`钱包`,
"label.partnerCloud.orderingPlatform.calculate":`计算价格`,
"label.forecast.edittotal.ycyx":`预测优先`,
"vue_label_commonobjects_detail_to_precise_search":`前往精准搜索`,
"label.order.number":`序号`,
"setup.mainpage.label.welcome7":`操作指导： 点击本页左侧菜单 → 应用程序设置 → 创建 → 对象 → 对象名 → 自定义字段。`,
"label.weixin.user.binding":`用户绑定`,
"label.custom.canvas.size":`画布大小`,
"label.projectManagement.recent.projects":`最近的项目`,
"vue_label_helpcenter_lead":`    通过Cloud CC跟踪管理您的潜在客户。利用配置好的规则对潜在客户进行打分、分配，并在合适的时机将潜在客户转化为客户、联系人，与对应的业务机会。<br>打分<br>    在视图的右上角，通过批量打分按钮，为该视图中的潜在客户进行打分。<br>分配<br>    在创建或编辑潜在客户时，在页面下方选择分配，即可按照已有规则将潜在客户分配给对应的人员处理。<br>转化<br>    在合适的时机，可以通过点击详情页面中右上角的转化按钮，将潜在客户转化为客户、联系人，同时可以创建对应的业务机会与任务，方便继续跟进交易机会。`,
"label.enabledprocess":`已启用的批准过程`,
"label.emailobject.noemail":`尚无任何邮件，快去发一封吧！`,
"label.validate.remark3":`根据另一个字段值有条件的决定字段是否必须`,
"vue_label_salesadvance_retention":`滞留`,
"label.product.managep":`管理价格手册`,
"font-evaluate-module-v1-not-report":`不重新打开`,
"label.emailmerge.mergepage.step1":`1.选择要合并的记录:`,
"front-epwechat-module-v1-epwechat-describe":`CloudCC提供集成企业微信的能力，结合企业微信强大的功能与轻量化的H5版本CloudCC系统，<br />帮助您便捷的管理客户关系，运营私域流量，提升企业营收能力。`,
"label.partner.template.detailimage":`详图`,
"label.recycle.clearall":`清空贵组织的回收站`,
"chatter.error.nottype":`错误：无效的类型，可以上载的文件类型是JPG、GID、PNG!`,
"pagecreator.button.cancel":`取消`,
"front-market-form-quired-ziduan":`注册页面必填字段`,
"vue_label_report_columnname":`列名称`,
"message.notdelete.type":`无法删除此记录类型，因为以下简档使用此记录类型作为默认值。`,
"label.ccpeak.folder.all.time":`所有定时类文件夹`,
"label.quickbooks.searchlist.total3":`搜索到有{0}个尚未关联的概算记录，共计金额为{1}`,
"label.forecast.detailforecast.quantity":`数量预测`,
"label.knowledge.language.british":`英式英语`,
"label.vlidaterule.example.messagelocation":`该错误信息可出现在页首或页中某一特定字段的下面`,
"front-kefu-moudle-chf-success":`拆分成功`,
"vue_label_jihui_yi":`机会1`,
"label.import.step1.null":`无可选项`,
"label.console.step5.tab.subtab":`作为次菜单`,
"batch.edit.permission":`无编辑权限`,
"label.weixin.fmu.before.min":`提前 {0} 分钟`,
"chatter.up.file":`上载文件可能花费一些时间，这取决于文件大小。请等待上载文档。`,
"setup.layout.group.field":`字段`,
"label.chat.unlike":`取消赞`,
"vue_label_dashboard_updatefrequency":`更新频率`,
"label.trigger.folder.new":`触发器页面：新建文件夹`,
"label.process.des.app":`若要查看当前记录的详细信息，请点右侧链接进入。`,
"vue_label_pool_assignselect":`选择分配成员`,
"label.lookup.user":`查找人员`,
"label.mobilescreentablayoutedit.remark2":`选择要在手机前台菜单页面筛选里显示的字段`,
"label.data.exp.objtemp":`您将按以下条件制作导出此对象的模板`,
"label.weixin.moreselect.error":`只能选择10条记录`,
"label.icon.25":`包扎`,
"lable.sample.text":`示例文本`,
"label.most.setup.obj":`最多可设置10个对象`,
"label.weixin.coming":`未来`,
"label.editdescription":`编辑备注`,
"label.multipleactivity.multiple":`多个用户`,
"label.sso.saml.idp.entityid":`实体ID`,
"label.SMS.pho.filed":`电话字段`,
"message.serviceabsence.violation":`派遣时间违规:在此时段与缺勤记录冲突`,
"label.forecast.settings.type.clist":`使用产品系列`,
"label.state.noend":`未结束`,
"label.sourcetemp":`源翻译模板`,
"vue_label_chatter_name_link":`请填写名称和链接`,
"label.emailobject.attach":`添加附件`,
"label.everyother":`每隔`,
"label.title":`CloudCC.com`,
"vue_label_chat_haventactivate":`尚未开通聊天账号，是否立即开通账号？`,
"pagecreator_layout_button_delete":`删除布局`,
"label.transfer.temporarily":`调用`,
"label.service.dispatchingUnits.search.services":`搜索服务预约`,
"customer.message.fail.chat":`获取消息记录失败，请联系管理员帮助`,
"label.apiname.toolong":`Api名称过长`,
"label.empty.filter":`清空筛选`,
"label_tabpage_personalCenterz":`个人中心`,
"label.minutes":`分`,
"label.multipleactivity.atasks":`个任务`,
"label_tabpage_deleteview":`删除视图`,
"pagecreator_layout_message_save_success":`布局保存成功`,
"label.reportlineorder":`报表列顺序`,
"label.total.forecast.have.priority":`的任何预测优先,但是接受其他下属的预测优先`,
"label.custom.quarter.subtitle":`自定义季度`,
"label.icon.79":`印刷`,
"label.hiddenoperate":`隐藏操作`,
"label.project.hit.six":`项目任务分配通知`,
"label.visualpageaction.errordesc":`您没有足够的权限执行所请求的操作。如果需要访问，请联系记录所有人或管理员。`,
"label.chat.unmute":`取消免打扰`,
"label.zhaiyao":`摘要`,
"vue_label_commonobjects_detail_bcc":`密送`,
"label.customcomponent.page.index.table.version":`API版本`,
"UG.quota.06":`创建报价`,
"label.icon.152":`机器人`,
"label.partnerCloud.partnerAccount.account":`账户`,
"label.file.sharewith":`共享者`,
"label.data.dataexptemplate.desc2":`2、导出方式的压缩格式分为两种：一种是自动生成压缩文件密码，自动生成的密码将在数据导出成功后发送到用户邮箱；另一种是手动输入压缩文件密码 ，手动输入的密码不会发送到用户邮箱，所以需要用户牢记自己输入的密码，若不输入，则默认没有密码。`,
"vue_label_dashboard_newfoldersuccessfully":`新建文件夹成功`,
"label.campaignmember.main.importmember":`批量导入市场活动成员`,
"label.htyj.completed":`已完成`,
"label.reportTypeLabel":`报表标签`,
"label.customer.tab.label":`菜单标签`,
"label.dashboard.component":`组件`,
"label.safetystatement.dialog":`安全声明 （新窗口）`,
"label.forecast.settings.data":`预测日期`,
"label.knowledgebase.modifiedby":`修改人`,
"label.batchadd.remark":`可以增加多条记录`,
"button.partner.delete":`删除`,
"Pagelayout_Setup_005":`名称必须放在第一个位置`,
"label.forecast.edit.wcpxl":`无产品系列`,
"lable.PowerProcess.seq.input":`请输入顺序`,
"pagecreator.layout.message.delete.fail":`布局删除失败`,
"label.emailobject.edit":`编辑`,
"label.weixin.million":`万元`,
"setup.mainpage.button.manageobject":`对象管理`,
"label.weixin.participants.perfect.information":`是否要求参与者完善信息`,
"vue_label_campaign_campaign_members":`添加市场活动成员`,
"label.ccchat.person.invite.emplaceholder":`输入电子邮件地址，用分号隔开`,
"label.mobile.phone.new":`新增`,
"font-evaluate-module-v1-small-program-evaluation-settings":`小程序评价设置`,
"UG.opportunity.005":`多销售流程`,
"vue_label_report_polymerization":`聚合`,
"label.multilang.lookfiltercondition.fieldtypenotmate":`第{0}行条件错误，字段类型不匹配！`,
"label.knowledgebase.delete.draft":`删除草稿？`,
"label.mr.descreption.condition3":`规则-是否完全匹配：勾选此选项，按字段的相同数据查询重复数据。勾选此选项后，按前几个字符输入将失效。`,
"Lead.Auto.Scoring.Setting":`潜在客户自动打分设置`,
"label.marketing.channel.default":`营销渠道（默认启用）`,
"front-project-module-v1-select-projecttemplate":`选择项目模板`,
"front-email-payment-select-area":`请输入区`,
"lable.PowerProcess.message":`权利过程信息`,
"label.weixin.free.get.captcha":`免费获取验证码`,
"label.projectManagement.please.select.task.or.question":`请选择任务/问题`,
"label.pacific.daylight.time":`太平洋夏令时`,
"label.sendsms.batch.step1.introduce":`选择以下视图之一(其中包含此短信的接收者)。`,
"label.same.analyze.account.name":`客户名称`,
"Homepage.Contract.FieldMissed.DoesntSupport":`合同对象中找不到字段 "qdrq" 和"htje" ，数据无法显示。`,
"label.partnerCloud.orderingPlatform.noProduct":`目前该产品没有产品选项需要配置`,
"label.totalsummary":`累计汇总`,
"label.partner.workspace.tab":`菜单`,
"label.entitlement.process.name.unique":`名称已存在，请重新填写`,
"report.label.norole":`您没有此权限，请联系系统管理员！`,
"label.password.old.error":`输入的旧密码不正确`,
"lable.account.quarter.stadate":`会计季度起始日`,
"label.salescloud.contactrole.choose.correct":`选择了重复的联系人，请更正`,
"label.schedulejob.setup.schedule.day":`日`,
"label.communalusergroup":`公共用户组`,
"label.Display.Fields":`服务预约列表上要显示的字段`,
"label.marketsea":`公海池`,
"label_partner_setup_address":`伙伴云地址`,
"label.industrialandcommercialverification.label.url":`URL`,
"lable.data.exp.newtemp":`数据导出及模板制作`,
"label.pc.ui.2018":`纵向菜单`,
"label.version.free":`免费版`,
"label.dataimport.contact.length":`出现错误：联系人姓名长度过长。`,
"label.cy.vlidate":`币种启用之后将不可逆，您确认启用币种管理功能？`,
"label.recycle.all":`全部回收站`,
"label.message.changeaccount.isnot":`联系人已启用了合作伙伴用户，无法更改客户信息`,
"label.searchlayout.exactsearch":`提示：勾选搜索字段后方的复选框，则该字段进行精确搜索`,
"label.file.size.limit":`注意：允许最大文件为10M`,
"label.mobileapp.modelsetting1":`移动端标准功能模块设置`,
"template.report.overall.sales.opportunities":`整体销售期（按业务机会类型）`,
"label.password.update.success":`密码修改成功！`,
"label.import.page3.gobackhome":`回到主页`,
"label.phone":`电话`,
"label.detail.vlidaterule":`查看验证规则`,
"label.weixin.input.usernames":`请输入用户名`,
"label.icon.85":`变压器`,
"vue_label_systemSettings_partner":`伙伴`,
"label.processsetting.new.process":`新建进程`,
"Lead_Scoring_Setting_Rule_Setup_01":`潜在客户打分规则列表`,
"setup.layout.component.area":`区域`,
"label.createnewpwdinformuser":`生成新密码并立即通知用户`,
"label.pwinfo":`密码信息`,
"label.imgfield.type.url":`引用图片`,
"label.attendance.sxccheckincy":`市场活动成员签到`,
"lable.PowerProcess.condition.input":`请选择条件`,
"label.partnerCloud.partnerAccount.topUpFailure":`充值失败`,
"label.document.size.too.long":`文档大小超过了`,
"label.link":`访问链接`,
"label.partnerproduct.sort.repeat":`产品系列名称重复`,
"label.data.setok.e_desc2":`导出数据列表页面`,
"front-project-module-v1-plase-input-project-name":`请输入项目名称`,
"label.export":`导&nbsp;&nbsp;出`,
"label.icon.45":`锅炉`,
"label.autoRegister.changepwd.title":`设置您的登陆密码`,
"label_clear_adjust":`清除调整`,
"front-kefu-moudle-return-visit":`回访`,
"label.ems.compose":`写邮件`,
"Pagelayout_Setup_002":`您已经选择了3个相关列表，再次选择的话将影响页面布局`,
"label.service.gantt.skill.screening":`使用技能筛选`,
"label.partnerCloud.basicSetting.enable":`你将关闭伙伴云启用状态，系统将自动禁用贵组织伙伴云登录与新建修改功能！`,
"label.workbanch.setup.description":`您可以设置以下视图是否在我的工作台中显示。`,
"label.category.1":`全部`,
"label.foldername":`文件夹名称`,
"label.forecast.settings.shuliang":`预测数量`,
"label.emailmerge.newtemplate.word":`请上载word文档!`,
"message.error.type":`type不能为空，需要传public公共类型或人员private！`,
"label.manualallocation":`手动分配`,
"label.addattachment.step2":`步骤 3.单击“上传文件”按钮，上传文件`,
"label.company":`公司`,
"label_emailsync_status_export":`导出为Excel_csv格式文件`,
"label.eventreminder":`事件提醒`,
"label.emailtemplate.lookup":`查看邮件模板`,
"label.customsetting.touse.getCustomSetting":`查询“层次结构”类型的自定义设置数据,返回对应apiName和权限（id为简档id或用户id）的单条数据 Map map = cs.getCustomSetting(String apiName, String id);`,
"label.projectManagement.Resourceuse":`资源使用`,
"label.appointment.wizard.subtitle4":`缓冲和时间设定`,
"label.donot.close.your.browser":`在此过程中,请不要单击其他链接或关闭您的Web浏览器`,
"label.multilang.customforcast.target":`{0}的目标`,
"setup_layout_label_newarea":`新建区域`,
"component.timeline.button.more":`更多步骤`,
"label.appointmentdetail.wizard.title3":`持续时间`,
"label.help.new.features.pc":`PC端新功能操作指南`,
"label.mr.record":`记录`,
"label.trigger.wgd":`未归档触发器`,
"label.icon.72":`工具箱`,
"setup.layout.label.detailpage":`详细页面`,
"frame.personinfo.label.usethisimage":`我们会在应用程序周围使用此缩略图的变形图。`,
"label.multilingual.confirm.open":`是否确认启用，启用后将可以使用多语种。`,
"label.recordcreater":`记录创建人`,
"label.afterfinish":`完成后，单击保存并新建"以创建更多自定义字段；如果已完成创建操作，单击"保存""`,
"label.companyinformation":`公司信息`,
"step1":`第1步`,
"label.sales.page.dashboard.add":`添加主页仪表板`,
"label.processsetting.process.enabled.failed":`删除进程失败！`,
"label.document.history.date":`日期`,
"label.linkedin.title":`领英-H5微应用`,
"label.foldervisitlimit1":`所有用户均可访问此文件夹`,
"april":`四月`,
"label_emailsync_form_disconnect":`取消关联`,
"label.appointment.wizard.subtitle4-2-6":`2天`,
"vue_label_notice_follow_success":`关注成功`,
"label.startuploadfile.success":`当单击“开始上传”按钮后，如果进度条达到100%，则说明文件上传成功，并且会在上方区域消失`,
"message.accesstoken.acquisition.failed":`访问令牌获取失败！`,
"label.quickbooks.fieldlabel.fistname":`名`,
"label.appointment.wizard.subtitle1-5":`1小时`,
"2018UI.Homepage.DataNoAccess.Info":`此条记录您没有权限访问，点击返回上一步。`,
"label.batchaddattachments":`批量添加附件`,
"label.ems.next":`下一步`,
"label.quote.zhekou":`折扣`,
"lable.product.notdel":`的删除,因为它仍与其它价格手册中的记录相关联。关联记录如下 。`,
"label.ems.action":`操作`,
"message.error.chart.type":`图表类型不能为空！`,
"label.conditiontag.lookup.value":`值`,
"label.chatter.allactivity":`所有活动`,
"label.summaryreport":`汇总报表`,
"label.textmessage.vonage.action":`操作`,
"label.ccpeak.must.result":`必须as别名才能从结果中取出`,
"label.data.newtemplate.savetemp.desc":`请认真填写模板名称和模板描述，方便您的使用。`,
"label.projectManagement.search.for.users":`搜索用户`,
"component.milestones.label.title":`里程碑`,
"vue_label_applauncher_description_accountpool":`使用客户公海池，便捷管理组织内的客户跟进状态，激励人员完成成交。`,
"label.import.index.startimport":`开始导入`,
"page.field.masterinput2":`主从录入`,
"label.mobile.change.owner.permission":`新所有人必须对此类型记录有读取权限`,
"label_partner_common_enable":`启用伙伴云`,
"label.log.browser":`浏览器`,
"label.app.step4":`步骤 4. 选择菜单`,
"lable.quote.syncing.opportunity":`业务机会`,
"label.forecast.customforecast.foredis.jqz":`精确值`,
"label.forecast.forecastroleuserpage.title":`预测经理分配`,
"label.starting.quarter":`起始季度`,
"label-combination-record":`记录{index}`,
"label.here":`此处`,
"label.weixin.underfind.error":`未知错误`,
"label.cloudccclass.list.tip.time":`允许开发人员在CloudCC.com平台上开发定时类,这些定时类可以用于定时程序`,
"label.data.setok.t_desc1":`如果需要用此模板导出数据，请点击`,
"label.service.gantt.break.rules":`违反规则`,
"label.weixin.no.pending.ywjh.qin":`亲，未来30天没有业务机会数据`,
"label.view.atleastone":`选项列表至少有一个值`,
"label.attendance.sxccheckin":`市场活动现场签到`,
"label.custom.split":`拆分`,
"front-kefu-moudle-v1-yesorno-delete-templete":`确定要删除这个模板吗？`,
"label_chatter_theme":`主题`,
"label.partner.new.step1":`步骤1：选择您喜欢的模板`,
"vue_label_commonobjects_view_settings":`看板视图设置`,
"UG_Contract_02":`合同是各方之间的书面协议。许多公司使用合同定义与其他公司从事业务往来的条款。使用 CloudCC 建立您与您的客户和业务机会已有的合同，并为其提供文档。通过批准流程，跟踪合同。使用工作流提醒，以提醒您合同展期。`,
"label.setup.mobilesetup.isenableh5newandedit":`移动端是否启用H5新建编辑`,
"label.attendance.edit":`修改考勤`,
"label.service.miniProgram.fillImageLink":`请填写轮播图链接`,
"label.b.c.without":`B" 记录可能有或没有相关 "C" 记录。"`,
"label.sso.key":`授权码`,
"label.star_click":`点击清零`,
"vue_label_SMS_name_or_phone_number_lookup":`记录名称搜索`,
"label.case.copre.text":`您也可以下载专属于贵公司的网页门户二维码，将二维码放到官网或设备上，客户可以扫描二维码使用网页版客户门户。`,
"label.salescloud.forbidden.confirm":`是否继续要禁用小组销售？`,
"vue_label_chat_conformactivation":`确认开通`,
"label.emailtocloudcc.redmessage9":`数据库错误，请联系管理员`,
"label.sahreto":`共享给`,
"label.recordtype.sort":`记录类型按保存的顺序显示`,
"label.allreport":`所有报表`,
"front-gantt-module-drag-and-drop-subtask":`拖放（归入任务），以使其成为子任务！`,
"label.permission.objlist.nopermission":`无访问权限`,
"label_file_num":`数量`,
"chatter.mostword":`最多可输入500个文字,请删减后再发表`,
"label.h5.chatter.comment":`评论正文`,
"vue_label_calendar_notice_havecreated":`您已创建日历`,
"label.tabpage.loadz":`页面加载中，请稍后...`,
"chatter.w.p":`工作电话`,
"label.chat.topic.name.desc":`您仅能更改主题名称的大小写和间隔`,
"label_partner_template_name":`模板名称`,
"label.mobile.phone.required.examines.people":`批阅人为必填项`,
"message.error.view.notexists":`视图不存在</br>视图可能已经被别人修改,单击<a href='javascript:history.back();'>此处</a>返回上一页`,
"label.custom_time":`自定义时间`,
"label_partner_workspace_member_all":`全部`,
"lable.custom.year.name":`自定义年度名称`,
"label.account.previous.M":`上月`,
"vue_label_commonobjects_detail_locking":`锁定`,
"label.brief.lead":`潜在客户`,
"label.linkedin.setting.appsecret":`秘钥密码`,
"label.query.detail.closepartner":`禁用合作伙伴`,
"label.isEnableVisualpage_new.rightlist":`已启用的自定义页面`,
"front-epwechat-module-v1-unbound-item3":`- 授权信息数据`,
"label.exchange.sync.setting.info":`在 Microsoft  Exchange 中为用户设置带有模拟权限的服务帐户后，输入服务帐户凭据，以允许 CloudCC 与 Exchange 服务器通讯。如果已保存服务帐户凭据但用户仍无法同步记录，确保您已正确设置 Exchange Sync。`,
"label.emailobject.groupemail.fail.title":`CloudCC批量发送邮件失败邮箱`,
"label.the.upper.bound.of.each.level.of.edit.discount.must.be.greater.than.the.lower.bound.":`编辑折扣每1层的上界必须大于下界。`,
"label.visualpage.list.vpname":`自定义页面名称`,
"label.mask.length.error.message":`加密文本字段长度不能超过255`,
"label.h5.approval.actorname":`发起人`,
"label.knowledgebase.view.translation":`查看翻译`,
"label.ems.edit":`编辑`,
"vue_label_commonobjects_view_reset_width":`重置列宽`,
"label.version.feature.controllist":`功能控制列表`,
"label.setuppagelayout":`页面布局`,
"vue_label_commonobjects_view_new_view":`新建视图`,
"label_tabpage_queuez":`队列`,
"label.direct.dashboard.wait.me.approval":`待我审批的项目`,
"message.report.error.noRelatedField":`报表没有找到关联字段，可能已删除，请联系系统管理员。`,
"label.ccchat.person.invite.notme":`您无法发送邀请到您自己的电子邮件地址。`,
"label.weixin.jieduan.finish":`将当前阶段标记为已完成`,
"vue_label_commonobjects_detail_?enter_subject":`请输入主题`,
"label_starting_month":`起始月份`,
"label.address_linetwo":`地址第二行`,
"message.error.select.contiguous.item":`选择的相关项已经与`,
"vue_label_pricebook_enterbookname":`请输入价格手册名称`,
"label.cycleworkflowoperate":`周期性的工作流操作`,
"label.ems.withoneday":`当天`,
"component.todaytask.label.notask":`今天没有到期任务-趁有时间，去喝杯咖啡吧。`,
"label.tianyancha.id":`公司ID`,
"label.user.illegal.login":`非法登录！`,
"label.withgathercondition":`按汇总条件`,
"label.foldervisitlimit":`访问权限`,
"label.ccchat.search.conversation":`搜索此会话`,
"lable.annual.project.report":`本年度项目客户报告`,
"template.chart.qzkhzhfx":`潜在客户转化分析`,
"label.my":`我的`,
"label.sendsms.batch.chosetemplate":`批量发送短信：模板选择或编辑短信内容`,
"label.callcenter.enterprise.number":`企业编号`,
"label_last_modified_by_time":`最后修改人&时间`,
"message.fieldtrack.operaterecord":`将 <b>operatefield</b>从<b>operateold</b>更改至<b>operatenew</b>`,
"label.mobile.more.openin":`打开方式`,
"label.multilingual.tip2":`您可以启用和禁用多语言`,
"label.datamanage.lead.novalue":`注意：本次导入操作没有给“潜在客户名称”字段赋值，联系人记录将不会被导入！`,
"label.custom.revoke":`撤销`,
"label_chatter_leaveword":`留言`,
"vue_label_ccchat_group_deletedgroup":`该小组已被删除`,
"label.tabpage.operationz":`字段，操作不能为空`,
"label.user.organization.permit.overdue":`您的组织许可证书已过期，请联系管理员！`,
"label.log.datetimeoruser.value":`请输入查询时间、用户名!`,
"lable.product.stsp.noavailable":`没有可用的标准价格`,
"label.appservice.cannot.delete.app":`无法删除自定义应用程序。某些简档正在使用此自定义应用程序作为默认应用程序。`,
"component.event.label.newevent":`新建事件`,
"label.view.sortview.exportview":`导出视图`,
"label.uploadfilemaxsize":`允许上传最大文件为`,
"label.event.weekview":`周视图`,
"label.conversion_rate":`转化率`,
"label.partnerCloud.partnerAccount.useWechat":`使用微信扫码支付`,
"UG_Forcast_05":`预测设置：步骤{0}/{1}`,
"label.service.gantt.jobresour":`仅显示工作资源`,
"vue_label_campaign_fromopprotunities":`来源{dsrjine}个进行的业务机会`,
"label.app.skyblue":`天空蓝`,
"label.chinacloudcc":`中国云计算`,
"label.connectOtherFinalNumber":`到达对象极限<br />您最多可以将四个对象关联到自定义报表数据源。`,
"label.redistributionrequest":`重新分配批准请求`,
"label.knowledge.category.button.one":`添加子分类`,
"label.campagin.pcandmo":`PC和移动端`,
"label.project.milestone.date":`里程碑日期必须在所属项目的日期范围内。`,
"assetbom.transfer.notpermission":`请联系管理员，您不具有迁移资产BOM的权限`,
"label.marketing.setting1":`市场活动营销渠道`,
"label.select.file":`选择文件`,
"message.error.object.contactadministrators":`系统异常，请联系系统管理员获取帮助。`,
"label.custom.quarter.title":`自定义季度`,
"label.knowledge.case.settings":`个案设置`,
"front-service-cloud-transfer-title":`转移资产BOM所有人`,
"label.group.search.searchthisfeed":`请输入搜索内容`,
"label.report.action.addtodashboard5":`添加到新的仪表板`,
"label.mobile.side.tab.remark2":`设置侧滑栏时，您可将最常用的项目放在靠前的位置；通话记录、菜单项仅可用于CloudCC移动端Android版本`,
"contain":`包含`,
"label.select.template":`选择模板`,
"label.addattachment.step3.weixin":`步骤 3.单击“完成”按钮，返回上一页`,
"lable.Order.successfully":`订单产品转资产成功`,
"label.user.title":`职务`,
"label.weixin.check.agreement":`请勾选相关协议`,
"label.SMS.pfi":`手机号码字段`,
"label.weixin.micro.research":`微调研`,
"label.projectManagement.assigned.work":`分配的工作`,
"label.document.login.error":`登录失败，请再次尝试重新登录。`,
"label.mobile.phone.examines.people":`批阅人`,
"label.safetyset":`安全性设置`,
"label_function_tip":`中国大陆用户暂不支持此功能，感谢您的理解！`,
"label.app.sort":`应用程序排序`,
"component.sendmail.label.cc":`抄送`,
"label.titlename":`标题`,
"label.event.moveup.3day":`提前 3 天`,
"label.condition":`条件`,
"label.description.message":`备注字数不能超过500`,
"label.ems.detailedsettings":`详细配置`,
"label.repeat.condition.field.prompt":`请在“按钮前几字符”字段处填写一个数字！`,
"label.validate.function.funcExplain.OR":`检查任何参数是否为真，并返回TRUE 或 FALSE。仅当所有参数均为假时才返回 FALSE`,
"label.salecommit.allow.prediction.query":`您没有在[设置]>[我的个人信息]>[个人信息]中勾选允许预测选项，不能查看销售承诺看板。`,
"front-kefu-moudle-soft-phone":`软电话`,
"label.view":`视图`,
"front-gantt-module-quick-create-task":`快速新建任务`,
"label.all_forms":`全部表单`,
"front-lightning-module-v1-dashborad-statistical-dimension":`统计维度`,
"label.forecast.settings.data.chanpin":`产品日期`,
"label.appointment.wizard.subtitle4-2-7":`3天`,
"front-web-module-v1-detail-comment-please":`请输入反馈意见`,
"label_chatter_nextSevenday":`未来7天`,
"homepage.components.desctiption":`此页面允许您创建或编辑在主页布局上显示的组件。`,
"label.customcomponent.page.index.table.namespace":`命名空间前缀`,
"label_emailtocloudcc_exists":`邮箱已存在`,
"label_tabpage_save":`保存`,
"label.mergeRechecking":`查重合并`,
"vue_label_helpcenter_view2":`在分屏视图下，可以快速切换查看每条数据的详细信息。<br>3、快速分析销售数据<br>    在视图右上角，可以打开视图内图表，对视图内数据进行简单可视化分析。同时可以查看视图数据相关的仪表板与报表列表，进行进一步分析。<br> 点击右上角的图表按钮，可以查看、新建、编辑利用视图数据创建的简易图表，或是查看当前视图相关的仪表板。<br>    步骤1：单击右上角图表按钮，展开页面内图表，可以根据权限查看并管理现有图表，并查看视图数据相关的仪表板列表。<br>    步骤2：点击设置按钮，可以根据权限新建、编辑、删除图表。可以创建垂直柱状图、水平柱状图、饼图与漏斗图四种样式的图表。<br> 点击报表按钮，可以查看当前视图相关的报表。<br>4、在视图中管理数据<br> 在视图内，根据您的权限，通过视图右上方的按钮，或是每条数据旁，可以对数据进行新增、编辑、删除、更改所有人等操作。<br> 利用标签来协助您的数据管理。通过右侧按钮展开标签管理列表，可以以标签为依据对视图内数据进行筛选。点击管理标签后，还可维护管理您的标签库。选中数据后使用右上角的添加标签按钮，还可批量为数据增加标签。`,
"label.app.ismobile":`应用到移动端显示`,
"chatter.group.changeTheGroupPicture":`更改小组头像`,
"label.mr.descreption.reDataList2":`条记录中共查询到满足条件的重复数据`,
"vue_label_chatter_agree_join":`同意加入`,
"label.planned.nextrun":`下次计划运行`,
"Homepage.News.003":`暂无客户数据，无法显示新闻，您创建客户之后即可在此显示客户新闻`,
"label.summaryreport.selectpictype":`选择图表类型和其它图表选项`,
"label.app":`应用程序`,
"label.trigger.name":`触发器名称`,
"vue_label_email_private_template":`私有模板`,
"label.appointmentpage.wizard.subtitle1":`请选择日期和具体时间 邀请者的时区是{0}`,
"label.partnerCloud.orderingPlatform.payment":`订单付款`,
"label.stdashbord.xsld.title":`销售漏斗`,
"vue_label_pool_poolname":`公海池名称`,
"label.ServiceCloud.fuwuyuyue.distributionMap":`服务预约分布图`,
"front-lightning-module-v1-dashborad-target-value":`目标值`,
"label.reportsSubscriptionPage.email.keywords":`输入关键字后搜索`,
"label.appointmentconfirmail.wizard.subtitle1":`事件名称`,
"label.limited_scanning":`入场券仅限于需要现场扫描登记的场景`,
"label.weixin.nomore":`没有更多了`,
"february":`二月`,
"label.view.filterbyowner":`按所有人过滤`,
"label.contentType":`文档扩展名`,
"label.customobjdel.master.hsiang":`对象中有主详关系字段，不能删除。`,
"lable.Removal.succeeded":`移除成功`,
"label.weixin.end.incorrect":`结束日期格式不正确`,
"label.email.cc.recipients":`抄送收件人`,
"label.taskevent.list":`任务事件列表`,
"label.formula":`公式`,
"label.h5.new.errorheader":`检查此页面上的错误`,
"label.emailobject.template.private":`私有`,
"label.visualpage.component.n4":`4.变量. 可以直接使用变量， 注意不要有单引号即可`,
"label.newemailnotice.step1":`步骤 1：选择对象`,
"label.chatter.file":`文件`,
"vue_label_checkduplicate_rules":`设置查重规则`,
"label.appointment.wizard.subtitle1-6":`1.5小时`,
"label.customReportType":`自定义报表数据源`,
"vue_label_email_with_accessories":`含附件`,
"label_efine_assessment_cycle":`定义考核周期`,
"label_emailtocloudcc_button_sure":`确认`,
"label.forecast.userenablepage.isusing":`已启用用户`,
"lable.goal.description":`目标描述`,
"message.error.serviceresource.relatedrecordid":`每个用户只能被添加为一条{0}类型的服务资源`,
"label.weixin.addbus.information":`添加车辆信息`,
"label.emailtocloudcc.button.view":`查看`,
"label.detail.workflow":`查看工作流`,
"label.standardfilter":`标准筛选器`,
"label.mobile.phone.results":`业绩`,
"chatter.feed.unavailabled":`未启用`,
"label.view.sortview":`视图排序`,
"label.availabilityobject.wizard.title":`空闲时间`,
"Main_Menu_Mobiledownload":`可用于`,
"chatter.sticker":`已跟踪`,
"label.workflow.intruduce":`通过创建工作流规则配置组织的工作流。每个工作流规则包括：`,
"label.customfields.richtext.tip":`允许用户输入格式化文本、添加图片和链接。`,
"label.new.cy.select":`从选项列表中选取新币种`,
"template.chart.schdzqzkhzhqk":`市场活动中潜在客户转化情况`,
"label.forecast.customforecast.cpxl":`产品系列`,
"front-electronic-signature-open-service":`开启电子签章服务`,
"label.datamanage.import.field":`导入字段`,
"chatter.email.sendMessageToMe":`发送给我一个消息时`,
"message.cannotusebefore":`记住，您不能使用此批准过程，直到它被启用为止。`,
"label.textmessage.vonage.api.secret":`API机密`,
"label_chatter_newEvent":`新建事件`,
"label.ji.year":`{a}年`,
"label.sendmail.step2":`步骤 2：选择电子邮件模板`,
"label.console.step5.record":`打开纪录`,
"label.customfields.totalsummary.gettogetherfield.isnull":`请选择要聚合的字段`,
"vue_label_commonobjects_detail_current_recorder":`新所有人也将成为与此项目相关记录的所有人，而这些记录由当前记录人所有`,
"label.SMS":`短信通知`,
"label.reconfigure.bundle":`重新配置捆绑包`,
"front-kefu-select-region":`请选择实例所在区域`,
"chatter.feed.deletefeeds":`是否确定删除该帖子及其注释?`,
"label.customsetting.manage.introduce.h":`如果自定义设置为层次结构，您可以为用户、简档添加数据。例如，您可能希望根据是否是特定用户、特定简档亦或是普通用户在运行应用程序来显示不同的值。`,
"label.product.name":`产品名称`,
"vue_label_commonobjects_view_saveas":`另存为`,
"label.group.my.archived":`我的已归档小组`,
"vue_label_pool_coflictmethods":`抵触当前销售方式`,
"label.appupload.upload":`上载`,
"lable.SalesCommitmentKanBan.signedTaskRate":`签约任务率`,
"label.dashboardStandard":`标准仪表板`,
"label.niboer.time":`尼泊尔时间`,
"label.emailtocloudcc.filed.email":`邮箱`,
"market.name.social.post":`社交帖子`,
"evaluation.detail.notfound":`评价详情未找到`,
"label.layoutoftestobj":`测试对象 布局`,
"label.example":`示例`,
"label.campaign.channel.step6.remark6":`请访问这里`,
"chatter.emailLike":`喜欢`,
"label.knowledge.category.button.two":`编辑分类`,
"label.alluser":`全部用户`,
"addadvancedconditions":`添加高级选项`,
"message.selectgsummarycondition":`请选择汇总条件`,
"message.duplication.label.sectionremar2":`注意：所有相关记录包括的任何备注、附件和活动都将与新的合并后记录相关联。`,
"vue_label_helpcenter_product&pricebook":`产品是您销售所有项目和服务及其标准价格的基础目录。价格手册可让您为特定用户创建产品及关联列表价格的自定义集合。`,
"message.duplication.label.isprofile":`是否通过权限`,
"component_setup_label_milestonesfield":`里程碑字段`,
"setup_layout_label_required":`必填`,
"component_chatter_label_title":`最新微贴`,
"label.assignment.setup.detail.order":`顺序号`,
"vue_label_pool_unassigned":`未分配`,
"UG_Lead_007":`Google同步`,
"label.knowledge.record":`不存在相关数据`,
"label_tabpage_filetypez":`文件类型`,
"label.ccpeak.if.error.message":`如果返回错误消息：使用`,
"label.intialsubmitter":`初始提交人`,
"label.wei.icon":`图标`,
"label.mask.show.last.4":`掩码显示最后4位`,
"lable.PowerProcess.time.trigger":`时间触发器(分钟)`,
"july":`七月`,
"label.usestandardwizard":`使用标准设置向导`,
"label.two.quarter":`第二季度`,
"label.size":`大小`,
"label.integrations.mailchimp.massage4":`未配置Mailchimp。请前往集成设置授权Mailchimp。`,
"label_emailtocloudcc_step2total3":`第2步，共3步`,
"vue_label_chat_customer_group_strategy":`客户群策`,
"label.searchvalue":`查找值`,
"label.sendemail.birthday.title":`生日提醒`,
"label.projectManagement.planned.days":`计划天数(天)`,
"label.service.gantt.workhours":`基于工时`,
"label.notification.approval5":`代理审批：【提交人】正在请求批准【对象】`,
"label.service.miniProgram.bindAddressDesc":`CloudCC标准客户服务门户小程序地址：`,
"chatter.error.wt":`错误: 不正确的文件类型!`,
"vue_label_calendar_my_calendar":`我的日历`,
"label.customername":`客户名称`,
"label.salescloud.salesdashboard.huikuan.rankings":`整体-销售回款业绩排行榜`,
"message.query.opportunity.contactrole.error":`查询业务机会联系人默认角色失败,请联系管理员`,
"noequal":`不等于`,
"label.document.searchcustominfo":`输入关键字查找匹配的文档`,
"label.account.PreviousFQ":`上一个会计季度`,
"label.file.f":`文件`,
"label.dashboard":`仪表板`,
"label.report.folder":`报表文件夹`,
"batch.edit.permission.list":`无编辑权限数据列表`,
"label.file.orderbyowner":`按所有人排序`,
"label.exchange.sync.account.password":`服务帐户密码：`,
"pagecreator.button.publish":`发布`,
"label.modify":`编辑`,
"label.exchange.sync4":`状态`,
"label.remark.information":`备注信息`,
"label.service.without.major.event":`没有要显示的重大事件`,
"label.knowledgebase.release.status":`发布状态`,
"label.tabpage.ok":`确定`,
"label_screening_assessment_content":`筛选考核内容`,
"label_partner":`伙伴云`,
"label.user.detail":`查看用户`,
"front-kefu-moudle-or-this":`或者，是这样吗？`,
"label.unselect.object":`可选对象`,
"label.quote.contactfax":`传真`,
"label.weixin.appmanage.alert":`按下{0}可从我的应用移除, 按下{1}可添加到我的应用`,
"vue_label_dashboard_thisfolder":`添加公用仪表板至此文件夹`,
"label.delete":`删除`,
"label.appexchange.installedpage.message1":`在 CloudCC.com AppExchange上，您可以浏览、下载应用程序直接安装到您的 CloudCC.com环境中。`,
"label.mobile.phone.required.summary":`总结为必填项`,
"label.batchadd.newbatchpage.addtr":`最多只能添加30条记录`,
"label.partnerCloud.partnerAccount.lockLine":`锁定额度`,
"label.emailsync.status.connectstatus":`关联状态`,
"label.campaignmember.main.importmember.lead":`导入成员-现有潜在客户`,
"message.username.isnull":`用户名不能为空！`,
"label.forecast.tree.enableuser":`启用用户`,
"label.multilang.view.viewmessage":`此视图已应用到移动端，字段最多选10个，现已有{0}个：`,
"friday":`星期五`,
"label.sendemail.activity.neweventtitle":`新事件通知`,
"label.page.addtabto.user":`将菜单附加到用户的现有个人自定义设置`,
"front-kefu-moudle-v1-connect-phone":`关联电话号码`,
"label.wei.pollis":`投票为`,
"lable.opppdt.editPdt.title":`编辑业务机会产品`,
"label.permission.objectpermission.recordfenpei":`记录类型分配`,
"pagecreator.layout.message.delete.success":`布局删除成功`,
"label.dataimport.isdupecatcher":`执行查重过滤器`,
"label.deletelayout.tip":`要删除页面布局，您必须选择另一个页面布局来替换它。`,
"label.projectManagement.No.matching.data":`暂无匹配数据`,
"pagecreator_page_message_delete_success":`页面删除成功`,
"label_tabpage_equalz":`等于`,
"label.ems.emailsetup":`邮件设置`,
"label.decimaldigits":`小数位数`,
"component.chatter.button.delete":`删除`,
"label.isallowreport":`是否允许报表`,
"label.view.appliedMobile.message":`勾选此项，步骤3.选择要显示的字段最多选6个`,
"label.must.positive.integer":`必须是正整数`,
"label.preview.print.template":`预览打印模板`,
"label.schedulejob.setup.schedule.start":`开始`,
"UG.Case.04":`个案分配`,
"vue_label_pool_move1":`{1}{2}`,
"label.list.userinterface.enableHoverDetails":`启用悬停详细信息`,
"vue_label_email_alltemplates":`全部模板`,
"label_report_chose_obj":`选择对象关系与报表数据源`,
"label.partnerCloud.productSet.del":`删除选项`,
"label.quote.shrdz":`收货人地址`,
"page.approval.history":`审批历史`,
"lable.outlook.detail.prefc":`首选CloudCC.com`,
"label.translation.unable.display.view":`无法显示视图`,
"label.encrypt.change":`加密字段转换`,
"button.partner.workspace.login.logo.upload":`上传图片`,
"label.batchadd.mustinput2":`的为必填项，如果必填项不填写则该记录不被保存`,
"label.dataimport.update.error.check":`更新数据发生错误，请仔细检查本条数据`,
"label.staticresource.name.already.exists":`静态资源唯一名称已经存在！`,
"label.appupload.upload.install.success":`安装成功`,
"label.conditiontag.lookup.true":`真`,
"label.quickbooks.viewlist.customer":`客户`,
"label.field.edit.change2":`最大评分至少为1`,
"label.fianalrejectoperate":`最终拒绝操作`,
"label.ccpeak.wgd":`未归档的类`,
"label.reportsSubscriptionPage.condition.emailreport":`总结 报表`,
"label.detailinf":`详情`,
"label.eastem.standard.time":`东部标准时间`,
"chatter.group.manager":`管理员`,
"label.manage_columns":`管理表头`,
"label.daylight.time":`夏令时`,
"label.weixin.mycar.information":`我的车辆信息`,
"label.ccpeak.help":`类 帮助`,
"lable.outlook.detail.match":`匹配条件`,
"label.version.nonsupport.approval":`暂不支持审批流程！`,
"label.custom-tailor":`客户定制`,
"label.showoperate":`显示操作`,
"label.view_edit":`查看并编辑`,
"label.lead.score.prompt2":`请选择需要给潜在客户打分的范围，点击【潜在客户打分】 按钮，系统将会按照当前激活的打分规则给所选择的潜在客户打分。`,
"label.datamanage.savetemplate.error":`保存模板失败！`,
"label.source":`来源`,
"label.multilang.customfieldsetup.reference":`此字段被{0}处引用：`,
"chatter.poll.option7":`选项7`,
"label.login.access.day":`天`,
"label.icon.66":`器材`,
"label.tabpage.kanbansetup":`看板设置`,
"label_emailtocloudcc_step1_lead2":`配置后，该邮箱收到的邮件均可自动生成潜在客户记录，确保不遗漏任何商机。`,
"label.partnerCloud.partnerAccount.numericValue":`充值金额必须为数字值`,
"label.permission.detail.app.object.tip":`访问对象和字段的权限以及菜单可用性的设置`,
"label.emailobject.template.subject":`主题：`,
"template.report.month.customer":`本月的客户`,
"label.weixin.formerly":`过去`,
"label.contract":`合同`,
"label.help":`帮助`,
"vue_label_homepage_setdefault":`设为默认主页`,
"label.icon.52":`发电`,
"label.customfields.file.count":`文件个数`,
"UG_Account_07":`导入客户`,
"label.addattachment.ntko":`在线编辑`,
"label.service.ganttBaiduMap.assign.service":`分配服务预约给他`,
"vue_label_file_my_file":`我的文件`,
"label.custom.page.hide":`隐藏`,
"label.addexistoperate":`添加已有的操作`,
"label.already.startdate":`已开始时间`,
"label.partnerCloud.financeSetting.alipay":`需开通企业支付宝账号，仅支持以企业对公账户作为收款账户。交易手续费由支付宝公司向收款方收取。`,
"label.dashboard.summary.editPageFooter":`编辑页脚`,
"label.category.8":`消费品`,
"label.forecast.customforecast.foretype.best":`超常发挥`,
"message.validation.isnull":`输入一个值`,
"label.savewxpay.failure":`保存微信支付商户信息失败`,
"label.file.stop.sharing.desc1":`停止于`,
"label.opportunity.setting.showstage。read.info":`勾选后业务机会阶段将不可手动编辑`,
"UG_Campaign_003":`创建市场活动`,
"label.edit.field.select.showoptions":`显示所有选项`,
"message.inputplatformpwd":`输入平台管理员密码`,
"vue_label_systemSettings_mobel_set":`移动端设置`,
"label.projectManagement.thefirstone":`已经是第一条了`,
"label.data.newtemplate":`制作数据导出模板`,
"label.monitorsys.delete.log":`系统重点操作审计日志`,
"label.template":`模板`,
"Lead.Auto.Scoring.Setting.001":`潜在客户在保存或者编辑时自动打分。 （不包括批量导入与接口创建）`,
"label.operatesuccess":`操作成功`,
"label.send":`发送`,
"chatter.yp":`隐藏微贴`,
"label.overall_responses":`整体回应情况`,
"vue_label_systemSettings_server_report":`服务报告`,
"label.icon.113":`房子`,
"label.partnerCloud.basicSetting.domainSet":`设置域名`,
"label.login.access.text":`要帮助解决支持的问题，您可以授予您的管理员作为您登录和访问您的数据权限。`,
"vue_label_report_addrowlevelformula":`添加行级公式`,
"message.duplication.label.mergeTitle":`合并我的`,
"label.event.add":`添加事件`,
"vue_label_homepage_bigscreen_light":`浅色`,
"setup.chatter.enabled":`未启用， 请联系管理员启用微贴。`,
"label.inputreceiver":`您最多可输入5个要发送通知的电子邮件地址，每个电子邮件地址之间用“;”相隔。`,
"label.custom.page.custom.page":`自定义页面`,
"label.data.exp.csv":`CSV格式`,
"label.searchlayout.view.example":`查看示例`,
"label_tabpage_fullscreenz":`全屏`,
"label.tabpage.last":`上一步`,
"lable.outlook.mcto.accepemail":`我的可接受电子邮件地址`,
"front-electronic-signature-isopen":`已开启`,
"vue_label_commonobjects_detail_earlier":`查看更早以前`,
"label.name.cannot.greater.str":`名称不能超过255个字符`,
"label.weixin.activity.email":`活动: 电子邮件`,
"label.tabpage.unequalz":`不等于`,
"label_calendar_year":`日历年度`,
"label.appupload.upload.installor":`安装者`,
"label.jixiaoswitchon":`展开绩效`,
"label.user.congratulations.send.finish":`祝贺您，已完成批量发送电子邮件申请操作。`,
"label.customsetting.touse.getListCustomSetting2":`查询“列表”类型的自定义设置数据,返回对应apiName和Name的单条数据 Map map = cs.getListCustomSetting(String apiName, String Name);`,
"label.recordtype.masterrecordtype.selectedTip":`不能将主记录类型分配给已为其分配了其它记录类型的简档`,
"label.tippage.li3":`使基于已删除报表的任何仪表板组件失效`,
"label.weixin.no.name":`无主题`,
"label.tabpage.viewz":`打印当前视图`,
"label.create_contacts":`创建联系人列表`,
"vue_label_homepage_operationitem":`请选择按钮操作项`,
"label.pc.ui.2018.switch.version":`版本切换`,
"label.salescloud.teamrole.main":`是否主要联系人`,
"label.reportsSubscription.format.report":`格式化报表 (Excel 格式 .xlsx)`,
"label.forecast.customforecast.total":`总额`,
"label.quickbooks.fieldlabel.lastname":`姓`,
"label.appointment.wizard.title2":`会议详情`,
"label.project.template.one":`从项目模板创建项目可能需要2到3分钟，请您耐心等待`,
"label.timetrigger.workflow":`该工作流已启用时`,
"label.projectManagement.creator":`创建者`,
"label.customfields.formula.selectreturnfieldtype":`请选择公式的返回字段`,
"label.list.userinterface.dashboard.enable":`启用新的仪表板组件`,
"label.email.delete.html.format":`这将删除所有HTML格式，是否确认？`,
"label.appupload.install.modifyapi":`修改冲突api名称：`,
"label.chat.add.topics":`添加主题`,
"label.savepartner.fail":`保存伙伴云设置失败`,
"label.pc.query.new":`查看您最新的`,
"message.duplication.label.editfiltertitle":`编辑查重过滤器`,
"label.task":`任务`,
"label.emailobject.emaildetail.title.toaddress":`发送给：`,
"label.setup.mobile.bottombutton.select":`选择需要显示在移动端的4个一级页面`,
"label.loginip.pagecue.invalido":`无效的Internet地址`,
"label_tabpage_listshow":`列表显示`,
"component.newrecords.label.10records":`10条记录`,
"label_chatter_file":`文件`,
"pagecreator.systemstyle.label.detailcolor":`明细文字颜色`,
"label.forecast.userenablepage.title":`预测用户`,
"front-project-module-v1-actual_working_hours":`报工工时`,
"vue_label_systemSettings_Security":`安全性控制`,
"label.processsetting.two.select.key.fields":`第二步：为进程中的每个步骤选择关键字段，并提供指导`,
"label.page.display1":`记录`,
"label.appointmentpage.wizard.subtitle1.2":`邀请者的时区是{0}`,
"label.ggReleaseRange.searchTeam":`搜索公用小组`,
"chatter.group.searchGroup":`搜索小组`,
"label_card_type":`卡片式`,
"label.appupload.managed.tip":`被受管，意味着您只能编辑某些属性。`,
"label.changemyshow":`更改我的显示`,
"label.custom.CustomQuarter":`自定义季度`,
"label.tobedelete":`将删除的`,
"label.newPage.unuse":`您的页面走丢了。`,
"label.product.pricebooks":`价格手册`,
"label.mobile.layout":`移动页面布局`,
"label.multilang.file.items":`{0}个项目：`,
"label.app.step4.tabused":`选定的菜单`,
"label_ccchat_create_account":`开通账号`,
"message.startusingprocess":`在启用此批准过程后，您就无法添加或删除批准步骤。某些批准步骤属性也将无法编辑。是否继续？`,
"vue_label_email_please_add_a_theme":`请先添加主题后再另存为模板`,
"label.please.create.a.target.record.first.":`请先创建一条目标记录。`,
"label.processsetting.set.objandfile":`第一步：选择您要设置进程的对象与字段`,
"label.newreport.group.data":`个分组`,
"label.notcreatenew":`请勿在转换时创建新业务机会.`,
"lable.custom.CurrentandPreviousCY":`当前和上一个自定义年度`,
"front-epwechat-module-v1-input-androidschema":`请输入Android schema`,
"label.projectManagement.unfinished.quantity":`未完成数量`,
"label.visualpage.idandname":`页面id和name命名为：`,
"label.approvingprojects":`待批准的项目`,
"label.partnerCloud.financeSetting.weChat":`需开通微信服务号，并与腾讯公司签约收款服务；交易手续费由腾讯公司向收款方收取。`,
"label.quickbooks.viewlist.view":`查看`,
"label.knowledge.category.hint.ten":`未启用分类组`,
"report_type_label_productPricebooks":`产品和价格手册`,
"label.fenbeitong.description":`勾选启用分贝通出差申请单，可协助员工进行出差申请及出差费用的报销`,
"label.ccchat.upload.change":`发生什么更改？（可选）`,
"label.emailsync.status.log":`关联日志`,
"label.addnew":`添加新的`,
"UG_contact_05":`创建一个联系人`,
"label.appupload.componet.queryerror":`查询组件的过程中出错，请联系管理员。`,
"label.salescloud.setting":`小组销售设置`,
"label.recurrencetimetriggeroperate":`周期性时间触发器操作`,
"label.event.moveup.4day":`提前 4 天`,
"No.Hisitory.Activity":`暂无历史活动`,
"label.validate.function.funcFormat.MINUTE":`MINUTE(date)`,
"label.recentview.seloption3":`我最近修改的`,
"label.login.access.nopermission":`--无访问权限--`,
"label.taskmenuandlink":`任务按钮和链接`,
"label.forecast.customforecast.foredis.sbw":`数百万`,
"lable.PowerProcess.created.event":`创建重大事件`,
"label.stdashbord.xsld.funnelchat":`销售漏斗图`,
"label.step1.total7":`第1步，共7步`,
"label.sendsms.batch.chosepersion":`批量发送短信：选择短信接收者`,
"Lead.Scoring.Setting.Rule.Setup.Value":`分值`,
"label.ccdocument.isdel.folder":`是否要删除该文件夹？`,
"label.discard_change":`是的，放弃更改`,
"label.knowledgebase.assign":`指派`,
"PersonalInfo_LoginHistory_001":`浏览器验证邮箱注册链接`,
"label.globalselect.deletedvlaue":`已删除全局值集`,
"label.ems.lookup2":`查找`,
"label.dataimport.system.unable.determine":`，系统无法确定丢失了哪`,
"label.weixin.invitation.consultant":`邀约顾问`,
"label.salescloud.salesdashboard.phone.rankings":`电话排行榜`,
"label.knowledgebase.plan.release":`计划发布`,
"label.integrations.first.half":`当前视图总计`,
"label.icon.123":`急救箱`,
"label.leadscore.isactivity":`是否激活`,
"front-epwechat-module-v1-corpid":`企业微信ID（Corpld）`,
"label.createnewcustomer":`创建新客户`,
"front-lightning-module-v1-details-page-chart-tittle":`可以在记录详情页中增加图表模块，插入最多10个报表图表。例如，您可以为客户对象中，记录类型为代理商的记录添加报表图表模块，将代理商订单产品销售金额统计、代理商季度销售额报表的图表添加至模块内，并使用客户名称进行筛选，在代理商客户的详情页直接查看相关数据。`,
"label.customobjects.fieldsrelation":`自定义字段和对应关系`,
"label.dashboardSetup.left":`左`,
"label.mobile.app.sectionpart":`移动端部分`,
"setup.mainpage.label.welcome25":`操作指导： 点击本页左侧菜单 → 管理设置 → 安全性控制 → 共享设置。`,
"label.custombutton.edit.error":`错误：该名称已使用或先前使用过，请选择其它名称。`,
"label.icon.48":`排风扇`,
"label.tabularreport.step2":`步骤 2：选择报表列`,
"label.reportsSubscriptionPage.schedulereport.monthly.week.two":`第二个星期`,
"UG_quota_01":`管理客户报价`,
"label.customcomponent.btn.usewhere":`用于何处?`,
"label.quickbooks.searchresault.email":`邮箱`,
"label.emailobject.appointment.urltext2":`选择一个合适的时间`,
"label.tianyancha.field.relation.error":`请先设置天眼查字段与客户字段的映射关系`,
"APPIntegration_Social_facebookerror":`必须是一个合法的facebook.com的URL`,
"label.notification.arketsea.transfer":`{5}将{0}：{1} 由{2}转移{3}`,
"lable.SalesCommitmentKanBan.allreceivingTaskRate":`总收款任务率`,
"UG.Account.04":`被动查询客户过滤`,
"this.week":`本周`,
"label.email.track.attachment.num.control1":`当前上传的文件个数超过10个，无法上传。`,
"label.exchange.sync.state.event":`事件`,
"vue_label_systemSettings_websitesetting":`网站设置`,
"vue_label_file_replace_reason":`替换原因`,
"label.version.feature":`功能`,
"E":`电子邮件`,
"label.escalation.setup.entrydetail.escalation.notifyTemplate":`通知模板`,
"label.chosesubject.meet":`会议`,
"UG.ST.003":`您没有创建{0}的权限，请联系管理员，点击确定则直接进入{0}界面。`,
"label.authorization.failure":`social用户授权失败，请重新授权`,
"label.newprocessstep3":`步骤 3 指定批准人字段和记录可编辑性属性`,
"lable.outlook.mcto.mostrecord":`带有最多活动的记录`,
"vue_label_normal_select":`选中`,
"label.partner.workspace.login.buttontext":`按钮文本`,
"template.chart.ydschdtj":`月度市场活动统计`,
"label.ServiceCloud.zichanmingcheng":`资产名称`,
"label.productsales.oppor.nooverdue":`非常棒，暂时没有逾期的业务机会`,
"label.appointment.wizard.subtitle3-5":`周五`,
"label.payment.the.current.version":`当前版本`,
"label.reportlist.top":`固定到顶部`,
"label.emailobject.emaildetail.prompt":`提示`,
"label.weixin.endst":`结束时间须晚于开始时间`,
"report_label_knowcreatehighlevelreport":`了解高级报表制作`,
"label.quickbooks.view.openestimates":`进行中的概算`,
"label.url.cannot.empty":`URL不能为空！`,
"label.emailnoticetemplate":`电子邮件通知模板`,
"calendar.tips.task":`今天没有任务`,
"label_partner_all_operate":`操作`,
"message.duplication.label.cancelbutton":`取消`,
"vue_label_SMS_addcontact":`添加联系人`,
"label.martrixreport.setsumfield2":`选择将在您的矩阵报表中用作汇总列的字段`,
"approval_request_email_body":`您好，请求您批准以下项目：\n      单击以下链接：\n`,
"label.emailobject.emaildetail.field.record":`记录`,
"label.tab.page":`页面`,
"label_tabpage_prepagez":`每页显示`,
"label.iran.daylight.time":`伊朗标准时间`,
"label.event.nextweek":`下周`,
"fliter.lastmonth":`上个月`,
"label.group.no.recent.search":`没有匹配的最近查看小组。`,
"label.h5.act.confirm":`确定`,
"label_tabpage_mypotentialcustomers":`我的潜在客户`,
"label.tabpage.queuez":`队列`,
"label.batch.edit.description":`选择要编辑的字段,至少选择一个字段,至多选择五个字段。`,
"label.batchadd.newbatchpage.deltr":`至少保留一行`,
"label.industrialandcommercialverification.instructions2":`您当前使用的免费版，接口单日查询上限1万次。如果您需要扩充查询次数，建议购买服务。购买服务后，向厂商获取token在本页面进行配置，厂商为您提供对应的付费服务。`,
"label.rejectrequestbehaviour":`执行此步骤的所有拒绝操作<strong>和</strong>所有最终拒绝操作。（最终拒绝）`,
"label.batchCopy":`批量复制`,
"label.service.two":`有些筛选条件进行了定义，但未在\"高级筛选条件\"中被引用.`,
"label.data.import.setup.detail.remark":`如果勾选下列选项后，则在数据导入时执行`,
"vue_label_file_delete_lib":`删除文件库`,
"label.integerdigit":`小数点左边的数字的位数`,
"label.profile.standardobjcontrol":`标准对象权限`,
"label.reportrecords":`条记录`,
"label.noplan":`您未来七天没有日程安排`,
"label.visualpage.ytype":`仪表板`,
"label.branch":`；`,
"label.knowledgebase.new.article":`新建文章`,
"label.Addressbook":`通讯录`,
"label.delete.reward.groups":`删除报价行组`,
"label.appexchange.uninstallpage.message1":`永久删除此软件包中的所有组件（列示如下）`,
"chatter.group.everyone":`全部用户`,
"label.cooperation":`协作`,
"label.uploadfail":`上传失败`,
"to":`到`,
"button_partner_delete":`删除`,
"attachment_select_warning_001":`勾选了归档的附件，归档按钮不可用， 请重新选择附件。`,
"label.step4.total4":`第4步，共4步`,
"label.login.access.avalid":`今天失效`,
"label.defaultview2":`默认视图`,
"vue_label_commonobjects_detail_style":`购买风格`,
"label.selectfield":`选择字段`,
"label.report.select.column.collect":`选择要汇总的列`,
"lable.currencyAdv.newdaterate.existeddate":`该时间已存在`,
"pagecreator_systemstyle_button_new":`新建样式`,
"label.ccchat.person.invite":`同事邀请`,
"label.sendemail.recycle.clear":`清空回收站操作`,
"label.usermanage.view.notexist":`视图不存在`,
"setup_chatter_enabled":`未启用， 请联系管理员启用微贴。`,
"UG.Contract.01":`管理合同`,
"label.martrixreport.2018.step4":`步骤4：选择报表标准`,
"message.errorinscript":`执行脚本出现问题！`,
"label.knowledgebase.modification.date":`修改日期`,
"label.projectManagement.the.maximum.number.of.fees.is.10":`费用最多输入10位`,
"label.list.isActiveNewApproval":`是否启用新首页批准页面`,
"label.mobile.main.page.icon.setup":`移动端桌面图标设置`,
"label.select.customer":`选择客户`,
"label.sharerule":`共享设置`,
"label.fiscal.FY":`会计年度`,
"label.appupload.component.type.customfield":`自定义字段`,
"label.emailobject.emailsend.sendindividually":`分别发送`,
"label.new_formname":`新建表单名称`,
"label.appointment.wizard.notif1":`结束时间不应早于开始时间`,
"front-console-conversation-evaluate-desc":`来自于{evaluateInfoName}的评价响应`,
"homepage.components.lasttime":`最后修改时间`,
"vue_label_commonobjects_view_chart_deletechart":`删除图表`,
"label.multilang.document.upload.fail":`成功上传了{0}个文件,失败了{1}个文件`,
"UG_contact_03":`在一个地方跟踪联系人 销售讯号`,
"label.marketsea.istoseafromother":`允许其他公海池转入`,
"label.datamanage":`数据管理`,
"label.globaloperation.operationtype.create.data":`创建记录`,
"label.customer.tab.step2.see":`菜单可视性`,
"label.wtd.changefields.desc":`用户提交表单后，将看到网站中指定的返回URL，如“十分感谢”页面。`,
"label.ems.eamilinfo":`邮箱信息`,
"label.recordtypeselect.new":`新记录类型`,
"vue_label_report_output":`公式输出类型`,
"label.emailnotice":`电子邮件通知`,
"label.icon.196":`卫生纸`,
"label.emailsync.status.disabel":`禁用`,
"label.tabpage.isdeleterecord":`是否删除已选中记录`,
"message.selectoneoftypes":`请选择以下类型之一`,
"label.import.index.createid":`创建ID`,
"vue_label_systemSettings_social2":`社交媒体账号设置`,
"label.ccpeak.sel.time":`此文件夹中的定时类`,
"label.data.downpage.i_list.desc1":`在导入的过程中，因为数据格式不正确，或者因为触发器或验证规则校验失败，而未成功导入的数据，都会生成csv文件显示在当前页面。而成功导入的数据，则不会在当前页面显示。`,
"label_adjust_forecast":`调整预测`,
"vue_label_normal_lead_sf":`潜在客户`,
"vue_label_report_notice1":`报表中包含未保存的更改，如果关闭报表，将丢失这些更改，点击下方"保存并关闭"按钮，即可保存更改。`,
"label.notfiledpublicreport":`未归档公用报表`,
"one":`一`,
"UG.Lead.008":`名片扫码`,
"label.archived":`已归档`,
"label.standardabstractfield":`标准摘要字段`,
"vue_label_notice_add_fail":`添加失败`,
"label.sendemail.registIMUser.addresserror":`邮件收件人地址错误`,
"label.ccdocument.toolbar.switch":`工具栏切换`,
"first":`第一个`,
"label.icon.147":`鼠标`,
"vue_label_jihui_er":`机会2`,
"label.ccchat.micropost.isedit":`帖子和留言修改`,
"label.department.next":`下一页`,
"front-kefu-moudle-confirm-disable-phone-user":`确定要禁用用户{0}的拨出呼叫吗？`,
"label.reportsSubscription.time.meets.subscription.frequency":`开始结束日期不满足订阅频率！`,
"lable.account.NextpDays":`未来120天`,
"UG_opportunity_007":`联系人角色`,
"label.encrypt":`加密`,
"label.knowledge.category.hint.three":`删除或替代现有的分类组即删除了所有与文章相关联的分类。`,
"label.customcomponent.usewhere.info":`以下是所有对此组件的引用。单击引用标签查看定义。`,
"vue_label_import_addandupdate":`添加并更新`,
"label.email.all.members":`通过电子邮件发送所有小组成员`,
"component_task_button_save":`保存`,
"label.file.deleted.unavailable.desc":`此文件已被删除，不存在或无法被预览`,
"label.emailsync.status.viewlog":`查看日志`,
"label.marketsea.othersetup":`其他设置`,
"label.data.exp.newtemppage":`模板制作页面`,
"vue_label_lead_score_successsful":`打分成功`,
"label.sendemail.activity.newtask":`尊敬的#belongtoidccname您好：\r\n  您的同事#createbyidccname于#createdate给您分配了一个新的任务，内容如下：\r\n  主题：#subject\r\n  到期日期：#expireDate\r\n  相关项：#relatedstr\r\n  内容：#remark\r\n  具体详情，请访问此链接：\r\n #path\r\n                        #orgNameCRM系统`,
"component.event.label.soon":`立即`,
"label.forecast.shrepage.getlist":`返回预测层级结构`,
"UG.solution.02":`解决方案是解决客户遇到的相关问题的机构内部解决方案。`,
"label.weixin.data.approval":`记录正在审批中`,
"label.build.pagelist":`页面构建器页面列表`,
"label.customsetting.type.hiberarchy":`层次结构`,
"label.forecast.ccfh":`超长发挥`,
"label.Current.Window":`现有窗口`,
"label.appointmentdetail.wizard.title20":`周日时间规划`,
"label.emailaddress":`邮件地址`,
"label.qetting_notifications":`没有收到我们的邮件? 请确保您已经将CloudCC电子邮件地址添加到您的白名单中，并允许导出通知。`,
"Homepage.News.001":`新闻`,
"label.runreport":`运行报表`,
"label.customer.tab.step3":`步骤3 添加到自定义应用程序`,
"label.dashboard.snapshot.refresh":`刷新`,
"label.approvepagelayout3":`配置布局`,
"vue_label_SMS_send_messages":`发送短信`,
"label.executestate.old":`已执行`,
"label.approvalstep3":`步骤 3 选择分配的批准人`,
"label.step3.total6":`第3步，共6步`,
"front-kefu-moudle-v1-delete-templete":`删除模板`,
"label.data.downpage.e.title.num3":`3、用户可以根据自己的需求制作导出模板，在导出数据时选择  按模板导出  ，可便捷导出操作。`,
"label.attendance.outer":`外勤`,
"setup_layout_button_selectall":`全选`,
"chatter.photo.img":`最大文件大小为2M。`,
"front-dynamiclayout-module-v1-required":`{required}字段已被设置为必填字段`,
"label.mytask":`我的任务`,
"label.edit.customerinfo":`更新公司简档`,
"label.processsetting.process.explain":`通过设置与使用进程，使用户专注于最重要的事项，在恰当的时间为用户展示关键字与小贴士，帮助用户完成流程。`,
"label.emailobject.subject":`主  题`,
"label.mobileapp.scansetting.message":`根据实际使用场景选择是否将扫描的名片以图片格式保存到记录的相关列表“备注与附件”中。<br>启用：勾选后，保存记录的同时，名片自动保存到记录的附件里。<br>禁用：勾选后，只保存记录。`,
"front-epwechat-module-v1-android-autograph":`Android应用签名：`,
"label_component_helper_potentialcustom":`今天为你分配的潜在客户`,
"label.projectManagement.nodata.week.work":`快来添加任务以便更好地完成本周的工作吧`,
"label_tabpage_rolez":`角色`,
"label.importsourcestep4":`步骤三：导入您的文件`,
"label.icon.50":`指南针`,
"lable.service.prompt":`无法创建字段，字段个数已超出限制`,
"label.campaign.channel.input.page":`指定网页，一般可设置活动主页为感谢页面`,
"UG.homepage.001":`在较少的时间赢得更多的交易`,
"label.step4.total6":`第4步，共6步`,
"label.partner.required":`错误：域名不能为空`,
"label.tag.manage.title":`管理标签-{0}`,
"label.data.downpage.i_title.num1":`1、系统只支持通用的CSV格式。`,
"label.custom.quarter.end":`自定义季度结束日期`,
"label.layout.distribute":`页面布局分配`,
"label.version.allsms":`群发短信`,
"label.tolead":`导入`,
"label.texttemplate.usemergefields":`短信模板中使用合并字段`,
"label.emailobject.sure":`确定`,
"lable_setup_mobilesetup_isenbaleh5newandedit":`移动端是否启用H5新建编辑`,
"label.tabpage.messagez":`请输入留言`,
"label.mobile.phone.write.day.report":`写日报`,
"label.data.setok.e.desc2":`导出数据列表页面`,
"label.emailsync.message":`提示`,
"label.sales.page.mubiao":`目标达成`,
"label.ccdocument.list":`查看您最新的文档`,
"label.tabpage.userGuidez":`用户指南`,
"label.report.fields":`报表可用的字段`,
"vue_label_checkduplicate_at_same_time":`同时满足全部`,
"label.sms.phone":`短信网关客服电话`,
"UG_ST_004":`您没有数据管理-》数据导入的权限，请联系管理员，点击确定后直接进入{0}界面。`,
"label.mobile.nobindmobile":`暂无此手机号信息,请先在用户信息里绑定手机号`,
"label.partnerCloud.basicSetting.intro":`CloudCC支持您为不同类型的合作伙伴创建多个站点，分别配置登录页面、可用菜单、使用权限，满足公司的各种业务需求。例如，零售商可以为地方代理商、广告合作商创建不同的站点。`,
"label.trigger.targetobject":`目标对象`,
"label.ems.emailsyncperiod":`邮箱同步时间间隔`,
"lable.Transformation.mode":`转化方式`,
"label.emailobject.new.template":`创建模板`,
"label.System.Setting":`系统设置`,
"label.emailtocloudcc.button.addemailaddress":`添加企业邮箱`,
"lable.a.total.of.invoices":`共计0个invoice`,
"label.multilang.customforcast.forecasthistory":`{0}的预测历史`,
"label.role":`角色`,
"advancedconditions":`高级筛选条件`,
"label.tabpage.beginz":`开始`,
"label.campagin.roi.khzhsl":`客户转化数量`,
"chatter.poll.option5":`选项5`,
"label.weixin.horse.club.registered":`爱马社用户注册`,
"frame_personinfo_label_resizeimage":`要调整您的缩略图，请拖放并调整简档照片上方的虚线。`,
"label.file.share.select.warning":`已对其设置过共享！`,
"label.event.this.week":`本周的事件`,
"label.data.import.object.label":`对象标签`,
"label.visualpage.folder":`未归档页面文件夹`,
"vue_label_report_saveandclose":`保存并关闭`,
"label.newdashboardpage.saveto":`保存到`,
"label.partnerCloud.financeSetting.developerIDTwo":`开发者ID`,
"lable.PowerProcess.created.ago.please":`在创建过程前，请`,
"label.chatter.myfollowers":`我的追随者`,
"label.campaignmember.main.duplicatelist.title":`市场活动成员：扫码除重设置`,
"label.group.no.recent2":`查找小组已加入`,
"label.icon.110":`书`,
"label.merge.my.account":`合并我的客户`,
"setup.layout.button.quicksave":`快速保存`,
"pagecreator.page.message.canntdelete":`当前页面不允许删除`,
"label.report.printable.view":`可打印视图`,
"ccchat_fieldtrack_fieldchange":`从 {0} 更改为 {1}`,
"label.email.bcc":`密件抄送`,
"label.sso.saml.sp.idpcert":`身份提供商证书`,
"label.step2.total2":`第2步，共2步`,
"lable.product.pricebooks.isn":`已启用的价格手册`,
"labal.emailtemplate.namemassage":`邮件模板的唯一名称已存在，请重新编辑`,
"only.one.field":`只能选择一个字段`,
"label.weixin.appr.audittime":`审批时间`,
"pagecreator.page.button.delete":`删除`,
"front-kefu-moudle-v1-Session-start-time":`会话开始时间：`,
"label_chatter_state":`状态`,
"vue_label_systemSettings_lightningcustom":`Lighting自定义UI`,
"label.searchs":`搜索`,
"label.mobile.phone.not.read":`未批阅`,
"label_chatter_allweather":`全天候`,
"label.enter.number":`请输入0到6之间的整数`,
"front-epwechat-module-v1-addressbook-desc":`开启同步后，可自动将企业微信通讯录中的人员与部门同步至CloudCC的用户与角色`,
"label.emailfield":`邮件字段`,
"pagecreator_button_next":`下一步`,
"label.more.select.merge.records":`最多只可选择三个要合并的记录`,
"lable.edit.queue.selobjct":`选择的对象`,
"label.reportsSubscription.editsubscribe":`编辑订阅`,
"label.selectfieldtoautotransmit":`选择用于自动传送批准的字段`,
"label.ccpeak.need.topass":`需要传入`,
"label.checkfield.merge":`合并`,
"front-lighting-module-v1-detail-file-downlaodInfo":`记录已锁定，不支持下载文件，请联系管理员解锁。`,
"vue.please.enter.a.chart.name":`请输入图表名称`,
"label.data.dataexptemplate.desc3":`3、导出方式只针对导出数据有效，对于导出模板无效。导出模板的文件格式是CSV格式。`,
"label.setup.mobile.homepageshortcuts.setting":`移动端主页快捷功能设置`,
"label.ems.connect.success":`邮箱检测成功`,
"label.applet.text":`通过小程序提交的报修请求单可在系统内生成个案记录，请选择用户作为个案记录的创建人，选择的用户需要对个案对象具有创建权限，更改所有人之后需要重新登录小程序后提交报修表单才能生效。`,
"label.knowledgebase.parent.window":`父窗口`,
"label_file_size":`占用空间`,
"label.allocation.department":`分配用户`,
"label.browser":`浏览器`,
"label.reportsSubscriptionPage.schedulereport.weekly.wednesday":`星期三`,
"label.integrations.description1":`导出当前视图的全部数据`,
"label.project360":`项目360`,
"label.choose_formtype":`选择您的表单类型`,
"label_emailsync_status_connectstatus":`关联状态`,
"label.bmap.beijing.city":`北京市`,
"label.mask.encryption.scheme":`加密格式`,
"label.imgfield.type":`图片类型`,
"label.person.target.responsible":`选择目标负责人`,
"label.appexchange.installedpage.installdate":`安装日期`,
"label.partnerCloud.orderingPlatform.partnerUsers":`该功能仅供合作伙伴用户使用`,
"label.profile.customfieldsafety":`自定义对象字段安全性设置`,
"label.no.target.models.available.":`无可用目标模型。请先创建目标模型，也可联系系统管理员。`,
"label.process.execute.tip":`已处理您的请求，批量审批需要一定的时间，系统在处理完成后将会发邮件告知您。`,
"label.app.step2.introduce":`填充下面的字段定义自定义应用程序。`,
"label.loginip.cue":`未指定登录Ip范围。允许来自任意Ip地址的用户登录。`,
"label.step1.select.tablayout":`步骤1：选择菜单布局`,
"mainpage.setup.chosecomponent.leastone":`至少需一个组件放在主页上。`,
"label.custom.quarter.name":`自定义季度名称`,
"chatter.ptup.link":`张贴链接`,
"label.compact.layout.frame.error2":`详细信息和相关列表必须在左屏`,
"vue_label_salesfunnel_notice7":`可能性为100%的业务机会总个数/可能性为0%或100%的业务机会总个数`,
"label.multilang.datamanage.dataimport.lostmsg":`标题的长度是&nbsp;{0}&nbsp;，但是数据的长度是&nbsp;{1}&nbsp;，系统无法确定丢失了哪&nbsp;{2}&nbsp;个字段。`,
"label.owner.notnull":`所有人不能为空`,
"label.logintime.pagecue.invalidt":`开始时间不能大于结束时间`,
"vue_label_file_checked_num_limit":`选择的文件个数超过限制`,
"front-email-payment-repayments":`重新支付`,
"template.report.today.prospects":`今天的潜在客户`,
"label.weixin.appr.status":`审批状态`,
"label.knowledge.language.japanese":`日语`,
"label.event.reminder.lead.time":`事件的提醒提前期`,
"lable.custom.dep":`单击“新建”按钮定义一个新的自定义年度`,
"Dashboard_View_Createdbyme":`我创建的仪表板`,
"label.file.upload.fail":`文件上传失败`,
"label.manager":`经理`,
"label.stdashbord.xsld.business.jine":`金额`,
"label.tag.manage.tag":`标签`,
"chatter.nlk":`不喜欢`,
"label.file.search.people":`搜索人员`,
"message.error.domain.format":`域名只能由英文和数组组成`,
"label.firstisdefault":`将第一个值作为默认值`,
"label.discount":`折扣`,
"label.mobile.phone.have.read":`已批阅`,
"label.field_selected":`该字段已选择`,
"label.payment.renew.now":`立即续费`,
"label.multilang.lookfiltercondition.notsetup":`第{0}行条件错误，未设置运算符！`,
"label.projectManagement.Selectionday":`选择日`,
"label.user.organization.permit.licensenotstart":`您的组织许可未到启用时间,请在许可启用后重试`,
"label.download.save.attachment":`下载并保存至附件`,
"lable.outlook.mcto.must":`必须是电子邮件格式`,
"vue_label_notice_unfollow_success":`取消关注成功`,
"label.taskinfo":`任务信息`,
"label.other.SMS":`其它手机号码`,
"label_partner_workspace_login_logo":`页眉徽标`,
"label.weixin.data.lock":`记录被锁定`,
"label.Yaxis":`Y 轴`,
"lable.edit.queue.selobjdes":`选择要分配给此队列的对象。随后这些对象的单个记录可以归此队列所有。`,
"label.campagin.roi.dcfezb":`到场份额占比`,
"label.marketseamemset.maximum":`最大数量`,
"label.owner":`所有人`,
"label.reportsubscribe.error.noview":`请在“以下列用户视角运行报表”中选择运行报表的视角`,
"label.icon.133":`文件夹`,
"vue_label_file_share_files":`共享文件`,
"label.searchlayoutfilterfields.remark":`选择要在菜单搜索或前台左侧栏搜索时显示的筛选条件字段`,
"vue_label_help_contract":`合同与收款计划`,
"component.chatter.button.message":`留言`,
"label.marketsea.recyclereminddays2":`天提醒（需小于获取后未跟进天数）`,
"label.webtocloudcc.input.information":`请填写该信息！`,
"vue_label_chatter_exit_group":`退出小组`,
"vue_label_lead_notcreatetask":`不创建任务`,
"front-lightning-module-v1-dashborad-date-dimension":`日期维度`,
"setup.layout.label.fieldlist":`可用字段`,
"label.leadscore.charname":`字段名`,
"label.forecast.customforecast.mybest":`我的超常发挥`,
"setup_mainpage_label_welcome24":`CloudCC 云平台提供系统内所有对象数据的安全性访问设置，可以通过设置各种规则、条件进行数据共享和访问权限的控制。`,
"label.queue":`队列`,
"label.icon.159":`芯片`,
"label.path":`要引用路径`,
"label.app.message.failtoget":`获取应用程序列表失败`,
"label.returntoprocess":`返回批准过程列表`,
"vue_label_commonobjects_detail_more_data":`没有更多数据`,
"label.number":`数字`,
"label.product.find":`查找价格手册`,
"label.legend":`图例`,
"label.partner.workspace.member.profile":`可选简档`,
"label.service.gantt.sum.appointments":`已完成的服务预约数量/所有服务预约数量`,
"label.partnerCloud.financeSetting.paymentAllowed":`允许线上支付充值`,
"label.integrations.upgrate":`升级`,
"label.timzone.tip.info3":`使用Calendar类处理日期时，应给Calendar实例设置时区，获取Calendar对象的方法可任选以下两种，Calendar cal=Calendar.getInstance(TimeUtil.getUserTimeZone(userInfo))和Calendar cal=TimeUtil.getCalendar(userInfo)`,
"label.ems.addaccount2":`添加邮箱账号`,
"label.partneruser":`合作伙伴用户`,
"label.validate.globalvariable.user.roleId":`角色ID`,
"pagecreator.layout.button.mergecell":`合并单元格`,
"label.evacuantvalue":`排除的值`,
"label.setup.mini.msg":`品牌故事/消息设置`,
"label.icon.178":`人`,
"vue_label_pricebook_notice_cantbedeleted":`价格手册条目无法删除，因为已有记录应用到该价格手册，您可以改为将价格手册条目标记为未启用。`,
"vue_label_appstore_application_recommendation":`热门应用推荐`,
"label.version.createlimit":`您当前CloudCC版本是 {0}， 允许创建 {1} 个{2}，已达到上限！如有需要，请升级CloudCC版本！`,
"message.duplication.label.sectionremar1":`请选择要在合并后的记录中保留的值。高标亮显示的行表明字段中包含冲突的数据。所选的主记录将保留只读和隐藏字段值。`,
"label.icon.1":`云`,
"label.salescloud.salesdashboard.sales.performance":`整体-销售合同业绩`,
"System_AddressFieldType_Post":`邮编`,
"setup_object_field_dependency_label_mustone":`请至少设置一个依赖字段的值`,
"label.appointmentdetail.wizard.title6":`地点`,
"label.layout.testobj2":`测试对象二`,
"label.searchlayout.dupcacher.field":`点击菜单下的查重合并链接显示的查重字段。`,
"label.attendance.persons.title":`请选择考勤适用的人员`,
"template.report.product.sales":`产品销量`,
"label.editCustomReportType":`编辑自定义报表数据源`,
"label.multilang.ui.setup.profile.alltime":`所有时间均为{0}`,
"label.service.dispatchingUnits.noservice.booking":`无服务预约`,
"label.validate.remark4":`确保数字位于某一特定的范围内，例如折扣大于30%`,
"front-kefu-moudle-v1-Waiting-time":`等待时长:`,
"label.weipagelayout.remark":`应用于微信小网页及手机版显示的布局`,
"vue_label_wang_er":`王二`,
"label.pw.text":`请为{user}输入密码，请确保包含至少`,
"message.error.user.data.null":`用户信息不能为空！`,
"chatter.like.p":`喜欢此帖子`,
"label.page.double.column.style.cloudcc":`双列样式在嵌入内容的同一个页面上提供最常用的CloudCC功能，如“搜索”和“最近项目”。`,
"label.h5.iscloseaccount":`是否确认注销`,
"label.dataimport.insertdata.id.error":`格式错误，请使用数字和字母的组合。`,
"label_tabpage_sum":`共计`,
"front-epwechat-module-v1-addressbook-sync":`通讯录同步`,
"label.setup.mobile.offlinecache.mostsave":`平台可设置默认启用的移动端离线菜单最多为10个`,
"label.weixin.quickcreate":`快速新建`,
"label.forecast.edittotal.de.mubiao":`的目标`,
"label.icon.144":`保障`,
"label.icon.155":`图片`,
"label.In.the.search":`搜索中`,
"message.validation.isnotdateISO":`输入合法日期 (ISO)`,
"label.service.appointmentList.send.successfully":`派遣成功`,
"label.dynamicpage.error.exist":`动态页面布局数据不存在`,
"vue_label_SMS_otherpeople":`等{0}人`,
"label.cloudccsite.url":`站点URL`,
"label.tabpage.contactsz":`联系人`,
"vue_label_commonobject_notice_clickthename":`如需要下载已上传文件，请点击文件名称`,
"vue_label_file_new_lib":`新建文件库`,
"label.chatter.card":`卡片`,
"chatter.feed.menutype.user.allusercom":`所有人员`,
"label.exchange.sync2":`设置`,
"template.report.year.income":`本年收入`,
"label.partner.template.detail":`功能说明`,
"label.setup.service.template":`服务报告模板`,
"label.dataimport.insertdata.id.length":`格式错误,长度小于20位，请仔细检查本条记录并修改。`,
"label.partnerCloud.financeSetting.collaborator":`合作者身份`,
"label.processskipwizard":`批准过程跳转起点向导`,
"label.weixin.inputbusnumber":`请输入车牌号`,
"label.dashboardSetup.d1":`断点1值`,
"template.report.conversions.number.industry":`潜在客户转化数（按行业统计）`,
"vue_label_chat_group_chat":`群聊`,
"label.file.publicview.error":`此文件已被删除、不存在或无法预览`,
"label.customfields.location.locationHelpText":`请输入位置名称，如“总公司”。请具描述性和特定性，而且请记住，一个记录可能有多个地址，如“西海岸销售办公室”和“东海岸销售办公室”。`,
"message.duplication.label.blankmatchtip":`设置空值是否参与匹配，默认是false`,
"message.appexchange.addtopackage":`请选择一个或多个组件以添加到此软件包！`,
"label.ems.return2query":`返回添加账号查询页面`,
"label_model_name":`模型名称`,
"label.apiname.retainapi":`name为系统保留名称，请使用其他字段Api名称！`,
"lable.Cancel.the.search":`取消搜索`,
"label.custom.viewport":`视口`,
"label.weixin.polls.type":`投票类型`,
"label.opportunity.setting.showstage.label":`自动推进`,
"label_component_helper_businesschange_expiredtask":`业务机会包含逾期任务`,
"label.operator":`运算符`,
"label.ccpeak.use.class.time.listmap":`通过传入List<Map>集合访问`,
"component_timeline_label_past":`过去活动`,
"label.mobile.phone.submit":`我提交的报告`,
"message.recordtype.new.subtip":`为新记录类型输入名称和备注。新记录类型将包括以下所选现有记录类型中的全部选项列表值。保存新记录类型后，您将可以自定义选项列表值。`,
"UG_product_05":`导入产品`,
"label.validate.globalvariable.user.id":`用户 ID`,
"label.umeng.activity.distribute":`您分配给`,
"label.weixin.avote":`发起投票`,
"label.weixin.already.sign":`已签到过`,
"label.emailmerge.mergepage.generator":`生成`,
"label.batchtransfer.transferto":`转移到`,
"label.tianyancha.industry":`行业`,
"label.addattachment.name":`文件名`,
"label.customfields.formula.date.tip":`计算日期，例如，通过在其它日期上加上或减去一定的天数`,
"label.partnerCloud.orderingPlatform.noPayment":`暂不付款`,
"label.emailobject.failedtosend":`发送失败`,
"label.knowledge.setting.data.three":`最多{count}条数据分类组数据`,
"label.weixin.input.maxlength.langtext":`请在此输入，最多可输入32000字符`,
"vue_label_calendar_delete_calendar":`删除日历`,
"vue_label_commonobjects_detail_filter":`收起筛选器`,
"setup.layout.group.custompage":`自定义页面`,
"component_sendmail_label_subject":`主题`,
"label_tabpage_maxfilez":`文件最大为`,
"label.logintime.pagecue":`选择具有此简档的用户可以登录的日期和时间。请注意，所有时间都采用指定时区的确切时间。即使用户在不同时区，登录时间也会采用这些确切时间。`,
"label.salescloud.salesdashboard.datetime":`预计签约时间`,
"label.format":`格式`,
"label.newfoundland.daylight.time":`纽芬兰夏令时`,
"front-kefu-moudle-v1-messagetemplate.finishdetailinfo":`将合并字段值复制并粘贴到短信正文`,
"message.chooseatleastoneforshare":`请至少选择一个共享用户`,
"label.multilang.datamanage.importobjfield":`第 {0} 列`,
"label.denglu":`登录`,
"label.popup.infoz":`提示`,
"label.schedulejob.setup.schedule.onday":`在每月`,
"label.appointmentdetail.wizard.title16":`周三时间规划`,
"label.userphoto.dragtoadjust":`拖动并调整大小以调整缩略图`,
"label.product.series":`产品系列`,
"message.view.kanban.not.set.group.summary.field":`视图看板未设置分组汇总字段`,
"page.un.activities":`未处理活动`,
"label.exchange.sync3":`配置`,
"label.login.activityExpired":`用户活跃度已过期，请联系系统管理员。`,
"component_chatter_file_button_files":`选择文件`,
"message.onlydelete.type":`只能删除不活动的记录类型。禁用记录类型以允许删除。`,
"message.recordtype.selectlayouttouse":`选择要使用的页面布局`,
"label.knowledgebase.unable.restore.draft":`您无法恢复已删除的草稿。`,
"label.shangqing.name":`商情`,
"label.weixin.target.payment":`目标回款`,
"label.chatter.sendEmailToGroupMember.check":`查看帖子`,
"front-kefu-moudle-v1-input-single-login-area":`请输入单点登录域名`,
"vue_label_zhang_yi":`张一`,
"label.icon.190":`吹风机`,
"label.quickbooks.fieldlabel.company":`客户名称`,
"vue_label_email_are_you_sure_to_delete":`是否确认删除邮件`,
"Pagelayout.Setup.005":`名称必须放在第一个位置`,
"label.object.name.two":`对象名2`,
"label.tabpage.completez":`将选中 状态标记为完成`,
"label.setup.mobile.bottombutton.saveerror":`移动端一级页面设置保存失败`,
"label.report.action.addtodashboard8":`选择仪表板文件夹`,
"label.data.downpage.i_list.desc3":`用户下载后，可以在文件最后一列查看导入失败的具体原因。`,
"label.layout":`布局`,
"label.marketsea.button.assign":`分配`,
"UG.solution.03":`创建解决方案`,
"label.ccchat.person.invited":`邀请同事`,
"label.ccchat.person.invite.address":`收件人`,
"label.displaytype1":`详细信息页面链接`,
"label.tianyancha.h5.ziranrengudong":`自然人股东`,
"lable.SalesCommitmentKanBan.targetReceipts":`目标收款额`,
"message.error.getitems.type":`getItems:type不能为空`,
"label.addattachment.list":`已上传下列文件`,
"label.datamanage.export.false":`导出时出现错误`,
"pagecreator.systemstyle.label.buttonfontcolor":`按钮文字`,
"label.emailtocloudcc.redmessage1":`请输入正确的电子邮箱地址`,
"label.weixin.polls.closed":`投票已截止,截止时间`,
"label.icon.165":`帽子`,
"vue_label_report_detailsonly":`仅限详细信息`,
"component.salesperformance.label.100finish":`已结束`,
"november":`十一月`,
"label.data.file.generatejwd":`执行根据地址生成经纬度服务`,
"label.salescloud.opportunity.access":`业务机会访问权限`,
"label.isremider.remider":`提醒`,
"vue_label_total":`总量`,
"label.email.prompt.using.lightning.link":`系统通知中的邮件链接使用lightning版本的链接`,
"label.knowledgebase.cancel.attached.articles":`取消附加文章`,
"label.version.custom.xslc":`可自定义销售流程`,
"component_setup_button_save":`保存`,
"label.ems.cc":`添加抄送`,
"label.edit.user":`更新用户`,
"label.emailtocloudcc.select2":`请选择类型`,
"label.industrialandcommercialverification.fieldnumber":`映射字段：4个`,
"label.ccchat.havenot.joined.group":`您没有加入任何活动小组`,
"pagecreator_page_label_pagename":`页面名称`,
"setup.layout.button.save":`保存`,
"label.campaignmember.main.updatestatus":`批量更新市场活动成员状态`,
"label.tab.web.edit":`编辑 Web 菜单`,
"label.ring_chart":`环形图`,
"label.usermanage.resetpwd.error":`重置密码失败，不存在的用户`,
"label.Xaxisscope":`X轴范围`,
"label.app.new":`新建应用程序`,
"message.modifythereport":`仪表板使用此报表。如修改可能会导致引用此报表的仪表板失效。`,
"label.component.helper.businesschange.0activity":`30天内没有任何活动`,
"label.weixin.fmu.noon":`中午{0}`,
"label.enter.rule.name":`输入规则名称`,
"lable.Confirm.recovery.potential.customers":`确认恢复潜在客户{name}`,
"lable.PowerProcess.type.created":`您想要创建什么类型的权利过程？`,
"front-lightning-module-v1-dashbord-rectangle-size":`矩形大小`,
"label.projectManagement.new.service.appointment":`新增服务预约`,
"label.multilang.totalpage2":`共`,
"pagecreator.systemstyle.label.styledesc":`样式描述`,
"chatter.up":`上载中`,
"2018UI_Homepage_DataDeleted_Info":`数据已经删除，点击返回上一步。`,
"label.knowledge.draft.recordid":`草稿id不能为空`,
"vue_label_pool_recyclecertification":`{0}{1}{2}{3}？`,
"label.setting.intergrationlist.viewall":`查看所有集成`,
"vue_label_file_num_limit_tip":`文件个数超出预设，如果需要替换文件，请先删除已上传的文件`,
"vue_label_commonobjects_view_refreshat":`已在{timeInterval}前刷新`,
"laebe.data.exp.save.success":`如果需要用此模板导出数据，请您返回到按模板导出按钮进行操作。`,
"label.mr.caption.contact":`查重合并：查询联系人重复数据的条件`,
"label.webtocloudcc.submit.error":`提交失败`,
"label.multilang.datadelete.delmessage":`已锁定记录（{0}条）不允许删除：`,
"label.quickbooks.searchlist.total2":`搜索到有{0}个尚未关联的付款记录，共计金额为{1}`,
"label.createnew":`新建...`,
"component.milestones.label.choicestate":`确认此状态`,
"lable.outlook.edit.exist":`字段名已存在，请输入唯一字段名。`,
"vue_label_dashboard_eachother":`来自同一张报表或同一对象的视图可互相联动`,
"label.new.role":`新建角色`,
"message.error.operationType":`调用服务时发现操作符未定义;`,
"label.fenbeitong.name":`分贝通`,
"label.choose.person":`请选择需要发送的人员`,
"label.attendance.thanks":`感谢您的参与！`,
"label.invoice.message.statusupdatefailed":`Invoice状态更新失败,请稍后重试`,
"template.chart.yzhqzkhlyfx":`已转化潜在客户来源分析`,
"chatter.feed.menutype.user.alluser":`所有人员`,
"UG_Forcast_04":`开始试用`,
"label.appupload.upload.tips.profile":`注意：此软件包中已添加“简档”组件，无法再次添加(一个软件包中最多只允许添加一个简档组件)。`,
"lable.PowerProcess.leave.the.process":`{describeName}退出过程`,
"template.report.sales.cycle.opportunities":`销售周期持续时间（按业务机会类型统计）`,
"vue_label_calendar_please_fill_in_the_calendar":`请填写日历名称`,
"label.salescloud.unit.wanyuan":`单位（元）`,
"label.fileAPI":`文档唯一名称`,
"label.weixin.link":`关联`,
"label.service.seconds":`秒`,
"label.encd.visible":`加密字段值可见`,
"label.tianyancha.regstatus":`经营状态`,
"label.event.moveup.18hour":`提前 18 小时`,
"label.upper.bound":`上界`,
"label.please.insertURL":`请输入要插入的URL`,
"label.approval.notallowed.reject":`不允许拒绝`,
"label.permission.fieldpermission":`字段权限设置`,
"label.customcomponent.page.index.title":`自定义组件`,
"label.quickbooks.viewlist.number":`编号`,
"lable.list.queue.sendemail":`向成员发送电子邮件`,
"label.productsales.today.noevtadd":`今天没有未处理的事件，您也可以点击右上角的“ ”添加事件！`,
"label.report.line.daixuan":`待选报表列`,
"label.reportsSubscription.select.start.endtime":`请选择开始时间结束时间！`,
"template.chart.schdyscb":`市场活动预算成本`,
"label.sendemail.chat.addPostatsubject":`CloudCC CCChat微贴里提及我`,
"label.RelatedList":`相关列表`,
"label.knowledgebase.delete.translation.associated.with.draft":`现有草稿翻译将链接到主语言文章的上一个发布版本。如果没有发布版本，将删除任何译稿。`,
"vue_label_chatter_submitted_review":`您已经提交加入申请，请等待管理员审核`,
"label.layout.list2":`列表二`,
"label.manage.area":`管理区域`,
"label.manageapproveprocess":`管理批准过程`,
"workflow.action.tasks.assignortype.created":`创建人`,
"label.custombutton.nonsupport.operation":`当前版本不支持操作标准按钮和链接`,
"label.ip":`IP地址`,
"label.chat.topic.desc.error.info":`主题描述不能超过1000个字符。尝试使用更短的主题说明。`,
"label_tabpage_cue":`信息提示`,
"label.integrations.mailchimp1":`集成授权后组织内的成员可以将潜在客户和联系人导入至Mailchimp`,
"label.email.track.required":`必填信息`,
"label.set.case":`请先设置个案所有人`,
"label.weixin.newspaper.coverage.number":`报险单编号`,
"vue_label_approve_submitreason":`提交原因`,
"message.oppdt.noenabledpricebook":`没有启用的价格手册!`,
"label.partner.workspace.setup":`设置`,
"label.version.nonsupport.feature":`暂不支持此功能！如有需要，请升级CloudCC版本！`,
"com.cloudcc.login.error.message.licenseexpired":`许可已过期`,
"label.emailsync.form.signin":`登录`,
"label.campaign.channel.input.to.chooselanguage":`请选择语言`,
"label.tabpage.gotit":`知道了`,
"front-console-no-contact-tip":`暂无数据，请先关联联系人后查看`,
"label.approval.apiname":`API和受管软件包使用的唯一名称。名称必须以字母开首，仅使用字母数字字符和下划线。名称不能以下划线结尾或有两条连续的下划线`,
"label_emailtocloudcc_filed_ssl":`安全连接`,
"component_sendmail_label_fromuser":`发件人`,
"front-kefu-moudle-v1-new-online-chats":`新建在线坐席`,
"label.searchlayout.merge.duplicated.results":`是否启用查重合并`,
"label.weixin.input.maxlength.remark":`请在此输入，最多可输入500字符`,
"component.telerecord.label.related":`相关项`,
"label.note":`注释`,
"message.duplication.label.nletters":`个字符`,
"label.productsales.payment.phb":`回款排行榜`,
"label.forecast.editshrepage.desc":`Forecast:指定此记录的共享。您可与单个用户、特定角色的用户或者特定角色下方角色的所有用户共享此记录及相关数据。`,
"vue.dashboard.setPenetrationSuccessful":`设置穿透成功！`,
"label.tabpage.noOperationz":`此内容为固定项，不可操作！`,
"label.email.jump":`跳转至第三方链接 ···`,
"label.appointmentpage.wizard.btn1":`确认预定`,
"label.umeng.approval.pass":`#approver已通过#obj申请`,
"label.project.hit.twelve":`里程碑到期提醒`,
"two":`二`,
"label.approvedinfo":`批准信息`,
"label.import.step1.choosecsv":`请选择csv文件`,
"vue.please.select.the.expansion.method":`请选择展开方式`,
"UG.homepage.005":`销售智能`,
"Account.News.Setting.003":`一般设置`,
"label.quickbooks.button.actions":`操作`,
"lable.list.queue.email":`队列电子邮件`,
"label.name.lastname":`姓`,
"message.confirm":`您确定吗？`,
"Opportunity.Detailed.Phase.Label.Popup.002":`离开日期`,
"label.knowledge.setting.title":`知识库设置`,
"label.helptocreateprocess":`的有效和无效批准过程。要创建一个批准过程，单击创建新的批准过程"，然后选择"使用跳转起点向导"仅几个步骤就可以设置您的批准过程。或者，选择"使用标准向导"配置所有批准选项。"`,
"label.batcheditor.remark":`可以对多条记录进行编辑`,
"label.page":`页`,
"label.newfolder":`创建新文件夹`,
"label.version.interceptor.api":`接口API`,
"label.sms.toaddress":`收到一封短信`,
"front-kefu-moudle-noopen-callcenter":`组织尚未开通呼叫中心功能，请联系管理员开通`,
"label.data.exp.zip":`压缩格式`,
"lable.account.LastcDays":`过去60天`,
"label.import.index.starttime":`开始时间`,
"label.dashboardall":`所有仪表板`,
"label.create_socialpost":`创建社交帖子`,
"label.searchlayoutedit.remark":`选择当点击前台左侧栏搜索或菜单搜索时，查询显示的字段及按钮`,
"message.servicecrew.violation":`资源分配违规:服务资源在此时段为服务班组成员`,
"label.email.attrach.file":`附加文件`,
"report.label.folderandreport":`报表和文件夹`,
"label.list.userinterface.sales.setup":`系统销售主页设置`,
"label.martrixreport.2018.step1":`步骤1：选择用于计算汇总信息的分组方式`,
"label.campaignmember.selectmember.memberstatus":`市场活动成员状态`,
"label.textmessage.vonage.api.key":`API密钥`,
"label.tabpage.next":`下一步`,
"UG_Lead_006":`网站访客`,
"label.salescloud.salesdashboard.visit.rankings":`拜访排行榜`,
"label.myevent":`我的事件`,
"label.activity.history":`历史`,
"label_tabpage_kanban":`看板设置`,
"label.weixin.allapp":`全部应用`,
"label.query.clone.detail.choose.choosed":`已选明细对象`,
"message.error.view.errvalid":`错误： 视图唯一名称字段只能包含下划线和字母数字字符。 它必须是唯一的，以字母开头，不包括空格，不得以下划线结尾，且不得包含两个连续下划线`,
"label.customfields.searchrelation.dependobject.tip":`选择此对象相关的另一个对象`,
"label.appointment.wizard.subtitle4-4-3":`三周`,
"label.setup.mobile.offlinecache.saveerror":`移动端离线缓存设置保存失败`,
"label.planned.started":`已开始`,
"label.page.step4.of.step5":`第4步，共5步`,
"label.tabpage.value":`值`,
"label.reportlist.allfolder":`全部文件夹`,
"label.callcenter.sure.disable.center":`确定要禁用当前呼叫中心吗？`,
"vue_label_commonobjects_detail_activity_tocalendar":`去日历`,
"label.setup.mobile.bottombutton.recovery.default":`恢复默认
`,
"label.appointmentdetail.wizard.title15":`周二时间规划`,
"label.icon.15":`维修单`,
"component_sendmail_label_touser":`收件人`,
"template.report.all.owner":`潜在客户所有人`,
"front-Partner-email-tips":`用户名请输入邮箱`,
"vue_label_systemSettings_mobelhomepagesetting":`移动端主页设置`,
"label.service.newBuildDialog.aswellas":`以及`,
"label.name":`名称`,
"label.tag.search.taglist":`标签列表`,
"label.partnerCloud.priceOfManual.theOnly":`建议为每个合作伙伴客户设置唯一的价格手册。若设置了多个价格手册，伙伴下单时需选择本单使用的价格手册。若未设置手册，会使用标准价格手册。`,
"label.knowledge.field.update":`已更改{1}从{2}到{3}`,
"label.emailobject.save":`保存`,
"label.top.changeVersion":`横向菜单`,
"label.recordtype.edit.unselected":`可用值`,
"label.knowledgebase.additional.articles":`附加文章`,
"label.lead.score.confirm":`请选择需要给潜在客户打分的范围，点击【潜在客户打分】 按钮，系统将会按照当前激活的打分规则给所选择的潜在客户打分，<br><br>打分过程可能需要花费较长的时间，一旦打分完成，您会收到一份确认邮件。<br><br>`,
"label.projectManagement.pleaseselectadate":`请选择日期`,
"label.appointment.wizard.subtitle5":`会议名称`,
"label_setup_failed":`设置失败`,
"label.chatter.collect":`收藏`,
"label.appointment.cancelappointment":`取消预约`,
"front-console-response":`响应时间`,
"message.delete":`确定要删除吗?`,
"label.dataimport.type.selected":`请选择导入类型`,
"label.new.target":`新建目标`,
"vue_label_report_autoupdatepreview":`自动更新预览`,
"label.knowledgebase.guidance":`指导`,
"label.chatter.mail":`邮件`,
"label.login.verification.scan.code.acquisition":`扫码获取：`,
"label.customsetting.changefieldtype":`更改字段类型`,
"label.data.dataexpalltype.all_desc2":`2、导出全部的数据较多，需要一定的时间。导出完成后，系统将为您发送一封导出成功的邮件。`,
"label.opportunity.contactisnull":`客户信息为空，无法显示`,
"pagecreator_layout_button_upload":`上传布局`,
"label.dashboard.noRecord":`暂无记录`,
"label.SMS.template":`短信模板名`,
"label.c.d.without":`C" 记录可能有或没有相关 "D" 记录。"`,
"UG.Case.05":`创建个案`,
"front-epwechat-module-v1-edit-selfapp":`编辑自建应用`,
"label.role.createrole.tip":`您可以依照显示在本页上的现有角色层次结构继续建构。 要插入新角色，单击<b>添加角色</b>。`,
"label.grouping":`分组`,
"vue_label_email_upload_new_file":`上传新文件`,
"label.notification.event3":`您的事件即将在【开始时间】开始`,
"labe_benchmark_objects":`基准对象`,
"component.chatter.button.collect":`收藏`,
"front-QBtoCC-sinchronies":`同步中……`,
"message.submitpage.sms":`祝贺您！短信发送请求成功！`,
"label.imgfield.width":`宽度`,
"label.send_email":`发送提交邮件通知给`,
"label.queue.list":`队列列表`,
"label.tabpage.fieldoptions":`记录类型字段，选项列表字段和选项列表（多选）字段，建议最多输入10个关键字，用英文逗号隔开实现或关系，如：“北京,上海,广州”。`,
"component.chatter.post.button.save":`发表`,
"chatter.group.groupDescriptionInformation":`组描述信息`,
"label_setup_mobilesetup_isenableh5newandedit":`移动端是否启用H5新建编辑`,
"lable.Confirm.recallpotential.customers":`确认回收{num}个潜在客户`,
"label.knowledge.setting.hint.seven":`从以下名称中选择并授予写入权限，以贡献自己的微薄之力。`,
"label.emailtocloudcc.redmessage2":`请输入正确的邮箱密码`,
"message.validation.equalTo":`入相同的值`,
"vue_label_help_golbal":`全局导航`,
"vue_label_chatter_delete_group_title":`删除小组`,
"label.user.login.success":`登录成功。`,
"label.chatham.standard.time":`查萨姆夏令时`,
"label.vlidaterule.example.percent":`折扣百分比不能超过30%`,
"label.group.field":`指定分组字段`,
"label.trigger.operation.sharetab":`触发器操作共享表：`,
"label.mobile.phone.write.month.report":`写月报`,
"label.statusofconvers":`已转换状态`,
"label.version.emailtemplate.track":`电子邮件模板`,
"label.customobjects.onlytrackforupdate":`仅跟踪更改`,
"label_tabpage_enterviewname":`第一步：请输入视图名称`,
"label.processsetting.three.enable":`第三步：启用`,
"label.service.show.more.info":`显示更多信息`,
"front-epwechat-module-v1-input-iosschema":`请输入iOS schema`,
"label.dataimport.datatype.error":`数据类型错误，请仔细检查数据和标题是否一一对应`,
"label.staticresource":`静态资源`,
"label.weixin.customize":`个性化`,
"label.product.edit.sel":`编辑所选`,
"label.appointmentpage.wizard.notif5":`无效手机号码格式`,
"label.marketsea.basicsetup":`基础设置`,
"label.workflow.supplyintruduce":`1.引发应用工作流规则的条件<br/>2.当某个记录同条件相匹配时执行的即时操作。例如，在创建了新业务机会后，CloudCC可以自动向客户小组发送电子邮件进行通知<br/>3.依赖于时间的操作在记录同条件相匹配时会排成队列，然后根据时间触发器执行`,
"label_report_line_tuozhuai":`请拖拽或双击鼠标选择报表列并调整列顺序`,
"label.add.new.rule":`新增生成规则`,
"label.marketing.setting2":`渠道设置`,
"vue_label_chatter_delete_some_group":`确定要删除小组"{groupInfoList}"吗`,
"label.appupload.uploading.wait":`请稍等`,
"label.linecondition.error":`行条件错误，字段类型不匹配！`,
"chatter.group.request":`请求`,
"label.recordtype.tabname.remark":`使用此页面创建并维护贵组织的记录类型。可根据记录类型显示不同的页面布局和选项列表值。要使用记录类型，请将“记录类型”字段添加到页面布局上`,
"setup_mainpage_label_welcome4":`操作指导： 点击本页左侧菜单 → 应用程序设置 → 创建 → 对象。`,
"vue_label_salesadvance":`销售阶段推进`,
"vue_label_campaign_of_existing_campaign_members":`请设置现有市场活动成员状态`,
"label.report.object.detail.no.permission":`报表类型变更或已被移动，请联系系统管理员。`,
"label.weixin.untreated":`未处理`,
"label.service.miniProgram.bindSetOwnerDesc":`小程序端提交的报修单可在系统内生成个案记录，请选择用户作为个案记录的创建人，此用户必须对个案对象具有创建权限，更改创建人之后需要重新登录小程序后提交报修表单才能生效。`,
"label.autoassigntoapprover":`自动分配至批准人。`,
"label.marketseamemset.containself":`包含自建记录`,
"vue_label_report_drill":`钻取`,
"label.order.products.to.assets":`订单产品转资产`,
"label.recordtype.list":`现有记录类型`,
"lable.outlook.detail.conflict":`冲突行为`,
"pagecreator.page.label.layoutpreview":`布局预览`,
"front-kefu-moudle-v1-zxltyhxzc-buyuser":`坐席聊天由环信支持，请先购买环信账号`,
"label.convers":`转化`,
"serviceappointment.worktype.isnot.father.worktype":`此服务预约必须选择其父级记录关联的工作类型`,
"lable.tianyancha.h5.relatedcom":`相关公司`,
"label.reportsSubscriptionPage.schedulereport":`安排报表时间`,
"label.workbanch.setup.showinworkbanch":`是否在我的工作台中显示`,
"label_emailsync_connectaccount":`关联邮箱账号`,
"label.usermanage.license.not.qualified":`系统监测到您的系统许可证不合规，请联系厂商重新获取许可授权！`,
"component_setup_label_displayfield":`显示字段`,
"setup_layout_label_buttonarea":`按钮区域`,
"label.weixin.input.content":`请输入内容`,
"label.operatedata.importsuc":`导入成功，请打开对象查看导入的情况`,
"label_tabpage_yes1z":`是1`,
"front-electronic-signature-describe":`接入电子签章服务，随时随地在线签约。一键签署，安全高效！`,
"label.event.this.month":`本月的事件`,
"label.document.replaces":`替换`,
"label.email.cc":`抄送`,
"chatter.feed.sticker":`微贴跟踪`,
"vue_label_commonobjects_view_chart_notice_pleaseaddchart":`请添加图表`,
"label.cpq.main.quote.transfer.order":`只有主报价单才可以生成订单`,
"label.partnerCloud.partnerAccount.topUpSuccess":`充值成功`,
"label.appexchange.uninstallpage.uninstall":`卸载`,
"label.campagin.roi.channel":`营销渠道`,
"label.multilang.versioncontrol.checkversion":`您当前CloudCC版本是{0}允许创建{1}个{2}，已达到上限！如有需要，请升级CloudCC版本！`,
"label.emailobject.my.template":`仅显示我的模板`,
"label.edittimetrigger":`编辑时间触发器`,
"label.setup.mobile.homepageshortcuts.saveerror":`移动端主页快捷功能设置保存失败`,
"label.address.street":`详细地址`,
"label.workflow.estimatecondition2":`仅当创建记录时`,
"label.wei.expiresdate":`截至时间`,
"label.quickbooks.viewlist.date":`日期`,
"label.page.select.field.type":`选择字段类型`,
"label.tabpage.mypotentialcustomers":`我的潜在客户`,
"label.file.library.editlib":`编辑文档库详细信息`,
"label.weixin.message.operateexception":`信息提示`,
"label.visualpage.staticresource.p1":`1.调用方式.  通过引入静态资源按钮引入选择的静态资源`,
"label.icon.175":`机票`,
"chatter.edit.r":`编写回复...`,
"label.examinationandapproval.flow":`审批流`,
"label.mr.descreption.reDataList5":`组数据。`,
"label.edit.field.select.showstyle":`显示样式`,
"label.reportsSubscriptionPage.condition.and":`并且`,
"label.please.associations":`请选择关联对象`,
"label.service.dispatchingUnits.displays.service.appointments":`显示未与区域关联的服务预约`,
"label.addcurrent":`添加现有`,
"label.search.change":`可搜索对象设置`,
"message.schedulejob.error.modify":`基于配置的时间表,给定的作业将永远不会触发,请检查数据后重新提交。`,
"label.chatter.sendEmailToGroupMember.subject.L":`{0}在小组{1}发布了全员链接`,
"label.weixin.micro.oldid":`微信公众号原始ID`,
"label.employees.only.invitation.code":`系统将为员工生成唯一邀约码，员工可使用此码进行邀约，并可计入个人绩效。请注意，潜在客户所有人将是当前市场活动所有人或者营销渠道邀约人。您可以通过潜在客户分配规则进行重新分配，关于分配规则`,
"lable.PowerProcess.event.msg":`您可以在权利过程中添加每个步骤（重大事件）都会发生的依赖于时间的工作流操作。例如，您可以设置操作，以在重大事件过期前一小时向个案所有人发送电子邮件，或者在首次回复重大事件完成时对自动更新特定个案字段`,
"label.file.share.email.content2":`共享信息：共享给您当前文件的#sharerole权限`,
"label.querydetailservice.datalayout.notexist":`记录对应的布局不存在`,
"label.group.items":`分组项目`,
"label.istouse":`是否可供使用`,
"front-electronic-signature-explain":`法大大电子签章服务说明：`,
"label.partner.template.thumbnail":`缩略图`,
"registration.page.selected.fields":`注册页面必选字段选择`,
"label.reportTypeCategoryLabel":`数据源`,
"vue_label_email_You_have_not_activated_the_mailbox":`您还未启用邮箱`,
"lable.SalesCommitmentKanBan.taskCompletionRate":`任务完成比例`,
"label.forecast.detailforecast.program":`预测项目`,
"label.page.display":`每页显示`,
"label.passwordPolicy.setup.minute":`分钟`,
"label.emailtocloudcc.step1total3":`第1步，共3步`,
"label.file.title":`标题`,
"label.callcenter.private.key":`私有访问秘钥`,
"com.cloudcc.login.error.message.loginerror":`用户名或密码错误`,
"UG_Lead_004":`Web表单`,
"label_tabpage_recordsz":`记录`,
"label.shangqing.discovery":`商情发现`,
"vue_label_notice_change_success":`更改成功`,
"label.ems.other":`其他`,
"loading":`数据加载中`,
"label.committedtoapprove":`已经提交的批准请求`,
"label.category.4":`金融`,
"template.report.folder.customer.situation":`客户情况分析`,
"label.quickbooks.searchresault.phone":`电话`,
"label.ccpeak.ccobj.save":`要将CCobject保存到数据库，调用方法`,
"label.knowledge.delete.linked":`删除关联文章出错`,
"label.forecast.settings.future2":`未来2个周期`,
"message.error.displaytype.detail":`显示类型不能为空，日：day，月：month，星期：week，可用性：availability！`,
"front-template-V1-search-template-name":`输入对象名，快速搜索`,
"label.sendsms.batch.step3.introduce":`存储每条短信的活动`,
"UG.Forcast.08":`上一步`,
"label.inputnameandintro":`输入名称和说明`,
"label.redistributioned":`已重新分配`,
"label.service.dispatchingUnits.left.right.total":`当前{left}-{right}条数据，共{totalCount}条数据`,
"label.projectManagement.Pleaseentertheactualworkinghours":`请输入实际工作时长`,
"label.exporttemplate":`导出模板`,
"label.data.downpage":`数据下载页面`,
"message.please.choose.contact":`请选择联系人`,
"message.error.dataformat.error":`数据格式错误`,
"label.customsetting.changefieldtype.losevalue":`更改为所选数据类型将会丢失该字段中的所有现有数据。`,
"label.sendemail.chat.chattype":`主贴类型：`,
"label.ccdocument.upload.error":`上载文档出错了！`,
"label.quickbooks.view.all":`全部`,
"label.data.downpage.e_title":`导出数据的步骤:`,
"lable.data.lock":`数据已锁定，操作请先解锁。`,
"label.locked":`已锁定`,
"label.customfields.beforedeletedata":`在删除该自定义字段之前，建议通过单击设置"|"数据管理"|"`,
"label.productsales.oppor.noapproach":`暂无预计签约日期<30 天的业务机会`,
"label.input.notmore.than.number":`请输入一个小于或等于 {0} 的数字`,
"label.list.userinterface.isenable":`启用内联编辑`,
"label.listofshare":`共享信息列表`,
"label.emailsync.status.role":`角色`,
"label.staticresource.useful.realtion":`使用此静态资源的位置`,
"label.sharerule.tip":`此页显示贵组织的共享设置。这些设置指定每个用户对于其他每个人的数据所拥有的访问权限级别。`,
"label.qrcodelogin.message.expired":`二维码已失效`,
"label.marketing.setting3":`市场活动营销渠道设置`,
"vue_label_statistical_field":`统计字段`,
"message.view.addtomyhomepage":`添加到首页工作台`,
"label.customfields.percent.tip":`允许用户输入百分比数字（例如，10"），并自动向数字添加百分号。"`,
"component_newrecords_label_10records":`10条记录`,
"Lead_Scoring_Warning_001":`针对单个潜在客户系统可在新建，编辑潜在客户时自动打分，但针对批量导入或者通过接口创建的潜在客户需使用批量打分手工进行。`,
"label.project.planing":`本年度派工工时VS报工工时`,
"label.data.exp.pwdverif":`密码只允许是字母或数字`,
"coderules.notEnable":`请联系管理员开启生成二维码或条形码的规则`,
"label.weixin.wdyj.jxhk":`个人-销售绩效-回款`,
"label.data.expnode.e_desc3":`3、模板制作：用户可以根据需求将所需导出的字段及条件制作成模板，方便下次使用。`,
"chatter.group.join":`加入`,
"vue_label_systemSettings_monitoring":`监控`,
"front-kefu-moudle-v1-yesorno-delete-folder":`确定要删除这个文件夹吗？`,
"label.exchange.sync.state.info":`检查系统状态,确保记录在Exchange和 CloudCC 之间同步的。`,
"lable.outlook.mcto.emaildes":`输入您用于发送电子邮件潜在客户和联系人的所有电子邮件地址，用逗号隔开。只有从您下面指定的电子邮件地址发送的电子邮件可添加到相关记录的活动历史。`,
"label.ems.save":`保存`,
"vue_label_dashboard_maximumvalue":`请输入显示最大数值`,
"label.passwordPolicy.setup.norestriction":`无要求`,
"label.multilang.customforcast.total":`{0}的累计`,
"label_partner_all_memo":`列表显示贵组织中的全部伙伴云。单击URL可将您直接跳转到登录页。`,
"Account.News.Setting.002":`使用下面的客户设置为贵组织指定默认的客户行为`,
"label.essential":`必需`,
"label.nonotice":`不再提醒`,
"vue_label_calendar_calendar_deleted_successfully":`删除日历成功`,
"message.huanxinagent.disable":`坐席未启用`,
"label.goto":`转至`,
"label.chat.topic.add.favorite":`添加到收藏夹`,
"label.trigger.targetobj":`目标对象`,
"label.form_fields":`表单字段`,
"this.month":`本月`,
"vue_label_homepage_select_view":`选择视图`,
"label.weixin.input.subject":`请填写主题`,
"label.ems.emailType":`邮箱类型`,
"vue_label_file_safe_type_file":`请确认文件不包含敏感信息。请考虑与特定用户或记录共享文件`,
"label.version.case.automatic.upgrade":`Case 自动升级及分配`,
"label.input.invalid.credit.card.number":`请输入一个合法的信用卡号码`,
"component_timeline_label_future":`后续步骤`,
"label.emailtemplate.cannotsupporthtml":`目前不支持HTML类型`,
"label.appupload.install.error.info2":`{1}  “{0}”           与现有组件冲突。`,
"label.custom.field.maping":`映射到此字段`,
"encd":`加密文本(显示加密)`,
"label.service.newBuildDialog.filter.logic":`筛选器逻辑`,
"label.customerinfo":`公司简档`,
"vue_label_applauncher_notice_activepoolsuccess":`启用公海池成功`,
"label.partner.workspace.member.choicepermission":`选择权限集`,
"front-gantt-module-this-task-of-other-tasks":`该任务存在子任务，不能成为其他任务的子任务！`,
"label_chatter_publish":`发表`,
"label.forecast.settings.mrfw":`默认范围起点`,
"label.Named.Filter":`命名筛选器`,
"label.department.email":`邮箱地址`,
"label.updatingfield":`要更新的字段`,
"label_partner_template_detail":`功能说明`,
"front-epwechat-module-v1-unbound-item":`- 所有企业的绑定关系`,
"vue_label_file_lib_name":`文件库名称`,
"label.notification.arketsea.distribution":`{5}将{2}{0}：{1} 分配给了您`,
"vue_label_norm_removecomponent":`删除组件`,
"component.event.label.begindate":`*开始时间`,
"chatter.note":`个收到注释`,
"label.forecast.settings.type.all":`使用整体预测`,
"label.compact.layout.frame.full":`全屏显示`,
"label.approvalstep3intro":`使用下面的选项，指定批准请求应分配给的用户`,
"label.notification.approval6":`【被委派人名称】替您批准【提交人】请求的【对象】【对象名称】审批申请。`,
"setup.object.field.dependency.label.actionfieldvalue":`控制字段值`,
"label.multilang.page2":`页`,
"vue_label_email_submitted":`提交通过`,
"label.Standard.button":`标准按钮`,
"vue_label_report_emailchoose":`电子邮件选项`,
"page.field.masterinput.list":`主从录入数据列表`,
"label.martrixdown":`矩阵下移`,
"vue_label_helpcenter_opportunity":`在视图的右上角，点击销售漏斗图标，可以跳转查看销售漏斗。<br>通过直观的进度条，跟踪每个业务机会的进程，并且可以通过点击按钮，标记完成当前阶段，或是调整当前阶段。如果推进业务机会的时候遇到了阻碍，还可以通过展开进度条来查看当前阶段下更应关注的信息与一些温馨提示。<br>通过业务机会小组相关列表，可以将该条业务机会数据共享给其他本无查看权限人员，方便协同工作。<br>在业务机会下的联系人角色相关列表上，快速为对应客户中的联系人添加机会中的角色，再通过关系网，查看相关的联系人上下级关系，同时通过雷达图评估联系人在当前机会下的价值，追踪跟进情况，定位关键人物，查看联系人的。角色、拜候状态、关系程度、购买风格与拜访次数<br>通过业务机会产品相关列表，可以为该业务机会添加同一价格手册中的产品，并编辑产品的售价、个数。`,
"label.sso.ssoKeyMan":`单点登录密钥管理`,
"label.forecast.edit.desc":`设置某用户在以下期间的定额`,
"label.weixin.newspaper.coverage.time":`报险时间`,
"label.pleaseselectpro":`请选择产品`,
"label.bottonandlink":`按钮和链接`,
"label.donot.know.error":`发生未知的错误，请联系管理员处理`,
"label.account_noordab":`您的账号有0个自定义报表，2个仪表板。`,
"label.partnerCloud.orderingPlatform.toPay":`账户支付`,
"label.many.dayline.nextday":`后一天`,
"lable.showmorerecords":`显示更多记录`,
"front-lightning-module-v1-details-page-chart-record-type":`请选择记录类型`,
"label.ccpeak.query.record":`查询记录：`,
"pagecreator.systemstyle.message.save.fail":`样式保存失败`,
"label.weixin.share.file":`分享文件`,
"errormessage.email.relatedorreceivermusthaveone.z":`收件人和相关项至少选择一项`,
"chatter.save.f":`保存失败`,
"button.partner.create":`创建`,
"label.marketseamemset.lead.title2":`请设置影响所有成员拥有潜在客户的数量上限，限制与公海池无关`,
"label.service.major.event.new":`新建重大事件`,
"label.version.custom.site":`自定义网站`,
"label.permission.visualpagepermission":`分配的自定义页面`,
"lable.product.zongjia":`总价`,
"label.viewchart":`查看图表`,
"label.alaska.daylight.time":`阿拉斯加夏令时`,
"front-kefu-moudle-v1-rgdyhcwzx-reply":`让更多用户成为坐席以服务更多访问者，提高客服满意度。`,
"component_assistant_label_todaylead":`今天分配给您的潜在客户`,
"label.sendemail.chat.addComentsfavorite":`尊敬的#name:\n\n    ;您好！#userName回复了您收藏的微贴。`,
"label.smstemplate.tip":`以下列出了选定文件夹中的所有短信模板。 单击“新建”按钮可以创建新的文本或HTML短信模板。您可以在发送短信时使用这些短信模板。单击角色链接可查看更详尽的信息。`,
"label.documentname":`文档名称`,
"label.icon.162":`风景`,
"label.salescloud.wanyuan":`元`,
"label.view.desc1":`记录类型字段，选项列表字段和选项列表（多选）字段，建议最多输入10个关键字，用英文逗号隔开实现或关系，如：“北京,上海,广州”。`,
"label.searchlayout.lookup.newfield":`在“查找”对话框中点击新建按钮显示的字段。`,
"label.emailobject.bcc":`密  送：`,
"label.manageAll.pagenum1":`当前已经是第一页了`,
"vue_label_appstore_crm_used_companies":`上市公司都在用的crm`,
"label.document.replace":`替换`,
"label.assignment.setup.newrule.title":`新建个案分配规则`,
"component.chatter.label.mygroup":`我的小组`,
"lable.currencyAdv.exchangedate":`日期范围`,
"label.quickbooks.button.viewinqb":`在QuickBooks查看`,
"UG.homepage.004":`自动化`,
"label.currencyName":`币种名称`,
"Homepage_News_001":`新闻`,
"front-lightning-module-v1-details-page-chart-refresh-button":`显示刷新按钮`,
"label.list.projectSetting.isenable":`启用项目定时器(包括：里程碑、任务、子任务、问题)`,
"setup.layout.message.relatedlistbutton":`选择在相关列表上显示的标准按钮。`,
"vue_label_homepage_homepageassignment":`应用程序主页分配`,
"label.pending":`待处理`,
"component.timeline.label.today":`今天`,
"front-kefu-moudle-free-hasexpire":`您的免费试用已过期`,
"homepage.layout.customlayout":`自定义主页布局`,
"label.service.miniProgram.content":`请填写内容`,
"label.defaultline.must.int":`默认行数只能是正整数`,
"label.mirror_issues":`如果表单不能反映您所查看内容，请阅读关于如何排除常见显示问题的帮助文章。`,
"label.edit.select.two":`单选框列表`,
"label.emailmerge.mergeFolder.tip":`合并模板需要一定的时间,在合并过程中,请不要单击其它链接或关闭您的Web浏览器或刷新页面!`,
"label.ServiceCloud.zichan.distributionMap":`资产分布图`,
"label.selectfile":`选择文件`,
"vue_label_account_equitymanage":`管理股权关系`,
"label.email.clearAll":`清空所有`,
"label.selecting.parent.assets":`选择父资产`,
"component.setup.tabs.label.delete":`删除`,
"label.visualpage.top.must.is":`页面头第一行必须是：`,
"label.SalesCommitmentDashboard":`销售承诺仪表板`,
"chatter.group.changeTheRole":`更改角色`,
"label.dataimport.insertdata.error":`插入新数据发生错误，请仔细检查本条数据`,
"label.partner":`伙伴云`,
"label.process.async.execute.tip":`您的审批操作已经进入处理队列，请稍后，若审批失败，会邮件通知您。`,
"label.service.newBuildDialog.additional.conditions":`附加条件`,
"label.name_copy":`您将复制本表单。请命名表单副本。`,
"label.integrations.install":`授权`,
"label.edit.ccpeakfolder.time":`定时类：编辑文件夹`,
"label.knowledgebase.filing.time":`归档时间`,
"vue_label_chatter_success_exit_group":`退出小组成功`,
"font.market.module.v1.save.name":`请填写会议名称`,
"label.a.b.without":`A" 记录可能有或没有相关 "B" 记录。"`,
"label.chat.topic.desc":`描述`,
"label.field.editoptionlist.introduce":`在下边输入选项列表值的名称， 选取此复选框，以使用此值作为默认值`,
"label.versiontype.Enterprise":`企业版`,
"message.selectrulecondition":`请指定规则条件！`,
"label.custombutton.unknown.operation":`未知的操作`,
"label.pricecannotnull":`价格不能为空`,
"component_salesperformance_label_target":`目标`,
"pagecreator.page.message.delete.success":`页面删除成功`,
"label.help.new.features":`新功能操作指南`,
"label.weixin.vehicle.owner.information":`车主信息`,
"label.exchange.sync.state.user.info":`检查用户的同步状态，确保用户记录在 Exhange 和 CloudCC 之间同步。如果用户在 Exchange 和 CloudCC 之间同步时遇到问题，您可以重置用户的同步过程。重置可清理仅 CloudCC for Exchange 使用的信息，且不会从您的 Microsoft Exchange 服务器或 CloudCC 中删除数据。`,
"label.batcheditor":`批量编辑`,
"report.label.knowcreatehighlevelreport":`了解高级报表制作`,
"label.dataimport.title.length":`标题的长度是`,
"label_model_description":`模型描述`,
"label.tabpage.ctbtsftcz":`点击后面搜索选择内容`,
"label.channel.activity.member.owner":`渠道活动成员所有人`,
"label.ems.serverinfo":`服务器信息`,
"tjinvilid":`条件不合法`,
"label.nameofreport":`报表名`,
"label.ifapproverreject":`如果批准人拒绝此请求会怎样？`,
"label.wtd.changefields.title.desc2":`如果需要移动端  Web to CloudCC 的记录关联潜在客户，则需要在当前对象上创建查找潜在客户的字段，且字段API为lead_wtd"。"`,
"label_emailsync_form_connecttime":`关联时间`,
"label.visualpage":`自定义页面`,
"label.customlink":`自定义链接`,
"label.lead.score.doing.remark":`已处理您的请求，潜在客户打分需要一定的时间，系统在处理完成后将会发邮件告知您。`,
"label.h5.act.details":`活动详情`,
"label.profile.setrecordtype":`记录类型设置`,
"label.processsetting.process.enabled.successfully":`启用进程成功！`,
"label.campaign.url.overtime":`该链接已过期`,
"label.structureChart.notFiled":`未填写`,
"label.h5.chatter.something":`您是不是要说点什么`,
"label.pm":`下午`,
"template.chart.rwlx":`任务类型`,
"label.icon.42":`云`,
"label.project.hit.one":`子任务分配通知`,
"label.martrixreport.2018.step3":`步骤3：选择报表列`,
"label.wtd.changefields.newmo":`生成移动版页面`,
"label.downloadTheTemplate":`下载模板`,
"label_chatter_assignPerson":`被分配人`,
"label_emailtocloudcc_license":`用户许可`,
"label.willdeletedlayout":`要删除的页面布局`,
"label.projectManagement.delete.question":`删除该问题，将删除问题和问题关联的所有信息，且数据无法恢复，是否确认删除`,
"lable_setup_mobilesetup_isEnableValidationRulesForScan":`名片扫描是否启用验证规则`,
"label.salescloud.opportunity.addandedit.contactrole.note":`注意：双击空白联系人，可以新增一条空白记录`,
"label.step6.total6":`第6步，共6步`,
"label.knowledge.setting.hint.one":`Knowledge允许客户和客服人员充分利用丰富翔实的Knowledge文章。`,
"label.usefieldautoassign":`使用标准或自定义层次结构字段自动分配批准人：`,
"label.partnerCloud.orderingPlatform.orderAmount":`订单金额：`,
"chatter.fieldtrack.operateupdate":`已更改一条`,
"chatter.del.com":`删除此评论`,
"report.reportdatasource.label":`报表数据源`,
"label.text":`文本`,
"label.marketsea.select.member":`可选成员`,
"label.typeofreceivers":`收件人类型`,
"label.knowledgebase.affect.existing.translations":`是，我的更改会影响现有翻译。标记为“过期”。`,
"label.marketing.invitationmail":`欢迎您参加我们的活动，您的邀请函链接为：`,
"label.version.quotation.management":`报价管理`,
"label.dataimport.insertdata.error.unique":`插入新数据时，$fieldName$违反了唯一性约束`,
"label.emailmerge.list.newtemplate":`新建模板`,
"label.salescloud.salescloud.allteam":`业务机会上的所有小组`,
"vue_label_commonobjects_detail_record_changes":`字段记录变更`,
"label.file.delete.info":`删除文件`,
"vue_label_calendar_name":`日历名称`,
"label.version.support":`支持`,
"label.event":`事件`,
"label.searchlayout.lookup.searchdialog":`在“查找”字段上点击查找链接弹出的“查找”对话框。`,
"label.data.downpage.e_list.desc2":`导出数据成功后，您会收到一封邮件，提醒您导出数据成功。`,
"label.partnerCloud.productSet.delIsTrue":`确认删除该条产品?`,
"label.tianyancha.businessverify.msg2":`本《协议》是您（下称“用户”）与CloudCC 之间关于使用工商数据验证功能所订立的协议。本《协议》描述CloudCC 与用户之间关于工商数据验证功能的使用及服务相关方面的权利义务，本《协议》可由 Cloud CC随时更新，更新后的协议条款一旦公布即代替原来的协议条款，恕不再另行通知。`,
"label.customobjects.cancleselectallfield":`取消选择全部字段`,
"image.up.maxsize":`上传的文件过大,请不要超过2M。`,
"label.icon.8":`档案`,
"label.donot.delete":`您没有删除权限！`,
"label.version.profile.and.layoutpage":`简档和页面布局`,
"chatter.coll.s":`停止收藏此帖子`,
"label.icon.163":`地球`,
"label_chatter_myfollowers":`我的追随者`,
"label.multilang.customforecast.refuse":`拒绝{0}的任何预测优先,但是接受其他下属的预测优先`,
"label.tabpage.findz":`查找`,
"label.smstemplate.detailinfo":`短信模板详细信息`,
"label.knowledge.setting.hint.nineteen":`开始吧`,
"label.mr.tip":`请把第{0}行的规则填写完整.`,
"label.icon.132":`保障`,
"label.customobjects.track.introduce2":`“字段跟踪”相关列表中跟踪的字段。无论何时用户修改以下所选的任何字段，旧字段值和新字段值，以及日期、时间、更改特性和进行更改的用户都将添加到“字段跟踪”相关列表中`,
"label_emailtocloudcc_redmessage5":`状态未知，请联系管理员`,
"label.must.select.field":`行条件错误，必须选择一个字段！`,
"label.tag.manage.modifiedby":`最后修改人`,
"label.translation.start1":`选择一种语言（若您是多种语言的译员）。`,
"label.ccchat.topic.searchs":`搜索主题`,
"label.mask.custom.example":`{AAAA}{****}{AAAA} 表示从第5个字符到第8个字符进行加密显示`,
"setup_object_field_dependency_label_addtolist":`添加选中值`,
"label.view.total.record":`共计选中0条记录`,
"label.service.without.right":`没有关联权利`,
"template.chart.wxqzkhyy":`无效潜在客户原因`,
"vue_label_dashboard_pleaseenterabreakpoint1value":`请输入断点1值`,
"message.pleaseinputmouthdistance":`请正确填写间隔月`,
"label.forgetPsd.tip":`忘记密码，联系管理员`,
"label.projectManagement.planned":`已计划`,
"lable.Product.conversion.asset.operation":`产品转换资产操作`,
"label.search_forms":`搜索表单`,
"label.sendemail.chat.addPostmainPagesubject":`CloudCC CCChat主页留言`,
"label_tabpage_viewNamez":`请输入视图名称`,
"label_chatter_addresser":`发件人`,
"Opportunity_Detailed_Phase_Change_Text_001":`更改业务机会阶段`,
"label.what":`第`,
"vue_label_systemSettings_set_android":`设置组织安卓和IOS软件的菜单和功能，使其符合企业用户的使用方式`,
"label.sell":`销售`,
"template.report.folder.case":`个案分析`,
"label.customfields.profilefieldsafety":`简档的字段级安全性`,
"label.industrialandcommercialverification.label.token":`Token`,
"label.finished":`已完成`,
"label.sendmail.step3.introduce1":`当前已选取`,
"vue_label_calendar_other_calendars":`其他日历`,
"label.donot.know.validate.field":`未知的校验字段`,
"label.exportdetail":`导出详细信息`,
"label.step.filter":`指定筛选条件`,
"label.campaignmember.main.hasMember":`现有成员`,
"label.updown.suess":`下载成功`,
"label.ems.browse":`查找`,
"front-email-payment-Invoice-login-account-describe":`点击“继续”，您可以通过扫描支付宝二维码或登录支付宝账户来完成发票支付。`,
"label.copyCustomReportType":`复制自定义报表数据源`,
"label.visualpage.write.class":`在页面中编写Class代码，代码的语法与Java相同`,
"label.setsharerule.tip":`使用共享规则将符合设定条件的数据，共享给指定的角色。<br>注意：角色和下属"包括特定角色中的所有用户和该角色下的角色。"`,
"label.report.action.addtodashboard9":`仪表板列表页`,
"label.cloudccsite.remark":`站点描述`,
"label_tabpage_noz":`否`,
"chatter.up.limit":`上传的文件过大,请不要超过`,
"label.leadmarketsea.grouplist.title":`潜在客户公海池分组设置`,
"label.pc.user.help":`用户指南`,
"label.partnerCloud.orderingPlatform.relyOn":`依赖`,
"label.appointmentpage.wizard.subtitle2":`选择时间`,
"label.deleteoneormore":`删除一个或多个`,
"january":`一月`,
"label.delete.profile":`删除简档`,
"label.appointment.wizard.subtitle1-7":`2小时`,
"label.icon.188":`化妆品`,
"vue_label_file_already_in_lib":`已存在于此文件库中`,
"label.icon.151":`VR`,
"label.withvalue":`按值`,
"label.tianyancha.businseeverify.opererror":`开启工商数据失败,请重新尝试或联系系统管理员！`,
"label.tabpage.individual":`单项选择`,
"label.layout.editdistribute":`编辑页面布局分配`,
"label.smstemplate.lookup":`查看短信模板`,
"pagecreator.systemstyle.button.delete":`删除样式`,
"label.customer.tab.step2.same.option1":`默认打开`,
"label.knowledgebase.no.results.knowledge":`Knowledge 中没有""的结果`,
"label.data.exp.newtemporexp":`选择数据导出方式或制作模板`,
"vue_label_chatter_refuse_join":`拒绝加入`,
"Homepage.News.002":`当前新闻组件服务不可用`,
"label.log.requesttype":`请求方式`,
"vue_label_dashboard_generatefromreport":`从报表生成`,
"label.knowledge.create.version":`创建版本`,
"label.emailtocloudcc.description2":`关联您的企业邮箱`,
"label.partnerCloud.partnerAccount.recharge":`充值金额要在0.1到 {upperlimit} 之间`,
"label.customobjects":`自定义对象`,
"label.schedulableprg.endtime":`结束日期必须大于系统当前日期`,
"message.error.viewreport.confirmdelete":`存在使用当前视图/报表作为数据源的图表，是否连同图表一起删除`,
"label.marketing.social.seting":`社交媒体设置`,
"chatter.follow.stop":`停止追随该用户`,
"label.notification.arketsea.return":`{5}将{0}：{1}退回至{2}`,
"label.conditionsofnextapprover":`您所选择的批准请求中有一个或多个要求指定下一个批准人。使用下面的查找框指定下一个批准人。`,
"label.partner.all.state":`状态`,
"mobel_web_closed":`已关闭`,
"label.icon.65":`器材`,
"label.stdashbord.xsld.business.jinehj":`金额合计`,
"label.selectobject":`选择对象`,
"label.account.CurrentFQ":`当前会计季度`,
"label.workflow.estimaterule":`评估规则`,
"label.list.userinterface.shownewrecordssetup":`最新记录设置`,
"label.tianyancha.businessverify.msg3":`一：费用：`,
"label.weixin..xsld.jieduan":`阶段`,
"label.first.quarter":`第一季度`,
"Opportunity.Detailed.Phase.Label.002":`当前状态已停留{0}天`,
"label_tabpage_page":`页`,
"label_emailsync_status_time":`时间`,
"label.pleaseselectaapprover":`请选择一个审批人`,
"label.emailtocloudcc.redmessage5":`状态未知，请联系管理员`,
"label.four.quarter":`第四季度`,
"label_chatter_relateList":`相关列表`,
"label.customfields.new.step2.opration.exid.info":`将此字段设置为针对外部系统的唯一记录标识符`,
"label.projectManagement.nodata.overdue.tasks":`太棒了，没有逾期的任务`,
"label.sendemail.activity.task.statuscompleted":`尊敬的#createbyidccname您好：\r\n  你于#createdate分配给#belongtoidccname任务，任务具体信息如下：\r\n  主题：#subject\r\n  到期日期：#expireDate\r\n  相关项：#relatedstr\r\n  内容：#remark\r\n  具体详情，请访问此链接：\r\n #path\r\n #belongtoidccname已标识为完成，请知晓。\r\n                      #orgNameCRM系统`,
"label.sso.saml.idp.config.issuer":`颁发人`,
"label.cannot.delete":`条）不允许删除`,
"label.pigeonhole.sel_f":`选择要归档的文件夹`,
"label.customfields.text.tip":`允许用户输入任何字母和数字组合。`,
"message.error.user.service.common":`操作失败，联系系统管理员获取支持！`,
"label.datamanage.account.information":`客户信息`,
"vue_label_homepage_deleteprofilepage":`删除简档主页`,
"label.sendmail.step3.introduce3":`位收件人接收此短信。`,
"label.pc.ui.2018.recentitem":`最近项目`,
"label.report.loading":`拼命加载中`,
"vue_label_globalsearch_adjustment":`调整方式`,
"label_report_line_yixuan":`已选报表列`,
"label.h5.similar.opportunity.only.view":`只显示`,
"label.marketactivitymember":`市场活动成员`,
"label.recycle.execute.tip":`已处理您的请求，清空回收站需要一定的时间，系统在处理完成后将会发邮件告知您。`,
"label.permission.detail.system.setting":`系统权限设置`,
"label.RecordType":`记录类型`,
"label.custom.error.between":`自定义年度开始日期或自定义年度结束日期在历史自定义年度时间段内，请检查后重新设置！`,
"vue_label_dashboard_selectview":`选择视图`,
"label.tianyancha.businessverify.cancel":`取消启用工商数据验证`,
"label.partnerCloud.financeSetting.MD5":`MD5密钥`,
"label.multilang.messagedetail.new.error":`我们找不到任何姓名带有{0}的Chat用户：`,
"label.callcenter.pleaseenter.private.key":`请输入私有访问秘钥`,
"label.umeng.activity.youdistribute":`您分配给`,
"label.weixin.nickname":`昵称`,
"label.customerinfo.mailusername":`发件邮箱用户名`,
"label.partnerCloud.orderingPlatform.discountPlan":`折扣计划名称：`,
"lable.account.year":`会计年度`,
"T":`时间`,
"System.Email.Template.Title":`欢迎您使用CloudCC CRM平台`,
"label.login.type":`登录类型`,
"label.notification.evaluation":`{0}在个案{1}留下了{2}的评价`,
"label.turntolist":`转至列表`,
"label.sort":`排序`,
"vue_label_commonobject_notice_clickcross":`如果需要替换已上传的文件，请点击【X】按钮后重新上传`,
"label.Select.maximumecords.operate":`最多选择200条记录进行操作`,
"label.submission_rate":`提交率`,
"label.datadelete.record.sucessfully":`条记录删除成功！`,
"label.version.standard.dashboard":`仪表板`,
"label.task.postunsolve":`逾期未完成任务`,
"label.Receivables.name":`收款计划名称`,
"label_tabpage_noOperationz":`此内容为固定项，不可操作！`,
"label.attendance.onrecord":`至少选择一条记录`,
"label.partner.error2":`错误：域名只能包含数字或字母`,
"label.account.map":`客户地图`,
"label.dashboardSetup.reference.legend":`参考图例`,
"label.Yaxisscope":`Y轴范围`,
"label.hierarchy.tree.tip":`基于在每个菜单里的自查找字段中选择一条记录创建的层级结构图表。层级结构显示如下：`,
"label.permission.objlist.columnsize":`总字段数`,
"label.setup.mobile.bottombutton.savesuccess":`移动端一级页面设置保存成功`,
"label.mobile.side.tab.selected":`已选取`,
"label.partner.donotdel.cause":`的删除操作，因为它与以下合作伙伴用户相关联`,
"label.ccchat.message.new.error4":`提示：`,
"vue_label_systemSettings_setorganization":`设置组织应用程序，为各职能人群设置不同应用程序菜单`,
"label.umeng.approval.approvalmes4obj1":`请您及时审批。`,
"UG_opportunity_010":`创建一个交易`,
"label.tag.addtags.public":`公用`,
"System.TAB.SeeViewPageAmount":`查看页数`,
"label.filterconditions":`筛选条件`,
"front-personalEmailBox-module-v12-clear-not-associated":`取消关联将会清空该邮箱中所有未关联相关项的邮件，是否确认取消关联`,
"label.assign":`分配`,
"label.layout.clone.tip":`可选择一个现有布局进行复制`,
"label.choose.relatedlist":`选择要转移的相关列表`,
"label_chatter_recordcall":`已记录呼叫`,
"label.product.proofOne":`请在{0}处，最多选择{1}个产品选项。`,
"label.layout.availablefield.relatedlist":`可用字段/相关列表`,
"label.campaignmember.main.updateleadstatus":`更新状态-现有潜在客户`,
"label.custom.buttonandlink":`自定义按钮或链接`,
"label.view.manage":`视图管理`,
"label.search.exp":`选择您希望为其启用以下功能的对象并单击“保存”:`,
"vue_label_appstore_apply_to":`适用于`,
"label.dashboard.message.refreshfail":`仪表板刷新失败`,
"UG_Case_02":`个案可让您响应并解决客户问题。个案在 Cloud CC中是功能强大的记录，不仅可以跟踪客户问题，而且也可以显示完整的客户视图。`,
"label.project.hit.three":`每天子任务提醒`,
"label.tianyancha.businessverify.tip":`勾选了启用工商数据验证，用户录入企业客户资料时，可协助用户录入正确的客户工商注册信息。`,
"label_emailsync_status_disconnect":`取消关联`,
"label.rule.disabled.successfully":`规则禁用成功`,
"label.custombutton.queryerror":`查询失败，请重新操作`,
"label.customfields.deletecannotresume":`对应的数据将被永久性的删除，不能恢复，请谨慎操作。`,
"label.account.current.M":`本月`,
"label.under.approve.data":`正在审批的记录（`,
"vue_label_title_remainingdays":`剩余天数`,
"label.partnerCloud.orderingPlatform.refundable":`本单可用返利`,
"label.lookup.iscover":`编辑是否允许同步`,
"label.recordtype.detail.selectlist":`可用于编辑的选项列表`,
"label.sso.isActiveYes":`是`,
"label.service.appointmentList.canceltheSuccess":`取消成功`,
"label.escalation.setup.newentries.createfirst":`根据创建个案的时间，并在首次修改个案后禁用`,
"label.new.ccpeakfolder":`类：新建文件夹`,
"lable.currencyAdv.exchagecurrency.after":`之后`,
"label.majoranddetailrelation":`主-详细信息关系`,
"label.appointment.wizard.subtitle4-2-1":`1小时`,
"label.projectManagement.working.hours":`工作时间`,
"label.forecast.customforecast.button.forehistory":`预测历史`,
"label.mymasterplate":`我的模板`,
"component.setup.tabs.label.memo":`设置Tab标签名称`,
"label.customfields.longtextarea.tip":`允许用户输入多行文本，最多可输入 32000 个字符,并且每个对象最多只支持10个此类型的字段。`,
"label.service.miniProgram.fillJumpLink":`请填写跳转链接`,
"label.british.summer.time":`格林威治时间`,
"label.nogreate":`<=不大于`,
"label.assignment.setup.detail.sameuser":`相同用户`,
"mesage.error.profile.delate.user":`无法删除简档，因为当前为简档分配了用户。`,
"label.tabpage.cownerz":`更改所有人`,
"label.multilang.dupicatecheck.processedcount":`重复数据，已处理{0}组，还剩余{1}组数据未处理。`,
"vue_label_report_notice_leavecertification":`您是否确认离开此页面-您输入的数据可能不会被保存`,
"label.master.required":`从记录有必填项未填`,
"label.chatter.follow":`关注`,
"label.dataimport.insertdata.error.repeat":`该记录和原数据库中数据重复，该记录已忽略导入。`,
"label.sms.cgid":`通道组编号`,
"label.knowledge.article.rator":`由于冲突我们无法归档一篇文章。`,
"label.datamanage.object.field":`对象字段`,
"label.forecast.editshrepage.quanxian":`共享权限访问级别`,
"label.weixin.interactive.log":`交互式日志`,
"label.batchedit.remark":`可以对多条记录进行编辑`,
"label.user.permissions.message":`没有权限设置用户信息。`,
"label.mobile.phone.month":`月份`,
"chatter.sel.u":`选择要@的人或直接输入@[用户名]`,
"label.service.gantt.assigned.work":`被分配工作`,
"UG_ST_001":`提示`,
"label.edit.select.one":`下拉列表`,
"label.forecast.shrepage.desc0":`此页面将列出对{0}具有共享访问的用户、角色及区域。`,
"label.multilingual.confirm.close":`是否确认禁用，禁用后将无法使用多语种，用户语种将被修改为公司默认语种。`,
"label.setting.intergrationlist.integration":`集成`,
"label.leadscore.rule.list":`潜在客户打分规则列表`,
"component_telerecord_button_save":`保存`,
"label.weixin.save.log":`保存日志`,
"label.validate.function.funcExplain.DAY":`返回一个月中的某一天，是 1 与 31 之间的一个数字`,
"label.appointmentdetail.wizard.title1":`会议名称`,
"label.multilang.feedtrack.dealkey":`将{0}从{1}更改至{2}`,
"label.optional.features":`可选功能`,
"vue_label_email_no_email":`无电子邮箱`,
"label.sendemail.chat.messagecontent":`消息的内容：`,
"label.tabpage.lessequalz":`小于或等于`,
"setup.layout.label.setupfield":`设置字段属性`,
"label.approved.receiveApprovalEmail.option1":`如果我是批准人或委派批准人`,
"label.chatter.relateList":`相关列表`,
"component.sendmail.label.fromuser":`发件人`,
"label.projectManagement.problem.status":`问题状态`,
"label.weixin.fmu.before.hour":`提前 {0} 小时`,
"chatter.feed.menutype.feed.mark":`我收藏的微贴`,
"label.addQuoteLineGroup":`添加报价行组`,
"label.report.action.addtodashboard6":`添加`,
"label.url":`URL`,
"lable.account.CurrentandPreviousCQ":`当前和上一个日历季度`,
"label.tabpage.emptyz":`清空`,
"less":`小于`,
"label.h5.selectmostphotos":`最多只能选择9张照片`,
"UG.activity.04":`Outlook/Gmail邮箱 记录邮件`,
"template.chart.qbhtje":`全部合同金额`,
"label.tabpage.endz":`结束`,
"label.partner.workspace.member":`成员`,
"label.filter.error.filedvaluetoolong":`错误：字段值超出最大限制。`,
"label.months":`月的`,
"button.partner.workspace.disable":`取消启用`,
"label.visualpage.checkpinyin.grammar":`请检查拼写语法。`,
"label.dashboardSetup.geshihua":`格式化`,
"label.belongto":`属于`,
"label.upload.cannot.empty":`上载文档不能为空！`,
"label.number.MaxCheck":`{0}最大数量为{1}，请修改数量后再点击保存。`,
"pagecreator.page.message.save.fail":`页面保存失败`,
"label.edit.SMS":`编辑短信通知`,
"UG_Lead_002":`有很多方法可以为您的产品或服务识别“潜在客户”。`,
"label.quickcreate.active.quickcreate":`启用快速新建`,
"label.recordtypeselect.tip":`若要在将来跳过此页，请在个人设置页上更改记录类型设置。`,
"label.form_content":`表单内容`,
"workflow.action.tasks.assignortype.related":`相关用户`,
"vue_label_allsearch_set_more_items":`您可以在搜索框左侧的下拉框中设置更多的搜索项来继续查找`,
"label.tianyancha.businessverify.title":`工商验证`,
"label.errormessage.batchedit.norecord":`没有数据。`,
"label.permission.appname":`应用程序名称`,
"label.report.action.addtodashboard7":`取消`,
"label.generated.transfer.product":`转资产时根据产品上“资产转换”的方式生成资产。`,
"vue_label_commonobjects_detail_you":`您`,
"label.user.captcha":`用户验证码验证`,
"label.notification.event4":`您分配给【被分配人】的事件即将在【开始时间】开始`,
"label.version.setup":`后台设置`,
"setup.object.layout.message.selectedlayoutandrecordtype":`请选择布局和记录类型`,
"label.role.add":`添加角色`,
"label.versiontype.Unlimited":`无限版`,
"label.partnerCloud.financeSetting.developerID":`请输入开发者ID`,
"front-invoice-online-payment-setup-global":`适用于全球客户`,
"vue_label_commonobjects_view_basis":`分类依据`,
"label.decimaldigits.tip":`小数点右边的数字的位数`,
"vue_label_commonobjects_detail_selected":`标记为选中{labelname}`,
"label.data.export.page":`进入数据导出页面`,
"message.error.serviceresource.servicecrewid":`每个服务班组只能被添加为一条班组类型的服务资源记录`,
"label.loginttime.alltime":`所有时间均为`,
"label.requiredinfo":`必填信息`,
"label.forecast.edit.di":`第`,
"vue_label_calendar_failed_to_remove_calendar":`移除日历失败`,
"pagecreator_systemstyle_button_delete":`删除样式`,
"label.import.page3.continueimport":`继续导入`,
"label.page.width":`整页宽度`,
"label.campaignmember.selectmember.addmember":`中添加成员`,
"label.finalreject":`最终拒绝`,
"label.isend":`是否结束`,
"front-console-conversation":`会话`,
"label.mr.theLastGroupOfThisPage":`这已经是此页的最后一组。请点击【返回查看重复数据列表】，查看重复数据。`,
"label.data.dataexpalltype.all_desc":`导出当前用户所有有权查看的对象的数据。`,
"label_emailtocloudcc_redmessage7":`后台配置错误，请联系管理员`,
"label.forecast.shrepage.classdes.all":`完全访问权限 - 用户可以查看和覆盖预测数据。用户还可将共享访问权限扩展到其他用户。`,
"market.contacts":`市场联系人`,
"label.weixin.polls.voter":`投票参与者列表`,
"template.report.industry.distribution.customers":`客户的行业分布`,
"front-electronic-signature-setup":`合同信息自动填充和回填设置`,
"vue_label_chatter_removecertification":`确定要移除小组成员"{name}"吗`,
"label.appointment.wizard.subtitle1-2":`15分钟`,
"label.sso.saml.idp.config.custattr":`自定义属性`,
"label_tabpage_totalTeamz":`共有小组`,
"lable.outlook.detail.assigned":`已分配的用户和简档`,
"label.department.user.delete":`删除`,
"label.customcomponent.check.label.same":`标签名已存在`,
"label.partner.error1":`错误：域名长度过长`,
"label.escalation.setup.entrydetail.escalation.notify":`通知`,
"component_todaytask_label_choicestate":`选择状态`,
"label.customfields.fielddependency.new.step1":`<b>步骤1：</b> 选择一个控制字段和一个依赖字段。完成时单击“继续”。`,
"chatter.group.anyoneCanSeeTheUpdateAndJoin":`任何人可见并可申请加入这个小组`,
"label.custom.pixel":`像素`,
"label.quicksave":`快速保存`,
"label.approved.persion":`委派的批准人`,
"lable.info.queue.member":`队列成员`,
"label.addattachment.step2.weixin":`步骤 2.单击“上传文件”按钮，上传文件`,
"label.forecast.customforecast.title":`预测`,
"mainpage_setup_chosecomponent_leastone":`至少需一个组件放在主页上。`,
"label.appointmentconfirmpage.wizard.title2":`关于本次预约的详细日程已经发送到你的邮箱`,
"label.useallselectedapprover":`要求所有选定批准人的 <strong>一致</strong>批准。`,
"label.ccpeak.current.line.return":`会从当前行返回，不再向下执行！`,
"label_new_target_model":`新建目标模型`,
"label.saving":`保存中...`,
"label.mobile.phone.write":`写`,
"label.applt.updown.text":`您也可以下载专属于贵公司的小程序门户二维码，将二维码放到网页或公众号文章内，客户可以扫描二维码使用小程序。`,
"label.partner.common.manageSetup":`伙伴云管理设置`,
"label.quickbooks.new":`新建客户`,
"message.error.color":`color不能为空！`,
"label.project.template.two":`每个对象的每个记录类型下只能有一套配置！`,
"label.approval.input.des1":`逐级审批 ，最大层级为：`,
"label.x.axis.cannot.empty":`X轴不能为空！`,
"label.solomon.isiands.time":`所罗门群岛时间`,
"label.login.access.duedate":`访问权限持续时间`,
"label.service.dispatch.booking.order":`分配服务预约`,
"label_shareme_forecast":`共享给我的预测`,
"label.custom.page.cuspage.height":`页面高度（像素）`,
"label.quote.line.group.":`确定删除{groupName}报价行组吗？删除后，该组内的报价行将会被一起删除。`,
"label.data.downpage.i_title.num6":`建议您在导入数据之前，先导入一个包含5条记录的测试文件，以确保所准备的导入文件正确无误。`,
"label.\u2019s":`的`,
"label.version.contact.management":`合同管理`,
"label.document.history.user":`用户`,
"vue_labenl_commonobjects_opportunity_product_edit_notice1":`请输入正确的金额数字，最多两位小数。`,
"label.weixin.target.contract.jine":`目标合同金额`,
"lable.common":`共￥0`,
"front-kefu-moudle-sendemail-success":`邮件已发送，销售人员会尽快与您联系`,
"label.service.no.operation.time":`当前记录没有关联操作时间！`,
"label.info":`信息`,
"label.ccchat.zw":`中午`,
"label.assignment.setup.newentries.title":`编辑规则条目`,
"label.weixin.report.timeline":`时间帧`,
"UG.quota.04":`打印报价单`,
"label.social.user.exception":`social用户信息异常`,
"label.import.index.failed":`失败`,
"label.common.settings":`通用设置`,
"label.nullvalue":`空值`,
"PageLayout_Search_MultiSearch_002":`搜索字段铺开显示（单字段搜索）`,
"message.myselfreport":`我的个人自定义报表`,
"label.productsales.today.noevttskaddtsk":`今天没有未处理的事件或者到期的任务，您也可以点击右上角的“ ”添加任务！`,
"lable.oppdt.noconditionrecrods":`没有符合条件的记录.`,
"label.campaignmember.selectmember.deletelead":`市场活动：从潜在客户中删除成员`,
"label.marketingactivity":`市场活动`,
"vue_label_pool_self-built":`自建`,
"message.textareamaxlength":`长度不能超过4000`,
"label.valadate.must.value":`必须输入一个值`,
"label.tabpage.groupsVisiblez":`某些用户组可见`,
"component.button.cancel":`取消`,
"label.emailobject.list.inbox":`收件箱`,
"label.app.step1.error.labelexist":`错误：标签已存在`,
"front-calendar-V1-Unable-to-display":`因有大于等于一个记录的结束字段早于开始字段，所以记录无法在日历中显示。`,
"label.forecast.settings.prompt1":`必须至少选一个预测选项：收入或数量。`,
"front-kefu-moudle-callout-missphone":`呼出漏接的电话`,
"label.tabpage.editz":`编辑`,
"vue_label_chatter_label_new_team":`新建小组`,
"label.version.formulafield":`公式字段`,
"label.partner.step1":`步骤1：选择模板`,
"label.weixin.perfect.url":`完善信息URL`,
"label.appointmentconfirmail.wizard.subtitle4":`描述`,
"label.step7.total7":`第7步，共7步`,
"setup.object.layout.label.selectedprofile":`已选简档`,
"label.payments.paytip5":`请输入正确的数量`,
"label.visualpage.open.type":`为开放式自定义页面类型`,
"lable.Sort.field.tips":`通过选择要排序的字段，自定义相关列表中的记录顺序。您可以按对象中的任何数字或日期字段进行排序。`,
"label.nosharerules":`未指定共享规则。`,
"label.service.miniProgram.bindSetOwner":`设置个案所有人`,
"report_label_highlevelreport":`高级报表可以帮您创建最多4个对象关联的报表`,
"S":`文本`,
"label.lastmodifyby":`最后修改人`,
"label.customerinfo.mailaddress":`发件邮箱地址`,
"vue_label_pool_converted":`已转化`,
"UG.ST.004":`您没有数据管理-》数据导入的权限，请联系管理员，点击确定后直接进入{0}界面。`,
"label.view.application.mobile.terminal.filed":`此视图已应用到移动端，字段最多选10个，现已有`,
"chatter.feed.limitentity500":`您最多可以追随500个人员和记录`,
"label.starttime":`开始时间`,
"chatter.emailToMe":`出现以下情况时发送CCChat提醒给我`,
"label.custom.Current.and.PreviousCQ":`当前和上一个自定义季度`,
"label.my.logout":`我的`,
"label.quickbooks.searchlist.enddate":`结束日期`,
"label.ccservice.validate.length":`对象API为{0}下的{1}字段对应值为{2} 长度超出，请重新设置！`,
"label.integrations.installed":`已授权`,
"label.integrations.mailchimplist":`Mailchimp列表`,
"label.checkfield.matchothers":`匹配其他记录`,
"label.umeng.activity.event.distributewillbegin":`您分配给#name的事件#event即将在#time后开始`,
"pool.notice.gotolightning":`若需使用此功能，请前往Lightning版本。`,
"label.batchtransfer.pleaseselecttransferreddata":`请选择需要转移数据`,
"label.mr.title.mailingAddress":`邮寄地址`,
"vue_label_approve_no_response":`未响应`,
"component.event.label.title":`即将进行的事件`,
"label.mobile.setup.confirm":`您正在更改移动端的默认菜单图标的位置信息，更改成功后所有以前在菜单上的配置的移动端菜单图标都将被清除，除非您重新在菜单上设置移动端图标，否则系统默认从您设置的目录里面随机选择。`,
"label.tianyancha.approvaltime":`核准时间`,
"label.download_merge_file":`下载合并文件`,
"label_display_quota":`显示定额`,
"label.publishreadonly":`公用只读`,
"label.campagin.roi.query.roi":`市场活动ROI`,
"label.dashboardSetup.lookup":`查找仪表板`,
"vue_label_notificationcenter_nomessages":`没有未读消息`,
"label.create.object":`新建对象`,
"label.social.campaign.null":`市场活动信息不能为空`,
"label.console.step6.left":`固定到左侧。列表始终可见。`,
"label.line":`列`,
"label.bottonandlink.introduce":`下面是按钮和链接列表。要添加按钮或链接，请编辑页面布局。<br/>按钮可以显示在详细信息页、相关列表和列表视图上：<br/>      1.要自定义详细信息页上的按钮或链接，请编辑页面布局。<br/>      2.要自定义相关列表上的按钮或链接，请在页面布局上相关列表出现的位置编辑相关列表的属性。<br/>      3.要自定义列表视图上的按钮或链接，请在“搜索布局”中编辑列表视图布局。<br/>`,
"label.layout.list1":`列表一`,
"label.mr.title.customerName":`客户名称`,
"label.user.text":`正文`,
"label.nolastestrecord":`暂无最新记录`,
"label.emailobject.appointment.urltext1":`这里是我的日程安排，请您`,
"label.chat.topic.my.favorites":`我的收藏夹`,
"label.select.dashboar.cd0":`分组字段不能为空`,
"label.data.downpage.e_title.num2":`2、若选择导出单个对象的数据，则需要选择数据导出方式。数据导出方式有：自定义导出，按模板导出，导出模板。`,
"message.error.user.service.login.unconn":`服务器错误，稍候`,
"label.escalation.setup.newentries.title":`编辑规则条目`,
"label.import.step1.above2000":`执行触发器时，最多单次导入2000条记录。请拆分为多个文件，分次导入。`,
"label.ccchat.person.allowinvite":`允许同事邀请`,
"label.input.number.between":`请输入一个 {0} 和 {1} 之间的数字`,
"label.forecast.shrepage.wpfmanager":`委派的预测经理`,
"label_server_is_time_out":`服务器超时，稍后再试。`,
"label.indochina.standard.time":`印度标准时间`,
"label.cpq.quote.sync.opportunity.failure":`只有主报价单才能和业务机会同步，请勾选主报价单复选框，再开始同步`,
"label.emailobject.send100emails":`非常抱歉，每天只能发送100封邮件，请重新选择！`,
"label.dashboard.snapshot.end":`截止`,
"label.jiandangfenpei.rightlist":`已分配的简档`,
"label.input.string.length.between":`请输入一个长度在 {0} 和 {1} 之间的字符串`,
"label.multilang.lookfiltercondition.select":`第{0}行条件错误，必须选择一个字段！`,
"label.datamanage.lead.namenull":`注意：如果没有给“潜在客户名称”字段赋值，记录将不会被导入！`,
"label.forecast.detailforecast.button.saveandfresh":`保存并刷新`,
"label.venezuela.time":`委内瑞拉时间`,
"label.same.analyze.miaoshu1":`如果还需要更多规则，请使用“`,
"label.twomb":`只能上传jpg/png文件，且不超过2MB`,
"label.event.moveup.7hour":`提前 7 小时`,
"label.weixin.forgot.password":`忘记了密码？`,
"label.import.page1.diledsizelimited":`2、上传文件最大为100M`,
"label.file.foldername":`文件夹名称`,
"label.multilingual.open":`多语言管理已启用`,
"label.dashboard.snapshot.refresh.failed":`仪表板快照刷新失败`,
"label.marketsea.memberfieldselectone":`查看字段与成员可查看字段请至少选择一个字段`,
"label.trigger.createdate":`创建时间`,
"label.ccpeak.operation.sharetab":`操作共享表：`,
"label.partner.message.admin.access":`只有系统管理员可以登录`,
"label.emailsync.status.email":`操作邮箱`,
"chatter.error":`错误：请先选择要上传的文件!`,
"label.role.viewinlist":`以列表视图显示`,
"label.tag.addtags.title":`标签`,
"setup.mainpage.label.welcome6":`用户无需任何编程知识、无需代码开发的情况下，便可在 CloudCC 系统的所有对象中都可以建立各种类型的字段，字段类型包括：查找关系、单项选择字段、双项选择、公式、自动编号、URL、电话、传真、电子邮件、复选框、日期、时间、数字、文本、文本区、选项列表（单选/多选）、币种等。`,
"label.delete.rule.successfully":`删除规则成功`,
"label.field.duplicate.error.msg6":`字段值重复。已存在记录：`,
"label.stdashbord.xsld.business.jhzsl":`机会总数量`,
"label.compact.layout":`关键信息布局`,
"label.checkfield.merge.introduce":`请选择要在合并后的记录中保留的值。`,
"earlieststarttime.duedate.time.illegal":`服务预约的最早允许开始时间应小于等于到期日期。`,
"label.dataimport.validate.prompt":`验证规则提示`,
"message.setuptip":`创建后，可删除`,
"template.report.customer.collection.statistics":`客户回款统计`,
"vue_label_homepage_dashboardcomponents":`编辑仪表板组件`,
"setup.mainpage.label.welcome30":`CloudCC 平台是真正的云计算平台，平台开放的属性、标准的集成方式、灵活的定制适用于各行各业、整合第三方软件，实现企业管理数据的实时统一，最大限度地满足客户全面深入的管理需要。 CloudCC 平台能够与任何企业应用程序或系统集成，包括SAP、金蝶、用友等第三方软件。采用灵活的SOA架构下标准 Web Service方式，不存在任何破坏性、技术依赖或厂商锁定。`,
"label.SMS.new.det":`创建一个短信通知 以关联一个或多个工作流规则、批准过程。 如果更改短信通知 ，任何修改都将应用到与之相关联的所有规则、批准。`,
"lable.product.page.previous":`返回上一页`,
"label.recordtype.labelname":`记录类型标签`,
"message.error.system.service.failure":`服务执行失败，联系系统管理员！`,
"label.visualpagefolder":`页面文件夹`,
"label.username":`用户名`,
"label.data.downpage.i.title.num5":`5、请审核数据的准确性。`,
"label.permission.manage":`管理分配`,
"label_emailsync_status_user":`用户`,
"label.weixin.voting.least.two":`投票选项至少有两个`,
"label.tabpage.thisrecord":`此记录`,
"label.icon.119":`黑板`,
"label.partner.common.webSit":`域名`,
"label.email.form.html2":`【切换为"仅文本"】`,
"label.appupload.upload.noversion":`无已上载的版本`,
"label.appointmentpage.wizard.subtitle1_2":`邀请者的时区是{0}`,
"MR":`查找多选`,
"label.partnerCloud.orderingPlatform.availableBalance":`账户可用余额`,
"label.schedulejob.setup.schedule.st3":`第三个`,
"label.reportsSubscriptionPage.email.general":`简略`,
"label.setsharerule.step4":`第四步：选择权限`,
"front-epwechat-module-v1-info-desc":`需要您从企业微信后台获取并填入以下信息`,
"message.duplication.label.isactive":`是否启用`,
"pagecreator_systemstyle_label_linkcolor":`链接颜色`,
"label.import.page1.alertfiledsize":`上传文件大小不能超过100MB!`,
"tomorrow":`明天`,
"label.publicdashboard":`未归档公用仪表板`,
"label.knowledgebase.same.taborworkspace":`相同选项卡或工作区`,
"homepage.layout":`主页布局`,
"label.emailobject.trackemailopening":`邮件追踪`,
"label.unlock.tip":`取消锁定可以进行编辑`,
"lable.account.NextzDays":`未来90天`,
"vue_label_report_throw":`丢弃`,
"label.icon.102":`日程`,
"label.payments.paytip2":`您已升级为付费版，点击确定将关闭该窗口并刷新您的CRM系统。`,
"label.customfields.email.tip":`允许用户输入电子邮件地址，对其进行验证以确保格式正确。如果对于一个联系人和潜在客户指定了此字段，则用户单击“发送电子邮件”时可以选择地址。注意，自定义电子邮件地址无法用于批量电子邮件。`,
"label.test_visitors":`测试访问者查看表单时的展示样式`,
"label.workflow.immediatelyoperate":`即时工作流操作`,
"label.approvalstep4.tip":`批准页面是批准人实际批准或拒绝请求的地方。使用下面的选项，选择要在此页面上显示的字段。`,
"label.ccchat.person.invite.failsend":`以下邀请发送失败，请联系管理员。`,
"label.import.index.obj":`对象`,
"label.multilang.leadscore.countnum":`{0}次：`,
"label.report.error.typefind":`通过分组信息没有找到报表类型`,
"label.validate.function.funcFormat.SUBSTITUTE":`SUBSTITUTE(text, old_text, new_text)`,
"label_tabpage_unpacketz":`无可用分组数据！`,
"lable.Create.new.template":`创建新服务报表模版`,
"label.knowledgebase.display.error":`显示{a}个错误`,
"label.emailobject.template.message2":`当前邮件正文中插入的字段与已关联的记录不匹配，可能会造成取值失败。`,
"label.productsales.today.taskcomplete":`设置为完成`,
"label.emailobject.selectone":`请至少选择一条记录作为邮件的收件人`,
"button_partner_workspace_saveas_memo":`将当前伙伴云另存为“模板”。`,
"vue_label_help_detail":`记录详情`,
"label.tabpage.minutesagoz":`分钟前`,
"label_tabpage_characterz":`起始字符`,
"message.error.accesstoken.null":`令牌不能为空！`,
"label.textMessageObject.send100":`非常抱歉，每天只能发送100封短信，请重新选择！`,
"vue_label_commonobjects_detail_record_call":`新建记录电话`,
"label.campaignmember.main.addlead":`添加成员-现有潜在客户`,
"setup_mainpage_label_welcome30":`CloudCC 平台是真正的云计算平台，平台开放的属性、标准的集成方式、灵活的定制适用于各行各业、整合第三方软件，实现企业管理数据的实时统一，最大限度地满足客户全面深入的管理需要。 CloudCC 平台能够与任何企业应用程序或系统集成，包括SAP、金蝶、用友等第三方软件。采用灵活的SOA架构下标准 Web Service方式，不存在任何破坏性、技术依赖或厂商锁定。`,
"label.file.library.deleteprompt":`删除文档库成员{0} ？`,
"label.wtd.changefields.title":`Web to CloudCC 设置`,
"label.sendmail.step1":`步骤 1：指定要包括的收件人`,
"label.cpq.newquote.createorder.checkbox.selected":`新建报价单时创建订单复选框不能勾选`,
"label.emailtocloudcc.name":`名称`,
"message.error.object.nullbinding":`binding为空`,
"B":`复选框`,
"label.pc.endtime":`您的许可证距离到期已经不足30天了,为了不耽误您的正常使用请及时续费。`,
"label.visualpage.section.start":`在起始处以标签`,
"label.partnerCloud.basicSetting.available":`域名可用`,
"label.data.exportall.all_desc":`导出当前用户所有有权查看的对象的数据。`,
"label.editor.layout":`编辑搜索布局`,
"label.send.chatter":`发微贴`,
"label.h5.chatter.reply":`快速回复`,
"component_chatter_post_button_file":`添加附件`,
"label.emailobject.emaildetail.button.reply":`回复`,
"label.eidt.queue.title.desc":`名称必须是唯一的，并且名称必须以字母开头，只能包含大小写字母，数字，下划线，且长度不能大于40。`,
"label.campaign.channel.input.url":`5.请设置用户注册之后能看到的信息，可以是一个感谢页面、活动宣传单或者入场券：`,
"label.compact.layout.assign.tip":`此表显示不同记录类型的关键信息布局分配。`,
"vue_label_fall":`下降`,
"label.trigger.save.failed":`保存失败，数据不能为空`,
"label.appupload.upload.tips.report":`注意：我的个人自定义报表"和"未归档公用报表"中的报表、旧报表不能添加到软件包，也不能显示在此列表中。"`,
"label.tianyancha.businessverify.rewriteall":`回填全部数据`,
"label.campaign.channel.step6.remark4":`请注意，潜在客户所有人将是当前市场活动所有人或者营销渠道邀约人，`,
"front-kefu-moudle-called-num":`被叫号码`,
"label.approvalstep4":`步骤4:选择要在批准页面布局上显示的字段`,
"label.login.verification.please.scan":`请使用智能手机上的MFA应用程序进行扫码`,
"label.invoice.message.statusupdated":`Invoice状态已更新`,
"label.pc.ui.2018.subject":`主题`,
"label.area.notexist.userinfo":`不存在的用户组`,
"label.newuser":`新建用户`,
"label.chat.micropost.share":`共享帖子`,
"label.locatedupcurrentvalue":`位于当前值的上方的值`,
"vue_label_systemSettings_course":`Lighting进程设置`,
"chatter.group.public":`公用`,
"label.reportsSubscription.entrance":`订阅`,
"front-kefu-moudle-v1-online-at":`在线聊天`,
"label.rejectbehaviourselect":`<strong>只</strong>执行此步骤的拒绝操作并将批准请求发回到最近的批准人。（返回1 步）`,
"vue_label_commonobjects_view_currentviewset":`要取消当前默认视图的设置，可将其他视图设为默认视图`,
"lable.currencyAdv.and":`和`,
"label.appexchange.installedpage.publish":`发布者`,
"label.tab.profile.ismobile":`应用于移动端`,
"label.data.setok.t.desc2":`返回到数据模板页面`,
"label.email_required":`电子邮件为必填项`,
"label.tabpage.fullscreenz":`全屏`,
"chatter.sticker.set":`微贴跟踪设置`,
"label.mobile.phone.year":`年份`,
"label.projectManagement.next.page.before":`前一页`,
"pagecreator_button_pcpage":`PC端`,
"label.dashboard.xsld.percent":`占比`,
"label.ccpeak.service.checkerror":`语法检查失败`,
"label.icon.26":`文件夹`,
"label_partner_common_webSit_memo":`贵组织中伙伴云的默认域名为：`,
"label.unselectfile":`未选择文件`,
"label.take.notice":`注意`,
"message.error.filename.null":`fileName不能为空！`,
"vue_label_SMS_nophone":`无电话号码`,
"label.area.assignuser":`分配用户`,
"label.icon.176":`提示`,
"label.icon.21":`货币`,
"message.error.system.service.deletedeny":`数据被关联,无法删除！`,
"label.compact.layout.main.tip":`选择当此对象的记录在CloudCC中以列表项出现时要使用的关键信息布局。`,
"label.emailtocloudcc.delete":`删除`,
"label.dashboardSetup.showdw.d2":`千万`,
"front-kefu-moudle-hqyyjlsb-admin":`获取语音记录失败，请联系管理员帮助`,
"label.partnerCloud.basicSetting.userCounts":`合作伙伴角色数量`,
"front-kefu-moudle-calling-num":`主叫号码`,
"label.alldocument":`所有文档`,
"coderules.nullvalue1":`生成失败,请给生成规则中使用的【{0}】录入值`,
"lable.automatically.shared":`自动共享`,
"label.batchadd.newbatchpage.save.emptyselect":`存在必选项未选择，请检查`,
"vue_label_homepage_card_30dayswithout":`30天未联系的业务机会`,
"label.multilang.dupicatecheck.onegroupnote":`请至少勾选两条数据，点击按钮【加载选中的信息】，进入数据合并页面。当前是第{0}组企业信息，
共有{1}条记录。`,
"UG.activity.03":`预约日程`,
"label.pc.oldpage":`旧版界面`,
"label.exchange.sync.state.task.m2":`在最后 60 分钟同步的记录：`,
"label.setmovable":`活动设置`,
"label.sendemail.send.loginfail":`登录邮箱失败，请重新设置邮件信息`,
"label.copy.quote.lines":`复制报价行`,
"label.copying.reward.to.groups":`复制到报价行组`,
"label.ems.connect.error":`服务器连接失败，请检查。`,
"lable.account.Tomorrow":`明天`,
"label.manageAll.sta2":`审批通过`,
"label.create_form":`创建表单`,
"label.ems.saveDetail.error.msg":`保存失败，请检查邮箱账号、密码等信息。`,
"label.service.gantt.distribution.recommendation":`分配已推荐`,
"label.email.track.attachment.size.control2":`当前上传的文件大小超过10M，无法上传。`,
"lable.product.pricebooks.add":`添加到价格手册`,
"label.login.time":`登录时间`,
"label.tabpage.yes1z":`是1`,
"label.SalesCommitmentKanBan":`销售承诺看板`,
"label_partner_workspace_myspace":`我的工作区`,
"chatter.like":`个收到喜欢`,
"lable.PowerProcess.number.input":`请输入整数`,
"chatter.coll":`收藏`,
"label.campaign.channel.img.remark":`注：图片大小不能超过2M`,
"label.field.duplicate.error.msg7":`重复的数据`,
"vue_label_pool_discard":`废弃`,
"label.service.gantt.total.planned.duration":`服务预约的计划持续时间总和`,
"label.weixin.click.loadmore":`点击加载更多`,
"label.help.new.features.yd":`移动端新界面操作指南`,
"label":`标签`,
"label.quickbooks.viewlist.total1":`共计{0}个invoice，共{1}`,
"front-kefu-moudle-v1-input-publicKey":`请输入共享密钥`,
"label.approval.allowed.reject":`允许拒绝`,
"label.visualpage.folder.notdel":`此文件夹中含有文件，不允许被删除。`,
"label.projectManagement.charging":`计费`,
"label.ccservice.validate":`对象API为{0}下的{1}字段对应值为{2}格式有误，请输入正确的数字！`,
"message.unbind.mfadevice.no.permission":`您无权限解除MFA设备绑定，请联系管理员`,
"label.partner.new.step3.meno":`不确定输入什么？别担心，您随后可以随时进行更改。`,
"label.import.page3.importsucceedtip":`成功开始导入，导入结束后会发送邮件到您绑定的邮箱`,
"label.customsetting.visible.protect":`已保护`,
"label.publishreadandwrite":`公用读/写`,
"vue_label_file_add_most_once":`单次最多添加`,
"label.salescloud.teamrole.optionlist.group":`将角色分配至业务机会小组成员和客户小组成员`,
"label.appointment.wizard.subtitle7":`地点`,
"label.task.dateminus":`减`,
"label.data.exp.zippwd":`手动输入压缩文件密码`,
"UG_Forcast_09":`下一步`,
"message.duplication.label.allselectlink":`[全选]`,
"label.file.ccchat.selectfromcloudcc":`从CloudCC中选择一个文件`,
"label.ems.addaccount3":`添加账号`,
"front-epwechat-module-v1-schedule-sync":`日程同步`,
"label.h5.manage":`管理应用`,
"setup.layout.label.nobutton":`暂无可选按钮`,
"label_component_hotdeal":`热门交易`,
"template.dashboard.contract.analysis":`合同和收款分析`,
"vue_label_dashboard_editcomponent":`编辑组件`,
"label.quotationInformation":`报价单信息`,
"label.data.file.validation_rules":`执行验证规则`,
"label.ccpeak.construction.shareobj":`构造一个对象的共享表对象，需传入对象API名称及共享标志：`,
"label.wei.pollinformation":`微投票基本信息`,
"label.quickbooks.viewlist.total3":`共计{0}个付款，共{1}`,
"label.paging.totalofpagesnoid":`共{0}页`,
"label.unlock":`解除锁定`,
"front-invoice-online-payment-information":`发票信息`,
"label.permission.systempermission":`分配的系统权限`,
"message.error.object":`调用服务时发现对象未定义;`,
"font-trade-module-v1-invoice-intro":`请输入发票编号或名称`,
"label.userinfo.pwdexpired":`当前密码已到期。基于安全原因，您现在必须更改密码。`,
"label.userphoto.photo":`简档照片`,
"label.tabularreport.filterrecord":`选择确定要显示哪些记录所使用的条件`,
"label.partnerCloud.orderingPlatform.rechargeIt":`您的账户余额不足，请充值`,
"label.icon.120":`电脑`,
"label.projectManagement.select.new.type":`选择新建类型`,
"vue_label_commonobjects_detail_customer_details":`正在加载客户详情`,
"label.ems.status":`状态`,
"label.validate.function.description":`在验证规则中可以使用符合java语法的任意函数，表达式需要返回一个布尔值；<br>还可以使用CloudCC提供的特定函数：isNew(),isChanged(字段Api名称__c),priorValue(字段Api名称__c),priorValue()返回object类型，需要转换成对应的字段类型`,
"label.escalation.setup.newaction.step2":`步骤2：选择要向其自动分配个案的用户`,
"label.forecast.customforecast.searchforecast":`查找预测`,
"label.the.upper.bound.of.each.level.of.block.pricing.must.be.greater.than.the.lower.bound.":`分块定价每1层的上界必须大于下界。`,
"vue_label_commonobjects_view_notice_deletefailreason":`id为{0}的数据删除失败，失败原因为{1};`,
"page.field.masterinput.remark":`对于已启用的主从录入，应用于前台菜单新建记录时，所录入的相关列表记录`,
"lable.SalesCommitmentKanBan.contractName":`合同名称`,
"front-gantt-module-add-milestone":`添加里程碑`,
"label.callcenter.save.error":`请不要重复保存`,
"label.workflow.selectobj":`步骤 1：选择对象`,
"label.validate.function.category.all":`-- 所有函数类别 --`,
"label.multilang.uploadifupage.select":`您共选择了{0}个文件`,
"label.weixin.dragsort":`拖动我的应用中的图标,可重新排序`,
"N":`数字`,
"label.knowledge.article.translation.completed":`文章翻译完成`,
"label.weixin.myapp":`我的应用`,
"label.icon.138":`货币`,
"vue_label_chat_create_discussion_now":`立即新建讨论`,
"label.knowledge.recover.article":`恢复文章`,
"label.ccpeak.use.class.time.map":`通过传入Map集合访问`,
"front-email-payment-error-tips":`接口错误`,
"label.service.gantt.ziyuan":`仅限为`,
"label.upload.error":`失败了`,
"label.staticresource.upload.error":`上载静态资源出错！`,
"com.cloudcc.login.error.message.loginfail":`操作失败，请联系管理员`,
"pagecreator_button_back":`上一步`,
"label_tabpage_skip":`跳至`,
"label.pw.old":`请输入旧密码`,
"pagecreator.layout.label.modifylayout":`布局编辑器`,
"vue_label_chatter_share_group":`与小组共享`,
"label.app.edit":`编辑应用程序`,
"label.user.Email.repeat":`错误：邮箱与现有坐席邮箱重复`,
"label.field.quilt":`此字段被`,
"label.projectManagement.Groupuser":`按用户分组`,
"label.deleteall":`全部删除`,
"label.appexchange.download.tiaoguo.mes":`跳过安装以下冲突组件：`,
"label.sendemail.recycle.operatehello":`#username 您好:\r\n`,
"label.emailmerge.mergeFolder.max20templates":`至多可以选择20个模板!`,
"label.campaignmember.main.deleteleaddesc":`一次从市场活动批量删除全部潜在客户`,
"Opportunity_Detailed_Phase_Label_Popup_003":`停留天数`,
"vue_label_file_no_title":`暂无标题`,
"label.data.dataexpalltype.all.desc":`导出当前用户所有有权查看的对象的数据。`,
"label.dashboard.unit2":`单位：百万`,
"label.list.userinterface.isrelatedlist":`启用相关列表悬停`,
"label.role.tree":`您的组织角色层次结构如下：`,
"label.campagin.roi.zcsl":`注册数量`,
"message.error.forecast.setupchange":`找不到您尝试访问的数据。这可能是因为其他用户删除了该数据或是发生了更改。`,
"label.sendemail.changeowner.dataname":`文档名称为:#dataname的文件`,
"label.salescloud.opportunity.contactrole.optionlist":`业务机会联系人角色选项列表值`,
"setup_mainpage_label_welcome1":`需要相应权限`,
"UG_activity_02":`分配任务`,
"label.tabpage.erraddressz":`邮箱地址格式错误,请正确输入邮箱地址。`,
"label.weixin.nicheng":`微信昵称`,
"label.forecast.settings.mrsz":`默认预测数字`,
"label.campaign.channel.download.size3":`小尺寸：300*300像素`,
"label.icon.73":`机床`,
"label.ServiceCloud.suoxuchanpin":`所需产品`,
"label.escalation.setup.newrule.description":`输入规则名，然后选取已启用"复选框，将此规则用于自动个案升级。启用此规则将禁用当前的个案升级规则。"`,
"label.data.import.setup.whichfield.cloudccid":`CloudCCID`,
"label.validate.function.funcExplain.PRIORVALUE":`返回object类型，需要转换成对应的字段类型`,
"Lead.Scoring.Warning.001":`针对单个潜在客户系统可在新建，编辑潜在客户时自动打分，但针对批量导入或者通过接口创建的潜在客户需使用批量打分手工进行。`,
"label.tianyancha.businessverify.msg9":`本《协议》的解释权归北京神州云动科技股份有限公司。`,
"label.compact.layout.tip":`关键信息布局用于在详情页面中展示记录详情的关键字段。`,
"label.visualpage.btype":`报表`,
"label.textmessage.vonage.settings":`设定`,
"label.field.not.exites":`不存在！`,
"label.payment.switch.version":`正在切换版本`,
"label.ems.hour":`小时`,
"label.weixin.cannot.edit":`该文件类型无法编辑！`,
"chatter.pt.limit":`最大文件大小为`,
"label.quote.detailinfo.add":`添加报价单明细`,
"component.setup.label.displayfield":`显示字段`,
"vue_label_report_reportfolder":`报表所在文件夹`,
"label.gbkencoding":`简体中文(GBK)`,
"front-kefu-moudle-v1-Transfer-to":`转接给{TransferName}`,
"label.file.stop.sharing.desc2":`共享`,
"label.textmessage.messageCannoutuse":`目前不可用，请联系系统管理员启用短信功能`,
"component_newrecords_label_type":`存储类别`,
"label.validate.function.funcFormat.ISNEW":`ISNEW()`,
"lable.product.pricebooks.new":`新建价格手册`,
"vue_label_newfile":`新建文件`,
"label.reportTypcrtB":`关联对象（B） 请点击选择关联对象`,
"label.knowledgebase.type":`分类`,
"label.report.select.format":`选择报表格式`,
"component.todaytask.label.title":`今天的任务`,
"message.undelete":`确定要取消删除吗？`,
"label.ccdocument.trace.retention":`痕迹保留功能`,
"label.publicgroup.tip":`公开的小组是用户的集合。它可包含各个用户、其他小组、特定角色或范围内的用户。`,
"label.forecast.settings.lable2":`预测摘要默认视图`,
"label.projectManagement.positive.integer":`请输入0-24之间的正整数`,
"label.projectManagement.one.work.list":`至少填写一条工作清单！`,
"label.or":`||或`,
"label.projectManagement.no.person.in.charge":`暂无负责人`,
"vue_label_commonobjects_detail_an_email":`发送一封电子邮件`,
"front-electronic-signature-field-mapping":`添加字段映射`,
"label.marketsea.name.error":`公海池名称不能为空`,
"component.setup.button.appurl":`本系统URL`,
"label.mr.title.button.group1":`第`,
"chatter.contact":`联系方式`,
"vue_label_pool_hasfixed":`有固定合作渠道`,
"lable.list.queue.des":`队列使用户组可以更有效地管理共享的工作量。队列是可以将记录由路由到以等待用户组成员处理的位置。记录保留在队列中，直到用户同意处理它们或者将它们转移到另一个队列。可以指定每个队列支持的一组对象，也可以指定允许从队列检索记录的一组用户。`,
"label.reportsSubscriptionPage.condition":`设置条件`,
"label.transwork":`翻译工作台`,
"label.batch.batchopration.resel":`请重新选择要转移的数据，点“OK”按钮将跳转到视图列表页面。`,
"label.cloudccsite.new":`新建站点`,
"label.button.select.page.required.field":`选择页面中的必填字段`,
"label.pagelayout":`页面布局`,
"label.weixin.trace.record":`跟踪记录`,
"label.emailtocloudcc.clear":`清空`,
"label.checkfield.find":`查找重复`,
"message.view.count.title0":`当前页面汇总`,
"label.reportsSubscriptionPage.schedulereport.frequency":`频率`,
"setup.mainpage.label.welcome5":`自定义字段`,
"label.implementation.details":`执行详细情况`,
"label.attendance.history":`考勤历史`,
"label.is.pigeonhole":`是否归档文件`,
"lable.account.CurrentandPreviousFYt":`当前和前两个会计年度`,
"label.forecast.customforecast.tab.opportunity":`销售机会子菜单`,
"label.version.business.track":`商机跟踪`,
"label.profilelayoutedit.selectrecordtype.tip":`为此用户简档选择记录类型。您需要将该记录类型字段添加到与此简档关联的页面布局上，这样才能将其显示在就详细信息页面和编辑页面上。`,
"label.campagin.roi.zclzb":`注册量占比`,
"label.validate.function.funcFormat.WEEKDAY":`WEEKDAY(date)`,
"label.view.sort.message":`按{!sort}排序`,
"page.field.masterinput.sort":`主从录入按保存的顺序显示`,
"label.selected.field":`已选搜索字段`,
"label.product.proofTwo":`请在{0}处，最少选择{1}个产品选项。`,
"vue_label_report_filtercondition":`筛选条件`,
"label.forecast.shrepage.desc1":`此页面将列出对`,
"label.file.copy.link":`复制链接`,
"vue_label_chat_movedto":`{name}将{label}更改至{newField}`,
"label.layout.new.built":`新建部分`,
"label_tabpage_crecordtypez":`更改记录类型`,
"label.report.searchcustominfo":`输入用来查找匹配自定义报表的关键字`,
"chatter.feed.menutype.user":`人员`,
"label.recordtypeselect":`选择记录类型`,
"label.partner.new.step3":`步骤3：输入名称和URL`,
"label.newCustomReportType":`新建自定义报表数据源`,
"label.service.gantt.day.timescale":`日视图上显示的时间刻度：`,
"label.displaytype3":`列表按钮`,
"label.weixin.discharge.rate":`排气量`,
"label.weixin.menu.message":`菜单信息`,
"label.mask.show.all.characters":`掩码显示所有字符`,
"label.quickbooks.fieldlabel.billingaddress":`开票地址`,
"Dashboard.View.All":`所有仪表板`,
"setup_mainpage_label_welcome22":`操作指导： 点击本页左侧菜单 → 管理设置 → 通讯模板 → 电子邮件模板。`,
"chatter.group.groupInformation":`小组信息`,
"front-epwechat-module-v1-input-secret":`请输入Secret`,
"lable.Set.value.prompt":`或者，筛选在相关列表中显示的记录。选择复选框，或选项列表字段和您想要筛选的值。如果您手动输入值，请使用逗号将其隔开。`,
"label.appupload.upload.from":`由`,
"label.weixin.postunsolve":`逾期`,
"label.cooperation.all":`全部协作`,
"lable.PowerProcess.close.time":`基于{detailInterestType}的关闭时间`,
"lable.opppdt.selPdt.leastone.fields":`请至少选择一个字段`,
"label.emailtocloudcc.help":`请输入正确的电子邮箱密码或授权码。如果您的电子邮箱服务端需要开启IMAP/SMTP服务才可由第三方客户端登录，您必须先登录电子邮箱进入设置确保此服务已开启，并复制相应授权码输入至此密码框。`,
"label.attendance.offwork.time":`下班时间`,
"front-gantt-module-v1-project-gantt":`项目甘特图`,
"label.chuangming.description":`配置创明短信接口信息，满足您组织的短信收发业务需求。`,
"label.custom.lead.notice.account.name":`您好！有潜在客户通过转换，指定您为客户、联系人及业务机会的所有人，客户名称：`,
"label.emailobject.failedtosend1":`发送失败原因：邮箱认证失效，请重新关联个人邮箱！`,
"vue_label_ccchat_notice_updaterecordsuccess":`已更新此记录`,
"label.dayinmonth":`个月的`,
"label.sendemail.chat.follow":`尊敬的#name:\n\n    您好！#userName追随了您。`,
"label.emailsync.form.emialpassword":`密码`,
"component_task_label_subject":`主题`,
"label.projectManagement.please.enter.a.positive.integer":`请输入正整数`,
"lable.account.NexteDays":`未来7天`,
"label.appupload.upload.managed":`最多只能创建一个受管软件包！`,
"label.data.dataexpalltype.all.desc1":`1、导出全部的压缩文件密码可以自动生成，或手动输入。自动生成的密码将在数据导出成功后发送到用户邮箱。手动输入的密码不会发送到用户邮箱，所以需要用户牢记自己输入的密码，若不输入，则默认没有密码。`,
"label.step1.total3":`第1步，共3步`,
"label.escalation.setup.detail.section":`规则详细信息`,
"front-gantt-module-drag-task-sorting":`拖动任务排序`,
"label.isEnableVisualpage.new.title":`启用自定义页面访问`,
"label_tabpage_yesz":`是`,
"label.emailobject.emaildetail.button.replyall":`回复全部`,
"label.knowledge.setting.data.one":`不能再继续添加子类别`,
"label.manageAll.sel.one3":`我批准过的项目`,
"UG_contact_01":`如何充分利用您的联系人?`,
"font-trade-module-v1-invoice-name":`发票名称
`,
"label.central.daylight.time":`中央夏令时`,
"label.chatter.pastThirtyday":`过去30天`,
"vue_label_commonobjects_detail_activity_ownevent":`拥有事件`,
"label.user.modify":`编辑用户`,
"label.uploadTemplate":`上载模板`,
"setup_mainpage_label_welcome14":`工作流定制、批准过程管理`,
"label.workmate":`同事`,
"label.displaycolumns":`显示的列`,
"label.emailnoticeintro":`电子邮件通知是触发工作流规则时发送的电子邮件。`,
"label.knowledge.category.button.five":`删除分类`,
"template.report.business.opportunities.type":`按类型统计的业务机会`,
"vue_labenl_applauncher_moreapp":`更多应用程序`,
"label.captcha.expired":`验证码过期，请重新领取`,
"template.chart.bnqzkhslmb":`本年潜在客户数量目标`,
"chatter.up.user.pic":`上载简档照片`,
"label.timezone.importtimezone.gmt":`使用格林威治标准时间`,
"label.step.type":`选择搜索的成员类型`,
"Dashboard.View.RecentlyView":`最近查看`,
"label.reportinthisfolder":`此文件夹中的报表`,
"label.product.vies":`产品视图`,
"pagecreator_systemstyle_message_delete_fail":`样式删除失败`,
"label.multipleactivity.singleUser":`单个用户`,
"vue_label_email_enter_subject":`输入主题`,
"label_tabpage_alltabs":`全部菜单`,
"label.publicgroup.groupname":`小组名`,
"template.report.sales.performance":`销售人员业绩`,
"label.newWindow":`新窗口`,
"label.forecast.editopp.forecastedit":`预测编辑`,
"label.data.import.setup.whichfield":`您希望将解决方案上的哪个字段用于匹配？`,
"label.noadd_dashboard":`请勿添加到仪表盘`,
"label.subtotal":`小计`,
"front-email-payment-weichat":`请使用微信“扫一扫”`,
"label.attendance.position.alert":`请先选择标注`,
"chatter.follow.me":`追随我的`,
"label.mobile.more.details":`编辑文件详细信息`,
"Dashboard_SelectBoardToDisplay":`请选择打开仪表板选项卡显示的仪表板`,
"front-gantt-module-v1-search-project":`搜索您的项目……`,
"label.paging.totalofpagereport":`共{0}页({1}条)`,
"label.from.phone":`发件人手机号`,
"lable.Signatory":`签署人：`,
"label.campagin.roi.query.roi2":`市场活动营销渠道ROI`,
"label.tabpage.selectcontentz":`请选择内容`,
"label.multilang.lookfiltercondition.valuetypenotmate":`第{0}行条件错误，值类型不匹配！`,
"label.interfaceconstraint.disabled":`此接口已被禁用，请联系系统管理员`,
"third":`第三个`,
"label.quickbooks.viewlist.status":`状态`,
"label.emailtocloudcc.select3":`请选择记录所有人`,
"label.projectManagement.week.work":`我本周的工作`,
"vue_label_pool_nodemand":`没有需求`,
"label.version.two.developapi":`二次开发API`,
"label.icon.82":`打印机`,
"label.batchadd.newbatchpage.suclist":`条数据添加成功`,
"label.checkfield.chooseatlast":`请至少选择两个`,
"label.quotation.deleteTip":`请选择需要删除的报价行。`,
"label.generatepage.title.desc2":`点保存按钮后，生成web页面及可以访问的 web URL链接。`,
"label.licence.total":`许可证总数`,
"Y":`查找关系`,
"label.wuzibiekesitan.time":`乌兹别克斯坦时间`,
"label.component.hotdeal.nodata":`无业务机会相关数据`,
"label.data.exp.save":`保存模板`,
"label.appupload.upload.tips.dashboard":`注意：我的个人仪表板"和"未归档公用仪表板"中的仪表板不能添加到软件包，也不能显示在此列表中。关联的旧报表不会上载。"`,
"lable.PowerProcess.new.PowerProcess":`新建权利过程`,
"label.loginhis.search.download":`考虑到登录历史较多，搜索下载的时候只允许下载2个月内的历史记录`,
"label.tabpage.deleteview":`删除视图`,
"label.chatter.recently":`最近`,
"label.industrialandcommercialverification.title":`工商验证`,
"message.nextapproverlost":`指定的下一个审批人为空。`,
"front-kefu-moudle-v1-mfsysy-time":`免费试用剩余天数`,
"label.role.assign.tip":`选定<b>可选用户</b>列表中显示的用户分配给角色`,
"label.addattachment.step2.intruduce":`重复步骤1和步骤2的操作，添加多个文件`,
"vue_label_pool_returnreasondiscription":`退回原因描述`,
"label.weixin.report.range":`持续时间`,
"label.wei.weiresearchtab":`微投票选项`,
"vue_label_report_setdrill":`设置钻取`,
"page_404_button_back":`返回上一步`,
"label.customfields.autonumber.tip":`系统使用您定义的显示格式生成的序列编号。该编号对于每条新记录会自动递增。`,
"label.ccpeak.return.allrecords":`返回所有记录。`,
"label.ccchat.notmember.active.group2":`您不是名称中含有`,
"label.uniquename":`唯一名称`,
"label.emailtocloudcc.filed.ssl":`安全连接`,
"chatter.emailFollowMe":`追随我的时候`,
"label.allrightsreserved.allrightsreserved.customerServiceHotline":`公司版权所有。保留所有权利。客户服务热线`,
"label.projectManagement.actualworkinghours":`实际工作时长`,
"label.quickbooks.fieldlabel.taxresale":`税收转售`,
"label.icon.12":`维修`,
"label.data.exp.dataexptemp":`数据导出模板`,
"component_setup_tabs_label_add":`新增`,
"label.appointmentdetail.wizard.title10":`空闲时间开始日期`,
"label.multilingual.close":`多语言管理未启用`,
"message.error.username.notexist":`未知的用户名，重新输入！`,
"label.batchadd.newbatchpage.des2":`若字段为自动编号类型，则无需输入，保存时系统将会为其自动生成编号`,
"vue_label_SMS_search":`搜索潜在客户或联系人`,
"label.appupload.successWithUrl":`现在可以使用以下安装URL来安装软件包。`,
"UG_Forcast_06":`请选择允许预测的用户`,
"vue_label_dashboard_secondarygroup":`请选择二级分组`,
"label.weixin..xsld.total":`漏斗总值`,
"label.setup.mobile.bottombutton.recovery.default.fail":`恢复默认失败
`,
"label.addrecurrencetimetrigger":`添加周期性时间触发器`,
"label.emailsync.connectaccount":`关联邮箱账号`,
"label_fiscal_years":`财年`,
"label.icon.164":`大巴车`,
"label.batchadd.mustinput":`带`,
"message.newtabpage.nokeywords":`请输入至少一个字符长度的关键字或使用高级搜索条件!`,
"label.login.verification.mfa.desc3":`如果您的账号已被多人共享使用，那么当您成功绑定MFA之后，其他未绑定MFA的人将无法登录。解决方法是让其他人也安装MFA应用程序并扫描此页的二维码，或者保存此二维码图片供其他人后续进行扫码。但从安全最佳实践来看，我们建议您取消多人共享账号。`,
"label.partnerCloud.basicSetting.initialize":`初始化后，您无法修改您的伙伴云域名。`,
"label.address.county":`区县`,
"label.validate.function.funcFormat.TODAY":`TODAY()`,
"label.sso.addAKey":`添加密钥`,
"label.myusergroup":`我的用户组`,
"label.import.index.time-consuming":`耗时`,
"label_tabpage_systems":`共有*个系统`,
"batch.sendemail.s":`， 邮件发送成功。`,
"label.appointment.wizard.subtitle4-1-1":`15分钟`,
"label.projectManagement.delete.milestone":`删除该里程碑，将删除里程碑和里程碑关联的所有信息，且数据无法恢复，是否确认删除`,
"label.umeng.chatter.praise":`赞了您的云贴`,
"font-evaluate-module-v1-evdetails":`评价详情：`,
"label.group.filter.resources.and":`选择筛选资源的方式，且的关系`,
"label_emailtocloudcc_description":`将您企业的邮箱，如sales@company.com, info@company.com, support@company.com添加于此，系统将自动根据所收邮件生成潜在客户或个案记录，确保及时跟进来信客户`,
"label.chat.topic.delete.prompt2":`请注意，其他社区中同一名称的主题将不会被删除。`,
"message.error.group.authorization":`您没有权限设置此小组`,
"label.attendance.wz":`地点`,
"vue_label_activity_notice_logacal_success":`您已记录电话`,
"label.emailtocloudcc.step1.case1":`Email to Case`,
"label.h5.chatter.praisenum":`收到的赞`,
"label_time_statistics_basis":`时间统计依据`,
"label.onlyadmincanedit":`<strong>只</strong>管理员可在批准过程中编辑记录。`,
"label.fieldtoolongmassage":`字段`,
"label.sales.team.shared":`业务机会小组共享`,
"label_emailsync_status_department":`部门`,
"label.mobile.quickcreate.default.sellingfunnel":`销售漏斗`,
"label.tabpage.closez":`关闭`,
"homepage.components.two":`步骤2：选择自定义组件显示位置`,
"label.everyday":`每天`,
"lable.Product.to.asset.BOM":`产品转资产BOM`,
"label.appointment.wizard.subtitle4-3":`被邀请者可以选择开始会议的间隔`,
"label.customobjects.standardfieldslist":`标准字段列表`,
"label.customfields.suretodelete":`是，我要删除该自定义字段。`,
"component.chatter.label.to":`到`,
"label.emailsync.form.seversetting":`设置`,
"label.service.gantt.enabled.resources":`已启用的资源`,
"label.tianyancha.h5.weibo":`微博`,
"template.chart.dddje":`丢单的金额`,
"label.pc.trigger.apiname":`Api Name已存在,请重试`,
"label.icon.34":`设置`,
"label.schedulejob.setup.schedule.prgname":`程序名称`,
"label.weixin.free.registration":`免费注册。`,
"label.placeholder":`请输入搜索关键字`,
"label.emailobject.manage.template":`管理邮件模板`,
"label.knowledge.article.existsdata":`存在其他数据，不符合要求`,
"label.campaign.channel.lookup.ticket":`查看入场券`,
"label.searchlayout.relation.searchfield":`搜索相关列表的搜索筛选器字段。`,
"label.recordid.cannot.empty":`记录ID不能为空`,
"label_partner_workspace_member_choice":`选择简档`,
"vue_label_campaign_amount":`收入金额`,
"label.niue.time":`纽威岛时间`,
"front-homepageobject-module-v1-workload-ranking":`工作量排行榜`,
"message.error.datainvalid":`错误：无效数据。`,
"vue_label_helpcenter_salesfunnel":`    使用新版本的销售漏斗，分析业务机会的跟进情况，为您的销售过程提供数据参考。<br>    在左上角将记录根据角色或所有人等条件筛选，查看对应条件下的全部可见业务机会，并进行分析。点击销售漏斗图的阶段，查看该阶段下的全部记录。`,
"vue_label_transferownernotice":`与此项目相关的记录的所有人也将一同更改`,
"label.monitorsys.operator":`操作人`,
"label.please.codeNorm":`请选择码标准`,
"label.campaign.channel.step6.remark2":`启用员工邀约功能`,
"market.potential.customers":`市场潜在客户`,
"label.customfields.phone.tip":`允许用户输入任何电话号码。自动将其转换为电话号码格式。`,
"label.currency.edit":`币种编辑：更改公司币种`,
"label.emailobject.emaildetail.button.markasunread":`标记为未读`,
"label_partner_template_memo":`简述`,
"label.chat.message.search.all":`搜索所有消息`,
"label_tabpage_hoursagoz":`小时前`,
"label.customcomponent.developer.help":`自定义组件开发者 帮助`,
"setup_mainpage_label_welcome":`欢迎进入 CloudCC PaaS 平台，平台主体功能如下。`,
"label.h5.similar.opportunity.list":`结果包括具有一个或多个与您的业务机会相同的字段的已结束赢得客户业务机会。把业务机会设为书签将把他们添加到您的业务机会详细信息页面上的类似业务机会相关列表。`,
"vue_label_record_count":`记录计数`,
"label.icon.29":`演示`,
"pagecreator.page.label.pagelayout":`页面布局`,
"label.ggReleaseRange.searchRole":`搜索角色`,
"label.campagin.member.field.setup":`市场活动成员字段设置`,
"augest":`八月`,
"label.salescloud.massloss.content":`禁用小组销售将删除用户的默认业务机会小组和业务机会上面的所有现有小组，且不可恢复。`,
"label.customfields.new.step2.opration.unique.info":`不允许重复值`,
"vue_label_email_optional_members":`可选成员`,
"label.emailobject.attachment.download":`下载`,
"label.recordamount":`记录数`,
"front-kefu-moudle-call-recorder":`通话录音`,
"label.more.info":`详细信息`,
"vue_label_commonobjects_view_secondsbefore":`{seconds}秒前`,
"label.emailsync.status.action":`操作`,
"label.customfields.totalsummary.collectedfields":`汇总的对象`,
"label.knowledge.setting.hint.two":`注意：在您启用Knowledge之后，您无法将其禁用。`,
"label.login.access.yujidao":`预计到`,
"label.assignment.setup.detail.description":`创建规则条目以根据其中指定的条件将记录自动分配给用户。`,
"message.error.marketsea.null":`公海池不存在`,
"lable.account.Current.CY":`当前日历年度`,
"vue_label_salesadvance_lost":`流失`,
"label.file.ownedbyme":`由我所有`,
"label.component.helper.nodata":`目前，无注意事项，请稍候检查`,
"label.weixin.appr.pending.auditor":`待审批人`,
"UG_opportunity_004":`多业务类型`,
"label.leadscore.setup":`潜在客户打分设置`,
"label.addtimetrigger":`添加时间触发器`,
"label.mr.title.match":`是否完全匹配`,
"label.projectManagement.Newmilestone":`新建里程碑`,
"label.preview":`预览`,
"label.tabpage.issuez":`问题`,
"label.img.max.size":`上传图片过大，图片最大不应超过500K。请重新上传。`,
"label.mainpageset":`主页组件配置`,
"label.user.login.false.lock":`失败次数过多，账号已被锁定`,
"UG_solution_02":`解决方案是解决客户遇到的相关问题的机构内部解决方案。`,
"vue_label_approve_put_away":`收起`,
"label.profile.existing":`现有简档`,
"label.ems.logininfo":`登录信息`,
"label.weixin.location.service":`支持定位服务的对象`,
"label.multilang.datamoveaction.totaldata":`共有{0}条符合条件的记录，每次最多可转移100条！`,
"label.ccdocument.cannot.update.set":`该文档不属于Word、Excel、PPT类型的文件,不能上传到模板套红文件夹里面！`,
"vue_label_fliter_addfliter":`添加筛选器`,
"label.custom.page.or.trigger":`（自定义页面或触发器）`,
"label.tag.filter1":`同时满足所有选中标签`,
"UG.homepage.006":`通过问卷调查、即时聊天、邮件、工单对社交媒体帖子甚至销售活动（如潜在客户、服务支持和活动）来360度了解您的客户活动。`,
"SCORE":`评分`,
"label.file.library.managemembers2":`管理文档库成员`,
"label.email.template.public.SMS":`公用短信模板文件夹`,
"label.leadscore.donot":`无法进行潜在客户打分`,
"label.gaode.map":`高德地图`,
"pagecreator_button_preview":`预览`,
"UG_contact_04":`或者`,
"label.ccchat.person.invite.eminfo":`{0}已邀请您加入CloudCC同事圈上的{1} - 贵公司的专用协作空间！使用同事圈与您的同事聊天、为您的项目创建小组，以及共享文件。`,
"setup_object_field_dependency_label_actionfieldvalue":`控制字段值`,
"lable.Product.options":`附属产品`,
"front-electronic-signature-add-autofill-field":`添加自动填充字段`,
"label.customfields.totalsummary.selectcollectedfields":`选择要汇总的对象`,
"label.projectManagement.the.maximum.contract.amount.is.10.digits":`合同金额最多输入10位`,
"label.forecast.shrepage.pagetitle":`用户，角色及区域共享`,
"label.login.access.mark":`要帮助解决支持的问题，您可以授予您的管理员作为您登录和访问您的数据权限.`,
"lable.outlook.edit.zdyout":`自定义Exchange字段映射`,
"label.approveoperate":`批准操作`,
"label.tabpage.linknamez":`链接名称`,
"label.report.error.deletehavedashboard":`此报表已新建仪表板，不能删除`,
"label.summaryreport.2018.step1":`步骤1：选择汇总信息的分组方式`,
"label.campaignmember.main.leadtomember.title":`字段映射配置`,
"label.select.dashboar.type":`请选择仪表板类型！`,
"message.setup.field.picklist.valueexists":`该选项列表值已存在`,
"label.loading":`数据加载中...`,
"label.payments.paytip1":`您的系统版本不是试用版，请点击“确定”进行刷新，或者重新登录。`,
"label.view.appliedMobile":`是否应用到移动端`,
"label.multilang.forcast.financialyear":`第{0}会计年度`,
"front-web-module-v1-detail-comment-opinion":`反馈意见`,
"UG_Forcast_10":`完成`,
"label.optionlistset":`选项列表选项`,
"label.visualpage_list.vpname":`自定义页面名称`,
"vue_label_calendar_failed_to_delete_calendar":`删除日历失败`,
"label.json.string.null":`空`,
"message.serviceappo.time.violation2":`服务预约允许时间违规:服务预约的已计划结束时间大于服务预约的到期日期`,
"label.productsales.today.noevttsk":`今天没有未处理的事件或者到期的任务`,
"label_tabpage_emptyz":`清空`,
"front-kefu-moudle-no-create":`不创建`,
"label.wedge.shaped.tail.arrow.cannot.empty":`楔形尾箭头不能为空！`,
"label.continue.shopping":`继续选购`,
"label.turntomain":`跳到主内容`,
"component.assistant.label.nodata":`今天无事项，请稍后检查。`,
"label.payments.paytip4":`请输入正确的数量！`,
"label.appupload.upload.versionName":`版本名称`,
"label.chatter.endData":`结束日期`,
"front-kefu-moudle-buytr-tip":`希望您在CloudCC客服云的呼叫中心有一个很棒的体验,您可以购买呼叫中心的正式账号,我们会提供更优质的服务。`,
"label.repw":`重复密码`,
"label.tabularreport.intro":`列表式报表是一种最简单且最快速的列示数据的方式`,
"label.selectoperatetype":`选择操作类型`,
"setup.layout.label.required":`必填`,
"label.default.designee":`默认被指派人`,
"label.ccdocument.cannotdel.folder":`该文件夹下面有文件存在，该文件夹不可删除！`,
"label.escalation.setup.newentries.inputentries":`输入规则条目`,
"label.emailobject.addnewtemplate":`创建新模板`,
"label_chatter_content":`内容`,
"label.htyj.mubiao":`目标`,
"label.reportsSubscriptionPage.schedulereport.weekly.friday":`星期五`,
"label_tabpage_fieldoptions":`记录类型字段，选项列表字段和选项列表（多选）字段，建议最多输入10个关键字，用英文逗号隔开实现或关系，如：“北京,上海,广州”。`,
"label.mobiletablayoutedit.remark2":`选择要在手机前台菜单页面显示的字段`,
"label.sendemail.chat.addComentsat":`尊敬的#name:\n\n    您好！#userName发的微贴的留言里提及了您。`,
"Z":`公式`,
"label.multilang.batchdeleteaction.movesuccess":`共有{0}条记录删除成功！`,
"label.textmessage.vonage.message2":`通过设置Nexmo API帐户，用户能够在CloudCC平台上访问Vonage API帐户以发送和接收文本消息。`,
"label.file.use.document":`存储空间使用情况`,
"UG.Lead.011":`创建一个线索`,
"label.view.name":`视图名称`,
"label.data.downtemplate":`下载模板`,
"vue_label_appstore_get_now":`立即获取`,
"label.controlfield":`控制字段`,
"label.dataimport.type.insert":`插入`,
"label.customfields.multiselect.tip":`允许用户从定义的列表中选择多个值。`,
"label.weixin.approval.qxzjl":`请选择记录`,
"component.salesperformance.label.70finish":`已结束-未处理（>70%）`,
"Lead_Auto_Scoring_Setting":`潜在客户自动打分设置`,
"pagecreator_layout_message_canntdelete":`当前布局不允许删除`,
"vue_label_report_exprotpage":`导出页数：第{page}页`,
"label.campaign.channel.step4":`步骤4：营销渠道注册页面必填字段设置`,
"label.app.launcher":`应用程序启动器`,
"vue_label_campaign_selectedmember":`已选择{member}个市场活动成员`,
"label.mobile.quickcreate.default.approvals":`待审批`,
"label.view.step4":`步骤4.限制可视性`,
"label.exchange.sync.state.user":`用户同步状态`,
"label.forecast.customforecast.tab.forecast":`预测子菜单`,
"label.theUserLoginForTheFirstTime":`用户首次登录`,
"label.workflowoperate.tip":`指定在满足规则条件时要触发的工作流操作`,
"font-evaluate-module-v1-ten-points":`好评得分：10分`,
"label.knowledge.delete":`删除知识出错`,
"front-console-see-contacts":`识别出{num}个联系人`,
"label.h5.similar.opportunity.add.to.favorites":`添加到书签`,
"front-epwechat-module-v1-install-app":`在企业微信中安装应用`,
"setup_layout_message_relatedlistbutton":`选择在相关列表上显示的标准按钮。`,
"label.salescloud.massloss.title":`可能导致大量数据丢失`,
"front-console-conversation-btn1":`电话回复`,
"label.custom.canvasScale":`画布比例`,
"label.lead.score.doing":`正在进行潜在客户打分`,
"message.approval.step.validation.invalid.number":`输入正确的数字`,
"chatter.lk":`喜欢`,
"label.dashboardSetup.showmaxval":`显示最大数值`,
"label.keywords":`关键字`,
"vue_label_helpcenter_SMS":`开启短信功能<br>    如果您购买的CRM系统的countrycode是USA，那贵组织系统内有短信的功能。组织管理员可在后台集成应用中vonage网关中输入贵组织在vonage系统内购买的电话号码，即可在销售云应用程序的菜单中使用短信功能。<br>短信收发箱<br>    短信收发箱分为两部分，左侧为有短信往来的潜在客户或联系人记录，单击某条记录后右侧显示收发详情。您可以查看自己以及自己下级的记录。<br>群发短信<br>    可以在短信菜单、潜在客户或联系人列表、市场活动成员上的发送短信的按钮群发短信。您只能给CRM内的潜在客户或联系人发送短信，编辑好短信后选择“发送”，则不管收件人的数量是多少都生成一条群发记录，或者选择“分别发送”，分别发送的短信支持显示短信模版中插入的合并字段。`,
"label.emailobject.createnewavailability":`创建日程预约链接`,
"front-kefu-moudle-buytr-send-email":`您尚未关联系统邮箱，请您发送邮件到邮箱support@cloudcc.com，请写明您的意图，公司名称，以及联系方式，销售人员会尽快与您取得联系。`,
"front-kefu-moudle-v1-Put-away-the-chat":`收起聊天详情`,
"label.marketseamemset.lead.maxuser":`成员最大潜在客户数`,
"label.forecast.forecastroleuserpage.shre.manager":`只有管理员才能共享该预测`,
"label.file.noselect":`未选择任何文件`,
"label.notification.task3":`您分配给【被分配人】的任务状态被修改为【新状态】`,
"label.dependfield":`依赖字段`,
"lable.SalesCommitmentKanBan.receipts":`收款`,
"label_partner_workspace_member_search":`搜索`,
"label.share.originally.posted":`初始张贴者`,
"label.autonumber":`自动编号`,
"label.view.sortview.name":`视图名称`,
"label.h5.add.activity":`添加活动`,
"label.textmessage.vonage.phone.number":`电话号码`,
"label.partnerCloud.financeSetting.enterApiKey":`请输入API密钥`,
"label.industrialandcommercialverification.enablestatus":`启用状态`,
"label.reportTypeFocusD1":`指定哪种记录(行)类型将成为由此报表数据源生成的报表的焦点。`,
"vue_label_report_four-levelseriesobjecttree":`四级串联式对象树`,
"label.mobile.default.catalogue":`默认目录`,
"label.partnerCloud.partnerAccount.again":`再次充值`,
"label.summaryreport.step2.new":`步骤 2：选择汇总信息的分组方式`,
"label.tabpage.cancel":`取消`,
"label.multilang.datamovelist.datamove":`将多个{0}从一个用户转移到另一个用户`,
"label.conferloginandvisitlimit":`授予登录访问权限`,
"vue_label_help_viewhelpcenter":`查看CloudCC帮助中心`,
"label.leadscore.norule":`没有打分规则，请先创建打分规则或者激活已经创建的打分规则`,
"label.tabpage.exitz":`退出`,
"label.DeploymentStatus":`开发状态`,
"label.layout.saving":`布局保存中...`,
"label.emailobject.emaildetail.field.object":`对象`,
"label.customfields.searchrelation.fieldtag.tip":`输入要在显示视图、页面布局视图、报表视图和列表视图上使用的标签`,
"message.huanxin.bindtenant.notfound":`用户未绑定坐席`,
"label.referpersonalias":`提交人别名`,
"label.icon.31":`电脑`,
"label.appupload.upload.install.thispackage":`此软件包`,
"label.appointment.wizard.subtitle1-1":`自定义`,
"pagecreator_page_message_save_fail":`页面保存失败`,
"label.lastset":`最后按`,
"label.version.support.limited":`支持受限`,
"vue_label_homepage_kanban":`看板`,
"label.layout.editsearchdistribute":`编辑页面搜索布局`,
"template.dashboard.customer.analysis":`客户分析`,
"label.continue_editing":`继续编辑`,
"label.version.sum.customtab":`个自定义菜单`,
"label.validate.function.funcExplain.TIMEVALUE":`返回日期/时间字段中的时间部分（时分秒）`,
"label.import.page1.selectobjfromdata":`选择要导入数据的对象`,
"label.partnerCloud.basicSetting.success":`初始化成功`,
"label.customfields.fielddependency.cannotcreat":`不能创建依赖关系，您选择的字段直接或间接依赖它本身`,
"label.umeng.activity.youhaveatask":`您有1个新任务`,
"label.file.folder.create":`新建文件夹`,
"vue_label_campaign_member_status":`成员状态`,
"lable.opppdt.addpdt.table.date":`日期`,
"label_partner_workspace_login_buttontext":`按钮文本`,
"label_other_mistakes":`其它错误`,
"label.must.be.configured":`必须配置`,
"label.customize.memory.function.sorting.enable":`启用视图表头排序记忆`,
"setup.layout.label.areaname":`区域名称`,
"label_chatter_pastThirtyday":`过去30天`,
"setup_mainpage_label_welcome25":`操作指导： 点击本页左侧菜单 → 管理设置 → 安全性控制 → 共享设置。`,
"label.ccchat.person.invite.succsend":`加入同事圈的邀请被发送到`,
"label.select.time.range":`请选择时间范围`,
"label.partnerCloud.orderingPlatform.djustQuantity":`将产品添加至购物车，并在购物车中调整数量并查看价格`,
"label.manageAll.sta1":`审批中`,
"label.cy.select":`请选择币种`,
"chatter.lam":`留言`,
"label.partner.setup.title":`设置`,
"component.setup.label.displaybutton":`显示按钮`,
"component.salesperformance.label.target":`目标`,
"label.campagin.channel":`请输入注册渠道的值`,
"label.validate.function.funcFormat.ISCHANGED":`ISCHANGED(field)`,
"UG.homepage.009":`访问CRM`,
"label.file.item":`项目`,
"label.file.library.addmembprompt":`已经是管理成员，不要重复添加`,
"label.bmap.releasePosition":`发帖位置`,
"setup_object_layout_label_selectedprofile":`已选简档`,
"label_emailsync_message":`提示`,
"label.view_submissions":`查看提交量`,
"lable.tianyancha.repeated":`重复选择`,
"label.import.index.introduce":`通过简单的三步，将您的数据导入到系统中`,
"label.time.operation.new":`新建定时作业`,
"label.projectManagement.Pleaseentersettlementtype":`请输入结算类型`,
"label.icon.169":`观光车`,
"vue_label_commonobjects_detail_related_listview":`列表展示`,
"label.view.step1":`步骤1.输入视图名称`,
"label.summaryreport.intro":`汇总报表同时列示数据小计和其它汇总信息`,
"vue_label_file_input_correct_name":`请填写正确的名称`,
"System_Email_Template_Title":`欢迎您使用CloudCC CRM平台`,
"label.tianyancha.province":`省份缩写`,
"label.deleteall.sure":`确定要全部删除吗？`,
"label.passwordPolicy.setup.uppercasealpandnum":`必须包含大小写字母及数字`,
"front-lightning-module-v1-details-page-chart-select":`选择对象与展示方式`,
"setup_mainpage_label_welcome8":`拖拽式界面定制`,
"lable.outlook.edit.lastupc":`最后更新的联系人`,
"label.weixin.registered":`注册`,
"vue_label_file_history_version":`历史版本`,
"vue_label_campaign_earned":`待收入金额`,
"label.staticresource.useful.realtion.tip":`以下是所有对此静态资源的页面引用`,
"vue_label_file_libraray":`文件库`,
"label.department.phone":`手机号`,
"label.emailtemplate.edit":`编辑邮件模板`,
"label.processsetting.key.information.tips":`关键信息与小贴士`,
"label.summaryreport.step7":`步骤 7：选择图表类型和报表突出显示`,
"label.chat.topic.remove.favorite":`从收藏夹删除`,
"label.campagin.roi.ksrq":`开始日期`,
"label.data.downpage.e_title.e_btn":`进入导出页面，开始导出`,
"label.approvaldatamove.dname":`当前批准人`,
"lable.Partial.attributes":`部分属性`,
"template.report.enabled.products":`已启用的产品`,
"lable.outlook.detail.cto":`CloudCC.com 到 Exchange`,
"label.sendemail.activity.newtasktitle":`新任务通知`,
"label.validate.function.funcFormat.DAY":`DAY(date)`,
"label.log.datetime.value":`请输入查询时间!`,
"label.import.index.updaterecord":`更新记录`,
"label.registration.page.invitation":`注册页面邀约`,
"pagecreator_systemstyle_label_detailcolor":`明细文字颜色`,
"label.tabname.cannot.empty":`菜单名不能为空！`,
"label.data.newtemplate.savetemp":`您可以勾选另存为模板，将此次数据导出所选择的字段及条件作为数据导出模板，保存到模板页面。请认真填写模板名称和模板描述,方便日后使用。`,
"label.ems.body":`正文`,
"enc":`加密文本(存储加密)`,
"label.profile.mobile.setup.commonSaler":`普通销售`,
"label.continueselectproduct":`继续选择产品`,
"label.event.new":`新建事件`,
"label.renametabandtaglib":`重命名菜单和标签`,
"label.qrcodelogin.message.exception":`服务端异常，请联系管理员`,
"label.service.gantt.locationToGantt":`甘特表`,
"label.mr.theLastGroup":`这已经是最后一组。请点击【返回查看重复数据列表】，查看重复数据。`,
"label.report.export.format.content":`导出当前报表表头、分组与详细信息。详细信息最大导出`,
"label.version.accountandcontact":`客户和联系人`,
"label.partnerCloud.financeSetting.enterMd5Key":`请输入MD5密钥`,
"label.login.access.quater":`周`,
"vue_label_commonobjects_view_searchthisview":`搜索此列表`,
"label.import.step1.allobj":`全部对象`,
"front-efficient-project-management":`项目云提供从项目启动、计划、执行、控制和结束的全生命周期管理，根据企业需求优化项目管理流程，帮助您高效管理项目。`,
"label.includedvalue":`包括的值`,
"label.service.newBuildDialog.past.days":`过去天数`,
"vue_label_report_sortup":`按升序排列`,
"label.appointment.wizard.subtitle3-2":`周二`,
"label.dashboard.trend":`趋势`,
"label.schedulejob.setup.schedule.st2":`第二个`,
"label.view.sortview.number":`记录数目`,
"lable.Please.enable.order":`订单未启用，请先启用订单`,
"label.datamanage.immediately.import":`立即导入`,
"label.delete.condition":`清除`,
"label.dashboard.chooseDispalyOnTheHomePage":`选择显示的主页`,
"asset.accountid.contactid.required":`每个资产都需要关联客户或联系人。`,
"label.mask.character":`掩码字符`,
"lable.account.Previous.FY":`上一个会计年度`,
"chatter.attachment":`附加文件`,
"label.view_only":`仅查看`,
"label.tianyancha.name":`企业名称`,
"label.service.gantt.avg.traveltime":`服务预约的平均出行时间`,
"vue_label_pool_move":`转移`,
"label.import.index.beforeexport":`2、导入之前，请先确保导入其相关的所有记录。例如：如果您正在导入联系人记录，且要填写客户字段（是一个查找字段），则需先创建好所填写的客户记录，然后再导入联系人记录，并在客户字段中填入对应客户的名称或id。`,
"label.view.delete":`删除视图`,
"template.detail.info.link":`详细信息链接`,
"label.sendemail.send.setfail":`设置邮箱信息失败，请正确配置邮箱信息`,
"label_emailtocloudcc_redmessage11":`SMTP认证失败，请检查电子邮件地址与密码是否正确`,
"label.campaigns.memberalert":`请至少选择一个成员`,
"label.schedulejob.setup.schedule.frequency":`频率`,
"component.newrecords.label.all":`查看全部`,
"label.mr.caption.opportunity":`查重合并：查询业务机会重复数据的条件`,
"chatter.group.onlyMembers":`仅成员可见这个小组。小组所有人有权添加小组成员。`,
"label.recordtype.edit.selectvalue.show":`选项列表值按保存的顺序显示`,
"message.textmaxlength":`长度不能超过255`,
"label.reportsSubscriptionPage.visibility":`以下列用户视角运行报表`,
"label.umeng.chatter.addcoments":`您的云贴有1条新回复`,
"chatter.up.f":`上传失败,未知错误。`,
"label.icon.146":`键盘`,
"lable.custom.CY.Ago":`两个自定义年度之前`,
"label.tabpage.step3":`步骤3 选择展示字段`,
"label.checkfield.introduce":`设置对象中可以查重的字段，在数据列表中可根据设置的字段对数据进行查重`,
"label.tag.addtags":`添加标签`,
"label.service.newBuildDialog.characterlimit":`名称超出25个字符限制`,
"font-evaluate-module-v1-evquestions":`评价问题：`,
"label.knowledge.only.update.draft":`只能更新草稿文章`,
"label.partnerCloud.basicSetting.defaultCounts":`添加合作伙伴客户时创建的默认角色数量`,
"label.chat.topic.delete":`删除`,
"label.workflow.contentcondition":`条件得到满足`,
"vue_label_commonobjects_view_sortby":`按{field}排序`,
"label.passwordPolicy.setup.pwdremember24":`记住{0}个密码`,
"front-kefu-moudle-free-account":`试用账号`,
"label.marketsea.isautorecycle":`启用自动回收`,
"label.addattachment.view":`查看文件`,
"vue_label_helpcenter_contact":`在详细信息中，点击联系人旁边的树状图按钮，可以查看联系人层次结构图，了解相关联系人的上下级关系，并查看每个联系人的部分字段信息。`,
"label.taskevent":`任务事件`,
"label.industrialandcommercialverification.message":`今日免费查询次数已用完`,
"label.object.already.delete":`对象已删除。`,
"label.project.hit.four":`子任务更新通知`,
"label.taskpagelayout":`任务页面布局`,
"label.version.sum.locationfield":`个地理定位字段`,
"front-sales-button-toQB":`同步至QuickBooks`,
"label.app.oceanblue":`深海蓝`,
"label.operating":`操作中...`,
"label.customfields.formula.dateexample":`Reminder Date（提醒日期）= CloseDate - 7`,
"label.happen_delete":`删除表单有什么影响？`,
"label.service.appointmentList.plansToStart":`计划开始`,
"label.persmets.operate.licence":`许可`,
"label.mobile.quickcreate.default.activities":`日历`,
"label.australian.eastem.standard.time":`东部夏令时（新南威尔斯）`,
"label.emailobject.remove":`删除`,
"label.weixin.vote":`参与投票`,
"label.reportsSubscriptionPage.condition.aggregate":`合计`,
"front-kefu-moudle-has-unbind":`您已被解绑`,
"chatter.group.newGroup":`新建组`,
"label.tabpage.systems":`共有*个系统`,
"label.textmessage.vonage.connect":`连接到Vonage`,
"label.campaign.channel.input.ticket":`发送入场券`,
"label.ccpeak.query.sharetab":`查询共享表`,
"label.reporttype":`报表数据源`,
"message.duplication.label.isprofiletip":`如果勾选，查重时会校验当前用户所能看到的数据.否则,校验所有数据`,
"label.tianyancha.businessverify.xieyi":`用户许可协议`,
"font-evaluate-module-v1-select-person":`请选择客服人员`,
"vue_label_chatter_all_groups":`所有小组`,
"label.recordtype.profile.setdefault":`设置默认`,
"label.mr.descreption.nocondition":`没有符合条件的重复数据。`,
"label.tabpage.askz":`你想提问什么`,
"label.marketsea.selectMember":`选择成员`,
"template.report.stage.possibility.analysis":`阶段可能性分析`,
"label.data.selectderivedobject":`选择需要导出的对象`,
"label.customfields.formula.explain":`说明：目前支持数字、百分比等字段的四则运算，以及查找字段的带值。示例：数字类型公式jine*knxing&nbsp;&nbsp;&nbsp;&nbsp;查找字段带值：khmc__r.dianhua`,
"vue_label_notice_change_fail":`更改失败`,
"label.customobjects.trackoldandnewvalues":`跟踪旧值和新值`,
"label.h5.leftprompt":`您有编辑的内容未发送是否确认离开？`,
"label.select.field":`可选字段`,
"label.customobjects.layoutedit":`页面布局分配`,
"label.false":`假`,
"UG_Forcast_07":`允许预测`,
"vue_label_chatter_team_member":`小组成员`,
"label.tabpage.retypez":`更改记录的记录类型时，现有选项列表值不会自动更改。我们建议在相同的地方更新记录上的现有选项列表值。`,
"front-epwechat-module-v1-single-desc":`通过企业微信单点登录到CloudCC的其他终端，快速在各端之间切换`,
"label.closeandconverted":`关闭-已转化`,
"label.service.confirmed":`已确认`,
"label.partner.workspace.member.cloudcc":`CloudCC 简档`,
"label.star.click":`点击清零`,
"label.icon.135":`货币`,
"button_partner_workspace_login_logo_upload":`上传图片`,
"message.error.sql.constraint.recordnotsingle":`设置外部ID未成功！原因:原来的数据中该字段有重复数据`,
"label.ccchat.person.invite.errorpwd":`使用至少8个字符并且包含数字和字符的组合`,
"label_tabpage_isdeleterecord":`是否删除已选中记录`,
"label.weixin.prompt.message":`提示信息`,
"vue_label_chatter_view_original_post":`查看原始帖子`,
"label.multilingual.tip3":`启用多语言可以允许组织内每个用户配置您启用的语言种类`,
"label.dataimport.error.datetime":`出现错误：日期时间`,
"label_tabpage_addcondition":`添加条件`,
"label.query.detail.manageexcludeuser":`管理外部用户`,
"label.tianyancha.creditcode":`统一社会信用代码`,
"label.cy.enter":`输入贵公司使用的币种转化成新币种的兑换率`,
"label.textmessage.vonage.message1":`通过对接Vonage，用户可以在CloudCC平台上收发短信。但是在这之前用户需要注册Vonage账户并购买电话号码。`,
"front-marketing-module-v1-share-invitation":`分享员工邀约`,
"label.file.items":`个项目`,
"label.otherwise":`否则`,
"label.permission.detail.system":`系统`,
"message.success.task.emailsend":`保存发送电子邮件信息成功`,
"label.the.reward.group":`报价行组`,
"setup.layout.label.relatedlistsetup":`相关列表设置`,
"label.empty":`清空`,
"label.weixin.cloudcc.user.binding":`CloudCC用户绑定`,
"label.file.what.change":`发送什么更改（可选）`,
"label.search":`搜索`,
"label.mobile":`手机`,
"template.report.month.potential.customer":`本月的潜在客户`,
"lable.setup.mobilesetup.isEnableValidationRulesForScan":`名片扫描是否启用验证规则`,
"lable.outlook.list.des":`Exchange Sync 配置定义要应用到特定用户组的CloudCC for Exchange 的设置。`,
"label.appupload.install.error.info":`{0}“{1}”已被{2}使用，请重新命名现有{0}。`,
"label.tabpage.addoptionsz":`添加选项`,
"label.arabian.standard.time":`阿拉伯标准时间`,
"label.thefirst":`第一列`,
"label_partner_workspace_login_footertext":`页脚文本`,
"lable.Disabled.successfully":`禁用成功`,
"label.confirm.del":`正在审批中的记录，请确认删除。`,
"vue_label_normal_reregister":`重新登录`,
"label_file_img":`图片`,
"label.salescloud.salesdashboard.sales.behavior":`销售行为`,
"label.startdate":`开始日期`,
"label.field.duplicate.error.msg5":`请查看下列所有错误消息并改正后重试。`,
"setup.main2018.label.managesetup":`管理设置`,
"label.forecast.editshrepage.title":`新建共享`,
"UG.solution.01":`提供解决方案`,
"label.knowledgebase.data.recovery.successfully":`{a}条数据恢复成功`,
"label.pc.ui.2018.myccchat":`我的CCChat`,
"label.attachement":`备注及附件`,
"message.mobilechooseatmostten":`最多选取十个字段`,
"label.campagin.roi.bhzeywjh":`总业务机会数`,
"label.autoresponserule":`自动响应规则`,
"label.attendance.yuyue":`您未预约，是否需要现场注册？`,
"label.insert":`插入`,
"label.service.ganttBaiduMap.shutDown":`确认关闭？`,
"label.icon.194":`电视`,
"message.serviceterritory.violation":`区域违规:资源区域不匹配服务预约的服务区域`,
"label.appointment.disable.function":`禁用功能`,
"lable.currencyManage.manageexchangeRate.dis":`要管理您公司的过期汇率，请单击管理过期汇率"。过期汇率适用于业务机会、业务机会产品和这两个对象相关的报表。"`,
"vue_label_file_upload_tip_newmsg":`建议上传文件小于{size}MB，否则可能导致页面加载缓慢`,
"label.event.next.week":`未来一周的事件`,
"label.datamanage.import.contactfield":`在下表中，选择导入文件中应导入到每个联系人的字段。完成操作后，点击下一步：`,
"label.projectManagement.time.allocated":`已分配时间`,
"label_tabpage_isdeleteview":`您确定是否删除此视图？`,
"label.pc.ui.2018.search":`请输入搜索内容`,
"label.role.createrolelevel":`创建角色层次结构`,
"label.tabpage.editview":`编辑视图`,
"label_partner_common_manageSetup":`伙伴云管理设置`,
"label.service.gantt.noservice.resource":`选择的服务区域下没找到任何可用的服务资源`,
"message.numbertoolarge":`数字太大`,
"label.sendsms.success":`短信发送成功`,
"UG.opportunity.009":`或者`,
"label.ccpeak.construction.dataobj":`构造一个数据对象，需传入对象API名称：`,
"front-lighting-module-v1-detail-file-uploadInfo":`记录已锁定，不支持上传文件，请联系管理员解锁。`,
"label.import.page2.newnotmatchfiled":`文件中共{{ csvfiledlength }}个字段，剩余{{this.csvfiledlength - this.selectlength}}个未映射`,
"label.ems.inputmailss":`接收邮件服务器`,
"label.knowledgebase.data.published.successfully":`{a}条数据发布成功`,
"label_emailtocloudcc_position":`职位`,
"label.data.exp.customexp":`自定义导出`,
"component_chatter_post_button_user":`添加人员`,
"label.new.visualpagefolder":`自定义页面：新建文件夹`,
"label.forecast.shrepage.classdes":`访问权限级别说明`,
"label.task.overdue.unfinished":`逾期未完成任务`,
"label.ccchat.micropost.isedit.setting.info":`帖子或留言的作者、记录所有人、ccchat 版主和此社区的版主均具备修改该文本的权限。`,
"label.recordname":`记录名`,
"label.posted_your":`并发布在您的`,
"label.globaloperation.operationtype.custom.page":`自定义页面`,
"label_tabpage_busoppnamez":`业务机会名`,
"front-epwechat-module-v1-schedule-desc":`同步企业微信日程与CloudCC事件`,
"label.escalation.setup.newentries.lastmodifydate":`根据上次修改个案时间`,
"setup_layout_label_nofield":`暂无可选字段`,
"label.sendemail.registIMUser.logininfo":`您可以登录的伙伴云门户如下：<br>`,
"label.weixin..xsld.kehu":`客户`,
"label.display_thank":`显示感谢信息`,
"label.group.no.my.group":`没有匹配的我的小组。`,
"label.partnerCloud.newBuildSite.enterDomain":`请输入域名`,
"label.step1.total2":`第1步，共2步`,
"label.ccpeak.delete.record":`删除记录：`,
"label.customer.tab.step1.introduce":`为此新自定义菜单选择自定义对象并输入其它详细信息`,
"label_tabpage_newInterfacez":`新版界面`,
"setup.mainpage.label.manageuser":`管理用户`,
"label.partnerCloud.partnerAccount.completed":`已完成支付？`,
"label.projectManagement.kanban":`任务看板`,
"label.operate":`操作`,
"label.service.dispatchingUnits.selected.time.range":`显示选定时间范围内的服务预约`,
"component_setup_label_pagesize":`每页显示条数`,
"font-evaluate-module-v1-email-evaluation-settings":`邮件评价设置`,
"label.service.dispatchingUnits.skills":`技能`,
"label.editrecurrencetimetrigger":`编辑周期性时间触发器`,
"vue_label_file_edit_lib":`编辑文件库`,
"label.campaignmember.selectmember.deleteconc":`市场活动：从联系人中删除成员`,
"label.reportsSubscriptionPage.schedulereport.monthly.day.monday":`星期一`,
"front-detail-module-v1-by":`截至`,
"label.mobile.home.page.date.signed":`预计签约日期`,
"label.apply.send.success":`发送成功！`,
"label.app.choseimg":`选择徽标`,
"label.customsetting.visible":`可见性`,
"label.sendemail.activity.task.distributetaskcompleted":`您分配给#belongtoidccname的任务已经标示为完成`,
"label.dashboard.snapshot.refreshing":`正在刷新`,
"label.document.name.already.exists":`文档唯一名称已经存在！`,
"label.ccchat.person.invite.needlastname":`输入您的姓`,
"pagecreator_page_button_copy":`复制`,
"label.appointmentpage.wizard.subtitle1-2":`上一周`,
"label.validate.function.funcFormat.MILLISECOND":`MILLISECOND(date)`,
"label.profile.allowtocreateview":`创建视图`,
"message.error.recordid":`记录id不能为空`,
"lable.SalesCommitmentKanBan.returnToTheSuperiorRole":`返回上级角色`,
"label.translation.start3":`如有必要，选择一个对象。例如，工作流任务有对象（账户、联系人等等）来筛选翻译术语。`,
"label.ccpeak.send.email":`发邮件通知：`,
"vue_label_commonobjects_detail_activity_noexpirationdate":`无到期日期`,
"label.permission.objectpermission.objpermission":`对象权限设置`,
"label.version.custom.report":`标准报表（自定义页面）`,
"label.title.qrcodeOrbarcode":`生成条码/二维码规则`,
"label.emailtocloudcc.step2.name":`配置邮件归属`,
"label.reportsSubscription.edited.successfully":`报表订阅编辑成功！`,
"label_tabpage_kanbansetup":`看板设置`,
"label.tianyancha.regcapital":`注册资金`,
"front-epwechat-module-v1-web-single":`web单点登录：`,
"label.visualpage.display.top":`显示页头，false-不显示页头`,
"label.customfields.fielddependency.selectcell":`从下表中至少选择一个单元格。`,
"label.paging.addmember.totalofpages":`共<span id='recordCount'></span>&nbsp;&nbsp;<span id='recordRange'></span>条&nbsp;&nbsp;`,
"label.email.saveing":`数据保存中 ···`,
"label.userinfo.doublepwd.notnull":`重复密码不能为空！`,
"label.appointment.wizard.subtitle4-4-2":`两周`,
"label.chatter.BCC":`密件抄送`,
"label.emailtocloudcc.description":`将您企业的邮箱，如sales@company.com, info@company.com, support@company.com添加于此，系统将自动根据所收邮件生成潜在客户或个案记录，确保及时跟进来信客户`,
"label.sendemail.send.atlastone":`收件人至少有一个`,
"label.mobile.phone.subordinate":`是否包含下属`,
"label.data.choses.e_desc":`根据您的需要，可以选择导出全部数据或选择导出单个对象的数据。`,
"chatter.new":`消息`,
"vue_label_help_back":`返回上一级`,
"label.skipwizardintro":`跳转起点向导在几分钟内就可以为您创建一个一步的批准过程.`,
"label.weixin.fmu.before.week":`提前 {0} 周`,
"label.sendemail.chat.praiseFeedsubject":`CloudCC CCChat 喜欢您的微贴`,
"lable.currencyAdv.andafterdate":`和 之后的日期`,
"label.sometoprocess":`如果只有某些类型的记录能够进入此批准过程，请在下面输入条件。例如，只有总部员工的费用报表应该使用此批准过程。`,
"label.campaignmember.main.updateleaddesc":`一次更新所有现有潜在客户的状态`,
"label_partner_common_roleSetup":`伙伴云角色和用户设置`,
"label.console.step5.no":`选择如何显示记录`,
"label.salescloud.teamrole.optionlist.account":`将客户小组成员添加到`,
"Report.Delete.Confirm.Title":`请确认`,
"label.onclick":`单击`,
"label.weixin.input.identifying.code":`请输入验证码`,
"label.knowledge.translate":`只有为草稿或者已发布的主版本知识文章可以被翻译`,
"label.log.ip":`IP`,
"front-electronic-export-goResult":`去Mailchimp查看`,
"label.escalation.setup.newaction.otheremail.otheremail":`其它电子邮件`,
"label.icon.104":`日程`,
"label.partnerCloud.exceedTwo":`上传头像图片大小不能超过2MB!`,
"label_tabpage_thevalurofz":`的值`,
"front-lightning-module-v1-details-page-chart-maximum":`最多输入50个字符`,
"label.data.downpage.i.title.num6":`建议您在导入数据之前，先导入一个包含5条记录的测试文件，以确保所准备的导入文件正确无误。`,
"label.ccpeak.update.record":`修改记录：`,
"label.dataimportandexport":`数据导入导出`,
"label.tabpage.notexceed25":`选择的记录不能超过25条`,
"label.starting":`进行中`,
"label.knowledge.language.spanish":`西班牙语`,
"label_emailtocloudcc_set":`设置邮箱信息`,
"message.oneormoreneedsreport":`仪表板使用此报表。请先删除引用此报表的仪表板组件，然后重试。`,
"label.attendance.xccheckin":`现场签到`,
"label.emailmerge.editfolder.title":`邮件合并模板文件夹`,
"template.report.year.customer":`本年潜在客户`,
"label.partner.common.webSit.memo":`贵组织中伙伴云的默认域名为：`,
"label.partnerCloud.financeSetting.onlinePayment":`线上支付`,
"Pagelayout.Setup.001":`选择要在悬停页面布局上显示的相关列表`,
"front-kefu-moudle-time-length":`时长`,
"label.deleteObject":`对象已删除。`,
"label.setup.mobile.homepageshortcuts.select":`选择需要显示在主页顶部区域的4个快捷功能`,
"setup.mainpage.label.welcome26":`数据管理 - 批处理功能`,
"label.ServiceCloud.yuyuebainhao":`服务预约编号`,
"label.emailobject.emaildetail.button.addtolead":`添加到潜在客户`,
"label.event.single.view":`单人视图`,
"lable.product.pricebooks.ustand":`使用标准价格`,
"label.emailtocloudcc.department":`分部`,
"component_assistant_label_30daysnoact":`30天没有任何活动`,
"label.weixin.no.pending.qzkh.qin":`亲，目前没有潜在客户数据`,
"label.vlidaterule.formula":`错误条件公式`,
"label.tianyancha.h5.contact":`联系信息`,
"label.button":`按钮`,
"message.checkemail":`<strong>错误：</strong> 电子邮件输入有误，请检查`,
"lable.account.previous.CY":`上一个日历年度`,
"label.icon.13":`维修`,
"chatter.coll.c":`取消收藏`,
"label.knowledge.category.hint.four":`数据分类分配`,
"label.tianyancha.phonenumber":`联系方式`,
"label.tablayoutedit.remark":`选择要在前台菜单页面显示的字段及自定义页面`,
"label.shareusers":`共享用户`,
"label.endtime":`结束时间`,
"label.length":`长度`,
"label.umeng.activity.event.begin":`后开始`,
"label.tabpage.alltabs":`全部菜单`,
"label.exact.query":`精确查询`,
"label.weixin.skip":`跳转`,
"label.ems.cancel":`取消`,
"label.trigger":`触发器`,
"label.exchange.sync.setting":`Exchange Sync 设置`,
"label.product.pricebooks.name":`价格手册名称`,
"label.relation.list.total":`共计选中`,
"label.step2.total7":`第2步，共7步`,
"label.martrixreport.2018.step6.new":`步骤6：选择图表类型和报表突出显示`,
"label.standard.buttonandlink.override":`覆盖`,
"front-console-conversation-btn4":`分解为新个案`,
"vue_label_dashboard_range":`范围`,
"label.app.sort.show":`应用程序将按照保存的顺序显示`,
"label.salescloud.teamrole.choose.correct":`选择了重复的用户，请更正`,
"label.schedule_post":`发布帖子`,
"front-kefu-moudle-server-request-num":`服务请求单编号`,
"label.h5.logout":`注销登录`,
"label.weixin.horse.club.member.message":`爱马社会员信息`,
"label.field.addoptionlist.introduce":`在下边添加一个或多个选项列表值，每个值应单独占一行`,
"setup_layout_label_setupfield":`设置字段属性`,
"label.chatter.nextStep":`后续步骤`,
"label.quickbooks.searchlist.total1":`搜索到有{0}个尚未关联的开票记录，共计金额为{1}`,
"label.tianyancha.h5.regcapital":`注册资本`,
"label.icon.184":`咨询`,
"label.dashboard.message.refreshtoomush":`仪表板快照刷新太频繁，请稍后刷新`,
"label.umeng.approval.reject":`#approver已拒绝#obj申请`,
"label.h5.chatter.newmessage":`输入新消息`,
"message.error.relationid":`relationid不能为空！`,
"label.setup.mobile.offlinecache.selectdefault":`选择默认启用的离线菜单`,
"label.setup.mobile.homepageshortcuts.saveprompt":`请选择4个快捷功能`,
"label.projectManagement.Selectmonth":`选择月`,
"label.version.ultimate":`旗舰版`,
"label.validate.remark5":`强制日期字段为正确的时间顺序，例如开始日期必须小于结束日期`,
"label.version.nowis":`您当前CloudCC版本是`,
"front-kefu-moudle-CRM-set":`CRM设置`,
"label.mr.title.customerAddress":`客户地址`,
"label_emailtocloudcc_step1_name":`选择功能`,
"label.time.operation.edit":`修改定时作业`,
"label_tabpage_operationz":`字段，操作不能为空`,
"label.translation.start4":`双击翻译列来输入新值。`,
"vue_label_systemSettings_request":`批量转移批准请求`,
"label.maintenance.notice":`例行维护通知`,
"label.customfields.txet.textlength.tip":`在下面输入文本字段的最大长度，文本字段长度不能大于255`,
"label.ccdocument.select.template.open":`请选择模板进行打开`,
"vue_label_display_date_field":`显示日期字段`,
"label_partner_workspace_tab":`菜单`,
"lable.account.LasthDays":`过去120天`,
"chatter.using.sticker":`启用微贴跟踪`,
"message.save.dataerror":`错误：数据长度过长或其他问题引起的保存错误，请修改数据后重新保存。`,
"vue_label_commonobjects_view_chart_newchart":`新建图表`,
"label.chat.micropost.a.group":`小组`,
"lable.currencyManage.advcurrencyunEnabled":`高级货币管理未启用`,
"label.appexchange.workflow":`工作流规则`,
"vue_label_calendar_show_details_and_add_events":`显示详细信息并添加事件`,
"label.salescloud.optionlist.inputname":`在下面输入选项列表值得名称`,
"label.dashboard.folder":`仪表板文件夹`,
"label.knowledgebase.permanently.remove.articles":`删除已归档文章会将其和所有关联版本从知识库中永久移除。`,
"label.emailtocloudcc.titel":`Email to CloudCC`,
"label.visualpage.sel":`此文件夹中的自定义页面`,
"label.planned.all.work":`所有计划的作业`,
"label.weixin.agree.agreement":`同意相关协议`,
"label.forecast.customforecast.qsn":`起始年`,
"label.appupload.managed":`受管`,
"template.report.folder.sale.index":`销售指标分析`,
"UG_opportunity_011":`导入交易`,
"label.validate.function.funcFormat.SECOND":`SECOND(date)`,
"UG_homepage_005":`销售智能`,
"label.clicktoreturn":`点此返回`,
"label.collectionofview":`的视图集`,
"com.cloudcc.login.error.message.nonuser":`用户不存在`,
"vue_label_systemSettings_emailsetting":`邮箱设置`,
"vue_label_email_mark_as":`标记为`,
"label.tabpage.customernamez":`客户名`,
"label.appupload.install.apicannotsame":`新的api名称不能与原值相同`,
"label.task.all.undealt":`所有未处理任务`,
"front-lightning-module-v1-dashborad-statistical-indicators":`统计指标`,
"UG.quota.02":`报价是客户及供货商之间关于在指定的时间以指定的价格对指定商品进行交易的法律条款。`,
"label.approve":`批准`,
"vue_label_calendar_remove_calendar":`移除日历`,
"label.mr.title.contactName":`联系人姓名`,
"label.projectManagement.resource":`资源管理`,
"label.rejectbehaviour1":`允许批准人手动选择返回到第几步骤。（返回之前第N步）`,
"label.publicgroup.relationship":`小组成员关系`,
"Lead.Scoring.DetailedPage.Popup.Title":`潜客洞察`,
"label.owner.edit":`编辑所有权`,
"label.campaign.channel.ticket.mark":`注：将二维码通过手机截屏保存到相册或者将二维码保存到手机，凭此二维码进场参加活动。`,
"label.opportunity.setting.showstage.info":`移动端详情页是否显示业务机会阶段快捷操作区`,
"label.emailobject.wizard.desc3":`使用电子邮件模板，节省更多时间`,
"label.cpq.quote.no.product.add":`报价单目前没有添加产品，请添加产品后再生成订单`,
"label.customer.tab":`自定义菜单`,
"Opportunity_Detailed_Phase_Label_Popup_002":`离开日期`,
"component_telerecord_label_name":`姓名`,
"label_component_helper_nodata":`目前，无注意事项，请稍候检查`,
"label.dashboardSetup.d2":`断点2值`,
"setup.mainpage.label.welcome4":`操作指导： 点击本页左侧菜单 → 应用程序设置 → 创建 → 对象。`,
"label.step4.total5":`第4步，共5步`,
"label.payment.the.remaining.days":`您的账号有效期还剩{0}天`,
"label.encoding":`编码`,
"label.setting.intergrationlist.status2":`目前已安装此集成`,
"label.new":`新建`,
"label.search.searchsetup":`搜索设置`,
"label_tabpage_printz":`打印`,
"report.type.label.customService":`客户支持`,
"label.notification.addEmailObject.message":`您有一封信来自{!fromaddress}的邮件，请点击查看`,
"label.icon.68":`机器`,
"UG.Lead.003":`社交`,
"label_mobile_default_field_service_home":`服务云首页`,
"label.select.one.group":`请至少选择一个报价行组!`,
"front-kefu-moudle-trkey-nopower":`天润秘钥对未分配权限`,
"label.chatter.cancel":`取消`,
"label.weixin.report.optiondisplay":`报表选项显示`,
"front-kefu-moudle-v1-System-version":`系统版本：`,
"lable.product.pricebooks.editall":`编辑全部`,
"label.group.no.recent3":`或`,
"label.knowledge.article.delete":`删除知识文章出错`,
"label.relateobj":`相关项`,
"workflow.action.tasks.assignortype.type":`类型`,
"label.layout.selectedfields":`选取字段`,
"label.role.assign.operate":`要将其他用户分配给此角色：<br><ul><li>从下拉列表中选择，以显示可用用户。</li><li>从左侧选择一个用户并将其添加到<b>已选中用户</b>列表。</li></ul>`,
"label.field.insert":`插入字段`,
"label.icon.11":`人`,
"label.group.no.recent4":`建立一个小组。`,
"front-epwechat-module-v1-input-corpid":`请输入Corpld`,
"setup_object_field_dependency_label_actionfieldnotnull":`请先选择一个控制字段的值进行设置`,
"setup.mainpage.label.welcome19":`操作指导： 点击本页左侧菜单 → 管理设置 → 管理用户 → 用户、角色、简档`,
"label.escalation.setup.list.rulename":`规则名称`,
"label.ems.addaccount":`立即添加账号`,
"label.reportsSubscription.details.only":`仅限详细信息 (Excel 格式 .xlsx)`,
"vue_label_commonobjects_view_groupby":`分组依据`,
"label.email.form.text":`仅文本`,
"label.weixin.loginname":`登录名`,
"label.forecast.settings.sr":`收入`,
"label.chatter.sendEmailToGroupMember.subject.F":`{0}在小组{1}发布了全员帖子`,
"label.ccchat.enter.subject":`请填写投票主题`,
"label.customer.tab.introduce":`自定义对象菜单的外观和功能与通过系统提供的标准菜单类似`,
"message.login.mfaverification.wrong":`安全码错误！`,
"component.newrecords.label.name":`名称`,
"label.salescloud.opportunity.addandedit.contactrole":`添加和编辑联系人角色`,
"label_emailtocloudcc_button_next":`下一步`,
"label.console.step5":`步骤 5.选择如何显示记录`,
"setup.main2018.label.norole":`您没有系统管理相关权限`,
"template.chart.ywjhqd":`业务机会阶段`,
"label.instrumentPanel.breakpointOneLabelname":`该值要大于最小值`,
"label.qrcode":`二维码`,
"label_tabpage_no2z":`否2`,
"label.log.search.date.range":`查询周期不能大于{c}个月！`,
"label.console.step7":`步骤 7.分配简档`,
"label.australian.central.standard.time":`中央标准时间（北领地）`,
"label_tabpage_deleteviewfailed":`视图删除失败`,
"vue_label_commonobjects_view_searchview":`搜索视图`,
"message.error.object.notexists":`对象不存在`,
"label.tablecell":`单元格`,
"vue_label_notice_edit_success":`编辑成功`,
"label.customer.language":`默认语言`,
"label.csrf":`启用csrf安全防护`,
"label.forecast.customforecast.submit.zhi":`至`,
"label.sso.saml.idp.config.desc2":`单击启用身份提供商可以启用您的CloudCC.com组织作为身份提供商。`,
"label.export_data":`导出数据`,
"component.todaytask.label.all":`查看全部`,
"label.h5.chatter.record":`跟踪记录`,
"front-vew-email-verification":`查看电子邮件，并验证账户。如您所知，您仅可在确认邮件后重新登录。`,
"laber.marketsea.del.error":`公海池被占用，无法删除`,
"vue_label_notice_homepage_entername":`请输入修改名称`,
"UG.Forcast.01":`预测`,
"front-email-payment-tips":`发票金额为空，请补充发票金额信息后，再发起线上付款`,
"setup.mainpage.label.welcome2":`自定制数据库（对象）`,
"APPIntegration.Social.facebookerror":`必须是一个合法的facebook.com的URL`,
"label.profile.mobile.setup.stand":`标准主页`,
"label.custom.CY":`自定义年度`,
"label.knowledgebase.publishing.conditions":`{a}条数据发布失败,不符合发布条件不能发布！`,
"label.tianyancha.description":`启用天眼查工商数据验证，用户录入企业客户资料时，可协助用户录入正确的客户工商注册信息。此服务有天眼查提供，支持中国大陆注册的工商企业数据。`,
"label.appexchange.uninstallpage.title":`卸载此软件包会导致：`,
"label.currencyRate":`兑换率`,
"setup_layout_label_areashow":`区域名称显示位置`,
"label.setup.case.setting":`小程序生成个案`,
"vue_label_commonobjects_view_fixed_at_most":`最多只能固定三列`,
"template.report.month.income":`本月收入`,
"label.sms.companyname":`公司名称`,
"label.sendemail.registIMUser.waitmessage":`您暂时没有可以登录的伙伴云门户，稍后请等待管理员通知，访问指定的地址即可进入登录页面。请使用上述用户名、密码登录即可。`,
"label.custom.field.task.object":`您好！现有一项任务指派给您，任务主题：`,
"message.pleaseselectdayinweek":`请选择星期中的一天`,
"label.chat.topic.favorites":`收藏夹`,
"UG.Campaign.004":`导入市场活动`,
"label.approval.preview":`审批流程预览`,
"label.knowledgebase.assign.articles.to.people.or.queues":`选择目标语言，然后将文章分配给人员或队列。翻译导出通常分配给一个队列，内部翻译的文章通常分配给一个人。`,
"pagecreator_systemstyle_message_save_success":`样式保存成功`,
"label.outline":`概要`,
"label.read.only.field":`只读字段`,
"front-gantt-module-v1-early-warning":`预警`,
"label.file.ccchat.selectfrompc":`从您的计算机上选择一个文件`,
"vue_label_systemSettings_social":`社交媒体`,
"label_report_year_last_year":`去年同比`,
"lable.PowerProcess.Meet.the.conditions":`需要满足以下条件：`,
"label.changemydisplay.list.title":`更改我的显示`,
"UG_Forcast_03":`启动规划并执行业务策略。<br> 祝您预测愉快！`,
"label.sendemail.chat.sendmessage":`尊敬的#name:\n\n    您好！#userName给您发了一条消息。`,
"label.huanxinconfig.secretid.lost":`secretid不能为空`,
"label.icon.49":`发电`,
"chatter.feed.button.publish":`发表`,
"label.power":`^乘方`,
"label.partnerCloud.financeSetting.informationThree":`3.进入密钥管理界面后，点击【mapi网关产品密钥】，获取合作伙伴身份和MD5密钥。`,
"label.emailtocloudcc.step1.lead2":`配置后，该邮箱收到的邮件均可自动生成潜在客户记录，确保不遗漏任何商机。`,
"label.knowledgebase.delete.draft.succeeded":`删除草稿成功`,
"label.dashboardSetup.title":`组件编辑器`,
"label.trigger.operation.email.template.map":`返回模板信息，邮件标题：m.get("subject");邮件内容：m.get("context");邮件类型是否文本：m.get("istext")`,
"label.dependencesearchfilter":`相关查询筛选器`,
"label.selected.search.length":`已选搜索字段不能超过10个`,
"label.profile.commonusercontrol":`普通用户权限`,
"lable.Microsoft.YaHei":`微软雅黑`,
"label.appupload.component.type.app":`应用程序`,
"label.customsetting.manage.position":`位置`,
"vue_label_systemSettings_bindweb":`绑定网站`,
"label.loginservice.license.notexist":`许可证不存在`,
"label.icon.43":`铃铛`,
"UG_homepage_003":`360度视图`,
"label.file_format":`文件格式`,
"label.reportsSubscriptionPage.schedulereport.monthly.day.sunday":`星期日`,
"vue_label_chatter_post_has_delete":`帖子已被删除`,
"report_label_searchresult":`搜索结果`,
"label.tabpage.justsz":`刚刚`,
"Lead_Scoring_Setting_LevelSetting":`潜在客户热度设置`,
"setup.object.field.dependency.label.selectedfieldvalue":`已选字段值`,
"label.search.morelistview":`更多列表视图`,
"vue_label_homepage_won":`已赢单`,
"label.notification.last30days":`近30天`,
"vue_label_helpcenter_pool":`使用客户与潜在客户公海池，管理您的销售数据。<br>设置公海池<br>    在后台创建公海池，设置公海池的管理员与成员，并配置逾期自动回收规则，便于管理您团队内部的机会跟进情况，鼓励团队成员积极跟进。<br>手动管理数据<br>    公海池管理员可以在公海池内进行记录的分配、回收、废弃、转移等操作，统一管理公海池内的记录；<br>    公海池成员可以在公海池中领取未分配的记录，或是查看自己负责的记录。`,
"label.emailsync.status.export":`导出为Excel_csv格式文件`,
"label.service.miniProgram.slideshowTitle":`轮播图`,
"label.service.miniProgram.slideshowName":`轮播图名称`,
"label.fieldupdate.selectobj":`为此字段更新选择对象并单击下一步"。字段更新只能与相同类型的工作流规则和批准过程相关联。"`,
"label.ccpeak.take.notice.sharetab":`注意：共享表的表达式中字段不需要加__c"！"`,
"label.log.startdate.after.endate":`开始时间不能大于结束时间！`,
"label.rememberme":`记住用户名`,
"label.partner.all.maxNum":`伙伴云的最大数据：`,
"component.setup.iframe.label.inputurl":`输入URL地址`,
"label.h5.systemmessage":`系统消息`,
"label.delete.date":`删除日期`,
"front-email-payment-select-month-tips":`请选择MM`,
"front-kefu-moudle-bind-userinfo":`绑定用户信息`,
"label.appointment.wizard.notif2":`您需要在创建日程预约前先设定好一个预约的时长`,
"label.custom.field.maping.number":`潜在客户数字位数不能多于映射字段位数`,
"label.event.dayview":`日视图`,
"label.replace":`替换`,
"label.knowledgebase.search.knowledge.articles":`搜索知识文章`,
"component_event_label_soon":`立即`,
"label.imgfield.upload":`上载图片`,
"message.printable.view":`可打印视图`,
"vue_label_notice_uploadavatar_notice1":`上传头像图片大小不能超过 2MB`,
"label.visualpage.developer.help":`自定义页面开发者 帮助`,
"label.validate.function.funcFormat.IF":`IF(logical_test, value_if_true, value_if_false)`,
"label.sso.saml.sp.description1":`单点登录设置`,
"vue_label_calendar_step_1":`第一步：命名对象日历`,
"component.telerecord.button.save":`保存`,
"setup_mainpage_button_manageobject":`对象管理`,
"label.marketingactivityinfluence":`市场活动影响`,
"label.quote.bjjsxx":`报价接受信息`,
"label.appupload.upload.install.retry":`重新安装`,
"label.layout.assignrules":`分配规则`,
"UG.Lead.006":`网站访客`,
"label.workmate.searchs":`搜索同事`,
"label.visualpage_list.no":`无自定义页面访问权限`,
"label.service.miniProgram.slideshowintroduce":`轮播图名称只是作为辨别多个广告条目之用，并不显示在广告中`,
"label.multilang.messagedetail.search.desc":`我们无法找到具有{0}的消息：`,
"label.mobile.phone.read.note":`请在此输入备注`,
"label.passwordPolicy.setup.isUsingGotp":`启用登录二次校验`,
"message.datetypeerror":`<strong>错误：</strong> 日期输入不正确`,
"label.searchlayout.listview.button":`列表视图中显示的按钮。`,
"label.sectionpart":`部分`,
"label.partnerCloud.basicSetting.userSetting":`角色和用户设置`,
"System_Data_Import_Warning_MaxCount":`您的组织每次只能导入数据{0}条，现在已经超出，请调整后再次导入。`,
"label.datamove.qualified.record":`条符合条件的记录，每次最多可转移100条！`,
"component_task_label_priority":`优先级`,
"vue_label_report_me":`我`,
"label.college.duplicate.option":`选项不可重复!`,
"label.pw.letter":`字母`,
"label.file.sharedwithme":`与我共享`,
"label.translation":`翻译`,
"lable.currencyAdv.exchagecurrency.before":`之前`,
"label.file.share":`共享`,
"label.page.next":`下一页`,
"label.autoRegister.changepwd.setpwd.notmatch":`两次密码不一致`,
"label.tabpage.include":`已包含`,
"front-email-payment-thanks":`谢谢`,
"vue_label_help_helponthispage":`该页面上的帮助`,
"label.approvepagelayout":`批准页面布局`,
"vue_lightning_help_zero_distance_communication":`通过启动在线支持请求节约时间，与CloudCC服务专家零距离沟通`,
"vue_label_normal_case_sf":`个案`,
"label.report.line.tuozhuai":`请拖拽或双击鼠标选择报表列并调整列顺序`,
"template.dashboard.management":`经营管理`,
"label.customcomponent.params.info.n1":`使用component标签中的args属性的值args为json格式, 如: args="name:'zhang',age:26", 在cc代码块中使用 String myName = name; int myAge = age;`,
"lable.SalesCommitmentKanBan.signedCommitmentRate":`签约承诺率`,
"label.add.status":`添加状态`,
"label.loss.customers":`已结束/客户流失`,
"vue_label_chatter_involving_me":`涉及我的`,
"label.update.input":`请修正输入`,
"label.import.step1.commonobj":`常用对象`,
"label.appupload.upload.tips.document":`注意："我的个人文件夹"和"模板套红文件夹"中的文档不能添加到软件包，也不能显示在此列表中。`,
"label.appupload.install.complete":`完成`,
"label.console.edit":`编辑控制台`,
"setup.object.field.dependency.label.removefromlist":`移除选中值`,
"label.textmessage.groupsms.no.phone":`无手机号`,
"label.account.Current.and.NextFQ":`当前和下一个会计季度`,
"label.sso.saml.sp.idtype.userid":`声明包含来自用户对象的用户ID`,
"label.data.import.setup.operate.update":`更新现有记录，不插入任何新记录`,
"front-kefu-moudle-v1-jcaws-call-serve":`集成AWS(Amazon Web Service)的呼叫中心以提供更全面的SaaS服务`,
"label.version.bacheditordel":`批量编辑/删除/转移`,
"lable.even.higher":`更高`,
"label.datetime.error":`日期格式不正确`,
"vue_label_commonobjects_detail_customer_hierarchy":`客户层级结构`,
"label.startuploadfile":`开始上传`,
"label.appointment.wizard.subtitle3-1":`周一`,
"label.weixin.relevance":`关联的业务机会`,
"label.datamanage.field.mapping.information":`字段映射设置`,
"label.brief.lastweek":`上周`,
"label.nextstep":`下一步`,
"label.listtoshow":`以下显示了一个列表，列示了{0}`,
"label.partner.ishave":`错误：域名已存在`,
"label.service.miniProgram.name":`请填写名称`,
"label.view.filterbyaddition":`按附加字段过滤 (可选):`,
"label.projectManagement.nodata.task":`还没有任务的记录，快来添加任务信息吧`,
"label.chooseemailtemplate":`选择电子邮件模板`,
"label.page.step4.add.profile":`步骤4：添加到简档`,
"label.ems.mailtype":`邮箱类型`,
"label.weixin.no.pending.projects.vg":`非常棒，暂无待审批项目`,
"label.tabpage.saveviewfailed":`视图保存失败`,
"label.chat.file.upload.cancel":`取消上传`,
"com.cloudcc.login.error.message.notenabled":`用户未启用`,
"label.data.import.setup.operate.insertandupdate":`更新现有记录并插入新记录`,
"label_target_type":`目标类型`,
"label.notification.event2":`您分配给【被分配人】的事件被查看`,
"chatter.feed.menutype.feed.news":`我追随的内容`,
"label.import.page1.suitedwayofcustomer":`匹配客户方式`,
"label.import.page2.CloudCCfiled":`CloudCC字段`,
"label.custom.quarter.start":`自定义季度开始日期`,
"label.page.including.tab":`包括菜单`,
"label.mobile.phone.day.plan2":`今日计划`,
"template.report.lead.conversion.statistics":`潜在客户转化统计`,
"label.show.type":`显示类型`,
"label.weixin.no.pending.wdgz.qin.week":`亲，本周没有工作安排`,
"2018UI.Homepage.DataDeleted.Info":`数据已经删除，点击返回上一步。`,
"label.vlidaterule.message":`错误信息`,
"label.approval.remark":`审批意见`,
"label.field.duplicate1":`独有`,
"label.batchtransfer":`批量转移`,
"label.quickbooks.view.allinvoices":`全部Invoices`,
"vue_label_commonobjects_detail_lead_selectedstatus":`标记为选中状态`,
"label_home_page_source":`请选择数据源`,
"front-kefu-moudle-v1-opencall-please":`请开启呼叫中心再进行设置`,
"setup_layout_label_asc":`升序`,
"label.use_tikect":`使用入场券？`,
"label.tag.setup":`标签设置`,
"label.existinglayout":`已存在的页面布局`,
"label.productsales.today.noevt":`今天没有未处理的事件！`,
"message.error.view.date.validerr":`输入合法的日期格式(YYYY-MM-DD、MM/DD/YYYY)或特殊日期字符`,
"label.mr.descreption.oneGroupReData3":`重复数据，已处理`,
"label.tianyancha.businessverify.msg1":`启用工商数据验证功能，用户应认真阅读、充分理解本《用户许可协议》(下称协议）中各条款，包括免除北京神州云动客户股份有限公司责任（下称 CloudCC)的免责条款及对用户的权利限制条款。请您审慎阅读并选择接受或不接受本《协议》。`,
"label.custom.CQ":`自定义季度`,
"label.version.custom.dashboard":`标准仪表板（自定义页面）`,
"vue_label_commonobjects_detail_dragtoupload":`将文件拖到此处，或<em>点击上传</em>`,
"label.tabpage.addadvancedoptions":`添加高级选项`,
"front-kefu-moudle-v1-Launch-page":`发起页：`,
"label.emailobject.tabname":`邮件`,
"label.weixin.addmore":`添加更多`,
"message.error.view.operator.validerr":`不支持的操作符`,
"label.another_page":`重定向到另一页面`,
"label.reportTypeFocusD2":`示例："如果报表关于具有合作伙伴的业务机会的联系人"`,
"label.icon.47":`气压表`,
"label.task.today":`今天的任务`,
"label.service.gantt.weekend.highlight":`高亮显示周末`,
"label.customcomponent.referencetagname":`标签名称`,
"label.senderemail":`发件人电子邮箱地址`,
"label.defaultvalue":`默认值`,
"label_tabpage_Sdfez":`天前`,
"pagecreator.page.label.pagename":`页面名称`,
"vue_label_report_pagenumber":`范围内的页码值`,
"label.emailsync.connectaccount.description":`将您的个人邮箱添加于此，系统将自动根据邮件的收发地址匹配系统中的潜在客户、联系人，并将邮件内容同步至该记录下，便于追踪与客户的沟通进度。`,
"label.schedulableprg.chooseweek":`请选择每周下的星期日期`,
"lable.edit.queue.membercanuse":`可用成员`,
"lable.Quick.find":`快速查找`,
"label.daynuminmonth":`个月的第`,
"message.error.state":`state不能为空！`,
"label.introduction.the.form":`表单简介`,
"label.batchtransfer.pleaseselectcomefromuser":`请选择转移自用户`,
"front-dashboard-module-implemented":`已实现`,
"label.custombutton.newerror":`新建失败`,
"label.version.allow.size":`，已超出上限！如有需要，请升级CloudCC版本！`,
"label.weixin.account.loginpage":`客户安全登录页面`,
"message.pleaseselectfieldtype":`请选择字段类型`,
"component.setup.label.parentobject":`上级对象`,
"System.TAB.SeeViewAmount":`查看总数`,
"label.event.lastmonth":`上月`,
"label.taskrecordtype":`任务记录类型`,
"label.layout.selectedpages":`选取页面`,
"label.appointmentdetail.wizard.title19":`周六时间规划`,
"label_chatter_endData":`结束日期`,
"label.appupload":`软件包`,
"label.knowledgebase.article.link":`链接文章`,
"label.licence.enddate":`许可证到期时间`,
"chatter.fieldtrack.record":`记录`,
"label.reportsSubscriptionPage.schedulereport.weekly":`每周`,
"label.forecast.editshrepage.title2":`编辑共享`,
"label.attendance.onwork.time":`上班时间`,
"label.appointment.wizard.subtitle1-8":`3小时`,
"pagecreator.layout.button.upload":`上传布局`,
"label.input.notless.than.number":`请输入一个大于或等于 {0} 的数字`,
"setup.mainpage.label.welcome13":`操作指导： 点击顶部菜单 → 报表 → 新建 。`,
"label.forecast.settings.data.opp":`业务机会关闭日期`,
"vue_label_display_checkbox_field":`显示复选框字段`,
"label.summaryreport.2018.step5":`步骤5：选择图表类型和报表突出显示`,
"front-lightning-module-v1-dashborad-one-statistic":`请至少选择一个统计值和统计类型`,
"label.home.standard.dashboard.forcase":`您没有设置允许预测，不能查看销售承诺看板。`,
"page.field.track":`字段跟踪`,
"label.dataimport.format.datetime.error":`格式错误，请使用yyyy/MM/dd HH:mm:ss或者yyyy-MM-dd HH:mm:ss的格式。`,
"lable.opppdt.selPbk.title":`选择价格手册`,
"pagecreator_systemstyle_label_stylename":`样式名称`,
"label.projectManagement.nodata.project":`没有找到相关数据，快来创建与我相关的项目吧`,
"label.start_below":`开始分享表单给联系人。您的表单已安全发布，可以在以下网址中使用。`,
"label.campaignmember.main.delete":`批量删除市场活动成员`,
"label.modifyall":`修改全部`,
"label.homepage":`首页`,
"vue_label_pool_adoptedbyme":`我领取的`,
"label.email.clearItem":`只清空未关联相关项的邮件`,
"label.callcenter.login.Amazon.connect":`登录到Amazon Connect`,
"label.import.page1.selectimportfiled":`选择要导入的文件`,
"message.error.id":`id不能为空！`,
"label.ggReleaseRange.searchUsers":`搜索合作伙伴用户`,
"label.changemypwd":`更改我的密码`,
"label.ccpeak.reference.parameters":`可以直接引用的参数有：`,
"chatter.share.success.tip":`成功！您已将此帖子共享至`,
"label.message.checkfailed":`语法检查失败 ,该类名称已被使用!`,
"label.shangqing.introduction":`对潜在客户或客户近期内发生的热点事件进行整合分析，协助销售更全面的了解客户`,
"label.allemailnotice":`全部电子邮件通知`,
"vue_label_report_copy":`复制报表`,
"label.exchange.sync.state.setting":`配置设置`,
"label.merge.result.error1":`以下记录处于被锁定状态，不允许进行 \"合并\" 操作`,
"label.process.des":`若要查看当前记录的详细信息，请点左侧链接进入。`,
"label.textmessage.vonage.create.lead.setting":`当收到未录入在系统电话的短信时，创建新的潜在客户`,
"label.views":`查看量`,
"label.notification.tip1":`您现在没有任何通知`,
"label.forecast.detailforecast.returnforecast":`返回预测`,
"label.knowledgebase.target.framework.name":`目标框架名称`,
"label.brief.close.opportunities":`赢单机会数`,
"label.appointment.wizard.subtitle4-2":`最晚日程提醒时间`,
"vue_label_systemSettings_set_record":`设置记录详情相关列表的展示形式，可以切换卡片形式和列表式两种`,
"pagecreator_page_message_publish_fail":`页面发布失败`,
"vue_label_homepage_name":`主页名称`,
"label.weixin.no.pending.wdgz.qin.month":`亲，本月当前周没有工作安排`,
"label.campagin.register.page":`市场活动成员注册页面`,
"label.campaign.channel.edit":`市场活动：编辑营销渠道`,
"label.folder":`文件夹`,
"label.umeng.chatter.follow":`追随了您`,
"label.sso.theKeyToEdit":`密钥编辑`,
"label.deletelayout":`删除页面布局`,
"label.same.analyze.miaoshu":`以上条件关系为：“业务机会名称” 或 “客户名称” 或 （“联系人手机” 与 “联系人邮箱”）;`,
"label.ccpeak.sel":`此文件夹中的类`,
"label.tabpage.addtoworkbench":`添加至首页工作台`,
"label.forecast.shrepage.classdes.r":`只读 - 用户可以查看预测数据。`,
"homepage.custompagename":`自定义主页名称`,
"label.sendemail.batchapprovalinfo":`#name 您好:\r\n     您执行的批量审批操作已成功,共审批成功#successnum条,审批失败#errornum条。`,
"front-email-payment-Invoice-alipay-describe":`安全可靠的支付`,
"setup.object.field.dependency.label.configured":`已配置内容`,
"label.potentialcustomers":`潜在客户`,
"label.timetrigger.button":`添加时间触发器按钮在以下情况下不可用：`,
"label.category.10":`律师`,
"label.selectall":`全选`,
"message.field.id.not.null":`字段ID不能为空`,
"CloudCCCRM.ST.Info.TypeIn.001":`请输入`,
"label.author":`作者`,
"label.import.step1.csvonly":`1、只支持csv格式的文件，最多单次导入{recordnumlimit}条记录，若需执行触发器，则最多导入2000条，超出限制的记录，系统会自动忽略。若需导入更多数据，请先拆分为多个文件，分次导入。`,
"label.assignment.setup.newrule.name":`规则名`,
"label.campaignmember.selectmember.chosestatusdesc":`请选择要添加成员的市场活动，并制定他们的成员状态。要创建新市场活动，必须退出此过程。`,
"label_tabpage_operation":`操作`,
"label_tabpage_datatyoez":`数据类型`,
"UG_product_04":`创建产品`,
"label_emailtocloudcc_step1_case2":`配置后，该邮箱收到的邮件均可自动生成个案，并根据发件箱匹配联系人与客户，将个案挂在对应的客户与联系人之上，方便Case服务的受理与追踪。`,
"workflow.action.tasks.assignortype.role":`角色`,
"vue_label_notice_refreshi_success":`刷新成功`,
"label.notification.arketsea.abandon":`{5}废弃了{2}{0}：{1}`,
"label.icon.36":`电脑`,
"chatter.group.cancelToJoin":`取消加入`,
"label.publicgroups.edit":`编辑公用小组`,
"message.duplication.label.letternum":`匹配字符位数`,
"label.brief.lost.opportunities":`丢单机会数`,
"setup.layout.label.nofield":`暂无可选字段`,
"label.dataimport.isSharingRule":`执行共享规则`,
"vue_label_opportunity_contactrole_synctocontacts":`将信息同步到联系人上`,
"attachment_button_massdownload":`批量下载`,
"label.weixin.agreement.remark":`此微信服务是爱马社对客户出险咨询服务的辅助工具，不作为保险公司理赔的最终依据，客户理赔应以保险公司实际要求为准`,
"label.partnerCloud.basicSetting.introTwo":`编辑您的伙伴云站点唯一URL中的一部分。CloudCC.com提供URL的第一部分；后续部分只能包含数字或字母。建议使用贵公司的名称或贵公司名称的变型，如“mycpmpanypotal”。`,
"pagecreator_layout_funcpath":`/构建器/布局库`,
"label.ccdocument.online.edit":`文档在线编辑`,
"label.partner.setup.Enable":`检查可用性`,
"label.log.state":`操作状态`,
"label.lower.bound":`下界`,
"label.timezone.isenable":`启用用户多时区，让用户设置自己的时区并且日期时间以用户时区显示`,
"label.martrixreport.setrowtitle":`指定列标题`,
"label.bottom":`底部`,
"label.multilang.ccchat.groupnotcontainsname":`您不是名称中含有{0}的任何活动小组的成员`,
"label.step1.of.step5":`第1步，共5步`,
"message.report.error.FieldListIsAmbiguous":`报表的字段中有公式字段引用了下面这个字段，导致了异常，请去掉这个公式字段。公式引用的字段：`,
"label.monitorsys.operator.ip":`IP`,
"ccchat.fieldtrack.fieldchange":`从 {0} 更改为 {1}`,
"label.report.export.print.content":`导出当前报表表头，分组与前2000条数据`,
"message.thanksusing":`感谢使用 CloudCC.com！`,
"label.reportexport.allobject":`导出所有对象`,
"label.projectManagement.working.hours.per.day":`每天工作小时数`,
"label.partnerCloud.financeSetting.enterCollaborator":`请输入合作者身份`,
"label.defineReportRecords":`定义报表记录集`,
"greate":`大于`,
"label.sure_discard":`您确定要放弃您的修改吗？`,
"label.escalation.setup.newaction.notifyowner":`通知个案所有人`,
"label.icon.28":`博士帽`,
"lable.PowerProcess.see.page":`查看重大事件`,
"message.error.object.relogin":`登录失败，请再次尝试重新登录`,
"label.chatter.activity":`活动`,
"label.query.clone.detail.choose.canChoose":`可选明细对象`,
"chatter.using.object":`启用对象的微贴跟踪，以便用户能追随该对象类型的记录。选择要跟踪的字段，以便当这些字段在用户追随的记录上发生更改时，用户能看到微贴更新。`,
"UG.opportunity.001":`您如何监控您的销售?`,
"label.ServiceCloud.fuwuziyuan.distributionMap":`服务资源分布图`,
"vue_label_email_current_email":`插入此模板将覆盖当前邮件`,
"label.h5.approval.page.layout":`您可如下方式设置批准页面布局：<br>设置->创建->工作流和批准->批准过程<br>选择对应的批准过程，点击批准过程名称，<br>选择编辑->批准页面布局<br>即可进行批准页面布局设置。`,
"component.hots.label.title":`热门交易`,
"mail.foldername.notOnly":`该文件已存在`,
"label.customer.tab.step1":`步骤1：输入详细信息`,
"label.delete.persion":`删除人`,
"chatter.changed0":`将{0}从{1}更改至{2}`,
"homepage.components.type":`组件类型`,
"label.norfolk.isiands.time":`诺福克时间`,
"label.product.pricebooks.view":`价格手册视图`,
"label.forecast.customforecast.director":`直接下属`,
"label.emailtocloudcc.step3total3":`第3步，共3步`,
"label.cloudccsite.end":`禁用站点主页`,
"label.login.verification.mfa.device":`验证虚拟MFA设备`,
"chatter.follow":`我要追随`,
"label.month's":`月的`,
"label.sendmail.step1.introduce":`选择以下视图之一(其中包含此电子邮件的收件人)。`,
"label.shangqing.title":`商情设置`,
"label.rejectrecords":`拒绝记录`,
"label.selectupdatevalue":`选择要更改至的目标值`,
"vue_label_pricebook_disabled":`价格手册已禁用`,
"component.chatter.label.title":`最新微贴`,
"label.partner.all.workspace":`工作区`,
"label.querydetailservice.delete.message":`数据被删除或者不存在`,
"label.objectRelationshipWithout":`具有或没有相关记录`,
"nocontain":`不包含`,
"label.partnerCloud.financeSetting.accountSettings":`伙伴账户设置`,
"label.file.sharetype.owner":`所有人`,
"label.open.multilingual":`启用多语言`,
"label.searchresult.field":`搜索结果字段`,
"label.tabpage.selectdate":`选择日期`,
"label.h5.logouting":`注销`,
"label.quickbooks.fieldlabel.payment":`付款方式`,
"label.chatter.leaveword":`留言`,
"label.customfields.majoranddetailrelation.tip":`创建一个此对象（子级或详细信息"）与另一对象（父级或"主"）之间的特殊父子关系类型，其中：<br>●所有详细信息记录的关系字段必填。<br>●一旦关系字段的值被保存，就无法更改。</li><br>●详细信息记录的所有权和共享由主记录确定。 </li><br>●当用户删除主记录时，将删除所有详细信息记录 。</li><br>●您可以在主记录上创建累计汇总字段以汇总详细信息记录。</li><br>关系字段允许用户单击查找图标，以从弹出列表中选择值。 主对象是列表中值的源。"`,
"label.batchapproveorrefuse":`批量批准/拒绝批准请求`,
"label.copy.success":`复制成功`,
"vue_label_show_record_count":`显示记录计数`,
"label.ems.delete.false":`删除失败`,
"label.new.Product.Goals":`新建产品目标`,
"label_chatter_BCC":`密件抄送`,
"label.knowledgebase.data.archived.successfully":`{a}条数据归档成功`,
"label.chuangming.title":`创明网络短信网关`,
"label.notification.arketsea.recovery":`您的{0}:{1} 已被{5}回收至{2}`,
"label.partnerCloud.orderingPlatform.paymentAmount":`支付金额：`,
"label.martrixreport.2018.step5.new":`步骤5：选择报表标准`,
"label.testing":`检测中...`,
"chatter.poll.option4":`选项4`,
"lable.outlook.detail.otc":`Exchange 到 CloudCC.com`,
"label.startuploadfile.batch.step2":`步骤 2.单击“开始上传”按钮，上传文件`,
"lable.outlook.edit.outdes":`请输入已在 Exchange中创建的自定义字段。在将此自定义 Exchange字段映射到 CloudCC.com 字段前，CloudCC.com 将在首次同步时验证 Exchange 字段是否存在。`,
"hour":`小时`,
"label.appointmentpage.wizard.notif4":`无效邮件格式`,
"label.import.index.state":`状态`,
"label.integrations.mailchimp.massage6":`当前页面中选中的数据将会导出至您选中的Mailchimp列表中`,
"label.file.share.email.subject":`#sharedBy已在#orgname上与您共享了文件`,
"label.assignment.setup.newentries.noassignment":`不要重新分配所有人`,
"label.dashboard.unit1":`单位：万`,
"label.forecast.customforecast.foretype.commit":`承诺额`,
"label.type":`类型`,
"label.partner.workspace.login.logo":`页眉徽标`,
"pagecreator_systemstyle_button_edit":`编辑样式`,
"label.displaytype2":`详细信息页面按钮`,
"email.one":`尊敬的用户您好：<br/>欢迎您使用CloudCC系统，您在{!operatetime}进行了找回密码操作，在15分钟内您可以使用下面的验证码进行密码重置的操作。<br/>随机验证码：<b>{!authcode}</b><br/>点击以下链接跳转到密码重置页面：<b>{!URL}/authcodecheck.jsp?username={!username}&lang={!lang}</b><br/><br/><b>重要事项：</b><br/>如果您未曾请求此操作，或您认为您不应收到此消息，请立即与您的系统管理员联系！`,
"label.partnerCloud.orderingPlatform.unavailable":`无可用产品`,
"vue_label_email_save_the_signature_successfully":`保存签名成功`,
"label.reportsSubscriptionPage.email.detailed":`详尽`,
"chatter.group.query":`查询`,
"label.translation.unsupported.format":`不支持的格式，多语言导入只支持property格式`,
"message.operateexception":`信息提示（如有问题请与您的系统管理员联系）。`,
"label.sendemail.chat.praiseFeedcomment":`尊敬的#name:\n\n    您好！#userName对您的留言(#href)点了喜欢。`,
"label.recycle.clearmy":`清空您的回收站`,
"label_tabpage_choose":`选择`,
"#label.importstep2tip":`如果您想上传多个文件，您可以将所有的文件压缩在一起导入。#`,
"label.batchedit":`批量编辑`,
"label.integrations.mailchimp.export":`导出至Mailchimp`,
"label.cloudccsite.name":`站点名称`,
"serviceterritory.serviceappointment.iscontain.contain":`因为服务区域和服务预约关联，因此无法删除服务区域，您可以不启用此服务区域`,
"label.sum":`总数`,
"setup.mainpage.label.welcome29":`标准的API 与第三方产品集成`,
"label.tabpage.nothingz":`无`,
"label.weixin.actual.contract.jine":`实际合同金额`,
"label.tabpage.emailaddressz":`发件人地址`,
"label.dashboard.unit4":`单位：千万`,
"label.dashboard.data.labels":`数据标签`,
"label.import.page2.oneonone":`一个CloudCC字段只能和一个文件中字段对应`,
"homepage.components.name":`组件名称`,
"template.report.task.theme":`任务主题`,
"component.setup.label.setupsaveok":`组件设置保存成功`,
"front-epwechat-module-v1-add-selfapp":`添加自建应用`,
"label.to.save.the.current.page.information.button.":`如需保存当前页面信息，请点击“快速保存”按钮。`,
"vue_label_file_not_support_preview":`该文件不支持预览，请下载后查看`,
"label.object.reached.limit":`对象已达到限定个数`,
"label.partnerCloud.basicSetting.online":`启用线上支付`,
"label.app.step1.error.nameexist":`公用小组名称已存在`,
"label.workflowandapprove":`工作流和批准`,
"label.recordtypeselect.change.tip":`更改记录的记录类型时，现有选项列表值不会自动更改。我们建议在相同的地方更新记录上的现有选项列表值。`,
"label.summaryreport.step6":`步骤 6：选择报表标准`,
"Pagelayout.Setup.004":`最多只能配置4个字段`,
"label.file.attached":`附加`,
"front-invoice-online-payment-setup-configure":`点击“立即配置”，配置{name}支付接口。`,
"label.approvaldatamove.submitdate":`提交日期`,
"label.emailobject.time.from":`发件人：`,
"label.dataimport.insertdata.error.fieldrepeat.insert":`该记录中的$schemefield_name$字段在数据库中已存在，不再进行插入，该记录已忽略导入。`,
"assetbom.copy.notpermission":`请联系管理员，您不具有复制资产BOM的权限`,
"lable.outlook.mcto.autoallocation":`自动将他们分配至相关的CloudCC.com记录`,
"label.dataimport.but.datalength":`，但是数据的长度是`,
"label.setuserstocommit":`使用下面的选项，指定哪些用户可以提交初始批准请求。`,
"component_telerecord_label_related":`相关项`,
"front-lighting-module-v1-detail-file-lockInfo":`记录已锁定，不支持添加文件，请联系管理员解锁。`,
"pagecreator_layout_button_edit":`编辑布局`,
"label.app.step3.tabcanuse":`可用菜单`,
"label.ems.delete.sure":`确定要删除这条邮箱账号信息?`,
"label.email.show":`显示`,
"label.checkbox.unchecked":`未选中的`,
"message.error.operation":`操作失败,请联系系统管理员！`,
"label.template.set.folder.only.upload.type.file":`模板套红文件夹只能上传Word、Excel、PPT类型的文件`,
"label.knowledgebase.select.publish.status":`请选择发布状态`,
"label.recordtype.tabname.edit":`为所选记录类型输入新名称，然后单击“保存”`,
"label.tabpage.exportview":`导出视图`,
"label.dataimport.insert.sharetab":`插入共享表失败。`,
"vue_label_dashboard_penetrateto":`穿透到`,
"label.weixin.group.member":`人员`,
"vue_label_systemSettings_customadd":`自定义扩展`,
"UG_Account_03":`主动查重客户并合并`,
"label.singapore.standard.time":`新加坡时间`,
"label.weixin.captcha":`验证码`,
"Account_News_Setting_004":`启用新闻`,
"label_emailtocloudcc_select1":`请选择`,
"label_ring_ratio":`环比`,
"label.industrialandcommercialverification.button.save":`保存`,
"label.approvalstep5.tip":`批准页面是批准人实际批准或拒绝请求的地方。使用下面的选项，选择要在此页面上显示的字段的编辑属性。`,
"label.import.page1.maxrecord{{30000}}":`1、您一次最多能导入{{30000}}条记录`,
"setup_object_layout_label_profileoptions":`可分配简档`,
"label.emailtemplate.type":`模板类型`,
"label.searchlayout.tab.field":`菜单下显示的字段。`,
"chatter.news":`消息`,
"label.pw.small.letter":`小写字母`,
"label.notification.group3":`您被拒绝加入公用小组`,
"label.ccchat.day.before.yesterday":`前天`,
"component.chatter.post.label.title":`张贴`,
"label.tianyancha.type":`法人类型`,
"label.detail.searchlayout":`查看搜索布局`,
"vue_label_pool_deleteconfirm":`确认删除选中的{tableCheckedObjectArrlength}条数据吗`,
"label.import.index.maxmb{{100}}，maxitem{{30000}}":`1、只支持csv格式的文件，最大支持{{100}}mb，最多单次导入条{{30000}}条记录；若超过限制，请先拆分为多个文件，分次导入；`,
"label.h5.similar.opportunity.lookup":`查找类似业务机会`,
"template.report.customer.list.opportunity":`有更多业务机会的客户列表`,
"component_setup_iframe_label_memo":`点击设置图标，输入嵌入的URL地址。`,
"label.version.allemail":`群发电子邮件`,
"lable.product.editp":`编辑价格`,
"label.weixin.plate.number":`车牌号`,
"font-evaluate-module-v1-disabled-successfully":`评价选项“一般”禁用成功`,
"label.multilingual.tip1":`使用此页面定义您的组织使用的所有语言。`,
"label.japan.standard.time":`日本标准时间`,
"lable.product.notdel.use":`的删除尝试,因为它仍与以下记录相关联.这种情况下,建议您禁用。`,
"label.appointment.wizard.subtitle4-2-4":`4小时`,
"label.queue.edit":`编辑`,
"label.partnerCloud.financeSetting.informationTwo":`2.商家中心首页点击【账户管理】-【商户信息管理】-【产看PIDIKEY】-【密钥管理】。`,
"label.partnerCloud.partnerOrdering.permission":`伙伴订货使用权限`,
"vue_label_commonobjects_detail_company_hierarchy":`公司层级结构`,
"label.forecast.settings.sl":`数量`,
"label.partner.workspace.tab.memo":`选择在此伙伴云中可以使用的菜单，可以选择系统标准菜单和自定义菜单。`,
"label.mr.mainRecord":`主记录`,
"setup_mainpage_label_welcome20":`邮件、短信模板`,
"front-email-payment-select-date-tips":`请选择YY`,
"label.dependencelisttag":`相关列表标签`,
"label.umeng.activity.eventof":`的事件`,
"label.sales.dashboard.collection":`收款目标`,
"report_label_folder":`文件夹`,
"label.assignment.setup.newentries.step1":`步骤 1：设置此规则条目的顺序`,
"label.quote.shrname":`收货人姓名`,
"label.newreport.group.sum":`分组数统计`,
"label.number.MinCheck":`{0}最小数量为{1}，请修改数量后再点击保存。`,
"label.chatter.save":`保存`,
"vue_label_email_all_email_templates":`全部邮件模板`,
"message.summaryconditionnototal":`汇总条件不得选择累计汇总字段！`,
"label.callboard":`公告`,
"label.step2.total5":`第2步，共5步`,
"vue_label_homepage_custom_homepage_page":`自定义主页`,
"label.data.newtemplate.e_seltype":`选择数据导出方式`,
"label.data.dataexpalltype.all.desc2":`2、导出全部的数据较多，需要一定的时间。导出完成后，系统将为您发送一封导出成功的邮件。`,
"lable.account.CalenderYear":`日历年度`,
"message.error.data":`传递的数据不能为空，请检查传递的参数`,
"label.from_user":`来自用户`,
"label.parentdepartment":`上级部门`,
"template.dashboard.product.analysis":`产品分析`,
"label.tabpage.unpacketz":`无可用分组数据！`,
"label.icon.107":`沟通`,
"label.monitorsys.operator.username":`用户`,
"label.serchreport":`搜索报表`,
"label.payment.upgrade":`升级`,
"setup_layout_button_ok":`确定`,
"label.please.select.channel":`请选择渠道负责人`,
"template.chart.txdrw":`提醒的任务`,
"chatter.group.accept":`接受`,
"pagecreator_systemstyle_message_canntdelete":`当前样式不允许删除`,
"label_tabpage_ctbtsftcz":`点击后面搜索选择内容`,
"label.datamanage.select.accountfield":`（选择导入客户所对应的字段）`,
"label.schedulejob.setup.list.title":`定时作业`,
"label.visualpage_list.title":`已启用的自定义页面访问`,
"label.mr.selectTwoData":`请选择至少两条待合并的数据。`,
"label.customer.tab.step2.different":`对每个简档应用不同的菜单可视性`,
"label.mobile.side.tab.can":`可用`,
"label.log.url":`URI`,
"label.weixin.cloudccnumber.isgoon":`CloudCC账号已绑定，如继续，以前绑定此CloudCC账号的微信号将不能使用微CloudCC系统。是否继续？`,
"label.applet.to.case":`小程序版客户服务门户`,
"lable.outlook.detail.cmaping":`联系人字段映射`,
"label.theUserActiveTime":`用户活跃期`,
"label.event.moveup.9hour":`提前 9 小时`,
"vue_label_pool_other":`其他`,
"label.fieldname":`字段名`,
"vue_label_notice_add_success":`添加成功`,
"label.conditiontag.lookup.insertbutton":`插入所选`,
"label.identifying":`标识`,
"label.tabpage.uploadingz":`上传中`,
"label.view.introduce":`编辑视图`,
"vue_label_dashboard_sortingmethod":`请选择排序方式`,
"label.quote.number.introduce":`输入产品的数量和折扣后点击“保存”`,
"front-kefu-moudle-which-missphone-case":`为哪些漏接的电话创建个案`,
"label.sendemail.chat.response":`微贴回复：`,
"label.productsales.refreshTime":`上次刷新时间`,
"lable.SalesCommitmentKanBan.phase":`阶段`,
"label.version.sum.object":`个对象`,
"label.defineReportStep2":`步骤2`,
"message.duplication.label.returnDuplications":`返回查重过滤器列表`,
"label.lookover":`查看`,
"label.quickbooks.button.copy2":`从CloudCC上同步至QuickBooks`,
"label.checkbox.true":`是`,
"label.profilename":`简档名称`,
"label.finalapproveoperate":`最终批准操作`,
"label.SMS.detailed":`短信通知是触发时工作流规则发送的短信。`,
"label.lasttimemodifier":`上次修改人`,
"label.sso.summary":`汇总`,
"label.customfields.encd.tip":`允许用户输入任何字母和数字组合,并将他们以明文格式存储,可加密格式显示,可搜索。`,
"vue_label_report_formulacolumn":`行级公式列`,
"vue_label_systemSettings_transfer":`批量转移记录`,
"lable.product.ecm":`行情输入正确的金额`,
"label.partner.setup":`伙伴云设置`,
"label.same.analyze.miaoshu2":`“功能`,
"label.mobile.phone.day.summary":`今日总结`,
"label.ccchat.person.error.illdomain":`错误：存在域格式填写不正确`,
"label.knowledgebase.edit.as.draft":`作为草稿编辑`,
"message.duplication.label.newfilterule":`新建查重过滤器规则`,
"vue_label_salesfunnel_notice1":`业务机会汇总`,
"label.partnerCloud.partnerAccount.order":`订单号：`,
"label.account.Current.and.PreviousFQ":`当前和上一个会计季度`,
"label.customfields.formula.dateandtimeexample":`Next（下一值）= NOW()   1`,
"label.area.unassign":`未分配的用户`,
"label.at.my":`我@的内容`,
"vue_label_calendar_notice_stopsharingfail":`停止共享失败`,
"label.data.file.validation.rules":`执行验证规则`,
"label.escalation.setup.entrydetail.escalation.hour":`小时`,
"vue_label_ccchat_notice_pleaseentercontent":`请输入发帖内容和选项`,
"label.forecast.edit.error1":`错误：币种无效`,
"label_emailtocloudcc_exists1":`此邮箱已经设置为Email to Lead，请勿重复设置`,
"label.trigger.send.email":`触发器发邮件通知：`,
"label.setmysafetysignagain":`重新设置我的安全标记`,
"label.callcenter.pleaseenter.access.keyID":`请输入秘钥ID`,
"chatter.poll.option10":`选项10`,
"vue_label_systemSettings_mobelbottonsetting2":`公司统一底部菜单设置`,
"label.quickbooks.searchs":`搜索`,
"label.section":`段`,
"label.customfields.fielddependency.new.tip":`创建一个依赖关系，该关系将导致基于用户在另一个字段中选择的值对选项列表或多选列表中的值进行动态筛选。<ul ><li>推动筛选的字段称为控制字段。具有至少一个值且小于300个值的标准和自定义复选框和选项列表可以是控制字段</li><li>其值被筛选的字段称为“依赖字段”。自定义选项列表和多选列表可以是依赖字段。</li></ul>`,
"label.customobjects.track.introduce3":`请注意：仅跟踪更改部分显示的字段，在跟踪字段值时，只显示“已更改”`,
"front-kefu-moudle-all-hidden-phone":`全局电话号码隐藏`,
"vue_label_calendar_share_calendar_with_others":`与他人共享日历`,
"label.case.copre":`下载网页版客户服务门户二维码`,
"label.conditiontag.lookup.pagetitle":`选择选项列表值`,
"UG.opportunity.004":`多业务类型`,
"label.event.moveup.1day":`提前 1 天`,
"label.industrialandcommercialverification.enablestatus1":`启用工商数据验证`,
"label.ccpeak.newrecord.getorpost":`新增记录：使用CCObject对象，CCObject有两个构造方法`,
"frame.personinfo.label.resizeimage":`要调整您的缩略图，请拖放并调整简档照片上方的虚线。`,
"label.optional.searchresultfield":`可选搜索结果字段`,
"UG.Contract.02":`合同是各方之间的书面协议。许多公司使用合同定义与其他公司从事业务往来的条款。使用 CloudCC 建立您与您的客户和业务机会已有的合同，并为其提供文档。通过批准流程，跟踪合同。使用工作流提醒，以提醒您合同展期。`,
"label.group.activity":`活动小组`,
"label.tabpage.characterz":`起始字符`,
"label.globalsearch.tip":`请输入搜索内容`,
"label.campaign.channel.download.size2":`中尺寸：500*500像素`,
"label.step3.total4":`第3步，共4步`,
"label.partnerCloud.payForFailure":`支付失败`,
"label.ggReleaseRange.editSuccess":`编辑成功`,
"label.summaryinforelyon":`汇总信息依据`,
"label.productsales.htyj":`合同业绩`,
"label.newpagelayout":`新版布局`,
"front-gantt-module-input-task-name":`请输入任务名称！`,
"label.c_d_without":`C" 记录可能有或没有相关 "D" 记录。"`,
"label.licence":`许可证`,
"setup.layout.button.selectall":`全选`,
"label.app.step1.error.appnameexist":`错误：应用程序名称已存在`,
"label.cpq.quote.item.no.record":`只有订单产品有记录才能转换为合同`,
"label.knowledgebase.noaffect.existing.translations":`否，我的更改不会影响现有翻译。`,
"label.schedulejob.setup.schedule.editjob":`编辑定时作业`,
"lable.PowerProcess.Tips":`权利过程是包含所有步骤（重大事件）的可自定义时间线，支持客服等工作人员必须完成所有步骤，才能解决支持的个案或者工作订单记录。在设置完成后，可以将其应用到权利中。`,
"label.campaignmember.selectmember.step2":`步骤2：选择要添加的成员`,
"vue_label_calendar_stopsharing":`是否确认停止共享日历`,
"vue_label_notice_savemenu_fail":`菜单保存失败`,
"message.error.getitems.id":`getItems:id不能为空`,
"label.return.currencylist":`返回列表：币种管理`,
"label.wtd.detail.p":`PC版`,
"label.knowledgebase.publish.now":`现在发布`,
"label.appupload.install.explain":`安装说明`,
"label.visualpage.folder.all":`所有页面文件夹`,
"message.passwordPolicy.validate.complexReq2":`错误：密码必须是数字和大小写字母的组合`,
"label.umeng.chatter.at":`提及了您`,
"label.mobile.phone.month.report":`月报`,
"label.describableEditeSelectedFields":`选择作为新建自定义报表时默认显示在报表列的字段`,
"component.event.label.subject":`主题`,
"label.knowledgebase.edit.draft":`编辑草稿？`,
"label.customer.tab.step1.selectoneobject":`选择一个现有自定义对象`,
"label_partner_step2":`步骤2：确认模板`,
"label_starting_annual":`起始年度`,
"X":`文本区`,
"label.customer.tab.style":`菜单样式`,
"vue_label_commonobjects_detail_book":`是标准价格手册`,
"chatter.email.referredToMe":`在帖子里提及我时（即@时）`,
"label.enable.both.barcode.qrcode":`同时启用条形码 二维码`,
"front-market-form-quired-choose":`必填字段`,
"noinclude":`不包括`,
"label.sms.template.select":`请选择短信模板`,
"label.weixin.optionten":`选项十`,
"message.duplication.label.matchlastletters":`后n个字符匹配`,
"label.webtocloudcc.submit.success":`提交成功`,
"label.sales.dashboard.number":`第`,
"label.custom.field":`将此自定义字段`,
"label.dataimport.of.field":`个字段。`,
"label.view.new":`创建新视图`,
"UG_activity_03":`预约日程`,
"label.customfields.image.tip":`允许用户上载图片`,
"label.startexport":`开始导出`,
"vue_label_commonobjects_view_chart_verticalbar":`垂直柱状图`,
"label.ccchat.person.invite.allexist":`您邀请的每个人已经在使用同事圈`,
"label.fielddependence":`字段依赖性`,
"label.scan.tip":`使用IE7、IE8、Chrome或Firefox浏览器，建议使用1024×768以上分辨率`,
"label.wei.weiactor":`微投票参与者`,
"label.service.miniProgram.quantity":`轮播记录最多创建20条~`,
"vue_label_homepage_new_homepage_page":`新首页`,
"label.apply.telphone.validate.error":`手机验证码错误。`,
"component.assistant.button.newevent":`新建事件`,
"System_TimeField_Format_Warning":`不是有效时间`,
"chatter.feed.publishfeed":`张贴`,
"label.setting.intergrationlist":`集成应用`,
"label.object.prefix":`对象前缀`,
"label.tippage.confirmed":`是，我希望删除自定义报表数据源及所有依赖报表`,
"label_emailsync_form_signin":`登录`,
"label.delete.cancel":`取消删除`,
"label.dashboard.myHomePage.des":`选择要在您的每一个应用程序中显示的仪表板。`,
"lable.account.FY.Ago":`两个会计年度之前`,
"label.umeng.approval.reassign":`#approver已重新分配#obj申请`,
"label.data.exp.zippwd2":`自动生成压缩文件密码`,
"label.tabpage.contentz":`请输入内容`,
"label.callcenter.batch.add.number":`批量添加号码
`,
"label.tabpage.deleteviewsuccess":`视图删除成功`,
"setup_layout_group_field":`字段`,
"label.appupload.component.addobj.scheme.label.suoshu":`所属对象`,
"front-project-module-v1-market-is-template":`标记为模板`,
"label.service.gantt.one.esource.types":`以及以下其中一种资源类型`,
"label.emailtocloudcc.search":`搜索`,
"label.mobile.home.page.myyj":`我的业绩`,
"vue_label_normal_invoice_sf":`发票`,
"label.permission.detail.app.fenpei.tip":`指定应用程序菜单上面何种应用程序可见的设置`,
"label.login.access.month":`月`,
"label_tabpage_retypez":`更改记录的记录类型时，现有选项列表值不会自动更改。我们建议在相同的地方更新记录上的现有选项列表值。`,
"label.ems.private.company.message":`私有云版本不支持在线编辑公司邮箱`,
"label.dataimport.length.check":`长度超过18位，请仔细检查本条记录并修改。`,
"label.batchtransfer.type1":`转移不属于现有客户所有人的未处理业务机会`,
"vue_label_calendar_are_you_sure_to_remove":`确定移除此日历吗`,
"label.icon.117":`书包`,
"vue_label_systemSettings_downloadapp":`下载移动程序`,
"label.approval.project":`待批准项目`,
"template.organization":`组织级`,
"label.weixin.return.research":`返回微调研信息页面`,
"label.ccchat.person.invite.addsay":`添加一条可选的信息...`,
"UG.Case.02":`个案可让您响应并解决客户问题。个案在 Cloud CC中是功能强大的记录，不仅可以跟踪客户问题，而且也可以显示完整的客户视图。`,
"label_emailtocloudcc_step1":`步骤1`,
"workflow.action.tasks.assignortype.owner":`所有人`,
"label.data.import.page":`进入数据导入页面`,
"label.cache":`缓存`,
"label.custom.page.cuspage.width":`页面宽度（像素）`,
"label.customcomponent.referencetag":`引用标签`,
"label.tabpage.search":`搜索`,
"label.knowledge.searcharticle.casefields":`用于查找推荐文章的个案字段`,
"setup_layout_message_relatedlistfield":`选择在相关列表上显示的字段，您也可以对选定字段重新排序。`,
"label.relationobject.type":`相关对象类型`,
"UG_Account_02":`有些企业向其它企业提供服务，有些企业直接与终端用户进行协作，有些则服务于NGO组织。`,
"UG_homepage_006":`通过问卷调查、即时聊天、邮件、工单对社交媒体帖子甚至销售活动（如潜在客户、服务支持和活动）来360度了解您的客户活动。`,
"chatter.poll.option1":`选项1`,
"label.ccdocument.fieldforld":`文档所属文件夹名称`,
"label.wei.result":`投票结果`,
"label.recentview.new":`最新`,
"label.martrixreport.setsumfield":`选择将在您的矩阵报表中用作汇总行的字段`,
"label.reportsSubscriptionPage.schedulereport.weekly.monday":`星期一`,
"label.marketsea.button.recycle":`回收`,
"label.standard.buttonandlink.info2":`请选择用来替换此标准按钮或链接的CloudCC URL的自定义页面。`,
"label.reportsSubscription.select.two.months":`该频率的日期范围请选择在两个月之内!`,
"label.standard.buttonandlink.page":`标准CloudCC页面`,
"vue_label_commonobjects_view_chart_horizontalbar":`水平柱状图`,
"label.Remove":`移除`,
"label.mobile.phone.receivable":`回款`,
"label.appupload.uploaddetail.goback":`返回软件包列表`,
"label.select.role":`请选择角色`,
"label.file.sharetype":`共享类型`,
"label.app.chosetab":`选择菜单`,
"label.case.other.phone":`其他手机号`,
"chatter.edit.cancel":`您的更改已取消。`,
"label.html":`HTML`,
"message.auth2cn.acquisition.failed":`auth2cn获取失败！`,
"message.error.system.service.permissiondeny":`对不起，您没有被授权此服务，请联系系统管理员！`,
"label.chatter.mygroups":`我的小组`,
"label.umeng.approval.approvalpass":`#obj批准请求已通过#objname`,
"label.chatter.owner":`所有人`,
"vue_label_commonobjects_view_kanban_view":`看板视图`,
"message.please.choose.group.role":`请选择小组角色`,
"label.icon.136":`货币`,
"label_tabpage_selectdate":`选择日期`,
"chatter.emailInformation":`一般信息`,
"front-lightning-module-v1-dashborad-bubble-size":`气泡大小`,
"label.stdashbord.xsld.business.wan":`万`,
"label.datamanage.field.notexist":`对象对应的字段不存在`,
"UG.Forcast.04":`开始试用`,
"UG.contact.02":`通过多个渠道吸引联系人 通话, 邮箱 , 社交`,
"vue_label_pool_selecttransferinto":`选择转入的公海池`,
"label.quote.xingming":`姓名`,
"label.customerinfo.userlicencenum":`用户许可证数`,
"label.group.no.my.archived":`找不到匹配的已归档小组。`,
"label.weixin.add.activity.tel":`添加活动电话`,
"label.partner.setup.address":`伙伴云地址`,
"label.data.file.i_title.num3":`3.系统会把将要导入的数据文件预读到服务器，然后启动后台批处理导入程序，导入结果将以邮件方式通知用户，您无需在此操作页面等待。`,
"label_sum_up":`求和`,
"label.searchall.title":`全局搜索`,
"label.bind.chooseone":`选择所有人`,
"label.campaign.channel.input.owner.select1":`当前市场活动所有人`,
"front-kefu-moudle-v1-Expand-chat":`展开聊天详情`,
"label.component.hotdeal":`热门交易`,
"component_event_label_title":`即将进行的事件`,
"No.planed.activity":`暂无计划中的活动`,
"label.searchlayout.result.field":`搜索结果显示的字段。`,
"label.leadscore.value":`分值`,
"vue.dashboard.linkage.is.set.successfully":`设置联动成功！`,
"PersonalInfo.LoginHistory.001":`浏览器验证邮箱注册链接`,
"front-gantt-module-v1-problem-number":`问题数量`,
"label.page.step5.of.step5":`第5步，共5步`,
"label.sendemail.chat.sendmessagesubject":`CloudCC CCChat消息提醒`,
"label.Linkedin_accounts":`领英账号`,
"label.qrcode.useful.life":`二维码有效期`,
"deleterow":`删除行`,
"label.forecast.settings.future1":`未来1个周期`,
"message.error.group.operation":`小组归档错误`,
"label_tabpage_loadz":`页面加载中，请稍后...`,
"label.brackets.left":`(左括号`,
"label.source.code":`源码查看`,
"setup_layout_label_areasetup":`设置区域属性`,
"component.assistant.label.todaylead":`今天分配给您的潜在客户`,
"label.qrcode_signin":`二维码仅限于需要现场扫描和登录的应用程序`,
"label.calendarshare":`日历共享`,
"IMG":`图片`,
"label.use.rule.when.both":`同时启用条形码和二维码规则时，使用此规则`,
"label.ccpeak.addshare.record":`新增共享表记录：见新增记录。`,
"label.enable.email.tracking":`启用电子邮件跟踪`,
"label.top.plsinput":`搜索此列表...`,
"vue_label_helpcenter_case":`    个案是客户的反馈或问题。支持代理可审核个案，以了解如何提供更好的服务。销售代表可以使用个案来了解对销售流程的影响。对个案做出响应可以让您的客户满意，提升品牌形象。`,
"label.useonly":`专用`,
"label.displaytype":`显示类型`,
"label.most.user.group":`用户最多可加入100个用户组。您已加入100个`,
"label.umeng.activity.yourevent":`您的事件`,
"label.forecast.shrepage.classdes.w":`读  / 写 - 用户可以查看和覆盖预测数据。`,
"label.defaultaccess":`默认访问权限`,
"label.partner.new.step2":`步骤2：确认模板`,
"component_setup_iframe_label_title":`自定义页面`,
"label.sso.saml.sp.idenitytype":`SAML身份类型`,
"label.dashboard.this.folder":`此文件夹中的仪表板`,
"label.data.newtemplate.e.seltype.desc":`数据导出方式有两种：</li><li class`,
"label.forecast.customforecast.submit.tip1":`是否提交从`,
"label.version.workflow.and.approval":`工作流和审批自动化`,
"label.tianyancha.tip":`输入有误，请重新输入！`,
"label.report_details":`报表详情`,
"template.report.folder.contract.product":`合同和产品分析`,
"label.all":`所有`,
"label.version.area.long.rich":`{0}个富文本或长文本区字段`,
"label.enc":`存储加密`,
"vue_label_pricebook_enterproductname":`请输入产品名称`,
"label.edit.quote.line":`编辑报价行`,
"label.edit":`编辑`,
"M":`主详信息关系`,
"front-kefu-phonenumber-exists":`坐席号为{a}的电话号码已存在`,
"label.standardplatformuser":`标准平台用户`,
"label.custom.page.configuration":`自定义页面配置`,
"url.error.contact.null":`微服务地址为空`,
"label.sethelp":`帮助设置`,
"setup.mainpage.label.welcome23":`安全性设置`,
"label.sales.page.dashboard.fenxi":`销售分析仪表板`,
"label.limit":`权限`,
"maintenanceasset.asset.contractlineitem.illegal":`您必须先在合同行项目上选择资产，才能将合同行项目与维护资产关联。`,
"UG.contact.04":`或者`,
"Opportunity.Detailed.Phase.Label.004":`天`,
"label.emailobject.receive":`收件人`,
"label.brief.new":`新增`,
"label.marketsea.button.adopt":`领取`,
"label.select.up.to.three.fields":`最多选择三个字段`,
"vue_label_allsearch_noresults":`我们已搜索您常用的搜索项，未找到与{userInput}匹配的结果`,
"Report_CantDelete_Info":`{0}报表被{1}仪表板引用，不可删除！`,
"label.chile.summer.time":`智利时间`,
"label.partnerCloud.menu.selectedMenu":`已选菜单（勾选的菜单将同时显示于移动端）`,
"vue_label_report_onlysummary":`仅汇总`,
"front-template-V1-Applicable-object":`请选择适用对象`,
"label.invoice.message.sendfailed":`Invoice发送失败，请稍后重试`,
"front-kefu-moudle-v1-use-free":`免费试用`,
"label.rule.updated.successfully":`规则更新成功`,
"label.owner.lastone":`至少维护一个条件`,
"label.appointment.wizard.subtitle1":`请设置每次会议的时长`,
"template.report.opportunities.closed.month":`本月关闭的业务机会`,
"label.tabpage.choosecontent":`请选择值内容`,
"template.chart.jbnddxl":`近半年订单销量`,
"label.fieldsecurity.detail":`字段安全性详细信息`,
"label.knowledgebase.data.deleted.successfully":`{a}条数据删除成功`,
"label.sso.saml.idp.config.nameidfmt":`名称ID格式`,
"label.emailobject.prompt":`提示`,
"label.marketsea.isgetbyself":`允许成员自行领取`,
"label.winxin.cancelprompt":`当前操作未保存，是否确认退出`,
"label.appexchange.installedpage.message2":`应用程序和组件以软件包的形式进行安装。任何自定义的应用程序、菜单、自定义对象、自定义页面和触发器开始都标记为“正在开发”，且不向用户部署。这使您可以在部署之前先测试和自定义它们。您可以使用设置中的其他功能单独部署组件，或者单击部署以作为一个组件来进行部署。`,
"vue_label_import_importtype":`导入类型`,
"label.data.importef.des":`导入失败的文件将在服务器上保留48小时，48小时后将自动删除。`,
"chatter.email.reply":`对我的帖子进行回复时`,
"label.stdashbord.xsld.business.sdl":`失单率`,
"labal.emailtemplate.namemessage":`邮件模板的唯一名称已存在，请重新编辑`,
"vue_label_email_Please_select_file":`请选择文件`,
"label.event.modify":`编辑事件`,
"label.projectManagement.isnmber":`请输入最多一位小数的数字`,
"lable.outlook.detail.emailst":`电子邮件设置`,
"label.partnerCloud.priceOfManual.isUsed":`该设置影响伙伴用户订货时，是否可以使用该价格手册。`,
"setup_mainpage_label_welcome26":`数据管理 - 批处理功能`,
"label.file.version":`版本`,
"pagecreator_systemstyle_label_bordercolor":`边框颜色`,
"label.approval.isallowed.reject.prompt":`单一数据审批时是否允许拒绝（批量审批始终可以拒绝）`,
"label.myinfo":`我的信息`,
"front-template-V1-fontSize":`字号`,
"lable.outlook.edit.alpreo":`始终首选Exchange`,
"front-email-payment-card-number":`卡号`,
"label.cpq.quote.pricebook.no.change":`报价单的价格手册一旦确定后，不可以再更改。如果使用新的价格手册，请新建1条报价单记录`,
"vue_label_file_size_limit_tip":`文件大小超过限制`,
"lable.PowerProcess.worktime":`权利过程工作时间`,
"label.monthly.month.report":`月度同环比报表`,
"front-kefu-moudle-v1-sydq-buyuser":`您的试用已到期，请购买环信账号后使用`,
"label_tabpage_Rolesz":`角色和下属`,
"chatter.f.n":`追随该记录`,
"UG.Forcast.02":`预测是对指定阶段预期销售的估算，预测模式可帮助您确定一段时间内的产品需求和销售收入情况。管理者可以使用预测来设定目标并衡量团队的进展情况。机构的整体预测可按销售代表来反映所有销售的概要情况（不论销售处于从管道阶段到关闭阶段之间的何种完成阶段）。`,
"label.productsales.contract.phb":`合同排行榜`,
"label.umeng.insert.approval.submit":`#applyer提交#obj待您审批`,
"message.duplication.label.matchfirstletters":`前n个字符匹配`,
"label.partnerCloud.partnerAccount.toPay":`前往支付`,
"label.model.un":`型号：UN6786`,
"label.save.c1":`Web to CloudCC 的名称不能重复!`,
"week":`星期`,
"Pagelayout.Setup.003":`Name字段必须选择`,
"label.query.detail.openpartnermessage":`一旦将客户作为合作伙伴启用，它就会出现在isPartner字段上筛选过的报表和列表视图中。另外，合作伙伴用户可以从与此客户关联的联系人进行创建。是否确定？`,
"label.validate.function.funcFormat.DATEVALUE":`DATEVALUE(date)`,
"label.apply.send.false":`发送失败。`,
"label.recordtype.edit.selectvalue":`选项列表值`,
"label.chosesubject":`选择主题`,
"label.validate.function.funcExplain.YEAR":`返回日期的年份，是 1900 与 9999 之间的一个数字`,
"component.chatter.button.more":`查看更多详细信息`,
"label.top.class.smallest":`层级最小是1`,
"label.startingvalue":`初始编号`,
"label.multi.layout.remark":`应用于前台主从录入及批量新增时所显示的布局`,
"label.role.availableuser":`可选用户`,
"label.weixin.iebrowser":`您当前使用的浏览器版本为IE6，IE6是微软2001年发布，由于此浏览器版本过低，CloudCC系统是采用新技术开发，不保证所有功能正常使用，请及时下载更新您的浏览器。`,
"Homepage_News_004":`暂无新闻`,
"vue_label_normal_task_sf":`任务`,
"label.version.nonsupport.trigger":`暂不支持触发器！`,
"pagecreator_page_label_pagelayout":`页面布局`,
"label_tabpage_step3":`第三步：选择要显示的字段`,
"label.canOnlyUploadCSVFormatFile":`只能上传csv格式文件。`,
"label.b.c.least":`每个 B" 记录必须至少有一个相关 "C" 记录。"`,
"label.list.userinterface.sales.enable":`销售主页排行榜查看数据启用权限`,
"label.umeng.approval.approvalreject":`#obj批准请求被拒绝#objname`,
"vue_labenl_normal_notice_share_fail":`共享失败`,
"label_emailtocloudcc_tip":`提示`,
"label.h5.touchselect":`点击选择`,
"label.tabularreport":`列表式报表`,
"label.app.defaulttab":`默认菜单`,
"label.validate.function.category.Datetime":`日期和时间`,
"vue_label_pricebook_editdetail":`编辑价格手册条目`,
"vue_label_commonobjects_view_no_selected_record":`未选择记录`,
"chatter.changed":`将`,
"label.asset.bom.based":`根据订单的产品结构生成资产BOM`,
"label.appointmentdetail.wizard.title8":`每隔多久开始`,
"label.area.query.user.error":`查询区域对应的用户数据失败，区域ID为空。`,
"page.field.masterinput":`设置主从录入`,
"chatter.selads":`选择收件人`,
"label.data.exp.please.savebutton":`请勾选“另存为模板”。`,
"label.members.activity":`活动成员`,
"label.weixin.click.searchs":`点击查找记录`,
"label.input.least.two":`请输入至少两个字符`,
"label.marketing.seting":`市场云设置`,
"label.approveprocess.tip":`批准是一个复杂的业务过程，它需要在实施前收集信息并进行计划。建议您在开始前遵从以下指导说明。`,
"front-email-payment-Invoice-login-account":`登录账户`,
"label.selectmulti.mes":`所选收件人 过多。`,
"label.workflow.gotolist":`返回工作流列表`,
"label.profile.fieldsafety":`字段级安全性`,
"front-project-module-v1-no-selectemplat":`当前无可用模板`,
"label.sendemail.queue.assigntitle":`队列分配对象记录通知邮件`,
"label.approval.mobile.comments.placeholder":`请在此输入备注，最多1000字`,
"vue_label_report_given":`特定`,
"vue_label_dashboard_groups":`请选择分组`,
"label.service.gantt.popoverTip":`大约出行距离/预计出行时间`,
"label.mr.title.characters":`按前几个字符`,
"label.passwordPolicy.setup.day":`天`,
"label_tabpage_personvisible":`相关人员可见`,
"ct":`多币种`,
"label.chatter.newEvent":`新建事件`,
"vue_label_systemSettings_id":`登录身份`,
"label.page.preview.web.tab":`预览Web 菜单`,
"label_emailsync_button_sure":`确认`,
"front-template-V1-Modification-time":`修改时间`,
"vue_label_homepage_edit_fixed_components":`编辑标准组件`,
"label.apply":`应用`,
"Main.Menu.Mobiledownload":`可用于`,
"vue_label_salesfunnel_notice6":`可能性为100%的业务机会总金额`,
"label.chosesubject.sendemail":`发邮件`,
"label.changemydisplay.chagetab.des":`选择要在您的每一个应用程序中显示的菜单。`,
"label.attendance.setting.checkUser":`已经存在其他的考勤中.`,
"label.list.projectSetting.setup":`项目管理设置`,
"label.app.introduce2":`您可以自定义现有应用程序以匹配您的工作方式，或通过对标准和自定义菜单分组构建新应用程序`,
"label_emailsync_form_emialpassword":`密码`,
"label.Lightning.Setting":`Lightning设置`,
"label.print.preview":`打印预览`,
"label_vue_create_edit_obj_create_event_dialog_desc_alert":`您是否仍要在该时间段内创建本事件？`,
"label.mobile.phone.report.type":`报告类型`,
"lable.account.CalenderWeek":`日历星期`,
"label_emailtocloudcc_step3total3":`第3步，共3步`,
"label_tabpage_emailaddressz":`发件人邮件地址`,
"label.data.is_woking":`正在操作`,
"label.knowledge.cancelattach.case":`取消附加到个案`,
"label.sendemail.chat.chatcontent":`主贴内容：`,
"label.timezone.set":`区域设置`,
"label_tabpage_uploadingz":`上传中`,
"front-epwechat-module-v1-home-url":`主页url：`,
"label.reportsSubscription.select.subscription.frequency":`请选择订阅频率！`,
"label.validate.function":`函数`,
"label.partnerCloud.orderingPlatform.quantity":`购买数量`,
"label.compact.layout.chatter":`微帖`,
"label.sso.saml.sp.description2":`配置单点登录，以便从外部环境登录CloudCC系统`,
"label.ccchat.message.new.error1":`我们找不到任何姓名带有{0}的Chat用户`,
"label.file.share.email.content3":`具体信息请登录CloudCC CRM系统查看`,
"label.file.cancel.sharing":`取消共享`,
"label.changemydisplay.showalltabs.add":`添加菜单到默认显示`,
"label_chatter_incident":`事件`,
"label.file.folder.delete3":`是否确定要删除{foldername}？`,
"label_tabpage_delsuccessz":`删除成功`,
"label.view_contact":`查看联系人`,
"label.deactivate":`禁用`,
"label.Horizontal.Date":`按照水平日期筛选服务预约`,
"label.forecast.tree.title":`预测层次结构`,
"vue_label_dashboard_dategruop":`请选择日期分组依据`,
"label.version.nonsupport.custompage":`暂不支持自定义页面！`,
"label.tabpage.personvisible":`相关人员可见`,
"message.error.unknown":`未知的错误;`,
"label.down":`向下`,
"label.multilang.customforcast.financialyear":`第{0}会计年度`,
"label.dataimport.type.error":`类型错误，请仔细检查本条记录并修改。`,
"label.batchadd.newbatchpage.save.num":`数值格式不正确`,
"front-Dev-V12.2.8-calendar-endField":`结束字段`,
"label.tabpage.rtemptyz":`记录类型不能为空`,
"vue_label_dashboard_maximum":`请输入最大值`,
"label.expiredate":`到期日期`,
"label_emailtocloudcc_button_view":`查看`,
"label.event.future":`未来的事件`,
"label.mobile.app.layout":`移动端布局`,
"label.emailobject.contacts":`个联系人`,
"label.approvalstep2.tip":`指定记录在进入此步骤前是否满足某些条件。`,
"label.usefollowtoset":`使用下面的选项，指定批准请求应分配给的用户。`,
"label.dashboard.summary.editPageHeader":`编辑页眉`,
"label_partner_workspace_tab_memo":`选择在此伙伴云中可以使用的菜单，可以选择系统标准菜单和自定义菜单。`,
"front-lightning-module-v1-details-page-chart-title-supports":`· 标题支持插入记录名称，格式为{recordname}，如：设置的名称为{recordname}的业务机会总金额，当前记录名称为神州云动，则在展示时名称为“神州云动的业务机会总金额”；`,
"label.enable.generate.location.service":`启用根据客户地址生成客户经纬度数据服务`,
"label.loginsystem":`登录系统`,
"label.email.template.edit.template":`编辑模板`,
"vue_label_commonobjects_detail_share":`收入份额`,
"label.icon.142":`房子`,
"label.maintype":`主类型`,
"label.step2.total4":`第2步，共4步`,
"label.select.intended.tablayout":`选择希望创建的 Web 菜单的页面布局`,
"label.custom.unit":`单位`,
"label.mr.title.phone":`电话`,
"label.compact.layout.frame.showtype":`显示方式：`,
"label.associations":`关联对象`,
"label.potentialcustomers.name":`潜在客户名称`,
"label.edit.profile":`更新简档`,
"label.tabpage.allvisible":`所有用户皆可见`,
"label.login.verification.confirmation.enabled":`确认启用`,
"vue_label_norm_recordselected":`已选择{selectNum}条数据`,
"label.partner.workspace.member.selectedprofile":`已选简档`,
"label.divide":`/除`,
"label.version.case.control":`Case 管理`,
"label.attendance.nocheckin":`未签到`,
"vue_label_helpcenter_report2.1":`2、移除行分组：<br>    A.在左侧“组行”列表中找到想要移除的“行分组”字段后，单击字段框上的“×”。<br>    B.或在右侧预览报表的表头中找到想要移除的“行分组”字段后，单击“下拉按钮”，单击“删除组行”。 <br>    移除列分组：<br>    A.在左侧“组列”列表中找到想要移除的“列分组”字段后，单击字段框上的“×”。<br>    B.或在右侧预览报表的表头中找到想要移除的“列分组”字段后，单击下拉按钮，单击“删除组列”。 <br>•自定义日期粒度分组记录<br>    步骤1：在按日期字段分组记录后，您也可以自定义日期粒度。首先，选择您想要作为报表分组依据的日期字段。然后单击预览报表表头中的这个字段旁的“下拉按钮”，单击“日期分组依据”。 <br>    `,
"label.payment.renew":`续费`,
"vue_label_file_wrong_type":`文件上传类型有误,您现在上传的文件格式是{type}!`,
"UG_opportunity_005":`多销售流程`,
"label.knowledge.language.korean":`韩语`,
"label.customobjects.inputrecordtagandformat":`输入记录的标签和格式`,
"label.h5.chatter.commentednum":`收到的回复`,
"label.quickbooks.button.unlink":`取消关联`,
"label.step5.total5":`第5步，共5步`,
"label.projectManagement.Selweek":`选择周`,
"label.optional.searchfield":`可选搜索字段`,
"label.mobile.quickcreate.default.signin":`签到`,
"label.visualpage.unable.parse":`无法解析的标记`,
"mesage.error.role.delete":`无法删除角色，因为当前为角色分配了子角色。`,
"label.role.user":`角色中的用户`,
"button_partner_workspace_saveas":`另存为`,
"label.file.no.public.link.created":`未创建公用链接`,
"label.login.access.shenyu":`余下`,
"label.ccchat.group.section":`小组`,
"label.weixin.object.notnull":`主题不能为空`,
"label.accmarketsea.add.title":`客户公海池新建`,
"label.sales.funnel.layout":`销售漏斗布局`,
"pagecreator.page.button.edit":`编辑`,
"label_tabpage_entercontent":`请输入内容`,
"component_event_label_begindate":`*开始时间`,
"label.file.versionhref":`跳转到新版页面&gt;&gt;`,
"label_chatter_send":`发送`,
"setup_layout_label_buttonlist":`按钮选择`,
"label.custom.Current.and.NexttCQ":`当前和未来三个自定义季度`,
"pagecreator_page_label_pagedesc":`页面描述`,
"label.appupload.upload.uploader":`上载人`,
"label.console.step5.tab.primary":`作为主菜单`,
"vue_label_globalsearch_expandlist":`展开列表`,
"label.forecast.edit.userqu":`的目标`,
"label.step1.total5":`第1步，共5步`,
"label.multilang.dupicatecheck.onegroupredata":`查重合并进度：共{0}组：`,
"vue_label_systemSettings_repeat":`管理重复`,
"label.mobile.side.tab.error1":`请选择需要展示的常用功能、应用程序菜单`,
"label.knowledgebase.reduction":`还原`,
"label.standard.buttonandlink.override.usedefault":`没有覆盖（使用默认）`,
"dateandtime":`日期/时间`,
"label.group.activate.info":`启用小组`,
"label.triggertotask":`任务触发器`,
"label.emailobject.save.template":`保存为模板`,
"label.audit.objInfo":`审批详情`,
"label.callcenter.successfully.logged.account":`已成功登录账号！`,
"label_new_customer_target":`新建客户目标`,
"label.campaign.channel.step5":`步骤5：营销渠道注册页面预览与源代码查看`,
"label.log.type":`操作类型`,
"front-template-V1-noTemplate":`当前切换对象下没有可用模板`,
"label_report_line_daixuan":`待选报表列`,
"label.tianyancha.businessverify.relation.tip":`将天眼查返回的字段回写到客户字段上`,
"label.default.value":`将此值作为主选项列表的默认值`,
"label.weixin.campaign.attendance":`市场活动签到`,
"message.duplication.label.check":`校验`,
"label.salescloud.salescloud.yes2forbidden":`是，禁用小组销售`,
"lable.currencyAdv.exchagecurrency.rate":`汇率范围`,
"lable.Hide.title":`隐藏标题`,
"label.finishedreport":`已生成的报表`,
"vue_label_account_business":`转移客户所有人的已结束业务机会`,
"vue_label_pool_assigned":`已分配`,
"label.report.export.error":`导出遇到异常，请重新操作。`,
"label.layout.availablefield":`可用字段`,
"label.licence.remainder":`许可证剩余数量`,
"label.approval.idea.required":`审批意见必填`,
"front-kefu-moudle-needhand-createcase":`需人工确认后再创建个案`,
"label.dashboard.snapshot.Data.change":`数据源发生变化，请重新配置`,
"label.partner.workspace.login.footertext":`页脚文本`,
"vue_label_chatter_upload_link_type":`已选择上传链接类型帖子`,
"front-dialog-module-v1-error-detail":`错误详情`,
"label.emailobject.sendgroupemail":`批量发送邮件`,
"lable.newtabpage.allviews":`全部视图`,
"label.khdd":`客户地点`,
"vue_label_dashboard_sortfield":`排序字段`,
"label.form.sample":`表单示例`,
"component_setup_button_cancel":`取消`,
"vue_label_salesfunnel_notice5":`可能性为1%-99%的业务机会金额*可能性`,
"pagecreator_systemstyle_label_modifystyle":`样式编辑器`,
"UG_homepage_001":`在较少的时间赢得更多的交易`,
"label.campaign.pc":`电脑端`,
"label.visualpage.lightning":`lightning版本`,
"label.knowledge.category.hint.two":`创建分类组后，使用此页面来选择 Lightning 应使用的组。`,
"label.south.africa.standard.time":`南非标准时间`,
"label.service.gantt.reservation.number":`预约编号`,
"label.weixin.report.period":`时间段`,
"label.leadtomap.exp":`将组织的每个潜在客户自定义字段映射到自定义客户、联系人或业务机会字段。在转换潜在客户时将使用这些映射。`,
"label.currency.d":`可以将公司币种更改为贵组织支持的另一种币种。系统中以定义的所有货币兑换率将作相应修改以反映此次修改。`,
"label.forecast.detailforecast.oppyclb":`业务机会预测类别`,
"label.reportsSubscriptionPage.email.selected":`所选成员`,
"vue_label_homepage_componentname":`请输入组件名称`,
"lable.account.Previous.FYt":`前两个会计年度`,
"label.appupload.success":`上传完毕`,
"label.customer.newtab":`新建自定义页面菜单`,
"label.value.notnull":`值不能为空`,
"label.case.miniprogram.layout":`客户生成个案：客户通过网页或微信小程序提交服务请求单时使用此页面布局，此布局只能编辑不能删除。`,
"label.partnerCloud.partnerAccount.twoDecimal":`请输入正确格式，可保留两位小数`,
"UG.Lead.004":`Web表单`,
"label.umeng.activity.event.eventwillbeginnew":`事件通知:#event，开始时间#begintime`,
"label.projectManagement.subtasks":`子任务`,
"vue_label_checkduplicate_repeat_conditions":`判定重复条件`,
"label.subject":`主题`,
"label_search_otherusers_forecast":`搜索其他用户的预测`,
"label_tabpage_namemandatory":`视图名称为必填内容`,
"label.timezone.importtimezone":`数据导入日期时间字段时区设置`,
"label.mobile.buttom.team.init":`群策用户初始化`,
"label.checkfield.choosefield":`请选择要进行查重的字段`,
"label.b_c_least":`每个 B" 记录必须至少有一个相关 "C" 记录。"`,
"label.knowledge.setting.hint.five":`选择Knowledge作者`,
"label.h5.similar.opportunity.step2":`步骤2.指定匹配条件`,
"label.page.style.imbedded.cloudcc":`使用整页样式可以最大限度的查看嵌入CloudCC.com窗口的屏幕内容。`,
"label.sendemail.marketactivity.invitecode":`市场活动#campaignname的邀约码`,
"label.block.pricing":`打包一口价`,
"message.error.field.number.zero":`长度输入格式有误,不能是0`,
"pagecreator.systemstyle.message.save.success":`样式保存成功`,
"pagecreator_systemstyle_label_styledesc":`样式描述`,
"APPIntegration_Dropbox_setting_01":`启用`,
"label_emailtocloudcc_redmessage2":`请输入正确的邮箱密码`,
"label.user.special.operations":`运营专用，暂不能使用，请联系管理员！`,
"pagecreator_page_label_layoutpreview":`布局预览`,
"APPIntegration_Dropbox_setting_03":`启用Dropbox，让您可直接在附件上从dropbox里面选择文件。`,
"label.sure_leave":`您确定离开吗`,
"label.applt.copylink":`复制小程序链接`,
"label_tabpage_allpotentialcustomers":`所有潜在客户`,
"label.rulestrikedate":`规则触发日期`,
"label_tabpage_justsz":`刚刚`,
"label.customize.memory.function.sorting.title":`自定义我的列表记忆功能`,
"message.duplication.label.mergebutton":`合并`,
"chatter.group.cancelRequest":`取消申请`,
"label.campaign.channel.step6.remark":`如果注册页面已经确认，点击生成按钮，系统将为您生成注册页面`,
"label.appupload.upload.install.abort":`结束安装`,
"label.emailobject.proposetimes":`日程预约`,
"label.probability.cannot.empty":`可能性不能为空，且必须是数字`,
"vue_label_homepage_editkanban":`编辑看板`,
"lable.Related.template":`相关模板`,
"label.cloudccclass.list.cls.time":`定时类`,
"component.task.label.enddate":`到期时间`,
"label.sendmail.step3":`步骤3：审核和确认`,
"label.projectManagement.Gridview":`网格视图`,
"label.emailobject.time":`发件时间`,
"label.applt.address":`小程序客户服务门户地址`,
"label.searchfield":`搜索字段`,
"vue_label_calendar_please_enter_the_name":`请输入名字`,
"label.list.userinterface.default.page.setup":`系统默认界面`,
"label.detail.2018":`详细信息`,
"label.webtocloudcc.success":`您的信息已提交成功，十分感谢您的参与，我们将竭诚为您服务！`,
"component_telerecord_label_title":`记录电话`,
"label.setting.sureDelete.rules":`确定删除此规则吗？`,
"vue_label_email_current_theme":`插入此模板将覆盖当前邮件主题`,
"lable.Order.product":`订单产品`,
"UG_product_02":`产品参考销售或采购的产品或服务。`,
"label.appexchange.task":`工作流任务`,
"label.selectprocesscondition":`指定步骤条件`,
"label.mobile.quickcreate.default.scan":`扫一扫`,
"label.tabpage.prepagez":`每页显示`,
"label.query.error":`查询出错了`,
"label.tabularreport.2018.step1":`步骤 1：选择报表列`,
"pagecreator.systemstyle.label.modifystyle":`样式编辑器`,
"label.app.step3":`步骤 3. 选择自定义应用程序徽标的图像源`,
"label_tabpage_rowsz":`删除行`,
"label.validate.function.funcExplain.SUBSTITUTE":`用new_text替换文本字符串中的old_text。要替换文本字符串中的指定文本时，使用SUBSTITUTE`,
"vue_label_checkduplicate_select_data_to_merge":`选择数据进行合并`,
"vue_label_commonobjects_view_chart_displaymode":`展开方式`,
"label.industrialandcommercialverification.servicesetiings":`服务设置`,
"label.refresh":`刷新`,
"label.taskfield":`任务字段`,
"label.notification.approval4":`【提交人】正在请求批准【对象】`,
"label.group.isusing":`启用`,
"label.language.settings":`语言设置`,
"front-kefu-moudle-please-login":`请先登录`,
"label.page.double.line.cloudcc":`双行并包括CloudCC侧栏`,
"folder.error.delete":`1.当前文件夹中含有报表，无法删除！2.当前文件夹含有隐藏报表，无法删除！隐藏报表是根据逻辑删除对象（设置-创建-对象下已删除的对象）创建的报表，因该对象未真正删除所以隐藏此报表`,
"eight":`八`,
"label.marketseamemset.user":`成员`,
"label.recordnum":`记录编号`,
"page.404.button.back":`返回上一步`,
"label.mobile.phone.month.plan":`下月计划`,
"label.marketseamemset.account.title2":`请设置影响所有成员拥有客户的数量上限，限制与公海池无关`,
"vue_label_chatter_current_avatar":`当前头像`,
"label.mobile.side.tab.remark3":`按住Shift键单击或者直接单击拖动以选择一系列相邻的项目；按住Ctrl键单击可选择多个不相邻的项目`,
"component.sendmail.label.touser":`收件人`,
"label.homeitems.noobject":`无主题`,
"template.report.overall.sales":`整体销售期（按潜在客户来源）`,
"label.partner.donotdel":`无法完成对`,
"label.service.miniProgram.bindCopyDesc":`将组织和贵公司的公众号或小程序绑定后，一键复制跳转地址，即可使用此地址拥有属于贵公司的客户服务门户。`,
"UG_Contract_01":`管理合同`,
"UG_quota_06":`创建报价`,
"vue_label_report_deletereport":`删除报表`,
"front-epwechat-module-v1-input-appname":`请输入应用名称`,
"label_tabpage_deleteviewsuccess":`视图删除成功`,
"component_chatter_label_mygroup":`我的小组`,
"label.campagin.roi.leixing":`市场活动类型`,
"label.dashboard.myHomepageDashboard":`我的主页仪表板`,
"UG_solution_04":`导入解决方案`,
"label.knowledge.setting.hint.four":`启用Knowledge`,
"label.campaign.channel.add.field":`点击按钮，添加字段`,
"label.eastem.european.time":`东欧时间`,
"label.partner.workspace.member.partner":`CloudCC Partner简档`,
"label.campaignmember.main.backtocampaign":`回到市场活动`,
"label.reportsSubscriptionPage.schedulereport.monthly.time.absolute":`绝对`,
"label.task.unsolve":`所有未处理任务`,
"label.multilang.chatterservice.vote":`{0}票`,
"label.console":`控制台`,
"label.emailsync.message1":`取消关联后将无法同步该邮箱邮件内容至联系人、潜在客户，确认取消？`,
"pagecreator.systemstyle.label.stylename":`样式名称`,
"setup_mainpage_label_welcome16":`操作指导： 点击本页左侧菜单 → 应用程序设置 → 创建 → 工作流、批准过程、任务、电子邮件通知、字段更新等。`,
"message.duplication.label.editfilterule":`编辑查重过滤器规则`,
"Account.News.Setting.004":`启用新闻`,
"label_tabpage_saveviewsuccess":`视图保存成功`,
"label.forecast.forehistory.replacecommit":`承诺额替代`,
"pagecreator_button_cancel":`取消`,
"label.knowledge.article.nomatch":`我们无法归档此文章，因为存在关联的草稿。删除草稿，然后重试。`,
"vue_label_combined_field":`没有可以用于合计的字段`,
"label.batchadd.save.prompt":`条记录`,
"label.tabpage.summaryway":`汇总方式`,
"label.check.input.condition.two":`不支持使用SQL`,
"mail.apiCode.notOnly":`唯一名称已经存在`,
"UG.quota.01":`管理客户报价`,
"label.approved.receiveApprovalEmail.option3":`仅在我是委派批准人时`,
"label.stdashbord.xsld.business.img5":`可能性为0%阶段的总金额`,
"vue_label_chat_movedfromto":`{name}将{label}从{oldField}更改至{newField}`,
"label.customfields.new.step2.opration":`一般选项`,
"label.dashboardSetup.isurl":`是否添加链接`,
"label.forecast.settings.mrfwqj":`默认范围期间`,
"label.campaign.channel.field":`字段`,
"label.weixin.optionthree":`选项三`,
"label.safetystatement":`安全声明`,
"label.useskipwizard":`使用跳转起点向导`,
"label.projectManagement.completion":`完成情况`,
"label.customfields.fielddependency.new.step2":`<b>步骤2：</b>在下面的页面上，编辑筛选规则，这些规则针对控制字段中每个值控制出现在依赖字段中的值。`,
"setup.mainpage.label.welcome8":`拖拽式界面定制`,
"label.emailobject.list.outbox":`发件箱`,
"label.app.default.login.tab":`默认登录菜单`,
"label.follow_emails":`访客提交表单后，邮件跟进访客是简便快捷的联系方法。`,
"vue_label_homepage_application_page":`应用程序主页`,
"label.confirm.template":`确认模板`,
"lable.product.not":`无法完成您对`,
"label.multilang.feedtrack.dispalyinfo":`您可以选择最多{0}个字段`,
"label.weixin.plz.inputsrhkey":`请输入搜索关键词`,
"label.projectManagement.service.appointment":`服务预约`,
"label.list.userinterface.watermark.enable":`PC与APP主页、视图、记录详情、报表、仪表板开启水印`,
"label.confirmDelete":`确定删除这些数据吗？`,
"label.sso.description":`用户可根据用户名和授权码免登录进入CloudCC系统。<br>进入系统URL：http://localhost:8080/ssologin.action?userName=admin@dev.com&authCode=dcc5c192facd7c08e124fbe93d8950b9 。<br>使用上面的链接时，"http://localhost:8080"请替换成贵组织的访问链接，"admin@dev.com"请替换成贵组织的用户名，<br>"dcc5c192facd7c08e124fbe93d8950b9"请替换成贵组织的授权码。`,
"errormessage_email_atleastonereceiver_z":`请至少选择或者填写一条收件人地址`,
"C":`累计汇总`,
"label.service.major.event.edit":`编辑重大事件`,
"label.icon.9":`维修`,
"label.visualpage.notvalidate.check":`不是有效的自定义页面，请参考帮助文档检查页面拼写。`,
"label.audit.todo.from":`来自:`,
"label.directboss":`直属上司`,
"label.manageAll.selpage":`当前页数`,
"label.console.step6.all":`全屏，取消固定。列表仅在选择了导航菜单时才可见`,
"vue_label_pool_expiredate":`到期时间`,
"lable.no.matching.record":`无匹配记录`,
"label.standard.redirecterror":`标准按钮跳转到自定义页面失败`,
"label.Platform.Setting":`平台设置`,
"lable.outlook.edit.havenewc":`具有最新活动的联系人`,
"label.partnerCloud.partnerAccount.choosePayment":`请选择支付方式`,
"label.weixin.optionsix":`选项六`,
"lable.SalesCommitmentKanBan.allCommitments":`Pipeline`,
"page_404_button_toknowmore":`了解更多`,
"label.customfields.number.tip":`允许用户输入任何数字。将删除前置零。`,
"label.import.index.processimport":`进行导入`,
"label.quote.phone":`电话`,
"label.insert.approval":`加签`,
"label.tabpage.printview":`打印视图`,
"lable.product.price":`价格`,
"front-kefu-moudle-call-detail":`通话详情`,
"label.umeng.approval.apply":`申请`,
"label.background.the.form":`表单背景`,
"chatter.f":`追随者`,
"label.quickbooks.searchresault.company":`客户`,
"vue_label_systemSettings_platformutils":`平台工具`,
"front-quotation-v1-nofilles-tocreate":`请点击生成报价单按钮，生成报价单后再发送。`,
"label.category.6":`医疗`,
"label.attendance.choose.positon":`选择地标`,
"label.batchadd.newbatchpage.save.pho":`电话格式不正确`,
"UG.Account.01":`您的客户是谁?`,
"label.marketseamemset.addspecialuser":`添加特殊成员`,
"label.query.detail.forbidpartneruser":`禁用合作伙伴用户`,
"label.stdashbord.xsld.business.ydzhl":`赢单率`,
"vue_label_SMS_mymessagebox":`我的短信箱`,
"label.knowledgebase.data.publishing.failed":`{a}条数据发布失败，请选择状态为草稿的文章进行发布`,
"label.wholestate":`整体状态`,
"label.selectedline":`选定的列`,
"label.validate.function.funcExplain.LEFT":`返回从文本字符串左边算起的指定数量的字符`,
"label.emailmerge.edittemplate.detail":`邮件合并模板信息`,
"vue_label_checkduplicate_checkduplicate":`查重`,
"label.knowledgebase.assign.articles":`分配文章`,
"label.tabpage.recordsz":`记录`,
"label.field.img.validate.error":`$User后的变量名拼写错误或非法的$User引用，请检查拼写！`,
"workorderlineitem.worktype.isnot.father.worktype":`此工作订单行项目必须选择其父级记录关联的工作类型`,
"label.ccchat.group.name.noexist":`您输入的小组名称不存在，请重新输入`,
"label.weixin.sign.type":`签到(退)类型错误`,
"label.nowvaluereplace":`替换为现有的`,
"report_label_report":`报表`,
"label.knowledge.setting.plus":`知识库Plus设置`,
"label.event.moveup.2day":`提前 2 天`,
"label.translation.start":`开始使用翻译工作台`,
"lable.PowerProcess.created.time":`基于{detailInterestType}的创建日期`,
"label.ems.step2":`步骤2`,
"label.tabpage.groupingemptyz":`分组项目不能为空`,
"pagecreator.layout.button.new":`新建布局`,
"label.tabpage.listshow":`列表显示`,
"label.partnerCloud.productSet.optionName":`选项名称`,
"label.service.without.cycle":`无周期`,
"label.chatter.sendEmailToGroupMember.subject.V":`{0}在小组{1}发布了全员投票`,
"label_target_model_dimension":`目标模型维度`,
"component.task.label.subject":`主题`,
"label.custom.field.login.query.information":`请进入系统浏览详细信息！`,
"label.validate.function.funcExplain.NOT":`将 FALSE 改为 TRUE 或将 TRUE 改为 FALSE`,
"pagecreator_layout_button_horizontal":`横向拆分`,
"lable.Returned.to.successful":`退回成功`,
"label.campaign.channel.ticket.title":`入场券`,
"label.ruleName.supportMaximum.50Characters":`规则名称最多支持50个字符`,
"label.email.track.attachment.size.control1":`当前邮件附件累计大小超过20M，无法继续上传。`,
"template.report.folder.opportunities":`业务机会分析`,
"label.knowledge.setting.data.eight":`您将要删除{flzmc}类别组及其类别。该类别将无法用于分配给记录。您有 15 天来取消删除该类别组。15 天后，它将被永久删除，并且无法恢复。是否确定要删除此类别组及其类别？`,
"mail.id.notNull":`模板删除时id不能为空`,
"vue_label_normal_product_sf":`产品`,
"vue_label_report_superiortothisrelationship":`上级对象到此对象关系`,
"label.leadscore.operation":`操作符`,
"label.customfields.formula.percentexample":`Discount（折扣）= (Amount - Discounted_Amount__c) / Amount`,
"component.setup.iframe.label.inputurlmemo":`请输入要引入的页面URL地址`,
"label.icon.177":`徽标`,
"label.tabpage.myz":`我的`,
"label.leadmarketsea.add.title":`新建潜在客户公海池`,
"label.partnerCloud.partnerAccount.thePage":`第 {skippageNum} 页`,
"label.visualpage.some.size":`代码容量 : 最大支持300KB字符,约300000字节`,
"label.setwxpay.null":`配置微信支付必填信息为空`,
"label.icon.74":`机床`,
"font-evaluate-module-v1-evbad":`评价类型是差评`,
"System.TimeField.Format.Warning":`不是有效时间`,
"label.captcha":`验证码`,
"label.payment.assessment":`评估其他版本`,
"message.error.not.taskevent":`非任务事件对象`,
"font-evaluate-module-v1-evaluation":`评价`,
"vue_label_commonobject_view_updatedago":`已在{timeInterval}刷新`,
"label.sendemail.birthday.newevent":`尊敬的{!ownerName}：\r\n  3日后是{!objectLable}{!recordName}的生日。请您关注！\r\n                        {!orgName}`,
"label.laststep":`上一步`,
"message.duplication.label.matchoption":`匹配选项`,
"label.setupmultplerecordtype":`多记录类型`,
"vue_label_account_unprocessed_oppprtunities":`未处理业务机会`,
"KeyInformationLayout.DefaultLayout.Name":`系统预设`,
"label.partner.all":`全部伙伴云`,
"label.datamanage.export.error":`导出失败！`,
"label.standard.buttonandlink":`标准按钮或链接`,
"label.reportsSubscriptionPage.email":`邮件报表`,
"message.nogrammarfaultinformula":`公式中没有语法错误`,
"front-kefu-moudle-nofind-instance":`没有找到实例`,
"label.is.delete.data":`您删除的数据中包含审批中的记录，确认要删除吗？`,
"label.partner.error":`错误：域名格式错误`,
"label.notification.time2":`{0}分钟前`,
"label.ccchat.person.invite.needfirstname":`输入您的名`,
"label.mr.title.URL":`网址`,
"chatter.norecord":`没有可显示的记录。`,
"label.readwrite":`读写`,
"label.partnerCloud.orderingPlatform.orderPayment":`订单支付`,
"label.accesslimittype":`访问权限级别`,
"label.preciew_tab":`在新标签页查看链接`,
"label.attachment":`附件`,
"label_tabpage_helpNavigationz":`帮助和导览`,
"label.dataimport.select":`勾选此信息，导入数据时执行`,
"chatter.en.info":`输入信息这样大家可以更多的了解你`,
"label.ccservice.validate.date":`对象API为{0}下的{1}字段对应值为{2} 格式有误，请输入正确的日期或时间格式！`,
"label.social.posts.send":`帖子发送失败`,
"label.emailobject.time.to":`收件人：`,
"label.defineReportStep1":`步骤1`,
"savefail":`保存失败`,
"label.mr.descreption.title":`合并重复数据`,
"label.share.info.by":`为`,
"label.list":`列表`,
"label.event.select":`已选`,
"message.accountmap.cannotfind":`无法找到的客户地址，请更新客户地址`,
"label.choosefield":`批准页面字段`,
"label.forecast.settings.title":`预测设置`,
"label.setup.log.datetime":`下载搜索时间范围内的行为日志（Excel.xls文件）`,
"button_partner_new":`新建伙伴云`,
"label.umeng.approval.dlsp.reject":`#approvalname替您拒绝#actorname请求的#objAPIName#recordname审批申请`,
"label.tabpage.totalTeamz":`共有小组`,
"label.lead.score.prompt3":`打分过程可能需要花费较长的时间，一旦打分完成，您会收到一份确认邮件。`,
"label.schedulejob.setup.schedule.name":`任务名称`,
"vue_label_report_advanced":`当启用高级筛选时，要手动将筛选条件，写入下方高级筛选框中，格式如图所示。`,
"label.emailsync.form.connecttime":`关联时间`,
"front-gantt-module-v1-project-status":`项目状态`,
"label.field.for.example":`例如`,
"label.marketsea.manager.notnull":`管理员不能为空`,
"label.click.here":`&lt&lt 点击此处返回`,
"UG.solution.04":`导入解决方案`,
"label.validate.function.funcExplain.IF":`检查条件是否为真，如果条件为 TRUE 则返回一个值；如果条件为FALSE 则返回另一个值`,
"label.profile.settab":`菜单设置`,
"front-email-payment-weichat-tips":`扫描二维码支付`,
"label.task.next.week":`未来一周的任务`,
"label.operatedata.selectobjectfields.tip":`请选择需要导出的字段，至少选择一个字段导出。<font color="red">请注意富文本字段无法导出。</font>`,
"label.recalculate.alert":`请选择要重新计算的共享规则`,
"label.marketsea.noopportunitydays":`天未创建业务机会（需大于获取后未跟进天数）`,
"label.chat.likeperson":`个人`,
"label.selectedFields":`可选取的字段个数`,
"label.App":`应用程序`,
"label.file.type":`文件类型`,
"permissionService.error1":`应用许可数量不足`,
"front-detail-module-v1-chart-display":`图表展示`,
"label.audit.status":`审批状态`,
"UG.activity.05":`记录电话`,
"label.connectOtherObject":`（点击以关联另一个对象）`,
"lable.currencyManage.unEnabledadvcurrency":`禁用高级货币管理`,
"label.ccpeak.getthree.function":`有三个方法，还有`,
"label.weixin.new.weitoupiao":`新建一条微投票,在微信平台微活动中可以获取投票信息参与投票活动。`,
"label.tag.manage.prompt":`标签已存在！`,
"label.goon":`继续`,
"label.addworkflowoperate":`添加工作流操作`,
"label.weixin.click.search":`点击查找记录`,
"vue_label_report_deletecolumn":`删除列`,
"label.ordercondition":`排序条件`,
"message.error.group.notallow":`小组不允许归档`,
"label.unread":`未读`,
"vue_label_report_notice_namerequired":`列名称是必填项`,
"label.tabpage.entercontent":`请输入内容`,
"label.schedulejob.setup.schedule.startdate":`开始日期`,
"component_assistant_button_newtask":`新建任务`,
"vue_label_report_notice_filter1":`当启用高级筛选时，要手动将筛选条件，<br?/>写入下方高级筛选框中，格式如图所示。`,
"value":`值`,
"label.icon.70":`维修`,
"label.knowledgebase.delete.draft.t":`删除草稿`,
"label.setup.mini.bind":`绑定小程序`,
"component_timeline_button_more":`更多步骤`,
"label_emailtocloudcc_redmessage4":`请输入端口信息`,
"label.field.input.number":`请输入正确的数字`,
"front-invoice-online-payment-setup-title":`开始接受在线付款`,
"front-kefu-moudle-called-user":`被呼叫人`,
"label.currency.disable":`禁用的币种`,
"label.user.alias":`别名`,
"UG_quota_04":`打印报价单`,
"label.chatter.delete":`删除`,
"label.addtocurrentcustomer":`附加到现有客户`,
"message.error.recordid.null":`recordid不能为空！`,
"label.merge.records":`合并记录`,
"report_label_norole":`您没有此权限，请联系系统管理员！`,
"label.pqrs":`。`,
"label.email.attach.button":`单击"附加"按钮`,
"label.tabpage.selrecordtypez":`选择记录类型`,
"label.ServiceCloud.purchase.date":`购买日期`,
"label.customreporttype.delete.prompt":`请删除以下报表,在执行删除操作`,
"label.brief.total.page":`共{total}页`,
"label.reportsSubscription.unsubscribe":`取消订阅`,
"label.ccpeak.take.notice.exp.order":`注意：exp和ordering条件中的字段API名称后一定要加__c""`,
"report_type_label_quote":`报价`,
"label.file.norecord":`没有可显示的项目。`,
"vue_label_checkduplicate_all_processed":`已处理完全部数据`,
"label.next":`下一步`,
"label.icon.10":`文件夹`,
"label.lanxin.title.setting":`集成信息`,
"label.h5.chatter.business":`关联的业务机会`,
"lable.are.you.sure.to.delete.this.view":`确认删除该视图吗`,
"vue_group_no_operation_permission":`无操作权限`,
"label.knowledge.archive.article":`归档文章`,
"vue_label_lead_":`暂无已激活的可用打分规则，请联系系统管理员`,
"label.fiscal.error.between":`会计年度开始日期或会计年度结束日期在历史会计年度时间段内，请检查后重新设置！`,
"label.stdashbord.xsld.business.qdzje":`赢单总金额`,
"label.calendar.day.view":`日视图`,
"label.emailtocloudcc.tip":`提示`,
"label.schedulejob.setup.schedule.st1":`第一个`,
"label_tabpage_addtoworkbench":`添加至首页工作台`,
"label.umeng.approval.waitapproval":`待批准`,
"label.justcheckingwebsite":`只验证网站`,
"homepage.components":`主页组件`,
"label.audit.remark":`审批备注`,
"label.searchs.labelname":`搜索{fieldlabelName}`,
"label.remarkofreport":`报表备注`,
"label.weixin.isno":`是否`,
"label.currencyCode":`币种代码`,
"label.service.resources":`资源`,
"label.clone_form":`复制表单`,
"label.weixin.view.information":`显示视图信息`,
"UG_activity_05":`记录电话`,
"chatter.feed.menutype.user.recentuser":`最近查看的人员`,
"label.marketsea.notfollowdays2":`天未跟进`,
"label.tabpage.namemandatory":`视图名称为必填内容`,
"message.demo.nosupport":`将在下一版本中推出此功能。`,
"label.mail.merge.template":`正在进行邮件合并模板...`,
"label.sendemail.marketactivity.sign":`市场活动签到通知`,
"setup_layout_group_relatedlist":`相关列表`,
"label.pc.ui.2018.all.tabs":`全部菜单`,
"label.field.lost.right.bracket":`缺失右括号`,
"label.datamanage.contact.novalue":`注意：本次导入操作没有给“联系人姓名”字段赋值，联系人记录将不会被导入！`,
"label.version.unlimited.edition":`无限版`,
"vue_label_dashboard_selectsortfield":`请选择排序字段`,
"label.partnerCloud.productSet.instructions":`可以为产品系列设置层级，在系统内部分功能添加产品时，可以按层级筛选查看。最多支持设置10级。`,
"front-kefu-moudle-v1-canuse-obj":`可见对象`,
"thursday":`星期四`,
"label.nextapprover":`下一个审批人`,
"setup_mainpage_label_manageuser":`管理用户`,
"label.saveandcontinue":`保存并继续`,
"label.top.userCenter":`个人中心`,
"component.chatter.file.button.save":`发表`,
"label_emailsync_setting":`个人邮箱设置`,
"label.usableshareuser":`可用共享者`,
"label.customfields.optionlist.fieldvaluelist.letterrank":`按字母顺序而不是输入顺序排序值， 所有值将以字母顺序显示`,
"label.list.button":`简档分配`,
"chatter.up.m":`上传的文件过大，请不要超过20M。`,
"label.knowledgebase.filters":`{a}个筛选器`,
"label.sso.saml.sp.idtype.username":`声明包含用户的cloudcc用户名`,
"vue_label_file_size_limit":`文件大小不超过{size}Mb`,
"label.appupload.install.error.choice4":`跳过冲突的组件，不安装有冲突的组件`,
"label.currencyDecimalDigits":`小数位数`,
"label.weixin.customer.details":`客户详情`,
"component.timeline.label.7daysahead":`前7天`,
"label.sendsms.batch.step1":`步骤 1：指定要包括的信息接收者`,
"label.brief.opportunity1":`业务机会`,
"label.datamanage.click.importbutton":`点击  <b>立即导入</b> 按钮，数据将被导入CloudCC系统`,
"label_filter_benchmark_objects":`筛选基准对象`,
"label.area.record.notexist":`记录不存在`,
"label.event.overdue.unfinished":`逾期未完成事件`,
"label.file.publicview.errortype":`此文件类型不支持预览`,
"label.setup.mobile.bottombutton.profile.setting":`定制简档底部菜单`,
"label.campaignmember.main.addleaddesc":`一次将所有现有潜在客户添加到这个市场活动`,
"vue_label_approve_actual_operator":`实际操作人`,
"label.version.essential":`基础版`,
"lable.SalesCommitmentKanBan.commitments":`Pipeline`,
"label.chatter.pastEvents":`过去活动`,
"vue_label_calendar_choose_calendar_type":`选择日历类型`,
"label.service.dispatchingUnits.batch.send":`批量派遣`,
"chatter.poll.option8":`选项8`,
"label_tabpage_summaryway":`汇总方式`,
"front-kefu-moudle-trindex-copy-num":`请到天润系统的首页复制企业编号`,
"lable.quote.syncing.syncfinish":`同步完成`,
"label.home.task.finish":`已完成任务`,
"label.toleadfield":`映射潜在客户字段`,
"label.everyone":`全部人员`,
"label.multilang.databatchadd.success":`{0}条数据添加成功`,
"label.quote.createdate":`创建日期`,
"email.template.nopermission":`仅管理员可在此文件夹下编辑模板`,
"label.report.action.addtodashboard2":`添加仪表板`,
"label.campaign.name":`市场活动名称`,
"label.check.input.condition":`语法错误，请检查输入的过滤条件`,
"front-epwechat-module-v1-upload-file":`上传授信文件：`,
"label.batchadd.newbatchpage.button.add":`增加一行`,
"label.partnerCloud.footer":`页脚`,
"lable.Enter.template.name":`请输入模板名称`,
"label_tabpage_last":`上一步`,
"label.setup.mobile.bottombutton.setting":`移动端一级页面设置`,
"label_emailtocloudcc_filed_emailto":`Email to`,
"label.data.downpage.e_title.num3":`3、用户可以根据自己的需求制作导出模板，在导出数据时选择  按模板导出  ，可便捷导出操作。`,
"startwith":`起始字符`,
"vue_label_normal_cancel":`取消`,
"label.reportTypcrtD":`关联对象（D） 请点击选择关联对象`,
"label.globalselect.disabledvalue":`无效值`,
"vue_label_commonobjects_view_notice_deletecertification":`确认删除选中的{selectNum}条数据吗？`,
"front-epwechat-module-v1-bound-role":`已绑定角色`,
"label.partnerCloud.financeSetting.gaofilter":`高级筛选条件 （例如：1 And 2 Or 3 ）`,
"label.quote.sprname":`收票人姓名`,
"lable.asset.successfully":`产品转资产成功`,
"label.projectManagement.service.appointment.work.noedit":`服务预约工时不可编辑`,
"lable.tianyancha.h5.inputandsearch":`输入关键字，检索相关公司`,
"label.customcomponent.check.tag.firstrow":`第一行必须是`,
"label.knowledgebase.published.translations":`已发布翻译也将归档，将删除处于草稿状态的翻译。`,
"vue_label_wang_yi":`王一`,
"label.step3.total3":`第3步，共3步`,
"label.stdashbord.xsld.business.img6":`可能性为100%阶段的个数/(可能性为100%阶段的个数 可能性为0%阶段的个数)`,
"component_button_cancel":`取消`,
"label.delete.false.not.exists":`删除失败，数据不存在`,
"label.appupload.install.error.choice1":`请勿安装`,
"label.Days.After.Horizontal.Date":`水平日期之后天数`,
"setup_layout_button_additem":`添加选中项`,
"UG.contact.05":`创建一个联系人`,
"label.form.title":`表单标题`,
"label.horizontalbar-group":`水平条-分组`,
"component_sendmail_label_title":`发送邮件`,
"label.passwordPolicy.setup.neverexpires":`永不失效`,
"label.sso.saml.idp.config.desc1":`启用CLoudCC.com作为身份提供商，您就可以在其他网站使用单点登录，并定义支持单点登录应用程序的适用服务提供商。您无需重新登录就可以切换至不同的服务供应商。`,
"label.chat.topic.desc.null":`了解有关本主题的一些信息？在右上角的下拉菜单中，选择编辑详细信息。`,
"label.movablecustomerfield":`活动自定义字段`,
"label.trigger.folder":`未归档触发器文件夹`,
"label.selectuploadfile":`请选择上传文件！`,
"front-email-payment-card-tips":`请输入卡号`,
"label.tabpage.addcondition":`添加条件`,
"label.number.MinAndMaxCheck":`{0}最小数量为{1}，最大数量为{2}，请修改数量后再点击保存。`,
"vue_label_dashboard_dashboard":`重命名仪表板成功`,
"label.objectDeleteList":`对象删除列表`,
"lable.service.gantt.and":`且`,
"label.emailtocloudcc.step2":`步骤2`,
"label.chatter.postup":`张贴`,
"label.personalsetting":`个人设置`,
"message.please.choose.permission":`请选择访问权限`,
"label.mobile.move":`移动端`,
"label.Choose":`选项`,
"label_chatter_vote":`投票`,
"label.weixin.user.select.one":`选择一个用户`,
"pagecreator.page.label.modifypage":`页面编辑器`,
"label.select.partOrField":`选择你想控制的部分或字段`,
"vue_label_helpcenter_chat":`1、即时通信<br>    群策可以代替企业微信等，让您在处于CRM系统工作时即可与公司同事发送文本消息、文件等。当组织各部门需要建立部门讨论群，部门领导即可在群策中发起群聊，添加部门成员进入群聊。<br>2、创建针对客户、业务机记录的群聊<br>    打开客户或业务机会记录详情页，单击右上角“群策”按钮即可在群策中创建一个关于此条记录的群聊，如果创建群聊的不是记录所有人，记录所有人也会被自动拉入到群聊中。其他人可以通过单击记录详情页右上角“群策”按钮或被群主添加后进入群聊。<br>3、在群聊中跟踪记录<br>    根据4.2中的方式为客户、业务机会记录创建群聊，即可在群聊中通过发送卡片的方式跟踪记录的动态。如果用户对卡片上的记录具有查看权限时，当点击卡片时即可直接跳转至对应对象的详细信息页面。<br>在群聊中跟踪记录字段变化<br>    当记录配置了“字段跟踪”相关列表，且配置了需要跟踪的字段，当跟踪的字段发生变化时，群聊中的群策小助手将会发送一张带有字段变更信息的卡片至群中。<br>在群聊中跟踪记录所有人变化<br>    当记录所有人发生变更时，群聊中的群策小助手将会发送一张带有所有人变更信息的卡片至群中。<br>在群聊中跟踪活动<br>    当创建了记录群聊后，如果新建了关于此记录的任务和事件时，群聊中的群策小助手将会发送一张带有任务或事件基本信息的卡片至群中。<br>在群聊中跟踪记录相关列表的新增记录<br>    当创建了记录群聊后，当记录的相关列表记录新增时，群聊中的群策小助手将会发送一张新增记录的基本信息的卡片至群中。例如：在客户记录的联系人相关列表中新增加一个联系人时，客户群聊中会收到一个“新建联系人”的卡片，并且可以在卡片上看到新增记录的基础信息。`,
"label.tianyancha.business":`工商信息`,
"chatter.group.groupMembersToFind":`小组成员查找`,
"label.pc.ui.2018.pin.top":`置顶`,
"label.forecast.forehistory.submitor":`提交人`,
"vue_label_email_send_emails_separately":`分别发送邮件成功`,
"vue_label_homepage_select_display_field":`选择展示字段`,
"label.partnerCloud.partnerAccount.accountBalance":`账户余额`,
"label.sendemail.template":`选择邮件模板`,
"label.service.violated":`已违反`,
"label.manageAll.title":`审批中心`,
"label.forecast.settings.qy":`启用预测共享`,
"label.detailofshare":`共享的详细信息`,
"label.multilang.passwordpolicy.chechlength":`错误：密码长度不得少于{0}个字符`,
"label.visualpage.filesave.error":`文件保存失败，请重试`,
"vue_label_campaign_please_select_member_status":`请选择成员状态`,
"homepage.components.sort":`组件排序`,
"label.brief.thismonth":`本月`,
"label_emailsync_connectaccount_description":`将您的个人邮箱添加于此，系统将自动根据邮件的收发地址匹配系统中的潜在客户、联系人，并将邮件内容同步至该记录下，便于追踪与客户的沟通进度。`,
"label.sms.csid":`签名编号`,
"label.ccdocument.remark":`文档描述`,
"label.forecast.customforecast.disdw":`显示单位`,
"label_tabpage_field":`字段`,
"label.logintime.all":`全天`,
"UG_Account_06":`创建一个客户`,
"label.login":`登  录`,
"label.dupicate.data.error":`查询合并数据异常，请检查!`,
"label.monitorsys.recent.logs":`默认列出最近的200条日志`,
"message.chooseatleastonefield":`至少选择一个字段`,
"lable.PowerProcess.name1":`权利过程名称`,
"label.processdetail":`处理定义详细信息`,
"label.upload.file.size.limit":`上传文件大小不能超过 2MB!`,
"label.forecast.userenablepage.desc":`启用预测的用户出现于“已启用用户”列表中。要启用可用的用户，将它们添加到“已启用用户”列表中。要禁用用户，删除它们。`,
"label.visualpage.type.detailembed":`页面类型为detailEmbed自定义页面使用规范`,
"label.textmessage.vonage.configurations":`配置`,
"label.report.select.chart.and.item":`选择图表和突出显示项`,
"label.data.downpage.i.title.num1":`1、系统只支持通用的CSV格式。`,
"label.mobileapp.scansetting":`移动端扫一扫模块设置`,
"chatter.emailFollow":`追随`,
"label.weixin.businformation":`车辆信息`,
"label.import.index.recentrecord":`近期导入记录`,
"label.case.update":`变更`,
"label.isEnableVisualpage.new.desc":`选择 可用的自定义页面 添加到 已启用的自定义页面 列表中，保存后，该简档可以访问已启用的自定义页面。`,
"label.emailobject.wizard.title":`关联您的个人邮箱`,
"vue_label_ccchat_notice_deletepostsuccess":`删除帖子成功`,
"label.deleteQuoteLine":`删除报价行`,
"label.integrations.export.failed.Mailchimp":`导出失败，请检查您的网络连接，稍后重试`,
"label.increase":` 加`,
"label.setup.mobile.homepageshortcuts.setunable":`主页不显示该模块`,
"label.ccchat.person.invite.toolong":`您不能输入超过255个字符的文本`,
"label.knowledge.setting.help":`帮助客户自助`,
"label.is_pigeonhole":`是否归档文件`,
"message.atleastonecommitter":`至少要有一个提交人`,
"label.emailobject.wizard.desc4":`插入一个可预约时间，让多人邀约更简单`,
"APPIntegration_Dropbox_setting_02":`禁用`,
"template.report.open.opportunities":`未关闭的业务机会`,
"label.goonwork":`继续工作`,
"label.isiands.time":`岛时间`,
"label.enable.rules.enableOnlyOneqrcodeOrbarcode":`已启用规则（每个对象仅支持启用一个二维码规则或条形码规则）`,
"label.summaryreport.2018.step2":`步骤2：选择要汇总的信息`,
"pagecreator.systemstyle.message.delete.success":`样式删除成功`,
"label.standarduser":`标准用户`,
"label.reportsSubscription.succeeded":`报表订阅成功！`,
"lable.Select.a.template":`选择一个已有的服务报告模板作为您新建模板的基础。`,
"label.file.library.addfile2libsuccess":`{0} 个文件已上传！`,
"label.searchfield.instruction":`搜索字段是为了当全局搜索或对单个对象进行查询的字段。如果默认不选，则按照已选搜索结果字段进行查询`,
"U":`URL`,
"label.Time.slot.overlap":`一个或多个时隙时间范围存在重叠。请更新为不会重叠的时隙。`,
"vue_label_chat_opportunity_details":`机会详情`,
"label.knowledge.category.hint.seven":`已选分类组`,
"label.chatter.list":`列表`,
"front-email-payment-Invoice-preview":`发票预览`,
"label_emailsync_message1":`取消关联后将无法同步该邮箱邮件内容至联系人、潜在客户，确认取消？`,
"label.summaryreport.step5":`步骤 5：确定报表中各列的顺序`,
"component_newrecords_label_name":`名称`,
"label.appointment.wizard.subtitle4-4-5":`两个月`,
"component_salesperformance_label_title":`销售绩效`,
"label.ccchat.person.invite.says":`说：`,
"label.fax":`传真`,
"label.knowledge.modify.article":`修改文章`,
"label.componenteditor.Limit.number.components":`单个页面最多添加15个组件`,
"label.multilang.forecast.shrepage.desc":`此页面将列出对{0}具有共享访问的用户、角色及区域。`,
"label.chat.micropost.write.comment":`编写留言`,
"Lead.Scoring.Setting.Rule.Setup.Active":`是否激活`,
"label.ccpeakfolder.time":`定时类文件夹`,
"label.partnerCloud.financeSetting.filter":`筛选条件:`,
"label.knowledge.delete.topicassignment":`删除话题分配出错`,
"label.file.orderbyname":`按标题排序`,
"vue_label_chat_activelater":`稍后开通`,
"chatter.reply":`回复`,
"label.setup.profile.accordtext":`显示文字是`,
"label.encd.plaintext":`查看明文`,
"label.h5.approval.cannotreassignmark":`代理审批项目不允许重新分配，请重新选择审批项`,
"label.version.area.lookup":`{0}个文本区或查找多选字段`,
"approval.request.email.body":`以下事项待批准：\n      点击下方链接批准：\n`,
"label.user.mass.emails.select":`批量发送电子邮件：模板选择`,
"lable.quote.syncing.title":`同步  报价 和  业务机会`,
"vue_label_dashboard_dashboardaccess":`仪表板访问权限`,
"label_emailtocloudcc_filed_owner":`记录所有人`,
"label.brief.page":`页`,
"label.isEnableVisualpage_new.desc":`选择 可用的自定义页面 添加到 已启用的自定义页面 列表中，保存后，该简档可以访问已启用的自定义页面。`,
"label.service.shift.view":`轮班视图`,
"label.emailsync.addnewaccount":`添加新账号`,
"label.forecast.settings.prompt":`禁用预测共享将删除所有手动共享的访问。`,
"front-electronic-signature-explain-second":`进行电子签章绑定时，请先准备好企业营业执照照片和统一社会信用代码。`,
"label.emailtocloudcc.redmessage3":`请输入服务器地址`,
"message.confirmgiveupedit":`如果您离开此页，会丢失所有未保存的更改。是否继续？`,
"label.gantt.plan.success":`计划成功`,
"label.monitorsys.type.error":`请选择查询类型!`,
"label.industrialandcommercialverification.button.setup":`设置`,
"today":`今天`,
"label.attendance.setting.position":`设置地标`,
"chatter.mynews":`我的消息`,
"label.recycle.dis.tip1":`系统将保留回收站中的数据15天，记录在放入回收站15天后，将被永久删除。`,
"label.icon.81":`制冷`,
"label.customer.tab.page.prompt":`请至少配置一个页面！`,
"label.globalselect.use":`使用全局选项列表值集`,
"template.report.customer.sales.order":`不同级别客户销售订单`,
"vue_label_dashboard_lastruntime":`最后运行时间`,
"label.edit.ccpeakfolder":`类：编辑文件夹`,
"vue_label_lead_be_converted":`已为已转换状态，不可转换`,
"label.tabpage.filenamez":`文件名称`,
"label.please.click.add.products.":`请点击“添加产品”，添加产品至报价单。`,
"label.followup_emails":`一旦访问者提交了表单，跟进电子邮件是一种快速、轻松地与他们联系的好方法`,
"label.indochina.time":`印度支那时间`,
"message.error.task.email":`邮件任务异常`,
"label.dynamic.copy":`同时复制动态布局规则`,
"label.log.d":`下载搜索时间范围内的审计日志（Excel.csv文件） >>`,
"pagecreator_layout_label_layoutname":`布局名称`,
"template.chart.htsktj":`合同收款统计`,
"label.appointment.wizard.subtitle4-2-5":`1天`,
"label.view_form":`查看表单`,
"label.tablet":`平板`,
"label.campaignmember.main.addcontact":`添加成员-现有联系人`,
"message.get.userinfo.error":`获取用户信息失败`,
"label.department.username":`用户名`,
"label.ems.verifysuccess":`验证添加邮箱账号成功！`,
"label.batchedit.copyValue":`应用到本列`,
"label.trigger.triggerVersion":`版本`,
"label.mr.descreption.oneGroupReData5":`组数据未处理。`,
"label.appointmentconfirmpage.wizard.subtitle5":`描述`,
"label.weixin.inbetween":`多选`,
"label.salescloud.contactrole.relatelist.customnize":`此列表不可自定义`,
"label.data.exp.please.nameanddes":`请填写模板名称和模板描述。`,
"label_partner_workspace_login":`登录页面`,
"label.notification.approval7":`【被委派人名称】替您拒绝【提交人】请求的【对象】【对象名称】审批申请。`,
"message.send.posts.image.error":`帖子图片上传失败！`,
"message.fieldtrack.operateupdate":`已更改`,
"label.sharerule.grantuselevelconstructureaccess":`授予使用层次结构的访问权限`,
"label.translation.setup":`多语言设置`,
"PageLayout.Search.MultiSearch.003":`您至少选择一个字段。`,
"label.ccchat.person.emaildomain":`公司电子邮件域`,
"pagecreator.systemstyle.label.bordercolor":`边框颜色`,
"label.submit":`提交`,
"UG.Lead.001":`如何引入线索?`,
"label.icon.172":`地图`,
"label_chatter_owner":`所有人`,
"vue_label_systemSettings_Currency":`币种管理`,
"page.layout.binfo":`基本信息`,
"label.version.date":`{0}个日期字段`,
"label.data.is.woking":`正在操作`,
"label.customfields.searchrelation.dependobjectDefault.tip":`可选择相关对象中的一条记录作为本字段的默认值`,
"label.partnerCloud.orderingPlatform.configuration":`配置产品`,
"lable.currencyManage.Enabledadvcurrency":`启用高级货币管理`,
"label.event.moveup.3hour":`提前 3 小时`,
"label.reportexport.object":`导出对象`,
"front-dialog-module-v1-requestid":`请求ID`,
"label.pw.symol":`符号`,
"label_group_field":`指定分组字段`,
"label.recallapprove":`调回批准请求`,
"vue_label_pool_deal_done":`已成交`,
"label.shangqing.description":`这是关于商情的描述`,
"label.view.allcansee":`<b>所有用户</b>皆可见`,
"chatter.poll.addOption":`添加更多选项`,
"label.icon.112":`餐饮`,
"label.ignorecase":`将"ABC"和"abc"视为重复值（不区分大小写）`,
"label.email.track.edit":`编辑电子邮件`,
"label_tabpage_erraddressz":`邮箱地址格式错误,请正确输入邮箱地址。`,
"label_tabpage_viewz":`打印当前视图`,
"component.timeline.label.future":`后续步骤`,
"label.b_c_without":`B" 记录可能有或没有相关 "C" 记录。"`,
"label.version.autonumberfield":`自动编号字段`,
"label.appointmentdetail.wizard.title5":`邀请链接`,
"label.weixin.addoption":`添加选项`,
"label.b.c":`B 到 C 关系`,
"chatter.group.complete":`完成`,
"label.must.numeric.value":`成本必须为数字值`,
"lable.edit.queue.memberdes":`要在此队列添加成员，选择一种成员类型，然后从“可用成员”选择角色或用户，并将其移动至“已选成员”。“如果队列中的所有对象的共享模式是“公用读/写/转移”，您将无需分配用户到队列，因为所有用户已经可以访问这些对象的记录。`,
"label.staticresource.chose.limit":`暂不支持使用此格式的文件，功能完善中，敬请期待.`,
"vue_label_commonobjects_view_kanban_unset":`请在看板视图设置中选择分组依据`,
"label.appexchange.download.merge.mes":`以下冲突组件通过合并安装：`,
"label.sharerule.baseofowner":`基于记录所有人`,
"label.email.template.manage.SMS":`管理短信模板`,
"label.imgfield.example.tip":`审批状态为审批通过"时显示绿色图片，否则显示红色图片."`,
"template.report.potential.customer.industry":`潜在客户行业`,
"component_hots_label_title":`热门交易`,
"label_file_use_document":`存储空间使用情况`,
"label.input.path":`输入引用路径`,
"label.partnerCloud.financialSetup":`伙伴财务设置`,
"label_tabpage_myz":`我的`,
"vue_label_pool_discard1":`{1}{2}`,
"label_emailtocloudcc_tip2":`删除后将无法通过此邮箱实现Email to CloudCC功能，确认删除？`,
"label.customfields.fielddependency.sure":`控制字段值不包括有依赖性的值。是否仍要保存？`,
"label.project.task.date":`任务日期必须在所属里程碑的日期范围内。`,
"Report.CantDelete.Info":`{0}报表被{1}仪表板引用，不可删除！`,
"label.assignment.setup.title":`分配规则`,
"image.pt.most.maxsize":`最大文件大小为2M。`,
"label.appupload.introduce":`软件包包含如应用程序、对象、菜单、触发器、自定义页面之类的组件。这些软件包可以通过上载张贴到Cloudcc.com AppExchange以公开共享。下面的列表显示您的组织创建的所有软件包。要创建新软件包，请单击“新建”。`,
"label.import.page2.confirm":`确 定`,
"label.console.step2.introduce":`填充下面的字段定义控制台。`,
"label.extendsfather":`从父`,
"front-homepageobject-module-v1-year":`本年度`,
"front-grasp-sales-opportunities":`CRM帮您精准掌握销售机会，获取更多潜在客户，提供快速报价，完成更多交易，同时实现全渠道营销，持续提升企业ROI。`,
"label.tab.oldpage":`老版本页面`,
"label.service.miniProgram.intro":`简介`,
"label.data.import.setup.operate.insert":`不更新现有记录，只插入新记录`,
"label.ccpeak.direction.for.use":`CloudCC 平台类使用说明[2.0版本]`,
"label.sendemail.chat.addComentsmyFeedsubject":`CloudCC CCChat微贴回复`,
"label.campaignmember.main.importmember.contacts":`导入成员-现有联系人`,
"setup.mainpage.label.welcome20":`邮件、短信模板`,
"label.newbatcheditor.remark":`针对不同数据记录存在不同的记录类型，系统将默认使用第一条数据记录类型的行式布局作为批量编辑的页面布局`,
"label.step4.total7":`第4步，共7步`,
"label.campagin.roi.tzhbl":`投资回报率`,
"label.emailmerge.mergepage.step3":`记录活动`,
"label.marketsea.isrecyclecreatebyself":`是否回收自建客户`,
"message.mobilechooseatmost.five":`手机前段菜单最多选取五个字段`,
"label.icon.171":`宾馆`,
"label.saveandnext":`保存并下一步`,
"label.import.page1.selectcodingtype":`选择编码类型`,
"label.searchlayout.displaybutton":`显示的按钮`,
"label.approvalstep5":`步骤5:选择要在批准页面布局上显示的字段的编辑属性`,
"label.passwordPolicy.setup.enforcePswHis":`强制密码历史`,
"vue_label_commonobjects_detail_contact_hierarchy":`联系人层级结构`,
"front-kefu-moudle-v1-trythjzx-intelligent":`天润融通呼叫中心智能服务`,
"label.select.statistical.indicators":`请选择统计指标`,
"label.callcenter.Tianrun.RONGTONG":`天润融通`,
"label.file.library":`文档库`,
"lable.completion.rate.color.setting":`完成率颜色设置`,
"label.name.firstname":`名`,
"setup_layout_label_readonly":`只读`,
"label.chatter.recordcall":`已记录呼叫`,
"label.service.appointmentList.service.empty":`服务预约为空`,
"component_milestones_label_choicestate":`确认此状态`,
"label.approved.receiveApprovalEmail.option2":`仅在我是批准人时`,
"label.marketseamemset.account.title":`客户公海池成员设置`,
"label.changemydisplay.list.custom":`自定义我的菜单`,
"label.emailtemplate.selecttype":`选择邮件模板类型`,
"component_timeline_label_title":`时间轴`,
"chatter.group.addRemoveMembers":`添加/删除成员`,
"label.console.step6.width":`宽度`,
"pagecreator.systemstyle.message.delete.fail":`样式删除失败`,
"label.partnerCloud.orderingPlatform.productPrice":`{productQuantity}种产品，共{totalCount}件，原价：{currency} {originalPrice}，优惠：{currency} {Reduction}`,
"label.h5.share":`分享`,
"label.schedulejob.setup.list.tip":`设置计划执行的作业，以每周或每月为间隔自动执行`,
"message.intheapproving":`此记录已经在审批流中，无法再次提交。`,
"vue_label_commonobjects_detail_real_time":`加入后，该群策将显示在您的群策列表，群策动态会实时推送给您。`,
"label.autoRegister.changepwd.setpwd.too.weak":`太短`,
"label.salescloud.forbiddenteamsales":`禁用小组销售`,
"component.chatter.link.label.title":`链接`,
"label.layout.editsearchdistribute.page":`选择要包含到菜单页面的自定义页面。`,
"label.dashboard.show.value.percent":`显示值与显示%请至少选一项`,
"label.everymonth":`每月`,
"label.campaign.channel.download.size1":`大尺寸：1000*1000像素`,
"permissionService.error2":`新增应用许可权限失败`,
"button.partner.workspace.manage.memo":`管理您的伙伴云，配置伙伴云属性。`,
"label.forecast.forehistory.commit.remark":`提交备注`,
"six":`六`,
"label.datamanage.donot.export.object":`不允许导出的数据对象`,
"label.schedulejob.setup.schedule.execute":`执行`,
"lable.account.CurrentandPreviousCY":`当前和上一个日历年度`,
"label.temp.SMS":`短信模板`,
"label_partner_all_state":`状态`,
"label.editdocument":`编辑属性`,
"front-epwechat-module-v1-ios-single":`iOS单点登录：`,
"lable.redo":`重做`,
"vue_label_SMS_alltemplates":`全部模板`,
"label.allfolderreport":`所有报表文件夹`,
"label.layout.alltab":`全部菜单`,
"lable.account.Yesterday":`昨天`,
"label.formula.to.evaluate":`公式评估`,
"component_setup_label_setupsaveok":`组件设置保存成功`,
"pagecreator_page_message_canntdelete":`当前页面不允许删除`,
"label.tab.message.failtotp":`选项卡置顶失败`,
"label.h5.chatter.location":`插入位置`,
"vue_label_commonobjects_view_chart_gotodashboard":`转至仪表板`,
"label.data.exp.conf":`确认要导出数据吗？`,
"label.currency.e":`货币类型编辑`,
"message.matrixReportSetupStage.column":`请选择【指定列标题】小计依据，两个小计依据至少选择一个。`,
"font-evaluate-module-v1-have-comment":`已留下了一个评价`,
"chatter.feed.dao":`到`,
"label.import.index.notice":`注：`,
"label.weixin.information":`详细信息`,
"label.multilingual.tip5":`多语言状态不正确，请刷新后尝试！`,
"label.appointment.wizard.subtitle3-7":`周日`,
"label.emailobject.groupemail.fail.content":`尊敬的{0}:\r\n您好！批量发送电子邮件发送失败的邮箱地址为：{1}                  \r\nCloudCC`,
"vue_label_notice_uploadavatar_fail":`上传头像失败`,
"chatter.group.myGroup":`我的组`,
"label.ccpeak.object.fieldapi.name":`为对象的字段API名称`,
"lable.activeCurrency":`启用的币种`,
"label.file.save.to.send":`保存并发送邮件`,
"label.emailmerge.list.editfolder":`编辑文件夹`,
"label.Path.Setting":`进程设置`,
"label.validate.function.funcFormat.DATE":`DATE(year,month,day)`,
"message.objapiexists":`对象api已存在`,
"label.sendmail.batch.confirm":`批量发送电子邮件：确认`,
"message.approval.cannotsubmit.detail":`此记录不满足任何有效批准过程的项目条件或初始提交，请与您的系统管理员联系以获得帮助。`,
"setup.layout.button.deleteitem":`移除选中项`,
"label.end.loginipIP":`IP结束地址`,
"component_event_label_subject":`主题`,
"message.500":`发生服务器内部错误`,
"label.wei.polltype":`类型`,
"vue_label_norm_duplicate":`副本`,
"label.addcycletrigger":`添加周期性触发器`,
"DetailedInfo.Activity.EmailMessage.01":`{0} 已为 {1}发送一封电子邮件`,
"No.Activity":`暂无任何活动`,
"label.chat.topic.add.topic":`单击添加主题`,
"label.schedulejob.setup.schedule.morning":`上午`,
"chatter.save.al":`您的更改已保存。`,
"label.setsharerule.step3":`第三步：选择共享给的角色`,
"label.tabpage.Sdfez":`天前`,
"label_submit_forecast":`提交预测`,
"label.version.sum.formulafield":`个公式字段`,
"lable.weixin.you.invitation":`您所邀约的`,
"label.stacked.horizontalbar":`堆叠图形-水平条`,
"label.file.anyone.can.link":`任何具有该链接的人员可以查看并下载文件。`,
"label.campaignmember.main.importmember.lead.desc":`将文件中的数据导入到这个市场活动潜在客户中`,
"UG_activity_01":`您如何跟踪记录与您的客户/团队互动?`,
"label.reason":`原因`,
"label.version.free.createmax":`允许创建2000条记录，已达到上限！`,
"label.brief.thisweek":`本周`,
"label.deleteobjinapprove":`请输入注释，从批准过程中删除此对象`,
"calendar.tips.event":`今天没有事件`,
"label.customerinfo.mailinfo":`公司发件邮箱信息`,
"lable.electronic.signature":`电子签名`,
"label_emailsync_addnewaccount":`添加新账号`,
"label.layout.exampleoftesgobj":`测试对象示例`,
"label.happen_submit":`访客提交此表单后下一步是什么`,
"label.forecast.customforecast.button.submit":`提交`,
"label_right_click_notice":`注意：Email to CloudCC 邮箱不能为系统用户绑定的帐号邮箱，否则将导致无效邮件生成潜在客户或者个案。`,
"font-trade-module-v1-invoice-no-price":`待回款金额`,
"lable.opppdt.selPdt.morecondtions":`更多筛选器`,
"label_invalid_token":`无效token`,
"label_chatter_postup":`张贴`,
"label.escalation.setup.newaction.step1":`步骤1：指定此升级规则的时间条件`,
"label.sendmail.step3.dealoption2":`存储每封邮件的活动`,
"front-kefu-moudle-v1-yesornoBatch-delete-templete":`确定要批量删除模板？`,
"vue_label_appstore_enter_website":`进入官网`,
"label.when":`发布时间`,
"label.linellae":`线条`,
"label_chatter_detailinfo":`详细信息`,
"lable.SalesCommitmentKanBan.receivingTaskRate":`收款任务率`,
"vue_label_homepage_dashboard_deleted":`仪表板已被删除`,
"pagecreator.layout.button.vertical":`纵向拆分`,
"label.redistribution1":`最多可选择5人`,
"pagecreator_page_label_modifypage":`页面编辑器`,
"label.Service.Cloud.Setting":`服务云设置`,
"setup_layout_label_pagename":`页面布局名称`,
"label.ems.send":`发送`,
"vue_label_commonobjects_view_kanban_notice1":`看板视图只显示前200条记录`,
"lable.outlook.detail.maping":`字段映射`,
"vue_label_pool_abandonorrestore":`{1}{2}`,
"label.mobile.side.tab":`移动端侧滑栏设置`,
"label.trigger.operation.email.template.param":`传递参数：语言、邮件模板ID、记录ID`,
"front-objectTemplate-V1-Select-a-template":`选择一个已有的模板作为您新建模板的基础。`,
"label.email.template.delete.template":`是否确定要删除此模板？`,
"label.reportsSubscription.cancel":`取消`,
"lable.quote.syncingfrom.firstsync.description":`业务机会产品  将替代报价单明细`,
"label.weixin.no.pending.xsld.qin":`亲，目前没有销售漏斗数据`,
"template.dashboard.sales.indicators":`销售指标`,
"label.field.new":`为用户提供评价和评分操作。`,
"label.generatepage.title.desc1":`根据选取的字段，生成移动版或PC版的 HTML 代码。用户可根据需要对代码进行修改。`,
"template.report.source.potential.customers":`潜在客户来源`,
"label.mr.title.queryData":`查询重复数据`,
"button_partner_workspace_enable":`启用伙伴云`,
"V":`自动编号`,
"label.icon.19":`文件夹`,
"vue_label_report_summaryformula":`汇总公式`,
"label.appointment.wizard.subtitle2":`请指定会议的有效期间`,
"label.stdashbord.xsld.business.bjdzhl":`本阶段转化率`,
"label.forecast.forehistory.deopportunity":`的业务机会`,
"chatter.email.referredToMeLeaveMessage":`在留言里提及我时（即@时）`,
"label.dategrouprelyon":`日期分组依据`,
"label.sendmail.batch.finish":`批量发送电子邮件：完成`,
"label.weixin.allexpired":`所有逾期`,
"label.dashboardSetup.showdw.d4":`万`,
"message.duplication.label.masterRecord":`主记录`,
"vue_label_calendar_availability":`可用性`,
"vue_label_chat_approval_message":`审批消息`,
"vue_label_zhang_er":`张二`,
"label.select.options":`请选择选项。`,
"label.israel.daylight.time":`以色列标准时间`,
"front-sales-search-QB":`共0条数据，是否在QuickBooks内新建客户`,
"vue_label_account_change_customer":`更改客户所有人`,
"label.integrations.mailchimp2":`查阅有关Mailchimp和CloudCC CRM的更多信息`,
"lable.product.pricebooks.onisu":`未启用的价格手册`,
"front-electronic-signature-backfill-field":`回填字段`,
"label.document.myself.folder":`我的个人文件夹`,
"label.event.moveup.10hour":`提前 10 小时`,
"report.label.report":`报表`,
"label.validate.function.funcFormat.CONTAINS":`CONTAINS(text, compare_text)`,
"label.usermanage.query.false":`查询失败，用户不存在`,
"front-epwechat-module-v1-input-EncodingAESKey":`请输入EncodingAESKey`,
"label.event.multi.view":`多人视图`,
"label.h5.similar.opportunity.setup":`类似业务机会设置`,
"label.setting.intergrationlist.button.install":`安装`,
"label.event.monthview":`月视图`,
"label.version.weixin":`微信版`,
"label_emailtocloudcc_redmessage6":`IMAP/SMTP认证失败，请检查电子邮件地址与密码是否正确`,
"UG.homepage.003":`360度视图`,
"vue_label_calendar_shared_calendar":`共享日历`,
"label.select.hope.merge.num1.record":`请选择希望合并到一条记录中的记录(每次最多三个)`,
"label.createnewprocess":`创建新的批准过程`,
"font-trade-module-v1-invoice-status":`回款状态`,
"label.customerinfo.introduce":`公司简档信息`,
"label.objectname":`对象名`,
"label.chosen.field":`已选字段`,
"label_target_name":`目标模型名称:`,
"label.appointment.wizard.subtitle4-4-4":`一个月`,
"label.emailobject.groupemail.msg1":`无电子邮件地址`,
"label_component_hotdeal_nopermission":`要查看业务机会相关数据，请联系您的CloudCC管理员`,
"label.appointmentdetail.wizard.title13":`描述`,
"front-web-module-v1-detail-comment-title":`请您对本次服务进行评价`,
"label.visualpage.component.n1":`1.调用方式.  &lt;component:Name /> Name为组件的具体名称`,
"lable.outlook.mcto.erecord":`最早的记录`,
"label.weixin.del.log":`清除日志`,
"setup_mainpage_label_welcome23":`安全性设置`,
"label.selectreportline":`请选择报表列`,
"label.chatter.following":`正在关注`,
"seven":`七`,
"message.error":`错误：`,
"label.mobile.phone.reporter":`报告人`,
"label.valadate.telphone.false":`手机号码输入有误，请检查`,
"label.linkedin.setting":`集成领英H5微应用`,
"label.mobile.side.tab.success":`移动端侧滑栏设置保存成功`,
"label.notification.approval3":`您的【对象】批准被【审批人】重新分配【重新审批人】`,
"label.channel.invites.employees":`此渠道邀约员工`,
"label.assignment.setup.detail.assigner":`分配至`,
"label.campaignmember.main.updatecontactdesc":`一次更新所有现有联系人的状态`,
"label.permission.detail.app.fenpei":`分配应用程序`,
"label.copydown":`向下复制`,
"label_emailsync_status_action":`操作`,
"lable.Please.switch":`请切换至横版或纵版系统中使用此功能`,
"label_adjust_remark":`调整备注`,
"label.weixin.newspaper.coverage.list":`报险单`,
"label.datamanage.contact.field":`联系人字段`,
"label.partner.workspace.login.headerfooter":`页眉和页脚`,
"lable.account.quarter.ovdate":`会计季度结束日`,
"pagecreator.systemstyle.label.textcolor":`文字颜色`,
"label.industrialandcommercialverification.fieldmappingsettings":`字段映射设置`,
"component_chatter_button_message":`留言`,
"label.partnerCloud.enterAddress":`请输入地址`,
"label.email.template.recently.used":`最近使用`,
"component.event.label.calendar":`查看日历`,
"label.setup.mobile.offlinecache.setting":`移动端离线缓存设置`,
"label.custom.PreviousCQ":`上一个自定义季度`,
"lable.total.of.payments":`共计0个付款`,
"label.ccpeak.use.class.time.trigger":`如果是触发器调用该类，可以直接使用CCService中的方法`,
"label_tabpage_addresswrongz":`邮箱地址格式错误,请正确输入邮箱地址！`,
"vue_label_homepage_select_components":`选择组件`,
"front-kefu-moudle-v1-secretID-reinput":`请输入secretID`,
"label.ccdocument.select.template.red":`请选择模板进行套红`,
"vue_label_email_public_template":`公有模版`,
"label.eowechat.openid":`企业微信账号`,
"label.user.ip.notlogin.range":`IP不在登录范围内！`,
"chatter.email.reply.collection":`对我收藏过的帖子回复时`,
"label.integrations":`集成`,
"label.permission.modifyAppPermission.selectedapp":`已选应用程序`,
"label.privacystatement":`隐私声明`,
"label.specificvalue":`特定值`,
"label.appointmentconfirmpage.wizard.subtitle2":`日期和时间`,
"label.message.ispartner.delete":`因为联系人已经与合作伙伴用户有关联，不能删除客户`,
"report_button_go":`前往`,
"label.h5.similar.opportunity":`类似业务机会`,
"UG_Lead_005":`邮箱`,
"label.num.length.not.overstep":`数值长度不能超过18位`,
"label.profile.mobile.setup.CEOandDirector":`CEO及销售总监`,
"label.addfield":`添加字段`,
"template.dashboard.institutional.overview":`机构概览`,
"label_tabpage_datefield":`日期字段等于时可以使用“昨天”，“今天”，“明天”，“上个月”，“本月”，“下个月”，“上星期”，“本星期”，“下星期” 或 “YYYY-MM-DD、MM/DD/YYYY”格式。`,
"label.category.7":`旅游`,
"UG_contact_02":`通过多个渠道吸引联系人 通话, 邮箱 , 社交`,
"chatter.feed.menutype.feed.mecom":`涉及我的更新`,
"vue_label_systemSettings_calltemplate":`通信模版`,
"approval_process_errore":`保存过程中出现错误，请联系系统管理员`,
"label.tabpage.choosefilez":`选择文件`,
"label.changemydisplay.chagetab.cusapp":`自定义应用程序`,
"clearadvancedoption":`清除高级选项`,
"front-epwechat-module-v1-binding-user":`已绑定用户列表`,
"label.customfields.fielddependency.null":`未定义字段依赖性`,
"label.enterprise":`企业版`,
"font-evaluate-module-v1-five-points":`一般得分：5分`,
"lable.Synchronize.from.QuickBook":`从QuickBook上同步`,
"front-gantt-module-v1-task-number":`任务数量`,
"label.currency.edit.newexchagecurrency":`过期汇率`,
"label.partnerCloud.partnerSite":`伙伴站点`,
"label_tabpage_unequalz":`不等于`,
"label.version.solutions":`解决方案`,
"label.setting.intergrationlist.button.installed":`已安装`,
"label.h5.chatter.share":`分享文件`,
"front-epwechat-module-v1-unbound-item4":`- 外部账户绑定关系`,
"label.textmessage.vonage.accessibility.setting":`使用权限设置`,
"font-evaluate-module-v1-evaluation-set":`评价设置`,
"message.servicecrew.time.violation2":`不在此时间工作`,
"label.processinfo":`批准过程信息`,
"label.knowledgebase.last.modified":`上次修改`,
"label.to.phone":`收件人手机号`,
"label.baseoffirsttimereply":`基于<strong>首次</strong>回复的批准或拒绝。`,
"label.projectManagement.startingEndingTime":`起止时间`,
"label.licence.enable":`启用`,
"label.partnerCloud.basicSetting.cshua":`初始化伙伴云`,
"APPIntegration.Dropbox.setting.03":`启用Dropbox，让您可直接在附件上从dropbox里面选择文件。`,
"label.account.contact":`客户联系人架构图`,
"label.many.dayline.tab":`标记`,
"label.weixin.input.username":`请输入姓名`,
"label.logintime.pagecue.invalido":`结束时间也必须是全天`,
"label.icon.30":`书`,
"label_tabpage_advancedscreening":`高级筛选条件`,
"lable.currencyManage.unEnabledadvcurrency.agree":`是的，我要禁用高级货币管理。`,
"label.tab.web.new":`新建 Web 菜单`,
"label.bmap.tiananmen":`天安门`,
"label.disabled":`不可用`,
"error.currencyAdv.deleteprecodedate":`不能删除货币代码的上一个日期兑换率`,
"message.error.view.checkbox.validerr":`错误：使用真或假`,
"UG_ST_006":`直接进入`,
"label.dongshifang.title":`东时方短信网关`,
"label.data.dataexpalltype.all.desc3":`3、导出成功的数据将生成一个压缩文件，用户可以根据邮件中的文件信息，在导出成功的文件列表页面下载您导出的文件。`,
"vue_label_pool_returnreason":`退回原因`,
"label.list.userinterface.des":`使用下列设置修改贵组织的用户界面：`,
"label.notification.approval2":`您的【对象】批准请求被【审批人】拒绝`,
"label.service.dispatchingUnits.the.level":`水平`,
"front-email-payment-Invoice-preview-tips":`目前所有发票模板均处于禁用状态，请联系管理员，启用模板后再生成发票。`,
"label.dashboard.isAvailableFieldOfComponentGroupInTheReport":`错误：组件中有一个或多个所选字段无法继续在报表中使用。<br>使用仪表板组件编辑器选择一个可用字段。`,
"label.import.step2.chooseidorother":`2、可以选择使用id或名称匹配记录与填写查找字段。若需获取对应记录id等信息，可创建报表，并将记录名称与记录id设置为组列，再将报表导出。`,
"label.customobjects.introduce":`自定义对象为数据库表格，用于在 CloudCC 中存储组织数据。 您可以使用自定义对象扩展 CloudCC 功能或构建新应用程序功能。`,
"label.visualpage.oldsystem":`老版本`,
"label.icon.94":`书`,
"label.setup.log.desctiption":`您可以下载您组织行为跟踪（Excel.xls文件）。`,
"label.dynamicpage.layout":`动态页面布局`,
"lable.list.queue.objct":`支持的对象`,
"label.customfields.placeholder.tip":`示例文字将显示在输入框中，获取焦点后消失`,
"label.ems.activationtime":`启用时间`,
"label.detailinfo":`详细信息`,
"label.icon.17":`报告`,
"label_emailtocloudcc_button_complete":`完成`,
"label.visualpage.component.n2":`2.注意.  component标签不能嵌套在<cc>标签内`,
"label.object.name.one":`对象名1`,
"label.summaryreport.step2":`步骤 2：选择要汇总的信息`,
"thisisanew":`新！`,
"label.query.detail.editpartneruser":`编辑合作伙伴用户`,
"label.tabpage.newview":`创建新视图`,
"label.partnerCloud.productSet.addNew":`新建选项`,
"label.appupload.upload.new.remark":`此为全新组件。`,
"label.case.ptext":`我们已经将贵公司和网站版门户绑定，复制专属于贵公司的网站版客户服务门户地址，在贵公司官网上添加入口进入此网站。`,
"lable.PowerProcess.name":`权利过程`,
"label_tabpage_choosefilez":`选择文件`,
"homepage.components.place":`组件位置`,
"lable.Synchronization.failure":`同步失败`,
"label.dashboard.snapshot.get.data":`获取您的数据`,
"label.input.invalid.format":`请输入合法的格式`,
"label.quickbooks.view.openinvoices":`进行中的Invoices`,
"label.weixin.seating":`座位数`,
"label.searchlayout.remark":`允许选择以下搜索功能中显示的标准及自定义字段：`,
"label.escalation.setup.entrydetail.escalation.assiner":`分配至`,
"vue_label_calendar_availability_view":`日历-可用性视图`,
"label.country":`国家`,
"label.campagin.roi.zl":`总览`,
"lable.currencyManage.advcurrencyEnabled":`高级货币管理已启用`,
"label.projectManagement.project.task":`项目任务`,
"label.appointmentpage.wizard.subtitle3-2":`邮箱`,
"label.input.invalid.date":`请输入合法日期 (ISO)`,
"vue_label_chatter_my_followers":`我的关注者`,
"label.setupdevelop":`新应用开发`,
"label.sendemail.send.checksend":`检测发送邮件是否能成功`,
"label.eventfield":`事件字段`,
"label.ccpeak.ccobject.put":`给CCObject赋值直接用put，例如：`,
"label.campaignmember.main.addMemberDesc":`可以搜索现有潜在客户及联系人,添加到这个市场活动中,也可以对现有成员进行管理`,
"label.knowledge.setting.hint.eleven":`输入数据分类组`,
"label.knowledge.category.button.four":`添加同级分类`,
"label.icon.27":`学习`,
"vue_label_chatter_certification":`确定要{isStatus}"{titleName}"吗`,
"label.data.downpage.i.title.btn":`进入导入页面，开始导入`,
"label.campaign.channel.step6.pc":`生成电脑端页面`,
"label.mr.caption.rule":`规则：必须选择一个或多个查重规则`,
"label.service.gantt.resourcestype":`资源类型`,
"label.searchfitconditions":`查找符合以下条件的`,
"label.partner.template.name":`模板名称`,
"setup.mainpage.label.welcome15":`CloudCC 云平台工作流规则可以自动化您的销售、市场等各种对象的支持过程。根据预先定义的一组规则，可以将记录自动分配给用户，或从一个用户转换到另一个用户。工作流管理的主要好处是，通过在更新记录时消除许多不必要的操作来提高工作效率，通过标准化工作方法、减少操作成本来提高业务处理水平，优化控制流程。支持任意对象的无限极审批，同时可以触发提醒邮件、短信提醒、任务、字段更新等功能。`,
"vue_label_commonobjects_view_chart":`图表`,
"label.salescloud.teamrole.choose":`请选择小组角色`,
"lable.outlook.mcto.emailrel":`电子邮件关联`,
"front-invoice-online-payment-setup-describe":`快速接入，一键接入。简单、安全、便捷的在线支付服务。`,
"label.korean.standard.time":`韩国标准时间`,
"label.lord.howe.standard.time":`豪公夏令时`,
"setup_layout_group_button":`按钮`,
"label.editdefaultshare":`编辑默认共享`,
"label_fiscal_year":`会计年度`,
"label.appointmentdetail.wizard.title2":`所有人`,
"label.email":`电子邮件`,
"label.city":`城市`,
"label.knowledgebase.data.recovery.failed":`{a}条数据恢复失败`,
"setup_mainpage_label_welcome6":`用户无需任何编程知识、无需代码开发的情况下，便可在 CloudCC 系统的所有对象中都可以建立各种类型的字段，字段类型包括：查找关系、单项选择字段、双项选择、公式、自动编号、URL、电话、传真、电子邮件、复选框、日期、时间、数字、文本、文本区、选项列表（单选/多选）、币种等。`,
"label_emailtocloudcc_button_enable":`启用`,
"label.account.custom":`自定义会计季度`,
"label.custompublish_time":`客户发布时间`,
"label.dashboardSetup.selwz":`选择显示位置`,
"component_todaytask_label_all":`查看全部`,
"label.service.resource.group.tip":`选择服务班组创建服务资源，资源类型只能选择班组。`,
"label.tianyancha.legalpersonname":`法人`,
"component.setup.label.titlefield":`标题字段`,
"label.email.template.public.mail":`公用邮件模板文件夹`,
"front-template-V1-DeleteTempalte":`确定删除“{currentTelmplateName}”模板吗？`,
"pagecreator.layout.label.layoutdesc":`布局描述`,
"vue_label_file_singel_upload":`只能上传一个文件，如果需要替换文件，请先删除已上传的文件`,
"label.view.hierarchy":`查看层级结构`,
"label.file.owner.settings":`所有人设置`,
"label.sales.dashboard.name":`名`,
"label.offfer.filer.name":`报价文件名称`,
"label.quickbooks.view.recentlypaid":`近期付款`,
"label.step1.select.merge.records":`步骤1:选择要合并的记录`,
"message.recordtype.assignprofile.tip":`选取为简档启用"复选框，使新记录类型可由该简档使用。已分配给此简档的用户将能够创建此记录类型的记录，或将此记录类型分配给现有记录。要使新记录类型成为某个简档的默认记录类型，请选取"设置为默认"复选框。"`,
"label.appointmentdetail.wizard.title9":`路途所用时间`,
"label.group":`组`,
"label.deltorecycle":`删除到回收站`,
"label.import.index.numlimit":`1、只支持csv格式的文件。 （最多单次导入30000条记录，若需执行触发器，则最多导入2000条）超出限制的记录，系统会自动忽略。若需导入更多数据，请先拆分为多个文件，分次导入。`,
"label.file.delete.desc":`删除文件也会将其从附加的任何记录或帖子中移出。`,
"UG_activity_04":`Outlook/Gmail邮箱 记录邮件`,
"label.event.all.undealt":`所有未处理事件`,
"label.appupload.upload.install.error":`此应用程序无法安装。请结束安装，或修改系统内API后重新安装！`,
"template.chart.yqydcpsl":`已启用的产品数量`,
"label.import.index.advancepreparation":`预先准备`,
"label.eowechat.epdeptnamee":`企业微信部门名称`,
"front-kefu-moudle-please-input-servernum":`请输入服务请求单编号`,
"label.lookup.autocmp.nodata":`没有匹配数据`,
"vue_label_pool_assign":`分配`,
"label.knowledge.timing.publish":`定时发布失败。`,
"label.selected.groups":`已选报价行组`,
"front-epwechat-module-v1-removesele-desc":`删除后，本应用的全部设置信息会被清除，是否确认？`,
"label.batchtransfer.type2":`转移已结束业务机会`,
"label.richtext":`富文本区`,
"label.icon.174":`飞机`,
"vue.please.select.grouping.basis":`请选择分组依据`,
"label.matrixreport":`矩阵式报表`,
"label.jiandangfenpei.leftlist":`未分配的简档`,
"label_chatter_card":`卡片`,
"label.file.enter.title":`请输入标题`,
"label.the.record.is.locked.and.cannot.be.selected.":`该记录已锁定，不可选择。`,
"label.partner.success":`成功！此域名可用`,
"label.selectreporttype":`选择报表数据源`,
"report.type.label.productPricebooks":`产品和价格手册`,
"label.texttemplate.mergefields.tip":`设计短信的内容时可向内容中添加合并字段替换文本。当短信被使用时，系统会替换成文本。例如{!Contact.name}，使用短信时，正文中会变成联系人的姓名`,
"label.publicgroup.detail.showallusers":`查看所有用户`,
"label.brief.follow":`跟进`,
"label.forecast.settings.qijian.p":`每季度预测`,
"label.sms.url":`网站`,
"setup_layout_group_custompage":`自定义页面`,
"label.validate.function.funcFormat.BEGINS":`BEGINS(text, compare_text)`,
"label.umeng.chatter.sendmessage":`给您发了一条消息`,
"label.pc.layout":`PC布局`,
"label.currency.v":`输入以新币种显示数据时可以显示的小数位数（小数点右边的位数），必须是 0 至 6 之间的整数`,
"label.projectManagement.kanbantask":`看板任务`,
"component_recdetail_label_title":`详细信息`,
"label.isremider":`是否提醒`,
"front-epwechat-module-v1-input-home-url":`请输入主页URL`,
"label.usefullife":`有效期`,
"label.visualpage.ptype":`普通`,
"label.quote.name":`报价单名称`,
"vue_label_report_addtocomponent":`确认将{name}添加到组件库吗?`,
"label.dashboardSetup.showdw.d1":`亿`,
"label.validate.function.funcFormat.OR":`OR(logical1,logical2,...)`,
"label.component.helper.potentialcustom":`今日分配潜客`,
"label.autoRegister.changepwd.setpwd.tip.number":`至少有一个数字`,
"label.data.setok.e.desc3":`下载您导出的数据。`,
"label.data.downpage.e.title.num4":`4、导出的文件格式有两种：CSV格式和压缩格式。其中压缩格式分为两种：一种是自动生成压缩文件密码；另一种是手动输入压缩文件密码。`,
"lable.quote.editqtpdt.description":`为此报价选择价格手册。您只能从单个价格手册添加产品。更改已选取价格手册将从该报价单中删除全部现有的产品。`,
"front-kefu-moudle-edit-userinfo":`编辑用户信息`,
"label.please.ChooseMinAndMax":`请最少选择{0}个产品选项，最多选择{1}个产品选项。`,
"label.knowledgebase.archive.an.article":`归档一篇文章？`,
"label.multilang.customforcast.submit":`是否提交从第{0}会计年度{1} 至 第{2}会计年度{3} 的预测 ?`,
"label.import.index.filename":`文件名称`,
"front-console-no-reco-contact":`未识别出联系人`,
"label.quantity.greater.than0":`数量需大于0`,
"label.codeNorm":`码标准`,
"label.average":`平均值`,
"label.multilang.page1":`第`,
"label.data.exp.save.ok":`保存模板成功`,
"message.error.delete.record":`未找到要删除的记录！`,
"label.newvaluereplaceoldvalue":`使用此页面用新值全局替换选项列表中的现有值。确保已在选项列表详细页面中创建新值。`,
"label.tabpage.saveviewsuccess":`视图保存成功`,
"label.partnerCloud.productSet.parentOptions":`父级选项`,
"label.emailtemplate.availablemergefields":`可用合并字段`,
"label.data.import.setup":`数据导入设置`,
"label.escalation.setup.entrydetail.escalation.action":`升级操作`,
"System.TimeField.Description":`允许用户输入当地时间。例如，"2:40 PM"、"14:40"和"14:40:00"是此字段的所有有效时间。`,
"front-additional-products":`增购其它产品`,
"label.appointment.wizard.subtitle4-4-1":`一周`,
"label.chatter.colleagues.list":`同事列表`,
"label.log.invalid.data":`非法的时间！`,
"label.file.preview.unconvert":`未生成预览信息,请点击预览详情`,
"label.customer.detailed":`为这个新菜单选择页面并填写其它详细信息`,
"label.sendsms.content":`内容如下：`,
"label.exported_to":`导出文件将通过邮件发送至`,
"label.attendance.checkin":`签到`,
"Dashboard.NoAccessRightToSee.Warning":`您所设置的默认打开仪表板{0}目前您没有权限查看，您需要重新设置为其他值。`,
"message.choosedelete":`请选择要删除的数据`,
"label_tabpage_choosecontent":`请选择值内容`,
"label.no_responses":`没有响应`,
"report_type_label_customService":`客户支持`,
"label.report.select.condition":`选择条件`,
"label.umeng.activity.distributeevent":`已为您分配事件`,
"label.knowledge.language.portuguese":`葡萄牙语`,
"label.knowledgebase.published":`已发布`,
"UG_opportunity_001":`您如何监控您的销售?`,
"label.mr.caption.scope":`范围：如不选择则查询全部数据`,
"message.login.mfaverification.to.pclogin":`您的组织已经启用二次校验，首次登录需要绑定移动设备，请使用PC端进行登录绑定`,
"vue_label_dashboard_pleaseenterthecolorrange":`请输入颜色范围`,
"label.emailsync.status.time":`时间`,
"chatter.putup":`张贴一个文件`,
"vue_label_report_drillcondition":`钻取条件`,
"label.emailobject.list.myemail":`我的邮件`,
"label_tabpage_andz":`与`,
"label.share_link":`分享链接`,
"label.emailtocloudcc.exists2":`此邮箱已经设置为Email to Case，请勿重复设置`,
"label.icon.89":`咨询`,
"front-kefu-moudle-v1-qdygbzx-chat":`确定要关闭在线聊天吗?`,
"label.approval.selectone":`至少选择一个操作`,
"chatter.group.groupName":`小组名`,
"label_chatter_relateitem":`相关项`,
"label.file.folder.delete1":`删除文件夹？`,
"Pagelayout_Setup_003":`Name字段必须选择`,
"setup_mainpage_label_welcome2":`自定制数据库（对象）`,
"pagecreator.systemstyle.label.linkcolor":`链接颜色`,
"label.task.this.week":`本周的任务`,
"message.custom.field.donotdelete.report":`该字段被报表所引用`,
"pagecreator.layout.button.delete":`删除布局`,
"label.reportsSubscriptionPage.condition.operator":`逻辑符`,
"label.location.display.type.degrees":`度数、分钟、秒数`,
"label.appupload.upload.url":`安装URL`,
"label.logical.relation":`逻辑关系`,
"label.knowledge.publish.article":`发布文章`,
"vue_label_commonobjects_detail_activity_commingtask":`拥有即将进行的任务`,
"vue_label_pool_reason":`{0}原因`,
"front-gantt-module-subtasks-cannot-subtasks":`子任务下不可出现子任务！`,
"label_tabpage_filesizez":`文件大小`,
"label.customfields.formula.returntype.monry.tip":`计算美元或其它货币金额，并将字段自动转换为货币金额格式`,
"label.tabpage.allapplications":`全部应用程序`,
"message.duplication.label.matchcontainletters":`包含匹配`,
"maintenanceplan.workorder.type.asset.workorderlineitem":`工作订单生成方式请选择“每个资产产生一个工作订单行项目”`,
"label.preview_post":`预览帖子`,
"chatter.p.data":`发表日期`,
"label.isnot.right.number":`不是正确的数字`,
"label.contentsource":`内容源`,
"message.groupandsummaryconditionsame":`分组条件不得与汇总条件相同`,
"label.weixin.wdyj.nodata.qin":`亲 , {0}没有数据.`,
"chatter.vote":`票`,
"label_partner_workspace_tab_option":`可选菜单`,
"chatter.changeVote":`更改投票`,
"label.data.file.i_title.num2":`2.建议在导入时先导出，以导出文档为数据模板整理导入数据，然后再导入。（导入的数据中如果含有逗号，请使用‘@’符号代替）`,
"label.relation.list.error":`出错了`,
"label.validate.function.funcExplain.MILLISECOND":`返回日期/时间字段中的毫秒数`,
"label.emailobject.emaildetail.button.relateto":`关联到`,
"label.dashboard.dataSource":`显示数据来源`,
"label.marketseamemset.lead.title":`潜在客户公海池成员设置`,
"label.appupload.addobj":`添加到软件包`,
"lable.outlook.mcto.domain":`格式如（gmail.com），添加到排除的域列表中。`,
"label.input.right.url":`请输入正确的URL`,
"label.newprocessstep5.tip":`批准页面是批准人实际批准或拒绝请求的地方。使用下面的选项，选择要在此页面上显示的字段。`,
"label.schedulejob.setup.schedule.st4":`第四个`,
"label.emailsync.status.user":`用户`,
"front-kefu-moudle-v1-jymm-reinput":`请输入12位大写字母、小写字母、数字、字符至少包含两种组合的密码`,
"Lead_Scoring_Setting_Rule_Setup_RuleName":`打分规则名称`,
"label.mr.title.fieldName":`字段名称`,
"label.data.deriall":`导出全部`,
"label.tianyancha.businessverify.step2":`启用工商数据验证第二步`,
"label.submissions":`提交量`,
"vue_label_calendar_removed_successfully":`移除日历成功`,
"label.eventrecordtype":`事件记录类型`,
"lable.outlook.detail.syndire":`同步方向`,
"label.mobile.bind.fail":`绑定失败,请稍后再试`,
"label.notification.task2":`您分配给【被分配人】的任务被查看`,
"label.partnerCloud.orderingPlatform.paymentMethod":`支付方式：`,
"label.escalation.setup.newaction.step3":`步骤3：选择要通知的用户`,
"label.summaryreport.selectsum":`选择汇总信息和汇总类型`,
"label.components.setup":`设置组件`,
"label.taskevent.introduce":`以下是您的任务和事件列表。`,
"label.assignment.setup.detail.conditon":`条件`,
"front-lightning-module-v1-details-page-chart-select-statements":`选择报表`,
"lable.Song.typeface":`宋体`,
"label.formulassesstrue":`公式评估为真`,
"label_partner_common_setup":`一般设置`,
"label_chatter_dateRange":`日期范围`,
"label.partner.workspace.tab.mobile.using":`勾选的菜单将同时显示于移动端`,
"message.servicecrew.time.violation1":`派遣时间违规:有班组成员`,
"report_label_projectcount":`个项目，按报表名称排序`,
"label.file.uploadfile":`上载文件`,
"vue_label_commonobjects_detail_correct_email_address":`请输入正确的邮箱地址`,
"lable.account.CurrentandNextCQr":`当前和未来三个日历季度`,
"setup.layout.label.order":`排序标准`,
"label.service.major.event.independent":`独立`,
"label.icon.38":`定位`,
"label.knowledge.draft.record":`未找到要删除的记录`,
"label_quota_percentage":`显示定额完成百分比`,
"label.escalation.setup.entrydetail.escalation.minute":`分钟`,
"label.knowledgebase.edit.article.category":`编辑文章类别`,
"Homepage_News_003":`暂无客户数据，无法显示新闻，您创建客户之后即可在此显示客户新闻`,
"label.mr.descreption.oneGroupNote3":`条记录。`,
"label.customsetting.touse.getListCustomSetting":`查询“列表”类型的自定义设置数据,返回对应apiName的全部数据 Map map = cs.getListCustomSetting(String apiName);`,
"message.error.view.cannotbenull":`错误：必须输入一个值`,
"label.reportsSubscriptionPage.schedulereport.monthly.day.friday":`星期五`,
"message.error.view.badprevilege.qin":`亲，您没有访问{1}的权限，因此无数据。`,
"label.dashboard.distribution":`分布`,
"label.field.value.save":`此字段中总是需要一个值来保存记录`,
"label_custom_year":`自定义年度`,
"label.code.error":`代码中含有不被允许的命令及函数，如：`,
"label.appexchange.uninstallpage.message2":`永久删除您对这些组件所做的全部自定义`,
"label.global.search.obj":`全局搜索对象设置`,
"label.emailobject.from":`发件人`,
"lable.opppdt.selPdt.byconditions":`按字段筛选条件`,
"chatter.p.note":`此帖子的注释`,
"label.hiddenformulaedit":`隐藏公式编辑器`,
"label.editQuotation":`编辑报价单`,
"label.notification.arketsea.collection":`{5}领取了{2}{0}{0}:{1}`,
"label.timzone.tip.info1":`涉及到数据库保存(insert和update)java.util.Date类型的数据时，例如TpSysTask task=new TpSysTask();task.setBeginTime(new Date());......dbman.insert(task);或者dbman.update(task);应将new Date()改为调用TimeUtil.getNowDate(userInfo),所以上例中相关语句应为task.setBeginTime(TimeUtil.getNowDate(userInfo));`,
"label_tabpage_transformationsz":`转换`,
"front-kefu-moudle-IP-phone":`IP话机`,
"label.emailobject.list.draft":`草稿箱`,
"label.tianyancha.businessverify.readandconfirm":`我已阅读此用户许可协议，并同意此协议。`,
"label.win.customers":`已结束/赢得客户`,
"vue_label_commonobjects_view_switch_display":`您的记录按照记录类型分组，可点击对应的记录类型名称，切换展示。`,
"pagecreator_systemstyle_label_textcolor":`文字颜色`,
"label.autosearch.keywords":`自动完成关键词搜索`,
"label.knowledge.setting.data.six":`您将要删除{lbmc}分类，是否要继续？`,
"front-console-sort-field":`个案编号`,
"label.bangladesh.time":`孟加拉时间`,
"label.dashboardSetup.number":`数值`,
"lable.account.LastbDays":`过去30天`,
"label.layout.searchdialog":`查找对话框`,
"label.newprocessstep4.tip":`选择电子邮件模板，用来通知批准人批准请求已经分配给他们。请注意，此模板将用于此过程的所有步骤。`,
"label.nousing":`未启用`,
"vue_label_report_detailline":`详细信息行`,
"label.emailobject.template.message3":`您的邮件模板已达上限！`,
"label.c.d":`C 到 D 关系`,
"message.report.error.fail":`加载失败，请重试`,
"label.edit.ccdocument.content":`修改了附件内容`,
"label.textmessage.exceeded":`你的短信模板数量已经超过最大上限`,
"label.saveas":`另存为`,
"label.visualpage.an.inline.style":`为详细页面和菜单页面内嵌自定义页面类型`,
"label.pagelayout.remark2":`数据。在创建页面布局之后，单击“页面布局分配”按钮，以控制用户在默认情况下看到哪个页面布局。`,
"label.notification.approval1":`您的【对象】批准请求已通过【审批人】批准`,
"label.h5.chatter.image":`上传的图片格式不正确`,
"vue_label_dashboard_displayunit":`请选择显示单位`,
"label.knowledge.default.language":`知识库默认语言`,
"label.chatter.publish":`发表`,
"label.companyprofile.serveraddress":`本次同步仅对当前服务器进行同步`,
"label.chatter.groups":`群组`,
"label_set_successfully":`设置成功`,
"label.quote.zongjia":`总价`,
"label.project.notice.endingdatelater":`结束日期需晚于或等于开始日期！`,
"label.customfields.fielddependency.info":`使用此页可以定义字段之间的依赖关系（例如有依赖性的选项列表）。`,
"vue_label_lead_successful_conversion":`转化成功`,
"label.icon.93":`书`,
"shift.serviceresource.illegal":`服务资源不属于此服务区域成员或轮班的日期范围不在成员关系范围内`,
"label.integrations.action.addnewlead":`新增潜在客户`,
"label_display_all_zeros":`显示全部为零值的行`,
"canlendaryear":`日历年`,
"label_tabpage_selrecordtypez":`选择记录类型`,
"vue_label_commonobjects_view_chart_funnel":`漏斗图`,
"label.layout3":`布局三`,
"label.logintime.cue":`未指定登录时间`,
"label.service.miniProgram.lastDate":`最后修改日期`,
"label.emailobject.view.fromcrm":`来自CRM联系人/潜在客户`,
"pagecreator.button.mobilepage":`手机端`,
"lable.oppt.jieduan.signcur":`标记为当前阶段`,
"label.fullaccess":`完全访问权限`,
"homepage.layout.pagename":`页面布局名称`,
"label.appointment.wizard.subtitle4-2-3":`3小时`,
"label.knowledgebase.please.check.record":`请至少勾选一条记录`,
"label.view.sortview.closepage":`关闭此页`,
"label_forecast_type":`预测类别`,
"all.day":`全天`,
"label.view.sortview.printpage":`打印此页`,
"message.integration.configure":`集成配置为空！`,
"label.forecast.customforecast.foretype.close":`已签单`,
"label_chatter_like":`喜欢`,
"template.report.folder.customer.potential":`潜在客户分析`,
"label.umeng.approval.dlsp.approve":`#approvalname替您批准#actorname请求的#objAPIName#recordname审批申请`,
"vue_label_normal_movedown":`下移`,
"chatter.group.groupAccessPermissions":`小组访问权限`,
"label.visualpage.tip":`你可以在这里创建属于你自己的页面`,
"message.validation.isnotdate":`输入正确的日期格式`,
"label.icon.173":`帆船`,
"label.icon.124":`打针`,
"label.import.page2.csvfiled":`CSV字段`,
"setup_layout_component_area":`区域`,
"label.visualpage.workability.standard":`页面中可使用的标准Class`,
"label_emailtocloudcc_redmessage9":`数据库错误，请联系管理员`,
"label_tabpage_contactsz":`联系人`,
"label.multilang.workflow.everydayinmonth":`每隔{0}个月的{1}天`,
"APPIntegration.Social.linkedinerror":`必须是一个合法的linkedin.com的URL`,
"button_partner_workspace_manage_memo":`管理您的伙伴云，配置伙伴云属性。`,
"template.chart.bnsrmb":`本年收入目标`,
"chatter.follow.now":`正在追随`,
"label.entitlement.process.condition.repeat":`设置重大事件重复`,
"label.relationobject.isdl":`是否代理`,
"label.lasttimemodifieralias":`上次修改人别名`,
"vue_label_commonobjects_detail_task_name":`编辑任务名称`,
"vue_label_homepage_quarterlyperformance":`季度业绩`,
"pagecreator.layout.message.delete":`是否删除当前所选布局？`,
"component_sendmail_label_cc":`抄送`,
"vue_label_email_enable_signature":`启用签名`,
"label.partnerCloud.financeSetting.create":`新的合作伙伴启用时，为符合条件的客户自动创建账户`,
"label.data.file.i.title.num1":`1.导入的文件必须是CSV格式的文件，CSV文件必须包含标题，没有标题不能导入。`,
"label_efine_assessment":`考核周期`,
"message.duplication.label.sectionTitle":`选择要保留的值`,
"front-electronic-export-buttonExport":`继续导出`,
"message.submitpage.email":`祝贺您！电子邮件发送请求成功！`,
"after":`晚于`,
"label.version.nonsupport":`不支持`,
"label.icon.105":`日程`,
"label.quickcreate.titledesc":`启用快速新建后，可以在查找字段录入时，在搜索框中快速创建新的记录。`,
"label.quote.number":`填写数量`,
"label.view.sortview.setdefault.prompt":`将此视图列表设为默认视图`,
"label.refertime":`提交时间`,
"frame.personinfo.label.minipic":`缩略图`,
"label.mobile.home.page.newopp":`最新潜客`,
"label.address":`地址`,
"front-pay":`付费`,
"label.chat.serviceAppointment":`服务通知`,
"label.umeng.activity.eventviewed":`您分配给#name的事件被查看`,
"label.validate.function.funcExplain.DATE":`通过年、月、日创建日期`,
"label.commiterselectapprover":`允许提交人手动选择批准人。`,
"label.appointmentconfirmpage.wizard.subtitle3":`地点`,
"vue_label_display_text_field":`显示文本字段`,
"label.salescloud.teamrole":`小组角色`,
"maintenanceplan.workorder.generate.limit":`生成的工作订单应在维护计划范围内`,
"label.campaignmember.selectmember.description":`选择一个视图，然后选择成员以添加到市场活动中,成员状态为`,
"label.ismodify":`是否允许编辑`,
"label.height":`高`,
"label.tabpage.thevalurofz":`的值`,
"label.create_successful":`表单创建成功`,
"front-invoice-online-payment-setup-configure-dialog":`配置支付接口`,
"label.customerinfo.smsEid":`短信网关EID`,
"label.visualpage.list.no":`无自定义页面访问权限`,
"look.trigger.in":`查看使用说明`,
"label.setting.disable":`停用`,
"chatter.group.name":`小组`,
"label.solutionadministrator":`解决方案管理员`,
"label.vlidaterule.top":`页首`,
"pagecreator.layout.message.save.fail":`布局保存失败`,
"label.partnerCloud.orderingPlatform.noZero":`数量不能为0`,
"label.customfields.suretodeleteprompt":`确认自定义字段删除提示`,
"button_partner_viewdetail":`查看`,
"label.icon.122":`房子`,
"label.customer.tab.step2.introduce":`选择要在其中使用新自定义菜单的用户简档。也可以在每个简档的详细信息和编辑页上检查或修改是否显示某个菜单。`,
"label.task.delegated":`已委派`,
"vue_label_salesadvance_averageamount":`平均客单价`,
"vue_label_chat_invitedtojoin":`“{invite}”邀请你加入了群聊`,
"label.data.downpage.e_title.num1":`1、选择要导出数据的对象，或者选择导出全部。`,
"label_display_options":`显示选项`,
"vue_label_chatter_more_comments":`更多评论`,
"label.ggReleaseRange.publish":`发布列表`,
"label.valuetype.notmate":`行条件错误，值类型不匹配！`,
"label.chatter.chatter":`CCChat`,
"label.exchange.sync.state.contact.m1":`上一同步活动：`,
"label.dataimport.duplication.filter":`查重过滤器提示`,
"label.appdownload.uninstall":`卸载软件包`,
"message.error.task.add":`新建任务异常`,
"UG.Account.07":`导入客户`,
"label_tabpage_lastone":`至少选择一条操作`,
"front-console-holdTime":`搁置时间`,
"label.emailobject.schedule":`这里是我的日程安排，请您选择一个合适的时间。`,
"label.lookup.locked.data":`该记录已锁定，不可选择`,
"label.assignment.setup.newentries.ifcondtions":`如满足以下条件，则运行此规则`,
"label.magadan.time":`彼得罗巴甫洛夫斯克时间`,
"message.error.serviceterritorymember":`请在服务预约计划开始和结束的时间范围内将选择的服务资源定义为服务区域成员`,
"label_chatter_delete":`删除`,
"label.partner.workspace.member.permission":`可选权限集`,
"label.notification.task5":`您的任务已逾期`,
"mary":`五月`,
"label.homepagemodule":`主页组件`,
"label.compact.layout.frame.error1":`右屏不能没有内容`,
"chatter.error.refresherror":`刷新失败，请重试`,
"label.login.rememberPsd":`记住密码`,
"Lead.Scoring.Setting.Rule.Setup.01":`潜在客户打分规则列表`,
"label.reportsSubscriptionPage.schedulereport.weekly.sunday":`星期日`,
"label.visible":`可见`,
"label.console.new":`新建控制台`,
"label.mr.descreption.reDataList4":`毫秒。 每页显示`,
"vue_label_notice_uploadavatar_notice2":`上传头像图片只能是 JPG/PNG/GIF 格式`,
"label.operation.error":`操作失败，请重试。`,
"label.sendsms.context":`短信内容`,
"label.least.show.line":`（至少显示4行）`,
"label.tabpage.newWizardz":`新增功能向导`,
"label.tippage.li2":`删除基于自定义报表数据源的所有报表`,
"label.customfields.new.step2.opration.unique":`独有`,
"label.listofshare.remark":`以下列出的用户可以看到此记录的信息`,
"label.address_information":`地址信息`,
"label.projectManagement.overdue.tasks":`已逾期的任务`,
"lable.account.PreviousCQ":`上一个日历季度`,
"label.service.miniProgram.advertising":`广告名称只是作为辨别多个广告条目之用，并不显示在广告中`,
"label.integrations.mailchimp.exportlead":`导出潜在客户至Mailchimp`,
"label.payments.paytip3":`请选择账单地址`,
"label.mobile.phone.screen":`筛选`,
"label.h5.tome":`关于我的`,
"label.mobile.side.tab.remark1":`将CloudCC菜单及对象添加到移动端侧滑栏导航菜单`,
"vue_label_calendar_choose_a_custom_color":`选择此日历的自定义颜色`,
"label.lastname":`姓`,
"vue_label_dashboard_selectreport":`请选择报表`,
"label.lanxin.setting.appid":`AppID`,
"vue_label_report_information":`以在CloudCC中显示的方式导出报表，包含报表表头，分组和筛选信息。`,
"label_chatter_default":`默认`,
"label.globalSearch.info":`搜索全部已选对象`,
"label.integrations.mailchimp.massage2":`正在将潜在客户导出至Mailchimp，稍后您可在Mailchimp列表中查看。`,
"label.tabpage.addresswrongz":`邮箱地址格式错误,请正确输入邮箱地址！`,
"label.mobile.phone.customer.call":`客户拜访`,
"vue_label_email_linkrecordfail":`已取消关联记录`,
"lable.account.LastfDays":`过去90天`,
"label.cpq.order.status.delete":`该订单已启用，不能删除`,
"label.ccchat.notmember.active.group":`您不是名称中含有`,
"label.savepayset.failure":`保存线上支付设置失败`,
"label.version.createlimitbyobject":`您当前CloudCC版本是 {0}， 每个对象允许创建 {1} 个{2}，已达到上限！如有需要，请升级CloudCC版本！`,
"approval.process.errore":`保存过程中出现错误，请联系系统管理员`,
"label.stdashbord.xsld.business.reportanalysis":`图表分析`,
"label.login.verification.please.enter":`请输入您从MFA应用程序中获取的安全码`,
"label.tabpage.cue":`信息提示`,
"vue_label_salesadvance_converserate":`转化率`,
"label.marketsea.recyclereminddays1":`自动回收前`,
"label.import.page1.update":`更新`,
"label.document.folder":`文档文件夹`,
"label.h5.similar.opportunity.feature":`此功能使用户可搜索与用户的业务机会共享共用字段的业务机会。一旦启用，一个“类似业务机会”相关列表会出现在业务机会记录中。`,
"label.myanmar.time":`缅甸时间`,
"monday":`星期一`,
"vue_label_account_shareholder":`股东`,
"button.partner.search":`查询`,
"label.partnerCloud.partnerAccount.topUpAmount":`充值金额`,
"label.tabpage.refreshz":`刷新`,
"lable.PowerProcess.complete":`完成重大事件的分钟`,
"front-kefu-moudle- normal-phone":`普通电话`,
"label.user.unauthorized.organization":`未经授权的组织，请联系管理员！`,
"label.area.canot.save.nulldata":`不能保存空数据`,
"label.version.role.management":`角色管理`,
"label.recordtype.batchaddattachments.batch.remark":`步骤 1.选择文件；  步骤 2.单击“开始上传”按钮，上传文件； 步骤 3.单击“完成”按钮，返回上一页`,
"label_tabpage_contentz":`请输入内容`,
"label.partner.workspace.member.all":`全部`,
"label.validate.function.funcFormat.LEFT":`LEFT(text, num_chars)`,
"vue_label_SMS_notice_selectatleastone":`请至少选择一位潜在客户或联系人`,
"label.appupload.install.error.choice5":`立即停止安装，并输出冲突组件`,
"label.version.lookupmdfield":`主详字段`,
"setup.layout.label.desc":`降序`,
"vue_label_report_addsummaryformula":`添加汇总公式`,
"label.done":`实际`,
"label.input.samevalue":`输入相同的值`,
"label.SMS.next":`为此短信通知选择对象并单击下一步"。短信通知只能与相同类型的工作流规则和批准过程相关联。"`,
"label.role.allunselectuser":`所有未分配的用户`,
"label.loginhistory":`登录历史`,
"vue_label_report_addpublicreportstofolder":`添加公用报表至此文件夹`,
"label.email.track.no.attachment":`无附件`,
"label_network_connection_failure":`网络连接失败`,
"vue_label_file_delete_lib_member":`删除文件库成员`,
"label_partner_step1":`步骤1：选择模板`,
"label.password":`密码`,
"label.select.the.fields.around.code":`选择显示在二维码/条形码周围的字段`,
"label.file.share.limit":`超出共享上限，无法添加新的共享！`,
"label.desktop":`桌面`,
"label.sendmail":`发送邮件`,
"label.quote.detail":`报价单明细`,
"label.approvalstep2":`步骤 2：指定步骤条件`,
"label_component_hotdeal_nodata":`无业务机会相关数据`,
"lable.reset":`重置`,
"label.eventpagelayout":`事件页面布局`,
"label.icon.100":`文具`,
"UG.quota.03":`报价模板`,
"label.calendar.week.view":`周视图`,
"component_chatter_file_button_save":`发表`,
"label.as":`为`,
"template.chart.yqxypjz":`预期响应平均值`,
"UG.Contract.03":`创建合同`,
"label.projectManagement.gantt":`甘特图`,
"label.forecast.edit.error0":`错误：请至少启用一种公司币种!`,
"label.ccpeak.delete.sharetab":`删除共享表`,
"label.account.contact.goback":`返回客户`,
"vue_label_email_insert_field":`请选择插入字段`,
"setup_object_field_dependency_label_fieldvalueoptions":`可选字段值`,
"label.salescloud.opportunity.contactrole.optionlist.main":`下面是业务机会联系人角色字段的选项列表值的主列表`,
"label.huanxinconfig.tenantid.lost":`tenantid不能为空`,
"label.mask.show.last_4":`掩码显示最后4位`,
"label.targer.name":`目标名称`,
"vue_label_commonobjects_detail_unlocksuccess":`解除锁定成功`,
"front-kefu-moudle-length-min":`长度(分钟)`,
"label.chat.topic.my.favorite":`我收藏的主题`,
"chatter.upload":`上传`,
"message.cannotapproveit":`无法处理该批准请求`,
"label.weixin..xsld.order.by.jine":`按合同金额排序`,
"label.projectManagement.wait.test":`等待测试`,
"template.report.customer.contact.list":`客户联系人列表`,
"label.empty.recycle.bin":`清空回收站`,
"label.detail.approveprocess":`查看批准过程`,
"label.appexchange.uninstallpage.message4":`永久删除基于此软件包中的自定义对象的任何报表、试图和自定义菜单`,
"label.weixin.linkreport":`关联→报表`,
"label.tianyancha.orgnumber":`组织机构代码`,
"Q":`选项列表（多选）`,
"pagecreator_systemstyle_message_save_fail":`样式保存失败`,
"label.partner.new":`伙伴云：新建`,
"label.ems.accounttype":`账户类型（A）`,
"label.weixin.next":`下一步`,
"label.weixin.coach.interpret":`爱马社保留此微信服务法律范围内的修改权和最终解释权`,
"label.some":`个`,
"label.currency.rate":`币种编辑：兑换率`,
"label.emailobject.template.name":`模板名称`,
"UG.Campaign.001":`计划市场活动`,
"label.mr.descreption.reDataList3":`组，查询花费时间`,
"label.project.hit.nine":`每天问题提醒`,
"lable.PowerProcess.golist":`<<返回列表：权利过程`,
"label.viewbuttonedit.remark":`选择要在前台视图上显示的标准按钮及自定义按钮`,
"label.component.helper":`助理`,
"lable.SalesCommitmentKanBan.contractAndReceipts":`签约收款`,
"chatter.group.userName":`用户名`,
"label.mobile.phone.business":`商机`,
"label.quickbooks.payments":`付款`,
"label.step6.total7":`第6步，共7步`,
"label.forecast.detailforecast.revenue":`收入预测`,
"vue_label_commonobjects_view_chart_displayas":`显示为`,
"label.recordeditoption":`记录可编辑性属性`,
"label.sendemail.send.sendfailstandby":`邮件发送失败，请联系管理员。(备用发件箱)`,
"label.knowledgebase.reset.filter":`重置筛选器`,
"label.icon.111":`餐饮`,
"label.standard.buttonandlink.firstsetting":`优先设置`,
"front-filter-module-v1-filter-description":`快速筛选器无法保存，仅适用于当前操作。不会影响视图，也不会影响其他用户。`,
"label.showmore":`显示更多`,
"UG_Lead_001":`如何引入线索?`,
"label.exchange.sync.state.setting.m1":`提供的 Miscrosoft Exchange 服务帐户：`,
"label.please.enter.channel.name":`请输入渠道名称`,
"label.emailtocloudcc.edit":`编辑`,
"label.layout.tabdialog":`菜单`,
"label.Emoji":`表情`,
"template.report.completed.tasks":`已完成的任务`,
"label.tabpage.enterviewname":`第一步：请输入视图名称`,
"label.mobile.phone.not.to.choose":`未选择`,
"label.datamanage.contact.namenull":`注意：如果没有给“联系人姓名”字段赋值，联系人记录将不会被导入！`,
"LT":`地理定位`,
"label.exchange.sync.state.task.m3":`在最后24 小时同步的记录：`,
"lable.SalesCommitmentKanBan.contractOwner":`合同所有人`,
"vue_label_chatter_write_review":`撰写评论`,
"label.h5.approval.enter.content":`请输入审批备注内容`,
"label.location.display.type":`纬度与经度显示表示法`,
"label.numberscannotnull":`数量不能为空`,
"label.icon.3":`货币`,
"setup_object_field_dependency_label_linkedfieldvalue":`依赖字段值`,
"label.task.future":`即将到来的任务`,
"label.look.more.record":`查看更多记录`,
"vue_label_account_cases":`转移客户所有人的全部个案`,
"label.emailobject.emaildetail.title.ccaddress":`抄送给：`,
"label.setHistoryTrack":`设置历史跟踪`,
"ObjectDetailed.ViewKeyInformation.Layout":`编辑关键信息`,
"label.layout.editsearchdistribute.tip":`选择要包括到此搜索布局中的字段。请注意，所做的选择只决定搜索结果的显示，而不会影响实际被搜索的字段`,
"label.emailtoall":`发送电子邮件给所有人`,
"label_partner_new":`伙伴云：新建`,
"label.direct.dashboard.me.not.approval":`我的未审批项目`,
"label.platform.customize.customizeui":`自定义UI`,
"label.userinfo.pwderror.againinput":`两次输入的密码不一致，请重新输入！`,
"label.customsetting.introduce":`使用自定义设置创建并管理组织、简档和用户级的自定义数据。自定义设置数据存储在应用程序缓存中。这意味着您可以有效地访问它，而不必进行重复的查询。`,
"label.file.owner":`所有人`,
"label.icon.7":`人`,
"label.document.query.button":`单击浏览按钮查找文件`,
"label.tabpage.turnoffsz":`关闭-已转化`,
"message.error.appid.appsecret.failed":`获取秘钥失败！`,
"vue_label_commonobjects_view_to_display_fields":`最多选择15个展示字段`,
"label.martrixreport.setlinetitle":`指定行标题`,
"vue_label_chatter_applycertification":`确定同意"{name}"加入小组吗`,
"front-electronic-export-success":`导出成功，请您再Mailchimp列表中查看`,
"label.emailsync.status.enable":`启用关联`,
"label.c_d":`C 到 D 关系`,
"PageLayout_Search_MultiSearch_003":`您至少选择一个字段。`,
"label.tabpage.newInterfacez":`新版界面`,
"label.cutomsummaryfieldedit":`编辑自定义汇总字段`,
"label.usermanage.view.field.notexist":`视图对应的字段不存在`,
"label.list.userinterface.dashboard.setup":`仪表板设置`,
"label.knowledgebase.delete.article":`删除文章`,
"label.dataimport.type.update":`更新`,
"label.marketsea.new":`新建公海池`,
"label_tabpage_newlybuildz":`新建`,
"vue_label_helpcenter_report1":`1、构建报表<br>    CloudCC销售管理系统中的Lightning 报表是一款功能强大的数据分析的工具。通过分组、筛选和汇总记录可以解决很多销售问题。例如：“上一季度，公司开展的新的商机共创造多少收入？”，在完成数据概览的基础上还可添加报表图表。报表完成后，单击运行，可查看数据的完整结果。<br>    步骤1：从报表选项卡，单击“新建报表”； <br>    步骤2：选择报表数据源，然后单击“下一步”； <br>    您选择的报表数据源，可以决定哪儿些记录或字段可以在报表中使用。选择或者搜索一个对象作为主对象，最多可以选择4个与主对象具有关联关系的对象，并且可以选择对象之间的关系。<br>    步骤3：进入报表编辑页面，并显示预览数据<br>    在编辑模式中，可以自定义报表，将字段作为列添加到报表、分组行和列、利用筛选器筛选报表数据，直到准确显示您需要的数据<br>•添加、移除列及调整列顺序<br>    添加列：在报表编辑模式中，单击页面左侧“概要”中的“列”输入框，通过搜索字段后选择或滚动下拉字段列表后选择想要的字段的方式添加报表列。<br>    移除列：<br>    A.在左侧“列”列表中找到想要移除的“列”后，单击字段框上的“×”。<br>    B.或在右侧报表预览视图的表头中找到想要移除的“列”后，单击“下拉按钮”，单击“删除列”。 <br>    将列从报表中移除不会删除字段。如果您移除列，但想要进行恢复，重新添加即可。<br>    调整列顺序：通过上下拖拽左侧“列”列表中的“列”字段可以调整“列”的排列顺序。<br>•添加、移除行分组和列分组<br>    添加行分组：单击页面左侧“概要”中的“组行”输入框，通过搜索字段后选择或滚动下拉字段列表后选择想要的字段的方式添加报表行分组字段，进行数据筛选。<br>    在没有添加列分组的情况下，最多可添加三个行分组。<br>    添加列分组：在存在行分组的情况下可以添加列分组，单击页面左侧“概要”中的“组列”输入框，通过搜索字段后选择或滚动下拉字段列表后选择想要的字段的方式添加报表列分组字段，进行数据筛选。<br>    最多可添加两个列分组，在添加列分组的情况下，最多可添加两个行分组。添加为行分组的字段不能再添加为列分组。<br>    `,
"label.notification.event1":`【分配人】已为您分配事件`,
"chatter.field":`个字段`,
"chatter.feed.menutype.feed.newscom":`我正在追随的所有内容`,
"label.attendance.range":`考勤范围`,
"vue_label_calendar_deleteconfirm":`确定删除日历{name}吗`,
"label.ems.createTask":`新建{taskName}`,
"label.visualpage.wgd":`未归档自定义页面`,
"label.multilang.product.deleterederect1":`无法完成您对<font style="font-weight:bold;">{0}</font>的删除尝试,因为它仍与以下记录相关联.这种情况下,建议您禁用。`,
"label_emailtocloudcc_filed_servertype":`服务器类型`,
"label.umeng.insert.approval.dlsp.approvenew":`#actorname提交#objAPIName#recordname待您审批`,
"label.tabpage.queue":`队列`,
"label.approval.step":`审批步骤`,
"label.approvaldatamove.approvalprocessname":`过程名称`,
"label.actualapprovedpeople":`实际批准人`,
"label.systemlog.f":`失败`,
"front-template-V1-addText":`添加文本`,
"label.chat.like":`赞`,
"label.userinfo.oldpwd.notnull":`旧密码不能为空！`,
"label.service.all.done.major.event":`您已完成所有重大事件`,
"label_chatter_to":`到`,
"message.toomuchlinecannotoutput":`选择报表列过多，报表无法输出！`,
"maintenanceasset.assetid.maintenanceplanid.unique":`维护计划已分配到资产，请勿重复分配`,
"lable.quote.syncing.firstsync.description":`报价单明细 将替代业务机会产品`,
"lable.outlook.mcto.saveemail":`务必保存电子邮件附件`,
"label.passwordPolicy.setup.pwdremember2":`记住2个密码`,
"label.project.hit.five":`项目任务更新通知`,
"label.linkedin.setting.appid":`秘钥`,
"label.dataimport.error.name.notnull":`出现错误：name不能为空。`,
"label.knowledge.case.field.selected":`已选个案字段`,
"label.version.datetime":`{0}个日期时间字段`,
"Dashboard_NoAccessRightToSee_Warning":`您所设置的默认打开仪表板{0}目前您没有权限查看，您需要重新设置为其他值。`,
"label.login.access.permission":`授予访问权限`,
"label.operatedata.import.tip":`1.导入的文件必须是CSV格式的文件，CSV文件必须包含标题，没有标题不能导入。<br/>2.建议在导入时先导出，以导出文档为数据模板整理导入数据，然后再导入。（导入的数据中如果含有逗号，请使用‘@’符号代替）<br/>3.系统会把将要导入的数据文件预读到服务器，然后启动后台批处理导入程序，导入结果将以邮件方式通知用户，您无需在此操作页面等待。`,
"workflow.action.tasks.assignortype.rolename":`角色名称`,
"vue_label_account_quotations":`转移客户所有人的全部报价单`,
"lable.account.CurrentCQ":`当前日历季度`,
"label.user.database.error":`数据库错误！`,
"label_emailtocloudcc_titel":`Email to CloudCC`,
"label_file_content":`正文内容`,
"label.button.behavior":`模式`,
"message.recordtype.new.tip":`输入详细信息`,
"label.ccchat.message.new.error3":`错误：您无法选择超过9个收件人`,
"vue_label_commonobject_notice_lessthanwords":`文件名称字数应小于{FILE_NAME_COUNT}个字！`,
"label.stacked.verticalline":`堆叠图形-垂直列`,
"vue_label_SMS_messagebox":`短信箱`,
"label.appexchange.installedpage.message3":`根据已安装软件包旁边的链接，您可以在此页面中执行不同的操作。要删除软件包，单击<b>卸载</b>。要管理软件包许可证，单击<b>管理许可证。</b>`,
"label.unusedapproveprocess":`未启用的批准过程`,
"label.onlywithspecificconditions":`此计算仅应包括符合特定条件的记录`,
"lable.outlook.mcto.formaterror":`格式错误`,
"label.area.parent":`上级区域`,
"vue_label_chat_activesuccess":`开通成功`,
"label.setting.intergrationlist.button.upgrade":`更新`,
"label.page_hidden":`注册页面隐藏字段`,
"label.customsetting.manage.belong":`设置所有者`,
"label.appointment.wizard.subtitle4-2-8":`7天`,
"template.chart.ydywjhxsje":`月度业务机会销售金额`,
"label.multilang.currencylist.after":`{0}之后`,
"vue_label_commonobjects_view_chart_countby":`合计依据`,
"label.week":`周`,
"label.emailtemplate.name":`模板名称`,
"label.umeng.sign":`已经签到`,
"label.appupload.upload.details":`详细信息`,
"label.file.loading":`正在加载`,
"label.newdetail.orgTitle":`联系人人脉`,
"label.salescloud.field.addoptionlist":`添加选项列表值`,
"pagecreator.page.funcpath":`/构建器/页面列表`,
"Account.News.Setting.001":`客户设置`,
"label.marketsea.getnoconversiondays":`天未转化（需大于获取后未跟进天数）`,
"message.error.event.add":`新建事件异常`,
"front-electronic-export-choseChimp":`请选择导出的Mailchimp列表`,
"vue_label_report_personothers":`其他人员`,
"label.hierarchy.diagram":`层级结构图`,
"label.stdashbord.xsld.business.yqsr":`预期收入`,
"label.chat.topic.max.count":`您已经达到主题的最大数目。`,
"label.sendemail.send.sendfail":`邮件发送失败，请联系管理员。`,
"registration.page.body.title":`注册页面`,
"label.userphoto.back":`取消`,
"label.service.without.timeslot":`似乎没有任何时隙，现在让我们添加一些！`,
"label.processsetting.remaining.quantity":`最多输入255个字符，剩余数量：`,
"label.sure.delete":`确认删除`,
"front-epwechat-module-v1-callback":`回调配置`,
"front-email-payment-failed":`抱歉，支付失败！`,
"label.icon.67":`机器`,
"UG_Forcast_01":`预测`,
"label.escalation.setup.newentries.step3":`步骤3：指定如何设置升级时间`,
"lable.account.NextCY":`下一个日历年度`,
"report.type.label.quote":`报价`,
"label.area.name":`区域名称`,
"component.setup.label.object":`对象`,
"label.customsetting.type":`设置类型`,
"label.showdetail":`显示详细信息`,
"label.department.prev":`上一页`,
"label.select.data.source.report":`请选择数据源报表！`,
"UG_homepage_002":`使用一体化的业务工具来管理您的线索、潜在客户、销售交易漏斗以及客户信息`,
"vue_label_report_notice_exprot1":`仅导出详细信息行。使用此数据，以进行更多计算，或上传到其他系统。分页导出，单页最多导出5000条`,
"message.error.task.phonecreate":`电话任务创建异常`,
"label_chatter_day":`天`,
"label.setinitialcommiter":`步骤 6 指定初始提交人`,
"message.huanxinconfig.notfound":`未找到环信相关配置`,
"label.customfields.file.count.tip":`请输入此字段可输入的文件个数，默认为1`,
"label.weixin.appmanage":`应用管理`,
"label.approverautoconfirm":`批准人的自动确定方式`,
"vue_label_CCChat_followers":`关注者`,
"label.usermanage.notselect":`未选择用户`,
"label.item":`条`,
"label.sendemail.chat.linkurl":`链接URL：`,
"label.sendmail.step3.deliveroptions":`交付选项`,
"homepage.components.creationtime":`创建时间`,
"label.pc.ui.2018.ccchat.setting":`CCChat设置`,
"label.knowledge.search.result.highlight":`在搜索结果中高亮突出显示相关的文章文本`,
"label.data.downpage.e.title.num2":`2、若选择导出单个对象的数据，则需要选择数据导出方式。数据导出方式有：自定义导出，按模板导出，导出模板。`,
"label.field.duplicate.error.msg1":`存在重复数据，请先处理重复数据再设置独有属性。`,
"label.campaign.channel.input.number.error":`数字格式错误`,
"label.goto.dashboard":`转至仪表板`,
"com.cloudcc.login.error.message.invalid.ip":`IP不在登录范围内`,
"label.selectnewfieldvalue":`指定新的字段值`,
"label.appointmentdetail.wizard.title11":`空闲时间结束日期`,
"Opportunity_Detailed_Phase_Label_Popup_001":`进入日期`,
"front-dynamiclayout-module-v1-readonly":`{readonly}字段已被设置为只读字段`,
"vue_label_calendar_start_field":`开始字段`,
"label.weixin.recalculate.shared.failed":`对象共享规则重新计算失败`,
"label.sendmail.step3.dealoptions":`处理选项`,
"setup_layout_label_modifypage":`编辑页面`,
"homepage.components.select.wide":`选择要显示的宽式组件`,
"label.import.page1.laststep":`上一步`,
"label.weixin.donot.permission":`您没有权限执行此操作`,
"message.error.name.null":`name不能为空！`,
"label.salescloud.teamrole.optionlist":`小组角色选项列表值`,
"component_setup_label_titlefield":`标题字段`,
"vue_label_commonobjects_detail_have_been":`您已为`,
"label.textmessage.vonage.setup":`Vonage设置`,
"label.recordtype.profile.enableit":`为简档启用`,
"UG.product.04":`创建产品`,
"label.knowledge.No.related.articles":`没有相关文章...`,
"label.chat.muted":`免打扰`,
"registration.page.field.selection":`注册页面字段选择`,
"label.project.hit.eleven":`问题分配通知`,
"lable.newtabpage.advsearch":`高级搜索`,
"label.report.share.roleandsub":`角色及内部下属`,
"component.salesperformance.label.nodata":`添加您的业务机会，然后返回此处查看业绩图。`,
"label.submitted_on":`提交日期`,
"label.file.create.link":`创建链接`,
"label.contact":`联系人`,
"label.tab.message.failtoopenleft":`左侧栏打开合并操作失败`,
"label.replaces":`替换`,
"label.customcomponent.check.tag.startwith":`组件必须以&lt;cc:component&gt;标签开头`,
"label.tab.web":`Web 菜单`,
"message.success.task.add":`保存新建任务信息成功`,
"label.chatter.addresser":`发件人`,
"label.mobile.homepage":`首页`,
"label.data.imp.su.ok":`系统正在导入`,
"label.knowledge.category.hint.one":`分类组是数据分类的层次结构。例如，一个名为“位置”的分类组可能包含大陆、国家、地区和州的地理层次结构。使用此页面来管理分类组及其所含的分类。`,
"label.schedulejob.setup.schedule.weekly":`每周`,
"label.tag.manage.description":`与{0}相关联的所有标签如下所示。您可以对可用标签进行重命名或删除操作。`,
"label.tabcontrol":`菜单`,
"label.field.duplicate3":`将“ABC”和“abc”视为重复值（不区分大小写）`,
"label.customsetting.type.list":`列表`,
"lable.account.ovdate":`会计季度结束日期`,
"label_chatter_pastSevenday":`过去7天`,
"front-kefu-moudle-v1-lxndxsdb-free":`联系您的销售代表，免费开通坐席功能`,
"label.termsforusage":`使用条款`,
"label.forecast.settings.qijian.m":`每月预测`,
"label_tabpage_viewname":`视图名称`,
"label.report.action.addtodashboard1":`添加至仪表板`,
"label_vue_create_edit_obj_create_event_dialog_desc":`您分配的用户在该时间段内已有待办事项：`,
"vue_label_report_standardfilter":`标准过滤器`,
"label.umeng.approval.submit":`#applyer提交了#obj待批准`,
"label.tab.mobile.sign":`移动端图标`,
"vue_label_commonobjects_detail_check_the_content":`存在验证错误，请检查填写的内容`,
"UG_Campaign_001":`计划市场活动`,
"chatter.group.baseInformation":`基本信息`,
"label.sendemail.send.noreceiver":`没有收件人或收件人邮件地址为空`,
"template.chart.yskje":`应收款金额`,
"label.textarea":`文本区`,
"vue_label_statistics_value":`统计值`,
"font-evaluate-module-v1-select-img":`选择图片：`,
"label.totalof":`您共选择了`,
"label.hangye":`行业`,
"label.partner.common.setup":`一般设置`,
"label.icon.78":`农业`,
"lable.outlook.detail.addemail":`添加电子邮件`,
"label.ServiceCloud.fuwuquyu":`服务区域`,
"label.gb2312encoding":`简体中文(GB2312)`,
"label.appointment.wizard.subtitle4-3-1":`10分钟`,
"label_emailtocloudcc_reauthorization":`重新授权`,
"label.approval.message":`审批意见最多输入1000字`,
"label_component_helper":`助理`,
"label.editRate":`编辑汇率`,
"label.setuptemplate":`自动化模板`,
"label_emailsync_button_cancel":`取消`,
"label.marketseamemset.account.maxuser":`成员最大客户数`,
"label.someerror":`由于安全原因，您的 CloudCC 会话即将超时。<br><br>您希望作何选择？`,
"label_person_in_charge":`负责人`,
"label.visualpage.reference.standard.style":`引用平台标准样式，customize-自定义样式`,
"errormessage_email_relatedorreceivermusthaveone_z":`收件人和相关项至少选择一项`,
"label.insert.field.empty.continue":`存在【{resDataField}】值为空的记录无法生成码,是否仍要继续生成?`,
"component.newrecords.label.title":`最近记录`,
"template.detail_info_link":`详细信息链接`,
"component_setup_tabs_label_default":`默认页`,
"label.emailobject.template.name.null":`邮件模板名称不能为空`,
"label.knowledge.field.changed":`已更改{1}`,
"homepage.components.select.narrow":`选择要显示的窄式组件`,
"label.mobile.phone.week":`第几周`,
"component_chatter_button_like":`喜欢`,
"label.brief.won":`成交`,
"label.setup.profile.replaceme":`替换关于我`,
"label.knowledge.setting.enable.lightning":`启用Lightning知识库`,
"label.middle":`中`,
"label.icon.109":`人`,
"vue_label_normal_activity_sf":`活动`,
"chatter.poll.option6":`选项6`,
"label.lanxin.setting":`集成蓝信H5微应用`,
"label.stdashbord.xsld.business.totals":`业务情况汇总`,
"label.emailobject.emaildetail.promptbutton1":`确定`,
"Opportunity.Detailed.Phase.Label.001":`阶段`,
"label.customcomponent.params.info":`如何使用参数`,
"label.emailtocloudcc.button.next":`下一步`,
"front-email-payment-billing-date":`开票日期`,
"label.ems.with3day":`3天以内`,
"label.project.subtask.date":`子任务日期必须在所属任务的日期范围内。`,
"label.role.allunselectanduseduser":`所有未分配且已启用的用户`,
"front-kefu-moudle-yes-wantbuy":`是的，我想要购买`,
"label.looking_for":`您找到想要的结果了吗？`,
"page.404.label.noresource":`很抱歉，您所访问的资源不存在。`,
"vue_label_ccchat_notice_deletecommentcertification":`确定要删除这条评论吗？`,
"label.data.setok.e.desc1":`导出成功后您会收到系统邮件提醒，导出的数据暂时保存在服务器上，系统只为您保存48小时，请尽快到`,
"label.weixin.confirm.delete":`确认删除该条数据吗？`,
"A":`文本区（富文本）`,
"template.report.sales.cycle":`销售周期持续时间`,
"label.service.shift":`轮班`,
"label.visualpage.display.side.bar":`显示侧栏，false-不显示侧栏`,
"label.list.userinterface.chatter.showall":`首页 CCChat 默认显示全部微贴`,
"vue_label_systemSettings_set_course":`设置进程，设置每个环节的要点贴士，引导大家按要求完成进程`,
"label.icon.156":`人`,
"label.marketsea.button.move":`转移`,
"front-email-payment-select-email":`请输入邮编`,
"front-electronic-signature-service-provider":`服务商`,
"label.h5.add.checkin":`签到`,
"vue_label_amount_total":`金额总和`,
"label.campaign.channel.new":`市场活动：新建营销渠道`,
"label.knowledgebase.restore.creates.draft":`还原会从此版本创建草稿。您将需要发布草稿，以使其可用。`,
"UG_Case_01":`个案`,
"label.validate.function.funcExplain.CONTAINS":`检查文本是否包含特定字符，如果是则返回TRUE。否则返回FALSE。`,
"label.data.exp.savetemp":`另存为模板`,
"front-project-module-v1-template-newcreate":`从项目模板新建项目`,
"label.field.default.count":`默认行数`,
"page.note.acc":`备注和附件`,
"label.close":`关闭`,
"label.app.detailbeforeedit":`下面是该自定义应用程序的信息。单击编辑"可以更改自定义应用程序。"`,
"label.profile.standardfieldsafety":`标准对象字段安全性设置`,
"vue_label_report_notice_deletefilter":`请先删除高级筛选条件`,
"label.multilang.datamoveaction.movesuccess":`共有{0}条记录转移成功！`,
"label.emailmerge.edittemplate.descirption":`输入有关您的邮件合并模板的信息。请注意，备注仅显示在CloudCC中，不会显示在Word中。`,
"label.visualpage.at.the.end":`在结束处以标签`,
"label.exchange.sync.state":`Exchange Sync 状态`,
"label.newdashboardpage.new":`新增一行`,
"label.querydetailservice.profile.notsetup":`您的账户对应的简档未设置`,
"label.escalation.setup.detail.description":`创建规则条目以根据其中指定的条件自动升级个案。创建规则条目后，可以从此页面上进行重新排序。`,
"lable.setup.mobilesetup.isenbaleh5newandedit":`移动端是否启用H5新建编辑`,
"vue_label_file_upload_tip_msg":`建议上传文件小于30MB，否则可能导致页面加载缓慢`,
"label.eowechat.epdeptid":`企业微信部门id`,
"label.adminorapprover":`管理员<strong>或</strong>当前分配的批准人可在批准过程中编辑记录。`,
"label_emailtocloudcc_email":`电子邮件`,
"setup_main2018_label_norole":`您没有系统管理相关权限`,
"label.onlyone":`唯一`,
"label.sso.saml.idp.config.nameidtype":`对象类型`,
"vue_label_normal_campaign_sf":`市场活动`,
"label.icon.61":`吊机`,
"label.datatype":`数据类型`,
"label.mobile.home.page.today.work":`我的工作`,
"label.sendemail.chat.praiseFeedcommentsubject":`CloudCC CCChat喜欢您的留言`,
"chatter.sel.p":`已选择0人`,
"label.b_c":`B 到 C 关系`,
"label.tabcontrolnameandtaglib":`菜单名称和标签`,
"label.globaloperation.tip":`创建、编辑和查看全局操作，这可用于详细信息页面。`,
"R":`记录类型`,
"label.initcommiteoperate":`初始提交操作`,
"front-kefu-moudle-v1-Operation-without0-permission":`无权限操作此记录，请联系管理员`,
"button_partner_create":`创建`,
"label.document.name.length.cannot.than":`文档名称长度不能超过255`,
"label.area.donot.delete":`无法删除区域，因为当前区域有下级区域`,
"label.currency.activation":`激活`,
"label.connect":`&串联`,
"button.partner.viewdetail":`查看`,
"setup_object_field_dependency_label_mustsetup":`请先设置字段依赖关系，再保存`,
"label.SalesCommitmentKanBan.task":`任务额`,
"lable.quote.syncing.finishbutton":`完成`,
"label.weixin.group.type":`访问类型`,
"vue_label_commonobjects_detail_relationship":`关系程度`,
"vue_label_email_cc":`密送人`,
"setup.object.field.dependency.label.fieldvalueoptions":`可选字段值`,
"label.sso.lookAtTheKey":`查看密钥`,
"UG.opportunity.008":`业务机会小组`,
"label.customfields.new.step1":`步骤1.选择字段类型`,
"lable.qrcodeOrbarcode.rule":`生成二维码/条形码规则`,
"vue_label_notice_nopermission_delete":`抱歉，您无权删除该条数据，请联系系统管理员。`,
"label.customerobj.tab":`自定义对象菜单`,
"com.cloudcc.login.error.message.nolicens":`许可不存在`,
"label.sendsms.batch.confirm":`批量发送短信：确认`,
"label.forecast.settings.sos":`收入和数量`,
"label.calendar.addevent.notice.opencalendarfirst":`请先开启我的日历或其他日历后再添加事件`,
"message.success.task.phonerecord":`保存电话记录任务成功`,
"label.knowledgebase.create.new.subtab":`新建子选项卡`,
"label.knowledge.article.recordid":`知识文章id不能为空`,
"Opportunity.Detailed.Phase.Label.Popup.003":`停留天数`,
"homepage.layout.nowpage":`现有的页面布局`,
"template.chart.khslph":`客户数量排行`,
"front-epwechat-module-v1-android-single":`Android单点登录：`,
"serviceresource.assignedresource.islacksr.lack":`因服务资源被分配了服务预约，因此无法删除服务资源，您可以不启用此服务资源`,
"label.email.only.display.info":`下框中只显示已存储有电子邮件地址的联系人或者同事`,
"label.weixin..xsld.yjhtje":`预计合同金额`,
"label.permission.delete.permsets.error.prompt":`该权限集中有分配的用户，不能删除！`,
"label.ccchat.enter.two.choices":`请填写至少2个选项`,
"label.edit.field.select.style2":`每个选项一行`,
"vue_label_email_please_enter_email_subject":`请输入邮件主题`,
"batch.sendemail.f":`， 邮件发送失败。`,
"label.sms.senderr":`短信发送失败`,
"label.batchadd.newbatchpage.save.em":`邮箱格式不正确`,
"label.icon.96":`圆规`,
"message.recordtype.deleterecord.tip":`使用此页将所有的现有记录类型替换为新记录类型。在以下框中选择替换记录类型以应用于任何包含所删除记录类型的记录。如果您只是想从现有记录中删除该记录类型而不用新记录类型替换它，请选择无"."`,
"label.field.edit.max":`最大评分`,
"label.partnerCloud.orderingPlatform.preferential":`优惠`,
"label.callcenter.login.later":`稍后登录`,
"batch.change.owner":`请选择所有人`,
"label.version.allow.upload.size":`允许上传文件最大为`,
"setup.mainpage.label.welcome17":`权限设置`,
"label.tag.sectionname":`标签信息`,
"label_partner_workspace_setup":`设置`,
"label.managecontrol":`管理权限`,
"label.timetrigger.condition":`评估条件设置为每次创建或编辑记录时`,
"label.reportsSubscriptionPage.schedulereport.monthly.week":`星期`,
"front-verkoop-bywerking-error":`更新失败`,
"label.allowcommittercallback":`允许提交人调回批准请求`,
"vue_label_commonobjects_detail_lead_finishistatus":`将状态标记为完成`,
"message.error.object.lookupmd":`对象建立了主详关系`,
"label.stdashbord.xsld.business.img7":`可能性为0%阶段的个数/(可能性为100%阶段的个数 可能性为0%阶段的个数)`,
"label.checkruleofevent":`事件验证规则`,
"front-epwechat-module-v1-single":`单点登录`,
"label.tabpage.save":`保存`,
"label_emailtocloudcc_search":`搜索`,
"label.tianyancha.h5.registeredPlace":`注册地（简写）`,
"label.field.addoptionlist":`添加选项列表值：选项列表`,
"label.schedule_anotherpost":`计划其他的帖子`,
"label.customfields.searchrelation.tip":`创建一个将此对象链接到另一对象的关系。 关系字段允许用户单击查找图标，以从弹出列表中选择值。 另一对象是列表中值的源。`,
"label.partnerCloud.partnerAccount.prepaidPhone":`账户充值`,
"label.projectManagement.view.details":`查看详情`,
"label.sendemail.chat.praiseFeed":`尊敬的#name:\n\n    您好！#userName对您的微贴点了喜欢。`,
"label.validate.function.category.Text":`文本`,
"component.task.label.newevent":`新建任务`,
"label.data.import.setup.operate":`如果发现现有记录，您希望采取什么操作？`,
"label.salescloud.salesdashboard.clear.option":`清除选项`,
"lable.account.PreviousCY":`前两个日历年度`,
"label.appointment.wizard.subtitle8":`对被邀请者可见的公司名称`,
"label_emailsync_status_viewlog":`查看日志`,
"message.duplication.label.filtertitle":`查重过滤器`,
"label.custom.quarter.description":`此页允许您定义一个自定义季度记录。自定义季度的日期将根据您下面所进行的选择生成。`,
"label_tabpage_filenamez":`文件名称`,
"lable.currencyAdv.andbefordate":`和 之前的日期`,
"label.version.nonsupport.sharerule":`暂不支持共享规则！`,
"front-epwechat-module-v1-unbound":`解绑`,
"label.division":`分部`,
"label.data.import.setup.repeat":`是否要阻止创建重复记录？`,
"label.callcenter.makesure.Amazon.connect":`注意：确保您已经创建了Amazon Connect的实例`,
"label.version.lead.control":`潜在客户管理`,
"label.copying.reward.groups":`复制报价行组`,
"#label.severalorone":`压缩或单个文件#`,
"label.mailinginfo":`邮寄地址`,
"component.telerecord.label.title":`记录电话`,
"label.godocumentlist":`返回文档列表`,
"APPIntegration.Dropbox.setting.01":`启用`,
"label.tianyancha.website":`网址`,
"label_tabpage_greaterequalz":`大于或等于`,
"vue_label_campaign_influencedopportunity":`影响业务机会`,
"message.save.param.null":`参数为空，保存失败`,
"front-epwechat-module-v1-domain":`可信域名-JS-SDK：`,
"label.allowreport":`允许报表`,
"label.service.major.event":`重大事件`,
"label.import.index.selectobjectandfiles":`选择对象与文件`,
"label.chatter.task":`任务`,
"label.knowledge.setting.hint.twelve":`输入数据分类`,
"lable.account.CurrentandPreviousFY":`当前和上一个会计年度`,
"label.martrixreport.step3":`步骤 3：选择要汇总的信息`,
"front-console-select-cases":`选择的个案数不能超过10个`,
"label.partnerCloud.partnerAccount.backHome":`回到首页`,
"label.me.assign":`我分配的`,
"label.appointment.wizard.subtitle3":`请指定一周中您可以预约的时间`,
"label.edit_columns":`编辑列`,
"label.partnerCloud.orderingPlatform.useRebates:":`使用返利：`,
"label.projectManagement.enter.up.to.10.digits":`最多输入10位`,
"label.integrations.description.mailchimp":`CloudCC与Mailchimp集成，您将系统内的潜在客户和联系人导入至Mailchimp后，可以将各类邮件群发至指定的收件人。您还可以在Mailchimp中查看邮件运营的统计数据。`,
"label.ccchat.person.error.requiredomain":`错误：至少需要一个域`,
"label.projectManagement.Pleaseselectitem":`请选择项目`,
"label.netaccess":`网络访问`,
"vue_label_SMS_searchobject":`搜索对象`,
"label.role.viewintree":`以树状视图显示`,
"lable.SalesCommitmentKanBan.accountName":`客户名称`,
"label.please.contact.your.administrator":`请联系管理员，启用生成二维码/条形码的规则`,
"label.sso.saml.sp.idenitysource":`SAML身份位置`,
"label.queue.delete":`删除`,
"label.service.miniProgram.jumpLink":`跳转链接`,
"label_set_ forecast_scope":`设置预测范围`,
"label.weixin.success.sign":`已经成功签到来现场,请知晓。`,
"front-dialog-module-v1-error-code":`错误码`,
"label.projectManagement.nodata.problem":`太棒了，没有棘手的问题需要解决`,
"label.myhomepage":`我的首页`,
"label.exchange.sync.state.task.m1":`上一同步活动：`,
"label.pw.config":`请输入确认密码`,
"front-console-new-contact":`新建联系人`,
"label.customfields.fielddependency.editexplain":`<li>双击某个单元格，以切换显示在列标题中的控制字段值的可见性。</li><li>要同时更改多个单元格，请选择多个单元格，然后单击包括值"或"排除值"按钮，以同时更改选定的全部单元格的可见性。</li><li>按住 Shift 键单击选择一系列相邻的单元格。按住 Ctrl 键单击选择多个不相邻的单元格。</li><li>使用"预览"按钮可对结果进行测试。 </li>"`,
"setup_mainpage_label_welcome7":`操作指导： 点击本页左侧菜单 → 应用程序设置 → 创建 → 对象 → 对象名 → 自定义字段。`,
"message.validation.sum":`批准页面布局上显示的字段选择过多,最多允许约190个字段`,
"label.knowledge.attach.case":`附加到个案`,
"front-electronic-signature-custom-field-type":`自定义字段类型`,
"vue_label_pricebook_activated":`价格手册已启用`,
"vue.schedule.pre":`这是我的日程安排，请您`,
"Lead_Tools_BatchScoring":`潜在客户批量打分`,
"front-lightning-module-v1-details-page-chart-screening-based-on":`筛选依据`,
"label.report.no.recently":`无最近记录.`,
"label.service.gantt.dangerous.sum":`处于危险状态的服务预约数量`,
"label.main.field":`主字段`,
"label.weixin.optionfive":`选项五`,
"homepage.wide":`宽栏(右栏)`,
"vue_label_notice_confirmdelatehomepage":`确认删除主页？`,
"vue_label_report_exportpages":`导出页数：第`,
"label.select_compaign":`选择一个市场活动`,
"attachment.button.massdownload":`批量下载`,
"label.chatter.incident":`事件`,
"label_partner_new_step1":`步骤1：选择您喜欢的模板`,
"button.partner.workspace.saveas.memo":`将当前伙伴云另存为“模板”。`,
"vue_label_pricebook_edit":`编辑价格手册`,
"label.weixin.privacy.rights":`隐私相关权限：大概位置(基于网络)；精确(GPS)位置`,
"label.please.codeType":`请选择码类型`,
"label.approveorrefuserequest":`批准/拒绝请求`,
"message.error.sharemember":`传递的sharemember不能为空，请检查传递的参数！`,
"label.file.folder.edit":`编辑文件夹`,
"label.data.import.setup.repeat.yes":`是-阻止创建重复记录。注意：如果希望更新现有记录，必须选择此选项。`,
"label.approveBeforeTheOperation":`审批前操作`,
"vue_label_file_already_checked_file":`已选择了 {checkedWork} 个文件，最多单次添加10个文件`,
"vue_label_hidden_record_count":`隐藏记录计数`,
"UG_product_01":`列出产品/服务`,
"label.tabpage.clearoptionsz":`清除高级选项`,
"label.partnercloud.num.overstep":`超过伙伴云最大数量`,
"label.tianyancha.businessverify.msg8":`本功能目前仅支持对注册在中国大陆地址的工商企业进行查询，并且有适当的延迟。`,
"Lead_Scoring_DetailedPage_Popup_Title":`潜客洞察`,
"label.emailtocloudcc.email":`电子邮件`,
"vue_label_pool_highcost":`产品成本高`,
"label.callcenter.enterprise.configuration":`请到天润的系统中的企业配置-系统对接中复制密钥对`,
"label.view.edit.search.prompt":`请输入关键字`,
"label.ems.sms":`发短信`,
"label.emailobject.list.new":`写邮件`,
"label.salescloud.forenableteamsales":`启用小组销售`,
"pagecreator.systemstyle.funcpath":`/构建器/品牌化样式库`,
"label.partnerCloud.basicSetting.domain":`一级域名不能为空`,
"label.projectManagement.Posttask":`后置任务`,
"label.tianyancha.businessverify":`启用工商数据验证`,
"label.tianyancha.h5.info":`基本信息`,
"september":`九月`,
"chatter.poll.option9":`选项9`,
"label.department.firstpage":`已经是第一页了`,
"label.reportsSubscriptionPage.condition.button":`添加条件`,
"label.exchange.sync.state.task":`任务`,
"pagecreator.layout.button.splitall":`拆分所有`,
"vue_label_calendar_please_select_the_start":`请选择开始字段`,
"label.tab.message.failtogettop":`获取顶部选项卡失败`,
"label.sharerule.organizationscopesetshare":`组织范围内默认共享设置`,
"label.delete.rules":`删除规则`,
"label.recordtype.tabname.detail":`使用“编辑”按钮以更改此记录类型的属性。使用“选项列表值”相关列表中的“编辑”链接，为此记录类型的记录选择可用的选项列表值`,
"label.knowledge.setting.hint.ten":`不确定事项的组织方式？没问题，您稍后可执行此操作。`,
"vue_label_norm_undone":`此项操作不可撤回`,
"label.trigger.line":`行：`,
"lable.info.queue.reason":`成为成员的原因`,
"label.validate.function.funcExplain.HOUR":`返回日期/时间字段中的小时数，是0至11之间的数字`,
"label.update.document.content":`修改了文档内容`,
"lable.Existing.template":`现有模板`,
"label.summaryreport.step3":`步骤 3：选择汇总信息的分组方式`,
"label.emailmerge.list.filetype":`文档类型`,
"label.customfields.helptext.tip":`当用户悬停在此字段旁的信息图标上时，此文本将显示在详细信息页和编辑页中`,
"label.setting.intergrationlist.description":`通过精确集成，您无需离开CRM即可在业务应用程序之间查看和共享数据。有些集成，如QuickBooks、Zapier需要授予相应权限才能使用户可以使用。有些集成，如Gmail、Outlook等可以由每个用户在自己的帐户上配置。`,
"component_milestones_label_title":`里程碑`,
"label.custom.AntiRevocation":`反撤销`,
"label.mobile.app.new.task":`移动端是否启用App版新建任务事件`,
"vue_label_opportunity_related_chooseproduct":`至少选择一个产品`,
"label.standardguest":`标准来宾`,
"label.icon.125":`仪器`,
"label.skipsomeset":`由于这是跳转起点向导，CloudCC 自动为您选择一些设置。`,
"label.forecast.shrepage.fmanager":`预测经理`,
"label.mobile.quickcreate.default.work":`办公`,
"label.projectManagement.nodata.team.members":`没有找到我的项目成员`,
"label_social_media_account_settings":`社交媒体账户设置`,
"UG.quota.05":`与业务机会双向同步`,
"label.partner.workspace.tab.selectedoption":`已选菜单`,
"front-kefu-moudle-v1-clientID-reinput":`请输入clientID`,
"label.mobile.home.page.contract.value":`预计合同金额`,
"december":`十二月`,
"label.campagin.roi.dcrs":`到场人数`,
"label.currency.edits":`币种编辑`,
"label.currency.company":`公司币种`,
"label.customfields.newformula.nogrammererror":`表达式中没有语法错误。`,
"label.version.nonsupport.api":`暂不支持接口API！`,
"label.data.file.i.title.num2":`2.建议在导入时先导出，以导出文档为数据模板整理导入数据，然后再导入。（导入的数据中如果含有逗号，请使用‘@’符号代替）`,
"front-console-conversation-title":`服务评价`,
"front-kefu-moudle-call":`通话`,
"vue_label_systemSettings_pagefooter":`页脚设置`,
"label.newRule.successfully.added":`新增规则成功`,
"label.trigger.direction.for.use":`平台触发器使用说明[2.0版本]`,
"label.instrumentPanel.maxLabelname":`该值要大于最小值、断点1值及断点2值`,
"label.same.month.report":`同环比报表`,
"label.knowledge.language.american":`美式英语`,
"label.paging.totalof":`共{0}条`,
"label.tianyancha.businessverify.enable.error":`获取是否启用工商数据验证失败，请联系系统管理员！`,
"vue_label_commonobjects_detail_email_template":`使用电子邮件模版`,
"message.error.save.failed":`保存失败！`,
"advancedoptions":`高级选项`,
"setup_object_layout_message_selectedlayoutandrecordtype":`请选择布局和记录类型`,
"label.sendemail.recycle.operatesuccess":`您执行的清空回收站操作已成功,共删除#size条数据!`,
"J":`文本区（长）`,
"message.validation.isnotmail":`输入正确的电子邮件地址`,
"label.timetrigger.before.lasttime":`早于最后修改时间1小时`,
"label.tabpage.arecordtypez":`可用记录类型`,
"label.reportoption":`报表选项`,
"pagecreator.button.next":`下一步`,
"assetbom.transferowner.notpermission":`请联系管理员，您不具有转移资产BOM的权限`,
"label.toptitle.lightning":`Lightning菜单`,
"label.copy.target":`复制目标值`,
"label.productsales.oppor.approach":`临近的业务机会`,
"label.email.template.select":`请选择邮件模板`,
"label.edit.lower.bound.of.discount.per.tier.is.required.":`编辑折扣每1层的下界为必填项。`,
"label.tabularreport.step3":`步骤 3：确定报表中各列的顺序`,
"label.multilang.cchttpservice.signin":`尊敬的{0}您所邀约的{1}活动的客人{2}已经成功签到来现场,请知晓。：`,
"label.appexchange.uninstallpage.message3":`永久删除为此软件包中的所有自定义对象创建的所有数据`,
"label_tabpage_ownedz":`共有`,
"label.tabularreport.2018.step2":`步骤2：选择报表标准`,
"label.object":`对象`,
"template.report.contracted.customers":`签订合同的客户行业分析`,
"label.field.remark3":`请注意，若删除某自定义字段，将删除所有使用此自定义字段的筛选器。可能还会改变依赖自定义字段数据的分配或升级规则的结果。`,
"label.eventview.issms":`是否短信通知`,
"label.knowledge.language.brazilian":`葡萄牙语（巴西）`,
"vue_label_norm_viewfilter":`视图筛选`,
"label.forecast.settings.qijian":`预测期间`,
"label.startuploadfile.step.intruduce":`单击“选择文件”按钮查找文件，并将所选择的文件显示在下方区域`,
"label.smstemplate":`短信模板`,
"vue_label_chatter_no_permission":`您没有权限查看该文件`,
"label.callcenter.Incorrect.data.filling":`数据填写有误`,
"label.tag.search.button":`按标签筛选`,
"label.multiplyselectoptions":`复选框选项`,
"lable.outlook.detail.mutual":`双向同步`,
"label.workflow.estimatecondition1":`当创建或编辑记录且原先未曾达到规则条件时`,
"label.validate.globalvariable.user.profileId":`简档 ID`,
"UG.Campaign.003":`创建市场活动`,
"label.validate.function.funcExplain.ISNULL":`检查表达式是否为空(空白)，如果是则返回TRUE(真)。如果它包含一个值，则该函数返回FALSE(假)`,
"label.setting.intergrationlist.status0":`集成状态`,
"label.copy_error":`复制失败`,
"label.connectOtherNone":`选择的对象没有可以进一步关联的对象。`,
"label.bmap.beijing":`北京`,
"front-kefu-moudle-v1-hxzxybsc-again":`环信坐席已被删除，请重新关联！`,
"label.wei.pollsubject":`投票主题`,
"APPIntegration_Social_twittererror":`必须是一个合法的twitter.com的URL`,
"label.appupload.install.apicannotuse":`api名称仍不可用`,
"label.returntolist":`返回列表`,
"label.translation.start2":`选择一个设置组件。`,
"lable.edit.queue.alter":`请选择队列支持的对象`,
"label.campaign.channel.step3":`步骤3：营销渠道注册页面字段选择`,
"label.data.newtemplate.e.seltype":`选择数据导出方式`,
"front-kefu-moudle-hangup":`挂断`,
"label.forecast.forecastroleuserpage.shre.managerandother":`管理员和预测经理可以共享该预测`,
"label.knowledgebase.mark.as.new.version":`标记为新版本`,
"label.conditiontag.lookup":`查找`,
"label.import.page3.importsucceed":`导入成功`,
"label.stdashbord.xsld.condtion":`条件设置`,
"label_emailtocloudcc_redmessage10":`信息已过期，请重新登录`,
"label.event.moveup.1hour":`提前 1 小时`,
"label.chat.topic.page.add.favorite":`在同事圈页面上保存为收藏夹`,
"label.icon.88":`咨询`,
"page_404_label_noresource":`很抱歉，您所访问的资源不存在。`,
"label.quickbooks.refresh":`刷新`,
"front-kefu-moudle-which-getphone-case":`接通电话后创建个案的规则`,
"label.objecttab.edit":`编辑对象菜单`,
"label.data.file.the.trigger":`执行触发器`,
"frame.personinfo.label.personimage":`简档照片`,
"label_tabpage_turnoffsz":`关闭-已转换`,
"label.sendmail.batch.chose":`批量发送电子邮件：选择收件人`,
"label.data.downpage.i_title":`导入数据的步骤:`,
"label.recycle.clearconfirm":`确定要清空吗？`,
"chatter.using":`到此用了`,
"label.batchadd.newbatchpage.list":`批量新增数据列表`,
"pagecreator.systemstyle.button.new":`新建样式`,
"label.notification.serviceappointment.changestate":`{1}{0}状态更改至{2}{3}
`,
"label.weixin.weipollname":`微投票名称`,
"label.tabpage.skip":`跳至`,
"label.edit.field":`编辑字段`,
"label.edit.new.rule":`编辑生成规则`,
"label.approved.receiveApprovalEmail":`接受电子邮件批准请求`,
"label.dashboard.refreshNow":`立即刷新`,
"label.lookup.introduce":`可输入字符进行模糊搜索`,
"homepage.components.newdes":`请确保以下输入的HTML代码有效且格式正确。在组件中写入不适当的HTML代码，可能会使整个主页菜单无法正确显示。`,
"label.role.giveuserrole":`为用户分配角色`,
"lable.opppdt.selPbk.subtitle":`的价格手册`,
"setup_mainpage_label_welcome19":`操作指导： 点击本页左侧菜单 → 管理设置 → 管理用户 → 用户、角色、简档`,
"setup.mainpage.label.welcome22":`操作指导： 点击本页左侧菜单 → 管理设置 → 通讯模板 → 电子邮件模板。`,
"label.tianyancha.h5.zipcode":`邮政编码`,
"label_tabpage_allapplications":`全部应用程序`,
"label.chatter.like":`喜欢`,
"label.licence.noremainder":`许可证剩余数量不足`,
"lable.outlook.edit.dataset":`数据设置`,
"D":`日期`,
"label.detail":`查看`,
"label.globaloperation.operationtype.custom_page":`自定义页面`,
"label.addattachment.down":`下载文件`,
"label.data.exportall.all_btn":`导出全部数据`,
"label.recordtypeselect.current":`当前记录类型`,
"label.tabpage.entercusnamez":`请输入客户名`,
"label.location.valunit.km":`公里`,
"label.mobile.phone.week.plan":`下周计划`,
"vue_label_report_everyday":`每日`,
"label.weixin.broadcasting":`发送中...`,
"label.input.search.string":`请输入搜索的字符串`,
"label.picandreporttype":`图表类型`,
"label.setmulti":`将多个`,
"label.visualpage.component.t":`使用组件 component`,
"label.knowledge.designate":`只有状态为草稿的知识文章可以指派`,
"label.enable.barcode.only":`仅启用条形码`,
"vue_label_commonobjects_detail_a_group_strategy":`该条数据缺少所有人,无法创建群策`,
"setup.layout.group.button":`按钮`,
"label.mini.layout.remark":`应用于前台悬停窗口所显示的布局`,
"setup.mainpage.label.welcome3":`CloudCC 云平台中建立表单依靠自定制数据库（对象）来实现，用户定义对象是一些数据库表格，用于存储贵组织特有的数据。无需任何程序开发的情况下，还可轻松建立表与表间的关系。`,
"label.knowledge.draft.status":`知识文章发布状态必须为草稿`,
"label.manageAll.sel.one1":`待审批的项目`,
"label.campagin.roi.bhydkhywjh":`赢得客户业务机会数`,
"label_partner_template_thumbnail":`缩略图`,
"label.loginip.setup":`登录Ip范围`,
"label.data.downpage.e.title.e.btn":`进入导出页面，开始导出`,
"vue_label_appstore_project_management":`项目管理`,
"assetbom.delete.notpermission":`请联系管理员，您不具有删除资产BOM的权限`,
"vue.dashboard.setdrill.inThe":`中的`,
"label.mobile.more.savephoto":`保存图片`,
"label.customerinfo.PageTriggerFag":`自定义类、触发器、自定义页面同步`,
"label.commonobjects.Nopermission":`抱歉，您无权编辑此条数据，请联系系统管理员`,
"label.searchlayout.opperationtab.xsldfield":`点击业务机会菜单下的销售漏斗链接显示的视图字段。`,
"label.emailsync.form.disconnect":`取消关联`,
"label.document.nofile.upload":`没有文件上传。`,
"label.appointmentpage.wizard.subtitle3-3":`电话号码`,
"message.custom.field.donotdelete":`字段被使用不能删除`,
"chatter.using0":`到此用了{0}ms`,
"label.tabpage.multiple":`多项选择`,
"label.attendance.setting.sy.alert":`考勤必须选择适用人员!`,
"label.refuse":`拒绝`,
"label.log.button":`根据用户名搜索`,
"component_chatter_link_label_title":`链接`,
"template.report.contract.collection":`合同收款`,
"label.campaignmember.selectmember.step1":`步骤1：选择市场活动和市场活动成员 状态`,
"label.datamanage.warn.owner":`警告：如果继续进行本次导入操作，则会以您作为记录所有人导入所有记录。`,
"label.a.b":`A 到 B 关系`,
"label.app.step3.homeisfrist":`主页必须是第一位`,
"UG_Lead_003":`社交`,
"label.partner.workspace.member.choice":`选择简档`,
"lable.outlook.detail.emaping":`事件字段映射`,
"label.service.appointmentList.gantt.chart.shows":`甘特图显示日期`,
"label.mr.caption.account.result":`查重合并：查询客户重复数据的结果`,
"vue_label_chatter_approve_members_join":`批准成员加入小组`,
"label.reportsSubscriptionPage.schedulereport.monthly.day":`天`,
"pagecreator.systemstyle.label.modifycolor":`编辑颜色`,
"label.tabpage.yesz":`是`,
"label.fieldtoolongmessage":`字段超出限制`,
"lable.account.year.name":`会计年度名称`,
"label.mini.layout":`悬停页面布局`,
"label.icon.97":`教学`,
"vue_label_chat_smart_assistant":`智能小助手`,
"label.marketingmanagementuser":`市场营销用户`,
"label_emailtocloudcc_description2":`关联您的企业邮箱`,
"label.campaign.channel.input.name":`1.请输入营销渠道名称:`,
"UG.homepage.007":`从发送跟进邮件到销售活动自动化，从使用我们的蓝图科技创建工作流到触发定制的宏，自动化日常任务，并更专注于建立关系。`,
"label.share":`共享`,
"label.step2.total6":`第2步，共6步`,
"label.sendemail.chat.addComentspraise":`尊敬的#name:\n\n    您好！#userName回复了您喜欢的微贴。`,
"label.icon.20":`档案`,
"label.service.gantt.absenteeism":`缺勤`,
"message.error.color.nagatice":`当前页数不能为负数`,
"chatter.group.applyToJoin":`申请加入`,
"pagecreator_layout_message_delete":`是否删除当前所选布局？`,
"label.multilang.viewlist.count":`共{0}条记录`,
"message.notdesable.type":`无法禁用此记录类型，因为以下简档使用此记录类型作为默认值。`,
"label.standard.time":`标准时间`,
"label_chatter_newpost":`最新帖子`,
"front-epwechat-module-v1-binding":`绑定企业微信`,
"label.recent":`最近`,
"label.globaloperation.createfeeditem":`创建摘要项目`,
"label_partner_common_roleNum":`角色数量`,
"front-template-V1-quikSearch":`输入字段名，快速搜索`,
"label_tabpage_haschangedz":`该潜在客户已经转化`,
"label.service.work.order.line":`工作订单行项目`,
"label.lead.score.ok":`好的`,
"Account_News_Setting_003":`一般设置`,
"label.event.moveup.15minutes":`提前 15 分钟`,
"vue_label_all_selected_objects":`全部已选对象`,
"label.visualpage.an.inline.style.relatedlist":`为相关列表内嵌自定义页面类型`,
"label.umeng.approval.approvaling":`#applyer正在请求批准#obj#objname#owner`,
"lable.SalesCommitmentKanBan.digital":`数字`,
"label.appupload.img.max.size":`上传图片过大，图片最大不应超过20K。请重新上传。`,
"vue_label_normal_top":`置顶`,
"label.knowledge.language.traditional":`繁体中文`,
"homepage.layout.edit":`编辑主页布局`,
"label.campagin.qrcode":`市场活动二维码`,
"label.emailmerge.merge.emailmerge":`邮件合并`,
"label.icon.18":`时钟`,
"vue_label_homepage_taskview":`任务视图`,
"label.search.related.record":`没有找到相关记录。`,
"label.report.reports":`报表`,
"label.appointment.wizard.subtitle4-3-2":`15分钟`,
"label.forecast.condition":`预测条件`,
"label.westem.indonesia.time":`西印度尼西亚时间`,
"front-epwechat-module-v1-callback-desc":`需要您将以下信息复制到企业微信后台`,
"label.version.group":`团队版`,
"label.allReportType":`所有自定义报表数据源`,
"label.trigger.lastmodifydate":`上次修改时间`,
"message.layout.unique.sectionfield":`违反页面布局中字段的唯一约束，请确认后重新保存!`,
"vue_label_systemSettings_mobelbottonsetting":`移动端底部菜单设置`,
"label.recordtype.selectonefield":`选择要新增的字段,至少选择一个字段。`,
"label.notification.group1":`【申请人】正在申请加入您的公用小组`,
"component_todaytask_label_title":`今天的任务`,
"label.assignment.setup.list.description":`使用分配规则可以自动将记录发送给相应的用户。分配规则由定义于记录上的条件和多条规则条目组成。`,
"label.project.resource.data":`此服务资源已分配到服务预约，请勿重复添加`,
"label.emailmerge.newtemplate.file":`文件`,
"label.notification.task1":`【分配人】已为您分配任务`,
"label.ServiceCloud.Overlapping":`重叠显示派工`,
"label.globalselect.used":`字段使用位置`,
"setup_layout_button_layoutprop":`布局属性`,
"label.quickbooks.retrivingdata":`正在获取数据...`,
"component.button.ok":`确定`,
"message.pleaseinputformula":`请输入公式`,
"label.h5.whatifollow":`我关注的`,
"label.new.crew.target":`新建人员目标`,
"label_chatter_task":`任务`,
"label.knowledge.setting.data.four":`最多选择{count}个分类组！`,
"label.rule.not.enabled":`未启用规则`,
"label_in_scope":`在范围中`,
"label.partnerCloud.orderingPlatform.bundle":`捆绑包`,
"label.emailtocloudcc.redmessage10":`信息已过期，请重新登录`,
"label.knowledgebase.data.assignment.succeeded":`{a}条数据指派成功`,
"vue_label_commonobjects_view_nokanban":`暂无已创建的看板视图`,
"label.knowledgebase.article.cancelled.attaching.case":`文章 {name}已取消附加到个案！`,
"label.brief":`简报`,
"label.version.sum.app":`个应用程序`,
"label.commoninfo":`一般信息`,
"vue_label_SMS_nodata":`暂无数据`,
"label.icon.153":`信息`,
"label.conditiontag.lookup.false":`假`,
"label.emailobject.view.unread":`全部未读`,
"label.staticresource.useful":`用于何处?`,
"label.ems.connect.test":`检测`,
"vue_label_chat_group_assistant_notification":`群助手通知`,
"label.multipleactivity.total":`总计`,
"vue_label_report_addtocomponentlibrary":`添加到组件库`,
"font-evaluate-module-v1-following-personnel":`收到3分以下评价时，通知以下人员：`,
"label.setup.mobile.bottombutton.change.fail":`修改失败`,
"front-epwechat-module-v1-unbound-item5":`并且数据无法找回，请确认是否要解绑？`,
"label.customerinfo.smsUid":`短信网关UID`,
"label.list.isOpenApprovalQueue":`是否开启审批队列(手动选择审批人状态下无法使用)`,
"label.leadscore.setup.scorenumber":`次`,
"label.workflow.selectobj.introduce":`选择该工作流规则所要应用到的对象`,
"label.visualpage.label.for.example":`页面标签如:`,
"label.appointmentdetail.wizard.title17":`周四时间规划`,
"label.projectManagement.timeFrame":`任务的开始时间和结束时间要在里程碑的时间范围内`,
"lable.product.pricebooks.list":`价格手册是具有特别定义的单价和币种的产品列表.价格手册可针对多币种进行设置.在将产品组织放入价格手册中时,记住业务机会或报价只能包括单个价格手册中的产品.如果要编辑价格手册中的产品,请点击价格手册名称。`,
"font-trade-module-v1-delete-invoice":`核销发票`,
"vue_label_salesadvance_winamount":`赢单总金额`,
"component.salesperformance.label.nopermission":`请联系系统管理员查看业务机会相关数据。`,
"vue_label_report_formatreport_desc":`导出报表，其中包含报表标头、分组和筛选设置。`,
"label.enable.qrcode.only":`仅启用二维码`,
"label.smstemplate.edit":`编辑短信模板`,
"label.qrcodeSetting.detailed.information":`QR码比较普通条码可以存储更多数据，也无需要像<br />普通条码般在扫描时需要直线对准扫描仪。因此其<br />应用范围已经扩展到包括产品跟踪，物品识别，文<br />档管理，营销等方面。`,
"label.event.moveup.1week":`提前 1 星期`,
"label.customize.memory.function.sorting.disable":`禁用视图表头排序记忆`,
"label.icon.195":`浴缸`,
"label.compact.layout.assign":`关键信息布局分配`,
"label.icon.183":`房子`,
"front-kefu-moudle-v1-jchxzxzi-chat":`集成环信在线坐席聊天功能以提供更加全面的SaaS服务。`,
"label.mycontact":`我的联系人`,
"label.tabularreport.2018.step3":`步骤3：选择报表标准`,
"chatter.group.uploadGroupPicture":`上传小组头像`,
"label.total.forecast.setup":`优先预测并将其设置为`,
"label.weixin.group.description":`备注`,
"label.edit_emailfooter":`编辑邮件页脚`,
"label.ems.create":`新建`,
"label.weixin.optionseven":`选项七`,
"font-evaluate-module-v1-continue-work":`您的评价激励了我们！我们会继续努力！`,
"label.close.multilingual":`禁用多语言`,
"component.chatter.post.button.user":`添加人员`,
"label.use_QRcode":`使用二维码`,
"label.operatedata.exportsuc":`导出成功，请登录您的邮箱查看您的导出文件下载地址，导出的文件将会为您保存48小时，请尽快下载。注意保护您的链接地址，建议您下载完后删除系统发送给您的邮件`,
"label.page.step2.define.content":`步骤2：定义内容和显示属性`,
"label_tabpage_groupingitem":`分组项目`,
"label.customfields.placeholder":`填写示例`,
"vue_label_commonobjects_detail_enter_subject":`请输入主题`,
"label.multilang.workflow.everyotherdayinmonth":`每{0}月{1}天`,
"label.knowledgebase.data.archiving.failed":`{a}条数据归档失败`,
"vue_label_notice_nopermission_view":`抱歉，您无权查看该条数据，请联系系统管理员`,
"vue_label_calendar_calendar_view":`日历视图`,
"lable.outlook.edit.des":`如果某个 Exchange 联系人与多个 CloudCC.com 联系人匹配，将其与符合下列条件的 CloudCC.com 联系人同步`,
"label.custom.NextCQ":`下一个自定义季度`,
"label.emailsync.form.stutas":`启用状态`,
"label.nameandintro":`名称和说明`,
"label.dashboardSetup.showdw":`显示单位`,
"label.tianyancha.actualcapital":`实收注册资金`,
"front-kefu-moudle-info-delete-calluser":`信息已被修改，请联系管理员`,
"label.emailobject.list.all":`全选`,
"label.campaign.channel.step7.send":`选择需要发送邮件的人员`,
"label.formulafield.type":`公式返回类型`,
"label.reportsSubscriptionPage.schedulereport.weekly.thursday":`星期四`,
"label.chosesubject.eat":`约吃饭`,
"label.back":`返回`,
"label.h5.allcompany":`全部云帖`,
"label.location.display.type.digital":`数字`,
"label.datamanage.error.csv":`不正确的文件格式，系统只支持通用的CSV格式，请重新操作`,
"label.emailobject.mark":`标记`,
"setup_mainpage_label_welcome9":`用户无需代码开发的情况下，通过鼠标拖拽的方式，便可实现所有页面元素的分类显示、布局调整。以及对页面上字段的只读、必填等属性的设置。`,
"label.icon.56":`测量仪`,
"label.forecast.edit.fwcd":`范围长度`,
"vue_label_email_Please_select_related_items_first":`请先选择相关项`,
"label.icon.87":`书`,
"label.knowledgebase.recovery.was.successful":`恢复成功`,
"label.emailobject.emaildetail.promptcontent":`是否确认删除此邮件？请注意，此删除操作不可撤销`,
"label.delete.role":`删除角色`,
"label.multiselect":`可多选的选项列表`,
"label.customerinfo.mailisnull":`未设置公司发件邮箱`,
"label.waitforamoment":`页面装载中，请稍候...`,
"lable.edit.queue.tip":`输入发送通知时（例如已将个案放入队列时）要使用的队列名和电子邮件地址，电子邮件地址可不填写，将不通知。若选择“向成员发送电子邮件”，向队列分配对象时，将通知队列成员，不选择不通知。`,
"lable.custom.y.d":`此页允许您定义一个自定义年度记录。自定义年度的日期将根据您下面所进行的选择生成。`,
"chatter.feed.content.user.searchbutton":`搜索`,
"label.data.downpage.i.list.desc3":`用户下载后，可以在文件最后一列查看导入失败的具体原因。`,
"label.tag.manage.createdby":`创建人`,
"label.h5.similar.opportunity.last.months3":`最近3个月`,
"chatter.group.members":`位成员`,
"label.knowledgebase.data.translation.failed":`{a}条数据翻译失败`,
"label.log.look":`查看设置审计线索`,
"label.service.gantt.week.timescale":`周视图上显示的时间刻度：`,
"label.userLicence":`用户许可证`,
"label.file.library.managemembers.permission":`访问权限`,
"label_emailtocloudcc_name":`名称`,
"label.mr.mrSuccess":`合并成功`,
"vue_label_commonobject_view_notice_selectadd":`请选择要添加的数据`,
"vue_label_commonobjects_detail_level":`层级`,
"CloudCCCRM_ST_Info_TypeIn_001":`请输入`,
"label_chatter_list":`列表`,
"label_tabpage_optionsz":`选项`,
"UG_homepage_008":`了解目前业务状态（销售简报，排行榜，销售漏斗等），查看可能存在问题的业务机会，预测未来业绩达成情况，及时受理和分派重要事项，做出明智决策。`,
"label.myselfdashboard":`我的个人仪表板`,
"label.globaloperation.operationtype.record_phone":`记录电话`,
"label.field.standard":`标准字段`,
"label.changemydisplay.appedit.check":`覆盖用户的个人自定义应用程序自定义设置`,
"label.tianyancha.h5.legalpersonnames":`法人代表`,
"label.tabpage.sorttypez":`排序类型`,
"label.newdashboard.folder":`新建仪表板文件夹`,
"label.campaign.channel.step6":`步骤6：营销渠道注册页面生成`,
"label.ems.composeemail":`发邮件`,
"label.app.step4.tabcanuse":`可用菜单`,
"label.sendmail.batch":`批量发送电子邮件`,
"label.process.execute.title":`正在进行审批`,
"lable.outlook.detail.lastup":`最后更新`,
"label_emailtocloudcc_delete":`删除`,
"lable.opppdt.selPdt.leastone":`请至少选择一条`,
"label.customfields.new.step2.opration.exid":`外部ID`,
"label.assignment.setup.newrule.description":`输入规则名，然后选取已启用"复选框，将此规则用于自动分配。启用此规则将禁用当前的分配规则。"`,
"label.campaign.channel.input.to.isactivity":`7.是否启用营销渠道`,
"label.document.return":`返回文档页面`,
"label.data.downpage.i_title.num5":`5、请审核数据的准确性。`,
"label.taskinto":`自动将任务分配给用户时，任务是工作流规则使用的模板。`,
"label.customfields.formula.textexample":`Full Name（全名）= LastName &amp; ", " &amp; FirstName`,
"label.appointmentpage.wizard.subtitle1-1":`下一周`,
"label.weixin.radio":`单选`,
"vue_label_file_replace_reason_check":`替换原因（选填）`,
"label.sendemail.recycle.operateexception":`您执行的清空回收站操作出现异常，请重试!`,
"label.vlidaterule.formulaerror":`如果“折扣”大于30%，则显示错误`,
"vue_label_campaign_existing_member_status":`保留现有成员状态`,
"label.service.miniProgram.fillSlideshowName":`请填写轮播图名称`,
"label_partner_workspace_login_headerfooter":`页眉和页脚`,
"label.quickbooks.viewlist.total2":`共计{0}个概算，共{1}`,
"chatter.viewingResults":`查看结果`,
"label_tabpage_allvisible":`所有用户皆可见`,
"label.quote":`报价单`,
"label.changemydisplay.list.des":`根据需要配置菜单`,
"label.leadscore.notimes":`打分次数已满`,
"label.icon.51":`发电`,
"component.assistant.label.title":`助理`,
"label.emailobject.emailsent":`邮件发送成功！`,
"label.group.nofile":`没有文件发送到该小组。`,
"label.foldervisitlimit2":`所有用户均不可见此文件夹`,
"label.dataoperate":`数据操作`,
"label.addattachment.size":`大小`,
"label.not.double":`不允许重复值`,
"label.customfields.formula.number.tip":`计算数字值`,
"lable.opppdt.addpdt.table.description":`行描述`,
"label.sms.isactivity":`是否启用`,
"label.campaign.channel.input.owner":`4.从此营销渠道注册的潜在客户的所有人是：`,
"label.visualpage.notfound.error":`发生未知错误，请联系管理员处理`,
"label.mr.title.button.group3":`条记录`,
"label_tabpage_beginz":`开始`,
"label_tabpage_queue":`队列`,
"label.tabpage.advancedscreening":`高级筛选条件`,
"nogreate":`小于或等于`,
"chatter.fields":`的字段`,
"button_partner_workspace_manage":`管理`,
"label.partnerCloud.orderingPlatform.search":`搜索产品`,
"message.password.isnull":`密码不能为空！`,
"label.fenbeitong.title":`分贝通设置`,
"label.salescloud.contactrole.message.chooseatleastone":`请至少选择一个联系人`,
"label.knowledge.delete.election":`删除数据分类选择出错`,
"front-console-status-hoided":`已搁置`,
"label.lastmodifydate":`最后修改时间`,
"vue_label_chat_deleting_chat":`删除后将清空聊天记录并从群策列表上移除。接收新消息时，会再次出现在群策列表处。`,
"label.timeframe":`时间帧`,
"UG.opportunity.002":`定义您的销售周期 配置阶段`,
"label.templates.merge":`请选择要合并的模板，最多20个`,
"label.generatepage.c2":`最大长度为30`,
"label.appointment.wizard.subtitle4-1-6":`2小时`,
"label.passwordPolicy.setup.pwdremember3":`记住3个密码`,
"button.partner.workspace.enable":`启用伙伴云`,
"vue_label_pool_nopool_notice":`您暂未加入到任何公海池中，请联系管理员创建或加入公海池。`,
"label.layout.required.field.select":`已选必填字段`,
"label.loginhis.date":`请输入开始时间和结束时间`,
"vue_label_commonobjects_detail_and_overdue":`即将到来和已逾期`,
"label_tabpage_advancedsearch":`高级搜索`,
"label.custom.field.login.home.query":`请进入系统主页浏览任务详细信息！`,
"page":`页面`,
"label_tabpage_onlymevisible":`仅对我可见`,
"label.weixin.optionfour":`选项四`,
"label.confirm.to.remove":`确定移除`,
"label.event.moveup.30minutes":`提前 30 分钟`,
"label.mail.merge.template.finish":`邮件合并模板已完成`,
"label.multilang.currencylist.before":`{0}之前`,
"label.goback":`返回上一步`,
"label.unknown.prefix":`未知的前缀，请输入正确的前缀`,
"lable.account.CurrentandPreviousCYt":`当前和前两个日历年度`,
"label.product.dent":`输入关键字和筛选条件，然后单击搜索开始搜索。单击更多筛选器"以使用一个以上的筛选器。搜索结果包括与所输入关键字和筛选条件匹配的所有记录。"`,
"label.ems.bcc":`添加密送`,
"label.import.index.operation":`操作`,
"label.knowledge.setting.hint.eight":`井井有条！`,
"label.sso.saml.sp.idtype.fid":`声明包含来自用户对象的联盟ID`,
"vue_label_chat_voice":`语音`,
"label.config.pw":`确认新密码`,
"lable.newtabpage.closesearchresult":`收起搜索结果`,
"lable.account.NextWeek":`下星期`,
"label.ems.username":`用户名（U）`,
"vue_label_email_emails_from_potential":`您CRM中的潜在客户、联系人发来的邮件，以及收件人中包含他们的邮件，都会被归类到这里`,
"lable.approval.shared":`审批共享`,
"label.tabpage.allz":`所有`,
"label.file.uploadfiles":`上传文件`,
"label.emailobject.text":`名称`,
"label.version.allow.create":`允许创建`,
"label.empty.field":`字段不能为空`,
"label.emailsync.status.department":`部门`,
"label.pw.str":`5个字符`,
"label.attendance":`考勤`,
"label_mobile_buttom_team":`群策`,
"label.campaignmember.main.addcontactdesc":`一次将所有现有联系人添加到这个市场活动`,
"label.search.result":`搜索结果`,
"label.weixin.activity.account":`活动的客人`,
"label_tabpage_clearoptionsz":`清除高级选项`,
"UG.activity.01":`您如何跟踪记录与您的客户/团队互动?`,
"serviceappointment.new.status.limit":`无法创建状态为已计划或已派遣的新的服务预约`,
"label.notice.higher":`是否通知上级`,
"label.passwordPolicy.setup.gletters":`个字符`,
"label.data.exportsf.des":`导出成功的文件将在服务器上保留48小时，48小时后将自动删除。`,
"label.view.onlymecansee":`仅对<b>我</b>可见`,
"UG.Lead.005":`邮箱`,
"label.umeng.approval.approvalfail":`提交失败`,
"label.huanxinconfig.clientid.lost":`clientid不能为空`,
"label.campaignmember.main.updatecontactstatus":`更新状态-现有联系人`,
"component_chatter_button_delete":`删除`,
"label.weixin.no.pending.projects.qin":`亲,目前没有待审批的项目`,
"front-electronic-signature-auto-fill-field":`自动填充字段`,
"message.resetpw":`确定要重新设置密码？`,
"label.service.ganttBaiduMap.service.resourname":`服务资源名称`,
"vue_label_pricebook_deleted":`价格手册已删除`,
"label.icon.193":`浴缸`,
"label.validate.function.funcFormat.NOT":`NOT(logical)`,
"label.address.city":`城市/城镇`,
"label.pc.ui.2018.searchs":`请输入搜索内容`,
"label.yard":`邀约码`,
"label.data.downpage.i_title.btn":`进入导入页面，开始导入`,
"label.useablereceivers":`可用接收人`,
"label.cloudccsite.name.length":`站点名称不能超过255个字符`,
"label.secrecy":`保密`,
"label.campagin.roi.ydkhywjhzz":`赢得客户业务机会总值`,
"vue_label_report_conditiondesc_one":`除了订阅外，您可为此报表设置条件。您将在满足条件时获得通知。这是可选项。`,
"label.datamanage.select.contactfield":`（选择导入联系人所对应的字段）`,
"label.emailtocloudcc.filed.action":`操作`,
"label.smstemplate.new":`新建短信模板`,
"label.mobile.side.tab.app":`应用程序`,
"label.icon.118":`时钟`,
"label.customfields.selectcontainfieldlayout.tip":`该字段将作为最后一个字段添加到这些页面布局的前 2 列。如果不选择布局，该字段在任何页面上都不会显示。`,
"Lead_Homepage_Tools_BatchScoring":`批量打分`,
"lable.quote.syncing.quote":`报价单`,
"pagecreator.button.preview":`预览`,
"label.ccchat.am":`上午`,
"chatter.feed.menutype.user.nullrecent":`无最近记录`,
"lable.info.queue.showallmember":`查看队列成员`,
"label.multilang.campaign.selelctmember.desc":`选择一个视图，然后选择成员以添加到市场活动中,成员状态为{0}`,
"label.notification.ccchat3":`您的微贴有1条新回复`,
"UG.product.03":`多币种支持的价格手册`,
"label.sso.saml.idp.config.pksize":`密钥大小`,
"label.defineCustomReportType":`定义自定义报表数据源`,
"component.timeline.button.filter":`筛选`,
"label.mr.nextGroup":`跳过该组，前往下一组`,
"label.quote.sprdz":`收票人地址`,
"label.total.refuse.forecast.have.priority":`拒绝所有预测优先`,
"lable.product.peep":`清输入有效价格`,
"label.file.who.can.access":`谁可以访问`,
"label.page.last":`最后一页`,
"label.icon.180":`人`,
"font-evaluate-module-v1-enabled-successfully":`评价选项“一般”启用成功`,
"label.appointment.wizard.subtitle4-2-2":`2小时`,
"label.passwordPolicy.setup.oneyear":`一年`,
"label.login.bound.mfadevice.title":`启用虚拟MFA设备`,
"vue_label_dashboard_statisticalvalue":`请选择统计值`,
"label.ishistory":`的历史`,
"component.timeline.label.title":`时间轴`,
"label.page.step3.of.step5":`第3步，共5步`,
"label.assignment.setup.detail.section":`规则详细信息`,
"label.salescloud.opportunity.nothave.main.contactrole":`没有主要联系人`,
"label.import.page1.limitedcsv":`上传文件只能是csv格式!`,
"label.icon.187":`锤子`,
"label.emailobject.wizard.desc5":`定制您的签名，让邮件看起来更美观。`,
"vue_label_report_notice_copy_success":`复制报表成功！`,
"label.dupicatecheck.repeatcondition.chooserulemsg":`您还没有选择查重的规则.`,
"label.componentEditor.upper.limit":`上限100`,
"label.validate.function.funcExplain.ISNEW":`检查记录是否是新的，如果是新的，则返回TRUE 。否则返回 FALSE。`,
"label.postalCode":`邮政编码`,
"label.dashboard.snapshot.enable.flag":`启用仪表板快照`,
"vue_label_file_upload_type_size":`只能上传{fileType}文件，且不超过{size}Mb`,
"label.appointment.wizard.subtitle3-6":`周六`,
"homepage.narrow":`窄栏(左栏)`,
"chatter.addmute.confirm":`是否确定将该帖子免打扰?`,
"label.lookup.account":`查找客户`,
"message.lostthemanager":`此提交需要用户的经理审批,此值为空。详情，请与您的管理员联系。`,
"label.exchange.sync.state.contact.m3":`在最后24 小时同步的记录：`,
"label.version.phone.app":`手机APP版`,
"label_tabpage_search":`搜索`,
"vue_label_helpcenter_campaign":`在详细信息中，点击市场活动旁边的树状图按钮，可以查看市场活动层次结构图，了解市场活动的父子层级关系。<br>通过市场活动成员相关列表，管理市场活动涉及到的联系人或潜在客户。`,
"front-lightning-module-v1-dashborad-last-year":`去年`,
"label.campaign.channel.value":`值`,
"vue_label_opportunity_contactrole_primarycontact_notice":`若想选择主要联系人，请保存此步骤后在“管理”中进行选择。`,
"label.biaoqingfaxian.title":`标情发现`,
"label.approved":`已批准`,
"label.hong.kong.time":`香港时间`,
"label.customfields.file.cannotopen":`无法打开此文件`,
"lable.New.tips":`点击“新建”，以根据标准模版或其中一个模版创建服务报表模版。启用后即可使用模板`,
"component.setup.tabs.label.add":`新增`,
"label.forecast.forehistory.replacebest":`超常发挥被替代`,
"front-kefu-moudle-v1-jctrrt-call-serve":`集成天润融通的呼叫中心以提供更全面的SaaS服务`,
"label.workflow.configrule":`步骤 2：配置工作流规则`,
"label.dashboard.snapshot.refresh.frequently":`仪表板快照刷新太频繁，请稍后再试`,
"label.ems.editsetting":`编辑邮件设置`,
"message.confirmdeleteAPP":`您将要删除此应用程序。`,
"label_chatter_activity":`活动`,
"label.editsharerules":`编辑共享权限`,
"label.loginservice.license.notuse.must":`许可证目前不可用，您必须在`,
"label.import.step2.beforeexport":`1、导入之前，请先确保导入其相关的所有记录。例如：如果您当前导入的对象与联系人之间存在查找关系，请先导入这些联系人，然后再导入您的数据。`,
"label.chat.mute":`免打扰`,
"label.icon.128":`房子`,
"label.give":`&&与`,
"label.hide":`不显示`,
"label.relationobject.wpr":`委派人`,
"label.summation":`总和`,
"label.layout.availabletab.details":`详情信息`,
"label.circle":`圈形`,
"vue_label_opportunity_contactrole_add":`添加联系人角色`,
"label.file.library.file2libsuccess":`成功加入文件到该库！`,
"label.weixin.report.reportgenerated":`已生成报表`,
"label.icon.91":`人`,
"report.label.pleaseinput":`请输入搜索内容`,
"label.escalation.setup.newaction.otheremail.tip":`您最多可输入5个要发送的电子邮件。每个地址间使用逗号分隔`,
"label.area.donot.have.data":`没有数据`,
"label.customcomponent.btn.reference":`组件引用`,
"label.appointmentdetail.wizard.title7":`最晚日程提醒时间`,
"label.ccchat.with":`具有`,
"label.file.size":`大小`,
"label.product.sort.beyond":`最多支持设置十级！`,
"label.ccchat.2018":`动态`,
"label.report.select.column":`选择列`,
"label.appointmentpage.wizard.subtitle1_1":`请选择日期和具体时间`,
"label.passwordPolicy.setup.uppercasealpandnumsymbol":`必须包含大小写字母数字及符号`,
"label_chatter_addressee":`收件人`,
"label.profile.remark2":`如果贵组织使用记录类型，请使用以下“记录类型设置”部分中的“编辑”链接，使此简档的用户可以使用一个或多个记录类型`,
"UG_Account_01":`您的客户是谁?`,
"label.dataimport.error.contact.notnull":`出现错误：联系人姓名不能为空。`,
"lable.account.CalenderQuarter":`日历季度`,
"vue_label_commonobjects_detail_empty":`销售价格不能为空`,
"label.approveassigntemplate":`批准分配电子邮件模板`,
"label.objectRelationshipDescription1":`此报表数据源将生成有关`,
"vue_label_email_insertmergefield":`插入合并字段`,
"label.mobile.home.page.check.team":`查看团队`,
"lable.edit.queue.edit":`编辑队列`,
"label.campagin.roi.query":`查询市场活动ROI`,
"label.dataimport.field.allow.access.to":`数据字段不允许访问，请手动删除对应的记录后重试`,
"pagecreator.systemstyle.message.canntdelete":`当前样式不允许删除`,
"label.searchkey":`请输入关键字`,
"chatter.showall":`显示全部`,
"show":`显示`,
"label.quote.choseproduct":`选择产品`,
"label.report.selected.field":`选中的字段`,
"label.globaloperation.operationtype.create_data":`创建记录`,
"label.knowledge.setting.data.seven":`删除分类组：{flzmc}`,
"chatter.email.mentionOrMessage":`提及或消息`,
"label_tabpage_exclusivez":`不包含`,
"chatter.en.userinfo":`输入有关您的信息`,
"label.log.orgid":`机构`,
"label.dataimport.insertdata.error.fieldrepeat.update":`该记录中的$schemefield_name$字段在数据库中的查找不到,无法进行更新操作，该记录已忽略导入。`,
"vue_label_chatter_add_link_success":`添加链接成功`,
"label.sender_details":`添加新发件人信息，创建用户于您的`,
"label.ccpeak.addwhere.condition":`可加where条件`,
"label.datamove.total":`共有`,
"label.tianyancha.businessverify.warning":`请注意，此验证仅支持中国大陆注册的工商企业数据。`,
"label.emailmainbody":`邮件正文`,
"label.justadmin":`仅限管理员`,
"label.data.downpage.e.list.desc1":`此页面显示的数据为导出成功的文件，请您根据邮件中提示的信息及时下载您导出的文件。`,
"label.reportsSubscriptionPage.email.value":`可用值`,
"message.error.serviceappointment":`请先在服务预约上填写已计划开始时间和已计划结束时间`,
"label.textMessageObject.selectone":`请至少选择一条记录作为短信的收件人`,
"label.schedulejob.setup.schedule.plan":`计划`,
"label.assignment.layout.field.isassigned":`使用有效的分配规则进行分配`,
"label.captcha.error":`验证码错误！`,
"mobel_web_not_more_data":`暂无更多数据`,
"label.emailsync.form.emailaddress":`邮箱地址`,
"label.loginservice.error":`登录出错了，请联系管理员`,
"label.integrations.description":`将您的CloudCC账户连接到企业软件生态系统中的其他应用程序`,
"vue_label_homepage_notice_selectone":`请选择至少一位潜在客户或联系人`,
"label.chatter.default":`默认`,
"label.tabpage.datefield":`日期字段等于时可以使用“昨天”，“今天”，“明天”，“上个月”，“本月”，“下个月”，“上星期”，“本星期”，“下星期” 或 “YYYY-MM-DD、MM/DD/YYYY”格式。`,
"front-kefu-moudle-myzdhsc-file":`没有找到或没有生成录音文件`,
"label.createname":`创建人`,
"label.mobile.phone.enter.plan":`这里输入计划`,
"report.label.highlevelreport":`高级报表可以帮您创建最多4个对象关联的报表`,
"label.edit.select.label":`编辑方式`,
"label.partnerCloud.financeSetting.deduction":`启用后，会添加返利帐户、返利收入、返利支出对象，合作伙伴用户在下单结算时可以使用返利帐户内的余额抵扣金额`,
"message.duplication.label.updateoption":`更新时操作`,
"label.custom.CurrentCQ":`当前自定义季度`,
"front-kefu-moudle-wait":`等待`,
"sunday":`星期日`,
"label.service.timezone":`时区`,
"setup.layout.label.selectfield":`字段选择`,
"label_emailtocloudcc_filed_action":`操作`,
"label.forecast.customforecast.mycommit":`我的承诺额`,
"label.uploadsuc":`上传成功`,
"vue_label_commonobjects_view_notice_atleast1field":`最少选择1个展示字段`,
"label.dataimport.khmc.length":`出现错误：客户名称长度过长。`,
"label.isemailnotification":`是否邮件通知`,
"label.addAPPexchange":`添加 AppExchange 应用程序...`,
"label.partnerCloud.orderingPlatform.currency":`币种：`,
"UG_quota_02":`报价是客户及供货商之间关于在指定的时间以指定的价格对指定商品进行交易的法律条款。`,
"label.customer.tab.step2.same.option3":`隐藏菜单`,
"H":`电话`,
"label_tabpage_searchz":`搜索`,
"vue_label_homepage_deleted":`已被删除`,
"label.weixin.recent.view":`最近查看的视图`,
"template.report.opportunity.sales":`业务机会销售量`,
"label.customfields.new.step2.opration.unique.info.v1":`将"ABC"和"abc"视为重复值(不区分大小写)`,
"savesuccess":`保存成功`,
"label.partner.workspace.member.memo":`选定的简档、权限集的所有用户都可以访问此伙伴云。`,
"label.icon.23":`药品`,
"lable.batchadd.service.cfq.before":`触发器(Before Insert)`,
"label.instrumentPanel.breakpointTwoLabelname":`该值要大于最小值及断点1值`,
"message.selectgsummaryinformation":`请选择汇总信息`,
"label.tianyancha.businessverify.msg6":`本功能使用第三方服务，可能存在因为高并发使用导致的性能不能稳定，服务不可能的情况，CloudCC 对此不承担任何连带责任。`,
"vue_label_helpcenter_report3":`3、A.单击字段搜索框，通过搜索字段后选择或滚动下拉字段列表后选择想要的字段，选择字段的操作符，输入或选择值，单击应用后字段筛选器生效。<br>&nbsp;&nbsp;&nbsp;&nbsp;B.单击字段搜索框上方“＋”号，在“筛选条件输入框”中输入数字和字母组成的高级筛选条件。如（1 and 2）or3。<br>•编辑筛选器<br>&nbsp;&nbsp;&nbsp;&nbsp;想要编辑筛选器，包含标准筛选器，单击筛选器即可。<br>•移除筛选器<br>&nbsp;&nbsp;&nbsp;&nbsp;单击筛选器上的“×”图标即可移除筛选器。<br>•运行报表<br>&nbsp;&nbsp;&nbsp;&nbsp;单击编辑页面右上角“运行”按钮，即可查看完整的报表结果。<br>•保存报表<br>&nbsp;&nbsp;&nbsp;&nbsp;单击编辑页面右上角“保存”按钮，填写报表名称，选择报表文件夹后保存。<br>2、构建报表文件夹<br>&nbsp;&nbsp;&nbsp;&nbsp;在没有构建报表文件夹前，系统默认生成“我的个人自定义报表文件夹”和“未归档公用报表文件夹”。 <br>&nbsp;&nbsp;&nbsp;&nbsp;步骤1：从报表选项卡，单击新建报表文件夹<br>&nbsp;&nbsp;&nbsp;&nbsp;步骤2：在弹出的新建报表文件夹弹窗中，可以选择将未归档公用报表文件夹中的报表转移至此文件夹。可以选择哪儿些用户可以访问此文件夹以及访问权限。<br>3、查看报表<br>&nbsp;&nbsp;&nbsp;&nbsp;步骤1：从报表选项卡，进入报表列表页，通过切换“最近查看”、“我创建的”、“全部报表”或报表文件夹找到想要查看的报表。 <br>&nbsp;&nbsp;&nbsp;&nbsp;步骤2：单击报表名称，即可查看报表。或单击报表最右侧“下拉按钮”，选择“运行”，即可查看报表。<br>&nbsp;&nbsp;&nbsp;&nbsp;如果是管理员简档，从报表选项卡，进入报表列表页，单击“新建文件夹”按钮旁边的“齿轮”图标，可以选择每一个文件夹中报表列表的表头展示的字段。<br>4、导出报表<br>&nbsp;&nbsp;&nbsp;&nbsp;步骤1：从报表选项卡，进入报表列表页，找到您想要导出的报表，单击报表最右侧“下拉按钮”。 <br>&nbsp;&nbsp;&nbsp;&nbsp;步骤2：选择类型<br>&nbsp;&nbsp;&nbsp;&nbsp;格式化报表：包含报表表头、分组、筛选详细信息。<br>&nbsp;&nbsp;&nbsp;&nbsp;仅限详细信息报表：未格式化的详细信息行。<br>&nbsp;&nbsp;&nbsp;&nbsp;步骤3：单击“导出”。其中仅限详细信息类型报表需要分页导出，每页最多导出2000条数据。`,
"label.batchdelete.success":`批量删除执行成功`,
"label.newprocess5.seq":`顺序`,
"label.knowledgebase.data.translated.successfully":`{a}条数据翻译成功`,
"label_enable_range":`启用范围`,
"label.ccchat.and":`和`,
"label.assignment.setup.list.norule":`没有分配规则`,
"vue_label_report_summaryformulacolumn":`汇总公式列`,
"label.field.edit.change1":`最大评分不能大于100`,
"syntaxerror":`语法错误,请检查您所输入的条件`,
"label.icon.116":`房子`,
"lable.asset.BOM.according.to.product":`根据产品结构生成资产BOM`,
"chatter.like.post":`喜欢此贴的人`,
"label.trigger.page":`触发器页面`,
"vue_label_email_contact_adminstrator":`系统异常，请联系管理员。`,
"label.workreport":`工作报告`,
"vue_label_homepage_edit_card_view":`编辑卡片视图`,
"label_emailsync_status_disabel":`禁用`,
"label.icon.54":`挖掘机`,
"message.error.view.validerr.common":`验证失败`,
"label.exchange.sync.account.username":`服务帐户用户名(域用户名或UPN)：`,
"label.dataimport.error.date":`出现错误：日期`,
"label.orgname":`组织`,
"label.weixin.group.owner":`所有人`,
"vue_label_dashboard_colorrange":`颜色范围`,
"label.forecast.shrepage.tableth":`预测访问`,
"label.related.disabled":`没有启用相关列表，请联系系统管理员在页面布局上启用相关列表。`,
"label.version.product.management":`产品管理`,
"label.knowledge.new.article.published":`已将文章发布为新文章`,
"label.sendsms.batch.step4":`步骤4：您已提交短信进行处理`,
"vue_label_commonobjects_detail_and_tasks":`恭喜你,没有未处理的事件和任务啦。`,
"label.salescloud.ci":`次`,
"label.ccpeak.getapi.name.time":`如果要使用CCService类中的方法，需要实例化`,
"label.escalation.setup.detail.conditon":`条件`,
"label.lbs.isUseLbs":`启用定位服务`,
"front-lightning-module-v1-dashborad-color-depth":`颜色深度`,
"date":`日期`,
"label.select.personnel":`选择人员`,
"label.appointmentpage.wizard.notif3":`请填写邮箱`,
"label.import.page1.pleaseselectwayofdealdata":`请先选择处理方式`,
"label.partner.all.memo":`列表显示贵组织中的全部伙伴云。单击URL可将您直接跳转到登录页。`,
"label.appointment.wizard.subtitle4-3-3":`30分钟`,
"component_telerecord_label_subject":`主题`,
"label.sendsms.batch.finish":`批量发送短信：完成`,
"label.login.access.myusername":`我的用户名`,
"label.weixin.wechatnumber":`微信号`,
"label.eowechat.status":`用户状态`,
"Lead_Scoring_Setting_Rule_Setup_Value":`分值`,
"label.appexchange.oldreport.noupload":`旧报表-不会上载`,
"label.approverfieldediting":`批准人字段和记录可编辑性`,
"label_tabpage_customernamez":`客户名`,
"vue_label_dashboard_linkagesettings":`联动设置`,
"vue_label_ccchart_notice_deletecomment":`确定要删除这条评论吗？`,
"label.allprofile":`所有简档`,
"label.campaignmember.main.addMember":`添加成员-搜索`,
"label.projectManagement.subtask.list":`子任务列表`,
"label.code.some.size":`代码容量 : 最大支持200KB字符,约200000字节`,
"front-custom-service":`服务云为客户提供高效敏捷的定制服务，使用智能工单系统缩短服务解决时间并提高解决率，提高客户忠诚度，增加复购率。`,
"label.SMS.det":`短信通知详细信息`,
"setup_layout_label_nobutton":`暂无可选按钮`,
"vue_label_email_Could_not_save_template":`无法保存模板`,
"label.imgfield.height":`高度`,
"label.leadscore":`潜在客户打分`,
"setup_object_field_dependency_label_removefromlist":`移除选中值`,
"message.error.code.null":`授权码不能为空！`,
"label.tianyancha.businessscope":`经营范围`,
"vue_label_chat_empty_message":`清空消息`,
"label.total":`共`,
"label.delerror.list":`未删除文件列表`,
"label.selectedreceivers":`所选收件人`,
"label.layout.availablepages":`可用页面`,
"label.pc.ui.2018.personalinfo":`个人信息`,
"label.chat.topic.edit.detial":`编辑详细信息`,
"label.mr.descreption.reDataList1":`在`,
"label.document.value.too.long":`此文件大小已超过5M！`,
"lable.opppdt.addpdt.table.listprice":`定价`,
"label.selectoperate":`选择操作`,
"label.icon.5":`货币`,
"label.icon.126":`病床`,
"label.hiddensearch":`隐藏搜索`,
"label.view.sortview.exportble":`可导出`,
"vue_label_homepage_noassignee":`无分配人`,
"label.knowledgebase.close.and.resolve":`关闭并解决`,
"label.licence.used":`许可证已使用数量`,
"label.newprocessstep5":`步骤 5 选择要在批准页面布局上显示的字段`,
"vue_label_appstore_all_applications":`全部应用程序`,
"label.no.edit.permission":`无所选记录编辑权限，不可选择`,
"vue_label_calendar_calendar_added_successfully":`添加日历成功`,
"report_line":`数据字段`,
"component.chatter.link.label.name":`链接名称`,
"label.data.expnode.e_desc1":`1、自定义导出：用户可以根据自己的需求选择要导出的字段，以及进行筛选的条件。`,
"label.tabularreport.step4":`步骤 4：选择报表标准`,
"Opportunity.Detailed.Phase.Change.Text.001":`更改业务机会阶段`,
"label.quickbooks.searchresault.action":`操作`,
"component_timeline_label_today":`今天`,
"label.callboard.remark":`在下面为贵组织输入公司公告`,
"label.campagin.field.choose":`选择要包含在市场活动注册页面中的字段`,
"front-gantt-module-rolling-temporary-tasks":`滚到临时任务`,
"label.file.des":`描述`,
"Dashboard_View_RecentlyView":`最近查看`,
"UG_Account_04":`被动查询客户过滤`,
"chatter.refresh":`刷新`,
"label.tianyancha.companyorgtype":`公司类型`,
"label.chatter.dateRange":`日期范围`,
"label.campagin.step3":`步骤3：生成页面`,
"label.appointmentdetail.wizard.title14":`周一时间规划`,
"setup.object.field.dependency.button.setdependency":`设置字段依赖`,
"serviceterritorymember.serviceterritory.isactive.notactive":`此服务区域未启用，您仅可以在已启用的服务区域下添加服务区域成员`,
"template.chart.ygydyj":`员工赢单业绩`,
"label.tag.edittags":`编辑标签`,
"label.clone":`复制`,
"front-electronic-signature-setting-intro1":`绑定账号前，建议您先在DocuSign平台进行注册和认证。`,
"label_reach":`达成`,
"label.tabpage.havez":`有`,
"label.email.clearCase":`只清空未关联个案的邮件`,
"label.customer.tab.all":`全部菜单`,
"label.direct.dashboard.day.report":`新建工作日报`,
"label_tabpage_exportview":`导出视图`,
"label.passwordPolicy.setup.maxFailTimes":`最大失败尝试次数`,
"label.processsetting.complete.enable":`完成并启用`,
"label.marketsea.memberfield":`成员可查看字段`,
"label.report.export.format.title":`格式化报表`,
"label.recycle.execute.title":`正在清空回收站`,
"label.file.use.most.user":`使用存储空间最多的用户`,
"report_type_label_systemReport":`系统报表`,
"label.customobjects.majorobject":`主对象`,
"label.file.delete.public.link":`删除公用链接`,
"front-epwechat-module-v1-id":`企业微信ID`,
"label.partner.common.roleNum":`角色数量`,
"label.sendtonextapprover":`发送到下一个审批人`,
"label.notification.tip3":`加载更多10条`,
"label.tabpage.placeenterz":`请输入`,
"label.mobile.phone.cc.people":`抄送人`,
"component_setup_iframe_label_inputurlmemo":`请输入要引入的页面URL地址`,
"label.umeng.activity.statuschange":`您分配给#name的任务状态被修改为#newstatus`,
"label.step3.restricted.visibility":`步骤3.限制可视性`,
"label.multilang.datadelete.approvedata":`正在审批的记录（{0}条）：`,
"label.reportsSubscription.save":`保存`,
"label.emailobject.template.visibility":`可见性`,
"label_partner_step3":`步骤3：基本信息`,
"label.product.across":`跨越各价格手册`,
"label.same.analyze.opportunity.name":`业务机会名称`,
"label.chatter.memotel":`记录电话`,
"label.recentview.seloption2":`我最近创建的`,
"label.ccchat.message.search.desc1":`我们无法找到具有`,
"label.reportexport":`导出`,
"label.service.gantt.drop.tip":`权限不足：您没有足够的权限进行此操作，请联系管理员`,
"label.australian.westem.standard.time":`西部标准时间（澳大利亚）`,
"label.emailobject.email":`邮件`,
"Homepage_Contract_FieldMissed_DoesntSupport":`合同对象上缺少字段“qdrq”和"htje"，无法显示数据。`,
"label.email.cancel.upload.info":`这将取消正在进行的上载过程`,
"label.page.copy.merged.field.value":`复制合并字段值`,
"UG.ST.006":`直接进入`,
"label.trigger.service.connot.access":`无法访问的语句`,
"label.projectManagement.new.tasks":`新增任务`,
"lable.SalesCommitmentKanBan.receiptsRate":`收款达成率`,
"label.productsales.oppor.overdue":`逾期的业务机会`,
"vue_label_pool_convertedbyme":`我转化的`,
"label.loginip.pagecue.invalidt":`开始Internet地址大于结束Internet地址，或无效的Internet地址`,
"label.campagin.roi.xyzj":`响应总计`,
"label.visualpage.list.title":`已启用的自定义页面访问`,
"chatter.feed.searchinitvalue":`键入名称...`,
"label.export_submission":`导出提交数据`,
"this.season":`本季度`,
"label.forecast.settings.gx":`预测数据共享`,
"label.tag.addtags.tagcolour":`标签颜色`,
"label.api":`API名称`,
"label.bulk.delete":`批量删除(彻底)`,
"label.reportsSubscriptionPage.condition.emailoption":`邮件选项`,
"vue_label_dashboard_newdashboardsuccessfully":`新建仪表板成功`,
"three":`三`,
"label.prompt":`提示`,
"label.same.analyze.contact.phone":`联系人手机`,
"label.icon.62":`管道`,
"label.forecast.shrepage.tableth.isnable":`允许提交`,
"label.multilang.polloption.vote":`{0}票`,
"label.customfields.totalsummary.selecttotaltype":`选择累计类型`,
"lable.SalesCommitmentKanBan.receivingCommitmentRate":`收款承诺率`,
"label.areaAndSub":`区域及下级区域`,
"vue_label_pool_recycle":`回收`,
"lable.outlook.detail.synset":`同步设置`,
"label.quote.detail.introduce":`输入关键字，点击“搜索”开始搜索，搜索完成后点击“选择”，进入下一步`,
"label.profile.customappset":`应用程序设置`,
"label.changemylanguage":`更改语言`,
"message.approval.plzcapppor":`请选择批准人`,
"vue_label_pool_operatecertification2":`{0}{1}{2}{3}？`,
"label.publiccalendarandresource":`公共日历和资源`,
"label.wtd.changefields.title.desc1":`选择要在页面上用到的字段，输入返回的URL，点生成按钮，生成页面。`,
"label.weixin.voting.not.empty":`投票选项不能为空`,
"label.campaign.channel.equal":`等于`,
"label.emailobject.emaildetail.button.back":`返回`,
"label.ccchat.person.invite.allowemails":`为了安全，请只输入以下结尾的电子邮件地址`,
"label.notEdit.message":`抱歉，您无权编辑该条数据，请联系系统管理员`,
"label.layout.selectedfields.relatedlist":`选取字段/相关列表`,
"label.weixin.voting.deadline":`投票截止时间`,
"label.document.upload":`要上载的文件`,
"label.import.page2.notmatchfiled":`文件中共{csvfiledlength}个字段，剩余{difflength}个未映射`,
"label.data.exp.selzippwd":`不填默认无压缩密码`,
"label.user.step2.select.email.template":`步骤2.选择电子邮件模板`,
"label.currency.effective":`有效币种`,
"label.version.control.type":`版本类别`,
"label.projectManagement.Taskorproblem":`任务/问题`,
"label.everyweek":`每周`,
"label.passwordPolicy.setup.pwdremember4":`记住4个密码`,
"label.emailobject.groupemail":`群发邮件`,
"label.approvepagelayout1":`多人采用相同页面布局`,
"label.integrations.mailchimp.massage5":`您将系统内的潜在客户和联系人导入至Mailchimp后，可以将各类邮件群发至指定的收件人。`,
"label.icon.22":`添加`,
"Dashboard_View_All":`所有仪表板`,
"label.import.page2.example":`示例`,
"label.send.letter":`发送邀请函`,
"label.mobilesectionpart":`移动端部分`,
"component_setup_tabs_label_title":`Tab分页`,
"label.knowledgebase.results":`{a}条结果`,
"label.field.remark":`应用于在`,
"vue_label_systemSettings_url":`域名设置`,
"vue_label_SMS_failed_find_view_list":`查找视图列表失败`,
"setup_layout_label_order":`排序标准`,
"label.customsetting.touse":`使用自定义设置 customSetting`,
"label.product.enter":`输入用来查找匹配产品的关键字`,
"label.email.template.private.SMS":`专用短信模板文件夹`,
"vue_label_homepage_chart_deleted":`图表或仪表板已被删除`,
"label.conversion_pages":`转换页面`,
"label.compact.layout.select":`选择关键信息布局字段`,
"report_label_folderandreport":`报表和文件夹`,
"label.product.entry":`价格手册条目`,
"label.campaignmember.main.manageMember":`管理成员`,
"front-QBtoCC-changing":`更新中……`,
"vue_label_pool_abandonreason":`废弃原因`,
"template.report.customer.contract.statistics":`客户的合同统计`,
"label.invoice.message.sendsuccessully":`Invoice发送成功`,
"label.addcurrentoperate":`添加现有操作`,
"label.customerinfo.mailpwd":`发件邮箱密码`,
"batch.nochange.owner":`无权限更改数据所有人！`,
"label_tabpage_uploadfailez":`上传失败，请重新上传。`,
"vue_label_systemSettings_mobelqrsetting":`移动端扫一扫设置`,
"label.regular_field":`表单域`,
"label.tabpage.delsuccessz":`删除成功`,
"label.Days.Before.Horizontal.Date":`水平日期之前天数`,
"label.evaluation.general":`一般`,
"chatter.notlike.p":`停止喜欢此帖子`,
"label.chatter.send":`发送`,
"label.emailsync.button.cancel":`取消`,
"label.notification.task4":`您的任务今天到期`,
"vue_label_helpcenter_detail1.2":`快速更改任务状态：勾选“已逾期和即将到来”模块中的任务前的复选框，单击刷新按钮即可快速更改任务状态为“已结束”。 <br>    未刷新前，取消勾选则任务状态不改变。<br>    优先级高的任务在活动时间线中会用“红旗”图标标记。<br>活动时间线的显示顺序<br>    按照任务的到期日期、记录电话的到期日期、事件的开始日期、邮件的收发日期、短信的收发日期倒序排列。如果以上日期相同时，会按照记录创建的时间倒序排列。<br>活动时间线筛选器<br>    使用活动时间线中筛选器，以缩小可见事项的范围、重点关注重要事项并查找目标事项。时间线的筛选器包括日期范围、要显示活动、活动类型三种类型的筛选。<br>    要显示的活动：所有活动、我的活动<br>    在活动时间线筛选器中，此选项可以缩小活动的显示范围。<br>    我的活动：显示您参与的活动，不论作为所有人或参与者。例如，您是发送电子邮件或组织活动的所有人。例如，在您是电子邮件抄送或密件抄送字段的收件人时，即表示您参与活动。<br>    `,
"component_chatter_post_label_title":`张贴`,
"label.data.dataexptemplate.desc":`数据导出模板是用户创建的用于导出数据的模板，用以便捷用户的导出操作。`,
"label.helptext":`帮助文本`,
"vue_label_norm_removecomponent_certify":`确认删除组件`,
"front-template-V1-Click-new-template":`点击”新建”，创建新的模板。启用后即可使用模板。`,
"label.optional_fields":`选填字段`,
"label.delete_about":`你要删除`,
"chatter.feed.initvalue":`您正在处理什么？`,
"label.mail.configure":`配置您个人同客户来往的邮箱，即可使用CloudCC邮箱主页进行收发邮件，并且同步历史来往邮件到潜在客户和联系上。`,
"label.project.hit.seven":`项目任务到期提醒`,
"label.button.upgrade":`购买与修改版本`,
"lable.PowerProcess.event.name":`重大事件名称`,
"label.weixin.confirm":`确认`,
"label.customfields.new.inputformula":`输入公式`,
"label.standard.buttonandlink.edit":`改写标准按钮或链接`,
"workflow.action.tasks.assignortype.createdtype":`创建人类型`,
"front-email-payment-paypal-describe":`点击“继续”，您可以登录到PayPal网站或者创建一个PayPal账户来完成发票支付。`,
"label.selectexistingoperate":`选择现有操作`,
"label.workflow":`工作流`,
"label.assignment.setup.detail.ruleentries":`规则条目`,
"label.data.file.i.title.num3":`3.系统会把将要导入的数据文件预读到服务器，然后启动后台批处理导入程序，导入结果将以邮件方式通知用户，您无需在此操作页面等待。`,
"label.use.view":`使用现有视图`,
"label.forecast.settings.moren":`默认产品系列`,
"vue_label_calendar_add_share":`添加共享`,
"label_tabpage_newview":`创建新视图`,
"label.recycle":`回收站`,
"UG_solution_03":`创建解决方案`,
"label.customfields.formula.text.tip":`创建文本字符串，例如，通过串联其它几个文本字段`,
"vue_label_file_single_file_size":`单个文件最大支持`,
"label.a.b.least":`每个 A" 记录必须至少有一个相关 "B" 记录。"`,
"label.validate.function.addtoformula":`插入所选函数`,
"label_tabpage_pleaseSelectz":`请选择`,
"label.account.NextFQ":`下一个会计季度`,
"label.project.project.name":`项目名称不能重复！`,
"label.emailtocloudcc.filed.owner":`记录所有人`,
"label.textmessage.template.message2":`当前短信正文中插入的字段与已关联的记录不匹配，可能会造成取值失败。`,
"label.icon.92":`书`,
"label.trailerpage":`尾页`,
"component_event_label_noevent":`看来您已完成今天的工作了。`,
"label.trigger.tip":`关于触发器`,
"label.knowledge.case.field.usable":`可用个案字段`,
"label.group.isusing.success":`启用成功`,
"label.marketsea.nextnotfollowdays":`距上次跟进后`,
"component.todaytask.label.choicestate":`选择状态`,
"label.recordtype.main":`--主--`,
"label.sendletter.step1":`步骤1：指定邀请函接受者`,
"label_tabpage_saveviewfailed":`视图保存失败`,
"vue_label_report_notiec_selectone":`每个上级对象记录必须至少有一个相关此对象记录`,
"UG_opportunity_003":`跟踪您的销售渠道 创建仪表板`,
"#label.importsourcestep4":`步骤四：导入您的文件#`,
"front-kefu-moudle-v1-trrt-tip":`您需要将您的用户（客服人员）与天润融通的分机进行关联，以获取“点击拨号”的功能`,
"UG.Forcast.09":`下一步`,
"label.ggReleaseRange.subordinates":`搜索角色和下属`,
"label.log.desctiption":`您可以下载包含更多内容的组织审计跟踪文件（Excel.csv文件）。`,
"label.submitted":`已提交`,
"label.validate.function.funcExplain.BEGINS":`检查文本是否以特定字符开头，如果是则返回TRUE。否则返回FALSE。`,
"label.campaign.channel.code":`市场活动营销渠道二维码`,
"chatter.group.theLastActivityDate":`上次活动日期`,
"vue_label_dashboard_pleaseenterabreakpoint2value":`请输入断点2值`,
"label.labeltranslation":`标签翻译`,
"label.multilang.product.deleterederect":`无法完成您对{0}的删除,因为它仍与其它价格手册中的记录相关联。关联记录如下 。`,
"lable.currencyManage.manageRate.dis":`要管理您公司其它对象的汇率、添加新币种、启用或禁用币种、或更改公司币种，请单击管理币种"。"`,
"setup.layout.label.modifypage":`编辑页面`,
"label.import.page2.editforname":`请为字段 {necessaryName} 编辑映射`,
"label.searchlayout":`搜索布局`,
"label.chatter.loadmore":`加载更多`,
"label.trigger.folder.all":`所有触发器文件夹`,
"label.export_submissions":`导出表单提交数`,
"lable.SalesCommitmentKanBan.allsignedTaskRate":`总签约任务率`,
"KeyInformationLayout_DefaultLayout_Name":`系统默认`,
"label.h5.chatter.great":`个赞`,
"label.call.center.configuration.enable":`使用下列设置修改贵组织Call Center功能是否启用`,
"label.overdate":`结束日期`,
"chatter.poll":`投票`,
"label.login.input.verification.code":`请输入安全码:`,
"label.file.sharetype.cooperation":`协作者`,
"label.app.step5":`步骤 5. 分配简档`,
"front-gantt-module-save-order":`保存顺序`,
"label.globalselect.toallrecord":`将新选项列表值添加到使用此全局值集的所有记录类型`,
"setup.mainpage.label.welcome24":`CloudCC 云平台提供系统内所有对象数据的安全性访问设置，可以通过设置各种规则、条件进行数据共享和访问权限的控制。`,
"homepage.layout.desctiption":`此页面允许您为主页菜单创建不同的菜单布局。`,
"vue_label_SMS_notice_send_sussess":`短信已发送`,
"label.projectManagement.overdue":`已逾期`,
"label.assignment.setup.list.lead.description":`使用潜在客户分配规则可以自动将潜在客户发送给相应的用户。潜在客户分配规则由定义于潜在客户的条件和多条规则条目组成。`,
"label.list.projectSetting.des":`使用下列设置修改项目下是否发送邮件：`,
"setup.mainpage.label.welcome18":`CloudCC 的企业级权限设置使您在处理数据和模块时可以控制各用户的使用权限。基于角色的权限设置还包括用户岗位、组、角色、数据共享规则、字段级安全控制，实现企业不同人员、部门之间的数据共享。`,
"label.ratio":`同环比`,
"label.Xaxis":`X 轴`,
"label.google.map":`谷歌地图`,
"Dashboard.SelectBoardToDisplay":`请选择打开仪表板选项卡显示的仪表板`,
"label.data.newtemplate.e_conditions":`导出条件`,
"label.emailtocloudcc.description3":`将您企业的邮箱，如sales@company.com, info@company.com, support@company.com添加于此，系统将自动根据所收邮件生成潜在客户或个案记录，确保及时跟进来信客户`,
"label.page.select.profile":`选择要在其中使用新自定义菜单的用户简档。也可以在每个简档的详细信息和编辑页面上检查或修改是否显示某个菜单。`,
"label.chosen.button":`已选按钮`,
"front-epwechat-module-v1-info":`企业微信后台信息`,
"label.translation.select":`选择筛选条件`,
"ten":`十`,
"label.barcode":`条形码`,
"lable.product.nextdel":`继续并删除显示的记录,或单击`,
"label.default":`默认`,
"label.chatter.theme":`主题`,
"vue_label_commonobjects_view_split_screen_view":`分屏视图`,
"label.ems.myemails":`我的邮件`,
"label.email.clearPersonalEmail":`是否清空所有个人邮件同步的邮件`,
"label.login.access.admin":`您的公司管理员`,
"label.emailobject.wizard.desc":`在CloudCC上，关联您的个人邮箱，可以直接从CloudCC发送邮件，同时自动关联您的潜在客户、联系人和业务机会。沟通历史按时间线一目了然。`,
"label.passwordPolicy.setup.minpwdlength":`密码最小长度`,
"choserow":`请选择显示的列`,
"front-epwechat-module-v1-role-binding":`角色绑定`,
"lable.outlook.edit.newdata":`创建日期最早`,
"label.schedulejob.setup.schedule.enddate":`结束日期`,
"label.quickbooks.view":`视图`,
"font-evaluate-module-v1-not-inform":`不通知`,
"chatter.poll.option3":`选项3`,
"setup_layout_label_selectfield":`字段选择`,
"label.partner.common.roleSetup":`伙伴云角色和用户设置`,
"label_partner_new_step3":`步骤3：输入名称和URL`,
"label.transfer":`转移`,
"label.bmap.myaddress":`我的位置`,
"label_tabpage_individual":`单项选择`,
"label.autoRegister.changepwd.setpwd.repassword":`请再输入一次密码`,
"vue_label_commonobjects_detail_and_before":`更早之前`,
"front-kefu-moudle-v1-single-Login-area":`单点登录域名`,
"label.replacedocument":`替换文档`,
"label.validate.function.category.Logical":`逻辑`,
"label.companyprofile.syncsuccess":`同步成功`,
"template.chart.rwzthyxj":`任务主题和优先级`,
"label.product.clearcondition":`清空条件`,
"component_task_label_person":`*被分配人`,
"label.tabpage.as":`如`,
"message.error.calendar.add":`已添加过该日历`,
"label.marketsea.isrecycleleadcreatebyself":`是否回收自建潜在客户`,
"label.icon.57":`气压表`,
"UG.Lead.010":`或者`,
"setup_object_field_dependency_label_configured":`已配置内容`,
"label.tianyancha.regnumber":`注册号`,
"front-kefu-moudle-v1-Opened-chats":`开通聊天`,
"label_tabpage_converstatez":`已转换状态`,
"label.bmap.beijing.haidianqu":`北京市海淀区上地10街`,
"label.startimport":`开始导入`,
"label.knowledgebase.application.default.settings":`Lightning应用程序默认设置`,
"lable.account.year.custom":`自定义会计年度`,
"label.event.nextmonth":`下月`,
"label.email.body":`正文`,
"setup.object.field.dependency.label.mustsetup":`请先设置字段依赖关系，再保存`,
"label_tabpage_multiple":`多项选择`,
"label.task.this.month":`本月的任务`,
"label.customfields.formula.moneyexample":`Gross Margin（毛利）= Amount - Cost__c`,
"label.tonewemailnotice":`为此任务选择对象并单击下一步"。任务只能与相同类型的工作流规则和批准过程相关联。"`,
"setup.mainpage.label.welcome11":`自定义报表`,
"label.layout.availabletab":`可用菜单`,
"label.data.importef":`导入失败的文件`,
"label.appupload.upload.alert":`在上载之前请提供有关此软件包的详细信息。这些设置确定安装此软件包所必需满足的要求。`,
"label.sales.accountteam.shared":`客户小组共享`,
"lable.currency.addexchageRate":`添加汇率`,
"label.page.simplified.chinese":`简体中文`,
"label.service.dispatchingUnits.search.service.area":`搜索服务区域`,
"lable.list.queue.name":`队列名称`,
"pagecreator.button.save":`保存`,
"label.ccpeak.support.function":`支持单表各种函数`,
"label.tianyancha.legalpersonid":`法人ID`,
"label.sendemail.chat.addPostmainPage":`尊敬的#name:\n\n    您好！#userName在您的CCChat主页上发帖。`,
"batch.no.change":`无权限转移的数据`,
"label.the.referenced":`处引用`,
"label.input.webtab.information":`填写有关 Web 菜单的信息。`,
"vue_label_systemSettings_subscription":`订阅类型`,
"label.login.access.title":`授予客户访问权限`,
"label.schedulejob.setup.schedule.lastday":`最后一天`,
"label.synchronize.department":`同步用户`,
"label_tabpage_lessequalz":`小于或等于`,
"label.file.library.successmanagemember":`管理成员保存成功`,
"label.service.major.event.oreder":`序列`,
"label.desktopintegration":`桌面集成`,
"label.a_b":`A 到 B 关系`,
"every":`每`,
"label.tabpage.bar":`条`,
"label.filecontentsnotnull":`文件内容不能为空`,
"label.layout.detailoftestobj":`测试对象详细信息`,
"label.summaryreport.2018.step3":`步骤3：选择报表列`,
"UG.Lead.002":`有很多方法可以为您的产品或服务识别“潜在客户”。`,
"label_partner_workspace_member_selectedprofile":`已选简档`,
"label.newdescription":`新建备注`,
"vue_label_normal_moveup":`上移`,
"label.mobile.quickcreate.default.logacall":`通话记录`,
"userterritory.serviceterritory.user.unique":`此用户已被分配了此服务区域，请勿重新分配`,
"label.weixin.record":`记录`,
"front-kefu-moudle-connecting":`正在连接`,
"label.monitorsys.recent.operation.log":`最近操作日志`,
"lable.outlook.detail.lmaping":`潜在客户字段映射`,
"lable.account.year.ovdate":`会计年度结束日期`,
"vue.homepage.auditcard.record":`记录{recordTotal}条`,
"label.processsetting.delete.process.succeeded":`删除进程成功！`,
"label.customerinfo.smsPwd":`短信网关密码`,
"label.tolead.object":`导入对象`,
"label.data.downpage.i.list.desc2":`导入数据后，您会收到一封邮件，提醒您是否导入成功。`,
"label.sharerule.ruletype":`规则类型`,
"label.reportsSubscriptionPage.email.toothers":`发送给我和其他用户`,
"label.emailobject.templates":`选择模板`,
"vue_label_checkduplicate_":`撞单分析`,
"label.campaign.channel.lookup.example":`查看示例`,
"label.login.verification.please.note":`请注意：`,
"label.version.charge":`收费`,
"label.ccdocument.show.trace":`显示痕迹`,
"label.sendemail.approval.submit":`您好,#name:\n     #actorname于#actordate提交的#objLabel-#recordname正在等待您的审批，请点击如下链接或者登录CRM系统，进入审批中心进行审批：\n  #path#appPath/query.action?id=#recordid&m=query\n#orgName`,
"setup.mainpage.label.welcome12":`用户通过点击鼠标，无需编程，按照系统提示步骤，便可以完成报表定义。系统有列表式报表、汇总报表、矩阵式报表可供选择。同时提供所有字段的显示选择。去除不必要的字段信息。 同时提包括、条状、折线、环状、漏斗、饼状等多类图形显示。让使用者一目了然。`,
"UG_contact_06":`导入联系人`,
"message.success.event.add":`保存新建事件信息成功`,
"report.line":`数据字段`,
"label.approvepagelayout2":`每人采用不同页面布局`,
"vue_label_normal_contract_sf":`合同`,
"label.tabpage.tpcustomersz":`转化潜在客户`,
"label.ccchat.message.new.error5":`错误，您的消息不能超过10000个字符。`,
"label.severalorone":`单个文件`,
"pagecreator_systemstyle_label_buttonfontcolor":`按钮文字`,
"label.customer.tab.step3.introduce":`选择要在其中使用新自定义菜单的自定义应用程序。也可以在每个自定义应用程序的详细信息页和编辑页上检查或修改是否显示某个菜单。`,
"chatter.group.groupEdit":`组编辑`,
"label.partnerCloud.partnerAccount.spending":`返利支出`,
"label.slip":`条）`,
"label.field.master.class":`主详关系层级超出3级`,
"label.sendemail.chat.addComentsmyFeed":`尊敬的#name:\n\n    您好！#userName对您的微贴进行回复。`,
"label.service.ganttBaiduMap.selectingDispatchTime":`选择派遣时段`,
"label.knowledgebase.remove.article":`将文章从归档中移除？`,
"label.appupload.notmanaged":`不受管`,
"label.report.goto.step":`转至步骤`,
"label.publicgroup.save.mustbeselect":`必须选择成员`,
"label.data.expnode.e.desc2":`2、按模板导出：用户可以选择模板进行数据导出。`,
"UG.product.02":`产品参考销售或采购的产品或服务。`,
"label.sendemailtouser":`确定要给选中的用户发送电子邮件吗？`,
"label.knowledge.setting.hint.nine":`如果您未找到Knowledge有什么好处？将相似文章排序为唯一数据分类，并累积为更为宽泛的数据分类组。现在，添加一个数据分类组。您稍后可添加更多。`,
"front-asset-module-v1-view-asset-bom":`查看资产BOM`,
"label_partner_all_enable":`启用`,
"label.processsetting.disable.process.successfully":`禁用进程成功！`,
"label.call.center.enable":`启用Call Center`,
"message.recordtype.applyitseparatly":`为每个简档应用不同的页面布局`,
"label.weixin.report.customize":`自定义`,
"label.file.mongdb.file.is.not.exist":`文件已不存在`,
"label.chat.edit.topics":`编辑主题`,
"label.knowledge.delete.searchterm":`删除搜索性能词出错`,
"label_emailtocloudcc_redmessage3":`请输入服务器地址`,
"use":`使用`,
"label.batchtransfer.transferfrom":`转移自`,
"label.recycle.my":`我的回收站`,
"label_json_string_null":`空`,
"label.version.lookupfield":`查找字段`,
"lable.tianyancha.h5.searchf":`未搜索到`,
"label.validate.globalvariable.description":`$User.[字段API]，例如：$User.id <br>可取到的字段值有：id,name,roleId,roleName,profileId,profileName,department,title,email`,
"UG.opportunity.006":`业务机会天才`,
"label.applt.copy":`一键复制`,
"chatter.emailMessageOrReply":`发帖或回复`,
"label.newreport.self":`选中的字段`,
"label.visualpage.checkpinxie":`请检查页面拼写。`,
"label.knowledgebase.article.attaching.case":`文章 {name}已附加到个案！`,
"label.dialogbox":`对话框`,
"label.summaryreport.step3.new":`步骤 3：选择要汇总的信息`,
"label.confirm":`确定`,
"label.mobile.buttom.team":`群策`,
"label.quickbooks.action.link":`关联`,
"vue_label_commonobjects_view_support_to_datas":`该操作最多支持10条数据`,
"vue_label_helpcenter_homepage":`    每个用户天生都带两个主页，标准主页和个人主页，管理员可以根据用户的简档再给用户分配一个对应的简档主页。注意，Lightning版本的主页和老版本的主页不互通。<br>1、标准主页<br>        标准主页的内容是统一不可编辑的。包括季度业绩组件、最近查看组件、审批中心组件、今日事件组件、任务组件、已逾期的业务机会组件、最近30天未联系的业务机会组件、临近的业务机会组件<br>        季度业绩组件：每个人可以设置自己的季度目标<br>        最近查看组件：展示最近查看的10条对象记录<br>        30天未联系的业务机会组件：展示未联系天数大于30天，且可能性不为0和100的5条业务机会<br>2、个人主页<br>        每个人都有一张个人主页，个人主页上的内容可以自定义的增删组件、也可以拖拽来调整组件的位置和大小<br>        人主页开户时默认会有简报组件、审批中心组件、逾期业务机会组件、临近业务机会组件<br>        个人主页最多15个组件<br>3、简档主页<br>        管理员可以通过自定义主页来新建/编辑/删除简档主页，并可以给不同简档分配不同的主页，以达到不同简档的用户可以看到不同的主页的效果<br>        每张简档主页最多15个组件<br>4、添加组件<br>        个人主页和简档主页可以自定义添加组件，可以添加仪表板组件、仪表板内图表组件和卡片视图组件<br>        仪表板组件：将系统中整张仪表板添加进主页，仪表板内包含多少个子组件就代表这个仪表板组件占用多少个组件的资源（主页最多支持15个组件），添加后仪表板组件的数据不会和原仪表板关联（即删除了原始仪表板，该仪表板组件依然可以作用）<br>        仪表板内图表组件：可以将系统中仪表板内具体的某个图表组件添加进主页，此时组件的联动功能将会失效<br>        卡片视图组件：可以选择将某个对象的某个视图作为数据源添加进主页，字段和操作项都可以自定义配置。但注意，如果卡片视图的数据源视图被删除了，卡片视图将无数据`,
"label.usersandlimit":`用户及权限`,
"label.sendmail.step3.introduce2":`位收件人接收此电子邮件。`,
"label.setupcustomfield":`自定义字段`,
"label.layout.last.notdel":`布局最后一个不允许删除`,
"label.emailtocloudcc.redmessage7":`后台配置错误，请联系管理员`,
"label.includedIn":`包含于{parentproductname}`,
"label.permission.detail.app.pagesetting":`自定义页面设置`,
"label.addfile.tips":`已选择了{selectedNum}个文件，单次最多添加{originNum}个文件`,
"label.fieldinformation":`字段信息`,
"label.campagin.roi.sjcb":`实际成本`,
"label.email.all.works.company":`公司所有同事`,
"label.currencyDesc":`使用此页面定义您的组织使用的所有货币。应将公司币种设置为公司总部在收入报告时所使用的币种。如果指定其它币种作为公司币种，则会修改所有兑换率以反映此变化。`,
"label.file.details":`详细信息`,
"label.foldervisitlimit3":`只有下列用户可访问此文件夹：`,
"label.account.next.M":`下月`,
"label.oweralias":`所有人别名`,
"label.projectManagement.entryname":`项目名称`,
"label.customcomponent.page.add.title1":`组件信息`,
"label.projectManagement.PleaseenterCreator":`请输入创建者`,
"label.multipleactivity.memberselected":`所选成员`,
"label_chatter_memotel":`记录电话`,
"lable.Confirm.customers":`确认恢复{num}个潜在客户`,
"front-email-payment-Invoice-number":`发票编号`,
"label.not.appoint.validation":`没有指定验证规则对应的对象，请指定`,
"label.peru.time":`秘鲁时间`,
"label.setting.intergrationlist.status3":`需要QuickBooks账号登录`,
"vue_label_display_number_field":`显示数字字段`,
"label_productline_count":`产品系列数量`,
"label.data.downpage.i_title.num2":`2、开始导入之前，请确保您要导入文件中的字段名称和 CloudCC 系统中对象字段名称的匹配。`,
"label.field.duplicate4":`将"ABC"和"abc"视为不同值（区分大小写）`,
"message.approval.step.validation.invalid.levels":`层级至少为1`,
"label.tianyancha.businessverify.step1":`启用工商数据验证第一步`,
"label.hidedetail":`隐藏详细信息`,
"UG_Lead_009":`APP通话记录`,
"label.partnerCloud.newProductSeries":`新建产品系列`,
"label.brief.opportunities":`机会总数`,
"label.user.mfa.unbind.remind":`您即将对选择的用户解除MFA绑定，用户下次登录之后需要重新绑定MFA设备，请确认。`,
"vue_label_report_grouprow":`组行`,
"setup.layout.label.newarea":`新建区域`,
"label.nostart":`未开始`,
"UG_Lead_010":`或者`,
"label.emailmerge.mergepage.record.requeired":`请选择要合并的记录!`,
"label.appointmentpage.wizard.notif1btn1":`确定`,
"UG.Account.02":`有些企业向其它企业提供服务，有些企业直接与终端用户进行协作，有些则服务于NGO组织。`,
"label.address.country":`国家或地区`,
"label.userinfo.updatepwd":`更改密码`,
"label.salescloud.teamrole.optionlist.opportunity":`将业务机会小组成员添加到`,
"lable.account.Current.FY":`当前会计年度`,
"chatter.coll.p":`收藏此帖子`,
"label.setupsms":`短信`,
"label.atlantic.daylight.time":`大西洋夏令时`,
"label.recordslock":`记录锁定`,
"button_partner_search":`查询`,
"vue_label_salesfunnel_notice4":`可能性为1%-99%的业务机会总金额`,
"vue_label_report_statistics":`统计`,
"label.ccchat.notmember.active.group0":`您不是名称中含有{0}的任何活动小组的成员`,
"label.tag.manage.newtag":`新增标签`,
"label.customfileds.formula.dateandtime.tip":`计算日期/时间，例如，通过在其它日期/时间上加上一定的小时或天数`,
"label.weixin.mobile.fly.ios":`ios移动端分享`,
"vue_label_file_over_file_size":`file.name   '的文件体积超出了系统预设！`,
"label.schedulejob.setup.schedule.last":`最后`,
"label.ccchat.whose.name.contains":`的任何活动小组的成员`,
"label.project.milestone.name":`同一个项目中里程碑不能重名！`,
"message.passwordPolicy.validate.reuse":`错误：不能重复使用此密码`,
"label.stdashbord.xsld.business.img3":`可能性为1%-99%阶段的金额*可能性`,
"label.event.view.list":`视图列表`,
"label.workflow.ruletriggertime":`规则触发时间`,
"label.campaign.channel":`市场活动营销渠道`,
"label.appexchange.emailnotice":`工作流电子邮件通知`,
"label.icon.77":`农业`,
"label.visualpage.display.value":`此处写要显示的值，注意前后不能有空格`,
"label.forecast.customforecast.type.user":`按用户`,
"label_tabpage_lessz":`小于`,
"label.same.analyze.contact.email":`联系人邮箱`,
"vue_label_report_range":`范围`,
"lable.product.pricebooks.nr":`您可通过从以下选项列表选择来从现有价格手册复制内容`,
"label_mobile_buttom_team_setUp":`群策设置`,
"label.email.bcc.recipients":`密件抄送收件人`,
"vue_label_ccchat_notice_deletepostfail":`删除帖子失败`,
"label_file_type":`文件类型`,
"label.multilang.feedtrack.operateupdate":`已更改一条{0}记录`,
"label.contractmanager":`合同经理`,
"front-gantt-module-drag-one-task-sorting":`任务只能在同一里程碑内排序！`,
"label.partner.step2":`步骤2：确认模板`,
"front-epwechat-module-v1-again-binding":`重新绑定`,
"label.service.miniProgram.imageSize":`上传图片大小不能超过2MB!`,
"setup_main2018_label_managesetup":`管理设置`,
"component_salesperformance_label_nopermission":`要查看业务机会相关的数据，请联系您的系统管理员。`,
"lable.account.stadate":`会计季度开始日期`,
"label.service.gantt.and.resourcestype":`和资源类型是`,
"label.ems.attachfiles":`添加附件`,
"label.data.expnode.e.desc1":`1、自定义导出：用户可以根据自己的需求选择要导出的字段，以及进行筛选的条件。`,
"vue_label_systemSettings_analyse":`分析`,
"label.project.all.date":`结束日期必须大于等于开始日期！`,
"vue_label_commonobjects_view_summary_basis":`汇总依据`,
"template.chart.yywjhdschd":`有业务机会的市场活动`,
"vue_label_pool_notmeet":`不符合客户要求`,
"label.attendance.manager":`考勤点管理`,
"vue_labenl_normal_current":`当前`,
"label.projectManagement.completed.quantity":`完成数量`,
"label.layout.testfield":`测试字段`,
"label.customfields.selectcontainrelatelistlayout":`选择应包含该相关列表的页面布局`,
"label.fiji.time":`斐济时间`,
"message.error.domain.already.exists":`域名已经存在`,
"label.accountandcontact":`客户/联系人`,
"label.dashboardSetup.right":`右`,
"label.view.appliedMobile.xgry":`勾选此项，可在相关人员的首页工作台看到该视图`,
"label.file.share.all":`您公司中的任何用户`,
"vue_label_pool_summary":`共{0}条数据,已在{1}刷新`,
"label.emailtemplate.new":`新建邮件模板`,
"label.tag.manage.button1":`新增标签`,
"label.data.exp.tempexppage":`数据导出模板页面`,
"font-trade-module-v1-invoice-total":`发票总额`,
"label.folder.sort":`文件夹排序`,
"label.multilang.campaign.countnum":`{0}次`,
"label.homepagelayout":`主页布局`,
"setup_layout_button_cancel":`取消`,
"lable.Search.in.QuickBook":`在quickbook中搜索`,
"setup_fielddependency_label_pleaseclick":`请点击“控制字段”值进行编辑`,
"setup.fielddependency.label.pleaseclick":`请点击“控制字段”值进行编辑`,
"label.version.sum.field":`个自定义字段`,
"label.form.is.submitted.successful":`表单提交成功提示`,
"label.campaignmember.main.batchaddmember":`批量添加市场活动成员`,
"label.sendemail.activity.newevent":`尊敬的#belongtoidccname您好：\r\n  您的同事#createbyidccname于#createdate给您分配了一个新的事件，内容如下：\r\n  主题：#subject\r\n  开始时间：#begintime\r\n  结束时间：#endtime\r\n  相关项：#relatedstr\r\n  内容：#remark\r\n  具体详情，请访问此链接：\r\n #path\r\n                        #orgNameCRM系统`,
"label.knowledgebase.select.target":`请选择目标`,
"setup.layout.label.buttonlist":`按钮选择`,
"pagecreator.page.label.pagedesc":`页面描述`,
"label.version.professional":`专业版`,
"UG.Forcast.10":`完成`,
"template.chart.schdyqsr":`市场活动预期收入`,
"front-filter-module-v1-quick-filter":`快速筛选器`,
"label.notification.group2":`您已成功加入公用小组`,
"label.ServiceCloud.statistics.by.serviceArea":`按照服务区域统计`,
"label.validate.function.funcExplain.TIMENOW":`返回当前时间（时分秒）`,
"label.brief.lastmonth":`上月`,
"label.weixin.member.states":`会员状态`,
"template.chart.ljxsje":`累计销售金额`,
"label.eidt.queue.label.hasused2":`该队列名称已经被使用`,
"label.textmessage.nophonenumber":`此联系人没有记录的手机信息`,
"label.task.new":`新建任务`,
"label.tabpage.grid":`网格显示`,
"label.workbanch.setup.viewname":`视图名称`,
"front-gantt-module-temporary-tasks":`临时任务`,
"label.reportTypeDescripe":`根据自定义报表数据源，用户能够根据预定义对象、对象关系及指定的字段创建报表。`,
"setup_layout_label_fieldlist":`可用字段`,
"label.ggReleaseRange.searchforRole":`搜索合作伙伴角色`,
"label.datamanage.account.field":`客户字段`,
"label_tabpage_groupingemptyz":`分组项目不能为空`,
"label.permission.edit.insertinfo":`输入权限集信息`,
"label.back_forms":`返回表单列表`,
"vue_label_calendar_step_2":`第二步：选择标准或自定义对象创建日历`,
"lable.outlook.mcto.out":`排除的域`,
"label.workflow.accessnext":`如果满足以下条件，则进入此步骤`,
"label.data.exp.temppage":`数据导出及模板制作页面`,
"label_tabpage_printview":`打印视图`,
"vue_label_report_preview":`要查看最新编辑，刷新预览。`,
"frame_personinfo_label_personimage":`简档照片`,
"component.chatter.button.like":`喜欢`,
"label.ems.drafts":`草稿箱`,
"front-lightning-module-v1-details-page-chart-report-name":`报表名称`,
"label.partner.workspace.login":`登录页面`,
"include":`包括`,
"label_length_20":`长度在20个字符以内`,
"component_event_button_save":`保存`,
"label.weixin.recalculate.shared.success":`对象共享规则重新计算成功`,
"message.duplication.errorinscript.lessthan2":`必须选择至少两条要合并的记录!`,
"label_my_forecast":`我的预测`,
"label.ems.to":`收件人`,
"label_mobile_buttom_team_init":`群策用户初始化`,
"label.sendemail.send.codeerror":`编码转换失败，请使用正确的编码`,
"lable.quote.syncing.and":`和`,
"label.campaignmember.selectmember.step1oftotal":`第1步，共2步`,
"label.ems.step3":`步骤3`,
"lable.PowerProcess.detail.message":`权利过程详细信息`,
"chatter.poll.option2":`选项2`,
"front-view-module-v12-verify-number":`数字格式错误，请检查输入的数据`,
"label.setup.mobile.homepageshortcuts.savesuccess":`移动端主页快捷功能设置保存成功`,
"lable.outlook.edit.zdyoutfi":`自定义 Exchange字段名`,
"label.assignment.setup.newentries.inputentries":`输入规则条目`,
"label.customfields.money.tip":`允许用户输入美元或其它货币金额，并将字段自动转换为货币金额格式。此功能在将数据导出到 Excel 或其它电子表格时非常有用。`,
"label.service.appointmentList.cancelThePlan":`取消计划`,
"label.chat.topic.suggest.add.topic":`无建议，添加您自己的主题`,
"vue_label_commonobjects_detail_tips":`小贴士`,
"message.error.view.nameexists":`错误： 视图唯一名称已存在`,
"label_emailtocloudcc_step2_name":`配置邮件归属`,
"label.field.validation.apiname":`必须以字母开头，只能包含大小写字母，数字，下划线，最大长度50，最小2位，且不能是数据库的关键字`,
"page.field.masterinput.remark2":`例如：新建销售订单时，要在同一页面内同时也录入销售订单明细项，那么就需要启用此功能；（此功能非常适合主详关系的对象使用）`,
"label.rule.enabled.successfully":`规则启用成功`,
"label.role.createrolelist.tip":`以下是贵组织的角色列表。单击角色链接可查看更详尽的信息。`,
"label.multilang.datamanage.dataimport.redundantmsg":`标题的长度是&nbsp;{0}&nbsp;，但是数据的长度是&nbsp;{1}&nbsp;，系统无法确定多余哪&nbsp;{2}&nbsp;个字段。`,
"label.visualpage.staticresource":`引入静态资源`,
"chatter.group.members01":`成员`,
"label.planned.workname":`作业名称`,
"label.service.dispatchingUnits.gantt.data":`匹配甘特表日期`,
"label.data.newtemplate.t.conditions":`模板条件`,
"label.accmarketsea.edit.title":`客户公海池编辑`,
"label_chatter_priority":`优先级`,
"label_mobile_buttom_team_open":`启用PC和App群策`,
"front-gantt-module-no-tasks-available":`无可用任务`,
"component.newrecords.label.type":`存储类别`,
"label.version.ccdocument.and.remark":`附件及备注`,
"label.martrixreport.step2":`步骤 2：选择用于计算汇总信息的分组方式`,
"label.projectManagement.Scheduleinformation":`时间表信息`,
"label.emailmerge.mergeFolder.description":`在此页中，您可以生成一个 Microsoft Word 文档，包含您的联系人数据。请选择邮件合并模板，最多可选20个。`,
"label.autoRegister.changepwd.setpwd.tip":`设置的密码需要满足以下几个条件`,
"label.partnerCloud.orderingPlatform.shoppingEmpty":`购物车为空，请点击添加产品按钮进行添加`,
"label.marketcloud_seminar":`市场云研讨会`,
"label.knowledgebase.no.results.knowledge.search":`Knowledge 中没有"{a}"的结果`,
"label.createdate":`创建时间`,
"vue_label_systemSettings_bazaar":`市场`,
"report_type_label_contractPayment":`合同和收款`,
"label.myemailset":`我的电子邮件设置`,
"label.emailtype":`邮件类别`,
"label.appexchange.uninstallpage.message5":`永久删除与此软件包中自定义对象相关联的任何关系和相关列表`,
"label.customerinfo.applicationlicencenum":`功能许可证数`,
"label.product":`产品`,
"lable.opppdt.selPdt.subtitle":`产品选择用于`,
"label_emailtocloudcc_step1_lead1":`Email to Lead`,
"label.multilang.recentview.query":`查看您最新的{0}`,
"label.cumstom":`自定义`,
"lable.product.pep":`请输入价格`,
"label.suggestion":`意见`,
"vue_label_email_sentto":`已为`,
"label.email.cancel":`取消关联后，将无法使用该邮箱收发邮件，确认取消？`,
"component_timeline_label_1monthahead":`前1个月`,
"setup_mainpage_label_welcome31":`操作指导： 点击本页左侧菜单 → 管理设置 → 创建 → 应用程序`,
"label.weixin.settlement.rate":`回款达成率`,
"front-lightning-module-v1-details-page-chart-add-report":`· 最多添加10个报表图表`,
"label_related_list_types":`Lightning版本相关列表类型`,
"label.tabpage.converstatez":`已转换状态`,
"label.chatter.ok":`确认`,
"lable.SalesCommitmentKanBan.contractRate":`签约达成率`,
"component.setup.label.setupsavefail":`组件设置保存失败`,
"label.email.form.text2":`【切换为"HTML"】`,
"UG.Lead.009":`App通话记录`,
"label.escalation.setup.newrule.title":`个案升级规则`,
"label.field.available.value":`可取到的字段值有`,
"label.cannotuseaddtimetrigger":`<b>  添加时间触发器按钮</b>在以下情况下不可用:<br/><ol><li>  规则条件设置为每次创建或编辑记录时</li><li>  规则已启用</li></ol>`,
"vue_label_chat_activefail":`开通失败`,
"label.dashboard.show.total.percent":`显示总数与显示%请至少选一项`,
"label.schedulejob.setup.schedule.jobprg":`作业程序`,
"label.select.email.type":`请选择邮件类型！`,
"chatter.group.allTheMembers":`所有成员`,
"label.webtab.validation.apiname":`必须以字母开头，只能包含大小写字母，数字，下划线，最大长度20，最小2位`,
"label_partner_new_step3_name":`名称`,
"vue_label_chatter_remove_member":`移除成员`,
"label.customobjects.majorobject.tip":`如果选择非主详关系对象，则汇总数据不走权限`,
"label.forecast.edit.kjjd":`会计季度`,
"label.reportsSubscriptionPage.schedulereport.monthly.week.three":`第三个星期`,
"label.weixin.senderror":`发送失败`,
"label.visiturl":`访问URL`,
"label.apply.img.error":`图中字符输入不正确。`,
"label.been.detained":`重置折扣`,
"vue_label_helpcenter_dashboard2":`新建的仪表板内需要优先添加组件，选择报表数据源或者列表视图数据源。然后确定使用的图表类型并选择相应的分组和统计数据来制作图表<br>&nbsp;&nbsp;&nbsp;&nbsp;添加完组件后，可以点击仪表板的“重新排序”按钮来将调整组件位置和大小。<br>&nbsp;&nbsp;&nbsp;&nbsp;如果需要给某些组件设置时间筛选的条件，即可点击“筛选条件设置”来选择组件设置该组件需要用于筛选的时间字段，设置好后，即可通过仪表板的时间筛选，选择对应的时间范围来更新选中数据。<br>&nbsp;&nbsp;&nbsp;&nbsp;注意：一张仪表板最多支持10个组件。<br>2、组件的穿透与联动<br>&nbsp;&nbsp;&nbsp;&nbsp;同一个仪表板内，组件A可以设置与它来自同一数据源的组件B和组件C作为它的联动对象。设置完成后，点击组件A的某一数据区，组件B和组件C会同时根据组件A的数据区条件进行数据的重新统计。<br>&nbsp;&nbsp;&nbsp;&nbsp;注意，点击组件B或者组件C的数据区，并不会让组件A进行数据的重新统计。如果需要达到这样的效果，需要在组件B/C上设置组件A为它的联动对象。<br>&nbsp;&nbsp;&nbsp;&nbsp;每一个仪表板内的图表组件，数据都来自视图或者报表。所以提供了一个穿透功能，即点击组件的数据区可以跳转到对应的报表和列表视图。注意，如果原本的数据源失效，组件将无数据，穿透功能也将失效。<br>&nbsp;&nbsp;&nbsp;&nbsp;由于穿透和联动都是点击组件的数据区，所以二者不能同时生效，组件如果同时设置了穿透和联动功能，那组件只能同时有一个功能生效，通过切换联动和穿透状态来更改生效的功能是哪个。`,
"vue_label_commonobject_view_notice_delete_false":`记录{0}删除失败，原因为{1};`,
"label.weixin.newspaper.coverage.information":`报险单信息`,
"label.you.do.not.have.permission.to.operate.":`您没有权限进行操作。`,
"label.checkfield.match":`匹配`,
"message.custom.field.donotdelete.ref":`该字段被其它字段所引用`,
"label.version.maxsum":`，已达到上限！`,
"System.ChangeUser.Info.001":`更改所有人成功，您没有查看此记录的权限，点击后返回到上一个页面。`,
"label.target":`目标`,
"template.dashboard.behavior.analysis":`行为分析`,
"label.login.verification.enter.prompt":`请输入6位数字安全码`,
"label.am":`上午`,
"chatter.emailSetUp.remark":`应用于CCChat页面对人员的追随及对帖子的各种操作，选择是否发送邮件的设置`,
"label.accmarketsea.grouplist.title":`客户公海池分组设置`,
"label.stdashbord.xsld.business.danwei":`单位:万元`,
"label.app.step1.error.namenull":`公用小组名称不能为空`,
"label.login.button.verification":`提交验证`,
"label_tabpage_newWizardz":`新增功能向导`,
"label.addattachment.step1.intruduce":`输入文件路径或点击按钮查找文件`,
"pagecreator.layout.funcpath":`/构建器/布局库`,
"fourth":`第四个`,
"label.timetrigger.after.lasttime":`晚于最后修改时间1天`,
"vue_label_report_showme":`向我显示`,
"label.h5.similar.opportunity.end.date.in":`结束日期在以下时间内`,
"label.turntonextstep":`转到下一步`,
"label.icon.106":`日程`,
"label.user.receivenewsbulletin":`接收  新闻简报`,
"label.mask.card.number":`信用卡号`,
"setup.object.layout.label.profileoptions":`可分配简档`,
"vue_label_systemSettings_obj":`对象及字段`,
"label.call.center.history.open":`自动打开通话记录页面`,
"label.attendance.cityname":`请输入城市名`,
"label.newemailnotice.tip":`创建一个电子邮件通知 以关联一个或多个工作流规则、批准过程。 如果更改电子邮件通知 ，任何修改都将应用到与之相关联的所有规则、批准。`,
"label.app.step1.error.labelnull":`错误：标签不能为空`,
"front-kefu-moudle-connect-free-account":`将CloudCC的用户与天润融通的试用账号进行关联`,
"label.biaoqingfaxian.description":`勾选了启用标情发现，可在前端增加标情发现的菜单，用户可查看相关行业的标情信息，并可将标情数据转化为系统内的潜在客户。`,
"label.filter":`筛选`,
"label.data.downpage.e.title.num1":`1、选择要导出数据的对象，或者选择导出全部。`,
"label.h5.similar.opportunity.last.months12":`最近9-12个月`,
"label.chatter.name":`名称`,
"vue_label_helpcenter_email":`1、发送邮件<br>    离开系统去您的邮箱与联系人进行邮件往来已成为过去。在CloudCC上，关联您的个人邮箱，可以直接从CloudCC发送邮件，当您在收件人输入邮箱地址或名称时，可为您模糊匹配您的联系人或潜在客户记录。您还可以将邮件记录关联到已经配置好的相关记录上，在记录详情页会同步您发送的邮件。<br>2、发邮件时的4个常用功能<br>    您在发邮件时可以使用邮件正文下方的4个功能，以此来辅助您的工作。<br>邮件追踪<br>    当您开启邮件追踪时，我们会帮您监听此邮件被打开的次数以及最后被打开的时间，您可以将鼠标悬浮在发件箱列表“眼睛”图标上查看。<br>上传附件<br>    点击上传附件，可以选择已经上传到系统中的文件，也可以选择上传文件。可以选择多个附件，只要附件的大小小于20M。<br>插入合并字段<br>    当邮件关联了某条对象记录后，您可以单击插入合并字段，选择关联的对象，选择您想插入的字段，在合并字段中逗号后边输入替换文本，例如{!Contact.FirstName,Sir or Madam}。保存模板时，合并字段将显示于模板的电子邮件正文中。使用合并字段个性化设计电子邮件的内容。可向任何合并字段中添加替换文本。仅当合并记录不包含该字段的数据时，才显示替换文本。<br>编辑并启用签名<br>    当您在发送工作邮件时，一个能代表自己身份的签名将有利于提高您的工作专业性。单击“编辑签名”按钮，您可以编辑您的基本信息，而且支持您插入图片。如果您勾选“启用签名”，在每次写邮件时邮件正文都会带上您的签名，您随时可关闭签名。<br>3、筛选收件箱<br>    您可以在收件箱中筛选所有未读的邮件，方便您处理工作。当您想通过邮件下载文件时，您可以在收件箱中筛选所有含有附件的邮件，这样您能很快定位到您需要的邮件。除此之外，您可以通过筛选含有未关闭的业务机会的邮件或者筛选发件人来自于潜在客户或联系人的邮件，快速了解您通过邮件来追踪的系统内客户的记录。<br>4、群发邮件<br>    在潜在客户、联系人列表右上角有群发邮件的按钮，您可以批量给含有邮箱地址的潜在客户或联系人记录发送邮件。当您有市场活动记录时，您可以给市场活动成员批量发送邮件，方便您发送活动邀请函。`,
"front-kefu-moudle-auto-callphone":`自动为已接通电话创建新个案`,
"label.fiscal.FQ":`会计季度`,
"label_tabpage_groupsVisiblez":`某些用户组可见`,
"UG.product.01":`列出产品/服务`,
"vue_label_commonobjects_view_members":`可选成员`,
"label.organization.id":`组织ID`,
"label.tyle_preview":`样式预览`,
"label.campaign.channel.input.to.owner":`6.请设置成员签到是否通知所有人：`,
"label.appointmentconfirmpage.wizard.notif1":`预约已经被取消`,
"lable.tianyancha.maping":`字段映射`,
"front-kefu-moudle-v1-noadd-online-chats":`未添加在线座席`,
"vue_label_commonobjects_detail_group_strategy":`确定进入该客户群策吗？`,
"vue_label_report_deletegrouprow":`删除组行`,
"lable.account.y.d":`此页允许您定义一个自定义会计年度记录。自定义会计年度的日期将根据您下面所进行的选择生成。`,
"label.visualpage.lllegal.definitions":`非法的定义`,
"label.tabpage.enterrecordnamez":`请输入记录所有人`,
"vue_label_report_howmuchlines":`{length}行`,
"homepage.components.custom":`自定义组件`,
"label.campaign.channel.upload.img":`上传图片`,
"UG_Case_03":`个案自动升级`,
"label.approved.receiveApprovalEmail.option4":`从不`,
"System.Data.Import.Warning.MaxCount":`您的组织每次只能导入数据{0}条，现在已经超出，请调整后再次导入。`,
"label.sent.sms":`发送一封短信`,
"vue_label_dashboard_statistictype":`统计类型`,
"label_report_last_year_same":`去年同期`,
"lable.Examle":`示例`,
"label.customerinfo.PageTriggerFagTitle":`两小时才能同步一次`,
"label.mobile.phone.read":`批阅`,
"label.product.gopage":`跳转到`,
"label.a_b_without":`A" 记录可能有或没有相关 "B" 记录。"`,
"front-kefu-moudle-callin-missphone":`呼入漏接的电话`,
"label.sso.saml.sp.idsource.attrname":`属性名称`,
"label.h5.chatter.colleagues2":`同事`,
"label.approveprocess":`批准过程`,
"label.dataimport.error.name.null":`出现错误：name为空。`,
"label.paging.countitems":`{0}条`,
"vue_label_report_notice_filter":`不启用高级筛选时，不同筛选，各个条件之间是“与”，也就是满足1与2的共同特征的记录显示到报表，例如：1为金额大于100万的业务机会，2为预计签约日期等于本月，则报表结果是本月大于100万的业务机会。`,
"front-lightning-module-v1-dashborad-export-picture":`导出图片`,
"label.activity.disabled":`没有启用活动，请联系系统管理员在页面布局上启用活动历史和未处理活动。`,
"message_chooseatleastonefield":`请至少选择一个要显示的字段`,
"label.case.text":`通过网站提交的服务请求单可在系统内生成个案记录，请选择用户作为个案记录的创建人，选择的用户需要对个案对象具有创建权限。网页适用于电脑和手机。`,
"label.sendmail.step3.dealoption1":`将每封邮件以密件形式抄送给我`,
"label.forecast.settings.title.remark":`为用户预计估测获得收入的最佳估计值，这些预测可以为用户提供一个完整的业务视图`,
"label.apply.youxiaotime.finish.opperation":`有效时间5分钟，请您尽快完成操作。如非本人操作，请忽略本短信。`,
"label.user":`用户`,
"pagecreator.page.button.copy":`复制`,
"label.userinfo.pwdupdate.or.reset":`您的密码上次更改或重置于`,
"label.fieldupdata":`字段更新`,
"label.sendemail.chat.followsubject":`CloudCC CCChat有人追随`,
"component_task_label_enddate":`到期时间`,
"label.campaign.channel.step6.remark5":`您可以通过潜在客户分配规则进行重新分配，关于分配规则`,
"label.mr.title.mobilePhone":`手机`,
"label.notice":`提醒`,
"message.serviceappo.time.violation":`服务预约允许时间违规:服务预约的已计划开始时间小于最早允许开始时间`,
"label.account":`客户`,
"front-kefu-moudle-callcenter-user":`呼叫中心用户`,
"label.usermanage.query.notexist":`查询的用户不存在`,
"label.forecast.userinfo.isnable":`允许预测`,
"label_partner_workspace_member":`成员`,
"vue_label_dashboard_penetrationsetting":`穿透设置`,
"chatter.fieldtrack.operatecreate":`已创建一条`,
"label_tabpage_tpcustomersz":`转化潜在客户`,
"label.emailtocloudcc.redmessage6":`IMAP/SMTP认证失败，请检查电子邮件地址与密码是否正确`,
"label.customfields.file.upload":`上载`,
"label.forecast.isforecast":`没有启用收入预测`,
"label_benchmark":`基准`,
"label.exchange.sync.state.system":`系统同步状态`,
"UG.opportunity.003":`跟踪您的销售渠道 创建仪表板`,
"label.campaign.matchway.select.error":`要更新数据，请选择匹配的方式`,
"vue_label_dashboard_located":`仪表板所在文件夹`,
"front-electronic-signature-enter-object":`请输入对象`,
"vue_label_systemSettings_mobelquick":`移动应用程序快速设置`,
"lable.outlook.list":`Exchange Sync配置`,
"label.sendemail.approval.dlsp":`您好,#dlspr：\n      #actorname于#actordate提交的#objAPIName-#recordname因原审批人#spr设置您为代理审批人，正在等待您的审批，\n请点击如下链接或者登录CRM系统，进入审批中心进行审批：\n#url\n感谢！\n#orgName`,
"label.service.deleteCustomView.wanttoremove.filter":`是否确定要删除“{name}”筛选器?`,
"component_task_label_newevent":`新建任务`,
"vue_label_commonobjects_view_chart_groupby":`分组依据`,
"front-kefu-moudle-v1-edit-chats":`编辑坐席`,
"pagecreator_page_message_delete_fail":`页面删除失败`,
"label.file.search":`搜索文件`,
"label.projectManagement.Addpredecessors":`添加前置任务`,
"label_tabpage_norecordtypez":`不可用记录类型`,
"label.come.recycle.bin":`进入回收站`,
"label.reportsSubscriptionPage.schedulereport.monthly.time.relative":`相对`,
"label.customfields.address.tip":`允许用户选择省、市、县字段，并且输入具体地址信息，可用于计算经纬度。`,
"label.weixin.optioneight":`选项八`,
"label.recordtypeselect.modify":`编辑记录类型`,
"label.forecast.settings.future3":`未来3个周期`,
"label.rename":`重命名`,
"label.emailtocloudcc.button.complete":`完成`,
"chatter.new.at":`最新活动`,
"component.setup.label.milestonesfield":`里程碑字段`,
"vue_label_commonobjects_detail_email_newaddress":`收件人邮件地址`,
"lable.PowerProcess.big.event":`重大事件：`,
"label.appexchange.uninstallpage.confirm":`是，我要卸载此软件包，并永久删除所关联的组件`,
"label_mobile_buttom_homepage":`主页`,
"label.sso.saml.idp.config.logouturl":`单点注销URL`,
"lable.quote.pdf.button.savetoquote":`保存到报价单`,
"label.page.select.application":`选择要在其中使用新自定义菜单的自定义应用程序。也可以在每个自定义应用程序的详细信息和编辑页面上检查或修改是否显示某个菜单。`,
"chatter.down":`下载`,
"label.tabpage.searchz":`搜索`,
"label.emailsync.form.action":`操作`,
"label.campaignmember.setup.campaignmember.field":`市场活动成员字段`,
"label.version.remark":`备注：免费版仅限5个用户，可新建2000条记录，不支持数据导入与导出。`,
"label.selectoperateobject":`选择将要操作的对象`,
"label.appointmentdetail.wizard.title12":`最长可以提前预约的时间`,
"label.submitforapproval":`提交待审批`,
"label.the.lower.bound.of.each.layer.of.editing.discount.must.be.equal.to.the.upper.bound.of.the.upper.level.":`编辑折扣每1层的下界必须等于上1层的上界。`,
"label.appupload.install.component.view":`查看组件`,
"label.profile.customobjcontrol":`自定义对象权限`,
"label.customfields.configprofilefieldsafety.tip":`选择希望通过字段级安全性在其中赋予对此字段拥有编辑访问权限的简档。如果您不将该字段添加到字段级安全性中，它将不在任何简档中显示`,
"label.service.gantt.service.resources":`服务资源`,
"label.input.right.emailaddress":`请输入正确的Email地址`,
"label.ccdocument.folder.notedit":`该文件夹不可编辑！`,
"label.data.choses.i.desc":`根据您的需要，选择导入单个对象的数据。`,
"label.icon.75":`汽车`,
"label.summaryreport.step4":`步骤 4：选择报表列`,
"label.appupload.upload.install":`安装`,
"label.reportlist.newfolder":`新建报表文件夹`,
"label.projectManagement.myproject":`我的项目`,
"label.true":`真`,
"label.tabpage.reallproplez":`记录所有人`,
"label.change.lead.share.error":`无编辑客户权限`,
"F":`日期/时间`,
"lable.account.CurrentandNextCQ":`当前和下一个日历季度`,
"UG.activity.06":`想跟进客户`,
"UG.contact.03":`在一个地方跟踪联系人 销售讯号`,
"label.field.duplicate.error.msg2":`独有属性设置失败`,
"label.sales.dashboard.reality":`实际回款`,
"lable.PowerProcess.type":`权利过程类型`,
"batch.selected.data":`选中的数据条数`,
"#label.importsourcefilestep2":`步骤二：压缩您的文件(可选)#`,
"label.emailtemplate.select":`请选择您要使用的邮件模板`,
"chatter.most.w":`最多可以输入500个字符!`,
"vue_label_calendar_new_object_calendar":`新建对象日历`,
"label.aggregated_formsdata":`汇总表单数据`,
"label.knowledge.language.french":`法语`,
"label.customfields.enc.tip":`允许用户输入任何字母和数字组合,并将他们以加密格式存储,不可搜索。`,
"label.icon.158":`云`,
"font-evaluate-module-v1-bad-review ":`当评价类型是差评时`,
"UG_quota_03":`报价模板`,
"label.eidt.queue.label.hasused":`该标签已经被使用`,
"label.lookupfilter":`查找筛选器`,
"label.callcenter.Instance.name":`实例名称`,
"label.commitertype":`提交人类型`,
"vue_label_checkduplicate_any_one":`满足任意一条`,
"label.campaign.channel.input.img":`请从本地计算机选择图片做为感谢页面`,
"vue_label_dashboard_pleaseenterafoldername":`请输入文件夹名称`,
"label.tianyancha.look":`查看`,
"label.tabpage.lastone":`至少选择一条操作`,
"label.sendemail.approval.submit.title":`{!objLabel} - {!recordName}  等待您的审批`,
"label.chat.topic.delete.prompt1":`删除主题需要花费时间，直到过程完成，主题将继续在帖子和记录中保留。`,
"component_setup_label_displaybutton":`显示按钮`,
"label.partnerCloud.backgroundImage":`背景图片`,
"label.mobile.phone.time.range":`时间范围`,
"label.page.url.address.remark":`在“链接URL”字段中输入网页地址。可以简单的输入URL地址，如同在浏览器中显示的样式；也可使用一个或多个合并字段将组织的特定数据从CloudCC插入URL参数中。由于浏览器安全设置，或者因为站点阻止显示在框架中，一些站点可能在Web菜单中无效。`,
"label.h5.copyemail":`邮箱已复制`,
"label.view.step3":`步骤3.选择要显示的字段`,
"label.quickbooks.view.moneyreceived":`收款`,
"label.emailobject.attachment.preview":`预览`,
"label.selectapprover":`选择批准人`,
"vue_label_normal_opportunity_sf":`业务机会`,
"label_emailtocloudcc_filed_port":`端口`,
"mesage.errorinsaving":`保存过程中出现错误,请联系管理员`,
"label.partnerCloud.partnerCloudName":`请输入伙伴云名称`,
"lable.edit.queue.checkemail":`错误：电子邮件地址无效。`,
"label_builder":`页面构建器`,
"component_setup_label_setupsavefail":`组件设置保存失败`,
"label.icon.76":`汽车`,
"label.reportsSubscriptionPage.schedulereport.monthly":`每月`,
"message.nopermession":`权限不足`,
"label.view.groupscansee":`某些<b>用户组</b>可见`,
"label.leadscore.rule.new":`潜在客户打分：新建规则`,
"label.new.ccpeakfolder.time":`定时类：新建文件夹`,
"label.record":`记录`,
"message.error.flabel":`字段标签不允许含有英文单引号和双引号`,
"label.emailobject.emaildetail.promptbutton2":`取消`,
"label.h5.phone":`电话`,
"label.visualpage.error.deal.with":`发生错误，请联系管理员处理`,
"label.button.step1.select.field":`步骤1：选择字段`,
"label.setsharerule.step1":`第一步：选择将要设置的规则类型`,
"component.chatter.file.label.title":`文件上传`,
"front-epwechat-module-v1-appname":`应用名称：`,
"chatter.error.notsel":`错误：请先选择要上传的图片!`,
"label.updatevalue":`要更改的确切值`,
"label.chatter.sendEmailToGroupMember.subject.D":`{0}在小组{1}发布了全员文件`,
"label_tabpage_grid":`网格显示`,
"homepage.components.standard":`标准组件`,
"label.movable":`活动`,
"label.report.selected.field.cannot":`选中字段不能超过50个`,
"label.projectManagement.distribution.by.excess":`按超过分配`,
"addrow":`添加行`,
"label.approvaldatamove.p":`使用下面的选项管理多个等待批准的请求。要想开始，筛选批准请求记录，然后单击“查找”。显示结果列表时，指定要执行的操作。`,
"label.passwordPolicy.setup.title":`密码策略`,
"label.appointmentpage.wizard.title1":`{0}（{1}）邀请你`,
"label.tippage.li1":`永久删除自定义报表数据源`,
"label.campagin.roi.dcl":`到场率`,
"label.h5.new.errorbody":`请填写全部带有*标记的的必填字段`,
"label.cy.enable":`币种启用`,
"label.currency.rate.e":`编辑贵组织使用的币种之间的兑换率。`,
"or":`或`,
"lable.custom.Previous.CYt":`前两个自定义年度`,
"front-epwechat-module-v1-unbound-desc":`解除绑定之后，绑定账号将被清空，确定解除绑定吗？`,
"pagecreator_button_publish":`发布`,
"font-evaluate-module-v1-case-owners":`通知个案所有者：`,
"label.pw.new":`请输入新密码`,
"message.tabsearch.nokeywords":`请输入至少一个字符长度的关键字`,
"label.sendemail.send.erroruser":`错误的用户`,
"label.personalinfo":`我的个人信息`,
"label.case":`个案`,
"lable.product.pricebooks.now":`现有价格手册`,
"label.ccpeak.take.notice":`注意：ID，自动编号，创建人，创建时间等系统字段不需要赋值！`,
"label.page.first":`第一页`,
"label.icon.168":`景点`,
"label.choices":`选择`,
"label.is.delete.document":`是否删除该文档？`,
"homepage.layout.custom":`自定义布局`,
"label.emailobject.template.insert.field":`插入字段`,
"label.ccpeak.folder.all":`所有类文件夹`,
"front-console-conversation-btn3":`转发邮件`,
"label.ems.port":`端口号`,
"label.app.introduce":`应用程序"是指作为一个单位提供功能的一组菜单。用户可以在每个页面右上角下拉选择应用程序，菜单会在不同的应用程序直接切换"`,
"label.file.library.managemembers.admin":`文档库管理者`,
"vue_label_salesadvance_win":`赢单`,
"label.email.click.complete.info":`单击"完成"按钮，返回上一页`,
"label.umeng.activity.event.willbegin":`您的事件#event即将在#time后开始`,
"label.mobile.phone.week.summary":`本周总结`,
"label.quickbooks.fieldlabel.terms":`条款`,
"lable.currencyManage.advcurrencyEnabled.dis":`您可以将货币兑换率汇率映射到特定的日期范围内的过期汇率。过期汇率用于业务机会、业务机会产品和这两个对象相关的报表。`,
"label.weixin.data.save.failed":`数据保存时失败`,
"label.service.gantt.filter.logic":`筛选器逻辑：`,
"vue_label_pool_adopt":`领取`,
"label.emailobject.markasunread":`未读`,
"label_please_select_a_member":`请选择成员`,
"label.salescloud.unit.ci":`单位（个）`,
"vue_label_pool_obsolete":`已废弃`,
"label.cancelall":`取消全选`,
"label.exchange.sync.state.setting.m2":`已启用 CloudCC Exchange 配置中的用户：`,
"vue_label_pool_claimtime":`认领时间`,
"label.forecast.forehistory.history":`的预测历史`,
"label.knowledge.article.record":`知识文章不符合要求`,
"label.setting.intergrationlist.button.uninstall":`卸载集成`,
"label_tabpage_gotit":`知道了`,
"label.data.exp.csvform":`只针对导出数据有效`,
"UG.Forcast.06":`请选择允许预测的用户`,
"vue_label_report_savereport":`保存报表`,
"setup.object.field.dependency.label.mustone":`请至少设置一个依赖字段的值`,
"label.batchadd.newbatchpage.des1":`记录的name字段为必填项，若未填写，则该条数据默认不被保存`,
"lable.custom.CurrentandPreviousCYt":`当前和前两个自定义年度`,
"label.versiontype.Professional":`专业版`,
"label.customfields.configprofilefieldsafety":`配置简档字段的安全性`,
"label.ccpeak.wgd.time":`未归档的定时类`,
"component.telerecord.label.subject":`主题`,
"label_year":`年度`,
"pagecreator_layout_label_modifylayout":`布局编辑器`,
"label.compact.layout.frame.splitline":`----左右分屏线----`,
"lable.PowerProcess.enter.the.process":`{describeName}进入过程`,
"label.emailobject.cc":`抄  送：`,
"front-electronic-export-choseCount":`请选择导入的数据`,
"label.setup.mobile.bottombutton.recovery.default.success":`恢复默认成功
`,
"label.datamanage.import.accountfield":`在下表中，选择导入文件中应导入到每个客户的字段。完成操作后，点击下一步：`,
"vue_label_opportunity_related_list":`添加到相关列表`,
"label.group.recent":`最近查看小组`,
"vue_label_pool_finalclaimtime":`最后认领时间`,
"vue_label_homepage_30daysnocontact":`30天未联系的业务机会`,
"label.tianyancha.field.error":`未找到天眼查字段，请联系系统管理员先执行初始化操作`,
"label.product.go":`转至报表`,
"label.customsetting.manage.introduce":`如果自定义设置是列表，单击新建添加一组新数据。例如，如果应用程序具有国家代码设置，则每组可能包括国家的名称和电话代码。`,
"label.task.dateadd":`加`,
"label.email.recipients.select":`请选择收件人`,
"chatter.emailListMyChat":`对我的微贴或回复点喜欢时`,
"label.batchadd.newbatchpage.save.name":`如果名称为空，系统将默认不添加此条记录，请确保您的名称不为空再保存`,
"UG_Lead_011":`创建一个线索`,
"vue_label_salesfunnel_notice2":`进行中机会总数量`,
"APPIntegration_Social_linkedinerror":`必须是一个合法的linkedin.com的URL`,
"label.industrialandcommercialverification.enablestatus2":`客户名称实时查询`,
"label.stdashbord.xsld.business.ajssx":`角色筛选`,
"lable.info.queue.showalluser":`查看所有用户`,
"label.generatepage.c1":`必须以字母开头，只能包含大小写字母，数字，下划线`,
"label.thenset":`然后按`,
"label.salescloud.salescloud.defaultteam":`用户的默认业务机会小组`,
"label_partner_workspace_tab_selectedoption":`已选菜单`,
"label.tippage.li":`删除自定义报表数据源将会：`,
"lable.quote.syncingfrom.syncingto":`业务机会产品已同步到报价单明细。`,
"label.emailobject.delete":`删除`,
"label.data.selectimportobject":`选择需要导入的对象`,
"label.knowledge.language.dutch":`荷兰语`,
"message.campaign.page.overtime":`该页面已过期`,
"label.ccchat.message.search.desc4":`检查搜索词的拼写。`,
"label.login.forgetPsd":`忘记密码`,
"vue_label_title_order":`订购`,
"template.report.contract.follow.status":`合同的跟进状态`,
"label.forecast.edit.kjnd":`会计年度`,
"front-electronic-export-listTitle":`Mailchimp列表`,
"label.dataimport.error.khmc.notnull":`出现错误：客户名称不能为空。`,
"label.testobject":`测试对象`,
"label_chatter_nextStep":`后续步骤`,
"label.file.public.link.share":`公用链接共享`,
"label.weixin.organization.name":`组织名称`,
"label.quote.email":`电子邮件`,
"label.reg_field":`常用字段`,
"font-evaluate-module-v1-response":`评价之后显示的回复：`,
"label.chatter.sendmail":`发送电子邮件`,
"label.weixin.start.incorrect":`开始日期格式不正确`,
"component_chatter_link_label_url":`链接URL`,
"vue_label_pool_operatecertification1":`{0}{1}{2}`,
"lable.currencyManage.Enabledadvcurrency.agree":`是的，我要启用高级货币管理。`,
"label.east.africa.time":`东非时间`,
"label.product.proof.Three":`请在{0}处，最少选择{1}个产品选项，最多选择{2}个产品选项。`,
"label_emailtocloudcc_filed_password":`邮箱密码`,
"component.task.label.person":`*被分配人`,
"pagecreator_systemstyle_label_buttonareacolor":`操作区颜色`,
"label.clearrule":`清空规则`,
"lable.customer.access":`客户访问权限`,
"label.finish.wait":`已处理您的请求，需要等待系统处理完成，请随时注意查看您的电子邮件。`,
"label.weixin.appr.auditor":`审批人`,
"label.tabpage.systemz":`个系统`,
"label.file.nocan.process.desc":`无法处理请求 我们无法处理内容传递`,
"label.relationobject.name":`相关对象名称`,
"setup.layout.group.relatedlist":`相关列表`,
"label.generatepage.title":`Web to CloudCC 页面`,
"label.page.step3.input.url.information":`步骤3：输入URL详细信息`,
"label.change.to":`更改市场活动成员状态至`,
"label.validate.function.funcFormat.TIMEVALUE":`TIMEVALUE(date)`,
"label.partnerCloud.seriesSettings":`产品系列设置`,
"component.timeline.label.1monthahead":`前1个月`,
"label.batchadd.senumberpage.selnum":`选择要添加记录数目`,
"label.downloadapp":`下载App`,
"label.dashboardSetup.showmainpage":`首页显示`,
"label.h5.nophoneprompt":`该同事没有录入联系电话`,
"label.service.deleteCustomView.wanttoremove.theFilter":`是否确定要删除“{name}”筛选器?`,
"label.appupload.state1":`已上载`,
"component_timeline_button_filter":`筛选`,
"label.passwordPolicy.setup.subtitle":`设置应用于所有用户的密码限制和登录锁定策略`,
"vue_label_normal_quote_sf":`报价单`,
"label.productsales.today.noevttskaddall":`今天没有未处理的事件或者到期的任务，您也可以点击右上角的“ ”添加任务或者事件！`,
"label.projectManagement.no.end.date":`暂无结束日期`,
"label.sendmail.batch.chosetemplate":`批量发送电子邮件：选择模板`,
"serviceterritorymember.serviceresource.isactive.notactive":`此服务资源未启用，您可以将服务区域分配到已启用的服务资源上`,
"label.notification.event.overlapEvent.continue":`继续创建`,
"label.appupload.component.type.obj":`自定义对象`,
"label.partnerCloud.financeSetting.basicConfiguration":`获取路径：公众平台-开发-基本配置`,
"lable.outlook.detail.info":`Exchange Sync配置详细信息`,
"vue_label_commonobjects_detail_activity_commingevents":`拥有即将进行的事件`,
"coderules.nullvalue2":`生成失败,请给生成规则中使用的【{0}】,【{1}】录入值`,
"label.version.sum.workflowrule":`个工作流规则`,
"label.sso.saml.idp.config.enable":`启用身份提供商`,
"label.temp.exp.conf":`确认要导出模板吗？`,
"label.department":`部门`,
"label.trigger.operation.email.template":`获取邮件模板信息`,
"label.page.content.frame.height":`内容帧高度（像素）`,
"label.ServiceCloud.jinengyaoqiu":`技能要求`,
"PageLayout.Search.MultiSearch.001":`您最多只能选择不超过3个字段。`,
"label.error500":`呀！出错了...<br />快去找系统管理员吧...`,
"label.appexchange.download.stop":`遇到冲突，停止安装`,
"label.service.dispatchingUnits.left.right.totalAll":`当前{left}-{right}条数据，共{totalCount}条数据`,
"label.tabpage.haschangedz":`该潜在客户已经转化`,
"label.industrialandcommercialverification.button.cancel":`取消`,
"label.edit.role":`修改角色`,
"label.mr.descreption.condition2":`规则-按前几个字符：请输入数字，按输入数字的前几个相同字符查询重复数据。`,
"label.testgrammer":`检查语法`,
"label.age":`年龄`,
"lable.real.time.chat":`实时聊天由环信提供技术支持，您可以直接在环信中配置高级设置。`,
"vue_label_opportunity_selected":`已选择{sum}个`,
"label.weixin.optionone":`选项一`,
"label.file.delete.public.link.desc":`删除公用链接表示没有人可以访问带有该URL的文件。如果您创建新公用链接，将成为不同的URL。`,
"label_tabpage_cancel":`取消`,
"template.report.opportunity.analysis":`业务机会阶段分析`,
"label.escalation.setup.newrule.inputrule":`输入规则名`,
"label.ccpeak.getapi.name":`取记录值的时候直接get字段的API名称：`,
"second":`第二个`,
"label_tabpage_uploadsz":`上传`,
"label.description":`备注`,
"label.ccchat.person.invite.notsamepwd":`密码不一致`,
"label.mobile.app.isEnableAblumWatermark":`签到时从手机相册选择的照片增加水印`,
"vue_label_allsearch_searchable_items":`可搜索项`,
"lable.outlook.detail.react":`最近的活动`,
"label.sales.team":`业务机会小组`,
"label.guif.standard.time":`波斯湾标准时间`,
"label.emailobject.emaildetail.button.forward":`转发`,
"label.refused":`已拒绝`,
"homepage.components.one":`步骤1：填写自定义组件名称`,
"day":`日`,
"label.dataimport.error.number":`出现错误：数字`,
"label.customer.tab.step2.same.option2":`默认关闭`,
"component_button_ok":`确定`,
"label.allrecordmeetprocess":`所有记录都应进入此步骤`,
"label.version.onefile.size":`单个附件上传大小`,
"label.partnerCloud.orderingPlatform.allProducts":`全部产品`,
"pagecreator.page.message.publish.success":`页面发布成功`,
"lable.currencyAdv.exchagecurrency.rate.pro":`上一个范围`,
"label.attendance.persons":`适用人员`,
"label.send.an.email":`发送电子邮件`,
"registration.page.browser.title":`市场活动营销渠道注册`,
"label.importfilestep3":`步骤二：选择并上传您的文件`,
"lable.currencyAdv.exchagecurrency.rate.next":`下一个范围`,
"label.ems.no.sync.msg":`您还没有配置邮件同步信息.`,
"label.total_views":`表单提交概览`,
"label.knowledge.article.notnull":`选择至少一篇文章。`,
"message.error.view.lastview.delete":`不能删除最后一个公共列表视图</br>您不能删除所有用户皆可视的最后一个列表视图<br><br>`,
"label.integrations.second.half":`条数据，选择导入的数据`,
"vue_label_systemSettings_mobelparams":`移动端参数设置`,
"message.choose.maximum":`共享信息最多选择150，现已选择`,
"vue_label_homepage_won&unprocessed":`已赢单 未处理`,
"UG.contact.01":`如何充分利用您的联系人?`,
"label.data.import.setup.remark":`系统管理员可以对数据导入时执行的规则进行设置，包括是否执行验证规则、触发器、查重过滤器`,
"pagecreator_layout_message_delete_success":`布局删除成功`,
"lable.account.name":`会计季度名称`,
"label.userinfo.must.updatepwd":`基于安全原因，您现在必须更改密码。`,
"label.mobile.phone.subordinate.setup":`不可设置是否包含下属，请选择所有人并设置他允许预测`,
"label.monitorsys.delete.date":`日期`,
"label_emailsync_form_emailaddress":`邮箱地址`,
"label.projectManagement.cancelled":`已取消`,
"label.partnerCloud.partnerAccount.rechargeAmount":`充值金额要在0.1到100000000之间`,
"label.select.relatedlist.approval.layout":`选择要在批准页面布局上显示的相关列表`,
"label.userphoto.thumbnail":`缩略图`,
"label.assignment.setup.list.rulename":`规则名称`,
"label.emailtemplate.usemergefields":`邮件模板中使用合并字段`,
"label.tabpage.enabletomobile":`是否启用到移动端`,
"setup_layout_label_desc":`降序`,
"vue_label_pool_abandonreasondiscription":`废弃原因描述`,
"label.ems.outputmails":`Send Email Server (smtp)`,
"font-evaluate-module-v1-evall":`全部评价`,
"front-epwechat-module-v1-unbound-tips":`解绑后您的以下数据都会被清除：`,
"label.weixin.number.data":`条数据`,
"front-objectTemplate-V1-UseObject":`适用对象`,
"label.call.center.configuration":`Call Center 设置`,
"vue_label_systemSettings_website":`网站版客户服务门户`,
"lable.currencyAdv.foreverdate":`永久日期`,
"label.globalselect.view":`查看选项列表值集`,
"component_newrecords_label_title":`最近记录`,
"component_assistant_label_title":`助理`,
"label.equals.deletebut.bulk.delete":`包括删除按钮，批量删除(回收站)`,
"label.field.duplicate.error.msg4":`错误：无效数据。`,
"label.input.right.date":`请按正确的日期格式输入`,
"file.error.notsel":`错误：请选择要上传的文件`,
"label.customcomponent.page.add.title":`新建自定义组件`,
"message.chooseatleastthreefield":`至少选择三个字段`,
"label.dataimport.system.unnecessary":`，系统无法确定多余哪`,
"message.login.wrong":`用户名或密码不正确！`,
"label.appupload.install.recheck":`重新检查`,
"label.ems.option":`选项`,
"label.wei.subject.img":`主题图标`,
"chatter.emailReceiveOrNotAccept":`勾选接收CCChat提醒，取消勾选不接收。`,
"label.icon.46":`炉`,
"label.newpw":`新密码`,
"font-evaluate-module-v1-praise":`评价类型是好评`,
"label.help.user":`用户指南`,
"label.callcenter.no.searchs":`没有相关查询到信息`,
"UG_homepage_007":`从发送跟进邮件到销售活动自动化，从使用我们的蓝图科技创建工作流到触发定制的宏，自动化日常任务，并更专注于建立关系。`,
"label.saveandnew":`保存并新建`,
"component_salesperformance_label_70finish":`已结束-未处理（>70%）`,
"lable.account.dp":`此页允许您定义自定义会计年度。`,
"label.notification.serviceappointment.injeopardy":`}处于危险状态，请尽快处理
`,
"label.workflow.edit.esimaterule":`错误：当该规则还具有关联的时间触发器时，您不能将评估条件更改为“每次创建或编辑记录时”。`,
"label.partnerCloud.basicSetting.feature":`功能设置`,
"label.sms.companyname.gm.infor":`创明网络短信接口信息`,
"vue_label_homepage_components":`请选择组件`,
"label_chatter_allactivity":`所有活动`,
"label.quickcreate.title":`快速新建布局`,
"label.tabpage.exclusivez":`不包含`,
"front-service-cloud-transfer-desc":`转移资产BOM所有人时，会将当前资产和资产下的自己资产逐一更改所有人`,
"label.data.downpage.i.list.desc1":`在导入的过程中，因为数据格式不正确，或者因为触发器或验证规则校验失败，而未成功导入的数据，都会生成csv文件显示在当前页面。而成功导入的数据，则不会在当前页面显示。`,
"template.report.individual.case.status":`个案状态`,
"label.report.export.file.format":`格式：Excel 格式.xlsx`,
"vue_label_filternotice1":`即同时满足每个筛选条件，例如：1位金额大于100万业的业务机会，2为预计签约日期等于本月的业务机会，则筛选结果显示本月大于100万的业务机会；当<spanstyle="color:red">启用高级筛选</span>时，需要手动筛选条件写入高级筛选框中`,
"label.lead.score.confirm1":`打分过程可能需要花费较长的时间，一旦打分完成，您会收到一份确认邮件。`,
"label.scores":`分`,
"label.dashboard.message.mainnoset":`主页仪表板没有配置`,
"label.customfields.optionlist.fieldvaluelist":`在下面为选项列表字段输入一列值，每个值应单独占一行`,
"label.autosearch.title":`自动完成标题搜索`,
"label.knowledge.setting.hint.seventeen":`创建一些文章`,
"label_tabpage_closez":`关闭`,
"label.partnerCloud.orderingPlatform.shoppingCart":`购物车`,
"label.recalculate":`重新计算`,
"label.umeng.approval.approvalmes4obj":`#obj里有#numsucc条审批成功，#numfailed条审批失败，`,
"label.appointment.wizard.subtitle2-2":`至`,
"label.validate.function.funcExplain.AND":`检查是否所有参数均为真，如果所有参数均为真则返回TRUE`,
"label.recordtype.batchaddattachments.remark":`步骤 1.选择文件；  步骤 2.是否归档文件；  步骤 3.单击“开始上传”按钮，上传文件； 步骤 4.单击“完成”按钮，返回上一页`,
"label.reportlist.findreport":`查找报表`,
"label.partnerCloud.financeSetting.enterAppsecret":`请输入Appsecret`,
"label.campagin.roi.query2":`查询市场活动营销渠道ROI`,
"label.sendmail.notice.immediately":`立即发送邮件通知`,
"label.file.library.managemembers1":`管理成员`,
"label.forecast.customforecast.foredis.yclb":`预测类别`,
"label.no.target.model.available.":`无可用目标模型。请先创建目标模型，也可联系系统管理员。`,
"label.quote.contactname":`联系人姓名`,
"label.customer.tab.step2.same":`将菜单的可视性应用到所有简档`,
"UG_product_03":`多币种支持的价格手册`,
"label.pc.system.prompt":`系统提示`,
"homepage.components.description":`组件描述`,
"front-email-payment-safety-code":`安全码`,
"label.the.extra.reward.group.describes":`添加报价行组描述`,
"label.isEnableVisualpage.new.rightlist":`已启用的自定义页面`,
"label.icon.84":`变压器`,
"label.chat.message.to":`收件人`,
"lable.product.pricebooks.edit":`价格手册编辑`,
"label.partner.workspace.member.belong":`属于`,
"pagecreator_systemstyle_message_delete_success":`样式删除成功`,
"label.salescloud.teamrole.message.chooseatleastone":`请至少选择一个用户`,
"label.knowledgebase.self.window":`同一窗口`,
"label.product.cost":`销售底价`,
"label.imgfield.remove":`清除图片`,
"label.event.lastweek":`上周`,
"template.report.today.statistics":`本日销售统计`,
"label.emailobject.recipients":`收件人 （{0}）：`,
"vue_label_commonobjects_view_successfully":`设置默认视图成功`,
"label.uploadfail.typeerror":`上传失败，图片格式错误!`,
"vue_label_lead_required_fields":`请填写必填项`,
"front-console-reopen":`重新打开`,
"message.layout.unique.relatedlist":`违反页面布局中相关列表的唯一约束，请确认后重新保存!`,
"label.emailobject.emaildetail.nextactivity":`接下来的活动`,
"label.publicgroup.save.error":`错误：下面的某个小组已是此小组的父级`,
"label.editdefaultshare.tip":`在下面编辑您整个组织范围内的共享默认设置。更改这些默认设置将导致重新计算所有共享规则。根据贵组织中的数据量，这可能需要耗用大量系统资源和时间。`,
"label.icon.53":`车`,
"label.exchange.sync.state.setting.m3":`带有已链接 Microsoft Exchange 和 CloudCC 电子邮件地址的用户：`,
"label.currency.enable":`币种：启用币种`,
"component.timeline.label.past":`过去活动`,
"workflow.action.tasks.assignortype.user":`用户`,
"setup_layout_label_relatedlistsetup":`相关列表设置`,
"label.systemadmin":`系统管理员`,
"label_tabpage_allz":`所有`,
"label.ems.subject":`主题`,
"message.recordtype.selectlayout.tip":`选择具有此简档用户将看到的此记录类型的记录采用的页面布局。保存后，选择此记录类型的可用选项列表值。`,
"label.current.version":`当前程序版本`,
"label.sourceoffile":`未翻译的语言文件：未翻译的语言文件`,
"label.file.versionerror":`请在新版界面中使用文件菜单功能`,
"label.validate.function.funcExplain.MINUTE":`返回日期/时间字段中的分钟数`,
"abel.setup.mobile.bottombutton.profile.setting":`定制简档底部菜单
`,
"label.recycle.dis.tip3":`从下拉列表中选择我的回收站能查看您删除的数据。管理员用户可以选择查看全部回收站。`,
"message.selectnothing":`未选取任何内容`,
"label.develop":`开发`,
"label.tab.lightningpage":`Lightning版本页面`,
"label.chat.micropost.share.info":`共享`,
"label.block.pricing.editor":`分块定价编辑器`,
"label.ccchat.file.unavailable":`该文件不可用`,
"label_component_helper_businesschange_0UntreatActivity":`无未处理活动的业务机会`,
"label.search.setup.obj":`最多可设置100个对象`,
"component.setup.button.cancel":`取消`,
"message.longtextareamaxlength":`长度不能超过32000`,
"vue_label_chat_removedby":`你被“管理员”移出了群聊`,
"label.autoRegister.changepwd.setpwd.tip.morechar":`不能少于8个字符`,
"label.informassigner":`通知被分配人`,
"font-evaluate-module-v1-not-received":`您尚未从联系人收到满意度评价`,
"label.trigger.triggertime":`触发时间`,
"label.attendance.cannot.make":`无法标注`,
"label.shouldallrecords":`此计算应包括所有的记录`,
"label.eidt.queue.alter1":`请选择队列成员`,
"L":`选项列表`,
"label_emailtocloudcc_filed_email":`邮箱`,
"label.productsales.contract.badversion":`您当前的版本不支持合同对象无法查看合同业绩`,
"label.tabpage.operation":`操作`,
"label.file.copy.public.link":`已复制该公用链接`,
"label.all.SMS":`全部短信通知`,
"UG_opportunity_008":`业务机会小组`,
"UG.Campaign.002":`规划、执行并监控市场活动的效果。`,
"label.jiandangfenpei.title":`简档分配`,
"pagecreator.systemstyle.message.delete":`是否删除当前所选样式？`,
"lable.outlook.mcto.repeat":`如果找到重复记录，则将电子邮件关联到`,
"label.user.field":`用户字段`,
"vue_label_commonobjects_detail_market_hierarchy":`市场层级结构`,
"label.ems.emails":`邮件`,
"label.tabpage.deleteviewfailed":`视图删除失败`,
"label.data.exp.new.expobjtemp":`制作导出对象模板`,
"label.useformulassetval":`使用公式设置新值`,
"label.service.newBuildDialog.six.fields":`最多选择六个字段`,
"error":`错误`,
"template.chart.sdyyfx":`输单原因分析`,
"label.icon.191":`胡子`,
"label.app.step3.tabused":`选定的菜单`,
"label.user.level":`用户级别`,
"label.custombutton.querydata.notexist":`查询的数据不存在`,
"label.executestate.calculating":`计算中...`,
"label.visualpage.folder.notdel2":`1、当前文件夹中含有文件，无法删除！ 2、当前文件夹中含有隐藏文件，无法删除！隐藏文件是根据逻辑删除对象（设置-创建-对象下已删除的对象）创建的文件，因该对象未真正删除所以隐藏此文件。`,
"vue_label_report_conditiondesc_three":`您将在满足所有条件时获得通知`,
"approval.request.email.subect":`审批请求`,
"label.log.user.value":`请输入查询用户名!`,
"label.isCompanyCurrency":`公司`,
"label.related.2018":`相关列表`,
"label.tonga.time":`东加时间`,
"message.actionfailed":`操作失败`,
"label.’s":`的`,
"label.custombutton.queryobj.notnull":`查询的对象ID不能为空`,
"label.list.userinterface.setup":`用户界面设置`,
"front-kefu-moudle-v1-yxgsbzq-reinput":`邮箱格式不正确，请重新输入`,
"label.chatter.content":`内容`,
"label.projectManagement.Addnotes":`添加备注`,
"label.service.newBuildDialog.reservation":`显示预约`,
"label.ccchat.pm":`下午`,
"vue_label_chat_cannot_invite_users":`非群主不能邀请用户加入群聊`,
"label_partner_workspace_member_belong":`属于`,
"label.task.modify":`编辑任务`,
"label.tabpage.transformationsz":`转化`,
"label.new.password.no.indexof":`新密码不能包含中文和空格`,
"label.ji.quarter":`第{a}季度`,
"label.sso.isActiveNo":`否`,
"label.mobile.phone.week.report":`周报`,
"label.email.template.please.select.folder":`请选择文件夹`,
"label.pc.ui.2018.tab.groups":`菜单组`,
"label.h5.approval.status":`审批状态`,
"setup.mainpage.label.welcome27":`CloudCC 云平台提供系统内所有对象数据的导入、导出、数据批量删除、批量转移等功能。`,
"vue_label_systemSettings_setHomePage":`设置主页`,
"label.select.button":`可选按钮`,
"label_emailsync_status_enable":`启用关联`,
"label.trigger.triggerVersion.detail":`此字段不可编辑，触发器目前有两个版本1.0和2.0版，新建的触发器全部为最高版本2.0，1.0版本已禁止创建`,
"pagecreator_layout_message_save_fail":`布局保存失败`,
"label.salescloud.salesdashboard.10big":`未来3个月前10大业务机会`,
"label.file.share.size":`每个文件最大共享和公用链接数量为`,
"label.page.simple":`简单`,
"pagecreator.page.message.delete":`是否删除当前所选页面？`,
"label.weixin.newspaper.coverage.detailinfo":`报险单详细信息`,
"label.list.userinterface.chattersetup":`CCChat设置`,
"lable.opppdt.addpdt.table.quantity":`数量`,
"label.product.description":`产品描述`,
"button_partner_back":`返回`,
"label.user.current.loginuser.sessionid":`当前登录用户SessionID是：`,
"label.otherreport":`其它报表`,
"pagecreator_button_mobilepage":`手机端`,
"label.mobile.phone.state":`批阅状态`,
"lable.currencyManage.unenableCurrencyAdv":`禁用高级货币管理`,
"lable.product.addp":`添加价格`,
"label.field.validate.notpass":`验证通过，没有发现语法错误`,
"label.app.global.search.obj":`应用于全局搜索中搜索的对象，最多可设置{0}个对象。`,
"label.group.archived":`归档`,
"vue_label_approve_to_submit":`待提交`,
"showfrom":`显示第`,
"chatter.emailNotification":`电子邮件通知`,
"label.callcenter.pleaseenter.enterprise.number":`请输入企业编号`,
"label.forecast.customforecast.forecastnumber":`预测数字`,
"label.vlidaterule.messagelocation":`错误位置`,
"label.h5.similar.opportunity.step3.conment":`将会始终显示表示匹配字段数量的相关性列`,
"label.ccchat.group.gd.setting.info":`修改CCChat小组设置`,
"label.knowledgebase.delete.article.succeeded":`删除文章成功`,
"message.layout.edit":`页面布局管理为单独增值功能，如您的组织确认已经采购了该功能模块，向系统管理员询问使用密码。更多问题可联系CloudCC.com进行支持。`,
"label.case.create":`个案({0})已创建`,
"label.icon.170":`购物`,
"message.error.contact.null":`联系人不能为空`,
"label.appupload.install.error.hasinstalled":`此软件包已在贵组织中安装。在安装新版本之前，你需要先卸载已安装版本。`,
"label.service.miniProgram.imageType":`图片支持类型PNG、JPG、JPEG，建议大小750*349像素。鼠标悬浮在图片上可重新上传或删除图片。`,
"label.leadscore.rule.edit":`潜在客户打分：编辑规则`,
"vue_label_commonobject_anytime":`任意时间点`,
"label.clearing.conditions":`清除条件`,
"label.campagin.roi.ydkhjhze":`赢得客户机会总额`,
"Lead_Auto_Scoring_Setting_001":`潜在客户在保存或者编辑时自动打分。 （不包括批量导入与接口创建）`,
"pagecreator.systemstyle.label.buttonareacolor":`操作区颜色`,
"label.batchregist.huanxinuser.finish":`批量注册用户已完成`,
"UG_opportunity_006":`业务机会天才`,
"message.serviceappo.violation":`派遣时间违规:此时段与其他服务预约冲突`,
"label.recordtypeselect.selectnew":`选择新记录类型`,
"Lead.Tools.BatchScoring":`潜在客户批量打分`,
"label.partnerCloud.financeSetting.enterWechat":`请输入微信支付商户号`,
"label.philippine.time":`菲律宾时间`,
"five":`五`,
"label_average_value":`平均值`,
"message.realdelete":`确定要彻底删除吗？`,
"label.currency.note":`输入新币种的信息。请注意，启用币种之后就不能再将其删除。`,
"label.projectManagement.delete.prompt":`删除提示`,
"label.approval.present":`（当前）`,
"label.escalation.setup.newrule.name":`规则名`,
"label.edit.list":`可编辑数据列表`,
"label.partnerCloud.financeSetting.informationOne":`1.访问支付宝商家中心（b.alipay.com），用签约支付宝账户登录。`,
"label.customfields.numberText":`2.输入数字的长度与小数位数之和不能超出18位`,
"label.biaoqing.businessverify.relation.tip":`将标情返回的字段的值回写到潜在客户字段上`,
"label.icon.149":`机器人`,
"System.btn.SaveAndCommit":`保存并提交`,
"label.calendar.many":`多人`,
"label.ccchat.create.email":`已创建电子邮件`,
"template.report.income.marketing.activities":`市场活动收入报表`,
"label.ccchat.person.invite.needemail":`输入一个电子邮件地址。`,
"template.report.open.amount":`未关单金额`,
"label.currentoperate":`已存在的操作`,
"label.finalapprove":`最终批准`,
"label.emailmerge.mergepage.step2":`2. 选择要合并的模板最多20个：`,
"label_tabpage_sorttypez":`排序类型`,
"label.workbanch":`我的工作台`,
"font-evaluate-module-v1-disable":`您确定要禁用吗?`,
"label.ServiceCloud.distributionMap":`分布图`,
"lable.Confirm.potential.customers":`确认领取{num}个潜在客户`,
"label.mobile.quickcreate.default.nearby":`附近`,
"label.isremider.noremider":`不提醒`,
"label.approval.select.step":`选择要返回的审批步骤`,
"chatter.error.pm":`错误: 上传图片文件过大!`,
"UG_activity_08":`预约一个日程`,
"label.marketsea.notwinopportunitydays":`天未成交天数（需大于未创建业务机会天数）`,
"label.selectpage":`选择一个现有页面`,
"label.dashboard.dispalyOnTheHomePage":`显示的主页`,
"front-lightning-module-v1-details-page-chart-set-report":`设置报表`,
"vue_label_pool_mydeal":`我成交的`,
"vue_label_report_lastone":`最后一个`,
"label.tabpage.potentialcustomersz":`潜在客户`,
"font-evaluate-module-v1-more-satisfied":`我们做的还不够好，下次一定会让您更加满意！`,
"label.trigger.instructions":`<font color="red">注意：触发器代码容量最大支持200KB字符约200000字节</font><font size=3 color="red"></font>`,
"lable.SalesCommitmentKanBan.commitmentToCompletionRate":`承诺完成率`,
"label.umeng.approval.dlsp.approvenew":`代理审批：#actorname正在请求批准#objAPIName#recordname`,
"label.edit.visualpagefolder":`自定义页面：编辑文件夹`,
"label.pc.flash.teach":`视频教学`,
"label.showsearch":`显示搜索`,
"label.reportsSubscriptionPage.condition.title1":`你会在所有条件都被满足之后收到通知`,
"label.h5.search.result":`结果`,
"vue_label_commonobjects_view_chart_pie":`饼图`,
"label_please_enter_currency":`请输入币种`,
"chatter.share.to.profile":`您的简档`,
"label.mykeeptouchset":`我的保持联系设置`,
"label.profile.mustcopyaprofile":`您必须选择一个要复制的现有简档。`,
"label.managereport":`管理报表`,
"label.total.choice":`个文件，共选择了`,
"label_emailtocloudcc_help":`请输入正确的电子邮箱密码或授权码。如果您的电子邮箱服务端需要开启IMAP/SMTP服务才可由第三方客户端登录，您必须先登录电子邮箱进入设置确保此服务已开启，并复制相应授权码输入至此密码框。`,
"label.trigger.sel":`此文件夹中的触发器`,
"label.dashboardLookUp":`查看仪表板`,
"label.batchadd.newbatchpage.save.emptytext":`存在必填项未填写，请检查`,
"setup.mainpage.label.welcome16":`操作指导： 点击本页左侧菜单 → 应用程序设置 → 创建 → 工作流、批准过程、任务、电子邮件通知、字段更新等。`,
"vue_label_email_mark as":`标记为`,
"label.customobjdel.cannot.delete.try":`无法完成对象的删除尝试，因为它与同其他对象的以下关系相关联。`,
"label.customsetting.visible.public":`公用`,
"label.log.bit":`位数`,
"label.data.exportall.all.desc":`导出当前用户所有有权查看的对象的数据。`,
"message.login.mfadevice.already.bound":`用户已经绑定MFA设备`,
"label.campaign.channel.please.img":`请上传图片`,
"assetbom.manage.notpermission":`请联系管理员，开启管理资产BOM权限`,
"schedstarttime.schedendtime.time.illegal":`服务预约的已计划开始时间应小于等于已计划结束时间。`,
"label.referperson":`所有人`,
"front-email-payment-area":`区`,
"label.c.d.least":`每个 C" 记录必须至少有一个相关 "D" 记录。"`,
"label.weixin.longitude.isnull":`经纬度为空或者无效`,
"setup.layout.button.ok":`确定`,
"vue_label_fiter_component_date_customdate":`自定义日期`,
"label.enable.case.createarticle":`允许用户从个案中创建文章`,
"label.event.moveup.8hour":`提前 8 小时`,
"label.input.most.string":`请输入至多 {0} 个字符`,
"lable.SalesCommitmentKanBan.contractEndDate":`合同结束日期`,
"label.visualpage.function.name":`方法名命名为:`,
"label_emailtocloudcc_redmessage1":`请输入正确的电子邮箱地址`,
"message.aliasnameinput":`错误： 唯一名称只能包含字母数字字符，必须以字母开头，并且必须是唯一的`,
"label.data.exp.selectedtemp":`选择数据导出所需模板`,
"label.import.page1.suitedwayoflinkman":`匹配联系人方式`,
"label.customsetting":`自定义设置`,
"label.versiontype.Free":`免费版`,
"setup.layout.label.norelatedlist":`暂无相关列表`,
"label.forecast.edittotal.de.leiji":`的累计`,
"label.customfields.file.max":`上传的文件过大,请不要超过5M。`,
"label_partner_all_workspace":`工作区`,
"label.searchrelation":`查找关系`,
"label.icon.185":`咨询`,
"label.service.gantt.effective":`有效`,
"label.newreportstp1":`步骤 1：选择报表格式`,
"label.category.9":`生产制造`,
"label.zuowei":`作为`,
"front-quotation-v1-select-quota":`选择报价单`,
"label.dashboard.refresh":`刷新`,
"label.weixin.saveandnew.log":`保存并新建日志`,
"label.report.list":`报表列表`,
"FL":`文件`,
"label.h5.followingcolleagues":`关注的同事`,
"template.report.conversions.number":`潜在客户转化数（按所有人统计）`,
"label.validate.function.funcFormat.MONTH":`MONTH(date)`,
"front-kefu-moudle-v1-tenant-ID":`租户ID`,
"label.reportsSubscriptionPage.schedulereport.monthly.time":`时间`,
"label.multilang.workflow.everyotherday":`每隔{0}天`,
"label.chat.message.send.message":`发送消息`,
"label.knowledgebase.fast.operation.error":`快速操作错误`,
"label.multilang.dupicatecheck.dumplicatedata":`在{0}条记录中共查询到满足条件的重复数据{1}组，查询花费时间{2}毫秒。 每页显示{3}组数据。`,
"vue_label_report_addFile_detail_Information":`仅导出2000条详细信息行。使用此数据，以进行更多计算，或上载到其他系统。`,
"label.ccchat.message.search.desc3":`搜索提示`,
"message.deletereport.prompt":`无法删除此报表`,
"pagecreator.page.message.save.success":`页面保存成功`,
"vue_label_rise":`上升`,
"label.appupload.install.error.choicehead":`如果系统中已存在的组件与要安装的组件冲突该如何处理？`,
"message.dispatch.violation":`派遣时间违规:派遣时段不在资源工作时间内`,
"label.tool":`工具`,
"label.sso.saml.idp.downloadcert":`下载证书`,
"label.chatter.detailinfo":`详细信息`,
"label.area.tree":`区域层次结构树`,
"label.partnerCloud.priceOfManual.notEnabled":`不启用`,
"label.chosesubject.call":`打电话`,
"label.leadscore.rule.detail":`潜在客户打分：规则详情`,
"front-welcome-to-try":`欢迎试用`,
"label.umeng.activity.event.willbegin1":`事件#event即将在#time后开始`,
"component.event.label.noevent":`看来您已完成今天的工作了。`,
"label.document.templatesetof.folder":`模板套红文件夹`,
"label.quickbooks.none":`无匹配数据，请手动搜索或新建`,
"label.assignment.setup.newrule.inputrule":`输入分配规则名`,
"label.appointmentdetail.wizard.title4":`公司名称`,
"label.malaysia.time":`马来西亚时间`,
"label.partnerCloud.partnerAccount.way":`充值方式`,
"label.roleoflinkman":`联系人角色`,
"mesage.error.role.delate.user":`无法删除角色，因为当前为角色分配了用户。`,
"chatter.warning":`警告：如果你选择其它对象，您刚刚所做的更改将不会保存，是否确定执行此操作?`,
"label.service.gantt.violations.sum":`违规的服务预约数量`,
"label.permission.objectpermission.recordfenpei1":`分配的记录类型`,
"label.mobile.phone.required.plan":`计划为必填项`,
"label.after_leaving":`离开后，当前数据将不被保存`,
"label.cpq.opportunity.mainquote.trasnfer.order":`业务机会下已经有主报价单，且已经转化成订单`,
"component.setup.iframe.label.title":`自定义页面`,
"visit.dispatchplatform.nopermission":`权限不足：您没有足够的权限访问派工平台，请联系管理员。`,
"label.validate.function.funcExplain.RIGHT":`返回从文本字符串右边算起的执行数量的字符`,
"component.chatter.link.button.save":`发表`,
"label.knowledge.selection":`每个知识下最多可以有8个数据分组选择`,
"chatter.email.homePage":`在我的CCChat主页上发帖时`,
"vue_label_commonobjects_view_copy_view":`复制视图`,
"label.documentmessage":`文档详细信息`,
"label.emailtocloudcc.step1":`步骤1`,
"label.user.mfa.unbind":`给选中的用户解除MFA绑定`,
"label.stdashbord.xsld.business.sdzje":`失单总金额`,
"vue.please.select.the.total.method":`请选择合计方式`,
"label.stdashbord.xsld.business.img1":`可能性为1%-99%阶段的个数`,
"label.reportsSubscriptionPage.condition.title":`除去订阅功能之外，你还可以在报表结果上设置条件。在条件满足之后你会收到通知。非必填`,
"chatter.sel.field":`选择超过了20个字段。`,
"label.login.access.year":`年`,
"label.dashboard.all":`全部仪表板`,
"label.approver":`批准人`,
"Lead.Homepage.Tools.BatchScoring":`批量打分`,
"lable.opppdt.selPdt.lesscondtions":`较少筛选器`,
"label.integrations.action.export":`立即导出`,
"label.datamanage.lookupandsure":`（查看和确认）`,
"label.email.attach.to.mail":`附加到电子邮件`,
"message.nodataordeleted":`数据不存在或已删除`,
"component_newrecords_label_all":`查看全部`,
"lable.currencyAdv.startdate.rate":`显示开始日期定义在以下范围中的所有汇率`,
"label.callbackoperate":`调回操作`,
"label.knowledge.setting.hint.eighteen":`开始为知识库创建文章`,
"label.user.step4.submit.email":`步骤4.已提交您的电子邮件发送请求。`,
"label.appointment.wizard.subtitle4-1":`日程间的交通时间`,
"component.assistant.button.newtask":`新建任务`,
"label.icon.129":`卡片`,
"label.relatedlist":`相关列表`,
"label.report.recently":`最近查看`,
"label.batchadd":`批量新增`,
"front-template-V1-Delete-succeeded":`“{currentTelmplateName}”模板删除成功`,
"label.appupload.upload.otherdetail":`其他详细信息`,
"label.emailobject.link":`链接`,
"label.quickbooks.createcustomer":`在QuickBooks上创建新客户`,
"report.label.projectcount":`个项目，按报表名称排序`,
"vue_label_normal_contact_sf":`联系人`,
"chatter.group.groupActivities":`全部组`,
"label_tabpage_addoptionsz":`添加选项`,
"label.knowledgebase.submit.for.translation":`提交进行翻译`,
"vue_label_pool_notallowed":`企业性质不允许`,
"label.icon.80":`造纸`,
"label.readonlys":`只读`,
"label.recordsediting":`记录可编辑性`,
"label.mr.title.email":`电子邮件`,
"label.partner.all.enable":`启用`,
"label.customsetting.manage.errmessage":`请先维护自定义字段，然后再管理数据`,
"label.cloudccclass.list.cls":`类`,
"label.weixin.click.loadall":`点击加载全部`,
"label.weixin.appr.initialtime":`发起时间`,
"UG_ST_002":`确定`,
"setup_mainpage_label_welcome17":`权限设置`,
"label.appupload.state0":`未上载`,
"label.icon.115":`房子`,
"setup_mainpage_label_welcome5":`自定义字段`,
"lable.custom.year.ovdate":`自定义年度结束日期`,
"label_tabpage_findz":`查找`,
"label.appupload.uploading":`正在上载软件包...`,
"setup.mainpage.label.welcome1":`需要相应权限`,
"label.file.folder.delete2":`删除文档库？`,
"2018UI_Homepage_DataNoAccess_Info":`此条记录您没有权限访问，点击返回上一步。`,
"label.ems.google":`谷歌`,
"label.hawaii.aleutian.standard.time":`夏威夷标准时间`,
"template.report.unfinished.tasks":`未完成的任务`,
"vue_label_calendar_add_calendar":`添加日历`,
"label.button.sel.useremail":`给选中用户发送电子邮件`,
"user.email.template":`亲爱的{username}：<br>您的市场活动[{Campaign.name}]的邀约码如下：<br>{Campaign.ColleagueInvitationLetter}<br>相对应的URL为：<br>{Campaign.ColleagueInvitationLetterLink}<br>当前市场活动支持二维码注册和URL链接注册！感谢您的支持<br>市场活动专员:{Campaign.Owner}`,
"label.forecast.settings.shouru":`预测收入`,
"label.casesensitive":`将"ABC"和"abc"视为不同值（区分大小写）`,
"message.pleaseinputrightdistanceweek":`请填写正确的间隔星期`,
"label.linellae-group":`线条-分组`,
"label.showdefault_times":`显示默认发布时间`,
"label.smstemplate.finishmessagedetailinfo":`完成短信模板的详细信息`,
"label.service.miniProgram.backgroundImage":`背景图`,
"label.recentview.news":`最新记录`,
"label.reportType.chose.and.form":`选择报表数据源及报表格式`,
"setup.layout.button.additem":`添加选中项`,
"front-epwechat-module-v1-auto-mate":`自动匹配`,
"vue_label_helpcenter_contract&plan":`合同是各方之间的书面协议。许多公司使用合同定义与其他公司从事业务往来的条款。使用 Cloud CC建立您与您的客户和业务机会已有的合同，并为其提供文档。通过批准流程，跟踪合同。<br>通过收款计划，协助合同功能，管理您的交易。`,
"label_mobile_version_nonsupport_feature":`此版本不支持该功能，请更新到最新版本`,
"label.icon.44":`火`,
"label.data.downpage.i.title.num3":`3、导入之前，请先确保导入其相关的所有记录。例如：如果您当前导入的对象与联系人之间存在查找关系，请先导入这些联系人，然后再导入您的数据。`,
"label.mr.object.customer":`客户`,
"label.social.user.null":`Social社交用户信息不能为空`,
"front-epwechat-module-v1-unbound-item2":`- 应用设置全部数据`,
"label.partnerCloud.partnerAccount.noempty":`充值金额不能为空`,
"label.weixin.myapproval":`我的审批`,
"label.data.setok.e_desc1":`导出成功后您会收到系统邮件提醒，导出的数据暂时保存在服务器上，系统只为您保存48小时，请尽快到`,
"lable.batchadd.service.cfq.after":`触发器 (After Insert)`,
"label.umeng.activity.youhaveanevent":`您有1个新事件`,
"label_emailsync_status_connectaccounts":`关联邮箱账号`,
"label.multilang.shenpi.count":`共{0}条记录：`,
"pagecreator.page.message.delete.fail":`页面删除失败`,
"label.version.sum.lookupmdfield":`个主详关系字段`,
"vue_label_pool_clueduplication":`线索重复`,
"label.system.setup.log":`系统行为日志`,
"label.globaloperation.operationtype.send.e-mail":`发送电子邮件`,
"vue_label_pricebook_entry":`新建价格手册条目`,
"label.forecast.forehistory.submit.date":`提交日期时间`,
"chatter.handle":`您正在处理什么?`,
"lable.SalesCommitmentKanBan.complete":`完成额`,
"label.weixin.upload.pictures":`上传图片`,
"label.create.document":`新增文档`,
"vue_label_commonobjects_detail_unlockconfirm":`确认解除锁定？`,
"label.customer.page":`自定义页面菜单`,
"button.partner.workspace.saveas":`另存为`,
"setup.layout.label.asc":`升序`,
"label.ccpeak.folder.time":`未归档定时类文件夹`,
"label_tabpage_includez":`包含`,
"label.custom.button":`自定义按钮`,
"label.weixin.binding":`绑定`,
"P":`百分比`,
"chatter.stop.n":`停止追随该记录`,
"label.reportsSubscriptionPage.schedulereport.monthly.day.wednesday":`星期三`,
"template.report.revenue.marketing.activities":`市场活动收入`,
"lable.SalesCommitmentKanBan.theActualReceipts":`实际收款额`,
"vue_label_popularresults":`热门结果`,
"label.log.belongs":`所属部分`,
"label.profile.remark":`此简档的用户具有下列权限和页面布局。管理员通过编辑用户的个人信息即可更改其简档`,
"label.appupload.component.type.button":`按钮`,
"label.partner.all.operate":`操作`,
"vue_label_notice_modify_fail":`修改失败`,
"label.icon.137":`地球`,
"front-dialog-module-v1-nosupport-copy":`不支持复制`,
"label.integrations.mailchimp.massage3":`已取消授权`,
"UG.opportunity.010":`创建一个交易`,
"front-lightning-module-v1-details-page-chart-selecting-reports":`· 选择报表时，只能选择公用报表，即所有用户均可访问的报表文件夹中的报表，与未归档公用报表中的报表；`,
"System_btn_SaveAndCommit":`保存并提交`,
"vue_label_dashboard_statisticaltype":`请选择统计类型`,
"label.mr.object.opportunity":`业务机会`,
"label.area.detail.remark":`预览区域下的用户`,
"label.view.sortview.index":`顺序号`,
"label.mobile.quickcreate.default.events":`事件`,
"label.product.price":`销售价格`,
"label.leadmarketsea.edit.title":`潜在客户公海池编辑`,
"pagecreator.layout.button.edit":`编辑布局`,
"label.addressee":`收件人`,
"label.movablesearchlayout":`活动搜索布局`,
"label.ems.confirm":`确定`,
"vue_label_file_save_to_file":`保存到文件`,
"component_chatter_button_more":`查看更多详细信息`,
"label.ccdocument.hidden.trace":`隐藏痕迹`,
"label.partnerCloud.maximumTwo":`文件最大为2M`,
"label.event.moveup.4hour":`提前 4 小时`,
"label.batchadd.save":`添加共享失败`,
"label.passwordPolicy.setup.expireDate":`用户密码有效期`,
"label.workflowrule":`工作流规则`,
"vue_label_notice_pleaseselecview":`请选择视图`,
"label.h5.chatter.colleagues":`关于同事`,
"lable.opppdt.addpdt.subtitle":`将产品添加到`,
"label.data.import.setup.repeat.no":`否-将所有记录插入我的导入文件中。`,
"label.changeCorporate":`更改公司币种`,
"label.customfields.dateandtime.tip":`允许用户输入日期和时间，或从弹出式日历中选择日期。当用户单击弹出式日历中的某个日期后，该日期和当前时间将输入到日期/时间"字段。"`,
"label.integrations.mailchimp.massage1":`请选择至少1条需要导出的记录`,
"lable.PowerProcess.custom":`基于自定义条件`,
"label.service.editDialog.displays.service.appointmentsFordays":`显示水平日期之前{before}天和水平日期之后{after}天的服务预约`,
"label.Receivables.ActualMoneyTime":`实际收款时间`,
"label.matrixreport.intro":`矩阵式报表以网格形式显示按水平和垂直方向的条件计算出来的汇总数据`,
"message.validation.isnotnumber":`输入正确的数字`,
"label.partner.workspace.member.search":`搜索`,
"label.customfields.deletewill":`删除该自定义字段将会`,
"label.content":`内容`,
"component.setup.button.weburl":`外部URL`,
"setup.mainpage.label.welcome28":`操作指导： 点击本页左侧菜单 → 管理设置 → 数据管理 → 数据导入导出、批量转移、批量删除。`,
"label.related.setup":`任务事件相关项配置`,
"label.weixin.sign":`亲，您已经签到，无须再签`,
"label.norecord":`没有记录`,
"label.emailmerge.detail.emailtempldatemerge":`邮件合并模板`,
"label_emailsync_status_role":`角色`,
"label.mobileapp.modelsetting2":`根据实际使用场景选择符合业务需求的模块<br>启用：勾选后模块将显示在移动端“更多”-“标准功能”<br>禁用：勾选后模块将不再显示在移动端“更多”-“标准功能”`,
"component.sendmail.label.title":`发送邮件`,
"component_assistant_button_newevent":`新建事件`,
"label.chatter.input":`请输入相关内容`,
"message.error.view.operate.rtnlink":`单击<a href='javascript:history.back();'>此处</a>返回上一页`,
"lable.new.profile":`新建简档`,
"label.custom.field.null":`无可用`,
"label.reportsSubscriptionPage.schedulereport.weekly.saturday":`星期六`,
"label.stdashbord.xsld.business.img4":`可能性为100%阶段的总金额`,
"pagecreator_layout_button_splitall":`拆分所有`,
"label.mobile.phone.total.amount":`总金额(万元)`,
"label.ratifyhistory":`批准历史`,
"label.projectManagement.Antecedents":`前置任务`,
"label.projectManagement.Newserviceappointment":`新建服务预约`,
"label.delete.record.is.approval":`您要删除的记录为审批中的记录，确认要删除吗？`,
"front-gantt-module-no-tasks-describe":`通过甘特图可以查看如何随时间安排工作项，它们如何重叠，以及如何关联。`,
"vue_label_visualize_data":`已回填天眼查数据，请保存。`,
"UG.activity.02":`分配任务`,
"label.field.duplicate2":`不允许重复值`,
"label.cloudccclass.list.tip":`允许开发人员在CloudCC.com平台上开发类,这些类可以用于自定义页面及触发器`,
"before":`早于`,
"UG.ST.001":`提示`,
"label_tabpage_userGuidez":`用户指南`,
"vue_label_account_looking_for":`请输入您所要查询的内容`,
"vue_label_calendar_notice_timecantmove":`该对象日历的时间不可拖拽更改`,
"label.mobile.phone.enter.summary":`这里输入总结`,
"label.object.api.existed":`对象api名称已存在，请更改api名称`,
"label.weixin..xsld.order.by.time":`按预计签约日期排序`,
"label.h5.chatter.whether":`是否`,
"label.file.delete.success":`文件删除成功`,
"label.imgfield.type.url.tip1":`用户可输入引用图片的链接，通过在图片链接后添加&cimgSize=宽度,高度，设置图片显示的大小。`,
"label.tomanyrecords":`表中条目超过 5,000 条。`,
"label.save.partnercloud":`保存伙伴云错误`,
"vue_label_homepage_fliteritems":`筛选配置项`,
"pagecreator_page_button_new":`新建页面`,
"label.sharerule.baseofcondition":`基于条件`,
"label.dashboard.snapshot":`仪表板快照`,
"label.appointmentpage.wizard.subtitle1.1":`请选择日期和具体时间`,
"label.reportsSubscriptionPage.condition.emailsummary":`只发送报表`,
"chatter.group.showAll":`显示全部`,
"label.tabpage.helpNavigationz":`帮助和导览`,
"label.emailtocloudcc.button.back":`取消`,
"approval_request_email_subect":`审批请求`,
"label.lookup.error":`查找时发生错误`,
"label.publicgroup.save.groupisnull":`保存过程中出现小组数据为空，请尝试重新保存，如果还是存在问题，请联系系统管理员`,
"label.pie":`饼图`,
"chatter.feed.is":`是企业社交网络，员工可以通过在工作时共享信息。`,
"label.customfields.file.max5m":`最大文件大小为5M`,
"com.cloudcc.login.error.message.vaildauthfail":`无效的登录认证`,
"label.profile.appsetuppermission":`应用程序设置管理权限`,
"label.customfields.file.totalmax":`上传的文件过大,请不要超过500M。`,
"label.sms.list":`短信接口信息列表`,
"message.error.referencedcolumnIdnotexist":`报表引用字段已删除,无法正常显示,请联系系统管理员获取帮助。`,
"front-lightning-module-v1-details-page-chart-setting-chart":`设置报表图表`,
"label.recordtype.profile.enables":`当前可用记录类型`,
"chatter.this.n":`这个记录`,
"label.only.upload.file":`只能上传jpg/png文件，且不超过500kb`,
"vue_label_lead_conversion_failed":`转化失败`,
"label.file.share.file.success":`成功共享文件！`,
"label.processsetting.delete.process":`确认删除该进程？`,
"message.uniquenamevalidate":`必须以字母开头，仅使用字母数字字符和下划线`,
"label.group.archived.desc.info":`此小组已归档，因此您不可以创建新帖子或与此小组共享文件。启用小组可启用所有功能。`,
"label.customer.maincontact":`主要联系人`,
"label.appointment.wizard.subtitle1-9":`4小时`,
"label_productline_income":`产品系列收入`,
"label.dashboardSetup.tz.ybb":`跳转到仪表板`,
"label.recordowner":`记录所有人`,
"message.approval.othersdoing":`其他人正在操作此流程，请刷新获取最新的信息！`,
"Opportunity_Detailed_Phase_Label_002":`当前状态已停留{0}天`,
"label.field.validating.rule.isnot.passed":`验证规则编译未通过，请检查语法`,
"label.textmessage.fieldskong":`部分插入的字段值为零，请重新编辑并发送`,
"com.cloudcc.login.error.message.islocked":`用户被锁定`,
"label.forecast.customforecast.foredis.debfb":`定额百分比`,
"lable.opppdt.selPbk.changepbk.worning":`修改此业务机会的价格手册，与此业务机会相关的业务机会产品将被删除。是否继续?`,
"label.mr.backLookReData":`返回，查看重复数据列表`,
"label.quickbooks.searchqb":`搜索 QuickBooks`,
"label.service.gantt.searchSkills":`搜索技能`,
"label.account.Current.and.NexttFQ":`当前和未来三个会计季度`,
"customer.notopen.chat":`组织尚未开通聊天功能，请联系管理员开通`,
"vue_label_commonobjects_view_sum":`共{total}条数据`,
"label.partnerCloud.orderingPlatform.adjust":`调整订单产品`,
"label.emailmerge.mergeFolder.tips":`此页面中，您可以生成一个Microsoft Word文档，包含您的联系人数据。请选择邮件合并模板，最多可选20个。`,
"vue_label_ccchat_notice_deletecommentfail":`删除评论失败`,
"label.emailsync.status":`用户邮箱状态统计`,
"label.forecast.forecastroleuserpage.desc":`为此角色分配预测经理。下属的预测将汇总到其经理的预测中。`,
"label.step1.total4":`第1步，共4步`,
"front-kefu-moudle-confirm-fjcase":`您确定要分离此个案`,
"label.icon.60":`吊车`,
"label.appointmentpage.wizard.subtitle3":`请输入您的信息`,
"label.loginservice.license.exceed.time":`许可证已经过期`,
"label.customcomponent.check.tag.lastrow":`最后一行必须是`,
"label.product.code":`产品代码`,
"label.salescloud.salesdashboard.phone":`电话`,
"label_please_input_price_list_price":`请输入价目表价格`,
"label.multilang.page3":`页`,
"label.file.lastmodifydate":`上次修改日期`,
"label.icon.121":`电脑`,
"message.error.system.service.unknow":`未知的服务，联系系统管理员！`,
"label.thesecond":`第二列`,
"vue_label_report_conditiondesc_two":`将条件添加到此报表`,
"label.exchange.serverUrl":`服务器地址`,
"RL":`引用`,
"label.emailobject.emailsend.sendindividuallyprompt":`“分别发送”会对多个人一对一发送。每个人将受到单独发给他/她的邮件。确定进行“分别发送”？`,
"label.appointmentconfirmpage.wizard.subtitle4":`参与人`,
"message.save.opportunity.team.save.failed":`业务机会小组失败`,
"vue_labenl_normal_notice_share_success":`共享成功`,
"label.triggerfolder":`触发器文件夹`,
"label.more":`更多`,
"label.file.num":`数量`,
"label.dashboard.list.sortBy":`个项目，按访问时间排序`,
"c":`币种`,
"label.weixin.detail.edit":`编辑`,
"label.escalation.setup.newentries.step2":`步骤2：选择此规则条目的条件`,
"label.report.error.prompt":`配置失败。只支持使用包含组行的串联报表，并确保为公用报表且未被删除！`,
"label.notification.new":`新通知`,
"label_tabpage_releaseTourz":`发布导览`,
"label.icon.41":`定位`,
"label.sendsms.hello.new":`您好：您有一个新的`,
"label.custom.combination":`组合`,
"label.project.hit.fifteen":`里程碑分配通知`,
"label.campaign.channel.step6.mobile":`生成移动端页面`,
"label.goback.N.step":`返回第N步`,
"label_partner_all_name":`伙伴云名称`,
"label.usermanage.loginusername.exist":`登录用户名已经存在！`,
"template.chart.cpxse":`产品销售额`,
"chatter.feed.deletecomments":`是否确定删除此注释?`,
"label.list.userinterface.show.newrcords.enable":`禁用最新记录`,
"label.sso.saml.idp.config.enablelogout":`启用单点注销`,
"label.file.library.create":`新建文档库`,
"label.event.moveup.half.day":`提前 0.5 天`,
"label.stdashbord.xsld.business.jhzje":`机会总金额`,
"label.partnerCloud.orderingPlatform.unitPrice":`单价`,
"label.recordtype.edit.attribute":`一般属性`,
"front-template-V1-TemplatePreview":`模板预览`,
"label.tabpage.personalCenterz":`个人中心`,
"label.setuplookuplayout":`查找布局`,
"label.no.merge.records":`没有可合并的记录`,
"label.attachementNew.set2":`步骤  2.是否归档文件`,
"label.publicgroup.detail.showmembers":`查看小组成员`,
"UG.Forcast.03":`启动规划并执行业务策略。<br> 祝您预测愉快！`,
"label.h5.manageprompt":`勾选某个菜单添加到主页，或者直接点击菜单图标打开菜单`,
"label.icon.145":`关联`,
"label.select":`选择`,
"label.publicgroup":`公用小组`,
"label.customcomponent.usewhere.title":`使用此组件的位置:`,
"label.custom.page.button.name":`按钮名称`,
"pagecreator_layout_button_vertical":`纵向拆分`,
"label.marketsea.autorecyclerule":`自动回收规则`,
"label.reportsSubscription.entrance.attachment":`Excel 格式.xlsx`,
"component_chatter_button_collect":`收藏`,
"label.page.step2.of.step5":`第2步，共5步`,
"label.reportsSubscription.addfile.helptext":`在此处可以设置是否在订阅邮件中添加报表的附件，以及附件报表的格式`,
"label.oldpw":`旧密码`,
"lable.SalesCommitmentKanBan.contractAmount":`签约额`,
"lable.Bundle":`所属捆绑包`,
"label.weixin.unit.million":`单位（万元）`,
"label.app.choseprofile":`分配简档`,
"label_tabpage_editz":`编辑`,
"label.email.attachement.size.info":`文件不能大于`,
"label.chatter.pastSevenday":`过去7天`,
"label.weixin.end.later.start":`结束日期必须大于等于开始日期`,
"label.passwordPolicy.setup.lockoutPeriod":`锁定时间`,
"pagecreator_page_funcpath":`/构建器/页面列表`,
"label.emailobject.apperror":`没有可用的邮件服务，请联系管理员。`,
"label.custom.page.button.broadband":`按钮宽度（像素）`,
"label.weixin.contract.rate":`合同达成率`,
"label.brief.payments":`回款金额`,
"lable.approvaldatamove.transfermsg":`向新用户批量传送未完成的批准请求`,
"label.datamanage.account.namenull":`注意：如果没有给“客户名称”字段赋值，客户记录将不会被导入！`,
"lable.SalesCommitmentKanBan.allTotalPaymentAmount":`总累计收款额`,
"Opportunity_Detailed_Phase_Label_001":`阶段`,
"vue_label_helpcenter_calendar2":`<br>    对象日历：您用对象创建的日历会在日期字段中将记录数据作为日历条目在日历视图上显示。您可以编辑、删除对象日历，并且可以为每一个对象日历自定义颜色。<br>新建事件<br>    您可以通过以下两种方式在日历视图中新建事件。<br>    （1）单击日历视图右上角“新建事件”按钮，即可进行新建事件。在新建事件中您可以在“相关项”和“名称”字段中选择其他对象，从而将事件与其他对象，如业务机会，进行关联。关联了其他对象的事件记录，会在其他对象详情页“活动”模块同步记录。<br>    （2）或者您可以通过单击日历网格新建事件。<br>新建对象日历<br>    步骤1：单击导航菜单日历选项卡进入日历视图页面。<br>    步骤2：在视图右侧找到我的日历，单击我的日历旁边的图标，在弹出的“新建对象日历”的弹窗中进行操作。<br>    步骤3：先为创建的对象日历命名。选择作为日历基础的对象，选择决定日历显示内容的字段，“开始字段”、“视图筛选器”、“显示字段”。开始字段决定显示数据的时间范围，您可以通过视图筛选器过滤数据，显示字段决定日历条目上显示的内容。<br>其他日历<br>    其他日历包含添加的其他用户的日历。可以添加您下级和共享给您日历的人员日历。<br>    共享我的事件日历<br>    步骤1：单击导航菜单日历选项卡进入日历视图页面。<br>    步骤2：在日历视图右侧我的日历下方找到“我的事件”，点击“我的事件”右侧的“下拉按钮”，选择共享日历。<br>    步骤3：在弹出的“共享日历”弹窗中选择您想要共享日历的用户及访问权限。除此之外，您还可以通过单击“目前谁有访问权限”查看您共享日历的记录，单击共享记录右侧“×”图标，即可移除共享记录。<br>    共享日历后，您的下级同事即可添加您的事件日历到其他日历后即可查看您的事件日历。<br>添加日历<br>    步骤1：单击导航菜单日历选项卡进入日历视图页面。<br>    步骤2：单击日历视图右侧其他日历的“下拉按钮”，选择添加日历。<br>    步骤3：在弹出的“共享日历”弹窗中选择您想要添加的人员的事件日历。您可以选择您下级的事件日历以及共享给您的事件日历。单击添加即添加成功。<br>    移除添加的日历<br>    单击其他日历下方的您想要移除日历右侧的“下拉按钮”，选择“移除”。`,
"label.callcenter.Seat.number":`坐席工号`,
"vue_label_commonobjects_view_change_all_selected_records":`更改全部已选记录`,
"label.user.notinuse":`用户未启用，请联系管理员`,
"label.usermanage.hasbeen.reached":`已达到许可用户数的最大数量，请联系服务提供商以获取更多数量的许可！`,
"vue_label_help_list":`列表视图`,
"label.infomation.edit":`编辑基本信息`,
"label.ccchat.person.setting.info":`免费开启您的企业网络！允许CloudCC用户邀请对同事圈没有CloudCC许可证的同事。接受邀请的用户只能看到简档、文件和小组，但无法看到任何对象详情信息，除非您对其授予完全的CloudCC许可。`,
"label.sso.isDelete":`是否删除`,
"label.unique.identification.number":`唯一识别码`,
"label.weixin.no.pending.projects":`暂无待审批的项目`,
"label.projectManagement.Pleaseenteramember":`请输入成员`,
"label.salescloud.salesdashboard.visit":`拜访`,
"label.weixin.user.registered":`用户注册`,
"message.loginhistory.downloadcsv":`下载最近六个月的登录历史.(Excel.csv 文件)`,
"label.icon.37":`定位`,
"template.chart.schdyqyx":`市场活动预期响应`,
"label.tel.ten":`您最多可输入10个要发送通知的手机号码，每个手机号码之间用;"相隔。"`,
"label.data.exp.objdata":`您将按以下条件导出此对象的数据`,
"label.loginservice.after.use":`后，才可以使用。`,
"pagecreator_systemstyle_message_delete":`是否删除当前所选样式？`,
"label.globalselect.deleteerror":`由于该选项列表值集被以下字段使用，暂时不能删除。`,
"label.department.add":`添加部门`,
"label.attendance.dingwei":`定位`,
"label.workflow.editrule":`编辑规则`,
"lable.product.pecm":`请输入正确的金额!`,
"label.icon.182":`公文包`,
"label.help.release.notes":`发布导览`,
"UG.product.05":`导入产品`,
"label.email2":`邮箱`,
"label.weekrepeat":`星期重复`,
"label.mr.descreption.oneGroupReData2":`组`,
"chatter.at.d":`活跃程度`,
"label.mr.descreption.oneGroupReData1":`查重合并进度：共`,
"label.weixin.mobile.fly.android":`Android移动端分享`,
"label.brackets.right":`)右括号`,
"message.recordtype.applytoAllProfiles":`将一个页面布局应用到所有简档`,
"label.customcomponent.page.index.tip":`与功能在编程语言中的工作方式类似，自定义组件允许您封装常见设计模式，然后在一个或多个自定义页面中重新使用那些模式。`,
"lable.List.properties":`列表属性`,
"label.fieldinfo":`字段信息`,
"label.ems.error.fail":`加载失败，请重试或联系系统管理员进行处理`,
"label_emailsync_form_email":`邮箱`,
"lable.currencyManage.button.manageRate":`管理货币`,
"component_salesperformance_label_100finish":`已结束`,
"label.knowledgebase.data.assignment.failed":`{a}条数据指派失败`,
"label.custom.buttonandlink.remark":`选择模式：现有窗口/新窗口（现有窗口：在当前窗口下打开；新窗口：重新另打开一个新的页面窗口）`,
"label.list.userinterface.watermark.setup":`水印设置`,
"component_timeline_label_7daysahead":`前7天`,
"label.sendemail.chat.replyinchat":`微贴留言：`,
"component.salesperformance.label.title":`销售绩效`,
"label.data.downpage.e.list.desc2":`导出数据成功后，您会收到一封邮件，提醒您导出数据成功。`,
"vue_label_campaign_fromclosedopprotunities":`来源{sjcb}个赢单的业务机会`,
"label.umeng.activity.taskviewed":`您分配给#name的任务被查看`,
"vue_label_salesadvance_retentions":`滞留数`,
"label.fieldtag":`字段标签`,
"label.quickbooks.button.searchinquickbooks":`在QuickBooks上搜索`,
"label.quickbooks.viewlist.action":`操作`,
"label.weixin.sysapp":`系统应用`,
"label.approval.examine.level":`按用户层级逐级审批，最大的用户级别至：`,
"label.appupload.upload.error":`此应用程序无法安装。请结束安装，或修改系统内API后重新安装！`,
"label.emailtemplate":`邮件模板`,
"front-email-payment-Invoice-amount":`发票金额`,
"label.viewselectedproducts":`查看已选择的产品`,
"label.tianyancha.businessverify.openfirst":`请先启用工商数据验证`,
"lable.SalesCommitmentKanBan.returnAList":`返回人员列表`,
"label.knowledgebase.nopublished.draft.translations":`没有已发布或草稿翻译版本`,
"vue_label_calendar_day_view":`日历-日视图`,
"label.globalselect.remark":`全局选项列表值集让您在对象之间共享值。`,
"label.orderby":`排序方式`,
"lable.weixin.LastaDaysFinished":`过去7天已完成`,
"lable.currencyManage.Enabledadvcurrency.discripation":`您可以将货币兑换率汇率映射到特定的日期范围内的过期汇率。 过期汇率用于业务机会、业务机会产品和这两个对象相关的报表。过期汇率不可用于其它对象的字段或其它类型的报表。 例如，1 月 1 日的汇率是 1 USD 等于 6.68 CNY，但 2 月 6 日的汇率更改为 1 USD 等于 6.70 CNY。结束日期在 1 月 1 日到 2 月 6 日期间的业务机会使用的是第一种汇率 (1 = 6.68)，而结束日期在 2 月 6 日之后的业务机会使用的则是第二种汇率 (1 = 6.70)。`,
"label.reportsSubscriptionPage.schedulereport.monthly.week.one":`第一个星期`,
"label.leadtoobjectfield":`潜在客户自定义字段映射`,
"label.dashboardSetup.shujuyuan":`数据源`,
"label.tabpage.userz":`用户`,
"label.sms.companyname.dsf":`东时方短信接口`,
"label.step2.total3":`第2步，共3步`,
"front-gantt-module-Drag-dropt- reorder-tasks":`拖放以重新排序任务！`,
"label.dashboard.snapshot.no.enabled":`未启用仪表板快照功能`,
"label.dashboard.unit3":`单位：整数单位`,
"label.forecast.shrepage.desc2":`具有共享访问的用户、角色及区域。`,
"label.commonobjects.new":`新建{eventName}`,
"label.view.nameonlyone":`视图唯一名称`,
"label.assignment.setup.newentries.user":`用户`,
"label.otheremails":`其它电子邮件`,
"component_sendmail_button_send":`发送`,
"vue_label_accountpool":`客户公海池`,
"label.h5.approval.actortime":`发起时间`,
"message.approval.cannotsubmit":`无法提交待审批`,
"vue_label_pool_createdbyme":`我自建的`,
"label.change.event":`切换到事件视图`,
"vue_label_homepage_personalpage":`个人主页`,
"label.new.collect.target":`新建汇总目标`,
"label.ServiceCloud.zichanxuhao":`资产序号`,
"label.product.userl":`用于所有用户的列`,
"label.syslog":`系统日志`,
"label.reportcreatestatus":`报表生成状态`,
"label.datamanage.account.novalue":`注意：本次导入操作没有给“客户名称”字段赋值，客户记录将不会被导入！`,
"label.letter.body":`邀请函正文`,
"label.select.please":`请选择`,
"label.escalation.setup.entrydetail.description":`1.单击编辑"以更改规则条目属性<br/>2.单击"新建"添加升级操作。"`,
"label.component.salesDashboard.nodata":`添加您正在使用的业务机会，然后返回此处以查看业绩。`,
"vue_label_helpcenter_account":`在详细信息中，点击客户旁边的树状图按钮，可以查看客户层次结构图，了解相关客户的子母级关系，并查看每个客户的部分字段信息。<br>更改客户的所有人时，可以选择同时更改该客户相关的业务机会、个案等信息的所有人。`,
"front-kefu-moudle-v1-awshjzx-intelligent":`AWS呼叫中心智能服务`,
"label.productby":`生成者`,
"label.operation.date":`操作时间`,
"label.name.donot.delete":`名称不能被移除`,
"label.validate.function.funcFormat.DATETIMEVALUE":`DATETIMEVALUE(date)`,
"label.escalation.setup.entrydetail.howescalationtime":`如何设置升级时间`,
"label.view.step2":`步骤2.指定过滤条件`,
"lable.outlook.edit.notnull":`字段名不能为空`,
"label.knowledgebase.createnewbrowser":`新建浏览器标签页`,
"label.partner.all.name":`伙伴云名称`,
"chatter.group.groupSetUp":`组设置`,
"label.reportlist.findfolder":`查找文件夹`,
"component.setup.tabs.label.title":`Tab分页`,
"label.passwordPolicy.setup.pswComplexReq":`密码复杂性要求`,
"label.emaildocument":`以电子邮件形式发送文档`,
"message.selectgsummaryconditon":`请选择汇总条件`,
"component_todaytask_label_notask":`今天没有到期任务-趁有时间，去喝杯咖啡吧。`,
"label.user.organization.notexists":`组织不存在！`,
"label.isEnableVisualpage.new.leftlist":`可用的自定义页面`,
"label.mobile.phone.write.week.report":`写周报`,
"label.emailmerge.edittemplate.edit":`邮件合并模板编辑`,
"template.dashboard.folder.sales.manage":`销售管理`,
"label.confirm.order.productsToassets":`确定将订单产品转资产？`,
"label.service.dispatchingUnits.leftRight.total":`当前{{ left }}-{{ right }}条数据，共{{ totalCount }}条数据`,
"label.import.step1.chooseidorother":`2、可以选择使用id或名称匹配记录与填写查找字段。若需获取对应记录id等信息，可创建报表，并将记录名称与记录id设置为组列，再将报表导出。`,
"label_tabpage_completez":`将选中 状态标记为完成`,
"chatter.c.adr":`联系地址`,
"label.account.d":`此页允许您定义一个自定义会计季度记录。自定义会计季度的日期将根据您下面所进行的选择生成。`,
"label.tag.more50":`最多创建50个标签`,
"setup.layout.label.areashow":`区域名称显示位置`,
"label.partnerCloud.basicSetting.rebate":`启用返利`,
"label.tabpage.greaterequalz":`大于或等于`,
"vue.please.select.the.aggregate.basis":`请选择合计依据`,
"label.form":`表单`,
"label.chatter.colleagues.list.beizhu":`启用`,
"label.priority":`优先级`,
"vue_label_checkduplicate_set_repeat_rules":`设置重复规则`,
"label.share_form":`分享表单`,
"label_relation_shareholder":`股东与子公司不可以相同`,
"label.project.hit.sixteen":`问题到期提醒`,
"label.service.miniProgram.imageFormat":`上传图片只能是 PNG、JPG、JPEG 格式!`,
"label.summary.mode":`汇总方式`,
"vue_label_beforeverification":`验证前`,
"label.data.newtemplate.desc":`将用户选中的字段和条件保存成模板，若用户多次重复操作可以直接通过模板导出。`,
"lable.evaluation.badreview":`差评`,
"label.total.tabs":`共有{0}个{1}`,
"label.emailmerge.mergeFolder.foldertemplate":`此文件夹中的模板`,
"vue_label_normal_notice_repeated":`请勿重复添加`,
"label.icon.140":`数据`,
"label.fromonetoanother":`从一个用户转移到另一个用户`,
"label.user.list":`用户列表`,
"label.file.prevent.share.operate":`防止其他人员共享和取消共享`,
"label.app.detail":`查看应用程序`,
"label.h5.similar.opportunity.correlation":`相关性`,
"label_emailtocloudcc_filed_username":`邮箱用户名`,
"vue_labe_account_shareholdingratio":`持股比例`,
"label.data.dataexpalltype.all_desc3":`3、导出成功的数据将生成一个压缩文件，用户可以根据邮件中的文件信息，在导出成功的文件列表页面下载您导出的文件。`,
"label.callcenter.please.select .seatID":`请选择坐席工号`,
"label.remark.length.cannot.than":`描述长度不能超过255`,
"label.batchtransfer.dateandtimetype.tip":`对于日期/时间字段，采用如下格式输入值：`,
"label.component.helper.businesschange.0UntreatActivity":`无未处理活动的业务机会`,
"front-project-module-v1-plase-input-start-time":`请输入开始日期`,
"label.event.moveup.6hour":`提前 6 小时`,
"label.data.exp.tempexp":`按模板导出`,
"label.schedulejob.setup.schedule.afternoon":`下午`,
"label.ems.format":`格式`,
"label.objectHasBeenDeleted":`已删除的对象`,
"label.ServiceCloud.chaxunchenggong":`查询成功`,
"label.campaign.channel.input.notice.owner":`通知所有人`,
"label.bajisitan.time":`巴基斯坦时间`,
"label.warnMes":`对象被引用，删除失败！`,
"lable.Up.to.ten.fields":`选择一个对象并添加它的最多10个字段到表格中。上移或下移箭头作为列标题出现的字段。`,
"label.approverule":`批准规则`,
"message.error.specific":`返回具体的错误提示`,
"front-template-V1-saveUse":`保存并预览`,
"label.uploadfile.success":`成功上传了`,
"label.tabname.donot.database.key":`菜单名不能是数据库关键字！`,
"message.recordtype.selectlayout.select":`--选择页面布局--`,
"front-detail-module-v1-list-cardview":`列表/卡片视图`,
"label.product.maintenance":`维护`,
"vue_label_helpcenter_approve":`1、待审批项目<br>    列出了所有需要您审批的项目。您可以通过审批记录的开始日期、结束日期、提交人、记录类型和相关项来搜索待审批记录。<br>处理单条记录：点击每条记录的左侧按钮。<br>    A.进行审批<br>    步骤1: 点击“进行审批”，打开批准请求页面<br>    步骤2: 点击“批准”或“拒绝”，完成审批操作。<br>    如果审批流程配置中下一个审批步骤需要手动选择审批人，则“批准”后执行步骤3。<br>    步骤3: 选择下一个审批人，完成审批操作。<br>    如果审批流程配置中审批拒绝后需要选择返回步骤，则“拒绝”后执行步骤4。<br>    步骤4: 选择要返回的审批步骤，完成审批操作。<br>    B.重新分配<br>    步骤1: 点击“重新分配”<br>    步骤2: 查找重新分配人<br>    步骤3: 点击“重新分配批准请求”，完成重新分配审批人操作。<br>注：如果您是某条记录的代理审批人，则不能进行重新分配操作。<br>    批量处理多条记录：选择多条待审批项目后，点击列表上方的操作按钮。<br>    C.进行审批<br>    步骤1: 选择多条待审批记录<br>    步骤2: 点击“进行批准”<br>    步骤3: 点击“批准”或“拒绝”，完成审批操作。<br>    如果审批流程配置中审批拒绝后需要选择返回步骤，则“拒绝”后执行步骤4。<br>    步骤4: 选择要返回的审批步骤，完成审批操作。<br>    D.重新分配<br>    步骤1: 选择多条待审批记录<br>    步骤2: 点击“重新分配”<br>    步骤3: 查找重新分配人<br>    步骤4: 点击“重新分配批准请求”，完成重新分配审批人操作。<br>2、我提交的项目<br>    列出了所有的您提交过的审批项目。可以通过审批记录的开始日期、结束日期、提交人、记录类型、相关项和审批状态来快速搜索到您要查看到记录。<br>3、我批准的项目<br>    列出了所有的您批准过的审批项目。可以通过审批记录的开始日期、结束日期、提交人、记录类型、相关项和审批状态来快速搜索到您要查看到记录。<br>4、我拒绝的项目<br>    列出了所有的您审批拒绝过的审批项目。可以通过审批记录的开始日期、结束日期、提交人、记录类型、相关项和审批状态来快速搜索到您要查看到记录.`,
"label.knowledgebase.knowledge.article":`知识文章`,
"march":`三月`,
"label.accraditation":`审批`,
"vue_label_pool_cantreach":`联系不上客户`,
"label.service.appointmentList.startOf.maturityPeriod":`到期时段开始`,
"message.huanxin.closed":`聊天功能未启用`,
"label.implementation.time.operation":`执行定时作业`,
"label.setting.intergrationlist.permissions":`集成权限`,
"label.translation.norecord":`暂无记录`,
"label.lack.expression":`缺失表达式`,
"setup.layout.message.relatedlistfield":`选择在相关列表上显示的字段，您也可以对选定字段重新排序。`,
"label.group.file":`小组文件`,
"message.error.id.null":`无此id信息`,
"label.a_b_least":`每个 A" 记录必须至少有一个相关 "B" 记录。"`,
"label.addattachment.step3":`步骤 4.单击“完成”按钮，返回上一页`,
"label.data.exportsf":`导出成功的文件`,
"label.callcenter.call.out":`呼出`,
"front-electronic-export-exportIntro":`选择的数据将会导出至您选中的Mailchimp列表中`,
"label.custombutton.deletedata.notnull":`删除的数据不能为空`,
"UG.homepage.002":`使用一体化的业务工具来管理您的线索、潜在客户、销售交易漏斗以及客户信息`,
"label.globaloperation":`全局操作`,
"label.icon.58":`工人`,
"vue_label_salesadvance_lostrate":`流失率`,
"chatter.from":`从`,
"front-epwechat-module-v1-account-binding":`账号绑定`,
"label.list.userinterface.old.page.setup":`旧版界面`,
"label.forecast.settings.periods":`个周期`,
"label.file.share.email.content":`#sharedBy已在#orgname上与您共享了文件`,
"label.knowledge.category.hint.five":`数据分类设置`,
"setup.layout.label.selectedfield":`选择字段`,
"label_business_income":`业务机会收入`,
"vue_label_display_options_field":`显示选项列表字段`,
"label.emailtocloudcc.set":`设置邮箱信息`,
"label.knowledge.setting.data.five":`删除分类：{lbmc}`,
"front-epwechat-module-v1-bound-enterprise":`已绑定企业`,
"label.ccpeak.delete.recycle":`记录将被删除到回收站。`,
"label.leadconvers.tip":`潜在客户无法转换为客户、联系人、业务机会以及后续任务，只有在确认潜在客户有价值后才能转换该潜在客户。`,
"label.rsa.key.invalid":`公钥无效,请再次登录。`,
"label.mobile.bind.success":`绑定成功`,
"label.emailtocloudcc.filed.servertype":`服务器类型`,
"label.user.new":`新建用户`,
"label.setup.mobile.homepageshortcuts.remark":`各组织可根据业务场景设置组织级的主页顶部区域快捷功能配置。`,
"label_emailtocloudcc_select2":`选择显示类型`,
"page.send.email":`发送电子邮件`,
"label.service.newBuildDialog.field.display":`要显示的字段`,
"vue_label_homepage_card_impending":`临近业务机会`,
"label.message.contactispartner.delete":`有合作伙伴用户关联到此联系人，无法删除`,
"label.attendance.checkout":`签退`,
"label.emailmerge.newtemplate.description":`输入有关您的邮件合并模板的信息。请注意，备注仅显示在CloudCC中，不会显示在Word中。`,
"laebe.data.exp.success":`导出成功后您会收到系统邮件提醒，导出的数据暂时保存在服务器上，系统只为您保存48小时，请尽快到导出数据列表页面下载您导出的数据。`,
"lable.Maximum.number":`模版名称最长允许50个字符`,
"label.projectManagement.drag.and.drop.existing.tasks":`将一个现有的任务拖放到这个类别`,
"label.forecast.tree.desc":`预测层次结构决定在贵组织中如何累计预测值，以及谁可以查看和调整它们。它根据您的角色层次结构自动产生，但您可能需要添加或编辑经理，销售代表或者其他用户。您还可以为个别预测用户启用预测共享。`,
"vue_label_chatter_upload_file_type":`已选择上传文件类型帖子`,
"front-lightning-module-v1-dashborad-analysis-dimension":`分析维度`,
"vue_label_homepage_custom_homepage":`自定义首页`,
"label.icon.39":`定位`,
"label.appointmentpage.wizard.notif1":`请先选择时间`,
"vue_label_report_filterby":`按照{screenCondition}筛选`,
"label.argentina.time":`阿根廷时间`,
"label.role.assign.notremove":`不允许将<b>已选中用户</b>列表中的用户移除给<b>所有未分配且已启用的用户</b>和<b>所有未分配的用户</b>两个选项。`,
"label.sharerule.detailsetshare":`详细共享规则`,
"label.file.publicview.error1":`文件已删除或公用链接失效`,
"label.data.downpage.e_title.num4":`4、导出的文件格式有两种：CSV格式和压缩格式。其中压缩格式分为两种：一种是自动生成压缩文件密码；另一种是手动输入压缩文件密码。`,
"label.knowledge.case.article":`个案文章`,
"label.data.newtemplate.e.conditions":`导出条件`,
"front-object-change-owner":`与此客户所有人一致的相关列表记录，其所有人也将更改为新所有人`,
"label.newdashboardpage.edittitle":`编辑标题`,
"label.datamove.end.query.no.record":`查询结束，没有符合条件的记录！`,
"lable.SalesCommitmentKanBan.receiptsTarget":`收款目标`,
"label.orderagain":`重新排序`,
"vue_report_dashboard_transfer":`转移文件夹`,
"label.view.sortview.default":`默认视图`,
"label.brasilia.time":`巴西利亚时间`,
"label.industrialandcommercialverification.instructions":`启用工商数据验证，用户录入企业客户资料时，可协助用户录入正确的客户工商注册信息。请注意，此功能当前阶段仅支持查询中国大陆注册的工商企业数据。`,
"label.chatter":`云贴`,
"label.sso.goBackToList":`返回列表：密钥管理`,
"label.mobile.side.tab.state":`启动自定义侧滑栏`,
"label.weixin.addbus":`添加车辆`,
"label.dropbox.description":`连接您的DropBox账号，以便在CloudCC中使用它。`,
"label.service.newBuildDialog.available.tousers":`使此筛选器对所有用户可用`,
"label.knowledge.language.thai":`泰语`,
"label.passwordPolicy.setup.foreverlock":`永久(需管理员解锁)`,
"label.bmap.unreported.location":`您没有上报地理位置信息。请在微信公众号里面设置。`,
"label.tag.field":`标签`,
"label.addyourlanguage":`单击“添加”可添加您的组织支持的语言。`,
"label.chat.topic.my.use":`我使用的主题`,
"UG.contact.06":`导入联系人`,
"label.embed_code":`嵌入代码`,
"label.campaign.channel.input.chenben":`3.实际成本:`,
"label.quickbooks.estimates":`概算`,
"label.report.items.i.created":`我创建的报表`,
"label.forecast.edit.fwqd":`范围起点`,
"label.validate.function.funcExplain.DATEVALUE":`根据输入的日期/时间字段（包含年，月，日以及GMT时间），返回一个日期字段（包含年、月、日）`,
"vue_label_helpcenter_calendar1.1":`事件是确保始终了解客户关系和达成交易的强大工具。您可以将事件与业务机会、潜在客户、客户和联系人相关联。日历视图主要显示即事件记录。<br>1、日历视图和列表视图<br>查看日历<br>    单击导航菜单日历选项卡即可访问日历页面。<br>日历视图<br>    日历视图的分类：日历视图分为月视图、星期视图、日视图和可用性视图。通过不同的网格样式可以分别显示不同时间范围的记录数据。其中可用性视图显示包括我的日历和其他日历在内的以每一个日历为维度的日记录数据。单击日历页面右上方的“日历按钮”图标，即可切换视图。<br>    日历视图可查看的内容：日历包括我的日历和其他日历。在日历视图上可以查看我的日历，包括我的事件日历和对象日历所有的记录数据。我们将这些记录称为“日历条目”。 <br>    您可以通过日历视图查看您拥有的全部事件。您用对象创建的日历会在日期字段中将数据作为日历条目在日历视图上显示。在日历视图上还可以查看其他日历即您可以查看任何您已经添加到视图的您同事共享的日历条目。<br>   `,
"label.tabpage.rowsz":`删除行`,
"label.file.library.managemembers.memberlist":`当前成员`,
"label.report.action.addtodashboard4":`添加到现有仪表板`,
"label.chat.send.voice":`发送一个语音`,
"label.home.dashboard.add":`添加主页仪表板`,
"front-dialog-module-v1-copied-requestid":`已复制请求ID`,
"label.customfields.exportdata":`数据导出""`,
"label.emailobject.signature":`编辑签名`,
"label.hide.source":`隐藏源代码`,
"label.icon.71":`维修`,
"vue_label_help_whatslightning":`什么是Lightning`,
"report.type.label.systemReport":`系统报表`,
"front-kefu-moudle-v1-input-email":`请输入电子邮箱`,
"label.event.moveup.5minutes":`提前 5 分钟`,
"message.error.postsid.null":`帖子ID不能为空！`,
"UG.Account.05":`联系人架构图`,
"label_emailtocloudcc_description3":`将您企业的邮箱，如sales@company.com, info@company.com, support@company.com添加于此，系统将自动根据所收邮件生成潜在客户或个案记录，确保及时跟进来信客户`,
"report.label.searchresult":`搜索结果`,
"vue_label_report_detailsonly_desc":`仅导出详细信息行。使用此数据，以进行更多计算，或上载到其他系统。`,
"label.partnerCloud.partnerAccount.payment":`付款金额：`,
"vue_label_commonobjects_view_select_member":`选择成员`,
"label.emailtocloudcc.step1.lead1":`Email to Lead`,
"label.forecast.settings.current":`当前周期`,
"label.canceluploadfile":`取消上传`,
"label.manual.shared":`手动共享`,
"label.document.uniquename.length.cannot.than":`文档唯一名称长度不能超过255`,
"vue_label_lead_notcreateopportunity":`不创建业务机会`,
"APPIntegration.Social.twittererror":`必须是一个合法的twitter.com的URL`,
"message.duplication.label.errormessage":`错误消息`,
"label.file.img":`图片`,
"label.tabpage.sum":`共计`,
"label.permission.systempermission.fenpei":`系统权限分配`,
"template.dashboard.folder.data":`数据分析`,
"label.sms.account":`用户账号`,
"label.product.filter":`产品筛选器`,
"label.file.content":`正文内容`,
"label.percent":`百分比`,
"label.single.attachment":`单个`,
"label.processsetting.failed.enable.process":`启用进程失败！`,
"label.view.modify":`编辑视图`,
"label.knowledgebase.enter.keywords.filter":`输入关键字进行过滤`,
"label.tabpage.uploadfailez":`上传失败，请重新上传。`,
"label.please.enter.the.target.model.name":`请输入目标模型名称`,
"label.layout.availabletab.related":`相关`,
"label.label":`标签`,
"label.reportsSubscriptionPage.schedulereport.monthly.day.saturday":`星期六`,
"label.addattachment.unit":`字节`,
"vue_label_commonobjects_view_selected":`已选中{checkedLength}条数据`,
"label.view.sortview.printble":`可打印`,
"label.umeng.insert.approval.approvaling":`#applyer提交#obj#objname待您审批`,
"label.forecast.customforecast.tztotal":`调整后总额`,
"label.ccchat.failtoset":`ccchat设置错误`,
"label.ccchat.message.new.error2":`的Chat用户`,
"label.validate.function.category.Advanced":`高级`,
"label.projectManagement.team.members":`团队成员`,
"vue_label_report_clickcrosstofliter":`单击上表中的交叉点，以筛选详细信息。`,
"lable.opppdt.selPdt.leasttwenty":`请至多选择二十五条`,
"label.campaign.channel.download":`下载高清二维码`,
"component_event_label_person":`被分配人`,
"vue_label_homepage_new_homepage":`新建主页`,
"label.version.sum.vlidaterule":`个验证规则`,
"vue_label_chat_click_for_details":`点击查看详情`,
"label.fold":`折叠`,
"label.readonly":`只读`,
"label.h5.similar.opportunity.result":`类似业务机会结果列`,
"label.yourimportsuc":`已处理您的导入请求，请查看您的电子邮件。`,
"label.report.line.yixuan":`已选报表列`,
"setup_layout_label_areaname":`区域名称`,
"label.forecast.edit.title":`目标`,
"label.chatter.allweather":`全天候`,
"label.service.ganttBaiduMap.scheduled.endtime":`计划结束时间`,
"lable.create.new.list":`新建列表`,
"label.emailobject.groupemail.msg3":`{0}个收件人`,
"lable.opppdt.selPdt.description":`输入关键字和筛选条件，然后单击搜索"以开始搜索。单击"更多筛选器"以使用一个以上的筛选器。搜索结果包括与所输入关键字和筛选条件匹配的所有记录。"`,
"label.file.versionerror1":`您可以点击下面的链接直接切换到新版界面文件菜单，也可以在手动切换到新版界面后再使用文件菜单功能`,
"label.under.approve.record":`正在审批的记录`,
"front-epwechat-module-v1-open":`开启`,
"label.projectManagement.delete.task":`删除该任务，将删除任务和任务关联的所有信息，且数据无法恢复，是否确认删除`,
"label.reportforms":`报表`,
"label.tabpage.onlymevisible":`仅对我可见`,
"label.customer.tab.please.name":`请输入菜单名`,
"label_emailsync_form_stutas":`启用状态`,
"message.recordtype.nolist":`未定义记录类型`,
"label.version.forecasting.sales":`销售预测`,
"chatter.sel.mostfield":`您可以选择最多`,
"label.data.derived":`数据导出`,
"label.component.helper.businesschange.expiredtask":`业务机会包含逾期任务`,
"label.cycle":`周期`,
"lable.product.standp":`标准价格`,
"label.sendemail.batchapproval":`批量审批操作`,
"message.organization.not.open.mffverification":`所在组织未开启二次认证`,
"label.icon.131":`雨伞`,
"UG.activity.08":`预约一个日程`,
"label_partner_workspace_member_choicepermission":`选择权限集`,
"label.reportTypeCategory":`报表数据源`,
"label.exporttwotype":`你可以导出两种文本`,
"message.oppdt.selectpricebook":`请先选择价格手册`,
"vue_label_dashboard_generatefromlistview":`从列表视图生成`,
"label.quote.title":`标题`,
"label.tianyancha.businessverify.cancel.sure":`取消启用工商数据验证后，无法在新建/编辑客户的时候回填工商注册信息，是否确认？`,
"label.save":`保存`,
"label.mobile.quickcreate.default.appstore":`应用市场`,
"label.partnerCloud.orderingPlatform.configure":`当前还有{a}产品未配置，请配置后再保存`,
"front-epwechat-module-v1-unbound-role":`未绑定角色`,
"label.partnerCloud.financeSetting.enterAlipay":`请输入支付宝企业账户`,
"label.validate.function.funcExplain.TODAY":`返回当前日期`,
"label.visualpage.parameter.values":`将参数值直接显示在页面上：`,
"label.version.task.and.activity":`任务和活动跟踪`,
"label.audit.history":`待审批`,
"setup.object.field.dependency.label.addtolist":`添加选中值`,
"vue_label_report_exportquantity":`导出数量：`,
"label_tabpage_havez":`有`,
"label.partnerCloud.partnerAccount.amountOfRebate":`可用返利金额`,
"label.createralias":`创建人别名`,
"label.created_followup":`创建跟进邮件`,
"label_chatter_mygroups":`我的小组`,
"label.chat.topic.no.display":`没有可显示的主题`,
"vue_label_calendar_month_view":`日历-月视图`,
"label.service.gantt.resources.assigned.work":`被分配工作的资源`,
"UG_activity_07":`创建一个任务`,
"label.quote.xsjg":`销售价格`,
"message.toomanyrows":`查询记录过多！`,
"label.importsourcestep1":`步骤一：准备好翻译的文件`,
"vue_label_normal_appointment_sf":`日程预约`,
"lable.list.queue.message":`由于存在属于队列的对象记录，不能删除该队列`,
"label.service.major.event.desc":`重大事件表示支持过程中依赖于时间的步骤，可以将重大事件添加到权利过程开始。然后，您可以将过程应用到客户权利，并从中创建个案或工作订单。`,
"label.ems.hostorport.null":`服务器地址与端口号都不能为空`,
"chatter.group.private":`专用`,
"label.icon.192":`肥皂`,
"vue_label_systemSettings_list":`相关列表展示设置`,
"label.activity.saveobj.notnull":`保存的对象不能为空`,
"vue_label_chatter_current_no_people_approval":`当前没有需要审批的人员`,
"label.tianyancha.reglocation":`注册地址`,
"UG_ST_005":`我知道了，不用再显示此页面，下次直接进入。`,
"label.vlidaterule.example.truetodisplay":`此消息将在“错误条件”公式为<b>真</b>时显示`,
"label.icon.99":`笔记`,
"label.whenselectmoreapprover":`当选择多个批准人时`,
"label.forecast.customforecast.directorbest":`直接下属的超常发挥`,
"label.customsetting.view.introduce":`为您的自定义设置创建字段。这些字段中的数据由应用程序放入缓存。`,
"label.there.are.no.unenabled.rules":`还没有未启用规则`,
"front-project-module-v1-plase-selectemplat":`请选择项目模板`,
"label.campaignmember.selectmember.from":`从`,
"setup_layout_button_quicksave":`快速保存`,
"label.setup.service.report":`服务报告模板设置`,
"label.visualpage.direction.for.use":`平台自定义页面使用说明[2.0版本]`,
"message.modify":`确定要修改吗?`,
"label.sms.inside":`内部`,
"label.category.3":`教育`,
"label.login.mfadevice.verification.title":`MFA 设备验证`,
"UG_Forcast_08":`上一步`,
"label.projectManagement.unable.to.complete":`无法完成`,
"front-kefu-moudle-all-missphone":`所有漏接的电话`,
"font-evaluate-module-v1-emergency":`告警`,
"label.sso.saml.sp.idsource.attr":`身份在属性元素中`,
"chatter.not.meg":`不能发送空消息`,
"label.chatter.startDate":`开始日期`,
"label.emailobject.track.times":`打开{0}次`,
"label.customsetting.fieldhasbeendeleted":`已删除的字段`,
"label.knowledge.setting.hint.thirteen":`添加其他数据分类`,
"message.duplication.label.newfiltertitle":`新建查重过滤器`,
"setup_object_field_dependency_label_selectedfieldvalue":`已选字段值`,
"vue_label_calendar_who_currently_has_access":`目前谁拥有访问权限`,
"message.passwordPolicy.validate.minlengthe":`个字符`,
"label.emailsync.status.disconnect":`取消关联`,
"label.applt.down.one":`一键下载`,
"label.manageAll.sel.one2":`我提交的项目`,
"message.error.SQLTimeout":`系统繁忙，请稍后重试！`,
"label.global.search.obj.setup":`全局搜索对象设置`,
"vue_label_commonobjects_view_chat":`群策`,
"vue_label_systemSettings_startSet":`开始设置`,
"label.quickbooks.viewlist.balance":`余额`,
"message.error.fieldid.null":`fieldid不能为空！文件内容id`,
"label.replaceallnullvalue":`替换所有空值`,
"label.georgia.time":`乔治亚时间`,
"label.hastransfer":`包含已转换`,
"label.partner.all.description":`描述`,
"font-evaluate-module-v1-following-peopple":`收到差评时,通知以下用户`,
"label_business_count":`业务机会数量`,
"vue_label_ccchat_closedetail":`收起原帖`,
"label.partner.all.disable":`禁用`,
"label.view.relationship":`对象关系`,
"label.noless":`>=不小于`,
"label.sendsms.batch.step2":`步骤 2：选择短信模板或自定义短信内容`,
"label.stdashbord.xsld.business.jieduan":`阶段名称`,
"label.appupload.component.type.trigger":`触发器`,
"label.knowledge.setting.data.two":`类别名称必填`,
"label.color.display.of.completion.rate":`完成率颜色展示`,
"label.loginhis.default":`默认列出最近的200条历史`,
"vue_label_pricebook_book":`当前价格手册`,
"label.knowledgebase.data.deletion.failed":`{a}条数据删除失败`,
"label_partner_workspace_member_permission":`可选权限集`,
"label.list.userinterface.approval.setup":`审批设置`,
"label.weixin.binding.effect":`binding失效，请重新登录获取`,
"label.appupload.install.newapicannotnull":`新的api名称不能为空`,
"chatter.feed.menutype.feed.company":`所有微贴`,
"label.assignment.setup.detail.email":`电子邮件`,
"label_tabpage_selectcontentz":`请选择内容`,
"template.report.converted.leads.campaign":`市场活动中已转化的潜在客户`,
"label.forecast.season":`本季`,
"label.post":`帖子`,
"label.knowledge.setting.hint.fifteen":`基础已奠定。现在，您和您的团队可以撰写和组织 Knowledge 文章。`,
"front-kefu-moudle-v1-Seats-name":`坐席昵称`,
"label.weixin.leadname":`潜在客户名称`,
"label.account.quarter":`季度`,
"label.detail.field":`查看字段`,
"label.icon.189":`化妆品`,
"label.appointment.disable.reappointment":`禁用重新预约`,
"label.appointmentconfirmpage.wizard.subtitle1":`事件名称`,
"label.campaign.channel.step6.remark3":`系统将为员工生成唯一邀约码，员工可使用此码进行邀约，并可计入个人绩效`,
"System.AddressFieldType.Post":`邮编`,
"label_partner_new_step2":`步骤2：确认模板`,
"vue_label_helpcenter_file":`查看与管理您的文件<br>    使用新版本的文件对象，查看与管理由您所有的，或是他人共享的文件。可以在线预览部分格式的文件。<br>文件库<br>    使用文件库功能，建立团队知识库，设立不同管理员与成员，便捷管理；利用文件夹功能，将文件进行归纳分类。`,
"label.locateddowncurrentvalue":`位于当前值的下方的值`,
"label.tianyancha.businessverify.msg5":`二：服务可靠性：`,
"label.setup.mobile.bottombutton.change.success":`修改成功
`,
"label.appointmentconfirmail.wizard.subtitle2":`时间`,
"label.email.address.lookup":`查找电子邮件地址`,
"setup.mainpage.label.welcome":`欢迎进入 CloudCC PaaS 平台，平台主体功能如下。`,
"label.icon.55":`推土机`,
"label_tabpage_enterrecordnamez":`请输入记录所有人`,
"label.tabpage.andz":`与`,
"label.selectfiletoimport":`选择将要导入的文件`,
"label.version.sum.trigger":`个触发器`,
"label.multi.layout":`行式布局`,
"pagecreator.button.back":`上一步`,
"label.imgfield.truetype":`请上载正确的图片类型`,
"front-kefu-moudle-v1-publicKey":`共享密钥`,
"label.data.exp.newtemp":`模板制作`,
"label.martrixreport.2018.step4.new":`步骤4：选择报表列`,
"label.sendemail.chat.addComentsatsubject":`CloudCC CCChat留言里提及我`,
"vue_label_applauncher_description_leadpool":`使用潜在客户公海池，便捷管理组织内的潜在客户跟进状态，激励人员完成成交。`,
"label.knowledgebase.archive.published.articles.without.drafts":`您仅可以归档没有草稿的已发布文章。`,
"label.projectManagement.bar.chart":`条形图`,
"label.ccpeak.condition.return.sort":`按条件返回并排序。`,
"label.salescloud.opportunity.contactrole":`业务机会联系人角色`,
"label.language":`语言`,
"message.error.view.badprevilege":`对不起，您没有被授权此服务，请联系系统管理员！`,
"label.textmessage.managetemplates":`管理模板`,
"message.error.type.null":`类型不能为空！`,
"setup.mainpage.label.welcome9":`用户无需代码开发的情况下，通过鼠标拖拽的方式，便可实现所有页面元素的分类显示、布局调整。以及对页面上字段的只读、必填等属性的设置。`,
"label.appupload.component.type.page":`自定义页面`,
"label.textmessage.bookschedule":`请点击下方链接查看并预约我的行程：`,
"component_chatter_post_button_save":`发表`,
"lable.oppt.jieduan.signcomplete":`将阶段标记为完成`,
"label.help.notes":`帮助和导览`,
"label_tabpage_reallproplez":`记录所有人`,
"label.obtain.authorization.failure":`授权码获取失败，请重新授权`,
"label.account.FiscalQuarter":`会计季度`,
"label.customsetting.savecustomvalue":`已存在针对该位置的数据，请修改后重新保存`,
"label.maximum":`最大值`,
"component_chatter_file_label_maxsize":`文件最大为20M`,
"c218":`您的帖子已经被保存为草稿`,
"c875":`创建新的帖子来开启对话
`,
"c1623":`验证提供商`,
"c183":`标签筛选`,
"c366":`配置公海池`,
"c91":`邮件互动评分`,
"c2193":`该字段最大长度为1500`,
"c184":`阶段推进图`,
"c1957":`最近搜索`,
"c750":`发起方：`,
"c1016":`参数名`,
"c2084":`安装包id不能为空`,
"c619":` Twitter的字符限制为280个字符`,
"c2094":`注：个案所有人的分配优先级低于已配置的个案分配规则。`,
"c1261":`试用产品系列`,
"c1172":`选取按钮`,
"c1220":`已选自定义组件`,
"c69":`应付金额`,
"c675":`居左`,
"c1280":`华东地区分配用户`,
"c1880":`预测时间`,
"c2307":`第{0}行条件错误，值类型不匹配,请使用yyyy/MM/dd 或者yyyy-MM-dd 的格式`,
"c533":`升级个案总数`,
"c1662":`考勤表条目`,
"c167":`接单时长为必填项`,
"c682":`正方形`,
"c1572":`为每种您要导入的语言创建包含名称和翻译的文件。`,
"c960":`超级版`,
"c1797":`10天`,
"c1966":`该字段不可用于创建主条件`,
"c1126":`货币类型编辑：新币种（从选项列表中选取新币种）`,
"c1033":`每个问题最少两个选项！`,
"c850":`这里显示了您的每个社交帐户的当前关注者数量，但 Facebook 除外，它显示当前页面喜欢的数量。`,
"c343":`增加项目成员`,
"c1007":`复制总价`,
"c8":`选择表单`,
"c1548":`添加预定义选型`,
"c157":`开启接单模式`,
"c1039":`查看电子邮件`,
"c1656":`发货单`,
"c1482":`清除坐标`,
"c1359":`悬停布局`,
"c1832":`注册处理器模板会在保存时自动创建`,
"c397":`服务班组`,
"c556":`个帖子图片发布失败`,
"c563":`激活时间`,
"c179":`伙伴Logo`,
"c1856":`计算规则`,
"c147":`接单规则`,
"c1787":`上班打卡提醒`,
"c303":`法律义务`,
"c1491":`属性`,
"c885":`隐藏侧边栏`,
"c1849":`拖拽或点击上传文件`,
"c1012":`标准手册价格`,
"c1503":`面板高度以像素为单位，输入值范围为1-2560px。`,
"c808":`插入图片`,
"c718":`继续设置`,
"c414":`谢谢您的填写。`,
"c9":`邀约员工`,
"c1066":`主标签语言`,
"c1683":`市场云对象`,
"c1974":`取消分配`,
"c1844":`OAuth 连接的应用程序`,
"c1448":`最大数量不能为空`,
"c2104":`配置表单信息`,
"c15":`已开具发票, 请重新选择`,
"c1806":`请检查基础表单是否填写完整`,
"c1226":`触发动作`,
"c1179":`基于首次回复的批准或拒绝。`,
"c1919":`制作完模板之后，将Word文件上传。`,
"c59":`请先绑定为环信管理员坐席再进入高级设置`,
"c1529":`<span style='color: #ff0000'>错误：存在域格式填写不正确</span>`,
"c504":`规划项目、分配工作、管理资源以及团队协作，帮助您有效实现项目目标，并从整体和细节上控制项目进度，从而在预算范围内按时交付项目。`,
"c836":`绑定法大大账号`,
"c2233":`访问身份URL服务`,
"c187":`感谢页`,
"c208":`打包下载`,
"c1851":`用户首次登陆`,
"c952":`巴西`,
"c104":`一次回复`,
"c1171":`可用按钮`,
"c1834":`验证提供商详细信息`,
"c1847":`启用快速创建`,
"c346":`任务资源计算`,
"c1801":`无法创建队列，{0}对象的队列个数已超出限制。`,
"c1322":`显示分栏`,
"c1194":`2个周期前`,
"c913":`展开侧边栏`,
"c571":`已选定{selectnumber}个表单`,
"c1749":`单点注销`,
"c1558":`详情data`,
"c44":`选择要连接的媒体平台`,
"label.social.posts.content.null":`帖子内容为空`,
"c1799":`永久有效`,
"c852":`企业名称(未填写)`,
"c561":`应用过滤器`,
"c1072":`要替换删除的个案团队角色`,
"c2235":`没有筛选出合适的资源，可以更换策略后试试。`,
"c1626":`网页工具`,
"c1058":`隐藏历史记录`,
"c1881":`文件夹测试`,
"obtain.contract.envelopeid.fail":`获取信封信息失败或者未绑定信息`,
"c465":`仅支持同一币种类型的订单新建发票`,
"c982":`当前价格手册已禁用`,
"c350":`任务排序`,
"c352":`人员资源日历`,
"c670":`图标形状`,
"front-electronic-signature-given":`交付`,
"c542":`满意度评价`,
"c314":`生成发票文件`,
"c2257":`管理支持项`,
"c148":`活动邮件通知设置`,
"c47":`链接域`,
"c1745":`授权范围`,
"c1440":`请输入公海池名称`,
"c754":`填写`,
"c326":`资产BOM`,
"c2311":`超时取消分配`,
"c289":`首选项`,
"c196":`达到限制消息`,
"c1306":`任务同步方向`,
"c63":`打开{objName}`,
"c769":`撤销后，已发起的签署任务文件将被清空，是否继续撤销？`,
"c216":`您的帖子已经预约`,
"c842":`发送提交邮件通知`,
"c389":`父级服务区域`,
"c7":`推广所有人`,
"c981":`天津市`,
"c143":`选择收到邮件通知的用户。这个设置可以在任何表单应用的页面更改。
`,
"c930":`员工定位开关`,
"c1861":`创建记录类型`,
"c1621":`用户及控制`,
"c2313":`{!ServiceTerritory.name}因超时未接单已取消派单，编号“{!ServiceAppointment.name}”，点击查看。`,
"c515":`添加工作总结`,
"c393":`服务区域成员`,
"c1162":`移除字段`,
"c1235":`预测数据集合`,
"c357":`费率`,
"c1660":`服务资源缺勤`,
"c597":`目标仪表`,
"front-electronic-signature-cancelIntro1":`解绑后将无法使用DocuSign电子签章功能，是否确定解绑账号？`,
"c271":`您超时未接单，编号{0}，请及时处理，谨防误工。点击查看详情>`,
"c1292":`使用不同颜色表示不同状态`,
"c1059":`发货单产品`,
"label.gaode.map.cannot.work.normally.please.check.whether.the.secret.key.is.correct":`高德地图不能正常运行，请检查秘钥是否正确！`,
"c424":`服务区域管理`,
"c1729":`时间字段属性`,
"c2164":`自动换行`,
"c995":`请选择公海池！`,
"c711":`连接社交账户，实现海量获客`,
"c1658":`现场服务云对象`,
"c1770":`时间维度`,
"c197":`您的提交次数已达到上限，感谢您的参与！`,
"front-electronic-signature-save-success":`映射关系保存成功`,
"c765":`阻塞中`,
"c1852":`组织级默认共享设置`,
"c1445":`其他设置`,
"c1575":`请上传格式为CSV的文件`,
"c1383":`{n}个周期`,
"c2151":`共享已派遣的服务预约的父级工作订单给已分配服务班组成员`,
"c1244":`超过最大长度`,
"c286":`不合规`,
"c145":`同一人同一天单个/多个任务报工时长不超过24小时`,
"c264":`管理个人字段`,
"label.china":`中国`,
"label.no.bind.mobile":`暂无手机信息，请先登录个人中心绑定。`,
"c95":`删除已选产品`,
"front-electronic-signature-open-signInfo1":`您已开启DocuSign电子签章服务，请关闭后，再开启法大大电子签章服务`,
"c1342":` 请注意，此验证仅支持中国大陆注册的工商企业数据`,
"c1393":`下载最近六个月的登录历史`,
"c1501":`面板高度`,
"c1077":`成员名称`,
"c1661":`服务资源工时`,
"c1659":`服务合同`,
"c1283":`映射字段`,
"c391":`查看留言`,
"c1499":`3次`,
"c1802":`可选搜索结果字段列表`,
"c106":`互动`,
"c2090":`服务请求单操作图示`,
"c1120":`请选择一个字段，然后点击'插入'。后跟'>'的标签表示还有更多的可用字段。`,
"c1736":`提供商类型`,
"c2258":`脚本名称`,
"c519":`删除该实际工作清单，将删除实际工作清单和实际工作清单关联的所有信息，且数据无法恢复，是否确认删除 ?`,
"c528":`去报工`,
"c1000":`我知道了`,
"c78":`订单编号`,
"c983":`链接网址`,
"c41":`解绑成功`,
"c1495":`10个字符`,
"c517":`请输入有效的税率`,
"c1624":`授权链接管理`,
"c774":`签署进行中`,
"c296":`请输入字段名称`,
"c996":`请选择原因！`,
"c1112":`等待输入`,
"c757":`待接收`,
"c1251":`以下显示了一个列表，列示了220309-子查的有效和无效批准过程。要创建一个批准过程，单击创建新的批准过程"，然后选择"使用跳转起点向导"仅几个步骤就可以设置您的批准过程。或者，选择"使用标准向导"配置所有批准选项。`,
"front-electronic-signature-confirmintro":`绑定成功。您可以在合同对象直接发起签署`,
"c1434":`移动页面布局：应用于微信小网页及手机版显示的布局`,
"c1169":`倒序`,
"c1006":`产品项总价`,
"c1805":`请检查URL参数名配置是否完整`,
"c1543":`CloudCC 许可证`,
"c1950":`创始人`,
"c1561":`邮件模板名称`,
"c1737":`提供商名称`,
"c446":`任务状态`,
"c238":`{!ServiceResource.name}已接单。客户：“{!ServiceAppointment.accountid.name}”，主题：“{!ServiceAppointment.subject}”，编号（{!ServiceAppointment.name}）`,
"c980":`上海市`,
"c802":`每个用户只能添加为一个服务资源`,
"c1895":`移动到此呼叫中心`,
"c1312":`校验通过`,
"c387":`服务资源技能`,
"c965":`环信服务未开启`,
"c1070":`个案访问权限`,
"c480":`我们将发送到哪个列表？`,
"c2140":`{0}在{1}共享帖子，点击查看`,
"c937":`修改手机号`,
"c1229":`对象ID`,
"c1920":`查看Word文件制作教程`,
"c632":`去Facebook查看`,
"c131":`发票的客户字段为空，请补充发票信息。`,
"c1088":`要将规则应用于哪些记录`,
"c1632":`定制门户`,
"c680":`白色`,
"c806":`发布时间`,
"c2174":`选择后,伙伴联系人默认归属于当前客户`,
"c2237":`消息通知设置`,
"c1873":`品牌域名`,
"c1971":`创建新的动态布局规则失败，请重试`,
"c2143":`派遣共享规则`,
"c649":`您已经阅读全部内容`,
"c797":`最近联系人`,
"c616":`在新窗口打开链接`,
"c987":`预约发布时间`,
"c169":`对不起，您没有权限查看此图表`,
"c1545":`CloudCC Partner 许可证`,
"c1923":`合并相关记录字段时请上传docx格式文件`,
"c1316":`服务帐户用户名(域用户名或UPN)`,
"c1577":`英文`,
"c1214":`新建自定义对象菜单`,
"c21":`产品数量不能少于该订单已开具发票的数量`,
"c1512":`该组件已经添加，请勿重复添加！`,
"c1432":`行式布局：应用于前台主从录入及批量新增时所显示的布局`,
"c231":`数量不能少于该订单产品已打包数量`,
"c1057":`查看更多评论`,
"c1900":`确认的，你都准备好了`,
"c1009":`启用/禁用价格手册`,
"c1110":`全部模块`,
"c555":`您的帖子图片发送失败`,
"c583":`中国地图`,
"c1629":`自助门户`,
"c1932":`创建数据类别`,
"c1633":`门户用户`,
"c1869":`起点范围`,
"c1218":`创建动作`,
"c1488":`添加页脚工具`,
"front-electronic-signature-open-signInfo2":`您已开启法大大电子签章服务，请关闭后，再开启DocuSign电子签章服务`,
"c822":`新增外部联系人`,
"c600":`数字图`,
"c1918":`上传Word模版`,
"c442":`全方位项目管理系统`,
"c1136":`添加分配`,
"c762":`待签署`,
"label.user.not.permission":`当前用户没有权限执行此操作`,
"c35":`订阅名称`,
"c1477":`个案升级规则：新建`,
"c1916":`当前对象`,
"c921":`个角色`,
"c1207":`复制以下脚本并将其粘贴到结束标记之前的网站HTML源代码中，此代码必须插入到要显示该窗件的每个页面中。`,
"c2210":`新建翻译`,
"c305":`公共利益`,
"c1836":`请选择提供商类型`,
"c2312":`您因超时未接单已取消派单，“{!ServiceAppointment.name}”，点击查看。`,
"c730":`不允许重复使用旧密码`,
"c1885":`呼叫中心URL`,
"c1638":`项目云设置`,
"c1223":`未命名条件1`,
"c1155":`名称必须是唯一的`,
"c525":`停用门户用户`,
"c942":`美国`,
"c780":`签署流程`,
"c1202":`动作, 是否继续?`,
"c447":`最后渠道来源`,
"c1408":`根据实际使用场景配置组织级主页<br>你可将与企业业务无关的组件从默认配置中禁用或关闭。<br>启用：启用的模块显示在所有成员的主页中。<br>禁用：禁用的模块不显示在所有成员的主页中，也不支持显示在移动端“配置我的主页”列表中。<br>关闭：默认不显示在组织内所有成员的主页中，用户可以通过移动端“配置我的主页”来开启模块。`,
"c1200":`已取消删除`,
"c369":`发送报价文件`,
"c702":`转为草稿`,
"c22":`如果继续新建回款明细，发票的已回款金额将大于总计值。请重新调整回款金额后再保存。`,
"c79":`订单日期`,
"c2260":`确定要启用脚本吗？`,
"c785":`真实姓名(选填)`,
"label.insert.approval.reassign.error":`审批存在加签状态，不可重新分配`,
"c1096":`此规则将应用于所有记录`,
"c998":`模块`,
"c273":`超时未接单，取消派单`,
"c3":`删除图表成功！`,
"c448":`聊天会话`,
"c495":`一应俱全的高效智能销售云`,
"c429":`派工KPI`,
"c1977":`请输入自定义脚本`,
"c1811":`开发者`,
"c1147":`权限名称`,
"c1269":`备选项`,
"c16":`存在多条已开具发票的订单, 请重新选择`,
"c1087":`使用以下策略`,
"c1644":`客户小组设置`,
"c1084":`税值应该为数字`,
"c1708":` 禁用：禁用的模块不显示在所有成员的主页中，也不支持显示在移动端“配置我的主页”列表中。`,
"c128":`最多添加五行`,
"c955":`{label}最小宽度为{minWidth}px`,
"c1427":`澳元`,
"c1556":`分类组名`,
"c716":`您可以开始从CloudCC发布帖子`,
"c1702":`是否上传照片`,
"c1724":`格式错误，请使用yyyy/MM/dd HH:mm:ss或者yyyy-MM-dd HH:mm:ss的格式或函数:Today()`,
"c2123":`允许外部用户自助注册并自动启用`,
"c638":`发布选项`,
"c746":`撤销销毁请求`,
"c534":`关闭个案总数`,
"c1685":`项目计划`,
"c948":`意大利`,
"c1710":`存在验证错误`,
"c317":`发送采购订单文件`,
"c426":`服务资源管理`,
"c1252":`使用此页面可创建各种页面布局以显示 用户 数据。在创建页面布局之后，单击“页面布局分配”按钮，以控制用户在默认情况下看到哪个页面布局`,
"c1831":`自动创建注册处理器模板`,
"c1219":`可选自定义组件`,
"c457":`累计合同金额排名`,
"c263":`个人字段`,
"c372":`生成订单`,
"c1930":`翻译文章-编辑`,
"c907":`仅在lightning版本生效`,
"c1795":`详情页底部显示按钮`,
"c771":`填写进行中`,
"c2197":`自定义标签详细信息`,
"c408":`可定制现场服务应用`,
"c1522":`自定义按钮和链接`,
"c12":`增长率`,
"c1827":`自定义注销 URL`,
"c379":`回款明细`,
"c410":`工作类型`,
"c510":`伙伴订货`,
"c1928":`查看草稿文章`,
"c701":`分配市场活动`,
"c617":`文本不能为空`,
"c2136":`您无权进行此操作`,
"c1630":`品牌重构`,
"c213":`EPS格式`,
"c1649":`评分设置`,
"c2230":`是否允许访问？`,
"c473":`系统将为员工生成唯一邀约码，员工可使用邀约码进行邀约，并写计入个人绩效。请注意，潜在客户所有人将是当前市场活动所有人或者营销渠道邀约员工`,
"c975":`批准并预约草稿`,
"c1239":` 共享`,
"c1975":`已取消派单{0}，点击查看`,
"c1921":`查看字段值`,
"c168":`请选择图表！`,
"c121":`未分类`,
"label.send.invoice":`发送发票`,
"c792":`确认发起`,
"c1309":`请输入工作流名称`,
"c686":`尺寸`,
"c2102":`超出限制时提示`,
"c1373":`1列`,
"c1295":`工作流规则允许您根据过滤条件对特定记录执行某些自动操作。工作流自动化可以发送电子邮件、更新字段、创建记录等等。`,
"c1108":`请检查条件配置是否完整填写`,
"c1603":`图片字段属性`,
"c1959":`小数位数不能为空`,
"c652":`这显示了在所选时间段内您的帐户发布的帖子数量。这还包括在CloudCC之外发布到您已连接帐户的帖子。`,
"c136":`请在此处输入文本简介信息`,
"c1970":`新建动态布局规则`,
"c662":`自定义图标`,
"c1191":`选择 最终批准 记录锁定`,
"c2082":`安装软件包`,
"c1865":`用户2`,
"label.invoice.customer.is.error":`仅支持同一客户下的订单生成发票。`,
"c580":`气泡图`,
"c1101":`新建webhook`,
"c894":`分配市场活动并在市场活动查看相关帖子，用于分析市场活动表现。`,
"c1297":`新建工作流`,
"c570":`设计`,
"c1597":`选项列表(多选)字段属性`,
"c1613":`导入我的客户`,
"c133":`超过`,
"c564":`尊敬的用户您好：<br/>欢迎您使用CloudCC系统，您在{!operatetime}进行了找回密码操作，在15分钟内您可以使用下面的验证码进行密码重置的操作。<br/>随机验证码：<b>{!authcode}</b><br/><br/><b>重要事项：</b><br/>如果您未曾请求此操作，或您认为您不应收到此消息，请立即与您的系统管理员联系！`,
"c2176":`接单失败`,
"c854":`看起来并没有已发布的帖子`,
"c1947":`软件包类型`,
"c2218":`主标签：`,
"c1248":`您想要复制哪个布局？`,
"c2107":`请输入提示语`,
"c1243":`创建新布局`,
"c1798":`15天`,
"c775":`已终止`,
"c105":`多次回复`,
"c1948":`使用计数`,
"c1078":`更新个案团队成员`,
"c2139":`已派遣成功！`,
"c729":`请确认是否已经配置社交平台应用，进入后台应用程序设置-集成-集成应用-启用（Twitter/Facebook/LinkedIn）`,
"c1275":`最多只能选择`,
"c1475":`使用分配规则可以自动将记录发送给相应的用户。<br />分配规则由定义于记录上的条件和多条规则条目组成。`,
"c491":`已停用`,
"c609":`商标`,
"c1469":`会计年度结束日期不能为空`,
"c611":`链接到`,
"c843":`查看提交`,
"c933":`提交来源`,
"c383":`业务机会产品`,
"c2314":`超时自动拒单`,
"c186":`资产唯一标识符已存在，请勿重复添加。`,
"c1305":`事件冲突行为`,
"c608":`代替`,
"c149":`使用Outlook邮件通知 (仅部分邮件服务支持)`,
"c1028":`供应商`,
"c1350":`vonage 设置`,
"c1606":`文件上传属性`,
"c1931":`翻译文章-发布`,
"c486":`回复电子邮件地址：`,
"c1555":`创建成功`,
"c1186":`3个周期`,
"c598":`环形图`,
"c726":`请求销毁成功`,
"c645":`通过草稿`,
"label.verificationCode.is.invalid":`验证码已失效，请重新获取`,
"c1284":`已分配成功！`,
"c1410":`5分钟`,
"c904":`介于`,
"c1397":`请求失败`,
"c594":`二维折线图`,
"c103":`多次点击`,
"c188":`条评论`,
"c891":`该记录不属于联系人、业务机会、潜在客户或客户`,
"c1254":`2.悬停页面布局：应用于前台悬停窗口所显示的布局`,
"c902":`签到地址距离拜访对象`,
"c1539":`成熟度`,
"c484":`电子邮件：`,
"c421":`工作订单生成方法`,
"c1889":`提供商电话`,
"c406":`自动化销售管理`,
"c1426":`已经存在相同语言不能重复添加`,
"c1113":`公式检查不通过，请检查语法`,
"c1654":`商务云对象`,
"c1100":`图片大小不能超过 20k`,
"c1246":`备注与附件`,
"c1228":`功能正在开发中，敬请期待`,
"c739":`市场活动:员工邀约`,
"c2201":`新建自定义标签`,
"c1511":`用户登录系统后则自动登录工具`,
"c1181":`唯一名称必须为字符串`,
"c329":`资产替换`,
"c1857":`设置：合同共享规则`,
"c1011":`产品类型`,
"c351":`重现频率`,
"c622":`网络统计数据上次刷新时间为`,
"c1367":`标题仅在详细信息页面上可见`,
"2":`筛选项配置成功！`,
"c463":`我的业务机会`,
"c268":`合并信息成功`,
"label.mobile.no.letter.blankcharacter":`手机号不能含有字母和空白符`,
"c1531":`小于等于`,
"c1637":`服务云移动端`,
"c2275":`共享已派遣的服务预约的父级工作订单给已派遣服务资源`,
"c1855":`请输入搜索名称`,
"c1125":`启用高级货币管理   您可以将货币兑换率汇率映射到特定的日期范围内的过期汇率。 过期汇率用于业务机会、业务机会产品和这两个对象相关的报表。过期汇率不可用于其它对象的字段或其它类型的报表。 例如，1 月 1 日的汇率是 1 USD 等于 6.68 CNY，但 2 月 6 日的汇率更改为 1 USD 等于 6.70 CNY。结束日期在 1 月 1 日到 2 月 6 日期间的业务机会使用的是第一种汇率 (1 = 6.68)，而结束日期在 2 月 6 日之后的业务机会使用的则是第二种汇率 (1 = 6.70)。`,
"c438":`转接`,
"c581":`同环比表格`,
"c2232":`是否需要访问{0}？`,
"c953":`韩国`,
"c90":`邮件标题`,
"c2":`删除仪表板成功！`,
"c1618":`模板打印设置`,
"c1680":`产品请求行项目`,
"c1964":`权重值最大不超过10`,
"c1201":`此操作将删除整个`,
"c1691":`返利帐户`,
"c897":`上传失败，文件不能超过200k`,
"c444":`首次渠道来源`,
"c1286":`已取消，无法完成`,
"c1544":`CCChat Free 许可证`,
"c242":`{!ServiceResource.name}已拒单。客户：“{!ServiceAppointment.accountid.name}”，编号：“{!ServiceAppointment.name}”`,
"c135":`空白模板`,
"c659":`联系我们`,
"c773":`定稿中`,
"c11":`表单营销推广`,
"c1209":`去开启`,
"c1580":`韩文`,
"c799":`外部联系人`,
"c1260":`请输入描述`,
"c1014":`当前组织未开启价格手册功能，请联系管理员开启。`,
"c1075":`成员数量`,
"c1830":`注册处理器 查找`,
"c880":`编辑社交帖子`,
"c890":`成功发送邀请邮件`,
"c1614":`导入我的联系人`,
"c846":`请选择符合条件的服务预约`,
"c2305":`第{0}行条件错误，字段类型不匹配!`,
"front-electronic-signature-sucessSign":`发起签署成功`,
"c472":`选择该海报应用的表单`,
"c1384":`会计季度{n}`,
"c963":`Name字段必填`,
"c1076":`成员角色`,
"c390":`子级服务区域`,
"c2291":`共享服务预约给对应服务区域的用户`,
"c248":`转单待接受`,
"c1505":`60天`,
"c1675":`资产扫描记录`,
"c1875":`想要链接跟域？`,
"c646":`收件箱流`,
"c2202":`注册伙伴云账户`,
"c1665":`计划策略目标`,
"c1425":`您可以将货币兑换率汇率映射到特定的日期范围内的过期汇率。
过期汇率用于业务机会、业务机会产品和这两个对象相关的报表。`,
"c308":`至少需要选择一条数据`,
"c858":`确定保存{a}条帖子为草稿么？这些帖子将不会发布直到重新预约他们`,
"c152":`当前选择时间范围内的已完成服务预约数量/当前选择时间范围内的所有服务预约数量`,
"c2293":`共享已分配的服务预约给服务资源`,
"c1754":`是否同时开启抢单`,
"c1666":`计划策略`,
"c1925":`查看文章草稿`,
"c1403":`文件夹：新建`,
"c1118":`请至少选择一个现有操作`,
"c1571":`步骤一：准备好翻译的文件（在导入之前，请确保文件符合以下条件）`,
"c316":`查看个案进度`,
"c2081":`卸载失败`,
"c1828":`如果您希望用户重定向到特定页面，将在用户从站点或自定义域注销后，为其输入目标地址。使用此功能，以加速 OpenID Connect 单点注销，或用作注销后重定向。绝对 URL 需要以 http:// 或 https:// 开头。`,
"c1808":`请检查附加header参数配置是否完整`,
"c2222":`选择用户名`,
"c1381":`添加高级筛选`,
"c1270":`全部关闭`,
"c1602":`文本区（长）字段属性`,
"c1492":`工具属性`,
"c1444":`从左侧选择一个用户并将其添加到已选中用户列表`,
"c1904":`您已准备好设置您的主机`,
"c435":`查看版本`,
"c1053":`请选择需要使用的模板`,
"c1409":`启用该功能后，组织内的成员可以在移动端无网络状态新建、查看、编辑、删除记录<br>
选取的菜单将作为默认离线缓存菜单在全组织人员的移动端启用，每个用户可以根据不同的场景需求在移动端设置关闭组织设置的菜单离线缓存，或切换启用其他需要的菜单<br>`,
"c1304":`事件冲突行为:始终首选Exchange`,
"c1190":`6个周期`,
"c1109":`未找到结果`,
"c362":`附属产品约束`,
"c1299":`联系人冲突行为:始终首选CloudCC.com`,
"c800":`请输入姓名或公司名称搜索`,
"c415":`已计划开始`,
"c1395":`替换选项列表值`,
"c1790":`关联用户`,
"c1149":`默认隐藏`,
"c1523":`请输入有效的电子邮件地址`,
"c1276":`该产品未关联任何税种。`,
"c735":`名称不可重复`,
"c903":`选择应用程序图标`,
"c1222":`编辑条件`,
"c1023":`很抱歉，由于您访问的URL有可能对网站造成安全威胁，您的访问被阻断。`,
"c1082":`税名称不允许有特殊符号`,
"c1655":`订单`,
"c1417":`默认值格式有误`,
"label.insert.approval.massreassign.error":`批量审批中存在加签中的审批，不可重新分配，系统将为您自动过滤`,
"c1516":`区域和下级区域`,
"c1898":`您已准备好设置您的主机。`,
"c354":`编辑实际工作清单`,
"c409":`一站式客户服务平台`,
"c1945":`选中项不能为空`,
"c2234":`通过API管理用户数据`,
"c651":`这显示了您的每个社交帐户的当前关注者数量，但 Facebook 除外，它显示当前页面喜欢的数量。`,
"c1667":`服务目标`,
"c1121":`当创建记录时`,
"c582":`世界地图`,
"c1360":`开始时间不能晚于结束时间`,
"c994":`自定义Lightning组件`,
"c1826":`自定义错误 URL`,
"c1374":`2列`,
"c1199":`需要更新的字段`,
"c826":`确定放弃您的更改么？`,
"c1361":`结束时间不能早于开始时间`,
"c781":`企业：请输入工商营业执照上的企业名称。签署时将会进行校验。`,
"c1139":`编辑权限集`,
"c1845":`当前分栏存在必填项，无法删除`,
"c873":`更多详细信息`,
"c1612":`导入我的潜在客户`,
"c837":`解绑后将无法使用法大大电子签章功能，已设置好的自动填充和回填字段关系也将被删除，是否确定解绑账号？`,
"label.diedirect.sale":`直接减价`,
"c798":`内部联系人`,
"c368":`生成报价文件`,
"c770":`已发起`,
"c1551":`其他的邮件`,
"c882":`《服务协议》`,
"c2129":`默认角色`,
"front-setting-dialog-title-two":`如本次无录入，可在个人信息设置里进行录入，录入即可绑定`,
"c2116":`门户设置`,
"c1449":`填写信息有误`,
"c535":`未解决`,
"front-electronic-signature-look-account":`查看账号`,
"c1972":`是否删除该规则？`,
"c19":`记录详情展示方式`,
"c1890":`添加用户`,
"c52":`税名称`,
"c2169":`审批请求id`,
"c388":`关联并使用权利`,
"c1451":`新加坡元`,
"c1648":`业务机会联系人`,
"c1156":`当intervaltype类型为minute时候，间隔时间必须大于等于30分钟，小于等于59分钟。`,
"c1390":` 创建一个依赖关系，该关系将导致基于用户在另一个字段中选择的值对选项列表或多选列表中的值进行动态筛选`,
"c18":`存在多条未激活的订单, 请重新选择`,
"c2093":`③ 外部用户扫描二维码提交服务申请`,
"c820":`请输入手机号/邮箱`,
"c285":`概览`,
"c1245":`穿梭框`,
"c1552":`当前用户邮件`,
"c478":`验证Mailchimp`,
"c1608":`加密文本（存储加密）字段属性`,
"c1206":`嵌入`,
"c164":`请输入0-60内的整数数值`,
"label.tip.excess.quota":`该资源使用量已超额`,
"c318":`生成采购订单文件`,
"c698":`社交网络`,
"c1116":`添加描述`,
"c1092":`当符合条件时`,
"c1915":`选择合并字段并复制至Word，并支持根据条件展示相关列表记录`,
"c312":`存在多条未生效的订单, 请重新选择`,
"c110":`按项目分组`,
"c549":`日期范围不能超过31天！`,
"c1128":`当前币种`,
"c1896":`保留当前呼叫中心`,
"c845":`请至少选择一条服务预约`,
"c1329":`选项列表(多选)`,
"c282":`管理CRM内客户的个人数据`,
"c1587":`查找关系字段属性`,
"c1969":`返回动态布局规则列表`,
"c270":`超时未接单`,
"c288":`更改数据处理基础`,
"c1231":`读 / 写 - 用户可以查看和覆盖预测数据。`,
"c878":`当前地址`,
"c1287":`默认状态`,
"c2206":`使用此字段输入您选择的任何逗号分隔值。创建自定义标签列表视图时，此字段中输入的文本可用在过滤条件中。`,
"c1698":`移动端推荐功能模块设置`,
"c1651":`考勤设置`,
"c1161":`您确定要从名片视图中删除此字段吗？`,
"c324":`给个案添加队列`,
"c2122":`伙伴自助注册`,
"c1099":`请选择 jpg、png 格式的图片`,
"c1145":`所有用户可见`,
"c2146":`共享已派遣的服务预约给已分配服务资源`,
"c1462":`不允许将已选中用户列表中的用户移除给所有未分配且已启用的用户和所有未分配的用户两个选项。`,
"c1840":`请输入验证端点 URL`,
"c1616":`导入客户/联系人`,
"c129":`此操作将永久删除该文件, 是否继续?`,
"c1510":`自动开始`,
"c339":`GDPR数据销毁`,
"c1106":`操作用于与第三方应用进行通讯，当特定事件/活动发生即时向第三方应用发送web通知。`,
"c1303":`事件冲突行为：始终首选CloudCC.com`,
"c405":`班组规模`,
"c848":`Linkedin 账号`,
"c1524":`操作列`,
"c345":`项目模板`,
"c591":`澳大利亚地图`,
"c180":`登录页语言`,
"c126":`已收货`,
"c2126":`唯一标识`,
"c1824":`用户信息端点 URL`,
"c1404":`文件夹：编辑`,
"c2304":`第{0}行条件错误，未设置字段值!`,
"c2306":`第{0}行条件错误，值类型不匹配!`,
"c311":`未生效, 请重新选择`,
"c587":`墨西哥地图`,
"c37":`这是您的客户在通信首选项页面上看到的文本`,
"c1914":`选择合并字段值`,
"c840":`暂时没有发布失败的帖子。`,
"c1866":`只能以字母开头，禁止输入下划线以外的特殊字符`,
"c1355":`选择您想要分配这个布局权限的角色
`,
"c1183":`1个周期`,
"c2087":`{!ServiceResource.name}已接单。编号：“{!ServiceAppointment.name}”，点击查看`,
"c1371":`部分名称显示在`,
"c1519":`文本区（富文本）字段属性`,
"c241":`{!ServiceResource.name}已拒单。客户：“{!ServiceAppointment.accountid.name}”，主题：“{!ServiceAppointment.subject}”，编号：“{!ServiceAppointment.name}”`,
"c1215":`选择自定义应用程序徽标的图像源`,
"c141":`感谢信息是必填项`,
"c1466":`单击“新建”按钮定义一个新的自定义年度。`,
"c1205":`批量转移批准请求成功`,
"c1430":`开始时间和结束时间的范围不能超过2个月!`,
"c1689":`伙伴账户`,
"c1540":`对我司态度`,
"c1271":`全部打开`,
"c1337":`通道组编号(MD5)
`,
"obtain.contract.fail":`获取合同信息失败`,
"c1541":`拜访次数分值`,
"c1129":`人民币`,
"c1786":`请进行今日下班打卡。（如已打卡请忽略）`,
"c945":`俄罗斯`,
"c1321":`表单校验未通过`,
"c454":`月度合同签约金额`,
"c34":`您的购物车已满100件产品，请至少清理1件后再添加新产品。`,
"c1550":`操作值不能为空`,
"c243":`{!ServiceResource.name}已拒单。主题：“{!ServiceAppointment.subject}”，编号：“{!ServiceAppointment.name}”`,
"c548":`实际工作清单不支持修改任务/问题、子任务、项目`,
"c1640":`潜在客户公海池设置`,
"c807":`立即发布`,
"c590":`德国地图`,
"c831":`认证中`,
"c198":`您的表单已安全发布，可以在以下网址中使用，将您的表单作为公共链接共享。`,
"c1437":`请选择开始时间和结束时间!`,
"c977":`这是您的帖子在{0}上的展示样式。如果{1} 做了细微的布局调整，可能会产生轻微的差别`,
"c1927":`管理文章`,
"c66":`产品运输状态已更改为已收货`,
"c1327":`此操作将删除该项数据，是否继续？`,
"c1599":`主详信息关系字段属性`,
"c1829":`注册处理器`,
"c1756":`开启全文检索`,
"label.twitter.title.setting":`推特集成信息`,
"c922":`联系管理员开通群策`,
"c1926":`查看已归档文章`,
"c1538":`角色1`,
"c1705":`其值被筛选的字段称为“依赖字段”。自定义选项列表和多选列表可以是依赖字段`,
"front-email-payment-Invoice-Tips":`请联系管理员，开通PayPal或VISA后，再发起线上付款`,
"c605":`默认账单地址`,
"c1704":`记录类型唯一名称`,
"c1871":`第2022年会计年度`,
"c403":`项目云`,
"c1891":`批量移除`,
"c1793":`是否启用sha512方式加密`,
"c156":`手机端接单规则`,
"c1485":`页脚工具`,
"c635":`预约另一个帖子`,
"c1810":`免费`,
"c2097":`选择用户或队列作为个案记录的创建人。其中选择的用户需要对个案对象具有创建权限。`,
"c1249":` 页面布局名称`,
"c1628":`品牌故事和消息`,
"c1755":`开启后，被派遣服务预约的用户可以在CloudCC Service app抢单。`,
"c1153":`如果队列中的所有对象的共享模式是“公用读/写/转移”，您将无需分配用户到队列，因为所有用户已经可以访问这些对象的记录。`,
"c753":`参与方`,
"c1822":`验证端点 URL`,
"c1196":`邮件通知可让用户了解已发生的特定事件/活动`,
"c1433":`悬停页面布局：应用于前台悬停窗口所显示的布局`,
"c1042":`4.文档保存方式`,
"c2302":`第{0}行条件错误，未设置运算符!`,
"c1641":`分组设置`,
"c1036":`在您从贵公司使用 API 时，您需要安全标记才能登录。什么是安全标记？这是区分大小写的字母数字代码，并与密码关联。`,
"c2158":`会签`,
"c2209":`类别`,
"c1777":`请先登录呼叫中心`,
"c1676":`费用报表`,
"c647":`全部活动`,
"c295":`关闭后，除记录上的操作历史外，包括个人字段标记、数据处理基础等合规性信息均会被清除。确认关闭吗？`,
"c915":`开启公海池`,
"front-electronic-signature-signStatus":`您已经发起线上签署，合同签署状态为{signStauts}`,
"c568":`调整布局`,
"c1051":`通过此功能，可以根据所选择的合并模板生成文档，其中的合并字段引用 CloudCC字段。如需合并相关列表字段，请上传docx格式合并模板。`,
"c1256":`其他手机号码`,
"c744":`请输入0-100之间的有效数字`,
"c1285":`计划持续时间`,
"c1480":`设置坐标`,
"c1278":`系统定义布局`,
"c1358":`PC页面布局`,
"c464":`个帖子已经删除`,
"c385":`工作总结`,
"c1973":`编辑主字段`,
"c1839":`请输入密钥`,
"c2213":`不是您？`,
"c1419":`  步骤2：在下面的页面上，编辑筛选规则，这些规则针对控制字段中每个值控制出现在依赖字段中的值`,
"c392":`选择您需要的解决方案`,
"c1858":`使用共享规则将符合设定条件的数据，共享给指定的角色。`,
"c418":`已分配服务资源`,
"c256":`更换客户将会清空已选订单，是否确认`,
"c1751":`开启后，被派遣服务预约的用户可以在CloudCC Service APP接单和拒单。`,
"c1188":`4个周期`,
"c690":`图像加载`,
"c261":`销毁数据`,
"c2105":`描述表单相关信息`,
"c1407":`<span style="color: red">提示：定制的简档底部菜单会覆盖公司底部菜单统一设置</span>`,
"c62":`员工邀约`,
"c1365":`单列`,
"c892":`未查询到当前记录`,
"c909":`已经添加此种币种的价格定义，请勿重复添加`,
"c2194":`当前组织的静态资源已经超量`,
"c2156":`新建静态资源`,
"c883":`及`,
"c1617":`相关列表样式`,
"c1739":`获取授权码`,
"c1154":`名称必须以字母开头，只能包含大小写字母，数字，下划线，且长度不能大于40`,
"c1672":`资产关系`,
"c134":`公海池成员数量上限`,
"c1671":`出差申请单`,
"c896":`记录已锁定，不支持添加文件，请联系管理员解锁`,
"c974":`发布一条新的帖子并开启新的对话。`,
"c209":`中等尺寸`,
"c185":`当前页统计`,
"c796":`请联系管理员，先到法大大平台设置好合同模板，再发起签署。`,
"c60":`项目数量`,
"c2154":`您被移出{0}`,
"c991":`数据共享规则`,
"c1573":`每个文件顶部必须包含语言属性(不支持中文导入)。语言属性如：Language=en_US。`,
"c2132":`相关介绍`,
"c866":`管理应用程序`,
"c666":`展示方式`,
"c219":`您的帖子已经删除`,
"c732":`海报`,
"c2315":`您因超时未接单已自动拒单，“{!ServiceAppointment.name}”，点击查看。`,
"c1048":`请至少启用一个模板`,
"c1854":`自定义共享规则`,
"c1345":`获取企业基本信息(含联系方式)
`,
"c1595":`设置必填或只读`,
"c155":`{name}名称`,
"c1328":`是否安装此集成`,
"c511":`电子合同`,
"c1598":`数字字段属性`,
"c240":`已拒单`,
"c1454":`选择图片`,
"c1024":`汇率`,
"c2092":`② 客服人员生成在线个案二维码`,
"c1730":`默认url格式错误！`,
"c468":`排序类型为空`,
"c961":`{year}年第{quarter}季度`,
"c1455":`请输入活动名称`,
"c1420":`已配置内容（请点击‘控制字段’值进行编辑）`,
"c404":`多渠道市场营销获客工具`,
"c1234":`所有未分配且已启用用户`,
"c586":`新加坡地图`,
"c1062":`自定义标签`,
"c694":`宽度和高度`,
"c1025":`根据以上汇率重新计算产品价格`,
"c1536":`每项最大分值均为20;可以重复`,
"c1897":`是否确认移除选中的用户`,
"c1909":`2.输入合并字段值：查看当前对象字段值及相关对象的字段值，选择需要的合并字段值复制至本地的Word模板中`,
"c297":`请输入个人数据类型`,
"c2214":`要随时撤销访问，请转到个人设置中的"链接"`,
"c860":`更改地址`,
"c1740":`获取令牌`,
"c58":`项目云标准主页`,
"c2170":`审批人id`,
"c1791":`当前未关联考勤组，无需打卡`,
"c1650":`升级规则`,
"c920":`若配置了自动回收规则，潜在客户超时未转换，系统会自动将记录回收至公海池，提高潜在客户的跟进效率。`,
"c27":`输入需要上浮或下调的金额，用来调整总金额，如:+10或-10。`,
"c94":`三次以上`,
"c1":`仅移动端`,
"c557":`收到的个案`,
"c1127":`小数位数（输入以新币种显示数据时可以显示的小数位数（小数点右边的位数），必须是 0 至 6 之间的整数）`,
"c294":`关闭GDPR合规性设置`,
"c1842":`请输入注册处理器`,
"c970":`请至少启用一个价格手册。`,
"c1727":`文本字段属性`,
"c1324":`钉钉-H5微应用`,
"c565":`分配此任务给`,
"c668":`对齐方式`,
"c972":`营销推广名称`,
"c2208":`链接到用户`,
"c660":`版权信息`,
"c433":`潜在客户公海池字段跟踪`,
"c443":`归档`,
"c1372":`部分显示列数`,
"c1105":`全部布局`,
"c275":`{0}超时未接单，已取消派单，编号{1}。点击查看详情>`,
"c691":`链接（可选）`,
"c956":`您还未绑定Mailchimp账户，继续绑定Mailchimp账户请进入设置-》集成-》集成列表-》启用Mailchimp或者联系管理员`,
"c1750":`开启接单`,
"c910":`新的工单`,
"c692":`浏览器默认`,
"c1067":`主标签文本`,
"c2134":`注册地址URL`,
"c355":`批量新增实际工作清单`,
"c1289":`显示推荐逻辑规则`,
"c122":`产品主图`,
"c395":`区域类型`,
"c689":`最大高度`,
"c344":`查看项目甘特图`,
"c1150":`输入发送通知时（例如已将个案放入队列时）要使用的队列名和电子邮件地址，电子邮件地址可不填写，将不通知。`,
"c1663":`服务区域工作类型`,
"c1483":`请完整填写表单后再提交`,
"c656":`刷新时间`,
"c943":`日本`,
"c1450":`普通视图`,
"c1813":`截图`,
"c1490":`永久（需要管理员解锁）`,
"c1104":`连接器`,
"front-electronic-signature-outerSinger":`外部签署人`,
"front-generate-v1-invoiceDetail":`发票明细`,
"front-electronic-signature-open-vertify":`输入验证码`,
"c1775":`个案所有人`,
"c291":`个人数据类型`,
"c2089":`通过网站提交的服务请求单可在系统内生成个案记录。在此可进行服务请求单页面配置网页适用于电脑和手机。`,
"c1471":`中国时区`,
"front-setting-phone-message":`请录入手机号信息`,
"c559":`升级的个案`,
"c1453":`是否发邮件给成员`,
"c990":`邮件同步`,
"c1102":`授权类型`,
"label.google.map.cannot.work.normally.please.check.whether.the.secret.key.is.correct":`谷歌地图不能正常运行，请检查秘钥是否正确！`,
"c259":`数据处理基础`,
"c1924":`允许查看知识`,
"c1722":`日期字段属性`,
"c1065":`主标签`,
"c1346":`依赖于时间的触发器`,
"c1838":`请输入应用ID`,
"c488":`邀请时间`,
"c6":`推广名称`,
"front-electronic-signature-signerInfo":`设置签署方信息`,
"c1168":`导航样式`,
"c512":`项目成员`,
"c507":`潜客培养`,
"c1385":`最后修改人名称`,
"c760":`已拒填`,
"c756":`未投递`,
"c321":`是否必填`,
"c817":`查看自定义页面菜单权限设置`,
"c2295":`共享服务预约的父级工作订单给服务资源`,
"c949":`西班牙`,
"c1133":`请选择许可`,
"label.biaoqing.field.relation.tip":`标情发现字段`,
"c382":`关系网评分`,
"c265":`当前订单未生效，无法更改`,
"c417":`服务资源工作信息`,
"c847":`Facebook 账号`,
"c1521":`标准按钮和链接`,
"c2100":`配置评价表单，用户可以通过链接对个案及工作订单进行评价。`,
"c494":`使用CloudCC市场云，实现多渠道统一管理，助您提升获客效率，与客户建立紧密联系，促进成单。`,
"c86":`市场活动：编辑员工邀约`,
"c1098":`裁剪图片`,
"c2249":`同时通知并自动拒单`,
"c1080":`个案团队`,
"c1138":`请选择要删除的用户`,
"c776":`撤销成功`,
"c2220":`主标签语言：`,
"c2152":`服务伙伴接单`,
"c709":`选择一个社交平台去连接`,
"c2008":`总体评价`,
"label.mobile.orVerificationCode.is.error":`手机号或验证码错误`,
"c579":`雷达图`,
"c1037":`在重置标记后，您无法在 API 应用程序和桌面客户端中使用原有标记。`,
"c413":`服务预约状态`,
"c2228":`如果您的账号已经被很多人共享使用，那么当您成功绑定MFA之后，其他未绑定MFA的人将无法登录。解决方法是让其他人也安装MFA应用程序并扫描此页的二维码，或者保存此二维码图片供其他人后续进行扫码。但从安全最佳实践来看，我们建议您取消多人共享账号。`,
"c950":`荷兰`,
"c1493":`8个字符`,
"c1785":`下班打卡提醒`,
"c1735":`客服个案统计图`,
"c1841":`请输入标记端点 URL`,
"c2155":`在线评价模板`,
"c1178":`选择要在悬停页面布局上显示的相关列表（至多选择3个相关列表，选择过多将影响页面布局）`,
"c1236":`选中用户`,
"c573":`二维条形图`,
"label.choose.is.tax":`选择税种`,
"c768":`已发起的合同签署任务尚未完成，请在合同完成签署后进行文件下载。`,
"c604":`已有账单地址，保存后会替换为新地址`,
"c160":`逾期后处理方式`,
"c1158":`intervaltype类型不对，请确认类型。`,
"c239":`已接单`,
"c1210":`打开记录`,
"c988":`当前价格条目正在使用，无法删除`,
"c1699":`电子围栏`,
"c2261":`确定要停用脚本吗？`,
"c834":`初审通过`,
"c113":`发送{name}`,
"c146":`更改币种后，相关产品将全部清空，是否继续更改？`,
"c313":`发送发票文件`,
"c140":`选择对象与模板`,
"c1311":`校验语法中`,
"c298":`不合规的`,
"c2199":`翻译文本`,
"c1399":`邮件合并模板：编辑`,
"c681":`圆形`,
"c870":`确定要批量删除？`,
"c551":`试用期还剩<span style="font-size: 16px; font-weight: bold; color: #fe8a14">  {days} </span>天`,
"c2163":`是否启用加签`,
"c1481":`选择需要开始编辑的步骤`,
"c88":`试用剩余天数`,
"c1694":`多语言工作台`,
"c1298":`联系人同步方向`,
"c1819":`验证提供商编辑`,
"c175":`获取详情信息失败`,
"c64":`是否打开{objName}`,
"c319":`表单外观设置`,
"label.pay.online":`发起线上付款`,
"c941":`中国台湾`,
"c550":`请选择开始日期或结束日期`,
"c1546":`请填写条件公式`,
"c365":`同步报价行至业务机会产品`,
"c908":`选择图标`,
"c260":`请求销毁`,
"c1238":` 启动用户`,
"c50":`税率`,
"c869":`确定归档所有数据吗？`,
"c1468":`会计年度开始日期不能为空`,
"c2238":`报表列字段最多选中50个`,
"c93":`多次打开`,
"c280":`删除电子邮件`,
"c1526":`CCChat 是企业社交网络，员工可以通过在工作时共享信息。`,
"c23":`如果继续新建回款明细，订单的已回款金额将大于订单金额。请重新调整回款金额后再保存。`,
"front-console-v1-see-contacts":`识别出多个联系人，请选择`,
"c607":`已有收货地址，保存后会替换为新地址`,
"c2172":`首个注册用户的角色默认为合作伙伴管理员`,
"c1472":`电子邮件`,
"c1056":`请开启全文搜索开关`,
"c1639":`销售云对象`,
"c1711":`请查看以下字段`,
"c1542":`长度在 1 到 16 个字符`,
"c229":`删除里程碑`,
"front-filter-v1-filter-by-name":`按'{name}'筛选`,
"c2277":`搜索对象`,
"c125":`运输中`,
"c1952":`点击搜索`,
"c1679":`产品请求`,
"c513":`实际工作清单`,
"c80":`账单地址`,
"c1833":`撤消`,
"c1954":`服务访问异常，请稍后重试`,
"c1422":`您已超出跟踪字段的最大数:20`,
"c648":`对话`,
"c521":`已下单数量`,
"c560":`关闭的个案`,
"c973":`您已经阅览完收件箱的全部内容`,
"c2224":`还没有账号？`,
"c1882":`呼叫中心显示名称`,
"c509":`装箱单`,
"c685":`添加新地址`,
"c2171":`自助注册启用`,
"c178":`您当前上传的图片格式暂不支持，请上传png、jpg、jpeg格式的图片。`,
"c1003":`CC钉通过连接钉钉的协同能力，帮助您更完整的进行私域流量运营，追踪、管理客户关系全生命周期，提升企业运营效率和盈利能力。`,
"c436":`访客详情`,
"front-electronic-signature-prepareTemplate":`请联系系统管理员，在DocuSign中预置好合同模板，再发起签署。`,
"c749":`签署进度`,
"c1894":`特定用户`,
"c2098":`关联记录类型`,
"c114":`请点击生成{name}按钮，生成{name}后再发送。`,
"c1446":`从已选中用户列表中移除一个用户会将该用户分配给上面选择的角色`,
"c898":`文件上传成功`,
"c279":`销售云`,
"c232":`不能超过相关订单产品的待打包数量`,
"c1282":`url测试`,
"c911":`取消派遣`,
"c901":`您的提交次数已达到上限。`,
"c1366":`双列`,
"c1934":`创建数据分类`,
"c663":`替代文字`,
"c1657":`采购订单`,
"c541":`当前个案统计数据`,
"c1584":`字段标签翻译`,
"c1340":`选择制作条件`,
"c536":`收到`,
"front-project-v1-batch-deletion-confirmation-information":`批量删除已选择的信息，将删除选中的信息以及与信息有关联的所有信息，且数据无法恢复，是否确认删除？`,
"c1809":`推荐应用`,
"c2256":`控制您的用户可以授予登录访问权限给哪个支持组织。`,
"c1301":`公式验证为真`,
"c1318":`此操作将启用该工作流, 是否继续？`,
"c893":`当前用户无权限编辑客户详细地址字段`,
"c623":`监控器`,
"c1956":`执行工作流`,
"c1198":`字段更新允许您将某个字段值自动更改为指定值，字段更新是与工作流规则和批准过程相关的操作`,
"c493":`助您在市场中抓住每一个商机`,
"c1557":`个案升级规则：新`,
"c1937":`当前开通版本，除{!language}外最多允许启用{!count}种语言`,
"c1377":`永久删除`,
"c1063":`筛选条件不可使用中文符号`,
"c327":`资产层次结构`,
"c747":`您的产品总数已满，请先删除部分产品后，继续添加产品。`,
"c728":`数据隐私`,
"c1423":`相关列表不能为空`,
"c1581":`法文`,
"front-reportlist-v1-optimizedReport":`为查询优化后报表，不要随意改动。`,
"c1265":`添加到简档`,
"c1143":`显示的字段`,
"c741":`请填写邮件内容!`,
"c643":`帖子详情`,
"c537":`平均响应时间`,
"front-electronic-signature-add-field":`添加回填字段`,
"c1574":`确定您导入的文件采用的是正确的编码格式，如果没有指定系统将会采用UTF-8编码。`,
"c1152":`要在此队列添加成员，选择一种成员类型，然后从“可用成员”选择角色或用户，并将其移动至“已选成员”。`,
"c626":`全部用户`,
"c199":`表单链接`,
"c1300":`新`,
"c2149":`共享已派遣的服务预约的父级工作订单给已分配服务班组组长`,
"c1611":`我的数据导入`,
"c917":`使用公海池激发团队的潜能，提高客户跟进效率。将客户纳入公海池统一管理，公海池管理员批量进行分配，销售人员也可自行甄别线索，领取跟进。`,
"c1414":`长度格式有误,不能是0`,
"c1773":`个案类型名称`,
"c1412":`60分钟`,
"c1933":`管理数据类别`,
"c159":`接单时长最大不超过`,
"c640":`预约发布`,
"c1001":`邀请您体验钉钉集成后台系统设置`,
"c192":`当前页面布局：`,
"c978":`暂无账号信息`,
"c969":`{0} 选中`,
"c871":`这里是您的帖子如何在{a}上展示，如果{a}做了布局的调整，可能会有细微的不同。`,
"c1264":`公式结果与期望的数据类型 (真或假) 不兼容。`,
"c814":`1{0}个选中`,
"c1559":`0分钟`,
"c235":`{!ServiceResource.name}已接单。主题：“{!ServiceAppointment.subject}”，编号：”{!ServiceAppointment.name}“`,
"c215":`您的帖子发布成功`,
"c425":`服务预约管理`,
"c182":`不能同时关联工作订单或个案记录`,
"c194":`限制提交数量`,
"c657":`无当前操作权限，请联系管理员`,
"c1352":`请正确填写表单后再保存`,
"c855":`看起来并没有已预约的帖子`,
"c1204":`提示-删除`,
"c2091":`① 客服经理配置在线个案表单`,
"c333":`费用`,
"c1518":`请求失败：`,
"c1091":`执行规则`,
"c1043":`保存至文档`,
"c338":`供应商-销毁`,
"c1421":`此页面允许您选择要在  “字段跟踪”相关列表中跟踪的字段。无论何时用户修改以下所选的任何字段，旧字段值和新字段值，以及日期、时间、更改特性和进行更改的用户都将添加到“字段跟踪”相关列表中请注意：仅跟踪更改部分显示的字段，在跟踪字段值时，只显示“已更改`,
"c431":`市场活动层次结构`,
"c2211":`翻译信息`,
"c374":`价格手册产品`,
"c506":`自动化日程管理`,
"font-trade-module-invoice-totalMoney":`发票回款总计`,
"c203":`通过Mailchimp分享您的表单`,
"c962":`{year}年{month}月`,
"c786":`手机号码/邮箱`,
"c1487":`必须包含大小写字母和数字`,
"c469":`页面处于编辑状态，离开后，当前数据将不被保存`,
"c137":`选择您的表单模板`,
"c993":`数据存储/机构（全对象）`,
"c1905":`操作顺序说明：`,
"c483":`活动信息`,
"c1396":`邮件合并模板：新建`,
"c1876":`学习怎样`,
"c947":`法国`,
"c190":`回款明细币种和订单、发票、回款币种需要保持一致，请修改回款明细币种后再保存`,
"c386":`已完成交付`,
"c2135":`是否确认取消分配？`,
"c803":`账号：全部账号`,
"c1119":`请完整填写表单后再保存`,
"c759":`待填写`,
"c1917":`相关对象筛选`,
"c1678":`工作规则`,
"c823":`顺序设置`,
"c1187":`Webhook列表`,
"c1498":`为您的工具选择图标，图标大小建议xpx*ypx`,
"c422":`服务预约生成方法`,
"c1686":`知识库`,
"c1326":`此操作将删除该时间触发器，是否继续？`,
"c782":`参与方式`,
"c1461":`从已选中用户列表中移除一个用户会将该用户分配给上面选择的角色。`,
"c416":`服务报告推送记录`,
"c2294":`共享服务预约给服务资源`,
"c1494":`为您的工具命名，方便用户了解工具的用途，这个名称会显示在应用程序底部页脚。`,
"c758":`已接收`,
"c407":`服务班组成员`,
"c51":`新税`,
"c844":`绑定DocuSign账号`,
"c1086":`候选人策略`,
"c361":`编辑菜单`,
"c602":`矩阵图`,
"c1257":`设置布局编辑器`,
"c191":`需具有当前视图编辑权限`,
"c299":`至少需要选择一个对象`,
"c432":`市场活动历史`,
"c650":`发布一个新帖子去开始新的对话`,
"c1038":`重新设置安全标记`,
"c1721":`累计汇总字段属性`,
"c1681":`客服服务云对象`,
"c531":`收到个案总数`,
"c13":`当前用户无编辑权限`,
"c162":`同时通知分配人及被分配人`,
"c1620":`税种设置`,
"c1182":`请输入唯一名称`,
"c1045":`保存并下载至本地`,
"c992":`文件存储/机构`,
"c1307":`任务冲突行为：始终首选CloudCC.com`,
"c171":`控股`,
"c230":`删除任务`,
"c470":`表单静默填写字段`,
"c367":`生成合同`,
"c1338":`不是`,
"c2150":`共享已派遣的服务预约给已分配服务班组成员`,
"c26":`设置折扣`,
"c1517":`必填项不能为空`,
"c989":`目标预测帮助手册`,
"c1424":`使用此页面定义您的组织使用的所有货币。<br>应将公司币种设置为公司总部在收入报告时所使用的币种。<br>如果指定其它币种作为公司币种， 则会修改所有兑换率以反映此变化。`,
"c1314":`此操作将永久删除该工作流， 是否继续？`,
"c705":`已发布的帖子`,
"c1949":`上次使用人`,
"c613":`外部页面`,
"front-electronic-signature-openSign":`发起签署`,
"c349":`拖拽操作`,
"c683":`加载更多`,
"c1253":`1.行式布局：应用于前台主从录入及批量新增时所显示的布局`,
"c679":`灰色`,
"c1741":`获取用户信息`,
"c2173":`选择后,当前用户可以管理新伙伴用户信息及审批`,
"c2159":`或签`,
"c1386":`编辑字段属性`,
"c914":`收起侧边栏`,
"c1725":`查找多选属性`,
"c1585":`检查技能等级`,
"c224":`跳转到里程碑`,
"c220":`您的帖子发送失败`,
"c498":`CloudCC商务云高效支撑线上线下全渠道业务，实现货物和资金流动与管理。多个模块有效结合，智能管理订单，与合作伙伴共创共赢。`,
"c566":`保存后自动获取客户地址内容`,
"c1978":`自定义脚本（JavaScript）`,
"front-electronic-signature-ContractTemplate":`选择合同模板`,
"c1976":`新建自定义脚本菜单`,
"c1951":`简短备注`,
"c540":`渠道的解决时间`,
"c793":`文档模板`,
"c293":`设置启用GDPR合规性的对象`,
"front-invoice-online-pay-again":`您已经发起线上付款，请勿重复发起。`,
"front-electronic-signature-open-password":`输入账户密码`,
"front-v1-partner-background-tooltip":`文件最大2M，建议上传效果清晰的图片。`,
"c449":`历史会话`,
"c30":`经典版`,
"c1195":`通知分配人`,
"c1497":`5次`,
"c1645":`关系网评分设置`,
"c245":`{!oldServiceResource.name}已将编号（{!ServiceAppointment.name}）的工单转给{!newServiceResource.name}`,
"c923":`这是你的智能聊天`,
"c24":`显示地图`,
"c1712":`步骤1： 选择一个控制字段和一个依赖字段。完成时单击“继续”。`,
"c872":`姓名(未填写)`,
"c886":`打开侧边栏`,
"c1074":`预定义个案团队`,
"c1259":`请选择电子邮件模板`,
"c1820":`URL后缀`,
"c1068":`定额差值`,
"c1596":`大小写区分`,
"c1389":`Lightning详细页面内嵌自定义页面`,
"c1892":`是否确认更改，更改后可能会影响使用用户`,
"c1435":`请输入布局名称`,
"c485":`来自姓名：`,
"c1554":`替换成功`,
"c1780":`新建批准过程`,
"c101":`件`,
"c1883":`唯一标签`,
"c816":`查看帖子详情`,
"c1814":`支付即视为你同意平台协议`,
"c2255":`登录访问权限政策`,
"c2205":`当前语言设置的默认值。要更改此标签的语言，您必须先更改您的个人语言。`,
"c1652":`钉钉外部联系人`,
"c445":`项目角色`,
"c1911":`下载模版`,
"c1677":`费用报表条目`,
"c1046":`请选择文件类型！`,
"c2212":`允许`,
"c1429":`设置权限`,
"c1094":`当`,
"c1004":`CC钉继承CloudCC平台强大的定制化能力，可以针对您个性化的业务需求，快速、灵活的配置扩展。`,
"c2259":`搜索页面`,
"c1035":`对不起，您无当前操作权限，请联系管理员！`,
"c1267":`备选项1`,
"c1653":`企业微信联系人`,
"c2299":`管理员可以作为任何用户登录`,
"c853":`这里显示您发布的帖子的点赞数、评论数。`,
"c398":`开始体验`,
"c522":`已开票数量`,
"c1763":`是否启用注册处理器`,
"c287":`合规`,
"c578":`同环比数字图`,
"c40":`输入账号密码`,
"c631":`去Twitter查看`,
"c489":`停用时间`,
"c819":`手机号/邮箱`,
"c1380":`注意: 该区段中的所有字段都将被移动到'未使用的条目'区段`,
"c935":`表单类型`,
"c625":`全部市场活动`,
"c471":`市场活动：员工邀约`,
"front-electronic-signature-writen":`已填写`,
"c1148":`对象权限`,
"c1015":`用户定义的格式参数`,
"c889":`成功停用门户用户`,
"c201":`在您的社交媒体上分享此表单`,
"c467":`排序字段为空`,
"label.mobile.no.null":`手机号不能为空`,
"c307":`权利`,
"c1796":`前5个按钮固定显示在详情页底部，其余按钮收纳到“更多”`,
"c1489":`页脚工具是固定在系统下方的实用工具`,
"c1019":`附加header参数(例如：API密钥，token令牌等)`,
"c1163":`名片被隐藏，因此无法定制。`,
"front-kefu-moudle-wait-calling":`通话中，请稍后再试`,
"c2250":`同时通知派遣人及被派遣人`,
"c784":`请输入工商营业执照上的企业名称`,
"c490":`最后登录时间`,
"c790":`手绘签名`,
"c336":`潜在客户-销毁`,
"c453":`主页看板`,
"c1157":`当intervaltype类型为hour时候，间隔时间必须大于等于1小时，小于等于23小时。`,
"c1738":`后缀`,
"c1760":`filenames数量和上传图片的数量不匹配！`,
"c1177":`运算符 "{!parameter.type1}" 参数类型错误。预期{!parameter.type2}，却收到{!parameter.type3}`,
"c1960":`请选择添加组件`,
"c1765":`您最多只能上传{n}个文件`,
"c1013":`标准格式的参数`,
"c1083":`税的名称不能为空`,
"c1208":`在线聊天账号未开通，请先开启聊天功能`,
"c530":`请先设置公司发件箱后再执行次操作`,
"c1268":`备选项2`,
"c610":`如果未指定URL，您的图标将链接到您的主域`,
"c359":`详情页图表`,
"c1438":`请选择页面布局`,
"c1279":`●  读 / 写 - 用户可以查看和覆盖预测数据`,
"c193":`提交限制`,
"label.mobile.verificationCode.exceeded.times":`验证码错误超出次数，请重新获取`,
"c138":`公司模板`,
"c821":`新增内部联系人`,
"c381":`请求在线支付`,
"c1590":`编辑是否允许重复`,
"c1484":`必须包含大小写字母和数字和符号`,
"c761":`签署`,
"c1370":`部分名称`,
"c2108":`服务申请单评价`,
"c964":`主详字段必填`,
"c585":`英国地图`,
"c500":`通过标准化服务流程和高效的团队管理，提供一站式客服解决方案，协同内外部服务资源，为客户提供最好的支持以及更满意的服务。`,
"c1502":`面板宽度以像素为单位，输入值范围为1-1920px。`,
"c214":`包含三种尺寸的位图和所有格式的矢量图`,
"c714":`在合适的时间发布帖子`,
"c1341":`  勾选了启用工商数据验证，用户录入企业客户资料时，可协助用户录入正确的客户工商注册信息`,
"c1718":`已经计划给{0}，不能重复计划。`,
"c1044":`下载至文档`,
"c1846":`请选择控制该规则的主字段`,
"c1789":`考勤人员`,
"c552":`已驳回`,
"c684":`…还有{sumTotalCount}个。`,
"c54":`请填写税种类`,
"c320":`表单字段选择`,
"c1008":`复制产品项详情`,
"c236":`{!ServiceResource.name}已接单。客户：“{!ServiceAppointment.accountid.name}”，编号：“{!ServiceAppointment.name}`,
"c1592":`自动编号字段属性`,
"c1588":`值不能为数据库关键字`,
"c1901":`有时DNS更改可能需要长达24小时才能在世界各地生效`,
"c123":`产品运输状态`,
"c2181":`显示数据`,
"c654":`回到仪表板列表`,
"c1442":`要将其他用户分配给此角色`,
"c1779":`图片的总大小不超过20M`,
"c1363":`部分标题显示在`,
"c335":`利润率`,
"c267":`不满足条件，更改失败`,
"c1818":`配置工作流规则`,
"c1803":`请输入URL`,
"c2226":`在智能设备上支持MFA的常用应用程序有阿里云、Google Authenticator.`,
"c226":`跳转到子任务`,
"c102":`一次点击`,
"c637":`保存为草稿`,
"c1336":`结束字符`,
"c633":`创建新的社交帖子`,
"c1103":`常规`,
"c777":`设置参与方信息`,
"c223":`添加项目`,
"c592":`瀑布图`,
"c1714":`根据实际使用场景选择符合业务需求的模块`,
"c1439":`没有可以保存的内容`,
"c1402":`预测类别值不能为空`,
"c315":`只有已生效的订单支持生成发票`,
"c89":`邮件活动名称`,
"c108":`自动匹配成功`,
"c1507":`180天`,
"c402":`现场云`,
"c748":`请为{title}选择价格手册，您只能从单个价格手册添加产品。更改已选取的价格手册，将删除全部现有的产品。`,
"c1293":`在 Microsoft Exchange中为用户设置带有模拟权限的服务帐户后，输入服务帐户凭据，以允许CloudCC 与 Exchange服务器通讯。如果已保存服务帐户凭据但用户仍无法同步记录，确保您已正确设置Exchange Sync。`,
"c1625":`沟通渠道`,
"c501":`为您的客户提供优质的现场服务`,
"c1877":`登录时间`,
"c269":`合并信息失败`,
"front-electronic-signature-open-confirm":`绑定账号`,
"c584":`美国地图`,
"c437":`发布失败`,
"c738":`发送日期`,
"c2096":`编辑用户可选择的服务类型名称，及当前服务类型关联的系统记录类型`,
"c274":`您超时未接单，已取消派单，编号{0}。点击查看详情>`,
"c83":`搜索数据`,
"c206":`PNG格式`,
"c1903":`如何制作word`,
"c309":`发送订单文件`,
"c1899":`核实验证`,
"c539":`信息来源占比最大`,
"c304":`重要利益`,
"c2130":`相关客户`,
"c1835":`CloudCC 配置`,
"c1413":`字段标签不能为空`,
"c1348":`拓展接口URL`,
"c2203":`名称字段只能包含下划线和字母数字字符。它必须是唯一的，以字母开头，不包括空格，不得以下划线结尾，且不得包含两个连续下划线`,
"c1452":`队列标签`,
"c1064":`已保护的组件`,
"c151":`简单描述表单的主要内容`,
"c1912":`查看不同对象的预置模版样式，支持本地下载`,
"c1294":`Exchange Sync 配置`,
"c639":`立即发布`,
"c1401":`选项列表值不能为空`,
"c1535":`用于配置在客户联系人架构图中，联系人五星图的评分规则`,
"c720":`不用了，谢谢`,
"c2301":`第{0}行条件错误，未设置字段!`,
"c1913":`下载Word模版`,
"c801":`新增联系人`,
"c900":`拜访对象暂无地址信息，无法计算签到距离`,
"c2145":`共享已分配的服务预约的父级工作订单给对应服务区域的用户`,
"c1669":`消耗产品`,
"c1069":`个案团队角色`,
"c695":`原始尺寸`,
"c2138":`取消分配失败`,
"c864":`选择一个表单`,
"c1443":`从下拉列表中选择，以显示可用用户`,
"c881":`我已阅读并同意`,
"c2142":`分配共享规则`,
"c794":`签署模板`,
"c543":`收到评价`,
"c1400":`控制字段或依赖字段不能为空`,
"c2125":`自助注册设置`,
"c1217":`自定义组件菜单配置`,
"c466":`仅支持同一价格手册的订单新建发票`,
"c1783":`而且，当记录在批准过程中时，它总是锁定的--只有管理员可以对其进行编辑。但是，您也可以选择允许当前分配的批准人来编辑该记录。`,
"c867":`{userName}将收到邀请邮件，会提示创建密码后以访问您的帮助中心。
是否继续？`,
"c1185":`2个周期`,
"c529":`暂无可用充值方式，请联系管理员`,
"c2079":`是否卸载软件包？`,
"c742":`您最多可选择4张图片，点击选中图片，文件上传单张不超过200K`,
"c430":`搜索性能词`,
"c2303":`第{0}行条件错误，未设置字段类型!`,
"c1180":`相关角色`,
"c553":`最新邀请时间`,
"c575":`柱形图`,
"c124":`待发货`,
"c1664":`计划策略工作规则`,
"c1525":`潜在客户字段和市场活动成员字段相关联`,
"c629":`发布失败的帖子`,
"c554":`首次邀请时间`,
"c547":`最近7天`,
"c1682":`时间条目`,
"c1368":`标题仅在编辑页面上可见`,
"c599":`表格图 `,
"c588":`加拿大地图`,
"c703":`发布平台`,
"c1357":`选择结束日期`,
"c1031":`至少添加一条产品`,
"c713":`从CloudCC内部创建社交帖子`,
"c142":`此操作发生于访问者在您的页面提交了表单之后`,
"c2316":`{!ServiceTerritory.name}因超时未接单已自动拒单，编号“{!ServiceAppointment.name}”，点击查看。`,
"c1111":`URL通知`,
"c153":`清空当前记录关联的产品后，可更改币种。`,
"c1942":`移动端url`,
"c1431":`使用此页面可创建各种页面布局以显示 用户 数据。在创建页面布局之后，单击“页面布局分配”按钮，以控制用户在默认情况下看到哪个页面布局。`,
"c253":`GDPR合规性`,
"c1479":`公式存在错误，请检查！`,
"c1313":`错误：验证规则编译未通过，请检查语法`,
"c1771":`通过网站提交的服务请求单可在系统内生成个案记录，在此可进行服务请求单页面配置。网页适用于电脑和手机`,
"c1079":`个案团队成员`,
"c612":`内部页面`,
"c1382":`清除高级筛选`,
"c1716":`待接单`,
"c400":`服务资源的位置信息`,
"c1176":`取消必填字段`,
"c1398":`点击上传`,
"c671":`图标和文字`,
"c1227":`选择用户`,
"c20":`不能超过相关订单的待开具发票的数量`,
"c514":`报表图表`,
"c1055":`RequestBody参数非json格式`,
"c946":`英国`,
"c1635":`资产二维码规则`,
"c1506":`90天`,
"c1351":`通过设置Nexmo API帐户，用户能够在CloudCC平台上访问Vonage API帐户以发送和接收文本消息。`,
"c1719":`钉钉集成`,
"c717":`创建帖子`,
"c1308":`任务冲突行为：始终首选Exchange`,
"c174":`编辑全部成功`,
"c1330":`多选列表`,
"c1465":`火星时区`,
"c940":`中国香港`,
"c1553":`记录所有者邮件地址`,
"c743":`请输入有效的数字`,
"c1232":`选定可选用户列表中显示的用户分配给角色CEO`,
"c1940":`必须填写PC端或移动端URL`,
"c2085":`已取消卸载`,
"c1963":`解除MFA绑定成功`,
"c2236":`消息通知将可让您随时了解您的重要客户的最新沟通状况。`,
"c441":`业财一体化智能管理`,
"c1794":`超时后处理方式`,
"c2115":`一句话介绍`,
"c1910":`3.上传邮件合并模板：在本地修改好Word模版之后，上传word文件`,
"c1406":`请上传文件`,
"c1197":`其他电子邮件`,
"c423":`派工平台`,
"c723":`确认请求销毁`,
"c664":`还没有社交网络。`,
"c1071":`替换个案团队角色`,
"c859":`请输入{0}`,
"c2147":`共享已派遣的服务预约的父级工作订单给已分配服务资源`,
"c356":`派工成本`,
"c221":`跳转到项目`,
"c1225":`PC端图标`,
"c1906":`想要跳过分步说明嘛？`,
"c1569":`已经处理您的导出请求,请查看您的电子邮箱`,
"c1339":`选择制作模板的对象`,
"c1837":`请输入URL后缀`,
"front-email-payment-Invoice-Tips1":`请联系管理员，开通微信、支付宝、PayPal或VISA后，再发起线上付款`,
"c99":`产品数量`,
"c278":`删除此后续电子邮件?`,
"c364":`报价行`,
"c572":`已选字段不能为空，请添加字段。`,
"c2080":`卸载成功`,
"c310":`生成订单文件`,
"c247":`已转单`,
"c158":`分配时间阈值`,
"c325":`个案分配通知模版`,
"c1600":`地理定位字段属性`,
"c985":`网络已断开，请检查网络连接`,
"c1277":`新建 全局选项列表值集`,
"c877":`无序填`,
"c1364":`分栏布局`,
"c1564":`复选框字段属性`,
"front-filter-v1-press":`按`,
"c505":`网站访客追踪`,
"c523":`添加为门户用户`,
"c727":`销毁数据成功`,
"front-electronic-signature-sended":`已发送`,
"c150":`请在选项栏填写必要值`,
"c700":`最后更新时间`,
"c1325":`企业微信-H5微应用`,
"c1263":`字段依赖性:编辑`,
"c1700":`电子围栏半径`,
"c824":`顺序签`,
"c710":`一个平台管理所有社交媒体`,
"c1320":`当前步骤表单校验未通过，请检查后再下一步`,
"c1130":`编辑贵组织使用的币种与其他币种之间的兑换率`,
"c1610":`币种字段属性`,
"c358":`预算`,
"c1537":`用户输入拜访次数，经规则计算出拜访次数分值`,
"c1530":`新建关键信息布局`,
"c1968":`该功能配额不足无法继续访问，请联系您的系统管理员。`,
"c544":`渠道`,
"c1211":`标准样式`,
"c212":`SVG格式`,
"c1255":`3.移动页面布局：应用于微信小网页及手机版显示的布局'`,
"c2231":`CLoudCC-api-auth2.0(Code)正在要求：`,
"c165":`请输入0-24内的整数数值`,
"c1081":`团队`,
"c1922":`文件最大支持5MB`,
"c1463":`美国时区`,
"c1583":`西班牙文`,
"c1415":`长度格式有误`,
"c932":`垃圾邮件`,
"c888":`成功激活此用户`,
"c838":`经办人`,
"c98":`产品种类`,
"c830":`由谁创建`,
"c661":`网络`,
"c1073":`用来替换的个案角色`,
"c1509":`个密码`,
"c818":`自定义页面菜单设置`,
"c861":`从地图选择`,
"c736":`帖子发送人`,
"c204":`标准`,
"c1962":`重置密码成功`,
"c1753":`开启后，可设置最大允许的接单时长以及超时后处理方式。`,
"c1563":`地址字段属性`,
"c1709":` 关闭：默认不显示在组织内所有成员的主页中，用户可以通过移动端“配置我的主页”来开启模块。`,
"c1049":`生成失败，目前仅支持docx类型模板生成PDF文件`,
"c1961":`仅支持xlsx格式的文件`,
"c1123":`当创建或编辑记录时`,
"c839":`看起来并没有预约的帖子`,
"c1473":`新建 分配规则`,
"c456":`已回款金额`,
"c1697":`新建软件包`,
"c1151":`若选择“向成员发送电子邮件”，向队列分配对象时，将通知队列成员，不选择不通知。`,
"c2215":`授权时出现问题`,
"c341":`决算`,
"c1281":`显示条数`,
"c724":`确认销毁数据`,
"c1017":`值的描述`,
"c1668":`用户区域`,
"c1943":`文章数量达到系统版本限制，请联系管理员升级版本。`,
"c865":`我已阅读并同意{0}及{1}`,
"c1193":`3个周期前`,
"c1744":`自定义注册处理类`,
"c1142":`过滤条件`,
"c1164":`取消隐藏才能定制它以便将其显示在明细页面。`,
"c332":`数量不能超过订单待开票数量`,
"c520":`当前可用返利金额不足，支付失败`,
"c906":`减去`,
"c1174":`定制设置`,
"c482":`为您的活动命名：`,
"c49":`更新域安全设置`,
"c1290":`候选人列表`,
"c725":`撤销销毁请求成功`,
"c76":`支付`,
"c1622":`身份提供商`,
"c1331":`不为空`,
"c1134":`请选择权限集`,
"c558":`搁置的个案`,
"c1884":`先去开发者平台创建自定义页面，在自定义页面中添加呼叫中心工具组件`,
"c1690":`伙伴账户充值记录`,
"c876":`无序签`,
"front-invoices-v1-nofilles-tocreate":`请点击生成发票按钮，生成发票后再发送。`,
"c779":`签署截止日期`,
"c1095":`添加另一个选项`,
"c603":`同环比双轴图`,
"c1527":`CCChat设置`,
"c1752":`接单时长阈值`,
"c1093":`当不符合条件时`,
"c1144":`可视性`,
"c1203":`请先选择要转移的数据`,
"c1496":`10次`,
"c455":`合同达成目标`,
"c1766":`点击这里或者拖拽文件到这里来附加`,
"c1731":`派遣失败`,
"c428":`地图模式派工`,
"c55":`请填写税值`,
"c1604":`引入图片`,
"c899":`签到距离`,
"c1887":`提供商Auth Token1`,
"label.facebook.title":`Facebook-H5微应用`,
"c487":`收件人姓名：`,
"label.social.posts.info":`未查询到帖子内容`,
"c704":`观众`,
"c1005":`如需使用CC钉请联系我们`,
"c673":`网络形象`,
"front-electronic-signature-singed":`已发起签署`,
"c722":`一个账号已连接`,
"c595":`面积图`,
"c1886":`提供商账户`,
"c1054":`该模板下未创建内容，请设置好模板后再保存`,
"c2300":`简档用户`,
"c1344":`编辑工作流`,
"c120":`类`,
"c68":`待付款订单`,
"c479":`Mailchimp分享中分享CloudCC表单`,
"front-electronic-signature-explain-mainTitle":`电子签章`,
"c5":`税`,
"c1022":`查看PDF视图`,
"c2114":`公司介绍`,
"c976":`批准并预约帖子`,
"c812":`评论`,
"c532":`搁置个案总数`,
"c330":`合同行项目`,
"c1296":`新建规则`,
"c249":`个帖子立刻发布`,
"c630":`去LinkedIn查看`,
"c1160":`第一次执行时间为:#time,以后每隔#number小时执行一次。
`,
"c1356":`选择开始日期`,
"c958":`帖子点赞ID不能为空`,
"c1378":`移到未使用的字段中去`,
"c170":`id为{0}的数据新建失败，失败原因为{1};`,
"c810":`回复`,
"c783":`签署要求`,
"c968":`断链`,
"c752":`发起签署任务`,
"c1040":`我们已将新安全标记发送到客户 {0} 的电子邮件地址。`,
"c439":`访客`,
"c1002":`CloudCC钉应用是基于CloudCC与钉钉平台打造的营销、销售、服务一体化解决方案。`,
"c1470":`有必填项未填`,
"c1184":`Webhook配置`,
"c1707":` 你可将与企业业务无关的组件从默认配置中禁用或关闭`,
"c2248":`同时通知并取消分配`,
"c67":`订单提交成功！`,
"front-generate-v1-invoice":`生成发票`,
"c477":`您必须验证您的Mailchimp帐号。请点击“验证Mailchimp”按钮重定向到Mailchimp已发送市场活动`,
"c1315":`联系人冲突行为`,
"c966":`请联系系统管理员`,
"c1726":`百分比字段属性`,
"c764":`已拒签`,
"c301":`最多输入200个字符`,
"c1027":`请检查密钥对是否正确或是否被禁用`,
"c61":`请先开启知识库后使用`,
"c815":`归档全部`,
"c827":`如果您继续的话，您当前页面未保存的更改将丢失`,
"c1460":`从左侧选择一个用户并将其添加到已选中用户列表。`,
"c688":`最大宽度`,
"c1693":`钉钉集成设置`,
"c1692":`动作`,
"c1939":`当前版本最多支持{!count}篇知识文章`,
"c1237":`请选择状态`,
"c33":`编辑订阅类型`,
"c217":`个帖子将于 {date} 发布`,
"c721":`断链账号`,
"c284":`处理CRM内客户的数据请求`,
"c1273":`菜单可见性`,
"c2310":`{!ServiceTerritory.name}超时未接单，编号“{!ServiceAppointment.name}”，点击查看。`,
"c2227":`如果您因为某些原因（如手机丢失或者误解除MFA应用等）无法进行验证，可以通过管理员解除MFA绑定。`,
"c939":`中国澳门`,
"c503":`追踪您的项目进度`,
"c1090":`基于特定条件选择`,
"c2103":`页面地址前缀`,
"c1800":`单个对象的最大队列个数为{0}。`,
"c492":`已邀请`,
"c2216":`我们无法让您授权，因为出现了一下错误，有关更多信息，请联系您的cloudcc管理员`,
"c2144":`共享已分配的服务预约给对应服务区域的用户`,
"c1428":`标记为必填`,
"c73":`当前余额`,
"label.the.peoples.republic.of.china":`中华人民共和国`,
"c828":`帖子`,
"c36":`预习`,
"c954":`新建手机号`,
"c1504":`30天`,
"c1520":`下面是按钮和链接列表。要添加按钮或链接，请编辑页面布局。<br />按钮可以显示在详细信息页、相关列表和列表视图上：<br />1.要自定义详细信息页上的按钮或链接，请编辑页面布局。<br />2.要自定义相关列表上的按钮或链接，请在页面布局上相关列表出现的位置编辑相关列表的属性。<br />3.要自定义列表视图上的按钮或链接，请在“搜索布局”中编辑列表视图布局。<br />`,
"front-electronic-signature-innerSinger":`内部签署人`,
"c2113":`页面设置`,
"c1457":`从下拉列表中选择，以显示可用用户。`,
"c508":`ROI投资回报分析`,
"c833":`认证通过`,
"c1872":`子域`,
"c1804":`URL格式校验未通过，请检查`,
"c2148":`共享已派遣的服务预约给已分配服务班组组长`,
"c1212":`在本页面可进行批量删除记录操作`,
"c207":`矢量格式`,
"c1441":`使用此页面定义您的组织使用的所有货币。<br />应将公司币种设置为公司总部在收入报告时所使用的币种。<br />如果指定其它币种作为公司币种，则会修改所有兑换率以反映此变化。`,
"c31":`二分屏`,
"c71":`请选择以下付款方式`,
"c1061":`发表张贴`,
"c373":`标准价格手册`,
"c545":`解决时间（小时）`,
"c77":`设置模块`,
"label.lastcompiledate":`最后编译时间`,
"c1216":`未上传`,
"c119":`确认收货`,
"c1047":`请选择文件保存方式！`,
"c281":`数据处理`,
"c1713":`步骤2:在下面的页面上，编辑筛选规则，这些规则针对控制字段中每个值控制出现在依赖字段中的值`,
"c1332":`为空`,
"c1189":`5个周期`,
"c715":`检测品牌提及并快速反应`,
"c1347":`周期性的时间触发器`,
"c127":`管理列`,
"c2157":`编辑静态资源`,
"c1500":`面板宽度`,
"c1391":`   推动筛选的字段称为控制字段。具有至少一个值且小于300个值的标准和自定义复选框和选项列表可以是控制字段`,
"c1173":`无法显示此列表预览`,
"c283":`数据请求`,
"c1464":`英国时区`,
"c919":`使用公海池激发团队的潜能，提高潜在客户转化率。将潜在客户纳入公海池统一管理，公海池管理员批量进行分配，销售人员也可自行甄别线索，领取跟进。`,
"c1979":`自定义脚本菜单`,
"c82":`仅Lightning版本`,
"front-file-delete-intro":`已移除文件`,
"c1634":`客户满意度`,
"c1213":`控制台样式`,
"c606":`默认收货地址`,
"c1250":`您确定要删除此布局吗？`,
"c1474":`规则名称不能为空`,
"c2106":`5天`,
"c1732":`分配失败`,
"c2137":`取消分配成功`,
"c905":`增加`,
"c644":`
发布时间`,
"c1560":`是否开通群策`,
"c75":`返利余额`,
"c1026":`请检查用户安全标记是否已更新`,
"c1586":`公式字段属性`,
"c884":`《隐私声明》`,
"c538":`平均解决时间`,
"c322":`新建发票`,
"c1140":`权限集名称`,
"c1135":`分配自定义页面`,
"c1167":`您的名片卡中最多可添加10个字段。`,
"c461":`收款金额趋势分析`,
"c825":`企业`,
"c56":`发票回款总计和回款金额不一致，请重新填写。`,
"c931":`您尚未开启员工定位开关，无法使用移动端位置上报间隔时间，是否继续？`,
"c1981":`保存导出`,
"c1673":`时隙`,
"c276":`启用GDPR合规性`,
"c334":`预算总额`,
"c733":`市场活动：新建海报`,
"c1146":`是否应用于移动端`,
"c384":`新建装箱单`,
"c139":`会议模板`,
"c1908":`查看你的DNS记录`,
"c1576":`已被添加`,
"c1568":`已存在`,
"c2133":`页面地址`,
"c957":`帖子评论ID不能为空`,
"c2124":`允许伙伴用户注册，审批后启用`,
"c1060":`采购订单产品`,
"front-electronic-signature-nosign":`贵机构尚未选择电子签章服务商，请联系系统管理员开通`,
"c1411":`20分钟`,
"c1050":`生成成功，文档已保存至文件列表`,
"c419":`维护计划`,
"c1230":`此页面将列出对CEO具有共享访问的用户、角色及区域`,
"c934":`提交标题`,
"c1020":`1.价格手册开启后，系统会默认生成1个标准价格手册。标准价格手册包含所有的产品。`,
"c677":`居右`,
"c593":`折线图`,
"c272":`{0}超时未接单，客户：{1}，主题：{2}，编号：{3}。点击查看详情>`,
"c1742":`自定义错误页面`,
"c811":`转推`,
"c451":`拆分个案`,
"c277":`一旦您点击删除电子邮件，此后续电子邮件将被删除，并且不会发送给任何未来的联系人。这是无法撤销的。`,
"c244":`{!ServiceResource.name}已拒单。编号：“{!ServiceAppointment.name}”`,
"c627":`已发布帖子`,
"c2141":`分配派遣规则`,
"c1862":`预览URL`,
"c1578":`日本語`,
"c601":`目标图`,
"c251":`个帖子发布失败`,
"c202":`在Mailchimp中分享`,
"font-social-prohibit-create":`编辑状态下无法新建帖子`,
"c394":`CloudCC助您提升业务效率，线上管理您的业务流程。选择您想要使用的应用程序，我们将为您提供进一步的介绍与引导。`,
"c1642":`成员设置`,
"c1684":`项目云对象`,
"c1362":`空白`,
"c1124":`汇率范围： 2022-05-31 到 Tue May 31 00:00:00 CST 2022之后`,
"c1323":`显示必填字段`,
"c323":`PDF格式`,
"front-setting-dialog-title-one":`为防止账号丢失、快速登陆、方便找回,请绑定手机号`,
"front-electronic-signature-cancelIntro2":`如果您是进行第1次账号绑定，请点击继续进入到下一步；如果您是解绑后需要重新绑定，建议点击取消按钮，清除浏览器缓存后再进行绑定。`,
"c1715":`启用：勾选后模块将显示在移动端“更多”-“标准功能”
禁用：勾选后模块将不再显示在移动端“更多”-“标准功能”`,
"c1379":`您确定要删除此分栏？`,
"c2095":`点击进行分配规则配置`,
"c353":`实际工作清单显示`,
"c621":`富文本内容`,
"front-v1-partner-image-tooltip":`文件最大为2M，图片将被等比压缩为{size}大小，建议上传效果清晰、比例相似的图片。`,
"c1967":`抱歉，记录锁定，您无权编辑该条数据，请联系系统管理员。`,
"c772":`已定稿`,
"c1018":`附加实体参数`,
"c734":`海报渠道名称`,
"c380":`新建回款`,
"c1291":`状态颜色图例`,
"c2217":`是否开启加签`,
"c979":`重庆市`,
"c1723":`格式错误，请使用yyyy/MM/dd或者yyyy-MM-dd的格式。或函数:Today()`,
"c1247":`要求所有选定批准人的一致批准。`,
"c1514":`角色:山东一部`,
"c233":`不能删除存在已配送的装箱单`,
"c2162":`索引创建失败`,
"c458":`客户分布图`,
"c697":`选择客户地址-{name}`,
"c1701":`依据地址`,
"c476":`选择要发送邀约码的员工`,
"c634":`创建有趣的帖子和世界分享`,
"c1567":`请输入正确的数字，最大长度8位`,
"c1288":`推荐策略规则`,
"c1607":`日期和时间字段属性`,
"c1166":`定制`,
"c144":`结束时间不能超过2038年，请重新选择结束时间。`,
"c2229":`请输入6位安全码`,
"c1032":`已根据币种汇率进行换算`,
"c2177":`拒单失败`,
"c474":`您可以通过潜在客户分配规则进行重新分配。关于分配规则请访问这里`,
"c2207":`是否将Open ID Connect 账户`,
"c371":`同步至业务机会`,
"c420":`维护资产`,
"c620":`分配市场活动，用于对多个内容分组，以便于在单个营销活动中进行分析`,
"c1643":`替换小组角色`,
"c708":`是否统一刻度`,
"c100":`累计折扣`,
"c576":`二维柱形图`,
"c2290":`共享已派遣的服务预约给已派遣服务资源`,
"c751":`签署截止日期：`,
"c1132":`请输入标签`,
"c252":`合规性设置`,
"c1562":`您没有要更改的内容`,
"c699":`仅限新的`,
"c74":`返利支付`,
"c1778":`允许的图片限制`,
"c805":`选择一个社交网络开始`,
"c452":`个案历史`,
"c740":`请选择要邀约员工`,
"c596":`双轴图`,
"c1508":`记住`,
"c1137":`删除分配`,
"c1636":`服务报告模版`,
"c2219":`主标签文本：`,
"c1792":`重新分配操作`,
"c2128":`默认简档`,
"c832":`审核中`,
"c971":`定时发布`,
"c262":`历史记录`,
"c363":`敏感`,
"c2101":`限制提交用户数量`,
"c1117":`此操作将永久删除该工作流规则, 是否继续`,
"label.singleSignOn.is.invalid":`免登录已失效`,
"c1941":`PC端Lighting版本页面`,
"c72":`第三方支付`,
"c1870":`指定您的内容的托管位置`,
"c292":`市场云`,
"c1874":`顶级域名`,
"c1131":`新建权限集`,
"c1807":`请检查RequestBody格式参数格式是否正确`,
"c1349":`复制工作流`,
"c2153":`服务资源接单`,
"c499":`高效的客户服务让客户留下深刻印象`,
"c574":`堆砌条形图`,
"c1593":`URL 字段属性`,
"c618":`Twitter24小时内不能发布内容相同的帖子，请更换帖子内容或者发布时间 `,
"c2160":`审批方式`,
"front-setting-phone-format":`请录入正确的手机格式`,
"c460":`客户数量排名`,
"c189":`发票币种需要和订单币种保持一致，请修改发票币种后再保存`,
"label.exe.supported.request.rejected":`不支持发送exe.格式文件，请求被拒绝！`,
"c835":`该报价单已经开具了发票，您是否想再次开具发票？`,
"c1907":`1.下载模板：选择对象，支持将当前对象预置的模板下载至本地`,
"c2223":`使用其他用户名登录`,
"c2168":`新建 case`,
"c1720":`查找辅助字段`,
"c1850":`确定您导入的文件末尾已进行回车换行`,
"c655":`发帖自`,
"c1513":`所有人 等于 biysuat普通`,
"c1781":`定义批准步骤时，可以向不同的用户分配批准请求。其中一个选项是为了使用用户字段自动传送这些请求。`,
"c1392":`请输入结束日期`,
"c45":`链接人`,
"c1821":`密钥`,
"c43":`连接账户`,
"c1534":`关键信息布局字段不能为空`,
"c481":`以其它账号登录`,
"c674":`外部地址`,
"c266":`当前订单已完成，无法更改`,
"c967":`您即将断链{0}账号。这将删除关于本账号全部的社交媒体设置和发布选项。`,
"c1010":`已禁用`,
"c1769":`至{Date}到期`,
"c154":`请选择产品后查找价格手册`,
"c841":`有什么新想法？记录下来。`,
"c615":`发帖账号不能为空`,
"c1416":`小数位数格式有误`,
"c84":`选择需要发送邀约码的员工`,
"c401":`客服云`,
"c290":`启用对象`,
"c1733":`派遣`,
"c205":`下载二维码`,
"c928":`最多可选择10个字段`,
"c195":`最大提交限制`,
"1":`无可用操作`,
"c1224":`权限不足，请联系系统管理员，在多组织配置库用户表信息下配置角色，角色ID：{id}`,
"c46":`授权成功`,
"c459":`已签约合同金额`,
"c1387":`未使用字段`,
"c1394":`编辑选项列表值`,
"c1274":`编辑 全局选项列表值集`,
"c1528":`大于等于`,
"c2083":`请输入要安装的软件包id`,
"c250":`个帖子保存为草稿`,
"c399":`商务云`,
"c1107":`高级筛选条件校验未通过，请检查`,
"c1589":`文本区字段属性`,
"c1774":`已配置字段`,
"c1034":`对象名过长`,
"c518":`#label的#recordName由于#failReason审批失败。`,
"c396":`选择不同的解决方案`,
"c300":`请求销毁的`,
"c789":`不限制签名方式`,
"c874":`您已经浏览完全部的消息
`,
"c1955":`请检查输入参数，请求值中存在SQL注入风险。`,
"c38":`小区楼栋`,
"c228":`添加子任务`,
"c1122":`当创建或编辑记录时，第一次满足规则条件时`,
"c342":`利润`,
"c1747":`单点登录初始化`,
"c1703":`是否允许上传相册图片`,
"c2167":`case 变更`,
"c879":`复制社交帖子`,
"c173":`重新绑定成功`,
"c2127":`验证方式`,
"c1089":`全部记录`,
"c1354":`页面布局名`,
"c778":`发起方`,
"c1594":`必须`,
"c1334":`短信网关密码(MD5)`,
"c1946":`必填项值不能为空`,
"c1515":`改写标准按钮和链接更改了CloudCC URL以及对该URL所有调用（例如CloudCC页面、浏览器快捷方式或外部系统）的含义。<br />您可以使用CloudCC的自定义页面替换标准按钮或链接的CloudCC URL。<br />请选择用来替换此标准按钮或链接的CloudCC URL的自定义页面。`,
"c211":`小尺寸`,
"c1601":`选择列表字段属性`,
"c1159":`第一次执行时间为:#time,以后每隔#number分钟执行一次。
`,
"c1825":`标记颁发人`,
"c1478":`输入规则名，然后选取已启用复选框，将此规则用于自动个案升级。启用此规则将禁用当前的个案升级规则。`,
"c1388":`创建新字段`,
"c496":`CloudCC销售云，全场景智能CRM助力销售成单`,
"c1085":`编辑简档`,
"c427":`甘特图模式派工`,
"c851":`这里显示了在所选时间段内您的帐户发布的帖子数量。`,
"c32":`创建订阅类型`,
"c1953":`服务地址404，请联系管理员`,
"c1165":`名片卡`,
"c28":`同比增长`,
"c2088":`{!ServiceResource.name}已拒单。编号：“{!ServiceAppointment.name}”，点击查看`,
"c163":`同时通知并取消派遣`,
"c1772":`在线个案`,
"c1743":`自定义注销页面`,
"c1863":`备用邮箱`,
"c225":`跳转到任务`,
"c569":`请先选择客户`,
"c1317":`此操作将禁用该工作流, 是否继续？`,
"c92":`一次打开`,
"c1706":`根据实际使用场景配置组织级主页`,
"c2166":`成员重复`,
"c412":`自动创建服务预约`,
"c81":`加入购物车`,
"c999":`手机号或密码错误`,
"c653":`这会显示您发布的帖子的点赞数、反应数和评论数。这还包括在CloudCC之外发布到您已连接帐户的帖子。如果您正在寻找 Twitter 转推，您可以在“共享”中找到它们。`,
"c1762":`拓展字段`,
"c1467":`会计年度名称 必须是正整数`,
"c2298":`安装软件包测试`,
"c1647":`业务机会小组设置`,
"c516":`考勤表`,
"c1241":`允许或搬运用户编辑个人信息`,
"c1459":`下载并保存至文件`,
"c918":`若配置了自动回收规则，客户超时未成交，系统会自动将记录收回至公海池，提高客户的跟进效率。`,
"c809":`点赞`,
"c1570":`导出异常`,
"c1532":`选择函数`,
"c1192":`这些是执行工作流规则、蓝图以及审批流程时分配给用户的任务`,
"c2297":`没有内容`,
"c181":`请填写工作订单或个案记录`,
"c745":`请输入最多2位小数`,
"c669":`配色方案`,
"c929":`请检查网络连接`,
"c2292":`共享服务预约的父级工作订单给对应服务区域的用户`,
"c117":`保存并支付`,
"c1240":`伙伴云角色和用户设置-用户角色数量`,
"c938":`中国大陆`,
"c112":`目前所有{name}模板均处于禁用状态，请联系管理员，启用模板后再生成{name}。`,
"c347":`更改项目任务工时`,
"c795":`请选择合同模板`,
"c1631":`访问设置`,
"c17":`未激活, 请重新选择`,
"c787":`经办人签名`,
"c829":`市场活动`,
"c1929":`翻译文章-提交翻译`,
"c1041":`3.文件类型`,
"c161":`同时通知给`,
"c1936":`字段条件为空时，展示全部记录`,
"c2198":`尊敬的用户，您好。<br/>{!authcode} 为您的注册验证码，请在15分钟内完成输入。<br/>如非本人操作，请忽略此邮件。`,
"c65":`是否将发票产品运输状态调整为已收货？`,
"c1958":`兑换率不能为空`,
"c1843":`连接`,
"c1823":`标记端点 URL`,
"c665":`添加一个`,
"c767":`签署进度查询`,
"c2131":`页面标题`,
"c87":`市场活动表单营销推广二维码`,
"c589":`法国地图`,
"c1343":`您当前使用的免费版，接口单日查询上限1万次。如果您需要扩充查询次数，建议购买服务。购买服务后，向厂商获取token在本页面进行配置，厂商为您提供对应的付费服务。<br>购买或咨询请联系 400-642-2008`,
"c1405":`邮件合并模板为Microsoft Word文档，其中的合并字段引用CloudCC字段。单击'新建模板'可上载新的邮件合并模板`,
"front-electronic-signature-newTime":`最新更新时间`,
"c2165":`剪辑文本`,
"c813":`分享`,
"c85":`已选择{member}个邀约员工`,
"c951":`波兰`,
"c1853":`添加选项列表值：小组角色`,
"c1788":`在此处键入并按enter开始搜索`,
"c2204":`链接 Open ID Connect 账户`,
"c29":`环比增长`,
"c1170":`选择在相关列表上显示的标准按钮。您也可重新排序选定的按钮。`,
"c210":`大尺寸`,
"c1615":`导入定额`,
"c39":`存档`,
"c672":`文字`,
"c97":`该选项列表必须包含至少一个“已转换”的选项`,
"c687":`最大尺寸`,
"c1646":`记录类型名称`,
"c916":`关闭公海池`,
"c475":`请填写市场活动所有人`,
"c2099":`二维码创建人`,
"c1376":`您喜欢做什么？`,
"c1097":`应用的规则`,
"c1812":`介绍`,
"c1486":`起始时间`,
"c628":`预约发布的帖子`,
"c788":`该业务机会的价格手册目前已禁用，请启用后再新建订单。`,
"c1030":`套餐内产品`,
"c1670":`资源首选项`,
"c1436":`选择布局`,
"c1302":`事件同步方向`,
"c1768":`修改`,
"c1902":`后退`,
"c177":`图片建议尺寸：390*210`,
"c1980":`控股比例不能为0!`,
"c1859":`注意：角色和下属"包括特定角色中的所有用户和该角色下的角色。`,
"c856":`暂时没有发布失败的帖子`,
"c2117":`已经分配过{0}，不能重复分配`,
"c1782":`如果要将此选项用于任何批准步骤，请从下面的选项列表中选择一个字段。`,
"c70":`订单信息`,
"c1533":`标签不能为空`,
"c1141":`许可类型`,
"c546":`最近24小时`,
"c1447":`不允许将已选中用户列表中的用户移除给所有未分配且已启用的用户和所有未分配的用户两个选项`,
"c331":`转换资产`,
"label.order.paidamount.greater.than.total":`回款明细新建后，订单的已回款金额将大于订单金额。请重新调整回款金额后再保存。`,
"c524":`重新邀请`,
"c1456":`要将其他用户分配给此角色：`,
"c1758":`图片的总大小不得超过20MB`,
"c1175":`设置为必填字段`,
"c1547":`查看/添加未用的值`,
"c1717":`您收到新的工单{0}，请您及时处理，点击查看。`,
"c246":`{!oldServiceResource.name}已将编号（{!ServiceAppointment.name}）的工单转给您。`,
"c986":`下载帮助手册`,
"c2274":`废弃中...`,
"c1748":`现有用户`,
"label.parameter.is.incorrect":`参数不正确`,
"c1242":`相关列表名称`,
"c1982":`自定义设置详细信息`,
"c1687":`话题`,
"c1591":`字段名必须以字母开头，只能包含大小写字母、数字、下划线，最大长度{maxApinameLength},最小2位`,
"c667":`图标间的间距`,
"c1817":`Apex 类详细信息`,
"c1375":` 可以直接删除该布局中想要移除的字段，或者将其移到左边的未使用的字段窗格中`,
"c737":`社交平台`,
"c1695":`开发者空间`,
"c48":`断开`,
"c111":`生成{name}`,
"c1582":`德文`,
"c2178":`拒单成功`,
"c755":`顺序填`,
"c2289":`客户端脚本`,
"c1333":`添加触发器`,
"c526":`激活门户用户`,
"c450":`合并个案`,
"front-electronic-export-reChoseChimp":`当前视图没有数据记录，无法导出，请重新选择视图`,
"c1759":`服务云移动端图标`,
"label.invoice.paidamount.greater.than.total":`回款明细新建后，发票的已回款金额将大于总计值。请重新调整回款金额后再保存。`,
"c1688":`伙伴云对象`,
"c222":`编辑项目`,
"c849":`Twitter 账号`,
"c1549":`批量添加选型`,
"c2309":`您超时未接单，编号“{!ServiceAppointment.name}”，请您及时处理，点击查看。`,
"c1369":`标题不可见`,
"c678":`黑和白`,
"c502":`为处理现场服务所涉及的整个流程提供全面的解决方案，为您简化现场操作，管理服务人员，提高技术人员的生产力，从而提高客户忠诚度和满意度。`,
"c1476":`删除成功！`,
"c1052":`更换页面布局模板`,
"c497":`优质数字商务云平台助力业财一体化管理`,
"c1458":`保存至文件`,
"c1815":`数字化产品不支持无理由退货`,
"c200":`在社交媒体上分享`,
"c1893":`选择使用呼叫中心的用户`,
"c1258":`请选择短信通知模板`,
"c1272":`全部隐藏`,
"c658":`富文本`,
"c434":`新建相关联系人`,
"c1848":`为每种您需要导入的语言创建包含名称和翻译的文件`,
"c641":`您最多可以选择4张图片，单击选中图片取消选中，且文件不超过200kb`,
"c944":`德国`,
"c1221":`您确定要删除吗？`,
"c411":`到期日期偏差`,
"c1114":`选择插入的字段`,
"c1353":`要查找API密钥和API机密，您可以登录Vonage API帐户，然后转到帐户名下的“设置”。要查找Vonage API帐户中的电话号码，可以转到“产品”下的“号码”，然后单击“您的号码”以查看您拥有的所有电话号码。`,
"c1776":`默认链接有效期`,
"c1565":`新建自定义对象`,
"c1619":`在线支付设置`,
"c1115":`请填写工作流规则名称`,
"c624":`全部账号`,
"label.twitter.title":`推特-H5微应用`,
"c1319":`取消禁用`,
"c1696":`已安装软件包`,
"c1746":`授权颁发者`,
"c791":`标准签名`,
"c1965":`权重值仅允许填入1-10的数字`,
"c1728":`评分字段属性`,
"c306":`同意`,
"c14":`当前用户无删除权限`,
"c176":`支持上传png、jpg、jpeg格式的图片。文件最大为2M`,
"c1335":`开始字符`,
"c997":`SKU功能清单`,
"c1233":`所有未分配用户`,
"c2225":`您必须先在智能设备上安装一个MFA应用程序，才能继续进行操作。`,
"c1566":`必须以字母开头，只能包含大小写字母，数字，下划线，最大长度30，最小2位，且不能是数据库的关键字`,
"c166":`请按规则输入最大接单时长`,
"c731":`更改已选取的价格手册，将删除全部现有的产品。是否更改为新的价格手册？`,
"c2086":`全文搜索对象`,
"c237":`{!ServiceResource.name}已接单。编号：“{!ServiceAppointment.name}”`,
"c887":`重新邀请用户成功`,
"c1418":` 步骤1:选择一个控制字段和一个依赖字段。完成时单击“继续”`,
"c227":`编辑子任务`,
"c1674":`评价项`,
"c257":`允许的联系方式`,
"c2175":`接单成功`,
"c1867":`菜单名长度不能低于2位，不能超过20位`,
"c1864":`用户1`,
"c712":`汇总并对比网络、帖子和市场活动表现`,
"c107":`按姓名、账号、手机号查找用户`,
"c1767":`链接有效期`,
"c1310":`任务冲突行为`,
"c1627":`微信小程序`,
"c1266":`添加到自定义应用程序`,
"c1262":`最后编辑`,
"c370":`合同行`,
"c1878":`登陆状态`,
"c1784":`请进行今日打卡。（如已打卡请忽略）`,
"c895":`距离计算失败，请录入完整的地址信息`,
"c1029":`产品规格`,
"c693":`自动调节`,
"c763":`已签署`,
"c302":`合法利益`,
"c577":`堆砌柱形图`,
"c258":`我要吐个槽`,
"c1757":`允许对图片限制`,
"c1879":`登陆系统`,
"c2296":`第{0}年会计年度`,
"c676":`居中`,
"c1609":`电子邮件字段属性`,
"c868":`停用后将限制他访问或在您的门户网站中执行某些操作。是否继续？`,
"c53":`比率（%）`,
"c2161":`加签理由`,
"c527":`#userName已为您分配审批任务`,
"c1816":`+加`,
"c1579":`日文`,
"c984":`网络已连接`,
"c1021":`2.价格手册可能会影响业务机会、报价单、订单、发货单、采购订单中的产品价格。如果以上5个对象关联了价格手册，销售人员只能选择价格手册中的产品，并默认带入价格手册中的产品价格。`,
"label.facebook.title.setting":`Facebook集成信息`,
"c1888":`提供商Auth Token2`,
"c340":`变更项目计划所属人`,
"c1764":`在线个案二维码`,
"c1868":`请输入正确的电子邮件地址`,
"c706":`关于图表`,
"label.mobile.used":`手机号已被使用`,
"c328":`资产二维码`,
"c1761":`是否是个人客户`,
"c337":`联系人-销毁`,
"c1605":`电话字段属性`,
"c1935":`暂无权限访问，请联系管理员`,
"c642":`最近的图片`,
"c2403":`SQL超时异常`,
"c2348":`未启用呼叫中心`,
"c2429":`文章 {name} 己附加到工作订单！`,
"c2398":`使用默认`,
"c2318":`文件总大小超过了允许的限制{0}MB`,
"c2400":`记录类型字段属性`,
"c2430":`文章 {name} 己取消附加到工作订单！`,
"c2424":`用户名错误`,
"c2374":`创建及编辑字段`,
"c2347":`呼叫中心市场`,
"c2343":`联系人电子邮件`,
"c2366":`openApi请求频繁`,
"c2436":`仅导出详细信息行。使用此数据，以进行更多计算，或上传到其他系统。分页导出，单页最多导出{number}条`,
"c2391":`参数`,
"c2377":`根据实际使用场景，选择服务业务需求的模块<br>启用：启用后，该模块将显示在移动端“更多”>“工具”<br>禁用：禁用后，该模块将不在移动端“更多”>“工具”显示`,
"c2446":`请拖拽字段至此处`,
"c2445":`博客`,
"c2437":`您没有派遣权限，请管理员在简档中开启`,
"c2337":`类主体`,
"c2335":`回拨 URL`,
"c2330":`请输入URL 后缀`,
"c2420":`值不存在或与筛选条件不匹配`,
"c2362":`触发器提示信息`,
"c2409":`最多支持添加1个匹配区域规则`,
"c2319":`总大小限制为{0}MB，或者最多不得超过{1}个图片`,
"c2320":`支持的格式：JPEG, PNG, GIF和BMP。`,
"c2432":`您没有分配权限,请管理员在简档中开启`,
"c2378":`组织级底部菜单配置`,
"c2414":`已存在相同的工作规则`,
"c2411":`最多支持添加1个最短出行目标`,
"c2360":`{0}已经关联{1}呼叫中心，是否将他们移动到此呼叫中心`,
"c2418":`请至少保留一个详情页底部按钮`,
"c2358":`是否确认删除此自定义呼叫中心`,
"c2379":`各组织可根据业务场景，初始化组织级的底部菜单。`,
"c2331":`验证提供商 ID`,
"c2361":`至少选择一个用户`,
"c2447":`确定要删除自定义字段“{name}”吗?`,
"c2444":`主机设置`,
"c2338":`请点击选择ID`,
"c2345":`联系人电话`,
"c2419":`首选`,
"c2339":`所有计划作业`,
"c2329":`公式字段等非真实字段不支持筛选`,
"c2408":`最多支持添加1个资源可用性规则`,
"c2406":`最多支持添加1个所需资源规则`,
"c2370":`通过使用母语向用户显示信息（例如帮助文本或错误消息），自定义标签允许开发人员创建多语言应用程序。`,
"c2371":`如果为CloudCC组织启用翻译工作台，您可以将这些标签翻译为CloudCC支持的任何语言。`,
"c2351":`最好以呼叫中心供应商名称命名`,
"c2443":`验证网址`,
"c2326":`URL 后缀`,
"c2363":`报表优化SQL验证异常`,
"c2399":`自定义脚本`,
"c2401":`创建及编辑布局编辑器中的字段`,
"c2359":`是否确认禁用此呼叫中心`,
"c2353":`标签必须由40个以内的字母或数字组成，只能以字母开头，且名称必须唯一`,
"c2334":`现有用户链接 URL`,
"c2404":`最多支持添加12个工作规则`,
"c2397":`当前用户`,
"c2435":`填写描述`,
"c2342":`连接的应用程序名称`,
"c2376":`移动端常用工具配置`,
"c2416":`距离`,
"c2332":`图标 URL`,
"c2442":`选择域`,
"c2413":`已存在相同的服务目标`,
"c2322":`拒单`,
"c2395":`登录方式`,
"c2434":`加签方式`,
"c2438":`没有可用服务资源`,
"c2407":`最多支持添加1个排除资源规则`,
"c2440":`右侧新增标签页`,
"c2356":`所有用户`,
"c2421":`布局最后一个按钮不允许移除。`,
"c2373":`确定要禁用多语言吗？`,
"c2439":`弹出面板`,
"c2350":`呼叫中心显示名称不能为空`,
"c2328":`该字段不支持排序`,
"c2405":`最多支持添加1个匹配技能规则`,
"c2324":`拒单原因`,
"c2382":`提示：简档底部菜单配置，会覆盖组织级底部菜单配置`,
"c2336":`单点注销 URL`,
"c2340":`CloudCC许可证`,
"c2431":`已达最大修改次数，请一小时之后再尝试！`,
"c2317":`你最多只能上传{0}张图片，请重新上传`,
"c2372":`您可以创建最多5,000个自定义标签，每个标签可以包含最多1,000个字符。`,
"c2323":`计划冲突`,
"c2402":`SQL语法异常`,
"c2341":`CloudCC Platform 许可证`,
"c2392":`报表列字段最多选中200个`,
"c2380":`请选择需要显示在移动端的4个底部菜单`,
"c2333":`单点登录初始化 URL`,
"c2381":`简档底部菜单配置`,
"c2352":`唯一标签不能为空`,
"c2321":`接单`,
"c2415":`距离：计算异常`,
"c2375":`各组织可根据业务场景，配置组织级主页顶部区域的4个快捷功能。`,
"c2357":`选择特定用户使用呼叫中心`,
"c2423":`在线评价内容`,
"c2344":`CloudCC Partner许可证`,
"c2441":`长度`,
"c2354":`自定义页面不能为空`,
"c2386":`指定自定义菜单权限`,
"c2422":`配置评价项`,
"c2433":`请添加`,
"c2448":`[任务提醒]您现在有一条任务提醒，请查看。`,
"c2349":`定义呼叫中心`,
"c2355":`保存并启用`,
"c2346":`是否自动登录`,
"c2412":`最多支持添加12个服务目标`,
"c2364":`报表优化SQL格式异常`,
"c2383":`启用ES`,
"c2396":`关闭所有菜单`,
"c2325":`请填写原因`,
"c2410":`最多支持添加1个资源首选目标`,
"c2327":`应用 ID`
}